(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[640],{

/***/ 4754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slugs_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__(72179);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./src/redux/apiData.js + 2 modules
var apiData = __webpack_require__(52417);
// EXTERNAL MODULE: ./src/components/ErrorBlock.js
var ErrorBlock = __webpack_require__(18);
// EXTERNAL MODULE: ./src/constants/errorMessages.ts
var errorMessages = __webpack_require__(35720);
// EXTERNAL MODULE: ./src/hocs/withMatch.tsx
var withMatch = __webpack_require__(30715);
;// CONCATENATED MODULE: ./src/components/WithSettings.js







var __jsx = react.createElement;

function _callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}









var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env;
  return {
    settings: (0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }),
    request: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getNewSettings: function getNewSettings() {
      var _ownProps$match$param2 = ownProps.match.params,
          projectSlug = _ownProps$match$param2.projectSlug,
          env = _ownProps$match$param2.env;
      dispatch((0,apiData/* performApiRequest */.T4)('getSettings', {
        projectSlug: String(projectSlug),
        env: String(env)
      }));
    }
  };
};

/* harmony default export */ var WithSettings = (function (WrappedComponent) {
  var WithSettings = /*#__PURE__*/function (_React$Component) {
    function WithSettings() {
      var _this;

      (0,classCallCheck/* default */.Z)(this, WithSettings);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _callSuper(this, WithSettings, [].concat(args));

      (0,defineProperty/* default */.Z)(_this, "state", {
        renderWidth: 1200
      });

      (0,defineProperty/* default */.Z)(_this, "onResize", function () {
        _this.setState({
          renderWidth: _this.getLayoutWidth()
        });
      });

      return _this;
    }

    (0,inherits/* default */.Z)(WithSettings, _React$Component);

    return (0,createClass/* default */.Z)(WithSettings, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.loadSettings({
          match: {
            params: {
              projectSlug: '',
              env: ''
            }
          }
        });
        window.addEventListener('resize', this.onResize);
        this.onResize();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(oldProps) {
        this.loadSettings(oldProps);
      }
    }, {
      key: "getLayoutWidth",
      value: function getLayoutWidth() {
        return document.body && document.body.offsetWidth || 0;
      }
    }, {
      key: "loadSettings",
      value: function loadSettings(oldProps) {
        var _this$props = this.props,
            request = _this$props.request,
            getNewSettings = _this$props.getNewSettings;
        var _oldProps$match$param = oldProps.match.params,
            oldProjectSlug = _oldProps$match$param.projectSlug,
            oldEnv = _oldProps$match$param.env;
        var _this$props$match$par = this.props.match.params,
            newProjectSlug = _this$props$match$par.projectSlug,
            newEnv = _this$props$match$par.env;

        if (oldProjectSlug !== newProjectSlug || oldEnv !== newEnv || !request || request && request.networkStatus === 'ready') {
          getNewSettings();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            settings = _this$props2.settings,
            request = _this$props2.request,
            match = _this$props2.match;
        var renderWidth = this.state.renderWidth;

        if (request && request.networkStatus === 'failed' && request.errorBody && request.errorBody.name && request.errorBody.name !== 'FetchError') {
          return __jsx(ErrorBlock/* default */.Z, (0,esm_extends/* default */.Z)({}, (0,errorMessages/* getErrorBlockProps */.k)(match, 'settings', 4044), {
            fullscreen: true,
            "data-id": "components_WithSettings_ErrorBlock"
          }));
        }

        return __jsx(WrappedComponent, {
          settings: settings,
          settingsRequest: request,
          match: match,
          renderWidth: renderWidth,
          "data-id": "components_WithSettings_WrappedComponent"
        });
      }
    }]);
  }(react.Component);

  (0,defineProperty/* default */.Z)(WithSettings, "displayName", "WithSettings(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")"));

  hoist_non_react_statics_cjs_default()(WithSettings, WrappedComponent); // prettier-ignore
  // $FlowFixMe

  return (0,withMatch/* default */.Z)((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(WithSettings));
});
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./src/services/withApiData.js
var withApiData = __webpack_require__(76221);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(37946);
// EXTERNAL MODULE: ./src/redux/modal.js
var redux_modal = __webpack_require__(47927);
// EXTERNAL MODULE: ./src/styles/gridElements.js
var gridElements = __webpack_require__(68819);
// EXTERNAL MODULE: ./src/styles/styleGuide.js
var styleGuide = __webpack_require__(90370);
// EXTERNAL MODULE: ./src/redux/menu.js
var menu = __webpack_require__(84201);
// EXTERNAL MODULE: ./src/components/atoms/Link.tsx
var Link = __webpack_require__(61571);
// EXTERNAL MODULE: ./node_modules/lodash.get/index.js
var lodash_get = __webpack_require__(29208);
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
// EXTERNAL MODULE: ./src/services/getLinkFromPageObject.ts
var getLinkFromPageObject = __webpack_require__(15571);
// EXTERNAL MODULE: ./src/styles/breakpoints.ts
var breakpoints = __webpack_require__(85819);
// EXTERNAL MODULE: ./src/components/shared/icons/Caret.js
var Caret = __webpack_require__(47947);
// EXTERNAL MODULE: ./node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(72307);
var lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(lodash_isequal);
;// CONCATENATED MODULE: ./src/components/shared/designElements/Triangle.js
var Triangle_jsx = react.createElement;


var defaultProps = {
  direction: 'right',
  color: styleGuide/* colorPalette.textGrey */.K5.textGrey,
  width: 150,
  height: 150
};
var DIRECTION = {
  top: 45,
  topright: 90,
  right: 135,
  bottomright: 180,
  bottom: 225,
  bottomleft: 270,
  left: 315,
  topleft: 0
};

var Triangle_Triangle = function Triangle(_ref) {
  var width = _ref.width,
      height = _ref.height,
      direction = _ref.direction,
      color = _ref.color;
  var style = {
    width: width || 0,
    height: height || 0,
    transform: "rotateZ(".concat(DIRECTION[direction], "deg)")
  };
  return Triangle_jsx("svg", {
    viewBox: "0 0 150 150",
    style: style,
    preserveAspectRatio: "xMinYMin",
    "data-id": "designElements_Triangle_svg"
  }, Triangle_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "designElements_Triangle_g"
  }, Triangle_jsx("g", {
    fill: color,
    "data-id": "designElements_Triangle_g_2"
  }, Triangle_jsx("polygon", {
    points: "0 150 0 0 150 0",
    "data-id": "designElements_Triangle_polygon"
  }))));
};

Triangle_Triangle.defaultProps = defaultProps;
/* harmony default export */ var designElements_Triangle = (Triangle_Triangle);
;// CONCATENATED MODULE: ./src/components/NotificationNumber.js


var _templateObject;

var NotificationNumber_jsx = react.createElement;




var NotificationsNumber = function NotificationsNumber(_ref) {
  var number = _ref.number,
      className = _ref.className;
  return number > 0 ? NotificationNumber_jsx(Container, {
    className: className,
    "data-id": "components_NotificationNumber_Container"
  }, number) : null;
};

/* harmony default export */ var NotificationNumber = (NotificationsNumber);
var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  right: -8rem;\n  bottom: -1rem;\n  border-radius: 50%;\n  background-color: ", ";\n  border: 1px solid white;\n  width: 16rem;\n  height: 16rem;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12rem;\n"])), styleGuide/* colorPalette.orange */.K5.orange);
;// CONCATENATED MODULE: ./src/components/FlyOutMenu.js








var FlyOutMenu_templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

var FlyOutMenu_jsx = react.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function FlyOutMenu_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, FlyOutMenu_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function FlyOutMenu_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (FlyOutMenu_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}









var FLYOUTMENUMARGINFROMTARGET = 20;

var FlyOutMenu = /*#__PURE__*/function (_Component) {
  function FlyOutMenu() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, FlyOutMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = FlyOutMenu_callSuper(this, FlyOutMenu, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "subMenus", {});

    (0,defineProperty/* default */.Z)(_this, "container", null);

    (0,defineProperty/* default */.Z)(_this, "state", {
      top: 0,
      left: 0,
      arrowPos: {
        direction: 'top',
        top: 0,
        left: 0
      },
      openSubMenu: ''
    });

    return _this;
  }

  (0,inherits/* default */.Z)(FlyOutMenu, _Component);

  return (0,createClass/* default */.Z)(FlyOutMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var options = this.props.options;
      options.forEach(function (option) {
        if (option && option.active) {
          _this2.setState({
            openSubMenu: option.link
          });
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          target = _this$props.target,
          position = _this$props.position;
      if (!target) return;
      var targetEl = target.getBoundingClientRect();
      var flyoutMenu = this.container ? this.container.getBoundingClientRect() : {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      };
      var pos = {
        top: 0,
        left: 0
      };
      var arrowPos = {
        direction: 'top',
        top: 0,
        left: 0
      };
      var flyoutMenuTooWide = targetEl.left + targetEl.width / 2 - flyoutMenu.width / 2 + flyoutMenu.width > (window && window.innerWidth);

      switch (position) {
        case 'top':
          pos.top = targetEl.top - flyoutMenu.height - FLYOUTMENUMARGINFROMTARGET;
          pos.left = targetEl.left + targetEl.width / 2 - flyoutMenu.width / 2;
          break;

        case 'right':
          pos.top = targetEl.top + targetEl.height / 2 - flyoutMenu.height / 2;
          pos.left = targetEl.right + FLYOUTMENUMARGINFROMTARGET;
          arrowPos.top = flyoutMenu.height / 2 - 10;
          arrowPos.left = -10;
          arrowPos.direction = 'left';
          break;

        case 'bottom':
          pos.top = targetEl.top + targetEl.height + FLYOUTMENUMARGINFROMTARGET;
          pos.left = flyoutMenuTooWide ? 0 : targetEl.left + targetEl.width / 2 - flyoutMenu.width / 2;
          arrowPos.top = -10;
          arrowPos.left = flyoutMenu.width / 2 - 10;
          arrowPos.direction = 'top';
          break;

        case 'left':
          pos.top = targetEl.top + targetEl.height / 2 - flyoutMenu.height / 2;
          pos.left = targetEl.left - flyoutMenu.width - FLYOUTMENUMARGINFROMTARGET;
          arrowPos.top = flyoutMenu.height / 2 - 10;
          arrowPos.left = flyoutMenu.width - 11;
          arrowPos.direction = 'right';
          break;

        default:
          break;
      }

      var newState = _objectSpread(_objectSpread({}, pos), {}, {
        arrowPos: arrowPos,
        openSubMenu: prevState.openSubMenu
      });

      if (!lodash_isequal_default()(prevState, newState)) {
        this.setState(newState);
      }
    }
  }, {
    key: "renderItem",
    value: function renderItem(item) {
      return FlyOutMenu_jsx("div", {
        "data-id": "components_FlyOutMenu_div"
      }, item.icon && FlyOutMenu_jsx(IconWrapper, {
        "data-id": "components_FlyOutMenu_IconWrapper"
      }, item.icon, Number(item.unreadCount) > 0 && FlyOutMenu_jsx(NotificationBubble, {
        number: item.unreadCount || 0,
        "data-id": "components_FlyOutMenu_NotificationBubble"
      })), FlyOutMenu_jsx(LabelWrapper, {
        "data-id": "components_FlyOutMenu_LabelWrapper"
      }, item.label));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          _this$props2$options = _this$props2.options,
          options = _this$props2$options === void 0 ? [] : _this$props2$options,
          visible = _this$props2.visible;
      var _this$state = this.state,
          arrowPos = _this$state.arrowPos,
          top = _this$state.top,
          left = _this$state.left,
          openSubMenu = _this$state.openSubMenu;
      return FlyOutMenu_jsx(HoverMenuContainer, {
        visible: visible,
        ref: function ref(el) {
          _this3.container = el;
        },
        style: {
          top: "".concat(top, "rem"),
          left: left === 0 ? 'initial' : "".concat(left, "rem")
        },
        "data-id": "components_FlyOutMenu_HoverMenuContainer"
      }, options.map(function (item, index) {
        var isActive = item ? item.active || openSubMenu === item.link : false;
        var isOpen = item ? openSubMenu === item.link : false;
        return item && !item.disable && item.type === 'link' ? FlyOutMenu_jsx(ListItem, {
          key: item.name,
          type: item.name,
          "data-id": "components_FlyOutMenu_ListItem"
        }, FlyOutMenu_jsx(Link/* default */.Z, {
          href: item.link || '',
          "data-e2e-flyoutmenu-option": item.name,
          "data-id": "components_FlyOutMenu_Link"
        }, _this3.renderItem(item))) : item && !item.disable && item.type === 'button' ? FlyOutMenu_jsx(ListItem, {
          key: item.name,
          type: item.name,
          "data-id": "components_FlyOutMenu_ListItem"
        }, FlyOutMenu_jsx(Button, {
          onClick: item.onClick,
          "data-e2e-flyoutmenu-option": item.name,
          "data-id": "components_FlyOutMenu_Button"
        }, _this3.renderItem(item))) : item && !item.disable && item.type === 'message' ? FlyOutMenu_jsx(ListItem, {
          key: item.name,
          type: item.name,
          "data-id": "components_FlyOutMenu_ListItem"
        }, FlyOutMenu_jsx(Message, {
          "data-e2e-flyoutmenu-option": item.name,
          "data-id": "components_FlyOutMenu_Message"
        }, _this3.renderItem(item))) : item && !item.hidden && item.type === 'menu' ? FlyOutMenu_jsx(MenuWrapper, {
          key: item.name,
          "data-id": "components_FlyOutMenu_MenuWrapper"
        }, item.subLinks && item.subLinks.length > 0 ? FlyOutMenu_jsx(Menu, {
          "data-id": "components_FlyOutMenu_Menu"
        }, FlyOutMenu_jsx(MenuItem, {
          onClick: function onClick() {
            return _this3.setState({
              openSubMenu: isOpen ? '' : item.link
            });
          },
          color: isActive ? styleGuide/* colorPalette.blue */.K5.blue : styleGuide/* colorPalette.headerGrey */.K5.headerGrey,
          "data-id": "components_FlyOutMenu_MenuItem"
        }, item.label, FlyOutMenu_jsx(CaretContainer, {
          isActive: isActive,
          "data-id": "components_FlyOutMenu_CaretContainer"
        }, FlyOutMenu_jsx(Caret/* default */.Z, {
          direction: "down",
          color: isActive ? styleGuide/* colorPalette.blue */.K5.blue : styleGuide/* colorPalette.headerGrey */.K5.headerGrey,
          "data-id": "components_FlyOutMenu_Caret"
        }))), FlyOutMenu_jsx(HoverMenu, {
          open: isOpen,
          height: _this3.subMenus[index] && _this3.subMenus[index].clientHeight,
          isLast: index === options.length - 1,
          "data-id": "components_FlyOutMenu_HoverMenu"
        }, FlyOutMenu_jsx("div", {
          ref: function ref(el) {
            _this3.subMenus[index] = el;
          },
          "data-id": "components_FlyOutMenu_div"
        }, item.subLinks.map(function (subLink) {
          return !subLink.hidden && FlyOutMenu_jsx(MenuLink, {
            key: subLink.label,
            color: subLink.active ? styleGuide/* colorPalette.blue */.K5.blue : styleGuide/* colorPalette.headerGrey */.K5.headerGrey,
            href: subLink.link || '',
            "data-id": "components_FlyOutMenu_MenuLink"
          }, subLink.label);
        })))) : FlyOutMenu_jsx(MenuLink, {
          color: isActive ? styleGuide/* colorPalette.blue */.K5.blue : styleGuide/* colorPalette.headerGrey */.K5.headerGrey,
          href: item.link || '',
          "data-id": "components_FlyOutMenu_MenuLink_19"
        }, item.label)) : null;
      }), FlyOutMenu_jsx(ArrowContainer, {
        position: arrowPos,
        "data-id": "components_FlyOutMenu_ArrowContainer"
      }, FlyOutMenu_jsx(designElements_Triangle, {
        direction: arrowPos.direction,
        color: "#ffffff",
        height: 20,
        width: 20,
        "data-id": "components_FlyOutMenu_Triangle"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_FlyOutMenu = (FlyOutMenu);
var HoverMenuContainer = styled_components_browser_esm["default"].div(FlyOutMenu_templateObject || (FlyOutMenu_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  z-index: 2;\n  min-width: 168rem;\n  width: fit-content;\n  max-width: 264rem;\n  right: 0;\n  padding: 10rem 20rem;\n  box-sizing: border-box;\n  opacity: ", ";\n  pointer-events: ", ";\n  background-color: #fff;\n  transition: opacity 0.4s ease-in-out;\n  ", ";\n"])), function (props) {
  return props.visible ? '1' : '0';
}, function (props) {
  return props.visible ? 'auto' : 'none';
}, styleGuide/* shadows.boxPrimaryHover */.q.boxPrimaryHover);
var NotificationBubble = (0,styled_components_browser_esm["default"])(NotificationNumber)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var MenuWrapper = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  font-size: 18rem;\n  font-weight: bold;\n  font-family: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary);
var HoverMenu = styled_components_browser_esm["default"].div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  padding: 0 32rem;\n  margin: ", ";\n  height: ", ";\n  transition: height 0.25s;\n  overflow: hidden;\n"])), styleGuide/* colorPalette.background */.K5.background, function (_ref) {
  var isLast = _ref.isLast;
  return isLast ? '0 -20rem -10rem' : '0 -20rem -0';
}, function (_ref2) {
  var open = _ref2.open,
      height = _ref2.height;
  return open ? height ? "".concat(height, "rem") : 'auto' : 0;
});
var Menu = styled_components_browser_esm["default"].div(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)([""])));

var sharedMenuStyles = function sharedMenuStyles(color) {
  return (0,styled_components_browser_esm.css)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  text-align: left;\n  width: 100%;\n  color: ", ";\n  padding 10rem 0;\n  transition: transform 0.25s;\n\n  &:hover {\n    color: ", ";\n\n    svg {\n      transform: rotateZ(180deg) scale(1);\n\n      > g {\n        fill: ", ";\n      }\n    }\n  }\n"])), color, styleGuide/* colorPalette.blue */.K5.blue, styleGuide/* colorPalette.blue */.K5.blue);
};

var MenuLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  text-decoration: none;\n"])), function (_ref3) {
  var color = _ref3.color;
  return sharedMenuStyles(color);
});
var MenuItem = styled_components_browser_esm["default"].div(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  cursor: pointer;\n  text-transform: uppercase;\n"])), function (_ref4) {
  var color = _ref4.color;
  return sharedMenuStyles(color);
});
var CaretContainer = styled_components_browser_esm["default"].span(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  margin-left: 8px;\n  transform: rotateX(", "deg);\n  transition: transform 0.25s;\n"])), function (props) {
  return props.isActive ? 180 : 0;
});
var ListItem = styled_components_browser_esm["default"].div(_templateObject0 || (_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  line-height: 24rem;\n\n  > a,\n  > button,\n  > div {\n    display: flex;\n    width: 100%;\n    color: ", ";\n    text-decoration: none;\n    padding: 10rem 0;\n\n    > div {\n      display: flex;\n      width: 100%;\n      align-items: center;\n    }\n\n    ", ";\n  }\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.textGrey */.K5.textGrey, function (props) {
  return props.type === 'messages' ? "&:hover{\n          color: ".concat(styleGuide/* colorPalette.blue */.K5.blue, ";\n          > div > div > svg > g > g > g > g > path {\n            &:nth-of-type(2) {\n              fill: ").concat(styleGuide/* colorPalette.blue */.K5.blue, ";\n            }\n          }\n        }\n        > div > div > svg > g > g > g > g > path {\n          &:nth-of-type(2) {\n            fill: ").concat(styleGuide/* colorPalette.beige */.K5.beige, ";\n            transition: fill 0.4s ease-in-out;\n          }\n        }") : "&:hover{\n          color: ".concat(styleGuide/* colorPalette.blue */.K5.blue, ";\n          > div > div > svg > g > g {\n            fill: ").concat(styleGuide/* colorPalette.blue */.K5.blue, ";\n          }\n        }\n        > div > div > svg > g > g {\n          fill: ").concat(styleGuide/* colorPalette.beige */.K5.beige, ";\n          transition: fill 0.4s ease-in-out;\n        }");
}, NotificationBubble, styleGuide/* colorPalette.darkOrange */.K5.darkOrange);
var Message = styled_components_browser_esm["default"].div(_templateObject1 || (_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Button = styled_components_browser_esm["default"].button(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var IconWrapper = styled_components_browser_esm["default"].div(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  margin-right: 12rem;\n  width: 20rem;\n  height: 20rem;\n  position: relative;\n"])));
var LabelWrapper = styled_components_browser_esm["default"].div(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var ArrowContainer = styled_components_browser_esm["default"].div(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  left: ", ";\n  top: ", ";\n"])), function (props) {
  return "".concat(props.position.left, "rem");
}, function (props) {
  return "".concat(props.position.top, "rem");
});
;// CONCATENATED MODULE: ./src/components/Menu.js








var Menu_templateObject, Menu_templateObject2, Menu_templateObject3, Menu_templateObject4, Menu_templateObject5, Menu_templateObject6, Menu_templateObject7, Menu_templateObject8, Menu_templateObject9, Menu_templateObject0, Menu_templateObject1, Menu_templateObject10, Menu_templateObject11, Menu_templateObject12, Menu_templateObject13, _templateObject14, _templateObject15;

var Menu_jsx = react.createElement;

function Menu_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function Menu_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? Menu_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Menu_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function Menu_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, Menu_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function Menu_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (Menu_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
















var Menu_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};

var findMenuItemBySlug = function findMenuItemBySlug(slug, menuItems) {
  return menuItems.find(function (menuItem) {
    return menuItem.slug === slug;
  });
};

var Menu_Menu = /*#__PURE__*/function (_Component) {
  function Menu() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Menu_callSuper(this, Menu, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "menuItemsObject", {});

    (0,defineProperty/* default */.Z)(_this, "state", {
      hoverMenuSlug: '',
      moreMenuItems: []
    });

    return _this;
  }

  (0,inherits/* default */.Z)(Menu, _Component);

  return (0,createClass/* default */.Z)(Menu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var oldPagePath = (0,getLinkFromPageObject/* default */.Z)(prevProps.match.params);
      var newPagePath = (0,getLinkFromPageObject/* default */.Z)(this.props.match.params);

      if (oldPagePath !== newPagePath) {
        this.setState({
          hoverMenuSlug: ''
        });
      }
    }
  }, {
    key: "calculateMenu",
    value: function calculateMenu() {
      var _this2 = this; // Calculate if the width of all menu items is bigger than wrapper, if so: add a 'more' menu section
      // Calculate width of all menu items


      if (this.menuItemsObject && Object.keys(this.menuItemsObject).length > 0) {
        var fullWidth = Object.values(this.menuItemsObject).reduce(function (start, value) {
          return start + (value.clientWidth + 50); // 50 for the margin
        }, 0); // if width of all items > than the menuwrapper (space available): add 'more' menu item

        if (this.menuWrapper && this.menuWrapper.clientWidth < fullWidth) {
          var moreItems = [];
          var newWidth = fullWidth;
          Object.values(this.menuItemsObject).reverse().forEach(function (value) {
            if (newWidth >= fullWidth) {
              newWidth = newWidth - (value.clientWidth + 50);
              moreItems.push(value);
            }
          });

          if (moreItems.length > 0) {
            this.setState(function (prevState) {
              return Menu_objectSpread(Menu_objectSpread({}, prevState), {}, {
                moreMenuItems: _this2.props.menuItems.slice(_this2.props.menuItems.length - (moreItems.length + 1))
              });
            });
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.calculateMenu);
      this.calculateMenu();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.calculateMenu);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          styling = _this$props.styling,
          _this$props$menuItems = _this$props.menuItems,
          menuItems = _this$props$menuItems === void 0 ? [] : _this$props$menuItems,
          match = _this$props.match;
      var _this$state = this.state,
          hoverMenuSlug = _this$state.hoverMenuSlug,
          moreMenuItems = _this$state.moreMenuItems;
      var _match$params = match.params,
          projectSlug = _match$params.projectSlug,
          env = _match$params.env,
          menuSlug = _match$params.menuSlug,
          pageSlug = _match$params.pageSlug;
      var filteredMenuItems = menuItems.filter(function (item) {
        return !item.hidden;
      });
      var currentMenuItem = menuSlug ? findMenuItemBySlug(menuSlug, filteredMenuItems) : undefined;
      var moreSectionIsActive = moreMenuItems && moreMenuItems.length > 0 ? filteredMenuItems.slice(filteredMenuItems.length - moreMenuItems.length).find(function (item) {
        return item.slug === (currentMenuItem && currentMenuItem.slug);
      }) : -1;
      var activeMenuColor = styling.navActiveLabel && env === 'open' ? styling.navActiveLabel : styleGuide/* colorPalette.blue */.K5.blue;
      return Menu_jsx(Menu_Container, {
        ref: function ref(el) {
          _this3.menuWrapper = el;
        },
        "data-e2e-menu-container": true,
        onMouseLeave: function onMouseLeave() {
          return _this3.setState({
            hoverMenuSlug: ''
          });
        },
        "data-id": "components_Menu_Container"
      }, Menu_jsx(MenuItemWrapper, {
        "data-id": "components_Menu_MenuItemWrapper"
      }, (moreMenuItems && moreMenuItems.length > 0 ? filteredMenuItems.slice(0, filteredMenuItems.length - moreMenuItems.length) : filteredMenuItems).map(function (menuItem, index) {
        var isCurrentMenu = menuItem.slug === menuSlug || !menuSlug && index === 0;
        var isHovered = menuItem.slug === hoverMenuSlug;
        var options = (0,menu/* hasSubmenu */.Df)(menuItem) ? menuItem.pages && menuItem.pages.map(function (page) {
          return {
            name: page.name,
            label: page.name,
            type: 'menu',
            active: menuSlug === menuItem.slug && pageSlug === page.slug,
            hidden: page.hidden,
            link: '/' + (0,getLinkFromPageObject/* default */.Z)({
              projectSlug: projectSlug,
              env: menuItem.env,
              menuSlug: menuItem.slug,
              pageSlug: page.slug
            })
          };
        }) : undefined;
        return !menuItem.hidden ? Menu_jsx(react.Fragment, {
          key: menuItem.slug
        }, Menu_jsx(Menu_MenuItem, {
          ref: function ref(el) {
            _this3.menuItemsObject[index] = el;
          },
          "data-id": "components_Menu_MenuItem"
        }, (0,menu/* hasSubmenu */.Df)(menuItem) ? Menu_jsx(MenuButton, {
          key: menuItem.slug,
          onClick: function onClick() {
            return _this3.setState({
              hoverMenuSlug: isHovered ? '' : menuItem.slug
            });
          },
          color: isCurrentMenu || isHovered ? activeMenuColor : styleGuide/* colorPalette.headerGrey */.K5.headerGrey,
          "data-id": "components_Menu_MenuButton"
        }, menuItem.name, Menu_jsx(Menu_CaretContainer, {
          isActive: isHovered,
          "data-id": "components_Menu_CaretContainer"
        }, Menu_jsx(Caret/* default */.Z, {
          direction: "down",
          color: isCurrentMenu || isHovered ? String(activeMenuColor) : String(styleGuide/* colorPalette.headerGrey */.K5.headerGrey),
          "data-id": "components_Menu_Caret"
        }))) : Menu_jsx(Menu_MenuLink, {
          href: '/' + (0,getLinkFromPageObject/* default */.Z)({
            projectSlug: projectSlug,
            env: menuItem.env,
            menuSlug: menuItem.slug
          }),
          color: isCurrentMenu || isHovered ? activeMenuColor : styleGuide/* colorPalette.headerGrey */.K5.headerGrey,
          "data-id": "components_Menu_MenuLink"
        }, menuItem.name)), (0,menu/* hasSubmenu */.Df)(menuItem) && options && Menu_jsx(components_FlyOutMenu, {
          visible: isHovered,
          projectSlug: String(projectSlug),
          options: options,
          target: _this3.menuItemsObject[index],
          position: "bottom",
          "data-id": "components_Menu_FlyOutMenu"
        })) : null;
      }), moreMenuItems && moreMenuItems.length > 0 && Menu_jsx(react.Fragment, null, Menu_jsx(MoreButton, {
        onClick: function onClick() {
          return _this3.setState({
            hoverMenuSlug: hoverMenuSlug === 'more' ? '' : 'more'
          });
        },
        color: hoverMenuSlug === 'more' || moreSectionIsActive ? activeMenuColor : styleGuide/* colorPalette.headerGrey */.K5.headerGrey,
        ref: function ref(el) {
          _this3.moreButton = el;
        },
        "data-id": "components_Menu_MoreButton"
      }, "Meer...", Menu_jsx(Menu_CaretContainer, {
        isActive: hoverMenuSlug === 'more' || moreSectionIsActive,
        "data-id": "components_Menu_CaretContainer"
      }, Menu_jsx(Caret/* default */.Z, {
        direction: "down",
        color: hoverMenuSlug === 'more' || moreSectionIsActive ? String(activeMenuColor) : String(styleGuide/* colorPalette.headerGrey */.K5.headerGrey),
        "data-id": "components_Menu_Caret"
      }))), Menu_jsx(components_FlyOutMenu, {
        visible: hoverMenuSlug === 'more',
        projectSlug: String(projectSlug),
        options: filteredMenuItems.slice(filteredMenuItems.length - moreMenuItems.length).map(function (menuItem) {
          return {
            name: menuItem.name,
            label: menuItem.name,
            type: 'menu',
            active: menuSlug === menuItem.slug,
            subLinks: (0,menu/* hasSubmenu */.Df)(menuItem) ? menuItem.pages && menuItem.pages.map(function (page) {
              return {
                label: page.name,
                active: menuSlug === menuItem.slug && pageSlug === page.slug,
                hidden: page.hidden,
                link: '/' + (0,getLinkFromPageObject/* default */.Z)({
                  projectSlug: projectSlug,
                  env: menuItem.env,
                  menuSlug: menuItem.slug,
                  pageSlug: page.slug
                })
              };
            }) : undefined,
            link: '/' + (0,getLinkFromPageObject/* default */.Z)({
              projectSlug: projectSlug,
              env: menuItem.env,
              menuSlug: menuItem.slug
            })
          };
        }),
        target: this.moreButton,
        position: "bottom",
        "data-id": "components_Menu_FlyOutMenu"
      }))), Menu_jsx(SubmenuBackground, {
        visible: !!currentMenuItem && (0,menu/* hasSubmenu */.Df)(currentMenuItem),
        "data-id": "components_Menu_SubmenuBackground"
      }, filteredMenuItems.map(function (menuItem) {
        return (0,menu/* hasSubmenu */.Df)(menuItem) && Menu_jsx(SubmenuBar, {
          key: menuItem.slug,
          visible: menuSlug === menuItem.slug,
          "data-e2e-menu-submenubar": menuItem.slug,
          "data-id": "components_Menu_SubmenuBar"
        }, Menu_jsx(SubmenuWidthLimit, {
          "data-id": "components_Menu_SubmenuWidthLimit"
        }, Menu_jsx(SubmenuMarginFix, {
          "data-id": "components_Menu_SubmenuMarginFix"
        }, menuItem.pages && menuItem.pages.map(function (submenuItem) {
          return !submenuItem.hidden ? Menu_jsx(SubmenuItemLink, {
            href: '/' + (0,getLinkFromPageObject/* default */.Z)({
              projectSlug: projectSlug,
              env: submenuItem.env,
              menuSlug: menuItem.slug,
              pageSlug: submenuItem.slug
            }),
            key: submenuItem.slug || 'home',
            color: activeMenuColor,
            style: {
              borderBottomColor: menuSlug === menuItem.slug && pageSlug === submenuItem.slug ? activeMenuColor : ''
            },
            "data-id": "components_Menu_SubmenuItemLink"
          }, submenuItem.name) : null;
        }))));
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_Menu = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(Menu_mapStateToProps)(Menu_Menu)));
var Menu_Container = styled_components_browser_esm["default"].div(Menu_templateObject || (Menu_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: none;\n\n  @media only all and (min-width: 1040px) {\n    display: flex;\n    justify-content: flex-end;\n    max-height: 68rem;\n  }\n"])));
var MenuItemWrapper = styled_components_browser_esm["default"].div(Menu_templateObject2 || (Menu_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: right;\n  overflow: hidden;\n"])));
var Menu_MenuItem = styled_components_browser_esm["default"].div(Menu_templateObject3 || (Menu_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  margin: 0 0 22rem 30rem;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(Menu_templateObject4 || (Menu_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 40rem;\n  "]))), breakpoints/* fromBreakpoint.slg */.ks.slg(Menu_templateObject5 || (Menu_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 50rem;\n  "]))));

var Menu_sharedMenuStyles = function sharedMenuStyles(color) {
  return (0,styled_components_browser_esm.css)(Menu_templateObject6 || (Menu_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  position: relative;\n  font-size: 18rem;\n  text-transform: uppercase;\n  font-weight: bold;\n  padding: 20rem 0 0;\n  font-family: ", ";\n  text-decoration: none;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover {\n    color: ", ";\n\n    > span > svg > g {\n      fill: ", ";\n    }\n  }\n"])), styleGuide/* fonts.primary */.Rq.primary, color, styleGuide/* colorPalette.blue */.K5.blue, styleGuide/* colorPalette.blue */.K5.blue);
};

var MenuButton = styled_components_browser_esm["default"].div(Menu_templateObject7 || (Menu_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return Menu_sharedMenuStyles(color);
});
var MoreButton = styled_components_browser_esm["default"].div(Menu_templateObject8 || (Menu_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n\n  margin-left: 30rem;\n\n  ", ";\n\n  ", ";\n"])), function (_ref2) {
  var color = _ref2.color;
  return Menu_sharedMenuStyles(color);
}, breakpoints/* fromBreakpoint.lg */.ks.lg(Menu_templateObject9 || (Menu_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 40rem;\n  "]))), breakpoints/* fromBreakpoint.slg */.ks.slg(Menu_templateObject0 || (Menu_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 50rem;\n  "]))));
var Menu_MenuLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(Menu_templateObject1 || (Menu_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n"])), function (_ref3) {
  var color = _ref3.color;
  return Menu_sharedMenuStyles(color);
});
var Menu_CaretContainer = styled_components_browser_esm["default"].span(Menu_templateObject10 || (Menu_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  margin-left: 10rem;\n  line-height: 9rem;\n  vertical-align: 10%;\n  transform: rotateX(", "deg);\n  transition: transform 0.25s;\n"])), function (props) {
  return props.isActive ? 180 : 0;
}); // The background prevents see-through when transitioning opacity

var SubmenuBackground = styled_components_browser_esm["default"].div(Menu_templateObject11 || (Menu_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: #f1f0ef;\n  height: 35rem;\n  opacity: ", ";\n  transition: opacity 0.2s;\n"])), function (props) {
  return props.visible ? 1 : 0;
});
var SubmenuBar = styled_components_browser_esm["default"].div(Menu_templateObject12 || (Menu_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: #f1f0ef;\n  transition: opacity 0.2s;\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);\n  opacity: ", ";\n  z-index: ", ";\n  ", ";\n"])), function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.visible ? 0 : 0;
}, function (props) {
  return !props.visible ? 'pointer-events: none;' : '';
}); // clip margin fixer

var SubmenuWidthLimit = (0,styled_components_browser_esm["default"])(gridElements/* WidthLimit */.N_)(Menu_templateObject13 || (Menu_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n"])));
var SubmenuMarginFix = styled_components_browser_esm["default"].div(_templateObject14 || (_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: -5rem;\n  margin-right: -5rem;\n  display: flex;\n  flex-wrap: wrap;\n"])));
var SubmenuItemLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(_templateObject15 || (_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: normal;\n  text-transform: none;\n  line-height: 27rem;\n  padding-bottom: 0;\n  font-family: ", ";\n  font-size: 18rem;\n  color: ", ";\n  &:hover {\n    color: ", ";\n  }\n  margin-left: 25rem;\n  margin-right: 25rem;\n  border-bottom: 4rem solid transparent;\n  padding-top: 4rem;\n  text-decoration: none;\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, function (props) {
  return props.color;
});
;// CONCATENATED MODULE: ./src/components/shared/icons/Hamburger.js
var Hamburger_jsx = react.createElement;


var Hamburger = function Hamburger(_ref) {
  var color = _ref.color;
  return Hamburger_jsx("svg", {
    style: {
      width: '20px',
      height: '17px'
    },
    viewBox: "0 0 20 17",
    "data-id": "icons_Hamburger_svg"
  }, Hamburger_jsx("title", {
    "data-id": "icons_Hamburger_title"
  }, "Hamburger of Menu icoon"), Hamburger_jsx("g", {
    fill: color,
    "data-id": "icons_Hamburger_g"
  }, Hamburger_jsx("path", {
    d: "M0,0 L18.4967494,0 C19.3269718,0 20,0.665797234 20,1.5 L20,3 L0,3 L0,0 Z",
    "data-id": "icons_Hamburger_path"
  }), Hamburger_jsx("rect", {
    x: "0",
    y: "7",
    width: "20",
    height: "3",
    "data-id": "icons_Hamburger_rect"
  }), Hamburger_jsx("path", {
    d: "M0,14 L20,14 L20,17 L1.5032506,17 C0.673028218,17 0,16.3342028 0,15.5 L0,14 Z",
    "data-id": "icons_Hamburger_path"
  })));
};

/* harmony default export */ var icons_Hamburger = (Hamburger);
;// CONCATENATED MODULE: ./src/components/MenuHamburger.js


var MenuHamburger_templateObject, MenuHamburger_templateObject2;

var MenuHamburger_jsx = react.createElement;










var MenuHamburger_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {}),
    mobileMenuIsOpen: state.menu.mobileMenuIsOpen,
    env: lodash_get_default()(ownProps, 'match.params.env')
  };
};

var MenuHamburger_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPress: function onPress(mobileMenuIsOpen) {
      if (!mobileMenuIsOpen) {
        dispatch((0,menu/* updateMobileMenuState */.WY)(true));
      }
    }
  };
};

var mergeProps = function mergeProps(stateProps, dispatchProps) {
  return {
    onPress: function onPress() {
      return dispatchProps.onPress(stateProps.mobileMenuIsOpen);
    },
    menuColor: stateProps.env !== 'closed' ? lodash_get_default()(stateProps, 'styling.navActiveLabel') : styleGuide/* colorPalette.blue */.K5.blue
  };
};

var MenuHamburger = function MenuHamburger(_ref) {
  var onPress = _ref.onPress,
      menuColor = _ref.menuColor;
  return MenuHamburger_jsx(MenuHamburger_MenuButton, {
    onClick: onPress,
    "data-id": "components_MenuHamburger_MenuButton"
  }, MenuHamburger_jsx(ButtonLabel, {
    color: menuColor,
    "data-id": "components_MenuHamburger_ButtonLabel"
  }, "Menu"), MenuHamburger_jsx(icons_Hamburger, {
    color: menuColor,
    "data-id": "components_MenuHamburger_Hamburger"
  }));
};

/* harmony default export */ var components_MenuHamburger = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(MenuHamburger_mapStateToProps, MenuHamburger_mapDispatchToProps, mergeProps)(MenuHamburger)));
var MenuHamburger_MenuButton = styled_components_browser_esm["default"].button(MenuHamburger_templateObject || (MenuHamburger_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  padding: 10rem;\n  align-items: center;\n  -webkit-tap-highlight-color: transparent;\n  &:active {\n    opacity: 0.5;\n  }\n"])));
var ButtonLabel = styled_components_browser_esm["default"].span(MenuHamburger_templateObject2 || (MenuHamburger_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 14rem;\n  text-transform: uppercase;\n  color: ", ";\n  letter-spacing: 0.58rem;\n  margin-right: 8rem;\n  text-transform: uppercase;\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.color;
});
// EXTERNAL MODULE: ./src/components/shared/icons/Login.js
var Login = __webpack_require__(61326);
;// CONCATENATED MODULE: ./src/components/LoginBarOpenEnv.js


var LoginBarOpenEnv_templateObject, LoginBarOpenEnv_templateObject2;

var LoginBarOpenEnv_jsx = react.createElement;






var LoginBarOpenEnv = function LoginBarOpenEnv(_ref) {
  var projectSlug = _ref.projectSlug,
      color = _ref.color;
  return LoginBarOpenEnv_jsx(LoginItemlink, {
    href: "/".concat(String(projectSlug), "/closed"),
    color: color,
    "data-id": "components_LoginBarOpenEnv_LoginItemlink"
  }, LoginBarOpenEnv_jsx(LoginIconWrapper, {
    "data-id": "components_LoginBarOpenEnv_LoginIconWrapper"
  }, LoginBarOpenEnv_jsx(Login/* default */.Z, {
    color: styleGuide/* colorPalette.beige */.K5.beige,
    "data-id": "components_LoginBarOpenEnv_LoginIcon"
  })), "Naar Mijn Homestudios");
};

/* harmony default export */ var components_LoginBarOpenEnv = (LoginBarOpenEnv);
var LoginItemlink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(LoginBarOpenEnv_templateObject || (LoginBarOpenEnv_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 30rem;\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  line-height: 24rem;\n\n  &:hover {\n    color: ", ";\n    > span > svg > g > g {\n      fill: ", ";\n    }\n  }\n"])), styleGuide/* colorPalette.headerGrey */.K5.headerGrey, styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});
var LoginIconWrapper = styled_components_browser_esm["default"].span(LoginBarOpenEnv_templateObject2 || (LoginBarOpenEnv_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 8rem;\n"])));
;// CONCATENATED MODULE: ./src/components/shared/icons/Logout.js
var Logout_jsx = react.createElement;


var Logout_defaultProps = {
  color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
  width: 63,
  height: 64
};

var LogOut = function LogOut(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Logout_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 63 64",
    version: "1.1",
    "data-id": "icons_Logout_svg"
  }, Logout_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Logout_g"
  }, Logout_jsx("g", {
    transform: "translate(-481.000000, -481.000000)",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_Logout_g_2"
  }, Logout_jsx("g", {
    transform: "translate(512.500000, 513.000000) rotate(-270.000000) translate(-512.500000, -513.000000) translate(480.500000, 481.500000)",
    "data-id": "icons_Logout_g_3"
  }, Logout_jsx("path", {
    d: "M31.8031846,0.0340043966 C33.1876996,-0.133675891 34.6301975,0.318208276 35.7092424,1.40244607 L50.4446406,16.2087577 C52.2633193,18.0361885 52.2937249,20.9641991 50.5217153,22.8427867 L50.5252508,22.8463392 L47.0837621,26.3043899 L36.5853477,15.7611365 L36.5556492,42.7704521 L26.8548513,42.7697416 L26.9163696,16.1917054 L20.0687475,23.0722813 C18.1800653,24.9700527 15.20456,24.9643686 13.3646681,23.1156224 C13.3597184,23.1106488 13.35689,23.1049647 13.3526473,23.1007016 L10.0363165,19.7684112 L28.2577512,1.45928685 C29.2484078,0.463862763 30.5360492,-0.00862618523 31.8031846,0.0340043966 Z M9.68826351,48 L9.68826351,53.0717469 L54.3117365,53.0717469 L54.3117365,48 L54.2999878,48 L54.2999878,36 C54.2999878,32.6862915 56.9862793,30 60.2999878,30 L63.9999876,30 L63.9999876,48 L54.3117365,48 L54.3117365,44.9133759 C54.3117365,41.5837204 56.998028,38.8845012 60.3117365,38.8845012 L64,38.8845012 L64,56.9711253 C64,60.3007809 61.3137085,63 58,63 L6,63 C2.6862915,63 1.29399067e-15,60.3007809 8.8817842e-16,56.9711253 L0,39.3079052 L0,30 L3.69999981,30 C7.01370831,30 9.69999981,32.6862915 9.69999981,36 L9.69999981,48 L9.68826351,48 Z",
    "data-id": "icons_Logout_path"
  })))));
};

LogOut.defaultProps = Logout_defaultProps;
/* harmony default export */ var Logout = (LogOut);
// EXTERNAL MODULE: ./src/components/UserAvatar.js
var UserAvatar = __webpack_require__(36154);
;// CONCATENATED MODULE: ./src/components/shared/icons/Key.js
var Key_jsx = react.createElement;


var Key_defaultProps = {
  color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
  width: 66,
  height: 65
};

var Key = function Key(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Key_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 66 65",
    "data-id": "icons_Key_svg"
  }, Key_jsx("g", {
    "data-id": "icons_Key_g"
  }, Key_jsx("g", {
    fill: color,
    transform: "translate(-40.000000, -612.000000)",
    "data-id": "icons_Key_g_2"
  }, Key_jsx("path", {
    d: "M56.5,668.9l-3.8,3.8c-2.3,2.3-6.1,2.3-8.5,0l-4.2-4.2l30.9-30.9c-1.1-2.3-1.7-4.9-1.7-7.6c0-9.9,8.1-18,18-18s18,8.1,18,18s-8.1,18-18,18c-2.8,0-5.5-0.7-7.9-1.8L65,660.4l3.9,3.9c2.3,2.3,2.3,6.1,0,8.5l-4.2,4.2L56.5,668.9z M87.2,641c6.1,0,11-4.9,11-11s-4.9-11-11-11c-6.1,0-11,4.9-11,11S81.1,641,87.2,641z",
    "data-id": "icons_Key_path"
  }))));
};

Key.defaultProps = Key_defaultProps;
/* harmony default export */ var icons_Key = (Key);
;// CONCATENATED MODULE: ./src/components/shared/icons/Profile.js
var Profile_jsx = react.createElement;


var Profile_defaultProps = {
  color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
  width: 64,
  height: 62
};

var Profile_Message = function Message(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Profile_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 64 62",
    "data-id": "icons_Profile_svg"
  }, Profile_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Profile_g"
  }, Profile_jsx("g", {
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_Profile_g_2"
  }, Profile_jsx("g", {
    "data-id": "icons_Profile_g_3"
  }, Profile_jsx("path", {
    d: "M24.122,33.791 C24.042,34.182 24,34.586 24,35 C24,38.307 26.688,41 30.003,41 L33.996,41 C37.322,41 40,38.314 40,35 C40,34.586 39.958,34.182 39.878,33.791 C44.728,30.688 48,24.808 48,18.064 C48,8.088 40.836,0 32,0 C23.164,0 16,8.088 16,18.064 C16,24.808 19.272,30.688 24.122,33.791 Z",
    "data-id": "icons_Profile_path"
  }), Profile_jsx("path", {
    d: "M50.506,35 L45.559,35 C44.005,41.9 38.523,47 32,47 C25.477,47 19.995,41.9 18.441,35 L13.495,35 C6.05,35 0,41.044 0,48.5 L0,62 L64,62 L64,48.5 C64,41.043 57.959,35 50.506,35 Z",
    "data-id": "icons_Profile_path_5"
  })))));
};

Profile_Message.defaultProps = Profile_defaultProps;
/* harmony default export */ var Profile = (Profile_Message);
;// CONCATENATED MODULE: ./src/components/shared/icons/Actions.js
var Actions_jsx = react.createElement;


var Actions_defaultProps = {
  color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
  width: 62,
  height: 64
};

var Actions = function Actions(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Actions_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 62 64",
    version: "1.1",
    "data-id": "icons_Actions_svg"
  }, Actions_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Actions_g"
  }, Actions_jsx("g", {
    transform: "translate(-1.000000, 0.000000)",
    fill: color,
    "data-id": "icons_Actions_g_2"
  }, Actions_jsx("path", {
    d: "M51.4780381,48.7176286 C51.4780381,49.074581 51.3665722,49.363379 51.1438038,49.5859839 C50.9211989,49.8089157 50.6317471,49.9202182 50.2757753,49.9202182 L41.4593452,49.9202182 C41.10321,49.9202182 40.8139216,49.8089157 40.5911533,49.5859839 C40.3683849,49.363379 40.2572459,49.074581 40.2572459,48.7176286 L40.2572459,35.5602389 L30.1050227,35.5602389 L30.1050227,48.7181189 C30.1050227,49.074581 29.9938837,49.363379 29.7712788,49.5859839 C29.548347,49.8089157 29.2590586,49.9202182 28.9030869,49.9202182 L20.0864933,49.9202182 C19.7746503,49.9202182 19.5077532,49.8089157 19.2851482,49.5859839 C19.0623799,49.363379 18.9507505,49.074581 18.9507505,48.7181189 L18.9507505,27.2780933 C18.9507505,26.8775025 19.0847711,26.5656594 19.3516682,26.3435448 L34.1789218,14.4542841 C34.7135332,14.0984758 35.2033621,14.0984758 35.6487354,14.4542841 L51.0101101,26.3435448 C51.3217897,26.5656594 51.4780381,26.8775025 51.4780381,27.2780933 L51.4780381,48.7176286 Z M58.3737243,0 L12.0488536,0 C9.59022951,0 7.60280222,1.98742729 7.60280222,4.44556104 L7.60280222,12.4603192 L4.1903438,12.4603192 C2.42503113,12.4603192 1,13.8860041 1,15.6514802 L1,17.1938611 C1,18.9590103 2.42503113,20.3842049 4.1903438,20.3842049 L7.60280222,20.3842049 L7.60280222,28.0331849 L4.1903438,28.0331849 C2.42503113,28.0331849 1,29.4580526 1,31.2233653 L1,32.7663999 C1,34.531876 2.42503113,35.9569071 4.1903438,35.9569071 L7.60280222,35.9569071 L7.60280222,43.6060506 L4.1903438,43.6060506 C2.42503113,43.6060506 1,45.0309183 1,46.7960675 L1,48.3521773 C1,50.1173265 2.42503113,51.5421942 4.1903438,51.5421942 L7.60280222,51.5421942 L7.60280222,59.5571158 C7.60280222,62.0157399 9.59022951,64.0033306 12.0488536,64.0033306 L58.3737243,64.0033306 C60.8323484,64.0033306 62.8199391,62.0157399 62.8199391,59.5571158 L62.8199391,4.4589631 C62.8326874,2.00017559 60.8323484,0 58.3737243,0 Z",
    "data-id": "icons_Actions_path"
  }))));
};

Actions.defaultProps = Actions_defaultProps;
/* harmony default export */ var icons_Actions = (Actions);
;// CONCATENATED MODULE: ./src/components/shared/icons/Message.js
var Message_jsx = react.createElement;


var Message_defaultProps = {
  color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
  width: 64,
  height: 46
};

var Message_Message = function Message(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Message_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 64 46",
    "data-id": "icons_Message_svg"
  }, Message_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Message_g"
  }, Message_jsx("g", {
    transform: "translate(0.000000, -9.000000)",
    "data-id": "icons_Message_g_2"
  }, Message_jsx("g", {
    transform: "translate(0.000000, 9.000000)",
    "data-id": "icons_Message_g_3"
  }, Message_jsx("g", {
    "data-id": "icons_Message_g_4"
  }, Message_jsx("path", {
    d: "M57.207,5.831 C57.006,5.757 56.787,5.716 56.559,5.716 L7.435,5.716 C7.272,5.716 7.115,5.737 6.964,5.777 L33.047,24.877 L57.207,5.831 Z",
    "data-id": "icons_Message_path"
  }), Message_jsx("path", {
    d: "M63.994,0.145 L7.435,0.145 C3.328,0.145 0,3.478 0,7.59 L0,45.854 L54.021,45.854 L56.559,45.854 C60.666,45.854 63.995,42.521 63.995,38.408 L64,0.145 L63.994,0.145 Z M7.435,5.715 L56.559,5.715 C56.788,5.715 57.006,5.756 57.207,5.83 L33.047,24.875 L6.964,5.775 C7.114,5.736 7.272,5.715 7.435,5.715 Z M58.423,38.408 C58.423,39.38 57.688,40.166 56.75,40.263 L56.75,40.283 L56.559,40.283 L5.571,40.283 L5.571,11.661 L31.464,30.621 C32.474,31.36 33.852,31.336 34.834,30.561 L58.423,11.966 L58.423,38.408 L58.423,38.408 Z",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_Message_path_6"
  }))))));
};

Message_Message.defaultProps = Message_defaultProps;
/* harmony default export */ var icons_Message = (Message_Message);
;// CONCATENATED MODULE: ./src/components/shared/icons/Documents.js
var Documents_jsx = react.createElement;


var Documents_defaultProps = {
  color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
  width: 46,
  height: 64
};

var Documents = function Documents(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Documents_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 46 64",
    version: "1.1",
    "data-id": "icons_Documents_svg"
  }, Documents_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Documents_g"
  }, Documents_jsx("g", {
    transform: "translate(-9.000000, 0.000000)",
    fill: color,
    "data-id": "icons_Documents_g_2"
  }, Documents_jsx("g", {
    transform: "translate(9.000000, 0.000000)",
    "data-id": "icons_Documents_g_3"
  }, Documents_jsx("path", {
    d: "M40.7462,55.7117 C40.7462,57.4117 39.4462,58.7117 37.7462,58.7117 L5.0002,58.7117 L5.0002,5.0577 L40.7462,5.0577 L40.7462,55.7117 Z M40.7462,-0.0003 L0.0002,-0.0003 L0.0002,5.0577 L0.0002,63.7117 L37.1942,63.7117 L39.4802,63.7117 L39.7462,63.7117 C42.4982,63.7117 44.8272,61.8317 45.5262,59.2947 C45.6542,58.8887 45.7472,58.4667 45.7922,58.0277 L45.8042,35.9307 L45.8042,5.0577 L45.8042,-0.0003 L40.7462,-0.0003 Z",
    "data-id": "icons_Documents_path"
  }), Documents_jsx("polygon", {
    points: "11.335 19.524 34.469 19.524 34.469 14.763 11.335 14.763",
    "data-id": "icons_Documents_polygon"
  }), Documents_jsx("polygon", {
    points: "11.335 29.318 34.469 29.318 34.469 24.557 11.335 24.557",
    "data-id": "icons_Documents_polygon_6"
  }), Documents_jsx("polygon", {
    points: "11.335 39.112 34.469 39.112 34.469 34.351 11.335 34.351",
    "data-id": "icons_Documents_polygon_7"
  }), Documents_jsx("polygon", {
    points: "11.335 48.906 20.982 48.906 20.982 44.145 11.335 44.145",
    "data-id": "icons_Documents_polygon_8"
  })))));
};

Documents.defaultProps = Documents_defaultProps;
/* harmony default export */ var icons_Documents = (Documents);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseBase.js
var HouseBase_jsx = react.createElement;


var HouseBase_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange,
  width: 21,
  height: 20
};

var HouseBase = function HouseBase(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return HouseBase_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseBase_svg"
  }, HouseBase_jsx("title", {
    "data-id": "icons_HouseBase_title"
  }, "Huis Basis"), HouseBase_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseBase_g"
  }, HouseBase_jsx("g", {
    transform: "translate(-46.000000, -767.000000)",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_HouseBase_g_3"
  }, HouseBase_jsx("g", {
    transform: "translate(40.000000, 761.000000)",
    "data-id": "icons_HouseBase_g_4"
  }, HouseBase_jsx("g", {
    transform: "translate(6.000000, 6.000000)",
    "data-id": "icons_HouseBase_g_5"
  }, HouseBase_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    "data-id": "icons_HouseBase_path"
  }))))));
};

HouseBase.defaultProps = HouseBase_defaultProps;
/* harmony default export */ var icons_HouseBase = (HouseBase);
;// CONCATENATED MODULE: ./src/components/shared/icons/Notification.js
var Notification_jsx = react.createElement;


var Notification_defaultProps = {
  color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
  width: 59,
  height: 64
};

var Notification = function Notification(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Notification_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 59 64",
    version: "1.1",
    "data-id": "icons_Notification_svg"
  }, Notification_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Notification_g"
  }, Notification_jsx("g", {
    transform: "translate(-3.000000, 0.000000)",
    fill: color,
    "data-id": "icons_Notification_g_2"
  }, Notification_jsx("path", {
    d: "M37.0595743,5.62218931 C45.7711472,7.82001327 52.2190871,15.7081412 52.2190871,25.1022661 C52.2190871,25.3236198 52.2155072,25.5441372 52.2084019,25.7637638 L52.2190871,25.7637638 L52.2190871,47.1204997 C52.7455964,49.3569639 54.1963032,50.6921309 56.5712075,51.1260006 L57.4099998,51.1260006 C59.6191388,51.1260006 61.4099998,52.9168616 61.4099998,55.1260006 L61.4099998,55.7373164 L3,55.7373164 L3,55.1260006 C3,53.0676108 4.5547875,51.3723611 6.55403176,51.1505821 C6.52712485,51.1425843 6.56604775,51.1333272 6.67080047,51.1228108 C7.77679105,51.0117778 12.0351186,50.1818217 12.0351186,45.0718904 C12.0351186,44.9078203 12.0368259,44.7563577 12.0402405,44.6175026 L12.0402405,25.7637638 L12.0509257,25.7637638 C12.0438205,25.5441372 12.0402405,25.3236198 12.0402405,25.1022661 C12.0402405,15.726793 18.4626013,7.85134262 27.1478902,5.63534777 C27.1211125,5.42587423 27.107308,5.21234526 27.107308,4.99559209 C27.107308,2.23660276 29.3439108,4.72863212e-17 32.1029001,4.72863212e-17 C34.8618894,4.72863212e-17 37.0984922,2.23660276 37.0984922,4.99559209 C37.0984922,5.20780852 37.0852595,5.41693429 37.0595743,5.62218931 Z M26.1028368,58.8967732 L37.8784459,58.8967732 C37.8784459,61.7151869 35.5936702,63.9999627 32.7752565,63.9999627 L31.2060263,63.9999627 C28.3876126,63.9999627 26.1028368,61.7151869 26.1028368,58.8967732 Z M32.2780216,6.32354255 C32.9147114,6.32354255 33.4308505,5.80740345 33.4308505,5.17071361 C33.4308505,4.53402376 32.9147114,4.01788466 32.2780216,4.01788466 C31.6413318,4.01788466 31.1251927,4.53402376 31.1251927,5.17071361 C31.1251927,5.80740345 31.6413318,6.32354255 32.2780216,6.32354255 Z",
    "data-id": "icons_Notification_path"
  }))));
};

Notification.defaultProps = Notification_defaultProps;
/* harmony default export */ var icons_Notification = (Notification);
;// CONCATENATED MODULE: ./src/components/NotificationsCounter.js


var NotificationsCounter_templateObject;

var NotificationsCounter_jsx = react.createElement;






var NotificationsCounter = function NotificationsCounter(_ref) {
  var notificationsCount = _ref.notificationsCount;
  return NotificationsCounter_jsx(NotificationsCounter_Container, {
    "data-id": "components_NotificationsCounter_Container"
  }, NotificationsCounter_jsx(icons_Notification, {
    color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
    width: 21,
    height: 21,
    "data-id": "components_NotificationsCounter_Alert"
  }), NotificationsCounter_jsx(NotificationNumber, {
    number: notificationsCount,
    "data-id": "components_NotificationsCounter_NotificationsNumber"
  }));
};

/* harmony default export */ var components_NotificationsCounter = (NotificationsCounter);
var NotificationsCounter_Container = styled_components_browser_esm["default"].div(NotificationsCounter_templateObject || (NotificationsCounter_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  position: relative;\n"])));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
;// CONCATENATED MODULE: ./src/services/countNotifications.js

/* harmony default export */ var countNotifications = (function (notifications) {
  var total = 0;
  var keys = [];
  if (!notifications) return total;

  for (var _i = 0, _Object$entries = Object.entries(notifications); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (value.unreadCount) {
      total = total + value.unreadCount;
    }

    keys.push(key);
  }

  return total;
});
;// CONCATENATED MODULE: ./src/components/LoginBarClosedEnv.js








var LoginBarClosedEnv_templateObject, LoginBarClosedEnv_templateObject2, LoginBarClosedEnv_templateObject3, LoginBarClosedEnv_templateObject4;

var LoginBarClosedEnv_jsx = react.createElement;

function LoginBarClosedEnv_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, LoginBarClosedEnv_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function LoginBarClosedEnv_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (LoginBarClosedEnv_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}























var connectApiData = (0,withApiData/* default */.Z)({
  profile: 'getProfile'
}, function (ownProps) {
  return {
    profile: {
      projectSlug: ownProps.projectSlug
    }
  };
});

var LoginBarClosedEnv_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    notifications: (0,apiData/* getResultData */.yh)(state.apiData, 'getNotifications', {
      projectSlug: ownProps.projectSlug
    }),
    activationPossible: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: ownProps.projectSlug,
      env: 'closed'
    }), 'activationPossible', false),
    logoutUserRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'logoutUser')
  };
};

var LoginBarClosedEnv_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getNotifications: function getNotifications() {
      dispatch((0,apiData/* performApiRequest */.T4)('getNotifications', {
        projectSlug: String(ownProps.projectSlug)
      }));
    },
    openActivationModal: function openActivationModal(activationType) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
        type: 'activation',
        componentProps: {}
      }));
    },
    onLogout: function onLogout() {
      var _ownProps$router;

      dispatch((0,apiData/* performApiRequest */.T4)('logoutUser'));
      dispatch((0,apiData/* clearCache */.LK)());
      (_ownProps$router = ownProps.router) === null || _ownProps$router === void 0 || _ownProps$router.push("/".concat(ownProps.projectSlug, "/closed"));
    }
  };
};

var LoginBarClosedEnv = /*#__PURE__*/function (_Component) {
  function LoginBarClosedEnv() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, LoginBarClosedEnv);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = LoginBarClosedEnv_callSuper(this, LoginBarClosedEnv, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "menuOptions", new Map());

    (0,defineProperty/* default */.Z)(_this, "state", {
      hover: 'none'
    });

    (0,defineProperty/* default */.Z)(_this, "hoverIn", function (type) {
      if (!type) return;

      _this.setState({
        hover: type
      }, function () {
        if (_this.hoverTimeout !== 0) {
          clearTimeout(_this.hoverTimeout);
        }
      });
    });

    (0,defineProperty/* default */.Z)(_this, "hoverOut", function () {
      clearTimeout(_this.hoverTimeout);
      _this.hoverTimeout = setTimeout(function () {
        _this.setState({
          hover: 'none'
        });
      }, 150);
    });

    return _this;
  }

  (0,inherits/* default */.Z)(LoginBarClosedEnv, _Component);

  return (0,createClass/* default */.Z)(LoginBarClosedEnv, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          phase = _this$props.phase,
          logoutUserRequest = _this$props.logoutUserRequest,
          getNotifications = _this$props.getNotifications;

      if ((phase === 'cj2' || phase === 'cj3') && !logoutUserRequest) {
        getNotifications();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.hoverTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          profile = _this$props2.profile,
          notifications = _this$props2.notifications,
          phase = _this$props2.phase,
          projectSlug = _this$props2.projectSlug,
          onLogout = _this$props2.onLogout,
          openActivationModal = _this$props2.openActivationModal,
          activationPossible = _this$props2.activationPossible;
      var name = lodash_get_default()(profile, 'data.customer.customerName', profile && profile.data && profile.data.name);
      var imageUrl = lodash_get_default()(profile, 'data.customer.customerImage', profile && profile.data && profile.data.image);
      var notificationsTotal = notifications ? countNotifications(notifications) : 0;
      var itemsCJ1 = [{
        name: 'profile',
        label: name,
        phase: ['cj1', 'cj2', 'cj3'],
        icon: LoginBarClosedEnv_jsx(UserAvatar/* default */.Z, {
          imageUrl: imageUrl,
          phase: phase,
          size: "xsmall",
          mode: "bg",
          name: name,
          "data-id": "components_LoginBarClosedEnv_UserAvatar"
        }),
        flyoutMenuOptions: [{
          name: 'profile',
          type: 'link',
          label: 'Profiel',
          link: "/".concat(projectSlug, "/closed/profiel"),
          icon: LoginBarClosedEnv_jsx(Profile, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_SettingsIcon"
          })
        }, {
          name: 'logout',
          type: 'button',
          label: 'Uitloggen',
          icon: LoginBarClosedEnv_jsx(Logout, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_LoginIcon"
          }),
          onClick: onLogout
        }, {
          name: 'activeLink',
          type: 'button',
          label: 'Activatiecode invoeren',
          icon: LoginBarClosedEnv_jsx(icons_Key, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_LockIcon"
          }),
          onClick: openActivationModal,
          disable: !activationPossible
        }]
      }];
      var itemsCJ2 = notifications ? [{
        name: 'notifications',
        label: 'Notificaties',
        phase: ['cj2', 'cj3'],
        icon: LoginBarClosedEnv_jsx(components_NotificationsCounter, {
          notificationsCount: notificationsTotal,
          "data-id": "components_LoginBarClosedEnv_NotificationsCounter"
        }),
        flyoutMenuOptions: [notifications.messages && {
          name: 'messages',
          type: 'link',
          label: 'Ongelezen berichten',
          link: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.messages.link)),
          icon: LoginBarClosedEnv_jsx(icons_Message, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_MailIcon"
          }),
          unreadCount: notifications.messages ? notifications.messages.unreadCount : 0
        }, notifications.documents && {
          name: 'documents',
          type: 'link',
          label: 'Nieuwe documenten',
          link: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.documents.link)),
          icon: LoginBarClosedEnv_jsx(icons_Documents, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_FolderIcon"
          }),
          unreadCount: notifications.documents ? notifications.documents.unreadCount : 0
        }, notifications.actions && {
          name: 'actions',
          type: 'link',
          label: 'Acties in planning',
          link: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.actions.link)),
          icon: LoginBarClosedEnv_jsx(icons_Actions, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_CalendarIcon"
          }),
          unreadCount: notifications.actions ? notifications.actions.unreadCount : 0
        }, notifications.newOptions && {
          name: 'options',
          type: 'link',
          label: 'Nieuwe opties',
          link: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.newOptions.link)),
          icon: LoginBarClosedEnv_jsx(icons_HouseBase, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_HouseIcon"
          }),
          unreadCount: notifications.newOptions ? notifications.newOptions.unreadCount : 0
        }, notifications.ordersToConfirm && {
          name: 'orders',
          type: 'link',
          label: 'Orders ter bevestiging',
          link: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.ordersToConfirm.link)),
          icon: LoginBarClosedEnv_jsx(icons_HouseBase, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_HouseIcon_9"
          }),
          unreadCount: notifications.ordersToConfirm ? notifications.ordersToConfirm.unreadCount : 0
        }]
      }] : [];
      var items = notifications ? itemsCJ1.concat(itemsCJ2) : itemsCJ1;
      return LoginBarClosedEnv_jsx(LoginBarClosedEnv_Container, {
        "data-id": "components_LoginBarClosedEnv_Container"
      }, items.map(function (item, index) {
        return item.phase.includes(phase) ? LoginBarClosedEnv_jsx(ItemContainer, {
          key: index,
          onMouseOver: function onMouseOver() {
            return _this2.hoverIn(item.name);
          },
          onMouseLeave: _this2.hoverOut,
          ref: function ref(item) {
            return _this2.menuOptions.set(index, item);
          },
          "data-id": "components_LoginBarClosedEnv_ItemContainer"
        }, LoginBarClosedEnv_jsx(HoverButton, {
          "data-e2e-header-profilebar-button": item.name,
          "data-id": "components_LoginBarClosedEnv_HoverButton"
        }, LoginBarClosedEnv_jsx(LoginBarClosedEnv_IconWrapper, {
          "data-id": "components_LoginBarClosedEnv_IconWrapper"
        }, item.icon), item.label, LoginBarClosedEnv_jsx(Caret/* default */.Z, {
          direction: "down",
          color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
          width: 10,
          height: 6,
          "data-id": "components_LoginBarClosedEnv_Caret"
        })), LoginBarClosedEnv_jsx(components_FlyOutMenu, {
          visible: _this2.state.hover === item.name,
          projectSlug: projectSlug,
          options: item.flyoutMenuOptions,
          target: _this2.menuOptions.get(index),
          position: "bottom",
          "data-id": "components_LoginBarClosedEnv_FlyOutMenu"
        })) : null;
      }));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_LoginBarClosedEnv = ((0,withMatch/* default */.Z)(connectApiData((0,es/* connect */.$j)(LoginBarClosedEnv_mapStateToProps, LoginBarClosedEnv_mapDispatchToProps)(LoginBarClosedEnv))));
var LoginBarClosedEnv_Container = styled_components_browser_esm["default"].div(LoginBarClosedEnv_templateObject || (LoginBarClosedEnv_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n"])));
var ItemContainer = styled_components_browser_esm["default"].div(LoginBarClosedEnv_templateObject2 || (LoginBarClosedEnv_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  line-height: 24rem;\n  margin-left: 40rem;\n"])), styleGuide/* colorPalette.headerGrey */.K5.headerGrey, styleGuide/* fonts.primary */.Rq.primary);
var HoverButton = styled_components_browser_esm["default"].div(LoginBarClosedEnv_templateObject3 || (LoginBarClosedEnv_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  > svg {\n    margin-left: 8rem;\n  }\n"])));
var LoginBarClosedEnv_IconWrapper = styled_components_browser_esm["default"].div(LoginBarClosedEnv_templateObject4 || (LoginBarClosedEnv_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin-right: 10rem;\n"])));
;// CONCATENATED MODULE: ./src/components/HeaderLink.js


var HeaderLink_templateObject;

var HeaderLink_jsx = react.createElement;




var HeaderLink = function HeaderLink(_ref) {
  var color = _ref.color,
      headerLink = _ref.headerLink,
      caption = _ref.caption;
  return HeaderLink_jsx(HeaderLinkItem, {
    color: color,
    target: "_blank",
    href: headerLink,
    rel: "noopener noreferrer",
    "data-id": "components_HeaderLink_HeaderLinkItem"
  }, caption);
};

/* harmony default export */ var components_HeaderLink = (HeaderLink);
var HeaderLinkItem = styled_components_browser_esm["default"].a(HeaderLink_templateObject || (HeaderLink_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 30rem;\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  line-height: 24rem;\n\n  &:hover {\n    color: ", ";\n    > span > svg > g > g {\n      fill: ", ";\n    }\n  }\n"])), styleGuide/* colorPalette.headerGrey */.K5.headerGrey, styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});
;// CONCATENATED MODULE: ./src/components/LoginBar.js


var LoginBar_templateObject;

var LoginBar_jsx = react.createElement;








var LoginBar = function LoginBar(_ref) {
  var match = _ref.match,
      settings = _ref.settings;
  var _match$params = match.params,
      projectSlug = _match$params.projectSlug,
      env = _match$params.env;
  var _settings$styling$nav = settings.styling.navActiveLabel,
      color = _settings$styling$nav === void 0 ? styleGuide/* colorPalette.blue */.K5.blue : _settings$styling$nav;
  var loggedIn = settings && settings.user;
  var phase = settings && settings.phase;
  var showLogin = settings && settings.showLogin;
  var showb2bLink = window.location.pathname.startsWith('/portal/open');
  return LoginBar_jsx(Bar, {
    "data-id": "components_LoginBar_Bar"
  }, showb2bLink && LoginBar_jsx(components_HeaderLink, {
    color: color,
    headerLink: 'https://www2.homestudios.nl/',
    caption: 'Over Homestudios',
    "data-id": "components_LoginBar_HeaderLink"
  }), showLogin && env === 'open' && LoginBar_jsx(components_LoginBarOpenEnv, {
    projectSlug: String(projectSlug),
    color: color,
    "data-id": "components_LoginBar_LoginBarOpenEnv"
  }), loggedIn && env === 'closed' && LoginBar_jsx(components_LoginBarClosedEnv, {
    projectSlug: String(projectSlug),
    phase: phase,
    "data-id": "components_LoginBar_LoginBarClosedEnv"
  }));
};

/* harmony default export */ var components_LoginBar = ((0,withMatch/* default */.Z)(LoginBar));
var Bar = styled_components_browser_esm["default"].div(LoginBar_templateObject || (LoginBar_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: flex-end;\n"])));
;// CONCATENATED MODULE: ./src/constants/logos.js
var HSSiteLogo = {
  small: '/images/Logo_Homestudios_small.png',
  large: '/images/Logo_Homestudios.png'
};
;// CONCATENATED MODULE: ./src/components/Header.js


var Header_templateObject, Header_templateObject2, Header_templateObject3, Header_templateObject4, Header_templateObject5, Header_templateObject6, Header_templateObject7;

var Header_jsx = react.createElement;












var whichLayout = function whichLayout(renderWidth) {
  return renderWidth > 1040 ? 'large' : 'small';
};

var Header = function Header(_ref) {
  var match = _ref.match,
      settings = _ref.settings,
      renderWidth = _ref.renderWidth,
      hasMenu = _ref.hasMenu;
  var _match$params = match.params,
      projectSlug = _match$params.projectSlug,
      env = _match$params.env;
  var layout = whichLayout(renderWidth);
  var logo = match.params.env === 'closed' ? layout === 'large' ? HSSiteLogo.large : HSSiteLogo.small : settings && settings.logoUrl;
  var submenuIsActive = match && settings && settings.menu ? (0,menu/* isSubmenuActive */.XP)(match, settings.menu) : false;
  return Header_jsx(Header_Container, {
    layout: layout,
    submenuIsActive: submenuIsActive,
    "data-id": "components_Header_Container"
  }, Header_jsx(MaxWidth, {
    "data-id": "components_Header_MaxWidth"
  }, Header_jsx(GridCell, {
    layout: layout,
    "data-id": "components_Header_GridCell"
  }, Header_jsx(Link/* default */.Z, {
    href: '/' + (0,getLinkFromPageObject/* default */.Z)({
      projectSlug: projectSlug,
      env: env
    }),
    "data-id": "components_Header_Link"
  }, logo ? Header_jsx(Logo, {
    src: logo,
    layout: layout,
    alt: "Homestudios",
    name: "Homestudios",
    "data-id": "components_Header_Logo"
  }) : ''), hasMenu ? Header_jsx(react.Fragment, null, Header_jsx(MenuLoginWrapper, {
    "data-id": "components_Header_MenuLoginWrapper"
  }, Header_jsx(LoginBarWrapper, {
    "data-id": "components_Header_LoginBarWrapper"
  }, settings && Header_jsx(components_LoginBar, {
    settings: settings,
    "data-id": "components_Header_LoginBar"
  })), settings && settings.menu && Header_jsx(components_Menu, {
    menuItems: settings && settings.menu,
    "data-id": "components_Header_Menu"
  })), Header_jsx(MobileMenuButton, {
    "data-id": "components_Header_MobileMenuButton"
  }, Header_jsx(components_MenuHamburger, {
    "data-id": "components_Header_MenuHamburger"
  }))) : null)));
};

/* harmony default export */ var components_Header = ((0,withMatch/* default */.Z)(Header));
var Header_Container = styled_components_browser_esm["default"].header(Header_templateObject || (Header_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.32);\n  height: 42rem;\n  background: white;\n  position: relative;\n  z-index: 10;\n  color: ", ";\n  margin-bottom: ", ";\n\n  @media only all and (min-width: 1040px) {\n    height: 100rem;\n  }\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey, function (props) {
  return props.submenuIsActive && props.hasMenu && props.layout === 'large' ? '35rem' : '0';
});
var MenuLoginWrapper = styled_components_browser_esm["default"].div(Header_templateObject2 || (Header_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: none;\n\n  @media only all and (min-width: 1040px) {\n    display: flex;\n    flex-direction: column;\n    align-self: flex-end;\n    width: 100%;\n  }\n"])));
var LoginBarWrapper = styled_components_browser_esm["default"].div(Header_templateObject3 || (Header_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: ", "rem;\n  width: 100%;\n  top: 10rem;\n  text-align: right;\n  box-sizing: border-box;\n  padding-left: ", "rem;\n"])), styleGuide/* maxContentWidth */.xN + styleGuide/* gridGutter */.X$, styleGuide/* gridGutter */.X$ / 2);
var MaxWidth = (0,styled_components_browser_esm["default"])(gridElements/* WidthLimit */.N_)(Header_templateObject4 || (Header_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n"])));
var GridCell = styled_components_browser_esm["default"].div(Header_templateObject5 || (Header_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  height: 100%;\n  padding-left: 10rem;\n  padding-right: 10rem;\n\n  @media only all and (min-width: 1040px) {\n    padding-left: ", "rem;\n    padding-right: ", "rem;\n  }\n"])), styleGuide/* gridGutter */.X$ / 2, styleGuide/* gridGutter */.X$ / 2);
var MobileMenuButton = styled_components_browser_esm["default"].div(Header_templateObject6 || (Header_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  position: absolute;\n  right: 0;\n  height: 100%;\n  align-items: center;\n\n  @media only all and (min-width: 1040px) {\n    display: none;\n  }\n"])));
var Logo = styled_components_browser_esm["default"].img(Header_templateObject7 || (Header_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 140rem;\n  max-height: 32rem;\n  margin-top: 5rem;\n\n  @media only all and (min-width: 1040px) {\n    max-width: 280rem;\n    max-height: 80rem;\n    margin-top: 10rem;\n  }\n"])));
// EXTERNAL MODULE: ./src/styles/utils.js
var utils = __webpack_require__(35328);
// EXTERNAL MODULE: ./src/components/shared/buttons/ButtonSecondary.js + 2 modules
var ButtonSecondary = __webpack_require__(6004);
// EXTERNAL MODULE: ./src/components/shared/richText/BBCode.js + 3 modules
var BBCode = __webpack_require__(84124);
// EXTERNAL MODULE: ./node_modules/is-electron/index.js
var is_electron = __webpack_require__(59134);
var is_electron_default = /*#__PURE__*/__webpack_require__.n(is_electron);
;// CONCATENATED MODULE: ./src/components/Footer.js


var Footer_templateObject, Footer_templateObject2, Footer_templateObject3, Footer_templateObject4, Footer_templateObject5, Footer_templateObject6, Footer_templateObject7, Footer_templateObject8, Footer_templateObject9, Footer_templateObject0, Footer_templateObject1, Footer_templateObject10, Footer_templateObject11, Footer_templateObject12, Footer_templateObject13, Footer_templateObject14, Footer_templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20;

var Footer_jsx = react.createElement;













var Footer = function Footer(_ref) {
  var match = _ref.match,
      footer = _ref.footer,
      siteName = _ref.siteName;
  var projectSlug = match.params.projectSlug;
  return footer ? Footer_jsx(FooterContainer, {
    "data-id": "components_Footer_FooterContainer"
  }, Footer_jsx(TopFooter, {
    "data-id": "components_Footer_TopFooter"
  }, Footer_jsx(gridElements/* GridWrapper */.zc, {
    "data-id": "components_Footer_GridWrapper"
  }, Footer_jsx(TopFooterContent, {
    "data-id": "components_Footer_TopFooterContent"
  }, Footer_jsx(FooterContentBlock, {
    "data-id": "components_Footer_FooterContentBlock"
  }, footer.status && footer.status.title && Footer_jsx("h3", {
    "data-id": "components_Footer_h3"
  }, footer.status.title), footer.status && footer.status.content && Footer_jsx(BBCode/* default */.Z, {
    content: footer.status.content,
    "data-id": "components_Footer_BBCode"
  }), footer.status && footer.status.contact && footer.status.contact.linkType === 'external' && Footer_jsx(ButtonSecondary/* default */.Z, {
    label: footer.status.contact.label,
    link: footer.status.contact.url,
    type: "externalLink",
    target: "_blank",
    rel: "noopener noreferrer",
    color: "#fff",
    "data-id": "components_Footer_ButtonSecondary"
  }), footer.status && footer.status.contact && (footer.status.contact.linkType === 'internal' || footer.status.contact.linkType === 'menuitem') && footer.status.contact.url && Footer_jsx(ButtonSecondary/* default */.Z, {
    label: footer.status.contact.label,
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(footer.status.contact.url),
    type: "internalLink",
    color: "#fff",
    "data-id": "components_Footer_ButtonSecondary_8"
  })), Footer_jsx(FooterContentBlock, {
    "data-id": "components_Footer_FooterContentBlock"
  })))), Footer_jsx(BottomFooter, {
    "data-id": "components_Footer_BottomFooter"
  }, Footer_jsx(gridElements/* GridWrapper */.zc, {
    "data-id": "components_Footer_GridWrapper"
  }, Footer_jsx(BottomFooterContent, {
    "data-id": "components_Footer_BottomFooterContent"
  }, Footer_jsx(FooterContentBottomBlockLeft, {
    "data-id": "components_Footer_FooterContentBottomBlockLeft"
  }, Footer_jsx(FooterMeta, {
    "data-id": "components_Footer_FooterMeta"
  }, Footer_jsx("li", {
    "data-id": "components_Footer_li"
  }, "\xA9 ", siteName, ", ", footer.project.copyrightText, is_electron_default()() ? '.' : null), Footer_jsx("li", {
    "data-id": "components_Footer_li_16"
  }, Footer_jsx(Link/* default */.Z, {
    href: "/".concat(String(projectSlug), "/open/sectionpage/disclaimer"),
    rel: "noopener noreferrer",
    "data-id": "components_Footer_Link"
  }, "Disclaimer")), Footer_jsx("li", {
    "data-id": "components_Footer_li"
  }, Footer_jsx(Link/* default */.Z, {
    href: "/".concat(String(projectSlug), "/open/sectionpage/privacy-statement"),
    rel: "noopener noreferrer",
    "data-id": "components_Footer_Link"
  }, "Privacy Statement")), Footer_jsx("li", {
    "data-id": "components_Footer_li"
  }, Footer_jsx(Link/* default */.Z, {
    href: "/".concat(String(projectSlug), "/open/sectionpage/about"),
    rel: "noopener noreferrer",
    "data-id": "components_Footer_Link"
  }, "Over Homestudios.nl")))), Footer_jsx(FooterContentBottomBlockRight, {
    "data-id": "components_Footer_FooterContentBottomBlockRight"
  }, Footer_jsx(FooterLogos, {
    "data-id": "components_Footer_FooterLogos"
  }, (footer.partners || []).map(function (item) {
    return Footer_jsx("li", {
      key: item.id,
      "data-id": "components_Footer_li"
    }, Footer_jsx("a", {
      href: item.href,
      target: "_blank",
      rel: "noopener noreferrer",
      "data-id": "components_Footer_a"
    }, Footer_jsx("img", {
      src: item.src,
      alt: item.name,
      "data-id": "components_Footer_img"
    })));
  }))))))) : null;
};

var FooterContainer = styled_components_browser_esm["default"].footer(Footer_templateObject || (Footer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  width: 100%;\n  font-family: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary);
var TopFooter = styled_components_browser_esm["default"].section(Footer_templateObject2 || (Footer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  background: ", ";\n  width: 100%;\n  height: ", ";\n\n  ", "\n\n  &:before{\n    content: '';\n    display: block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    border-style: solid;\n    border-width: 320rem 0 0 320rem;\n    border-color: transparent transparent transparent ", ";\n\n    ", "\n  }\n }\n"])), styleGuide/* colorPalette.beige */.K5.beige, function (props) {
  return props.twoBlocks ? '530rem' : '360rem';
}, breakpoints/* fromBreakpoint.md */.ks.md(Footer_templateObject3 || (Footer_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 360rem;\n    "]))), (0,utils/* hex2rgb */.wK)('#6F6259', 0.2), breakpoints/* fromBreakpoint.md */.ks.md(Footer_templateObject4 || (Footer_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      border-width: 360rem 0 0 360rem;\n      "]))));
var TopFooterContent = styled_components_browser_esm["default"].div(Footer_templateObject5 || (Footer_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  flex-direction: column;\n\n  ", ";\n\n  > div {\n    color: #fff;\n\n    h3 {\n      ", " margin-bottom: 25rem;\n      margin-top: 0;\n      padding-top: 0;\n      line-height: 26rem;\n\n      ", ";\n    }\n\n    p {\n      font-size: 16rem;\n      line-height: 24rem;\n\n      ", ";\n    }\n\n    a {\n      margin-top: 40rem;\n    }\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(Footer_templateObject6 || (Footer_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: row;\n    padding: 0;\n    "]))), styleGuide/* textStyles.title */.sq.title, breakpoints/* fromBreakpoint.md */.ks.md(Footer_templateObject7 || (Footer_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n        font-size: 22rem;\n        line-height: 20rem;\n        "]))), breakpoints/* fromBreakpoint.md */.ks.md(Footer_templateObject8 || (Footer_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n        font-size: 18rem;\n        line-height: 26rem;\n        "]))));
var FooterContentBlock = styled_components_browser_esm["default"].div(Footer_templateObject9 || (Footer_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  width: 100%;\n  height: auto;\n  padding: 45rem 15rem 15rem 15rem;\n  color: #fff;\n\n  ", ";\n\n  > div > * {\n    color: #fff;\n  }\n\n  > div > * > * {\n    color: #fff;\n    &:hover {\n      color: #fff;\n      border-bottom: 1rem solid #fff;\n    }\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(Footer_templateObject0 || (Footer_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 360rem;\n    padding: 65rem 20rem 20rem 20rem;\n    margin-bottom: 0;\n  "]))));
var FooterContentBottomBlockLeft = (0,styled_components_browser_esm["default"])(FooterContentBlock)(Footer_templateObject1 || (Footer_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 0;\n  width: 100%;\n  height: auto;\n  padding: 0;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(Footer_templateObject10 || (Footer_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-grow: 2;\n    width: auto;\n    height: auto;\n    margin-bottom: 0;\n    padding: 0;\n    "]))));
var FooterContentBottomBlockRight = (0,styled_components_browser_esm["default"])(FooterContentBlock)(Footer_templateObject11 || (Footer_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n  width: 100%;\n  height: auto;\n  padding-top: 0;\n  padding-bottom: 0;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(Footer_templateObject12 || (Footer_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: row;\n    width: auto;\n    height: auto;\n    padding: 0 20rem;\n    "]))));
var BottomFooter = styled_components_browser_esm["default"].section(Footer_templateObject13 || (Footer_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: middle;\n  padding: 0;\n  background: #fff;\n"])));
var BottomFooterContent = styled_components_browser_esm["default"].div(Footer_templateObject14 || (Footer_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: wrap;\n"])));
var FooterMeta = styled_components_browser_esm["default"].ul(Footer_templateObject15 || (Footer_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding-left: 5rem;\n  padding-right: 5rem;\n  margin: 0;\n  list-style: none;\n  font-size: 14rem;\n\n  ", " li {\n    display: flex;\n    margin: 12rem 15rem;\n\n    ", " &:first-child {\n      flex-basis: 100%;\n      justify-content: center;\n      color: #585858;\n\n      ", ";\n    }\n\n    a {\n      color: ", ";\n      text-decoration: none;\n      transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n      border-bottom: 1rem solid #fff;\n\n      &:hover {\n        color: ", ";\n        border-bottom: 1rem solid ", ";\n      }\n    }\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(_templateObject16 || (_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    padding-left: 15rem;\n    padding-right: 15rem;\n    margin: 15rem -10rem;\n    "]))), breakpoints/* fromBreakpoint.md */.ks.md(_templateObject17 || (_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin: 0 15rem;\n      "]))), breakpoints/* fromBreakpoint.md */.ks.md(_templateObject18 || (_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n        flex-basis: auto;\n        margin-right: 15rem;\n        "]))), styleGuide/* colorPalette.blue */.K5.blue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue);
var FooterLogos = styled_components_browser_esm["default"].ul(_templateObject19 || (_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 0;\n\n  ", " li {\n    display: flex;\n    height: 100%;\n    text-align: center;\n    margin: 0 20rem;\n    max-width: 250rem;\n\n    a {\n      display: flex;\n      align-items: center;\n    }\n\n    img {\n      display: flex;\n      width: 100%;\n    }\n\n    &:first-child {\n      margin-right: 0;\n    }\n\n    &:last-child {\n      margin-left: 0;\n    }\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(_templateObject20 || (_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n    justify-content: right;\n    margin-left: auto;\n    "]))));
/* harmony default export */ var components_Footer = ((0,withMatch/* default */.Z)(Footer));
;// CONCATENATED MODULE: ./src/components/MobileMenu.js








var MobileMenu_templateObject, MobileMenu_templateObject2, MobileMenu_templateObject3, MobileMenu_templateObject4, MobileMenu_templateObject5, MobileMenu_templateObject6, MobileMenu_templateObject7, MobileMenu_templateObject8, MobileMenu_templateObject9;

var MobileMenu_jsx = react.createElement;

function MobileMenu_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, MobileMenu_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function MobileMenu_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (MobileMenu_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}














var MobileMenu_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};

var MobileMenu_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNavigate: function onNavigate() {
      dispatch((0,menu/* updateMobileMenuState */.WY)(false));
    }
  };
};

var MobileMenu = /*#__PURE__*/function (_Component) {
  function MobileMenu() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MobileMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = MobileMenu_callSuper(this, MobileMenu, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "refMap", {});

    (0,defineProperty/* default */.Z)(_this, "state", {
      hoverMenuSlug: ''
    });

    (0,defineProperty/* default */.Z)(_this, "handleClick", function (slug) {
      var subNavMaxHeight = _this.refMap[slug].offsetHeight;

      _this.setState(function (prevState) {
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, 'menuItem_' + slug, !prevState['menuItem_' + slug]), 'subNavMaxHeight_' + slug, subNavMaxHeight);
      });
    });

    (0,defineProperty/* default */.Z)(_this, "getSubNavMaxHeight", function (state, slug) {
      return state['subNavMaxHeight_' + slug];
    });

    (0,defineProperty/* default */.Z)(_this, "getExpandedStatusForItem", function (state, slug) {
      return state['menuItem_' + slug];
    });

    return _this;
  }

  (0,inherits/* default */.Z)(MobileMenu, _Component);

  return (0,createClass/* default */.Z)(MobileMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          match = _this$props.match,
          _this$props$menuItems = _this$props.menuItems,
          menuItems = _this$props$menuItems === void 0 ? [] : _this$props$menuItems; // open active menu item if deep linked, by simulating click on item

      if (match.params.menuSlug && (menuItems || []).some(function (menuItem) {
        return menuItem.slug === match.params.menuSlug && menuItem.pages && menuItem.pages.length > 1;
      })) {
        this.handleClick(match.params.menuSlug);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          match = _this$props2.match,
          styling = _this$props2.styling,
          _this$props2$menuItem = _this$props2.menuItems,
          menuItems = _this$props2$menuItem === void 0 ? [] : _this$props2$menuItem,
          loggedIn = _this$props2.loggedIn,
          onNavigate = _this$props2.onNavigate;
      var _match$params = match.params,
          projectSlug = _match$params.projectSlug,
          env = _match$params.env,
          menuSlug = _match$params.menuSlug,
          pageSlug = _match$params.pageSlug;
      var activeMenuColor = styling.navActiveLabel && env === 'open' ? styling.navActiveLabel : styleGuide/* colorPalette.lightBlue */.K5.lightBlue;
      return MobileMenu_jsx(MobileMenu_Container, {
        "data-id": "components_MobileMenu_Container"
      }, MobileMenu_jsx(MenuItemsWrapper, {
        "data-id": "components_MobileMenu_MenuItemsWrapper"
      }, menuItems.map(function (menuItem) {
        var isCurrentMenu = menuItem.slug === menuSlug;
        var moreThanOnePages = menuItem.pages && menuItem.pages.length > 1;
        return !menuItem.hidden ? MobileMenu_jsx(MobileMenu_MenuItem, {
          key: menuItem.id,
          "data-id": "components_MobileMenu_MenuItem"
        }, moreThanOnePages ? MobileMenu_jsx("div", {
          "data-id": "components_MobileMenu_div"
        }, MobileMenu_jsx(MenuItemButton, {
          maxHeight: _this2.getSubNavMaxHeight(_this2.state, menuItem.slug),
          expanded: _this2.getExpandedStatusForItem(_this2.state, menuItem.slug),
          onClick: function onClick() {
            return _this2.handleClick(menuItem.slug);
          },
          name: loggedIn ? 'true' : 'false',
          activeColor: activeMenuColor,
          "data-id": "components_MobileMenu_MenuItemButton"
        }, MobileMenu_jsx("span", {
          "data-id": "components_MobileMenu_span"
        }, menuItem.name), MobileMenu_jsx(MobileMenu_CaretContainer, {
          "data-id": "components_MobileMenu_CaretContainer"
        }, MobileMenu_jsx(Caret/* default */.Z, {
          direction: "down",
          color: styleGuide/* colorPalette.white */.K5.white,
          "data-id": "components_MobileMenu_Caret"
        }))), MobileMenu_jsx(SubNav, {
          "data-id": "components_MobileMenu_SubNav"
        }, MobileMenu_jsx("div", {
          ref: function ref(input) {
            _this2.refMap[menuItem.slug] = input;
          },
          "data-id": "components_MobileMenu_div"
        }, menuItem.pages && menuItem.pages.map(function (submenuItem) {
          return !submenuItem.hidden ? MobileMenu_jsx(SubMenuItem, {
            href: '/' + (0,getLinkFromPageObject/* default */.Z)({
              projectSlug: projectSlug,
              env: env,
              menuSlug: menuItem.slug,
              pageSlug: submenuItem.slug
            }),
            onClick: onNavigate,
            key: submenuItem.id,
            "data-id": "components_MobileMenu_SubMenuItem"
          }, MobileMenu_jsx(SubMenuItemLabel, {
            isActive: menuSlug === menuItem.slug && pageSlug === submenuItem.slug,
            activeColor: activeMenuColor,
            "data-id": "components_MobileMenu_SubMenuItemLabel"
          }, submenuItem.name)) : null;
        })))) : MobileMenu_jsx(MenuItemLink, {
          href: '/' + (0,getLinkFromPageObject/* default */.Z)({
            projectSlug: projectSlug,
            env: env,
            menuSlug: menuItem.slug
          }),
          onClick: onNavigate,
          className: isCurrentMenu ? 'isActive' : '',
          color: activeMenuColor,
          name: loggedIn ? 'true' : 'false',
          "data-id": "components_MobileMenu_MenuItemLink"
        }, MobileMenu_jsx("span", {
          "data-id": "components_MobileMenu_span"
        }, menuItem.name, isCurrentMenu))) : null;
      })));
    }
  }]);
}(react.Component);

var MobileMenu_Container = styled_components_browser_esm["default"].div(MobileMenu_templateObject || (MobileMenu_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  padding-left: 40rem;\n  padding-bottom: 50rem;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  will-change: transform;\n"])), styleGuide/* fonts.primary */.Rq.primary);
var MenuItemsWrapper = styled_components_browser_esm["default"].div(MobileMenu_templateObject2 || (MobileMenu_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n"])), styleGuide/* colorPalette.beige */.K5.beige);
var MobileMenu_MenuItem = styled_components_browser_esm["default"].div(MobileMenu_templateObject3 || (MobileMenu_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var MenuItemLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(MobileMenu_templateObject4 || (MobileMenu_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  text-transform: uppercase;\n  display: inline-block;\n  width: 100%;\n  padding: 20rem 30rem;\n  box-sizing: border-box;\n  position: relative;\n  text-decoration: none;\n  background-color: ", ";\n  font-weight: bold;\n\n  > span {\n    display: inline-block;\n    position: relative;\n  }\n\n  &.isActive span {\n    &:after {\n      content: '';\n      position: absolute;\n      left: 0;\n      bottom: -10rem;\n      width: 100%;\n      height: 4rem;\n      background-color: ", ";\n      border-radius: 0 0 3rem 0;\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), styleGuide/* colorPalette.white */.K5.white, function (props) {
  return props.name === 'false' ? styleGuide/* colorPalette.beige */.K5.beige : styleGuide/* colorPalette.lightBeige */.K5.lightBeige;
}, function (props) {
  return props.color;
}, (0,utils/* hex2rgb */.wK)("".concat(styleGuide/* colorPalette.beige */.K5.beige), 0.3));
var MenuItemButton = styled_components_browser_esm["default"].button(MobileMenu_templateObject5 || (MobileMenu_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  text-align: left;\n  text-transform: uppercase;\n  display: inline-block;\n  width: 100%;\n  padding: 20rem 45rem 20rem 30rem;\n  box-sizing: border-box;\n  position: relative;\n  text-decoration: none;\n  font-weight: bold;\n  -webkit-tap-highlight-color: transparent;\n\n  ", ";\n\n  + div {\n    transition: max-height 0.22s ease-in-out;\n    max-height: ", "rem;\n    -webkit-backface-visibility: hidden;\n    -webkit-transform-style: preserve-3d;\n    will-change: transform;\n  }\n\n  i {\n    position: absolute;\n    width: 12rem;\n    height: 10rem;\n    right: 30rem;\n    transition: transform 0.2s ease-in-out;\n    top: 50%;\n    transform: translateY(-50%) ", ";\n    transform-origin: center center;\n  }\n\n  svg {\n    position: absolute;\n    width: 100%;\n  }\n"])), styleGuide/* colorPalette.white */.K5.white, function (props) {
  return props.expanded ? "\n        background-color: ".concat(props.activeColor, ";\n\n        &:active, &:hover {\n          background-color: ").concat((0,utils/* darken */._j)(props.activeColor, 15), ";\n        }\n      ") : props.name === 'false' ? "\n          background-color: ".concat(styleGuide/* colorPalette.beige */.K5.beige, ";\n\n          &:active, &:hover {\n            background-color: ").concat((0,utils/* darken */._j)(styleGuide/* colorPalette.beige */.K5.beige, 15), ";\n          }\n      ") : "\n          background-color: ".concat(styleGuide/* colorPalette.lightBeige */.K5.lightBeige, ";\n\n          &:active, &:hover {\n            background-color: ").concat((0,utils/* darken */._j)(styleGuide/* colorPalette.lightBeige */.K5.lightBeige, 15), ";\n          }\n      ");
}, function (props) {
  return props.expanded ? props.maxHeight : '0';
}, function (props) {
  return props.expanded ? 'scaleY(-1)' : 'scaleY(1)';
});
var MobileMenu_CaretContainer = styled_components_browser_esm["default"].i(MobileMenu_templateObject6 || (MobileMenu_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n"])));
var SubNav = styled_components_browser_esm["default"].div(MobileMenu_templateObject7 || (MobileMenu_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  overflow: hidden;\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey);
var SubMenuItem = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(MobileMenu_templateObject8 || (MobileMenu_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  width: 280rem;\n  padding: 20rem 30rem;\n  box-sizing: border-box;\n  font-family: ", ";\n  font-size: 18rem;\n  line-height: 23rem;\n  color: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.beige */.K5.beige);
var SubMenuItemLabel = styled_components_browser_esm["default"].span(MobileMenu_templateObject9 || (MobileMenu_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  position: relative;\n  ", " &:hover:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: -10rem;\n    width: 100%;\n    height: 4rem;\n    background-color: ", ";\n    border-radius: 0 0 3rem 0;\n  }\n"])), function (props) {
  return props.isActive ? "\n    &:after {\n      content: '';\n      position: absolute;\n      left: 0;\n      bottom: -10rem;\n      width: 100%;\n      height: 4rem;\n      background-color: ".concat(props.activeColor, ";\n      border-radius: 0 0 3rem 0;\n    }\n  ") : '';
}, function (props) {
  return props.activeColor;
});
/* harmony default export */ var components_MobileMenu = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(MobileMenu_mapStateToProps, MobileMenu_mapDispatchToProps)(MobileMenu)));
// EXTERNAL MODULE: ./src/components/shared/icons/PlaceholderUser.js
var PlaceholderUser = __webpack_require__(37271);
// EXTERNAL MODULE: ./src/components/shared/icons/PlaceholderUserCJ.js
var PlaceholderUserCJ = __webpack_require__(72161);
;// CONCATENATED MODULE: ./src/components/MobileLoginBarProfile.js








var MobileLoginBarProfile_templateObject, MobileLoginBarProfile_templateObject2, MobileLoginBarProfile_templateObject3, MobileLoginBarProfile_templateObject4, MobileLoginBarProfile_templateObject5, MobileLoginBarProfile_templateObject6, MobileLoginBarProfile_templateObject7, MobileLoginBarProfile_templateObject8, MobileLoginBarProfile_templateObject9, MobileLoginBarProfile_templateObject0, MobileLoginBarProfile_templateObject1, MobileLoginBarProfile_templateObject10, MobileLoginBarProfile_templateObject11, MobileLoginBarProfile_templateObject12, MobileLoginBarProfile_templateObject13;

var MobileLoginBarProfile_jsx = react.createElement;

function MobileLoginBarProfile_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, MobileLoginBarProfile_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function MobileLoginBarProfile_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (MobileLoginBarProfile_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


























var MobileLoginBarProfile_connectApiData = (0,withApiData/* default */.Z)({
  profile: 'getProfile'
}, function (ownProps) {
  return {
    profile: {
      projectSlug: ownProps.match.params.projectSlug
    }
  };
});

var MobileLoginBarProfile_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    notifications: (0,apiData/* getResultData */.yh)(state.apiData, 'getNotifications', {
      projectSlug: String(ownProps.match.params.projectSlug)
    }),
    activationPossible: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'activationPossible', false),
    logoutUserRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'logoutUser')
  };
};

var MobileLoginBarProfile_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getNotifications: function getNotifications(projectSlug) {
      dispatch((0,apiData/* performApiRequest */.T4)('getNotifications', {
        projectSlug: projectSlug
      }));
    },
    onNavigate: function onNavigate() {
      dispatch((0,menu/* updateMobileMenuState */.WY)(false));
    },
    onLogout: function onLogout(projectSlug) {
      var _ownProps$router;

      dispatch((0,apiData/* performApiRequest */.T4)('logoutUser'));
      dispatch((0,apiData/* clearCache */.LK)());
      (_ownProps$router = ownProps.router) === null || _ownProps$router === void 0 || _ownProps$router.push("/".concat(projectSlug, "/closed"));
    },
    openActivationModal: function openActivationModal(activationType) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, activationType));
    }
  };
};

var MobileLoginBarProfile = /*#__PURE__*/function (_Component) {
  function MobileLoginBarProfile() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MobileLoginBarProfile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = MobileLoginBarProfile_callSuper(this, MobileLoginBarProfile, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "refMap", {});

    (0,defineProperty/* default */.Z)(_this, "state", {
      expanded1: false,
      expanded2: false
    });

    (0,defineProperty/* default */.Z)(_this, "activation", function () {
      var props = _this.props;
      props.openActivationModal({
        type: 'activation',
        componentProps: {}
      });
      props.onNavigate();
    });

    (0,defineProperty/* default */.Z)(_this, "handleClick", function () {
      var props = _this.props;
      props.onNavigate();
      props.onLogout(String(props.match.params.projectSlug));
    });

    (0,defineProperty/* default */.Z)(_this, "openMenu", function (phase) {
      var subNavMaxHeight = _this.refMap[phase].offsetHeight;

      _this.setState(function (prevState) {
        return (0,defineProperty/* default */.Z)({}, 'subNavMaxHeight_' + phase, subNavMaxHeight);
      });

      if (phase === 'cj1') {
        _this.setState({
          expanded1: !_this.state.expanded1
        });
      } else {
        _this.setState({
          expanded2: !_this.state.expanded2
        });
      }
    });

    (0,defineProperty/* default */.Z)(_this, "getSubNavMaxHeight", function (state, phase) {
      return state['subNavMaxHeight_' + phase];
    });

    return _this;
  }

  (0,inherits/* default */.Z)(MobileLoginBarProfile, _Component);

  return (0,createClass/* default */.Z)(MobileLoginBarProfile, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          settings = _this$props.settings,
          match = _this$props.match,
          logoutUserRequest = _this$props.logoutUserRequest,
          getNotifications = _this$props.getNotifications;

      if ((settings.phase === 'cj2' || settings.phase === 'cj3') && !logoutUserRequest) {
        getNotifications(String(match.params.projectSlug));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          profile = _this$props2.profile,
          notifications = _this$props2.notifications,
          match = _this$props2.match,
          settings = _this$props2.settings,
          onNavigate = _this$props2.onNavigate,
          activationPossible = _this$props2.activationPossible;
      var _this$state = this.state,
          expanded1 = _this$state.expanded1,
          expanded2 = _this$state.expanded2;
      var profileData = profile.data;
      var projectSlug = match.params.projectSlug;
      var imageUrl = settings.phase === 'cj1' ? lodash_get_default()(profileData, 'image', undefined) : lodash_get_default()(profileData, 'customer.customerImage') ? lodash_get_default()(profileData, 'customer.customerImage') : lodash_get_default()(profileData, 'image', undefined);
      return profileData ? MobileLoginBarProfile_jsx(LoggedIn, {
        "data-id": "components_MobileLoginBarProfile_LoggedIn"
      }, (settings.phase === 'cj2' || settings.phase === 'cj3') && notifications && MobileLoginBarProfile_jsx(LoginItem, {
        "data-id": "components_MobileLoginBarProfile_LoginItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_HoverButton, {
        onClick: function onClick() {
          return _this2.openMenu('cj2');
        },
        maxHeight: this.getSubNavMaxHeight(this.state, 'cj2'),
        expanded: expanded2,
        "data-id": "components_MobileLoginBarProfile_HoverButton"
      }, MobileLoginBarProfile_jsx(NotifyIconWrapper, {
        "data-id": "components_MobileLoginBarProfile_NotifyIconWrapper"
      }, MobileLoginBarProfile_jsx(icons_Notification, {
        color: styleGuide/* colorPalette.white */.K5.white,
        width: 21,
        height: 21,
        "data-id": "components_MobileLoginBarProfile_AlertIcon"
      }), countNotifications(notifications) > 0 && MobileLoginBarProfile_jsx(NotifyNumber, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumber"
      }, countNotifications(notifications)), "Notificaties"), MobileLoginBarProfile_jsx(MobileLoginBarProfile_CaretContainer, {
        expanded: expanded2,
        "data-id": "components_MobileLoginBarProfile_CaretContainer"
      }, MobileLoginBarProfile_jsx(Caret/* default */.Z, {
        direction: "down",
        color: styleGuide/* colorPalette.white */.K5.white,
        width: 10,
        height: 6,
        "data-id": "components_MobileLoginBarProfile_Caret"
      }))), MobileLoginBarProfile_jsx(MobileLoginBarProfile_HoverMenuContainer, {
        expanded: expanded2,
        maxHeight: this.getSubNavMaxHeight(this.state, 'cj2'),
        "data-id": "components_MobileLoginBarProfile_HoverMenuContainer"
      }, MobileLoginBarProfile_jsx("div", {
        ref: function ref(input) {
          _this2.refMap['cj2'] = input;
        },
        "data-id": "components_MobileLoginBarProfile_div"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_HoverMenu, {
        "data-id": "components_MobileLoginBarProfile_HoverMenu"
      }, notifications.messages && MobileLoginBarProfile_jsx(ListLoginItem, {
        href: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.messages.link)),
        color: styleGuide/* colorPalette.blue */.K5.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, MobileLoginBarProfile_jsx(icons_Message, {
        color: styleGuide/* colorPalette.beige */.K5.beige,
        width: 21,
        height: 15,
        "data-id": "components_MobileLoginBarProfile_MailIcon"
      }), notifications.messages.unreadCount > 0 && MobileLoginBarProfile_jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.messages.unreadCount)), MobileLoginBarProfile_jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Ongelezen berichten")), notifications.documents && MobileLoginBarProfile_jsx(ListLoginItem, {
        href: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.documents.link)),
        color: styleGuide/* colorPalette.blue */.K5.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, MobileLoginBarProfile_jsx(icons_Documents, {
        color: styleGuide/* colorPalette.beige */.K5.beige,
        width: 21,
        height: 21,
        "data-id": "components_MobileLoginBarProfile_FolderIcon"
      }), notifications.documents.unreadCount > 0 && MobileLoginBarProfile_jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.documents.unreadCount)), MobileLoginBarProfile_jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Nieuwe documenten")), notifications.actions && MobileLoginBarProfile_jsx(ListLoginItem, {
        href: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.actions.link)),
        color: styleGuide/* colorPalette.blue */.K5.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, MobileLoginBarProfile_jsx(icons_Actions, {
        color: styleGuide/* colorPalette.beige */.K5.beige,
        width: 22,
        height: 22,
        "data-id": "components_MobileLoginBarProfile_CalendarIcon"
      }), notifications.actions.unreadCount > 0 && MobileLoginBarProfile_jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.actions.unreadCount)), MobileLoginBarProfile_jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Acties in planning")), notifications.newOptions && MobileLoginBarProfile_jsx(ListLoginItem, {
        href: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.newOptions.link)),
        color: styleGuide/* colorPalette.blue */.K5.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, MobileLoginBarProfile_jsx(icons_HouseBase, {
        color: styleGuide/* colorPalette.beige */.K5.beige,
        width: 22,
        height: 22,
        "data-id": "components_MobileLoginBarProfile_HouseIcon"
      }), notifications.newOptions.unreadCount > 0 && MobileLoginBarProfile_jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.newOptions.unreadCount)), MobileLoginBarProfile_jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Nieuwe opties")), notifications.ordersToConfirm && MobileLoginBarProfile_jsx(ListLoginItem, {
        href: "/".concat((0,getLinkFromPageObject/* default */.Z)(notifications.ordersToConfirm.link)),
        color: styleGuide/* colorPalette.blue */.K5.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, MobileLoginBarProfile_jsx(icons_HouseBase, {
        color: styleGuide/* colorPalette.beige */.K5.beige,
        width: 22,
        height: 22,
        "data-id": "components_MobileLoginBarProfile_HouseIcon"
      }), notifications.ordersToConfirm.unreadCount > 0 && MobileLoginBarProfile_jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.ordersToConfirm.unreadCount)), MobileLoginBarProfile_jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Orders ter bevestiging")))))), MobileLoginBarProfile_jsx(LoginItem, {
        "data-id": "components_MobileLoginBarProfile_LoginItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_HoverButton, {
        onClick: function onClick() {
          return _this2.openMenu('cj1');
        },
        maxHeight: this.getSubNavMaxHeight(this.state, 'cj1'),
        expanded: expanded1,
        "data-id": "components_MobileLoginBarProfile_HoverButton"
      }, MobileLoginBarProfile_jsx(UserDetails, {
        "data-id": "components_MobileLoginBarProfile_UserDetails"
      }, MobileLoginBarProfile_jsx(UserImage, {
        "data-id": "components_MobileLoginBarProfile_UserImage"
      }, imageUrl && MobileLoginBarProfile_jsx(BackgroundImage, {
        image: imageUrl,
        "data-id": "components_MobileLoginBarProfile_BackgroundImage"
      }), !imageUrl && settings.phase === 'cj1' && MobileLoginBarProfile_jsx(PlaceholderUser/* default */.Z, {
        "data-id": "components_MobileLoginBarProfile_PlaceholderUser"
      }), !imageUrl && (settings.phase === 'cj2' || settings.phase === 'cj3') && MobileLoginBarProfile_jsx(PlaceholderUserCJ/* default */.Z, {
        "data-id": "components_MobileLoginBarProfile_PlaceholderUserCJ"
      })), settings.phase === 'cj1' ? profileData.name : settings.phase !== 'cj1' && profileData.customer && profileData.customer.customerName ? profileData.customer.customerName : profileData.name), MobileLoginBarProfile_jsx(MobileLoginBarProfile_CaretContainer, {
        expanded: this.state.expanded1,
        "data-id": "components_MobileLoginBarProfile_CaretContainer"
      }, MobileLoginBarProfile_jsx(Caret/* default */.Z, {
        direction: "down",
        color: styleGuide/* colorPalette.white */.K5.white,
        width: 10,
        height: 6,
        "data-id": "components_MobileLoginBarProfile_Caret"
      }))), MobileLoginBarProfile_jsx(MobileLoginBarProfile_HoverMenuContainer, {
        expanded: expanded1,
        maxHeight: this.getSubNavMaxHeight(this.state, 'cj1'),
        "data-id": "components_MobileLoginBarProfile_HoverMenuContainer"
      }, MobileLoginBarProfile_jsx("div", {
        ref: function ref(input) {
          _this2.refMap['cj1'] = input;
        },
        "data-id": "components_MobileLoginBarProfile_div"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_HoverMenu, {
        "data-id": "components_MobileLoginBarProfile_HoverMenu"
      }, MobileLoginBarProfile_jsx(ListLoginItem, {
        href: "/".concat(String(projectSlug), "/closed/profiel"),
        color: styleGuide/* colorPalette.blue */.K5.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, MobileLoginBarProfile_jsx(Profile, {
        width: 18,
        height: 18,
        color: styleGuide/* colorPalette.beige */.K5.beige,
        "data-id": "components_MobileLoginBarProfile_SettingsIcon"
      })), MobileLoginBarProfile_jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Profiel")), MobileLoginBarProfile_jsx(ListLoginItem, {
        href: "/".concat(String(projectSlug), "/closed/"),
        onClick: this.handleClick,
        color: styleGuide/* colorPalette.blue */.K5.blue,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, MobileLoginBarProfile_jsx(Logout, {
        width: 18,
        height: 18,
        color: styleGuide/* colorPalette.beige */.K5.beige,
        "data-id": "components_MobileLoginBarProfile_LoginIcon"
      })), MobileLoginBarProfile_jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Uitloggen")), activationPossible && MobileLoginBarProfile_jsx(MobileLoginBarProfile_ListItem, {
        color: styleGuide/* colorPalette.blue */.K5.blue,
        onClick: this.activation,
        "data-id": "components_MobileLoginBarProfile_ListItem"
      }, MobileLoginBarProfile_jsx(MobileLoginBarProfile_IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, MobileLoginBarProfile_jsx(icons_Key, {
        width: 18,
        height: 18,
        color: styleGuide/* colorPalette.beige */.K5.beige,
        "data-id": "components_MobileLoginBarProfile_LockIcon"
      })), MobileLoginBarProfile_jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Activatiecode invoeren"))))))) : null;
    }
  }]);
}(react.Component);

/* harmony default export */ var components_MobileLoginBarProfile = ((0,withMatch/* default */.Z)(MobileLoginBarProfile_connectApiData((0,es/* connect */.$j)(MobileLoginBarProfile_mapStateToProps, MobileLoginBarProfile_mapDispatchToProps)(MobileLoginBarProfile))));
var LoggedIn = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject || (MobileLoginBarProfile_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n"])));
var BackgroundImage = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject2 || (MobileLoginBarProfile_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n"])), function (props) {
  return props.image;
});
var UserDetails = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject3 || (MobileLoginBarProfile_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n"])));
var LoginItem = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject4 || (MobileLoginBarProfile_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: #fff;\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  line-height: 24rem;\n  border-bottom: 1px solid ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.beige */.K5.beige);
var MobileLoginBarProfile_HoverButton = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject5 || (MobileLoginBarProfile_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  width: 233rem;\n  height: 42rem;\n  justify-content: space-between;\n  padding: 0 22rem 0 25rem;\n\n  ", ";\n"])), function (props) {
  return props.expanded ? "\n        background-color: ".concat(styleGuide/* colorPalette.lightBlue */.K5.lightBlue, ";\n\n        &:hover {\n          background-color: ").concat(styleGuide/* colorPalette.darkBlue */.K5.darkBlue, ";\n        }\n      ") : "\n      background-color: ".concat(styleGuide/* colorPalette.headerGrey */.K5.headerGrey, ";\n\n      &:hover {\n        background-color: ").concat((0,utils/* darken */._j)(styleGuide/* colorPalette.headerGrey */.K5.headerGrey, 15), ";\n      }\n  ");
});
var MobileLoginBarProfile_CaretContainer = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject6 || (MobileLoginBarProfile_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 6rem;\n  transition: transform 0.2s ease-in-out;\n  transform: translateY(-50%) ", ";\n  transform-origin: center center;\n"])), function (props) {
  return props.expanded ? 'scaleY(-1)' : 'scaleY(1)';
});
var MobileLoginBarProfile_HoverMenuContainer = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject7 || (MobileLoginBarProfile_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-height: ", "rem;\n  transition: max-height 0.22s ease-in-out;\n  -webkit-backface-visibility: hidden;\n  -webkit-transform-style: preserve-3d;\n  will-change: transform;\n  overflow: hidden;\n"])), function (props) {
  return props.expanded ? props.maxHeight : '0';
});
var MobileLoginBarProfile_HoverMenu = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject8 || (MobileLoginBarProfile_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  padding-left: 25rem;\n  padding-top: 4rem;\n  padding-bottom: 32rem;\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey);
var NotifyNumberHover = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject9 || (MobileLoginBarProfile_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  right: -4rem;\n  bottom: -1rem;\n  border-radius: 50%;\n  background-color: ", ";\n  border: 1px solid white;\n  width: 16rem;\n  height: 16rem;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12rem;\n  font-weight: bold;\n"])), styleGuide/* colorPalette.orange */.K5.orange);
var ListLoginItem = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(MobileLoginBarProfile_templateObject0 || (MobileLoginBarProfile_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  display: flex;\n  line-height: 24rem;\n  cursor: pointer;\n  margin-top: 20rem;\n  position: relative;\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n\n  > span {\n    position: relative;\n\n    &:hover {\n      &:after {\n        content: '';\n        position: absolute;\n        left: 0;\n        bottom: -5rem;\n        width: 100%;\n        height: 4rem;\n        background-color: ", ";\n        border-radius: 0 0 3rem 0;\n      }\n    }\n  }\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* fonts.primary */.Rq.primary, NotifyNumberHover, styleGuide/* colorPalette.darkOrange */.K5.darkOrange, function (props) {
  return props.color;
});
var MobileLoginBarProfile_ListItem = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject1 || (MobileLoginBarProfile_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  display: flex;\n  line-height: 24rem;\n  cursor: pointer;\n  margin-top: 20rem;\n  position: relative;\n\n  > span {\n    position: relative;\n\n    &:hover {\n      &:after {\n        content: '';\n        position: absolute;\n        left: 0;\n        bottom: -5rem;\n        width: 100%;\n        height: 4rem;\n        background-color: ", ";\n        border-radius: 0 0 3rem 0;\n      }\n    }\n  }\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.color;
});
var MobileLoginBarProfile_IconWrapper = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject10 || (MobileLoginBarProfile_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 12rem;\n  position: relative;\n  width: 25rem;\n"])));
var UserImage = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject11 || (MobileLoginBarProfile_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 8rem;\n  align-self: auto;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  background-color: ", ";\n  width: 24rem;\n  height: 24rem;\n  border-radius: 50%;\n\n  > div {\n    border-radius: 50%;\n    border: 1px solid white;\n    width: 24rem;\n    height: 24rem;\n  }\n\n  > svg {\n    align-self: center;\n    margin-bottom: 1rem;\n  }\n"])), styleGuide/* colorPalette.loadingOrange */.K5.loadingOrange);
var NotifyIconWrapper = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject12 || (MobileLoginBarProfile_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  position: relative;\n\n  > svg {\n    margin-right: 10rem;\n  }\n"])));
var NotifyNumber = styled_components_browser_esm["default"].div(MobileLoginBarProfile_templateObject13 || (MobileLoginBarProfile_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  left: 8rem;\n  bottom: -2rem;\n  border-radius: 50%;\n  background-color: ", ";\n  border: 1px solid white;\n  width: 16rem;\n  height: 16rem;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12rem;\n  font-weight: bold;\n"])), styleGuide/* colorPalette.orange */.K5.orange);
;// CONCATENATED MODULE: ./src/components/MobileLoginBar.js


var MobileLoginBar_templateObject, MobileLoginBar_templateObject2, MobileLoginBar_templateObject3, MobileLoginBar_templateObject4;

var MobileLoginBar_jsx = react.createElement;













var MobileLoginBar_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};

var MobileLoginBar_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNavigate: function onNavigate() {
      dispatch((0,menu/* updateMobileMenuState */.WY)(false));
    }
  };
};

var MobileLoginBar = function MobileLoginBar(_ref) {
  var settings = _ref.settings,
      match = _ref.match,
      styling = _ref.styling,
      onNavigate = _ref.onNavigate;
  var _match$params = match.params,
      projectSlug = _match$params.projectSlug,
      env = _match$params.env;
  var loggedIn = settings && settings.user;
  var showLogin = settings && settings.showLogin;
  var activeMenuColor = styling.navActiveLabel && env === 'open' ? styling.navActiveLabel : styleGuide/* colorPalette.blue */.K5.blue;
  return MobileLoginBar_jsx(MobileLoginBar_Login, {
    loggedIn: env === 'closed',
    "data-id": "components_MobileLoginBar_Login"
  }, showLogin && (env === 'open' || env === 'closed' && !loggedIn) && MobileLoginBar_jsx(MobileLoginBar_LoginItemlink, {
    href: "/".concat(String(projectSlug || ''), "/closed"),
    color: activeMenuColor,
    onClick: onNavigate,
    "data-id": "components_MobileLoginBar_LoginItemlink"
  }, MobileLoginBar_jsx(MobileLoginBar_LoginIconWrapper, {
    "data-id": "components_MobileLoginBar_LoginIconWrapper"
  }, MobileLoginBar_jsx(Login/* default */.Z, {
    color: "white",
    "data-id": "components_MobileLoginBar_LoginIcon"
  })), "Naar Mijn Homestudios"), env === 'closed' && loggedIn && MobileLoginBar_jsx(components_MobileLoginBarProfile, {
    settings: settings,
    "data-id": "components_MobileLoginBar_MobileLoginBarProfile"
  }), env === 'open' && loggedIn && MobileLoginBar_jsx(Itemlink, {
    href: 'https://www2.homestudios.nl/',
    color: activeMenuColor,
    target: "_blank",
    rel: "noopener noreferrer",
    "data-id": "components_MobileLoginBar_Itemlink"
  }, "Over Homestudios"));
};

/* harmony default export */ var components_MobileLoginBar = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(MobileLoginBar_mapStateToProps, MobileLoginBar_mapDispatchToProps)(MobileLoginBar)));
var MobileLoginBar_Login = styled_components_browser_esm["default"].div(MobileLoginBar_templateObject || (MobileLoginBar_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 40rem;\n  ", ";\n"])), styleGuide/* textStyles.standardText */.sq.standardText);
var MobileLoginBar_LoginItemlink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(MobileLoginBar_templateObject2 || (MobileLoginBar_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding-left: 30rem;\n  color: ", ";\n  text-decoration: none;\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), styleGuide/* colorPalette.white */.K5.white, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, (0,utils/* darken */._j)(styleGuide/* colorPalette.headerGrey */.K5.headerGrey, 15));
var MobileLoginBar_LoginIconWrapper = styled_components_browser_esm["default"].span(MobileLoginBar_templateObject3 || (MobileLoginBar_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 8rem;\n"])));
var Itemlink = styled_components_browser_esm["default"].a(MobileLoginBar_templateObject4 || (MobileLoginBar_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding-left: 30rem;\n  color: ", ";\n  text-decoration: none;\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), styleGuide/* colorPalette.white */.K5.white, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, (0,utils/* darken */._j)(styleGuide/* colorPalette.headerGrey */.K5.headerGrey, 15));
// EXTERNAL MODULE: ./src/components/shared/ui/ContentLoader.js
var ContentLoader = __webpack_require__(64588);
// EXTERNAL MODULE: ./src/components/shared/ui/ImageLoader.js + 1 modules
var ImageLoader = __webpack_require__(49213);
;// CONCATENATED MODULE: ./src/components/BannerBlock.js


var BannerBlock_templateObject, BannerBlock_templateObject2, BannerBlock_templateObject3, BannerBlock_templateObject4, BannerBlock_templateObject5, BannerBlock_templateObject6, BannerBlock_templateObject7;

var BannerBlock_jsx = react.createElement;







var BannerBlock = function BannerBlock(_ref) {
  var _ref$banners = _ref.banners,
      banners = _ref$banners === void 0 ? [] : _ref$banners,
      title = _ref.title,
      renderWidth = _ref.renderWidth;
  return BannerBlock_jsx(BannerBlock_Container, {
    renderWidth: renderWidth,
    "data-e2e-block-bannerblock": true,
    "data-id": "components_BannerBlock_Container"
  }, renderWidth && BannerBlock_jsx(designElements_Triangle, {
    direction: "bottomright",
    color: (0,utils/* hex2rgb */.wK)(styleGuide/* colorPalette.orange */.K5.orange, 0.25),
    width: renderWidth > 1100 ? 360 : 280,
    height: renderWidth > 1100 ? 360 : 280,
    "data-id": "components_BannerBlock_Triangle"
  }), BannerBlock_jsx(InnerContainer, {
    "data-id": "components_BannerBlock_InnerContainer"
  }, BannerBlock_jsx(Title, {
    "data-id": "components_BannerBlock_Title"
  }, title), BannerBlock_jsx(BannersContainer, {
    renderWidth: renderWidth,
    "data-id": "components_BannerBlock_BannersContainer"
  }, banners.map(function (banner, index) {
    return BannerBlock_jsx(BannerContainer, {
      key: index,
      renderWidth: renderWidth,
      "data-id": "components_BannerBlock_BannerContainer"
    }, BannerBlock_jsx(Banner, {
      renderWidth: renderWidth,
      "data-id": "components_BannerBlock_Banner"
    }, BannerBlock_jsx(ImageLoader/* default */.Z, {
      mode: "img",
      src: banner.media,
      width: renderWidth,
      "data-id": "components_BannerBlock_ImageLoader"
    }), BannerBlock_jsx(Text, {
      renderWidth: renderWidth,
      "data-id": "components_BannerBlock_Text"
    }, banner.leader)));
  }))));
};

/* harmony default export */ var components_BannerBlock = (BannerBlock);
var BannerBlock_Container = styled_components_browser_esm["default"].div(BannerBlock_templateObject || (BannerBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  position: relative;\n  padding: 40rem;\n  box-sizing: border-box;\n  background-color: ", ";\n  ", ";\n  color: #fff;\n\n  > svg {\n    position: absolute;\n    bottom: ", "rem;\n    right: ", "rem;\n  }\n"])), styleGuide/* colorPalette.lightOrange */.K5.lightOrange, styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, function (props) {
  return props.renderWidth > 1100 ? '-20' : '-10';
}, function (props) {
  return props.renderWidth > 1100 ? '-20' : '-10';
});
var InnerContainer = styled_components_browser_esm["default"].div(BannerBlock_templateObject2 || (BannerBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  max-width: 780rem;\n"])));
var Title = styled_components_browser_esm["default"].h3(BannerBlock_templateObject3 || (BannerBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " color: #fff;\n  margin: 0 0 30rem 0;\n  padding: 0 15rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle);
var BannersContainer = styled_components_browser_esm["default"].div(BannerBlock_templateObject4 || (BannerBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: ", ";\n  margin-top: -10rem;\n  justify-content: center;\n"])), function (props) {
  return props.renderWidth > 872 ? 'row' : 'column';
});
var BannerContainer = styled_components_browser_esm["default"].div(BannerBlock_templateObject5 || (BannerBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  padding: 10rem;\n  box-sizing: border-box;\n  width: ", ";\n  flex: 0 0 auto;\n  flex-direction: column;\n  max-width: ", "rem;\n  max-height: ", "rem;\n"])), function (props) {
  return props.renderWidth > 872 ? '33%' : '100%';
}, function (props) {
  return props.renderWidth > 872 ? '246' : '245';
}, function (props) {
  return props.renderWidth > 872 ? '246' : '270';
});
var Banner = styled_components_browser_esm["default"].div(BannerBlock_templateObject6 || (BannerBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  z-index: 5;\n  background-color: #fff;\n  margin-bottom: ", "rem;\n"])), function (props) {
  return props.renderWidth > 872 ? '0' : '20';
});
var Text = styled_components_browser_esm["default"].div(BannerBlock_templateObject7 || (BannerBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  padding: 6rem 12rem;\n  margin: 5rem;\n  flex-grow: 1;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
// EXTERNAL MODULE: ./src/components/shared/forms/FormGenerator.js + 4 modules
var FormGenerator = __webpack_require__(51919);
;// CONCATENATED MODULE: ./src/components/dashboard/ActivationModal.js








var ActivationModal_templateObject, ActivationModal_templateObject2, ActivationModal_templateObject3, ActivationModal_templateObject4, ActivationModal_templateObject5, ActivationModal_templateObject6, ActivationModal_templateObject7, ActivationModal_templateObject8, ActivationModal_templateObject9, ActivationModal_templateObject0, ActivationModal_templateObject1, ActivationModal_templateObject10;

var ActivationModal_jsx = react.createElement;

function ActivationModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ActivationModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ActivationModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ActivationModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}














var ActivationModal_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    postActivationCodeRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postActivationCode', {
      projectSlug: String(ownProps.match.params.projectSlug)
    })
  };
};

var ActivationModal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    postActivationCode: function postActivationCode(projectSlug, values) {
      dispatch((0,apiData/* performApiRequest */.T4)('postActivationCode', {
        projectSlug: projectSlug
      }, values));
    },
    openNextModal: function openNextModal(modalObject) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, modalObject));
    },
    getNewSettingsAndPage: function getNewSettingsAndPage(projectSlug) {
      var pagePath = (0,getLinkFromPageObject/* default */.Z)({
        projectSlug: projectSlug,
        env: 'closed'
      });
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getSettings', {
        projectSlug: projectSlug,
        env: 'closed'
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getPage', {
        pagePath: pagePath
      }));
    }
  };
};

var ActivationModal = /*#__PURE__*/function (_PureComponent) {
  function ActivationModal() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ActivationModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ActivationModal_callSuper(this, ActivationModal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      error: '',
      loading: false
    });

    (0,defineProperty/* default */.Z)(_this, "handleSubmit", function (values) {
      var _this$props = _this.props,
          match = _this$props.match,
          postActivationCode = _this$props.postActivationCode;
      postActivationCode(String(match.params.projectSlug), values);

      _this.setState({
        loading: true
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ActivationModal, _PureComponent);

  return (0,createClass/* default */.Z)(ActivationModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
          postActivationCodeRequest = _this$props2.postActivationCodeRequest,
          openNextModal = _this$props2.openNextModal,
          getNewSettingsAndPage = _this$props2.getNewSettingsAndPage,
          match = _this$props2.match;
      var loading = this.state.loading;

      if (postActivationCodeRequest && postActivationCodeRequest.networkStatus === 'success') {
        openNextModal({
          type: 'firstWelcomeCJ2'
        });
        getNewSettingsAndPage(String(match.params.projectSlug));
      }

      if (postActivationCodeRequest && postActivationCodeRequest.networkStatus === 'failed' && loading) {
        var error;

        switch (lodash_get_default()(postActivationCodeRequest, 'errorBody.message')) {
          case 'Activation-code not found':
            error = 'Deze activatiecode is niet juist.';
            break;

          default:
            error = 'Er is iets mis gegaan.';
            break;
        }

        this.setState({
          error: error,
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var renderWidth = this.props.renderWidth;
      var _this$state = this.state,
          loading = _this$state.loading,
          error = _this$state.error;
      var activationForm = [{
        categoryTitle: 'Activatiecode invoeren',
        options: [{
          id: 'activationCode',
          name: 'activationCode',
          required: true,
          title: 'Vul hier de activatiecode in',
          type: 'text'
        }]
      }];
      return ActivationModal_jsx(ActivationModal_Container, {
        "data-id": "dashboard_ActivationModal_Container"
      }, ActivationModal_jsx(ActivationModal_InnerContainer, {
        "data-id": "dashboard_ActivationModal_InnerContainer"
      }, ActivationModal_jsx(ActivationModal_Title, {
        "data-id": "dashboard_ActivationModal_Title"
      }, "Speciaal voor kopers: activeer je account"), ActivationModal_jsx(IntroText, {
        "data-id": "dashboard_ActivationModal_IntroText"
      }, "Ben je een trotse toekomstige bewoner van dit project? Dan heb je mogelijk al een activatiecode ontvangen van je woonadviseur. Die activatiecode kun je hieronder invoeren om toegang te krijgen tot Mijn Homestudios voor kopers. Op deze persoonlijke omgeving kun je onder meer direct communiceren met je Homestudios woonadviseur, jezelf alvast voorstellen aan de buren en meepraten op het forum.", ActivationModal_jsx("div", {
        "data-id": "dashboard_ActivationModal_div"
      }, "Heb je een woning gekocht, maar nog geen contact gehad met de Woonadviseur en geen activatiecode ontvangen? Neem dan contact met ons op.")), error && ActivationModal_jsx(FormError, {
        "data-id": "dashboard_ActivationModal_FormError"
      }, error), ActivationModal_jsx(FormGenerator/* default */.Z, {
        fields: activationForm,
        submitLabel: "Activeren",
        loadingLabel: "aanvraag wordt verwerkt",
        submitFn: this.handleSubmit,
        loading: loading,
        "data-id": "dashboard_ActivationModal_FormGenerator"
      })), ActivationModal_jsx(ActivationModal_BannerContainer, {
        "data-id": "dashboard_ActivationModal_BannerContainer"
      }, ActivationModal_jsx(components_BannerBlock, {
        title: "Na activatie:",
        renderWidth: renderWidth,
        banners: [{
          leader: 'Helpen woonontwerpen je bij het maken van keuzes voor jouw nieuwe thuis.',
          media: '/images/bannerblok-woonontwerp.png'
        }, {
          leader: 'Communiceer je direct met de woonadviseur en maak je kennis met de toekomstige buren.',
          media: '/images/bannerblok-communiceer.png'
        }, {
          leader: 'Beschik je over een eigen planning en beheer je belangrijke documenten op één plaats',
          media: '/images/bannerblok-documenten.png'
        }],
        "data-id": "dashboard_ActivationModal_BannerBlock"
      })));
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var dashboard_ActivationModal = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(ActivationModal_mapStateToProps, ActivationModal_mapDispatchToProps)(ActivationModal)));
var ActivationModal_Container = styled_components_browser_esm["default"].div(ActivationModal_templateObject || (ActivationModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  background-color: #fff;\n  padding-bottom: 100rem;\n  ", " ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* toBreakpoint.lg */.Hx.lg(ActivationModal_templateObject2 || (ActivationModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-bottom: 60rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(ActivationModal_templateObject3 || (ActivationModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-bottom: 40rem;\n  "]))));
var ActivationModal_InnerContainer = styled_components_browser_esm["default"].div(ActivationModal_templateObject4 || (ActivationModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 80rem 200rem 80rem 200rem;\n\n  ", " ", ";\n"])), breakpoints/* toBreakpoint.lg */.Hx.lg(ActivationModal_templateObject5 || (ActivationModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 70rem 60rem 70rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(ActivationModal_templateObject6 || (ActivationModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 20rem 20rem 40rem 20rem;\n  "]))));
var ActivationModal_Title = styled_components_browser_esm["default"].h3(ActivationModal_templateObject7 || (ActivationModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n  margin-top: 0;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var IntroText = styled_components_browser_esm["default"].div(ActivationModal_templateObject8 || (ActivationModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: -20rem;\n  font-weight: normal;\n  max-width: 700rem;\n\n  > div {\n    margin-top: 10rem;\n  }\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var FormError = styled_components_browser_esm["default"].div(ActivationModal_templateObject9 || (ActivationModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  padding: 20rem;\n  justify-content: center;\n  border: solid 1px #eee;\n  border-radius: 5rem;\n  background: ", ";\n  font-family: ", ";\n  color: red;\n  margin-top: 50px;\n  margin-bottom: -20px;\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, styleGuide/* fonts.primary */.Rq.primary);
var ActivationModal_BannerContainer = styled_components_browser_esm["default"].div(ActivationModal_templateObject0 || (ActivationModal_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 4rem;\n  padding-left: 100rem;\n  padding-right: 100rem;\n  ", " ", ";\n"])), breakpoints/* toBreakpoint.lg */.Hx.lg(ActivationModal_templateObject1 || (ActivationModal_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 30rem;\n    padding-right: 30rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(ActivationModal_templateObject10 || (ActivationModal_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 20rem;\n    padding-left: 10rem;\n    padding-right: 10rem;\n  "]))));
// EXTERNAL MODULE: ./src/styles/colors.ts
var colors = __webpack_require__(94367);
;// CONCATENATED MODULE: ./src/components/shared/icons/Play.js
var Play_jsx = react.createElement;

var Play_defaultProps = {
  color: '#ffffff'
};

var Play = function Play(_ref) {
  var color = _ref.color;
  return Play_jsx("svg", {
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    version: "1.1",
    "data-id": "icons_Play_svg"
  }, Play_jsx("title", {
    "data-id": "icons_Play_title"
  }, "Afspelen"), Play_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Play_g"
  }, Play_jsx("g", {
    transform: "translate(-280.000000, -2654.000000)",
    fill: color,
    "data-id": "icons_Play_g_3"
  }, Play_jsx("g", {
    transform: "translate(130.000000, 2507.000000)",
    "data-id": "icons_Play_g_4"
  }, Play_jsx("g", {
    transform: "translate(0.000000, 1.000000)",
    "data-id": "icons_Play_g_5"
  }, Play_jsx("path", {
    d: "M190,226 C167.90861,226 150,208.09139 150,186 C150,163.90861 167.90861,146 190,146 C212.09139,146 230,163.90861 230,186 C230,208.09139 212.09139,226 190,226 Z M207.934066,187.142857 L180.857143,171.142857 L180.857143,203.142857 L207.934066,187.142857 Z",
    "data-id": "icons_Play_path"
  }))))));
};

Play.defaultProps = Play_defaultProps;
/* harmony default export */ var icons_Play = (Play);
// EXTERNAL MODULE: ./node_modules/react-swipeable-views/lib/index.js
var lib = __webpack_require__(77314);
;// CONCATENATED MODULE: ./src/components/shared/icons/CircleArrow.js
var CircleArrow_jsx = react.createElement;


var CircleArrow_defaultProps = {
  direction: 'right',
  color: styleGuide/* colorPalette.textGrey */.K5.textGrey,
  width: 60,
  height: 60
};
var ROTATE = {
  up: 270,
  down: 90,
  left: 180,
  right: 0
};

var CircleArrow = function CircleArrow(_ref) {
  var width = _ref.width,
      height = _ref.height,
      direction = _ref.direction,
      color = _ref.color;
  return CircleArrow_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px"),
      transform: "rotateZ(".concat(ROTATE[direction], "deg)"),
      overflow: "visible"
    },
    viewBox: "0 0 60 60",
    version: "1.1",
    "data-id": "icons_CircleArrow_svg"
  }, CircleArrow_jsx("title", {
    "data-id": "icons_CircleArrow_title"
  }, "Circle Arrow"), CircleArrow_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_CircleArrow_g"
  }, CircleArrow_jsx("g", {
    transform: "translate(-1229.000000, -480.000000)",
    fill: color,
    "data-id": "icons_CircleArrow_g_3"
  }, CircleArrow_jsx("g", {
    transform: "translate(130.000000, 175.000000)",
    "data-id": "icons_CircleArrow_g_4"
  }, CircleArrow_jsx("g", {
    transform: "translate(20.000000, 305.000000)",
    "data-id": "icons_CircleArrow_g_5"
  }, CircleArrow_jsx("path", {
    d: "M1109,60 C1092.43146,60 1079,46.5685425 1079,30 C1079,13.4314575 1092.43146,0 1109,0 C1125.56854,0 1139,13.4314575 1139,30 C1139,46.5685425 1125.56854,60 1109,60 Z M1098.87213,29.9757829 L1098.87213,29.9757829 C1098.84316,30.8797773 1099.17542,31.7943932 1099.87617,32.4951408 L1108.03936,40.658335 C1109.37178,41.9907577 1111.5228,42.0000216 1112.86455,40.6582774 C1114.197,39.3258229 1114.21428,37.182766 1112.86461,35.8330903 L1107.0073,29.9757829 L1112.86461,24.1184756 C1114.21428,22.7687998 1114.197,20.625743 1112.86455,19.2932884 C1111.5228,17.9515443 1109.37178,17.9608081 1108.03936,19.2932309 L1099.87617,27.456425 C1099.17542,28.1571727 1098.84316,29.0717885 1098.87213,29.9757829 Z",
    id: "icon/modelSlider/arrow/right/hover",
    transform: "translate(1109.000000, 30.000000) scale(-1, 1) translate(-1109.000000, -30.000000) ",
    "data-id": "icons_CircleArrow_path"
  }))))));
};

CircleArrow.defaultProps = CircleArrow_defaultProps;
/* harmony default export */ var icons_CircleArrow = (CircleArrow);
;// CONCATENATED MODULE: ./src/components/shared/ui/SliderSlide.js



var SliderSlide_templateObject, SliderSlide_templateObject2, SliderSlide_templateObject3, SliderSlide_templateObject4;

var SliderSlide_jsx = react.createElement;








var SliderSlide = function SliderSlide(_ref) {
  var slide = _ref.slide,
      sliderWidth = _ref.sliderWidth,
      isCurrent = _ref.isCurrent,
      fit = _ref.fit;
  var titleProps = {
    sliderWidth: sliderWidth,
    isCurrent: isCurrent
  };
  return slide.internalLink && slide.internalLink.projectSlug && slide.internalLink.env ? SliderSlide_jsx(SlideInternalLink, {
    href: '/' + (0,getLinkFromPageObject/* default */.Z)(slide.internalLink),
    "data-id": "ui_SliderSlide_SlideInternalLink"
  }, fit === 'contain' && slide.image && SliderSlide_jsx(ImageBlurContainer, {
    "data-id": "ui_SliderSlide_ImageBlurContainer"
  }, SliderSlide_jsx(ImageLoader/* default */.Z, {
    src: slide.image.src,
    mode: "bg",
    width: 100,
    height: 0,
    "data-id": "ui_SliderSlide_ImageLoader"
  })), SliderSlide_jsx(ImageLoader/* default */.Z, {
    src: slide.image && slide.image.src,
    mode: "bg",
    fit: fit,
    width: sliderWidth,
    height: 0,
    "data-id": "ui_SliderSlide_ImageLoader_3"
  }), slide.text && SliderSlide_jsx(SliderSlide_Title, (0,esm_extends/* default */.Z)({}, titleProps, {
    "data-id": "ui_SliderSlide_Title"
  }), slide.text)) : slide.externalLink ? SliderSlide_jsx(SlideExternalLink, {
    href: slide.externalLink,
    target: "_blank",
    "data-id": "ui_SliderSlide_SlideExternalLink"
  }, fit === 'contain' && slide.image && SliderSlide_jsx(ImageBlurContainer, {
    "data-id": "ui_SliderSlide_ImageBlurContainer"
  }, SliderSlide_jsx(ImageLoader/* default */.Z, {
    src: slide.image.src,
    mode: "bg",
    width: 100,
    height: 0,
    "data-id": "ui_SliderSlide_ImageLoader"
  })), SliderSlide_jsx(ImageLoader/* default */.Z, {
    src: slide.image && slide.image.src,
    mode: "bg",
    fit: fit,
    width: sliderWidth,
    height: 0,
    "data-id": "ui_SliderSlide_ImageLoader_8"
  }), slide.text && SliderSlide_jsx(SliderSlide_Title, (0,esm_extends/* default */.Z)({}, titleProps, {
    "data-id": "ui_SliderSlide_Title"
  }), slide.text)) : SliderSlide_jsx(SlideNoLink, {
    "data-id": "ui_SliderSlide_SlideNoLink"
  }, fit === 'contain' && slide.image && SliderSlide_jsx(ImageBlurContainer, {
    "data-id": "ui_SliderSlide_ImageBlurContainer"
  }, SliderSlide_jsx(ImageLoader/* default */.Z, {
    src: slide.image.src,
    mode: "bg",
    width: 100,
    height: 0,
    "data-id": "ui_SliderSlide_ImageLoader"
  })), SliderSlide_jsx(ImageLoader/* default */.Z, {
    src: slide.image && slide.image.src,
    mode: "bg",
    fit: fit,
    width: sliderWidth,
    height: 0,
    "data-id": "ui_SliderSlide_ImageLoader_13"
  }), slide.text && SliderSlide_jsx(SliderSlide_Title, (0,esm_extends/* default */.Z)({}, titleProps, {
    "data-id": "ui_SliderSlide_Title"
  }), slide.text));
};

var ImageBlurContainer = styled_components_browser_esm["default"].div(SliderSlide_templateObject || (SliderSlide_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background-color: #000000;\n\n  > div {\n    backface-visibility: hidden;\n    opacity: 0.85;\n    transform: scale(1.3);\n    filter: blur(8px);\n  }\n"])));
var Slide = styled_components_browser_esm["default"].div(SliderSlide_templateObject2 || (SliderSlide_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  position: relative;\n  height: 100%;\n"])));
var LinkSlide = styled_components_browser_esm["default"].div(SliderSlide_templateObject3 || (SliderSlide_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  position: relative;\n  height: 100%;\n  overflow: hidden;\n\n  > div {\n    transform: scale(1) translateZ(0);\n    transition: transform 1s ease;\n    will-change: transform;\n    backface-visibility: visible;\n\n    &:hover {\n      transform: scale(1.03) translateZ(0);\n    }\n  }\n"])));
var SlideNoLink = Slide;
var SlideInternalLink = LinkSlide.withComponent(Link/* default */.Z);
var SlideExternalLink = LinkSlide.withComponent('a');
var SliderSlide_Title = styled_components_browser_esm["default"].h2(SliderSlide_templateObject4 || (SliderSlide_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  pointer-events: none;\n  margin-top: 0;\n  margin-bottom: 0;\n  top: 20rem;\n  left: 20rem;\n  width: calc(100% - 40rem);\n  max-width: 530rem;\n  z-index: 2;\n  color: ", ";\n  ", ";\n  ", "\n  opacity: ", ";\n  transition: opacity 0.3s 0.5s ease-in-out;\n\n  ", "\n\n  ", "\n"])), styleGuide/* colorPalette.white */.K5.white, styleGuide/* shadows.textPrimary */.q.textPrimary, styleGuide/* textStyles.pageTitle */.sq.pageTitle, function (props) {
  return props.isCurrent ? 1 : 0;
}, function (props) {
  return props.sliderWidth >= breakpoints/* breakpointSizes.md */.YA.md ? "\n    width: calc((7/12) * 100%);\n  " : '';
}, function (props) {
  return props.sliderWidth >= breakpoints/* breakpointSizes.lg */.YA.lg ? "\n    top: 30rem;\n    left: 30rem;\n  " : '';
});
/* harmony default export */ var ui_SliderSlide = (SliderSlide);
// EXTERNAL MODULE: ./src/components/ObserveSize.js + 2 modules
var ObserveSize = __webpack_require__(12114);
// EXTERNAL MODULE: ./src/components/shared/buttons/ButtonDownload.js
var ButtonDownload = __webpack_require__(5224);
// EXTERNAL MODULE: ./src/services/formatCmsImageUrl.ts
var formatCmsImageUrl = __webpack_require__(11091);
;// CONCATENATED MODULE: ./src/components/shared/ui/Slider.js








var Slider_templateObject, Slider_templateObject2, Slider_templateObject3, Slider_templateObject4, Slider_templateObject5, Slider_templateObject6, Slider_templateObject7, Slider_templateObject8, Slider_templateObject9, Slider_templateObject0, Slider_templateObject1, Slider_templateObject10, Slider_templateObject11, Slider_templateObject12, Slider_templateObject13, Slider_templateObject14, Slider_templateObject15;

var Slider_jsx = react.createElement;

function Slider_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, Slider_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function Slider_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (Slider_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

















var Slider_defaultProps = {
  showPrimaryArrows: true,
  showBullets: true,
  size: 'normal'
};

var Slider_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};

var Slider = /*#__PURE__*/function (_Component) {
  function Slider() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Slider_callSuper(this, Slider, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      swipeIndex: _this.props.currentIndex ? _this.props.currentIndex : 0,
      renderWidth: 0
    }); // Returns cover if image 'amost fits', otherwise contain


    (0,defineProperty/* default */.Z)(_this, "getImageFit", function (image, heightRatio) {
      return image ? Math.abs(image.height / image.width - heightRatio) > 0.1 ? 'contain' : 'cover' : 'cover';
    });

    return _this;
  }

  (0,inherits/* default */.Z)(Slider, _Component);

  return (0,createClass/* default */.Z)(Slider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          heightRatio = _this$props.heightRatio,
          styling = _this$props.styling,
          _this$props$heroes = _this$props.heroes,
          heroes = _this$props$heroes === void 0 ? [] : _this$props$heroes,
          showBullets = _this$props.showBullets,
          size = _this$props.size,
          showPrimaryArrows = _this$props.showPrimaryArrows,
          showSecondaryArrows = _this$props.showSecondaryArrows,
          showDownloadButton = _this$props.showDownloadButton,
          paginationColor = _this$props.paginationColor;
      var _this$state = this.state,
          swipeIndex = _this$state.swipeIndex,
          renderWidth = _this$state.renderWidth;
      var themeColor = styling.button;
      var calculatedHeightRatio = heightRatio || 820 / 1180;
      var singleSlide = !heroes || heroes.length === 1;
      var shouldPrimaryArrowsBeDisplayed = this.state.renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? false : showPrimaryArrows;
      return Slider_jsx(Wrapper, {
        "data-id": "ui_Slider_Wrapper"
      }, Slider_jsx(ObserveSize/* default */.Z, {
        observerFn: function observerFn(contentRect) {
          return _this2.setState({
            renderWidth: contentRect.width
          });
        },
        "data-id": "ui_Slider_ObserveSize"
      }, Slider_jsx(ButtonSpace, {
        singleSlide: singleSlide,
        hasArrows: shouldPrimaryArrowsBeDisplayed,
        "data-id": "ui_Slider_ButtonSpace"
      }, Slider_jsx(SlideView, {
        singleSlide: singleSlide,
        heightRatio: calculatedHeightRatio,
        "data-id": "ui_Slider_SlideView"
      }, Slider_jsx(InnerView, {
        "data-id": "ui_Slider_InnerView"
      }, heroes && (singleSlide ? Slider_jsx(ui_SliderSlide, {
        slide: heroes[0],
        fit: this.getImageFit(heroes[0].image, calculatedHeightRatio),
        sliderWidth: renderWidth,
        isCurrent: true,
        "data-id": "ui_Slider_SliderSlide"
      }) : Slider_jsx(lib/* default */.ZP, {
        index: swipeIndex,
        onChangeIndex: function onChangeIndex(index) {
          return _this2.setState({
            swipeIndex: index
          });
        },
        resistance: true,
        ignoreNativeScroll: true,
        style: {
          height: '100%'
        },
        containerStyle: {
          height: '100%'
        },
        slideStyle: {
          height: '100%'
        },
        "data-id": "ui_Slider_SwipeableViews"
      }, heroes.map(function (hero, index) {
        return hero ? Slider_jsx(ui_SliderSlide, {
          key: index,
          fit: _this2.getImageFit(hero.image, calculatedHeightRatio),
          slide: hero,
          sliderWidth: renderWidth,
          isCurrent: swipeIndex === index,
          "data-id": "ui_Slider_SliderSlide"
        }) : null;
      })))), shouldPrimaryArrowsBeDisplayed && [Slider_jsx(ArrowPrimaryNext, {
        key: "next",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex + 1
          });
        },
        disabled: !heroes || swipeIndex >= heroes.length - 1,
        "aria-label": "Volgende",
        "data-id": "ui_Slider_ArrowPrimaryNext"
      }, Slider_jsx(Caret/* default */.Z, {
        direction: "right",
        color: styleGuide/* colorPalette.white */.K5.white,
        "data-id": "ui_Slider_Caret"
      })), Slider_jsx(ArrowPrimaryPrev, {
        key: "prev",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex - 1
          });
        },
        disabled: !heroes || swipeIndex === 0,
        "aria-label": "Vorige",
        "data-id": "ui_Slider_ArrowPrimaryPrev"
      }, Slider_jsx(Caret/* default */.Z, {
        direction: "left",
        color: styleGuide/* colorPalette.white */.K5.white,
        "data-id": "ui_Slider_Caret"
      }))], showSecondaryArrows && [Slider_jsx(ArrowSecondaryNext, {
        key: "next",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex + 1
          });
        },
        disabled: !heroes || swipeIndex >= heroes.length - 1,
        "aria-label": "Volgende",
        "data-id": "ui_Slider_ArrowSecondaryNext"
      }, Slider_jsx(icons_CircleArrow, {
        direction: "right",
        color: styleGuide/* colorPalette.white */.K5.white,
        "data-id": "ui_Slider_CircleArrow"
      })), showDownloadButton && Slider_jsx(DownloadButtonBase, {
        key: swipeIndex,
        "data-id": "ui_Slider_DownloadButtonBase"
      }, Slider_jsx(ButtonDownload/* default */.Z, {
        key: swipeIndex,
        link: heroes && heroes ? (0,formatCmsImageUrl/* default */.Z)(0, 0, heroes[swipeIndex].image.src, false) : '/',
        content: "",
        image: true,
        "data-id": "ui_Slider_DownloadButton"
      })), Slider_jsx(ArrowSecondaryPrev, {
        key: "prev",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex - 1
          });
        },
        disabled: !heroes || swipeIndex === 0,
        "aria-label": "Vorige",
        "data-id": "ui_Slider_ArrowSecondaryPrev"
      }, Slider_jsx(icons_CircleArrow, {
        direction: "left",
        color: styleGuide/* colorPalette.white */.K5.white,
        "data-id": "ui_Slider_CircleArrow"
      }))])), showBullets && heroes && heroes.length > 1 && Slider_jsx(DotView, {
        "data-id": "ui_Slider_DotView"
      }, heroes && heroes.map(function (hero, index) {
        return Slider_jsx(Slider_Button, {
          key: index,
          onClick: function onClick() {
            return _this2.setState({
              swipeIndex: index
            });
          },
          isActive: swipeIndex === index,
          size: size,
          color: paginationColor || themeColor,
          "aria-label": "Navigeer naar slide ".concat(index),
          "data-id": "ui_Slider_Button"
        }, Slider_jsx(Bullet, {
          color: paginationColor || themeColor,
          "data-id": "ui_Slider_Bullet"
        }));
      }))));
    }
  }]);
}(react.Component);

(0,defineProperty/* default */.Z)(Slider, "defaultProps", Slider_defaultProps);

/* harmony default export */ var ui_Slider = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(Slider_mapStateToProps)(Slider)));
var Wrapper = styled_components_browser_esm["default"].div(Slider_templateObject || (Slider_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: auto;\n  margin-right: auto;\n"])));
var SlideView = styled_components_browser_esm["default"].div(Slider_templateObject2 || (Slider_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  padding-top: ", "%;\n"])), function (props) {
  return props.heightRatio * 100;
});
var ButtonSpace = styled_components_browser_esm["default"].div(Slider_templateObject3 || (Slider_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  ", ";\n"])), function (props) {
  return props.hasArrows ? 'margin: 0 20rem;' : '';
});
var InnerView = styled_components_browser_esm["default"].div(Slider_templateObject4 || (Slider_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background-color: ", ";\n  box-shadow: 0 0 20rem 0 rgba(0, 0, 0, 0.25);\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey);
var ArrowStyle = (0,styled_components_browser_esm.css)(Slider_templateObject5 || (Slider_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  opacity: 0.85;\n  background-color: ", ";\n  width: 40rem;\n  height: 40rem;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n  ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, function (props) {
  return props.disabled ? 'opacity: 0; pointer-events: none;' : ' &:hover { opacity: 1; } ';
});
var ArrowCircleStyle = (0,styled_components_browser_esm.css)(Slider_templateObject6 || (Slider_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%) scale(1);\n  z-index: 1;\n  opacity: 0.85;\n  width: 60rem;\n  height: 60rem;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n  ", ";\n  ", ";\n"])), function (props) {
  return props.disabled ? 'opacity: 0; pointer-events: none;' : ' &:hover { opacity: 1; } ';
}, breakpoints/* toBreakpoint.md */.Hx.md(Slider_templateObject7 || (Slider_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      transform: translateY(-50%) scale(.6);\n  "]))));
var DownloadButtonBase = styled_components_browser_esm["default"].button(Slider_templateObject8 || (Slider_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  transform: translateY(-50%) scale(1);\n  z-index: 10;\n  opacity: 1;\n  width: 100%;\n  height: auto;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  -webkit-tap-highlight-color: transparent;\n  opacity: 1;\n  ", ";\n  right: 20px;\n  bottom: 20px;\n"])), breakpoints/* toBreakpoint.md */.Hx.md(Slider_templateObject9 || (Slider_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n      bottom: 5px;\n  "]))));
var ArrowPrimaryNext = styled_components_browser_esm["default"].button(Slider_templateObject0 || (Slider_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  right: -20rem;\n"])), ArrowStyle);
var ArrowPrimaryPrev = styled_components_browser_esm["default"].button(Slider_templateObject1 || (Slider_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  left: -20rem;\n"])), ArrowStyle);
var ArrowSecondaryNext = styled_components_browser_esm["default"].button(Slider_templateObject10 || (Slider_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  right: 20rem;\n"])), ArrowCircleStyle);
var ArrowSecondaryPrev = styled_components_browser_esm["default"].button(Slider_templateObject11 || (Slider_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  left: 20rem;\n"])), ArrowCircleStyle);
var DotView = styled_components_browser_esm["default"].div(Slider_templateObject12 || (Slider_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  width: 100%;\n  padding-top: 15rem;\n"])));
var Bullet = styled_components_browser_esm["default"].span(Slider_templateObject13 || (Slider_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  border-radius: 50%;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.color ? props.color : styleGuide/* colorPalette.lightBlue */.K5.lightBlue;
}, function (props) {
  return props.color ? props.color : styleGuide/* colorPalette.blue */.K5.blue;
});
var Slider_Button = styled_components_browser_esm["default"].button(Slider_templateObject14 || (Slider_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: ", ";\n  height: 12rem;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n\n  > span {\n    width: ", ";\n    height: ", ";\n    transition: background-color 0.25s ease-in-out;\n\n    background-color: ", ";\n  }\n\n  ", ";\n"])), function (props) {
  return props.size === 'small' ? '15rem' : '25rem';
}, function (props) {
  return props.size === 'small' ? '8rem' : '12rem';
}, function (props) {
  return props.size === 'small' ? '8rem' : '12rem';
}, function (props) {
  return props.isActive && props.color ? "".concat((0,utils/* darken */._j)(props.color, 15)) : props.isActive ? styleGuide/* colorPalette.darkBlue */.K5.darkBlue : '';
}, breakpoints/* fromBreakpoint.md */.ks.md(Slider_templateObject15 || (Slider_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: ", ";\n\n    > span {\n      width: ", ";\n      height: ", ";\n    }\n"])), function (props) {
  return props.size === 'small' ? '15rem' : '25rem';
}, function (props) {
  return props.size === 'small' ? '8rem' : '12rem';
}, function (props) {
  return props.size === 'small' ? '8rem' : '12rem';
}));
;// CONCATENATED MODULE: ./src/components/HeroArticle.js








var HeroArticle_templateObject, HeroArticle_templateObject2, HeroArticle_templateObject3, HeroArticle_templateObject4, HeroArticle_templateObject5, HeroArticle_templateObject6, HeroArticle_templateObject7, HeroArticle_templateObject8, HeroArticle_templateObject9, HeroArticle_templateObject0, HeroArticle_templateObject1, HeroArticle_templateObject10, HeroArticle_templateObject11;

var HeroArticle_jsx = react.createElement;

function HeroArticle_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, HeroArticle_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function HeroArticle_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (HeroArticle_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}













var HeroArticle = /*#__PURE__*/function (_Component) {
  function HeroArticle() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, HeroArticle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = HeroArticle_callSuper(this, HeroArticle, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      showVideo: false
    });

    (0,defineProperty/* default */.Z)(_this, "handleClick", function () {
      _this.setState({
        showVideo: true
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(HeroArticle, _Component);

  return (0,createClass/* default */.Z)(HeroArticle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          image = _this$props.image,
          type = _this$props.type,
          title = _this$props.title,
          theme = _this$props.theme,
          media = _this$props.media,
          credits = _this$props.credits,
          author = _this$props.author,
          youtubeId = _this$props.youtubeId,
          renderWidth = _this$props.renderWidth,
          showDownloadButton = _this$props.showDownloadButton;
      var showVideo = this.state.showVideo;
      var IMAGE_SIZES = renderWidth && renderWidth > 1000 ? 1180 : 1000;
      var El;

      switch (type) {
        case 'image':
        default:
          El = HeroArticle_jsx(ImageContainer, {
            "data-id": "components_HeroArticle_ImageContainer"
          }, image && image.src && HeroArticle_jsx(react.Fragment, null, showDownloadButton && HeroArticle_jsx(HeroArticle_DownloadButtonBase, {
            "data-id": "components_HeroArticle_DownloadButtonBase"
          }, HeroArticle_jsx(ButtonDownload/* default */.Z, {
            link: image && image.src ? (0,formatCmsImageUrl/* default */.Z)(0, 0, image.src, false) : '/',
            content: "",
            image: true,
            "data-id": "components_HeroArticle_DownloadButton"
          })), HeroArticle_jsx(ImageLoader/* default */.Z, {
            width: renderWidth,
            height: 900,
            src: image.src,
            alt: title,
            color: styleGuide/* themes */.np[theme].secondary,
            mode: "bg",
            "data-id": "components_HeroArticle_ImageLoader"
          })));
          break;

        case 'video':
          El = HeroArticle_jsx(Video, {
            "data-id": "components_HeroArticle_Video"
          }, renderWidth && renderWidth > 720 && HeroArticle_jsx(VideoPlaceholder, {
            image: (0,formatCmsImageUrl/* default */.Z)(IMAGE_SIZES, 0, image ? image.src : ''),
            size: "large",
            showVideo: showVideo,
            "data-id": "components_HeroArticle_VideoPlaceholder"
          }, HeroArticle_jsx(PlayIconWrapper, {
            onClick: this.handleClick,
            "data-id": "components_HeroArticle_PlayIconWrapper"
          }, HeroArticle_jsx(icons_Play, {
            color: "#FFFFFF",
            "data-id": "components_HeroArticle_PlayIcon"
          }))), HeroArticle_jsx(YouTubeIFrame, {
            title: title,
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/".concat(String(youtubeId), "?rel=0&autoplay=").concat(showVideo ? '1' : '0', "&showinfo=0"),
            frameBorder: "0",
            allowFullScreen: true,
            showVideo: showVideo,
            desktop: renderWidth && renderWidth > 720,
            "data-id": "components_HeroArticle_YouTubeIFrame"
          }));
          break;

        case 'slider':
          El = HeroArticle_jsx(react.Fragment, null, showDownloadButton && HeroArticle_jsx(ui_Slider, {
            heroes: media,
            showBullets: false,
            showPrimaryArrows: false,
            showSecondaryArrows: true,
            heightRatio: 664 / 1180,
            currentIndex: 0,
            showDownloadButton: true,
            "data-id": "components_HeroArticle_Slider"
          }), !showDownloadButton && HeroArticle_jsx(ui_Slider, {
            heroes: media,
            showBullets: false,
            showPrimaryArrows: false,
            showSecondaryArrows: true,
            heightRatio: 664 / 1180,
            currentIndex: 0,
            "data-id": "components_HeroArticle_Slider_10"
          }));
          break;
      }

      return HeroArticle_jsx(HeroArticle_Container, {
        "data-id": "components_HeroArticle_Container"
      }, El, credits && HeroArticle_jsx(Credits, {
        "data-id": "components_HeroArticle_Credits"
      }, credits), (type !== 'video' && author || type === 'video' && !showVideo) && author && HeroArticle_jsx(AuthorImageContainer, {
        "data-id": "components_HeroArticle_AuthorImageContainer"
      }, HeroArticle_jsx(UserAvatar/* default */.Z, {
        mode: "imageLoader",
        size: renderWidth > breakpoints/* breakpointSizes.md */.YA.md ? 'xlarge' : 'larger',
        name: author.name,
        imageUrl: author.image,
        "data-id": "components_HeroArticle_UserAvatar"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_HeroArticle = (HeroArticle);
var HeroArticle_Container = styled_components_browser_esm["default"].div(HeroArticle_templateObject || (HeroArticle_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n"])));
var Credits = styled_components_browser_esm["default"].div(HeroArticle_templateObject2 || (HeroArticle_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  text-shadow: 0 0 20rem rgba(0, 0, 0, 0.5);\n  position: absolute;\n  max-width: 320rem;\n  z-index: 2;\n  left: 20rem;\n  bottom: 10rem;\n  color: white;\n  font-size: 12rem;\n  ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, breakpoints/* fromBreakpoint.md */.ks.md(HeroArticle_templateObject3 || (HeroArticle_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    left: 60rem;\n    bottom: 20rem;\n    font-size: 14rem;\n  "]))));
var ImageContainer = styled_components_browser_esm["default"].div(HeroArticle_templateObject4 || (HeroArticle_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 56.25%;\n  position: relative;\n\n  > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    &:after {\n      position: absolute;\n      content: ' ';\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 2;\n      background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2));\n    }\n  }\n"])));
var HeroArticle_DownloadButtonBase = styled_components_browser_esm["default"].button(HeroArticle_templateObject5 || (HeroArticle_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  transform: translateY(-50%) scale(1);\n  z-index: 10;\n  opacity: 1;\n  width: auto;\n  height: auto;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  -webkit-tap-highlight-color: transparent;\n  opacity: 1;\n  width: 100%;\n  left: 20px;\n  bottom: 20px;\n"])));
var Video = styled_components_browser_esm["default"].div(HeroArticle_templateObject6 || (HeroArticle_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: #000000;\n  padding-top: 56.25%;\n  width: 100%;\n  position: relative;\n"])));
var YouTubeIFrame = styled_components_browser_esm["default"].iframe(HeroArticle_templateObject7 || (HeroArticle_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 3;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  box-sizing: border-box;\n  background-size: cover;\n  background-position: center;\n  visibility: ", ";\n"])), function (props) {
  return props.showVideo || !props.desktop ? 'visible' : 'hidden';
});
var PlayIconWrapper = styled_components_browser_esm["default"].div(HeroArticle_templateObject8 || (HeroArticle_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(1.5);\n  transition: transform 0.35s ease-in-out;\n  z-index: 1;\n  opacity: 0.9;\n  cursor: pointer;\n  box-shadow: 0 0 200rem 0 rgba(0, 0, 0, 0.5);\n  border-radius: 50%;\n\n  svg {\n    float: left;\n  }\n\n  &:hover {\n    transform: translate(-50%, -50%) scale(1.6);\n  }\n"])));
var loadOutAnimation = (0,styled_components_browser_esm.keyframes)(HeroArticle_templateObject9 || (HeroArticle_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    opacity: 1;\n    z-index: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n    z-index: 0;\n  }\n"])));
var VideoPlaceholder = styled_components_browser_esm["default"].div(HeroArticle_templateObject0 || (HeroArticle_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding-top: 56.28%;\n  width: 100%;\n  background-size: cover;\n  background-position: center;\n  background-image: url(", ");\n  animation: ", ";\n  animation-fill-mode: forwards;\n\n  &:after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    position: absolute;\n    background-color: #000000;\n    opacity: 0.15;\n  }\n"])), styleGuide/* colorPalette.background */.K5.background, function (props) {
  return props.image;
}, function (props) {
  return props.showVideo ? (0,styled_components_browser_esm.css)(HeroArticle_templateObject1 || (HeroArticle_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n          ", " 1.2s ease-in\n        "])), loadOutAnimation) : '';
});
var AuthorImageContainer = styled_components_browser_esm["default"].div(HeroArticle_templateObject10 || (HeroArticle_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  z-index: 2;\n  right: 20rem;\n  bottom: -20rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(HeroArticle_templateObject11 || (HeroArticle_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n    right: 40rem;\n    bottom: -40rem;\n  "]))));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/homestudio/CategoryDescriptionModal.tsx



var CategoryDescriptionModal_templateObject, CategoryDescriptionModal_templateObject2, CategoryDescriptionModal_templateObject3, CategoryDescriptionModal_templateObject4, CategoryDescriptionModal_templateObject5, CategoryDescriptionModal_templateObject6;

function CategoryDescriptionModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CategoryDescriptionModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CategoryDescriptionModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CategoryDescriptionModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // eslint-disable-next-line import/no-cycle

 // eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member

 // eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member





var TypedHeroArticle = function TypedHeroArticle(props) {
  // @ts-ignore
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_HeroArticle, CategoryDescriptionModal_objectSpread(CategoryDescriptionModal_objectSpread({}, props), {}, {
    "data-id": "homestudio_CategoryDescriptionModal_HeroArticle"
  }));
};

var getApiDataParams = function getApiDataParams(_ref) {
  var projectSlug = _ref.projectSlug,
      modalId = _ref.modalId;
  return {
    wishListModalCategory: {
      projectSlug: projectSlug,
      modalId: modalId
    }
  };
};

var CategoryDescriptionModal_connectApiData = (0,withApiData/* default */.Z)({
  wishListModalCategory: 'getWishListModalCategory'
}, getApiDataParams);
var CategoryDescriptionModal_Wrapper = styled_components_browser_esm["default"].div(CategoryDescriptionModal_templateObject || (CategoryDescriptionModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 20rem;\n  margin-left: 20rem;\n"])));
var CategoryDescriptionModal_Container = styled_components_browser_esm["default"].div(CategoryDescriptionModal_templateObject2 || (CategoryDescriptionModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, colors/* colors.white */.O.white);
var Content = styled_components_browser_esm["default"].div(CategoryDescriptionModal_templateObject3 || (CategoryDescriptionModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding-bottom: 60rem;\n"])));
var CategoryDescriptionModal_Title = styled_components_browser_esm["default"].h1(CategoryDescriptionModal_templateObject4 || (CategoryDescriptionModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-left: 20rem;\n  margin-right: 20rem;\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* toBreakpoint.md */.Hx.md(CategoryDescriptionModal_templateObject5 || (CategoryDescriptionModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(CategoryDescriptionModal_templateObject6 || (CategoryDescriptionModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))));

var CategoryDescriptionModal = function CategoryDescriptionModal(_ref2) {
  var wishListModalCategory = _ref2.wishListModalCategory,
      renderWidth = _ref2.renderWidth;
  var data = wishListModalCategory.data;

  if (!data) {
    return null;
  }

  var heroArticleProps = {
    theme: 'woonStyling',
    type: data.type,
    renderWidth: renderWidth
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CategoryDescriptionModal_Container, {
    "data-id": "homestudio_CategoryDescriptionModal_Container",
    children: [data.type === 'slider' && /*#__PURE__*/(0,jsx_runtime.jsx)(TypedHeroArticle, CategoryDescriptionModal_objectSpread(CategoryDescriptionModal_objectSpread({}, heroArticleProps), {}, {
      media: data.media,
      "data-id": "homestudio_CategoryDescriptionModal_TypedHeroArticle"
    })), data.type === 'image' && /*#__PURE__*/(0,jsx_runtime.jsx)(TypedHeroArticle, CategoryDescriptionModal_objectSpread(CategoryDescriptionModal_objectSpread({}, heroArticleProps), {}, {
      image: data.image,
      "data-id": "homestudio_CategoryDescriptionModal_TypedHeroArticle_3"
    })), data.type === 'video' && /*#__PURE__*/(0,jsx_runtime.jsx)(TypedHeroArticle, CategoryDescriptionModal_objectSpread(CategoryDescriptionModal_objectSpread({}, heroArticleProps), {}, {
      youtubeId: data.youtubeId,
      "data-id": "homestudio_CategoryDescriptionModal_TypedHeroArticle_4"
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
      "data-id": "homestudio_CategoryDescriptionModal_Content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-id": "homestudio_CategoryDescriptionModal_div",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryDescriptionModal_Title, {
          "data-id": "homestudio_CategoryDescriptionModal_Title",
          children: data.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryDescriptionModal_Wrapper, {
        "data-id": "homestudio_CategoryDescriptionModal_Wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BBCode/* default */.Z, {
          content: data.text,
          "data-id": "homestudio_CategoryDescriptionModal_BBCode"
        })
      })]
    })]
  });
};

/* harmony default export */ var homestudio_CategoryDescriptionModal = (CategoryDescriptionModal_connectApiData(CategoryDescriptionModal));
;// CONCATENATED MODULE: ./src/components/homestudio/CategorySubDescriptionModal.js


var CategorySubDescriptionModal_templateObject, CategorySubDescriptionModal_templateObject2, CategorySubDescriptionModal_templateObject3, CategorySubDescriptionModal_templateObject4, CategorySubDescriptionModal_templateObject5, CategorySubDescriptionModal_templateObject6;

var CategorySubDescriptionModal_jsx = react.createElement;








var CategorySubDescriptionModal_connectApiData = (0,withApiData/* default */.Z)({
  wishListModalSubCategory: 'getWishListModalSubCategory'
}, function (ownProps) {
  return {
    wishListModalSubCategory: {
      projectSlug: ownProps.match.params.projectSlug,
      modalId: ownProps.modalId
    }
  };
});

var CategorySubDescriptionModal = function CategorySubDescriptionModal(_ref) {
  var wishListModalSubCategory = _ref.wishListModalSubCategory,
      color = _ref.color,
      renderWidth = _ref.renderWidth;
  var data = wishListModalSubCategory.data;
  return data ? CategorySubDescriptionModal_jsx(CategorySubDescriptionModal_Container, {
    "data-id": "homestudio_CategorySubDescriptionModal_Container"
  }, data.type === 'slider' && CategorySubDescriptionModal_jsx(components_HeroArticle, {
    type: data.type,
    media: data.media,
    renderWidth: renderWidth,
    theme: "woonStyling",
    "data-id": "homestudio_CategorySubDescriptionModal_HeroArticle"
  }), data.type === 'image' && CategorySubDescriptionModal_jsx(components_HeroArticle, {
    type: data.type,
    image: data.image,
    theme: data.type === 'category' ? 'projectUpdate' : 'woonStyling',
    renderWidth: renderWidth,
    "data-id": "homestudio_CategorySubDescriptionModal_HeroArticle_2"
  }), data.type === 'video' && CategorySubDescriptionModal_jsx(components_HeroArticle, {
    type: data.type,
    youtubeId: data.youtubeId,
    renderWidth: renderWidth,
    theme: "woonStyling",
    "data-id": "homestudio_CategorySubDescriptionModal_HeroArticle_3"
  }), CategorySubDescriptionModal_jsx(CategorySubDescriptionModal_Content, {
    "data-id": "homestudio_CategorySubDescriptionModal_Content"
  }, CategorySubDescriptionModal_jsx("div", {
    "data-id": "homestudio_CategorySubDescriptionModal_div"
  }, CategorySubDescriptionModal_jsx(CategorySubDescriptionModal_Title, {
    color: color,
    "data-id": "homestudio_CategorySubDescriptionModal_Title"
  }, data.title)), CategorySubDescriptionModal_jsx(CategorySubDescriptionModal_Wrapper, {
    "data-id": "homestudio_CategorySubDescriptionModal_Wrapper"
  }, CategorySubDescriptionModal_jsx(BBCode/* default */.Z, {
    content: data.text,
    "data-id": "homestudio_CategorySubDescriptionModal_BBCode"
  })))) : null;
};

/* harmony default export */ var homestudio_CategorySubDescriptionModal = ((0,withMatch/* default */.Z)(CategorySubDescriptionModal_connectApiData(CategorySubDescriptionModal)));
var CategorySubDescriptionModal_Wrapper = styled_components_browser_esm["default"].div(CategorySubDescriptionModal_templateObject || (CategorySubDescriptionModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 20rem;\n  margin-left: 20rem;\n"])));
var CategorySubDescriptionModal_Container = styled_components_browser_esm["default"].div(CategorySubDescriptionModal_templateObject2 || (CategorySubDescriptionModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary);
var CategorySubDescriptionModal_Content = styled_components_browser_esm["default"].div(CategorySubDescriptionModal_templateObject3 || (CategorySubDescriptionModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding-bottom: 60rem;\n"])));
var CategorySubDescriptionModal_Title = styled_components_browser_esm["default"].h1(CategorySubDescriptionModal_templateObject4 || (CategorySubDescriptionModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-left: 20rem;\n  margin-right: 20rem;\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, function (props) {
  return props.color ? props.color : styleGuide/* colorPalette.headerGrey */.K5.headerGrey;
}, breakpoints/* toBreakpoint.md */.Hx.md(CategorySubDescriptionModal_templateObject5 || (CategorySubDescriptionModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(CategorySubDescriptionModal_templateObject6 || (CategorySubDescriptionModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))));
// EXTERNAL MODULE: ./src/components/atoms/Title.tsx
var atoms_Title = __webpack_require__(9746);
// EXTERNAL MODULE: ./src/components/atoms/Text.tsx
var atoms_Text = __webpack_require__(73006);
// EXTERNAL MODULE: ./src/styles/spacing.ts
var styles_spacing = __webpack_require__(8013);
// EXTERNAL MODULE: ./src/components/atoms/Box.tsx
var Box = __webpack_require__(39629);
;// CONCATENATED MODULE: ./src/components/atoms/TextBox.tsx



var _excluded = ["spacing"];

var TextBox_templateObject;

function TextBox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TextBox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TextBox_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TextBox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var TextBox_Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(TextBox_templateObject || (TextBox_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  gap: ", "rem;\n"])), function (_ref) {
  var spacing = _ref.spacing;
  return styles_spacing/* SIZE_MAP */.H[spacing];
});

var TextBox = function TextBox(_ref2) {
  var _ref2$spacing = _ref2.spacing,
      spacing = _ref2$spacing === void 0 ? 'lg' : _ref2$spacing,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextBox_Container, TextBox_objectSpread(TextBox_objectSpread({
    spacing: spacing
  }, props), {}, {
    "data-id": "atoms_TextBox_Container"
  }));
};

/* harmony default export */ var atoms_TextBox = (TextBox);
;// CONCATENATED MODULE: ./src/components/homestudio/DeadlineModal.tsx


var DeadlineModal_templateObject, DeadlineModal_templateObject2, DeadlineModal_templateObject3, DeadlineModal_templateObject4, DeadlineModal_templateObject5, DeadlineModal_templateObject6;










var DeadlineModal_Wrapper = (0,styled_components_browser_esm["default"])(atoms_TextBox)(DeadlineModal_templateObject || (DeadlineModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 20rem;\n  margin-left: 20rem;\n"])));
var DeadlineModal_Container = styled_components_browser_esm["default"].div(DeadlineModal_templateObject2 || (DeadlineModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, colors/* colors.white */.O.white);
var DeadlineModal_Content = styled_components_browser_esm["default"].div(DeadlineModal_templateObject3 || (DeadlineModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 60rem;\n  padding-bottom: 60rem;\n"])));
var StyledTitle = (0,styled_components_browser_esm["default"])(atoms_Title/* default */.Z)(DeadlineModal_templateObject4 || (DeadlineModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 20rem;\n  margin-right: 20rem;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* toBreakpoint.md */.Hx.md(DeadlineModal_templateObject5 || (DeadlineModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(DeadlineModal_templateObject6 || (DeadlineModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))));

var DeadlineModal = function DeadlineModal() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DeadlineModal_Container, {
    "data-id": "homestudio_DeadlineModal_Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DeadlineModal_Content, {
      "data-id": "homestudio_DeadlineModal_Content",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DeadlineModal_Wrapper, {
        "data-id": "homestudio_DeadlineModal_Wrapper",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
          text: "Beslisperiode",
          "data-id": "homestudio_DeadlineModal_StyledTitle"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
          text: "We hebben even de tijd nodig om ervoor te zorgen dat jouw keuzes straks duidelijk zijn voor onze collega\u2019s op de bouwplaats. Om die reden werken we met beslisperiodes; het tijdsbestek waarin je jouw keuzes uit de beschikbare meer- en minderwerkopties aan ons door kunt geven. Er gelden verschillende beslisperiodes voor verschillende typen opties. Zo is de beslisperiode voor opties zoals een uitbouw, elektra of loodgieterswerk anders dan de beslisperiode voor opties die te maken hebben met de afwerking van de woning.",
          "data-id": "homestudio_DeadlineModal_Text"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
          text: "De datum die je boven een subcategorie ziet, is de uiterste datum waarop je een aanvraag kunt starten voor opties binnen deze subcategorie. Wanneer deze datum is gepasseerd, is het niet meer mogelijk om een nieuwe aanvraag te starten. Opties die binnen de beslisperiode zijn aangevraagd, worden vanzelfsprekend wel in behandeling genomen.",
          "data-id": "homestudio_DeadlineModal_Text_5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
          text: " Heb je vragen over de beslisperiode, of is er nog geen beslisperiode ingesteld voor opties in een bepaalde subcategorie? Neem dan contact op met de woonadviseur.",
          "data-id": "homestudio_DeadlineModal_Text_6"
        })]
      })
    })
  });
};

/* harmony default export */ var homestudio_DeadlineModal = (DeadlineModal);
;// CONCATENATED MODULE: ./src/components/shared/designElements/ModalInnerWrapper.js


var ModalInnerWrapper_templateObject, ModalInnerWrapper_templateObject2, ModalInnerWrapper_templateObject3;

var ModalInnerWrapper_jsx = react.createElement;





var ModalInnerWrapper = function ModalInnerWrapper(_ref) {
  var children = _ref.children;
  return ModalInnerWrapper_jsx(ModalInnerWrapper_Container, {
    "data-id": "designElements_ModalInnerWrapper_Container"
  }, children);
};

var ModalInnerWrapper_Container = styled_components_browser_esm["default"].div(ModalInnerWrapper_templateObject || (ModalInnerWrapper_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 40rem 20rem 40rem 20rem;\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* fromBreakpoint.md */.ks.md(ModalInnerWrapper_templateObject2 || (ModalInnerWrapper_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 70rem 60rem 70rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ModalInnerWrapper_templateObject3 || (ModalInnerWrapper_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 200rem 80rem 200rem;\n  "]))));
/* harmony default export */ var designElements_ModalInnerWrapper = (ModalInnerWrapper);
// EXTERNAL MODULE: ./src/components/shared/buttons/ButtonPrimary.js
var ButtonPrimary = __webpack_require__(77528);
;// CONCATENATED MODULE: ./src/components/shared/designElements/DeleteConfirmation.js


var DeleteConfirmation_templateObject, DeleteConfirmation_templateObject2, DeleteConfirmation_templateObject3, DeleteConfirmation_templateObject4, DeleteConfirmation_templateObject5, DeleteConfirmation_templateObject6;

var DeleteConfirmation_jsx = react.createElement;






var DeleteConfirmation = function DeleteConfirmation(_ref) {
  var title = _ref.title,
      description = _ref.description,
      submitButtonLabel = _ref.submitButtonLabel,
      loading = _ref.loading,
      loadingLabel = _ref.loadingLabel,
      submitFn = _ref.submitFn,
      cancelFn = _ref.cancelFn,
      cancelButtonLabel = _ref.cancelButtonLabel,
      lastOne = _ref.lastOne,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return DeleteConfirmation_jsx(DeleteConfirmation_Container, {
    "data-e2e-modal-confirmation": true,
    "data-id": "designElements_DeleteConfirmation_Container"
  }, DeleteConfirmation_jsx(DeleteConfirmation_Title, {
    dangerouslySetInnerHTML: {
      __html: title
    },
    "data-id": "designElements_DeleteConfirmation_Title"
  }), DeleteConfirmation_jsx(Description, {
    "data-id": "designElements_DeleteConfirmation_Description"
  }, description), submitButtonLabel && submitFn && DeleteConfirmation_jsx(ButtonPrimary/* default */.Z, {
    label: submitButtonLabel,
    type: "button",
    clickHandler: submitFn,
    loadingLabel: loadingLabel,
    loading: loading,
    disabled: disabled && !loading,
    "data-id": "designElements_DeleteConfirmation_ButtonPrimary"
  }), cancelButtonLabel && cancelFn && DeleteConfirmation_jsx(Cancel, {
    lastOne: lastOne,
    onClick: disabled ? undefined : cancelFn,
    "data-id": "designElements_DeleteConfirmation_Cancel"
  }, cancelButtonLabel));
};

var DeleteConfirmation_Title = styled_components_browser_esm["default"].h2(DeleteConfirmation_templateObject || (DeleteConfirmation_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-bottom: 10rem;\n\n  > span {\n    font-weight: normal;\n    font-style: italic;\n  }\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var Description = styled_components_browser_esm["default"].p(DeleteConfirmation_templateObject2 || (DeleteConfirmation_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-bottom: 40rem;\n  font-weight: normal;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var DeleteConfirmation_Container = styled_components_browser_esm["default"].div(DeleteConfirmation_templateObject3 || (DeleteConfirmation_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  > button {\n    margin-bottom: 20rem;\n  }\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(DeleteConfirmation_templateObject4 || (DeleteConfirmation_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    > button {\n      margin-bottom: 0;\n    }\n  "]))));
var Cancel = styled_components_browser_esm["default"].span(DeleteConfirmation_templateObject5 || (DeleteConfirmation_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " font-weight: bold;\n  color: ", ";\n  cursor: pointer;\n  margin-left: ", "rem;\n  font-size: 18rem;\n  transition: color 0.2s ease-in-out;\n\n  &:hover {\n    color: ", ";\n  }\n\n  ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.blue */.K5.blue, function (props) {
  return props.lastOne ? 0 : 20;
}, styleGuide/* colorPalette.darkBlue */.K5.darkBlue, breakpoints/* fromBreakpoint.md */.ks.md(DeleteConfirmation_templateObject6 || (DeleteConfirmation_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 20rem;\n  "]))));
/* harmony default export */ var designElements_DeleteConfirmation = (DeleteConfirmation);
;// CONCATENATED MODULE: ./src/components/DeleteWishListModal.js






var DeleteWishListModal_jsx = react.createElement;

function DeleteWishListModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, DeleteWishListModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function DeleteWishListModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (DeleteWishListModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}









var DeleteWishListModal_mapStateToProps = function mapStateToProps(state, ownProps) {
  var wishListId = ownProps.wishListId;
  return {
    resultWishList: (0,apiData/* getResultData */.yh)(state.apiData, 'duplicateWishList', {
      projectSlug: String(ownProps.match.params.projectSlug),
      wishListId: wishListId
    }),
    duplicateWishListRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'duplicateWishList', {
      projectSlug: String(ownProps.match.params.projectSlug),
      wishListId: wishListId
    }),
    deleteWishListRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'deleteWishList', {
      projectSlug: String(ownProps.match.params.projectSlug),
      wishListId: wishListId
    })
  };
};

var DeleteWishListModal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    deleteDef: function deleteDef(projectSlug, wishListId) {
      dispatch((0,apiData/* performApiRequest */.T4)('deleteWishList', {
        projectSlug: projectSlug,
        wishListId: wishListId
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getWishLists', {
        projectSlug: projectSlug
      }));
      setTimeout(function () {
        dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
        dispatch((0,redux_modal/* clearModalState */.TR)());
      }, 500);
    },
    copyDef: function copyDef(projectSlug, wishListId) {
      dispatch((0,apiData/* performApiRequest */.T4)('duplicateWishList', {
        projectSlug: String(projectSlug),
        wishListId: wishListId
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getWishLists', {
        projectSlug: String(projectSlug)
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('duplicateWishList', {
        projectSlug: projectSlug,
        wishListId: wishListId
      }));
    },
    onClose: function onClose() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var DeleteWishListModal = /*#__PURE__*/function (_Component) {
  function DeleteWishListModal() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, DeleteWishListModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = DeleteWishListModal_callSuper(this, DeleteWishListModal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "deleteWishList", function () {
      var _this$props = _this.props,
          deleteDef = _this$props.deleteDef,
          projectSlug = _this$props.projectSlug,
          wishListId = _this$props.wishListId;
      deleteDef(projectSlug, wishListId);
    });

    (0,defineProperty/* default */.Z)(_this, "copyWishList", function () {
      var _this$props2 = _this.props,
          copyDef = _this$props2.copyDef,
          projectSlug = _this$props2.projectSlug,
          wishListId = _this$props2.wishListId;
      copyDef(projectSlug, wishListId);
    });

    (0,defineProperty/* default */.Z)(_this, "closeModal", function () {
      _this.props.onClose();
    });

    return _this;
  }

  (0,inherits/* default */.Z)(DeleteWishListModal, _Component);

  return (0,createClass/* default */.Z)(DeleteWishListModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          duplicateWishListRequest = _this$props3.duplicateWishListRequest,
          resultWishList = _this$props3.resultWishList,
          match = _this$props3.match,
          router = _this$props3.router;

      if ((duplicateWishListRequest === null || duplicateWishListRequest === void 0 ? void 0 : duplicateWishListRequest.networkStatus) === 'success') {
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed/homestudio/").concat(resultWishList.id));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          deleteWishListRequest = _this$props4.deleteWishListRequest,
          duplicateWishListRequest = _this$props4.duplicateWishListRequest;
      var lastOwnWishlist = this.props.bnr === this.props.ownBNR && this.props.ownBNRWishlists === 1;
      var duplicateIsLoading = (duplicateWishListRequest === null || duplicateWishListRequest === void 0 ? void 0 : duplicateWishListRequest.networkStatus) === 'ready';
      var deleteIsLoading = (deleteWishListRequest === null || deleteWishListRequest === void 0 ? void 0 : deleteWishListRequest.networkStatus) === 'loading';
      return DeleteWishListModal_jsx(designElements_ModalInnerWrapper, {
        "data-id": "components_DeleteWishListModal_ModalInnerWrapper"
      }, lastOwnWishlist && this.props.type === 'delete' && DeleteWishListModal_jsx(designElements_DeleteConfirmation, {
        title: "Dit is het laatste ontwerp van jouw woning",
        description: "Daarom kan je dit ontwerp niet verwijderen.",
        submitButtonLabel: "OK",
        lastOne: lastOwnWishlist,
        submitFn: this.closeModal,
        "data-id": "components_DeleteWishListModal_DeleteConfirmation"
      }), !lastOwnWishlist && this.props.type === 'delete' && DeleteWishListModal_jsx(designElements_DeleteConfirmation, {
        title: "Weet je zeker dat je het woonontwerp \u2018<span>".concat(this.props.title, "</span>\u2019 wilt verwijderen?"),
        description: "Deze actie kan niet ongedaan worden gemaakt.",
        submitButtonLabel: "Verwijderen",
        submitFn: this.deleteWishList,
        cancelButtonLabel: "Annuleren",
        cancelFn: this.closeModal,
        loading: deleteIsLoading,
        disabled: deleteIsLoading,
        "data-id": "components_DeleteWishListModal_DeleteConfirmation_2"
      }), this.props.type === 'confirmation' && DeleteWishListModal_jsx(designElements_DeleteConfirmation, {
        title: "Helaas, deze woning is niet meer beschikbaar",
        description: "Deze woning is verkocht en inmiddels gekoppeld aan een toekomstig bewoner. Om die reden kun je woonontwerpen die je voor deze woning hebt gemaakt niet meer bewerken. Kies voor 'Maak een nieuw woonontwerp' om de mogelijkheden van andere woningen te bekijken en ontdek welke woning het beste bij je past.",
        submitButtonLabel: "Ik begrijp het",
        submitFn: this.closeModal,
        "data-id": "components_DeleteWishListModal_DeleteConfirmation_3"
      }), this.props.type === 'copy' && DeleteWishListModal_jsx(designElements_DeleteConfirmation, {
        title: "Je staat op het punt om een kopie te maken van het woonontwerp \u2018<span>".concat(this.props.title, "</span>\u2019"),
        description: "Hiermee gebruik je alle opties en woonwensen die je in dit ontwerp hebt opgeslagen om een nieuw ontwerp te starten.",
        submitButtonLabel: "Kopi\xEBren",
        submitFn: this.copyWishList,
        cancelButtonLabel: "Annuleren",
        cancelFn: this.closeModal,
        loading: duplicateIsLoading,
        disabled: duplicateIsLoading,
        "data-id": "components_DeleteWishListModal_DeleteConfirmation_4"
      }));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_DeleteWishListModal = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(DeleteWishListModal_mapStateToProps, DeleteWishListModal_mapDispatchToProps)(DeleteWishListModal)));
;// CONCATENATED MODULE: ./src/components/shared/icons/Like.js
var Like_jsx = react.createElement;


var Like_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white,
  width: 27,
  height: 31
};

var Like = function Like(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Like_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 27 31",
    "data-id": "icons_Like_svg"
  }, Like_jsx("title", {
    "data-id": "icons_Like_title"
  }, "Like Thumb"), Like_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-111.000000, -39.000000)",
    "data-id": "icons_Like_g"
  }, Like_jsx("g", {
    transform: "translate(95.000000, 26.000000)",
    fill: color,
    "data-id": "icons_Like_g_3"
  }, Like_jsx("path", {
    d: "M16.0121585,30.9076071 C16.1401432,29.6512248 17.2621416,28.7340017 18.520657,28.8619864 L21.9293138,29.2096779 L21.9421123,29.1094233 L19.2395039,28.8342564 C18.1388362,28.7233364 17.3495977,27.6120033 17.4775824,26.3534879 C17.6077001,25.0949726 18.6017139,24.1670841 19.7023816,24.2801372 L28.7508937,25.2016264 L30.035006,25.2208241 C30.035006,25.2208241 28.177096,24.3782587 29.6041245,17.6590665 C31.0290198,10.9420074 34.7917675,13.4633043 34.7917675,13.4633043 C34.7917675,13.4633043 34.8408282,19.2034142 35.0434705,20.0182496 C35.2482459,20.8309519 39.661582,29.4208525 39.661582,29.4208525 C39.661582,29.8751979 42.3961866,30.3295433 42.3940535,30.7860217 C42.3620573,34.7364801 42.3940535,38.1152739 42.3940535,42.2065154 C39.4610728,41.4386077 37.8932613,43.7423307 31.6262814,43.7423307 C29.5806606,43.7423307 27.0209684,43.4074377 24.8665607,43.0512138 L19.2267054,42.4774161 C18.2476231,42.3771615 17.5607724,41.2764938 17.6866239,40.0179785 C17.7868785,39.0474285 18.3500108,38.2795208 19.0517931,38.0214185 L18.3414785,37.9488939 C17.2237462,37.8337077 16.4195762,36.7245078 16.5475608,35.4659924 C16.6606139,34.3866555 17.4285216,33.595284 18.3457447,33.4481017 L18.0577793,33.4203717 C16.7992639,33.290254 15.8841739,32.1661225 16.0121585,30.9076071",
    "data-id": "icons_Like_path"
  }))));
};

Like.defaultProps = Like_defaultProps;
/* harmony default export */ var icons_Like = (Like);
;// CONCATENATED MODULE: ./src/components/dashboard/ECWInterestModal.js


var ECWInterestModal_templateObject, ECWInterestModal_templateObject2, ECWInterestModal_templateObject3, ECWInterestModal_templateObject4, ECWInterestModal_templateObject5, ECWInterestModal_templateObject6, ECWInterestModal_templateObject7, ECWInterestModal_templateObject8, ECWInterestModal_templateObject9, ECWInterestModal_templateObject0, ECWInterestModal_templateObject1, ECWInterestModal_templateObject10, ECWInterestModal_templateObject11, ECWInterestModal_templateObject12, ECWInterestModal_templateObject13;

var ECWInterestModal_jsx = react.createElement;






var ECWInterestModal_connectApiData = (0,withApiData/* default */.Z)({
  hotspotOptions: 'getHotspotOptions'
}, function (ownProps) {
  var hotspotId = ownProps.hotspotId;
  return {
    hotspotOptions: {
      hotspotId: hotspotId
    },
    options: {
      cache: 'disabled'
    }
  };
});

var ECWInterestModal = function ECWInterestModal(_ref) {
  var hotspotId = _ref.hotspotId,
      color = _ref.color,
      hotspotOptions = _ref.hotspotOptions;
  var optionData = hotspotOptions && hotspotOptions.data;
  return optionData ? ECWInterestModal_jsx(ECWInterestModal_Container, {
    "data-id": "dashboard_ECWInterestModal_Container"
  }, ECWInterestModal_jsx(ECWInterestModal_Title, {
    color: color,
    "data-id": "dashboard_ECWInterestModal_Title"
  }, optionData.title), ECWInterestModal_jsx(SubTitle, {
    "data-id": "dashboard_ECWInterestModal_SubTitle"
  }, "Bekijk hieronder de voorkeuren die je in het Homestudios experience center over dit onderwerp hebt bewaard. Ben je nog niet in het experience center geweest? Dan kun je hier alvast bekijken over welke onderwerpen je straks meer kunt ontdekken, ervaren en kunt leren in de Kennisstudio."), ECWInterestModal_jsx(Preferences, {
    "data-id": "dashboard_ECWInterestModal_Preferences"
  }, ECWInterestModal_jsx(PreferenceTitles, {
    color: color,
    "data-id": "dashboard_ECWInterestModal_PreferenceTitles"
  }, ECWInterestModal_jsx("div", {
    "data-id": "dashboard_ECWInterestModal_div"
  }, ECWInterestModal_jsx(icons_Like, {
    color: color,
    width: 16,
    height: 19,
    "data-id": "dashboard_ECWInterestModal_Like"
  }), "Niets voor mij"), ECWInterestModal_jsx("div", {
    "data-id": "dashboard_ECWInterestModal_div"
  }, ECWInterestModal_jsx(icons_Like, {
    color: color,
    width: 16,
    height: 19,
    "data-id": "dashboard_ECWInterestModal_Like"
  }), "Iets voor mij")), (optionData.optionGroups || []).map(function (optionGroup, index) {
    return (optionGroup.options || []).map(function (option, index) {
      return ECWInterestModal_jsx(OptionContainer, {
        key: index,
        rating: option.customerRating,
        "data-id": "dashboard_ECWInterestModal_OptionContainer"
      }, option.title);
    });
  }))) : null;
};

/* harmony default export */ var dashboard_ECWInterestModal = (ECWInterestModal_connectApiData(ECWInterestModal));
var ECWInterestModal_Container = styled_components_browser_esm["default"].div(ECWInterestModal_templateObject || (ECWInterestModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #fff;\n  padding: 20rem 20rem 40rem 20rem;\n  ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestModal_templateObject2 || (ECWInterestModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 70rem 60rem 70rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ECWInterestModal_templateObject3 || (ECWInterestModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 200rem 80rem 200rem;\n  "]))));
var ECWInterestModal_Title = styled_components_browser_esm["default"].h3(ECWInterestModal_templateObject4 || (ECWInterestModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 18rem;\n  margin-top: 0;\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, function (props) {
  return props.color;
}, breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestModal_templateObject5 || (ECWInterestModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 28rem;\n  "]))));
var SubTitle = styled_components_browser_esm["default"].h4(ECWInterestModal_templateObject6 || (ECWInterestModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  width: 100%;\n  color: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  line-height: 24rem;\n  margin-top: 0;\n  text-align: center;\n  ", ";\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestModal_templateObject7 || (ECWInterestModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 22rem;\n    line-height: 30rem;\n  "]))));
var Preferences = styled_components_browser_esm["default"].div(ECWInterestModal_templateObject8 || (ECWInterestModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 600rem;\n  min-height: 200rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 74rem;\n  box-sizing: border-box;\n  ", " &:after {\n    content: '';\n    width: 1rem;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    background-color: ", ";\n  }\n\n  &:before {\n    content: '';\n    height: 1rem;\n    position: absolute;\n    top: 40rem;\n    left: 0;\n    right: 0;\n    background-color: ", ";\n    ", ";\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestModal_templateObject9 || (ECWInterestModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-bottom: 114rem;\n  "]))), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, styleGuide/* colorPalette.lightBeige */.K5.lightBeige, breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestModal_templateObject0 || (ECWInterestModal_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: 50rem;\n    "]))));
var PreferenceTitles = styled_components_browser_esm["default"].div(ECWInterestModal_templateObject1 || (ECWInterestModal_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-size: 14rem;\n  line-height: 20rem;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 40rem;\n  margin-bottom: 25rem;\n  ", ";\n\n  > div {\n    display: flex;\n    align-items: center;\n    &:nth-of-type(1) {\n      svg {\n        transform: scale(1) rotate(180deg);\n      }\n    }\n    > svg {\n      margin-right: 4rem;\n      ", ";\n    }\n  }\n"])), styleGuide/* textStyles.title */.sq.title, function (props) {
  return props.color;
}, breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestModal_templateObject10 || (ECWInterestModal_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 22rem;\n    line-height: 30rem;\n    height: 50rem;\n    margin-bottom: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestModal_templateObject11 || (ECWInterestModal_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n        margin-right: 12rem;\n      "]))));
var OptionContainer = styled_components_browser_esm["default"].div(ECWInterestModal_templateObject12 || (ECWInterestModal_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 30rem;\n  width: 142rem;\n  margin-bottom: 16rem;\n  border-radius: 20px;\n  z-index: 1;\n  box-sizing: border-box;\n  padding: 15rem;\n  align-self: ", ";\n  ", ";\n  font-size: 12rem;\n  line-height: 18rem;\n  background-color: ", ";\n  color: white;\n  font-weight: bold;\n  text-align: center;\n\n  ", ";\n"])), function (props) {
  return props.rating === 1 || props.rating === null ? 'center' : props.rating === 0 ? 'flex-start' : 'flex-end';
}, styleGuide/* textStyles.standardText */.sq.standardText, styleGuide/* colorPalette.blue */.K5.blue, breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestModal_templateObject13 || (ECWInterestModal_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 188rem;\n    min-height: 40rem;\n    font-size: 16rem;\n    line-height: 24rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/dashboard/EditProfileModal.js







var EditProfileModal_templateObject, EditProfileModal_templateObject2, EditProfileModal_templateObject3, EditProfileModal_templateObject4, EditProfileModal_templateObject5;

var EditProfileModal_jsx = react.createElement;

function EditProfileModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, EditProfileModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function EditProfileModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (EditProfileModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}








var EditProfileModal = /*#__PURE__*/function (_Component) {
  function EditProfileModal() {
    (0,classCallCheck/* default */.Z)(this, EditProfileModal);

    return EditProfileModal_callSuper(this, EditProfileModal, arguments);
  }

  (0,inherits/* default */.Z)(EditProfileModal, _Component);

  return (0,createClass/* default */.Z)(EditProfileModal, [{
    key: "render",
    value: function render() {
      var _this = this;

      var changedFields = [];
      Object.keys(this.props.values).map(function (value) {
        return _this.props.form.filter(function (cat) {
          if (cat.options.find(function (option) {
            return option.name === value;
          }) && value !== 'users') {
            changedFields.push(cat.options.find(function (option) {
              return option.name === value;
            }));
          }

          return changedFields;
        });
      });
      return EditProfileModal_jsx(EditProfileModal_Container, {
        "data-id": "dashboard_EditProfileModal_Container"
      }, EditProfileModal_jsx(EditProfileModal_Title, {
        "data-id": "dashboard_EditProfileModal_Title"
      }, "Gelukt!"), EditProfileModal_jsx(EditProfileModal_Description, {
        "data-id": "dashboard_EditProfileModal_Description"
      }, "Je hebt de volgende profielgegevens aangepast:"), changedFields.map(function (field, index) {
        return EditProfileModal_jsx(BBCode/* default */.Z, {
          key: index,
          content: {
            content: "[ul][li]".concat(String(lodash_get_default()(field, 'label')), "[/ul][/li]")
          },
          "data-id": "dashboard_EditProfileModal_BBCode"
        });
      }));
    }
  }]);
}(react.Component);

var EditProfileModal_Container = styled_components_browser_esm["default"].div(EditProfileModal_templateObject || (EditProfileModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  background-color: #fff;\n  padding: 80rem 200rem 80rem 200rem;\n\n  ", " ", "\n\n  > div {\n    margin-bottom: -12rem;\n  }\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* toBreakpoint.lg */.Hx.lg(EditProfileModal_templateObject2 || (EditProfileModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 70rem 60rem 70rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(EditProfileModal_templateObject3 || (EditProfileModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 40rem 30rem 40rem 30rem;\n  "]))));
var EditProfileModal_Title = styled_components_browser_esm["default"].h2(EditProfileModal_templateObject4 || (EditProfileModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-bottom: 10rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var EditProfileModal_Description = styled_components_browser_esm["default"].p(EditProfileModal_templateObject5 || (EditProfileModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-bottom: 30rem;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.textGrey */.K5.textGrey);
/* harmony default export */ var dashboard_EditProfileModal = (EditProfileModal);
;// CONCATENATED MODULE: ./src/components/FeedbackModal.js








var FeedbackModal_templateObject, FeedbackModal_templateObject2, FeedbackModal_templateObject3, FeedbackModal_templateObject4, FeedbackModal_templateObject5, FeedbackModal_templateObject6, FeedbackModal_templateObject7;

var FeedbackModal_jsx = react.createElement;

function FeedbackModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, FeedbackModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function FeedbackModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (FeedbackModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function FeedbackModal_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function FeedbackModal_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? FeedbackModal_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FeedbackModal_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var FeedbackModal_mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    feedbackResponseData: (0,apiData/* getResultData */.yh)(state.apiData, 'patchFeedback', {
      projectSlug: String(projectSlug),
      feedbackId: ownProps.feedbackId
    })
  };
};

var FeedbackModal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    patchFeedback: function patchFeedback(projectSlug, feedbackId, feedbackValues) {
      dispatch((0,apiData/* performApiRequest */.T4)('patchFeedback', {
        projectSlug: projectSlug,
        feedbackId: feedbackId
      }, FeedbackModal_objectSpread({}, feedbackValues)));
    },
    onClose: function onClose() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var FeedbackModal = /*#__PURE__*/function (_Component) {
  function FeedbackModal() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, FeedbackModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = FeedbackModal_callSuper(this, FeedbackModal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      stepOne: true,
      isLoading: false,
      stepOneFadeOut: false,
      stepTwoFadeIn: false
    });

    (0,defineProperty/* default */.Z)(_this, "handleSubmit", function (_ref) {
      var comment = _ref.comment;

      _this.setState({
        isLoading: true
      });

      var _this$props = _this.props,
          match = _this$props.match,
          patchFeedback = _this$props.patchFeedback,
          feedbackId = _this$props.feedbackId;
      var projectSlug = String(match.params.projectSlug);
      patchFeedback(projectSlug, feedbackId, {
        comment: comment
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(FeedbackModal, _Component);

  return (0,createClass/* default */.Z)(FeedbackModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.feedbackResponseData && this.state.isLoading) {
        this.setState({
          isLoading: false
        });
        this.goToStepTwo();
      }
    }
  }, {
    key: "goToStepTwo",
    value: function goToStepTwo() {
      var _this2 = this;

      this.setState({
        stepOneFadeOut: true
      });
      setTimeout(function () {
        _this2.setState({
          stepOne: false
        });
      }, 300);
      setTimeout(function () {
        _this2.setState({
          stepTwoFadeIn: true
        });
      }, 500);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          positive = _this$props2.positive,
          negative = _this$props2.negative,
          feedbackType = _this$props2.feedbackType,
          thanks = _this$props2.thanks,
          onClose = _this$props2.onClose;
      var isLike = feedbackType === 'like';
      var feedbackForm = [{
        options: [{
          id: 'comment',
          name: 'comment',
          required: !isLike,
          title: 'Beschrijf je ervaring hier',
          validationMessage: 'Vul hier a.u.b. je ervaring in',
          type: 'textarea'
        }]
      }];
      return FeedbackModal_jsx(FeedbackModal_Container, {
        "data-id": "components_FeedbackModal_Container"
      }, this.state.stepOne ? FeedbackModal_jsx(CommentContainer, {
        fadeOut: this.state.stepOneFadeOut,
        "data-id": "components_FeedbackModal_CommentContainer"
      }, FeedbackModal_jsx(FeedbackModal_Title, {
        "data-id": "components_FeedbackModal_Title"
      }, isLike ? positive.title : negative.title), FeedbackModal_jsx(FeedbackModal_IntroText, {
        "data-id": "components_FeedbackModal_IntroText"
      }, isLike ? positive.description : negative.description), FeedbackModal_jsx(FormGenerator/* default */.Z, {
        fields: feedbackForm,
        submitLabel: "Verstuur",
        loading: this.state.isLoading,
        loadingLabel: "aanvraag wordt verwerkt",
        submitFn: this.handleSubmit,
        "data-id": "components_FeedbackModal_FormGenerator"
      })) : FeedbackModal_jsx(ThanksContainer, {
        fadeIn: this.state.stepTwoFadeIn,
        "data-id": "components_FeedbackModal_ThanksContainer"
      }, FeedbackModal_jsx(FeedbackModal_Title, {
        "data-id": "components_FeedbackModal_Title"
      }, thanks.title), FeedbackModal_jsx(FeedbackModal_IntroText, {
        "data-id": "components_FeedbackModal_IntroText"
      }, thanks.description), FeedbackModal_jsx(ButtonPrimary/* default */.Z, {
        label: "Sluit",
        type: "button",
        clickHandler: onClose,
        "data-id": "components_FeedbackModal_ButtonPrimary"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_FeedbackModal = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(FeedbackModal_mapStateToProps, FeedbackModal_mapDispatchToProps)(FeedbackModal)));
var FeedbackModal_Container = styled_components_browser_esm["default"].div(FeedbackModal_templateObject || (FeedbackModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  background-color: #fff;\n  padding: 80rem 200rem 80rem 200rem;\n\n  ", " ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* toBreakpoint.lg */.Hx.lg(FeedbackModal_templateObject2 || (FeedbackModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 70rem 60rem 70rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(FeedbackModal_templateObject3 || (FeedbackModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 40rem 30rem 40rem 30rem;\n  "]))));
var FeedbackModal_Title = styled_components_browser_esm["default"].h3(FeedbackModal_templateObject4 || (FeedbackModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var FeedbackModal_IntroText = styled_components_browser_esm["default"].div(FeedbackModal_templateObject5 || (FeedbackModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 10rem;\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var CommentContainer = styled_components_browser_esm["default"].div(FeedbackModal_templateObject6 || (FeedbackModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  transition: opacity 0.3s ease-out;\n  opacity: ", ";\n"])), function (props) {
  return props.fadeOut ? '0' : '1';
});
var ThanksContainer = styled_components_browser_esm["default"].div(FeedbackModal_templateObject7 || (FeedbackModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  transition: opacity 0.3s ease-in;\n  opacity: ", ";\n\n  ", " {\n    margin-bottom: 40rem;\n  }\n"])), function (props) {
  return props.fadeIn ? '1' : '0';
}, FeedbackModal_IntroText);
;// CONCATENATED MODULE: ./src/components/FirstWelcomeWishlistModal.js


var FirstWelcomeWishlistModal_templateObject, FirstWelcomeWishlistModal_templateObject2, FirstWelcomeWishlistModal_templateObject3, FirstWelcomeWishlistModal_templateObject4, FirstWelcomeWishlistModal_templateObject5, FirstWelcomeWishlistModal_templateObject6;

var FirstWelcomeWishlistModal_jsx = react.createElement;








var FirstWelcomeWishlistModal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var FirstWelcomeWishlistModal = function FirstWelcomeWishlistModal(_ref) {
  var onClose = _ref.onClose;
  return FirstWelcomeWishlistModal_jsx(FirstWelcomeWishlistModal_Container, {
    "data-id": "components_FirstWelcomeWishlistModal_Container"
  }, FirstWelcomeWishlistModal_jsx(FirstWelcomeWishlistModal_Title, {
    "data-id": "components_FirstWelcomeWishlistModal_Title"
  }, "Jouw wensen in een woonontwerp"), FirstWelcomeWishlistModal_jsx(react.Fragment, null, FirstWelcomeWishlistModal_jsx(FirstWelcomeWishlistModal_IntroText, {
    "data-id": "components_FirstWelcomeWishlistModal_IntroText"
  }, "Doe alsof je thuis bent en begin direct met het maken van je eerste woonontwerp."), FirstWelcomeWishlistModal_jsx(FirstWelcomeWishlistModal_Text, {
    "data-id": "components_FirstWelcomeWishlistModal_Text"
  }, "Met woonontwerpen maak je keuzes uit alle mogelijkheden van je favoriete woning(en). Bij alle keuzes zie je direct wat de gevolgen zijn voor de ruimte, het aantal slaapkamers (wanneer van toepassing) en de totale investering voor de woning."), FirstWelcomeWishlistModal_jsx(FirstWelcomeWishlistModal_Text, {
    "data-id": "components_FirstWelcomeWishlistModal_Text_4"
  }, FirstWelcomeWishlistModal_jsx("em", {
    "data-id": "components_FirstWelcomeWishlistModal_em"
  }, "Tip:"), " maak woonontwerpen voor meerdere bouwnummers en verschillende woontypes, deel ze met familie en vrienden. Of neem ze mee naar de makelaar of hypotheekadviseur. Gebruik ze om voorbij de vrij-op-naam-prijs en vierkante meters te kijken, zodat je een bewuste keuze kunt maken voor de woning die het beste bij je past!")), FirstWelcomeWishlistModal_jsx(ButtonPrimary/* default */.Z, {
    label: "Start met ontwerpen",
    type: "button",
    clickHandler: onClose,
    "data-id": "components_FirstWelcomeWishlistModal_ButtonPrimary"
  }));
};

/* harmony default export */ var components_FirstWelcomeWishlistModal = ((0,es/* connect */.$j)(null, FirstWelcomeWishlistModal_mapDispatchToProps)(FirstWelcomeWishlistModal));
var FirstWelcomeWishlistModal_Container = styled_components_browser_esm["default"].div(FirstWelcomeWishlistModal_templateObject || (FirstWelcomeWishlistModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 20rem 20rem 40rem 20rem;\n\n  ", ";\n\n  ", ";\n\n  > button {\n    margin-top: 20rem;\n  }\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* fromBreakpoint.md */.ks.md(FirstWelcomeWishlistModal_templateObject2 || (FirstWelcomeWishlistModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 70rem 60rem 70rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(FirstWelcomeWishlistModal_templateObject3 || (FirstWelcomeWishlistModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 200rem 80rem 200rem;\n  "]))));
var FirstWelcomeWishlistModal_Title = styled_components_browser_esm["default"].h3(FirstWelcomeWishlistModal_templateObject4 || (FirstWelcomeWishlistModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var FirstWelcomeWishlistModal_IntroText = styled_components_browser_esm["default"].div(FirstWelcomeWishlistModal_templateObject5 || (FirstWelcomeWishlistModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n\n  > span {\n    font-style: italic;\n  }\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var FirstWelcomeWishlistModal_Text = styled_components_browser_esm["default"].p(FirstWelcomeWishlistModal_templateObject6 || (FirstWelcomeWishlistModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
;// CONCATENATED MODULE: ./src/components/FirstWelcomeCJ2Modal.js








var FirstWelcomeCJ2Modal_templateObject, FirstWelcomeCJ2Modal_templateObject2, FirstWelcomeCJ2Modal_templateObject3, FirstWelcomeCJ2Modal_templateObject4, FirstWelcomeCJ2Modal_templateObject5, FirstWelcomeCJ2Modal_templateObject6, FirstWelcomeCJ2Modal_templateObject7, FirstWelcomeCJ2Modal_templateObject8;

var FirstWelcomeCJ2Modal_jsx = react.createElement;

function FirstWelcomeCJ2Modal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, FirstWelcomeCJ2Modal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function FirstWelcomeCJ2Modal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (FirstWelcomeCJ2Modal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}












var FirstWelcomeCJ2Modal_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    patchUserProfile: function patchUserProfile(customerName, customerIntro, anonymous) {
      var projectSlug = ownProps.match.params.projectSlug;
      dispatch((0,apiData/* performApiRequest */.T4)('patchProfile', {
        projectSlug: String(projectSlug)
      }, {
        customerName: customerName,
        bio: customerIntro,
        anonymous: anonymous
      }));
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var FirstWelcomeCJ2Modal = /*#__PURE__*/function (_Component) {
  function FirstWelcomeCJ2Modal() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, FirstWelcomeCJ2Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = FirstWelcomeCJ2Modal_callSuper(this, FirstWelcomeCJ2Modal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      stepOne: true,
      stepOneFadeOut: false,
      stepTwoFadeIn: false
    });

    (0,defineProperty/* default */.Z)(_this, "goToStepTwo", function () {
      _this.setState({
        stepOneFadeOut: true
      });

      setTimeout(function () {
        _this.setState({
          stepOne: false
        });
      }, 300);
      setTimeout(function () {
        _this.setState({
          stepTwoFadeIn: true
        });
      }, 500);
    });

    (0,defineProperty/* default */.Z)(_this, "handleSubmit", function (values) {
      _this.props.patchUserProfile(values.customerName, values.customerIntro, values.anonymous);
    });

    return _this;
  }

  (0,inherits/* default */.Z)(FirstWelcomeCJ2Modal, _Component);

  return (0,createClass/* default */.Z)(FirstWelcomeCJ2Modal, [{
    key: "render",
    value: function render() {
      var profileForm = [{
        options: [{
          id: 'customerName',
          name: 'customerName',
          required: true,
          title: 'Naam van het huishouden',
          type: 'text'
        }, {
          id: 'customerImage',
          name: 'customerImage',
          label: 'Foto van het huishouden',
          title: 'Foto van het huishouden',
          type: 'imageUpload',
          required: false,
          excludeFromSubmit: true,
          uploadType: 'customer'
        }, {
          id: 'customerIntro',
          name: 'customerIntro',
          required: false,
          title: 'Introductie van het huishouden',
          type: 'textarea'
        }, {
          id: 'anonymous',
          name: 'anonymous',
          required: false,
          title: '',
          type: 'checkbox',
          choices: [{
            key: 'anonymous',
            value: 'Door deze optie aan te vinken, tonen we alleen je bouwnummer op de pagina buren en wanneer je op het forum reageert. Je kunt deze instellingen altijd wijzigen bij je profiel.',
            defaultChecked: false
          }]
        }]
      }];
      return FirstWelcomeCJ2Modal_jsx(FirstWelcomeCJ2Modal_Container, {
        "data-id": "components_FirstWelcomeCJ2Modal_Container"
      }, this.state.stepOne ? FirstWelcomeCJ2Modal_jsx(ContentStepOne, {
        fadeOut: this.state.stepOneFadeOut,
        "data-id": "components_FirstWelcomeCJ2Modal_ContentStepOne"
      }, FirstWelcomeCJ2Modal_jsx(FirstWelcomeCJ2Modal_Title, {
        "data-id": "components_FirstWelcomeCJ2Modal_Title"
      }, "Account geactiveerd!"), FirstWelcomeCJ2Modal_jsx(FirstWelcomeCJ2Modal_IntroText, {
        "data-id": "components_FirstWelcomeCJ2Modal_IntroText"
      }, "Je online Mijn Homestudios omgeving is vanaf nu uitgebreid met een aantal handige functies."), FirstWelcomeCJ2Modal_jsx(FirstWelcomeCJ2Modal_Text, {
        "data-id": "components_FirstWelcomeCJ2Modal_Text"
      }, "Zo kun je vanaf nu via het berichtencentrum direct communiceren met de woonadviseur en bewaar je alle belangrijke documenten - die nu eenmaal horen bij het kopen van een nieuw huis - overzichtelijk op \xE9\xE9n plaats. Je kunt nog steeds woonontwerpen maken, maar deze zijn nu volledig gericht op het bouwnummer dat je hebt gekocht. De optimale voorbereiding voor het eerste bezoek aan het Homestudios experience center. Hoog tijd om van je nieuwe huis ook echt een thuis te gaan maken!"), FirstWelcomeCJ2Modal_jsx(ButtonPrimary/* default */.Z, {
        label: "Volgende",
        type: "button",
        clickHandler: this.goToStepTwo,
        "data-id": "components_FirstWelcomeCJ2Modal_ButtonPrimary"
      })) : FirstWelcomeCJ2Modal_jsx(ContentStepTwo, {
        fadeIn: this.state.stepTwoFadeIn,
        "data-id": "components_FirstWelcomeCJ2Modal_ContentStepTwo"
      }, FirstWelcomeCJ2Modal_jsx(FirstWelcomeCJ2Modal_Title, {
        "data-id": "components_FirstWelcomeCJ2Modal_Title"
      }, "Het huishouden van..."), FirstWelcomeCJ2Modal_jsx(FirstWelcomeCJ2Modal_IntroText, {
        "data-id": "components_FirstWelcomeCJ2Modal_IntroText"
      }, "Gebruik de velden hieronder om je huishouden alvast voor te stellen. Aan ons, \xE9n aan de toekomstige buren."), FirstWelcomeCJ2Modal_jsx(FirstWelcomeCJ2Modal_Text, {
        "data-id": "components_FirstWelcomeCJ2Modal_Text"
      }, "De informatie die je hier invult, is te zien op de pagina 'Buren' en op het forum. Blijf je liever nog even anoniem? Vink dan de optie 'anoniem blijven' aan. Je bouwnummer is dan het enige dat zichtbaar is voor anderen."), FirstWelcomeCJ2Modal_jsx(FormGenerator/* default */.Z, {
        fields: profileForm,
        submitLabel: "Opslaan",
        loadingLabel: "aanvraag wordt verwerkt",
        submitFn: this.handleSubmit,
        "data-id": "components_FirstWelcomeCJ2Modal_FormGenerator"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_FirstWelcomeCJ2Modal = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(null, FirstWelcomeCJ2Modal_mapDispatchToProps)(FirstWelcomeCJ2Modal)));
var ContentStepOne = styled_components_browser_esm["default"].div(FirstWelcomeCJ2Modal_templateObject || (FirstWelcomeCJ2Modal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  transition: opacity 0.3s ease-out;\n  opacity: ", ";\n"])), function (props) {
  return props.fadeOut ? '0' : '1';
});
var ContentStepTwo = styled_components_browser_esm["default"].div(FirstWelcomeCJ2Modal_templateObject2 || (FirstWelcomeCJ2Modal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  transition: opacity 0.3s ease-in;\n  opacity: ", ";\n"])), function (props) {
  return props.fadeIn ? '1' : '0';
});
var FirstWelcomeCJ2Modal_IntroText = styled_components_browser_esm["default"].div(FirstWelcomeCJ2Modal_templateObject3 || (FirstWelcomeCJ2Modal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 10rem;\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var FirstWelcomeCJ2Modal_Title = styled_components_browser_esm["default"].h3(FirstWelcomeCJ2Modal_templateObject4 || (FirstWelcomeCJ2Modal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var FirstWelcomeCJ2Modal_Text = styled_components_browser_esm["default"].p(FirstWelcomeCJ2Modal_templateObject5 || (FirstWelcomeCJ2Modal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var FirstWelcomeCJ2Modal_Container = styled_components_browser_esm["default"].div(FirstWelcomeCJ2Modal_templateObject6 || (FirstWelcomeCJ2Modal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 20rem 20rem 40rem 20rem;\n\n  ", "\n\n  ", "\n\n  ", " > button {\n    margin-top: 20rem;\n  }\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* fromBreakpoint.md */.ks.md(FirstWelcomeCJ2Modal_templateObject7 || (FirstWelcomeCJ2Modal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 70rem 60rem 70rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(FirstWelcomeCJ2Modal_templateObject8 || (FirstWelcomeCJ2Modal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 200rem 80rem 200rem;\n  "]))), ContentStepOne);
;// CONCATENATED MODULE: ./src/components/FirstWelcomeModal.js


var FirstWelcomeModal_templateObject, FirstWelcomeModal_templateObject2, FirstWelcomeModal_templateObject3, FirstWelcomeModal_templateObject4, FirstWelcomeModal_templateObject5, FirstWelcomeModal_templateObject6;

var FirstWelcomeModal_jsx = react.createElement;








var FirstWelcomeModal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var FirstWelcomeModal = function FirstWelcomeModal(_ref) {
  var onClose = _ref.onClose,
      type = _ref.type;
  var content;

  if (type === 'firstWelcomeCJ1') {
    content = {
      title: 'Welkom thuis!',
      intro: 'Welkom op het Mijn Homestudios dashboard, jouw uitvalsbasis op de weg naar je nieuwe thuis.',
      paragraphs: ['Het dashboard toont je altijd de meest actuele informatie; je vindt hier een overzicht van je favoriete of laatst bewerkte woonontwerpen, de volgende stappen op de projectplanning, actuele projectupdates en andere artikelen van Homestudios specialisten.', 'Vanuit de diverse onderdelen duik je verder de diepte in; via de planning heb je toegang tot de volledige projectplanning en via de meest recente artikelen ben je met één klik bij het overzicht van alle artikelen en projectupdates. Via het woonontwerpenoverzicht kun je jouw woonontwerpen in detail bekijken. Heb je nog geen woonontwerp gemaakt? Gebruik het blok dan om je eerste woonontwerp te starten en te ontdekken welke woning het beste bij je past.', 'Veel plezier!'],
      button: 'Aan de slag'
    };
  } else if (type === 'firstWelcomeCJ3') {
    content = {
      title: 'Welkom op Mijn Homestudios voor bewoners!',
      intro: 'Waarschijnlijk weet je inmiddels de weg op Mijn Homestudios, maar er is het één en ander veranderd op deze online omgeving voor bewoners.',
      paragraphs: ['De grootste verandering is de toevoeging van de pagina Bewonersinformatie. Hier vind je nuttige informatie over onderhoud, tips voor wanneer je nog gaat klussen en informatie over het melden van storingen en gebreken. En als bewoner van een woning van BAM Wonen houd je natuurlijk exclusief toegang tot de Homestudios webshop; handig voor wanneer je nieuwe interieur nog wat aanvulling kan gebruiken.', 'Veel woonplezier in je nieuwe woning gewenst!'],
      button: 'Aan de slag'
    };
  }

  return FirstWelcomeModal_jsx(FirstWelcomeModal_Container, {
    "data-id": "components_FirstWelcomeModal_Container"
  }, FirstWelcomeModal_jsx(FirstWelcomeModal_Title, {
    "data-id": "components_FirstWelcomeModal_Title"
  }, content && content.title), FirstWelcomeModal_jsx(react.Fragment, null, FirstWelcomeModal_jsx(FirstWelcomeModal_IntroText, {
    "data-id": "components_FirstWelcomeModal_IntroText"
  }, content && content.intro), (content && content.paragraphs || []).map(function (paragraph, index) {
    return FirstWelcomeModal_jsx(FirstWelcomeModal_Text, {
      key: index,
      "data-id": "components_FirstWelcomeModal_Text"
    }, paragraph);
  })), FirstWelcomeModal_jsx(ButtonPrimary/* default */.Z, {
    label: content && content.button,
    type: "button",
    clickHandler: onClose,
    "data-e2e-firsttimewelcome-modal-submit": true,
    "data-id": "components_FirstWelcomeModal_ButtonPrimary"
  }));
};

/* harmony default export */ var components_FirstWelcomeModal = ((0,es/* connect */.$j)(null, FirstWelcomeModal_mapDispatchToProps)(FirstWelcomeModal));
var FirstWelcomeModal_Container = styled_components_browser_esm["default"].div(FirstWelcomeModal_templateObject || (FirstWelcomeModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 20rem 20rem 40rem 20rem;\n\n  ", ";\n\n  ", ";\n\n  > button {\n    margin-top: 20rem;\n  }\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* fromBreakpoint.md */.ks.md(FirstWelcomeModal_templateObject2 || (FirstWelcomeModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 70rem 60rem 70rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(FirstWelcomeModal_templateObject3 || (FirstWelcomeModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 200rem 80rem 200rem;\n  "]))));
var FirstWelcomeModal_Title = styled_components_browser_esm["default"].h3(FirstWelcomeModal_templateObject4 || (FirstWelcomeModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var FirstWelcomeModal_IntroText = styled_components_browser_esm["default"].div(FirstWelcomeModal_templateObject5 || (FirstWelcomeModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n\n  > span {\n    font-style: italic;\n  }\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var FirstWelcomeModal_Text = styled_components_browser_esm["default"].p(FirstWelcomeModal_templateObject6 || (FirstWelcomeModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
// EXTERNAL MODULE: ./src/components/Form.js
var Form = __webpack_require__(41212);
;// CONCATENATED MODULE: ./src/components/FormContainer.js



var FormContainer_templateObject, FormContainer_templateObject2, FormContainer_templateObject3;

var FormContainer_jsx = react.createElement;






var FormContainer = function FormContainer(props) {
  return FormContainer_jsx(FormContainer_Container, {
    "data-id": "components_FormContainer_Container"
  }, FormContainer_jsx(Form/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    "data-id": "components_FormContainer_Form"
  })));
};

/* harmony default export */ var components_FormContainer = (FormContainer);
var FormContainer_Container = styled_components_browser_esm["default"].div(FormContainer_templateObject || (FormContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " padding: 40rem 20rem;\n  background: #fff;\n  width: 100%;\n  box-sizing: border-box;\n\n  > div {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, breakpoints/* fromBreakpoint.md */.ks.md(FormContainer_templateObject2 || (FormContainer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 60rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(FormContainer_templateObject3 || (FormContainer_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 100rem 100rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/ForgotPasswordModal.js








var ForgotPasswordModal_templateObject, ForgotPasswordModal_templateObject2, ForgotPasswordModal_templateObject3, ForgotPasswordModal_templateObject4, ForgotPasswordModal_templateObject5, ForgotPasswordModal_templateObject6, ForgotPasswordModal_templateObject7;

var ForgotPasswordModal_jsx = react.createElement;

function ForgotPasswordModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ForgotPasswordModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ForgotPasswordModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ForgotPasswordModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
} // @ flow












var ForgotPasswordModal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleClick: function handleClick(projectSlug, email) {
      dispatch((0,apiData/* performApiRequest */.T4)('requestPassword', {
        projectSlug: projectSlug
      }, {
        email: email
      }));
    },
    onClose: function onClose() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var ForgotPasswordModal_form = [{
  options: [{
    id: 'email',
    name: 'email1',
    label: 'Vul hier je e-mailadres in',
    required: true,
    title: 'Vul hier je e-mailadres in',
    type: 'email'
  }]
}];

var ForgotPassword = /*#__PURE__*/function (_Component) {
  function ForgotPassword() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ForgotPassword);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ForgotPasswordModal_callSuper(this, ForgotPassword, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      send: false
    });

    (0,defineProperty/* default */.Z)(_this, "handleSubmit", function (values) {
      var _this$props = _this.props,
          match = _this$props.match,
          handleClick = _this$props.handleClick;
      handleClick(String(match.params.projectSlug), values.email1);

      _this.setState({
        send: !_this.state.send
      });
    });

    (0,defineProperty/* default */.Z)(_this, "resetForm", function () {
      _this.setState({
        send: !_this.state.send
      });
    });

    (0,defineProperty/* default */.Z)(_this, "closeModal", function () {
      _this.props.onClose();
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ForgotPassword, _Component);

  return (0,createClass/* default */.Z)(ForgotPassword, [{
    key: "render",
    value: function render() {
      var changePassword = this.props.changePassword;
      var send = this.state.send;
      return ForgotPasswordModal_jsx(ForgotPasswordModal_Container, {
        "data-id": "components_ForgotPasswordModal_Container"
      }, !send && !changePassword && ForgotPasswordModal_jsx("div", {
        "data-id": "components_ForgotPasswordModal_div"
      }, ForgotPasswordModal_jsx(ForgotPasswordModal_Title, {
        "data-id": "components_ForgotPasswordModal_Title"
      }, "Wachtwoord opnieuw instellen"), ForgotPasswordModal_jsx(ForgotPasswordModal_SubTitle, {
        "data-id": "components_ForgotPasswordModal_SubTitle"
      }, "Wachtwoord vergeten, of wil je een nieuw wachtwoord instellen? Geen probleem, dat is binnen een handomdraai geregeld. Vul hieronder je e-mailadres in en we sturen je direct een e-mail waarmee je het wachtwoord opnieuw kunt instellen."), ForgotPasswordModal_jsx(FormGenerator/* default */.Z, {
        fields: ForgotPasswordModal_form,
        submitLabel: "Versturen",
        loadingLabel: "email wordt verzonden",
        submitFn: this.handleSubmit,
        "data-id": "components_ForgotPasswordModal_FormGenerator"
      }), ForgotPasswordModal_jsx(Disclaimer, {
        "data-id": "components_ForgotPasswordModal_Disclaimer"
      }, "De link in de e-mail die we je sturen is 24 uur geldig. Je kunt eens per 2 uur een nieuw wachtwoord aanvragen.")), (send || changePassword) && ForgotPasswordModal_jsx("div", {
        "data-id": "components_ForgotPasswordModal_div"
      }, ForgotPasswordModal_jsx(ForgotPasswordModal_Title, {
        "data-id": "components_ForgotPasswordModal_Title"
      }, "We hebben je een e-mail gestuurd"), ForgotPasswordModal_jsx(ForgotPasswordModal_SubTitle, {
        "data-id": "components_ForgotPasswordModal_SubTitle"
      }, "Klik op de link in de e-mail om je wachtwoord opnieuw in te stellen"), ForgotPasswordModal_jsx(Try, {
        "data-id": "components_ForgotPasswordModal_Try"
      }, "Geen e-mail ontvangen? Het zou kunnen dat de e-mail in de spam folder is terechtgekomen, of", ' ', ForgotPasswordModal_jsx("span", {
        onClick: changePassword ? this.closeModal : this.resetForm,
        "data-id": "components_ForgotPasswordModal_span"
      }, "probeer het nog een keer"))));
    }
  }]);
}(react.Component);

/* harmony default export */ var ForgotPasswordModal = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(null, ForgotPasswordModal_mapDispatchToProps)(ForgotPassword)));
var Try = styled_components_browser_esm["default"].div(ForgotPasswordModal_templateObject || (ForgotPasswordModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  font-weight: normal;\n  font-style: italic;\n  margin-top: 60rem;\n\n  > span {\n    color: ", ";\n    cursor: pointer;\n  }\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, styleGuide/* colorPalette.blue */.K5.blue);
var ForgotPasswordModal_SubTitle = styled_components_browser_esm["default"].div(ForgotPasswordModal_templateObject2 || (ForgotPasswordModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  font-weight: normal;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ForgotPasswordModal_Title = styled_components_browser_esm["default"].h2(ForgotPasswordModal_templateObject3 || (ForgotPasswordModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ForgotPasswordModal_Container = styled_components_browser_esm["default"].div(ForgotPasswordModal_templateObject4 || (ForgotPasswordModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 80rem 200rem 142rem 200rem;\n\n  ", " ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* toBreakpoint.lg */.Hx.lg(ForgotPasswordModal_templateObject5 || (ForgotPasswordModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 70rem 142rem 70rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(ForgotPasswordModal_templateObject6 || (ForgotPasswordModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 20rem 142rem 20rem;\n  "]))));
var Disclaimer = styled_components_browser_esm["default"].p(ForgotPasswordModal_templateObject7 || (ForgotPasswordModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 20rem 0 0 0;\n  ", ";\n  color: ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
// EXTERNAL MODULE: ./src/redux/redirect.js
var redirect = __webpack_require__(42477);
// EXTERNAL MODULE: ./src/components/shared/ui/Spinner.js
var Spinner = __webpack_require__(6048);
;// CONCATENATED MODULE: ./src/services/formatPrice.js
/* harmony default export */ var formatPrice = (function (price, _ref) {
  var showDecimal = _ref.showDecimal,
      _ref$showEuroSign = _ref.showEuroSign,
      showEuroSign = _ref$showEuroSign === void 0 ? true : _ref$showEuroSign,
      _ref$showNegative = _ref.showNegative,
      showNegative = _ref$showNegative === void 0 ? true : _ref$showNegative;
  if (!price) return "".concat(showEuroSign ? '€' : '', " 0,-");
  var isNegativeNumber = price < 0;
  var priceToFixed = price.toFixed(2); // make sure the price only has 2 decimals

  var priceArray = Math.abs(Number(priceToFixed)).toString().split('.'); // places a thousand separator (period) after every third instance of a digit,
  // from the right

  priceArray[0] = priceArray[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  var processedNumber = priceArray.reduce(function (acc, curr, index) {
    if (priceArray.length === 1 && !showDecimal) {
      return "".concat(curr);
    }

    if (priceArray.length === 1) {
      return "".concat(curr, ",-");
    }

    if (index === 1) {
      return "".concat(acc, ",").concat(curr.length === 1 ? curr + '0' : curr);
    }

    return curr;
  }, '€ ');
  return "".concat(isNegativeNumber && showNegative ? '-' : '', " ").concat(showEuroSign ? '€ ' : '').concat(processedNumber);
});
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(38735);
;// CONCATENATED MODULE: ./src/components/shared/designElements/PriceTag.js


var PriceTag_templateObject, PriceTag_templateObject2, PriceTag_templateObject3, PriceTag_templateObject4, PriceTag_templateObject5, PriceTag_templateObject6, PriceTag_templateObject7, PriceTag_templateObject8;

var PriceTag_jsx = react.createElement;







var PriceTag_defaultProps = {
  isSold: false
};

var PriceTag = function PriceTag(_ref) {
  var isSold = _ref.isSold,
      small = _ref.small,
      mini = _ref.mini,
      notAvailable = _ref.notAvailable,
      loading = _ref.loading,
      price = _ref.price,
      hasExternalSellers = _ref.hasExternalSellers;
  var infoIconRef = (0,react.useRef)(null);
  return PriceTag_jsx(react.Fragment, null, PriceTag_jsx("style", {
    "data-id": "designElements_PriceTag_style"
  }, "\n          .__react_component_tooltip {\n            text-transform: none !important;\n            font-weight: normal !important;\n          }\n        "), PriceTag_jsx(PriceSummary, {
    isSold: isSold,
    small: small,
    mini: mini,
    notAvailable: notAvailable,
    loading: loading,
    "data-id": "designElements_PriceTag_PriceSummary"
  }, isSold ? 'Verkocht' : loading ? PriceTag_jsx(Loading, {
    "data-id": "designElements_PriceTag_Loading"
  }, PriceTag_jsx(Spinner/* default */.Z, {
    monochrome: true,
    color: "#fff",
    size: "small",
    "data-id": "designElements_PriceTag_Spinner"
  })) : PriceTag_jsx("div", {
    "data-id": "designElements_PriceTag_div"
  }, hasExternalSellers && PriceTag_jsx(react.Fragment, null, PriceTag_jsx(InformationIcon, {
    ref: infoIconRef,
    "data-tip": "Dit totaalbedrag wordt gefactureerd door meerdere partijen",
    "data-for": "info-tooltip",
    tabIndex: 0,
    onFocus: function onFocus() {
      return index_es/* default.show */.Z.show(infoIconRef.current);
    },
    onBlur: function onBlur() {
      return index_es/* default.hide */.Z.hide(infoIconRef.current);
    },
    onMouseEnter: function onMouseEnter() {
      return index_es/* default.show */.Z.show(infoIconRef.current);
    },
    onMouseLeave: function onMouseLeave() {
      return index_es/* default.hide */.Z.hide(infoIconRef.current);
    },
    "data-id": "designElements_PriceTag_InformationIcon"
  }, "i"), PriceTag_jsx(index_es/* default */.Z, {
    id: "info-tooltip",
    place: "top",
    effect: "solid",
    "data-id": "designElements_PriceTag_ReactTooltip"
  })), PriceTag_jsx(EuroSignContainer, {
    "data-id": "designElements_PriceTag_EuroSignContainer"
  }, "\u20AC"), PriceTag_jsx(PriceContainer, {
    "data-id": "designElements_PriceTag_PriceContainer"
  }, PriceTag_jsx("span", {
    "data-e2e-pricetag": true,
    "data-id": "designElements_PriceTag_span"
  }, formatPrice(Number(price), {
    showDecimal: true,
    showEuroSign: false
  }))))));
};

PriceTag.defaultProps = PriceTag_defaultProps;
/* harmony default export */ var designElements_PriceTag = (PriceTag);
var PriceSummary = styled_components_browser_esm["default"].div(PriceTag_templateObject || (PriceTag_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  justify-content: center;\n  align-items: center;\n  height: ", "rem;\n  min-width: ", "rem;\n  padding-left: 10rem;\n  padding-right: 10rem;\n  line-height: 16px;\n  box-sizing: border-box;\n  background-color: ", ";\n  color: #fff;\n  text-transform: uppercase;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: ", ";\n  transition: background 0.25s ease-in-out;\n\n  > div {\n    display: flex;\n    flex-direction: row;\n  }\n\n  ", ";\n"])), function (props) {
  return props.mini ? 24 : 28;
}, function (props) {
  return props.mini ? 72 : 96;
}, function (props) {
  return props.loading ? styleGuide/* colorPalette.darkGreen */.K5.darkGreen : props.isSold || props.notAvailable ? styleGuide/* colorPalette.lightBeige */.K5.lightBeige : styleGuide/* colorPalette.lightGreen */.K5.lightGreen;
}, styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.mini ? '12rem' : '14rem';
}, breakpoints/* fromBreakpoint.md */.ks.md(PriceTag_templateObject2 || (PriceTag_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: ", "rem;\n    min-width: ", "rem;\n    font-size: ", ";\n  "])), function (props) {
  return props.mini ? 24 : 32;
}, function (props) {
  return props.mini ? 72 : 115;
}, function (props) {
  return props.small ? '16rem' : props.mini ? '12rem' : '18rem';
}));
var EuroSignContainer = styled_components_browser_esm["default"].span(PriceTag_templateObject3 || (PriceTag_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin-right: 5rem;\n"])));
var PriceContainer = styled_components_browser_esm["default"].span(PriceTag_templateObject4 || (PriceTag_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n"])));
var Loading = styled_components_browser_esm["default"].div(PriceTag_templateObject5 || (PriceTag_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n\n  > div {\n    width: 22rem;\n    min-height: 22rem;\n    margin-right: 10rem;\n\n    ", ";\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(PriceTag_templateObject6 || (PriceTag_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      min-height: 25rem;\n    "]))));
var InfoIconWrapper = styled_components_browser_esm["default"].span(PriceTag_templateObject7 || (PriceTag_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  display: inline-block;\n\n  &:hover > span {\n    opacity: 1;\n    pointer-events: auto;\n  }\n"])));
var InformationIcon = styled_components_browser_esm["default"].div(PriceTag_templateObject8 || (PriceTag_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: bold;\n  background: #fff;\n  color: ", ";\n  border: 1px solid\n    ", ";\n  margin-right: 6px;\n  text-transform: none;\n"])), function (props) {
  return props.loading ? styleGuide/* colorPalette.darkGreen */.K5.darkGreen : props.isSold || props.notAvailable ? styleGuide/* colorPalette.lightBeige */.K5.lightBeige : styleGuide/* colorPalette.lightGreen */.K5.lightGreen;
}, function (props) {
  return props.loading ? styleGuide/* colorPalette.darkGreen */.K5.darkGreen : props.isSold || props.notAvailable ? styleGuide/* colorPalette.lightBeige */.K5.lightBeige : styleGuide/* colorPalette.lightGreen */.K5.lightGreen;
});
;// CONCATENATED MODULE: ./src/components/Handshake.js








var Handshake_templateObject, Handshake_templateObject2, Handshake_templateObject3, Handshake_templateObject4, Handshake_templateObject5, Handshake_templateObject6, Handshake_templateObject7, Handshake_templateObject8, Handshake_templateObject9, Handshake_templateObject0, Handshake_templateObject1, Handshake_templateObject10, Handshake_templateObject11, Handshake_templateObject12, Handshake_templateObject13, Handshake_templateObject14, Handshake_templateObject15, Handshake_templateObject16, Handshake_templateObject17, Handshake_templateObject18;

var Handshake_jsx = react.createElement;

function Handshake_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, Handshake_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function Handshake_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (Handshake_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}















var Handshake_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env;
  return {
    loggedIn: Boolean((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }).user),
    postWishListRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    }),
    resultWishList: (0,apiData/* getResultData */.yh)(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    })
  };
};

var Handshake_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var router = ownProps.router,
      match = ownProps.match;
  var projectSlug = match.params.projectSlug;
  return {
    handleClick: function handleClick(houseId, wishList, loggedIn) {
      if (!loggedIn) {
        dispatch((0,redirect/* updateRedirectState */.SE)(String(projectSlug), 'closed', houseId));
        router === null || router === void 0 || router.push("/".concat(String(projectSlug), "/closed"));
        dispatch((0,redux_modal/* clearModalState */.TR)());
      } else {
        dispatch((0,apiData/* performApiRequest */.T4)('postWishList', {
          projectSlug: String(projectSlug)
        }, {
          house: houseId
        }));
      }
    },
    closeModal: function closeModal() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var Handshake = /*#__PURE__*/function (_Component) {
  function Handshake() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Handshake);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Handshake_callSuper(this, Handshake, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "onClick", function (houseId) {
      var _this$props = _this.props,
          handleClick = _this$props.handleClick,
          wishList = _this$props.wishList,
          loggedIn = _this$props.loggedIn;
      handleClick(houseId, wishList, loggedIn || false);
    });

    return _this;
  }

  (0,inherits/* default */.Z)(Handshake, _Component);

  return (0,createClass/* default */.Z)(Handshake, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
          match = _this$props2.match,
          resultWishList = _this$props2.resultWishList,
          loggedIn = _this$props2.loggedIn,
          router = _this$props2.router,
          closeModal = _this$props2.closeModal;

      if (!loggedIn) {
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed"));
      } else if (resultWishList) {
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed/homestudio/").concat(resultWishList.id));
        closeModal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          houseVariant = _this$props3.houseVariant,
          pricelistId = _this$props3.pricelistId,
          onBoarding = _this$props3.onBoarding;
      var selectedHouse = (houseVariant.houses || []).find(function (house) {
        return house.id === pricelistId;
      });
      var houseDetails = [{
        label: 'Woonoppervlak',
        content: houseVariant.livingSpace ? "".concat(houseVariant.livingSpace, " m\xB2") : '-'
      }, {
        label: 'Slaapkamers',
        content: houseVariant.bedrooms
      }, {
        label: 'Kaveloppervlak',
        content: selectedHouse && selectedHouse.surface ? "".concat(selectedHouse.surface, " m\xB2") : '-'
      }];
      return selectedHouse ? Handshake_jsx(HandshakeContainer, {
        "data-id": "components_Handshake_HandshakeContainer"
      }, Handshake_jsx(HandshakeBlock, {
        "data-id": "components_Handshake_HandshakeBlock"
      }, Handshake_jsx(HandshakeLogo, {
        "data-id": "components_Handshake_HandshakeLogo"
      }, Handshake_jsx(ImageLoader/* default */.Z, {
        mode: "img",
        src: onBoarding.logo,
        "data-id": "components_Handshake_ImageLoader"
      })), Handshake_jsx(HandshakeTitle, {
        "data-id": "components_Handshake_HandshakeTitle"
      }, onBoarding.title), Handshake_jsx(HandshakeText, {
        "data-id": "components_Handshake_HandshakeText"
      }, Handshake_jsx(BBCode/* default */.Z, {
        content: onBoarding.description,
        "data-id": "components_Handshake_BBCode"
      })), Handshake_jsx(ButtonPrimary/* default */.Z, {
        label: onBoarding.label,
        type: "button",
        clickHandler: function clickHandler() {
          return _this2.onClick(selectedHouse.id);
        },
        "data-id": "components_Handshake_ButtonPrimary"
      }), Handshake_jsx(DetailsBlock, {
        "data-id": "components_Handshake_DetailsBlock"
      }, Handshake_jsx(DetailsText, {
        "data-id": "components_Handshake_DetailsText"
      }, "Ontwerp voor:", Handshake_jsx(DetailsTitle, {
        "data-id": "components_Handshake_DetailsTitle"
      }, houseVariant.variantName, " ", selectedHouse.variantCode, Handshake_jsx("span", {
        "data-id": "components_Handshake_span"
      }, "Bouwnummer ", selectedHouse.bnr)), Handshake_jsx(Price, {
        "data-id": "components_Handshake_Price"
      }, Handshake_jsx(designElements_PriceTag, {
        price: selectedHouse.price,
        isSold: selectedHouse.status === 'sold',
        "data-id": "components_Handshake_PriceTag"
      }), Handshake_jsx(PriceText, {
        isSold: selectedHouse.status === 'sold',
        "data-id": "components_Handshake_PriceText"
      }, "v.o.n.")), Handshake_jsx(Details, {
        "data-id": "components_Handshake_Details"
      }, houseDetails.map(function (item, index) {
        return Handshake_jsx(DetailsItem, {
          key: index,
          "data-id": "components_Handshake_DetailsItem"
        }, Handshake_jsx("span", {
          "data-id": "components_Handshake_span"
        }, item.label, ":"), " ", item.content);
      }))), Handshake_jsx(DetailsImage, {
        "data-id": "components_Handshake_DetailsImage"
      }, Handshake_jsx(ImageLoader/* default */.Z, {
        mode: "img",
        src: houseVariant.image.src,
        "data-id": "components_Handshake_ImageLoader"
      }))))) : null;
    }
  }]);
}(react.Component);

/* harmony default export */ var components_Handshake = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(Handshake_mapStateToProps, Handshake_mapDispatchToProps)(Handshake)));
var HandshakeLogo = styled_components_browser_esm["default"].div(Handshake_templateObject || (Handshake_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 120rem;\n  align-self: flex-end;\n"])));
var PriceText = styled_components_browser_esm["default"].div(Handshake_templateObject2 || (Handshake_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 10rem;\n  display: ", ";\n"])), function (props) {
  return props.isSold ? 'none' : 'block';
});
var Price = styled_components_browser_esm["default"].div(Handshake_templateObject3 || (Handshake_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 12rem;\n  display: flex;\n  align-items: center;\n"])));
var Details = styled_components_browser_esm["default"].div(Handshake_templateObject4 || (Handshake_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  font-size: 14rem;\n  margin-top: 16rem;\n\n  > div {\n    margin-top: 3rem;\n  }\n"])));
var DetailsItem = styled_components_browser_esm["default"].div(Handshake_templateObject5 || (Handshake_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 4rem;\n"])));
var DetailsTitle = styled_components_browser_esm["default"].span(Handshake_templateObject6 || (Handshake_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  font-weight: bold;\n  margin-top: 5rem;\n  color: ", ";\n  font-size: 18rem;\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var DetailsImage = styled_components_browser_esm["default"].div(Handshake_templateObject7 || (Handshake_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 380rem;\n  height: 228rem;\n\n  ", " ", ";\n"])), breakpoints/* toBreakpoint.md */.Hx.md(Handshake_templateObject8 || (Handshake_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    order: 1;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(Handshake_templateObject9 || (Handshake_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 260rem;\n    height: 160rem;\n  "]))));
var DetailsText = styled_components_browser_esm["default"].div(Handshake_templateObject0 || (Handshake_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n\n  ", ";\n"])), styleGuide/* textStyles.standardText */.sq.standardText, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* toBreakpoint.md */.Hx.md(Handshake_templateObject1 || (Handshake_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    order: 2;\n  "]))));
var DetailsBlock = styled_components_browser_esm["default"].div(Handshake_templateObject10 || (Handshake_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top: 1rem dashed ", ";\n  border-bottom: 1rem dashed ", ";\n  margin-top: 60rem;\n  display: flex;\n  justify-content: space-between;\n  padding: 20rem 0;\n\n  ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, styleGuide/* colorPalette.lightBeige */.K5.lightBeige, breakpoints/* toBreakpoint.md */.Hx.md(Handshake_templateObject11 || (Handshake_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: column;\n    margin-top: 40rem;\n  "]))));
var HandshakeText = styled_components_browser_esm["default"].div(Handshake_templateObject12 || (Handshake_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 10rem;\n  max-width: 700rem;\n\n  ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* toBreakpoint.md */.Hx.md(Handshake_templateObject13 || (Handshake_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n  "]))));
var HandshakeContainer = styled_components_browser_esm["default"].div(Handshake_templateObject14 || (Handshake_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var HandshakeBlock = styled_components_browser_esm["default"].div(Handshake_templateObject15 || (Handshake_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  padding: 30rem 160rem 80rem 160rem;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n\n  ", " ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* toBreakpoint.lg */.Hx.lg(Handshake_templateObject16 || (Handshake_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 20rem 70rem 40rem 70rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(Handshake_templateObject17 || (Handshake_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 16rem 10rem 40rem 10rem;\n  "]))));
var HandshakeTitle = styled_components_browser_esm["default"].div(Handshake_templateObject18 || (Handshake_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n  width: 95%;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
;// CONCATENATED MODULE: ./src/components/ImageContainer.js


var ImageContainer_templateObject;

var ImageContainer_jsx = react.createElement;





var ImageContainer_ImageContainer = function ImageContainer(_ref) {
  var image = _ref.image,
      renderWidth = _ref.renderWidth;
  return ImageContainer_jsx(ImageContainer_Container, {
    "data-id": "components_ImageContainer_Container"
  }, ImageContainer_jsx(ImageLoader/* default */.Z, {
    color: styleGuide/* colorPalette.lightBlue */.K5.lightBlue,
    mode: "img",
    src: image,
    position: "relative",
    width: renderWidth,
    "data-id": "components_ImageContainer_ImageLoader"
  }));
};

var ImageContainer_Container = styled_components_browser_esm["default"].div(ImageContainer_templateObject || (ImageContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n\n  > div {\n    width: 100%;\n    > img {\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n"])));
/* harmony default export */ var components_ImageContainer = (ImageContainer_ImageContainer);
;// CONCATENATED MODULE: ./src/components/PictureCollageSliderContainer.js


var PictureCollageSliderContainer_templateObject;

var PictureCollageSliderContainer_jsx = react.createElement;




var PictureCollageSlider = function PictureCollageSlider(_ref) {
  var currentIndex = _ref.currentIndex,
      images = _ref.images;
  return PictureCollageSliderContainer_jsx(PictureCollageSliderContainer_Container, {
    "data-id": "components_PictureCollageSliderContainer_Container"
  }, PictureCollageSliderContainer_jsx(ui_Slider, {
    currentIndex: currentIndex,
    heroes: images,
    "data-id": "components_PictureCollageSliderContainer_Slider"
  }));
};

var PictureCollageSliderContainer_Container = styled_components_browser_esm["default"].div(PictureCollageSliderContainer_templateObject || (PictureCollageSliderContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 940rem;\n  box-sizing: border-box;\n  margin-left: auto;\n  margin-right: auto;\n"])));
/* harmony default export */ var PictureCollageSliderContainer = (PictureCollageSlider);
// EXTERNAL MODULE: ./src/constants/months.js
var months = __webpack_require__(2081);
;// CONCATENATED MODULE: ./src/services/parseTimestamp.js

/* harmony default export */ var parseTimestamp = (function (timestamp) {
  if (!timestamp) return {
    error: 'no timestamp provided'
  };
  var date = timestamp.split(/-|\s|:/);
  if (date.length < 3) return {
    error: 'invalid date'
  };
  return {
    day: Number(date[2]),
    month: months/* months */.e[Number(date[1])],
    year: Number(date[0]),
    time: date.length > 3 ? "".concat(date[3], ":").concat(date[4]) : ''
  };
});
;// CONCATENATED MODULE: ./src/services/getDate.js

/* harmony default export */ var getDate = (function (timestamp) {
  var isLongName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!timestamp) return '';
  var dateObject = parseTimestamp(timestamp);

  if (dateObject) {
    var dateObjectType = isLongName ? dateObject.month && dateObject.month.longName : dateObject.month && dateObject.month.shortName;
    return "".concat(String(dateObject.day), " ").concat((dateObjectType || '').toLowerCase(), " ").concat(String(dateObject.year));
  }

  return '';
});
;// CONCATENATED MODULE: ./src/components/dashboard/PlanningStepModal.js


var PlanningStepModal_templateObject, PlanningStepModal_templateObject2, PlanningStepModal_templateObject3, PlanningStepModal_templateObject4, PlanningStepModal_templateObject5, PlanningStepModal_templateObject6, PlanningStepModal_templateObject7, PlanningStepModal_templateObject8, PlanningStepModal_templateObject9, PlanningStepModal_templateObject0, PlanningStepModal_templateObject1, PlanningStepModal_templateObject10, PlanningStepModal_templateObject11, PlanningStepModal_templateObject12, PlanningStepModal_templateObject13, PlanningStepModal_templateObject14, PlanningStepModal_templateObject15, PlanningStepModal_templateObject16, PlanningStepModal_templateObject17;

var PlanningStepModal_jsx = react.createElement;







var PlanningStepModal = function PlanningStepModal(_ref) {
  var stepNumber = _ref.stepNumber,
      title = _ref.title,
      date = _ref.date,
      showDate = _ref.showDate,
      text = _ref.text;
  return PlanningStepModal_jsx(PlanningStepModal_Container, {
    "data-id": "dashboard_PlanningStepModal_Container"
  }, PlanningStepModal_jsx(designElements_ModalInnerWrapper, {
    "data-id": "dashboard_PlanningStepModal_ModalInnerWrapper"
  }, PlanningStepModal_jsx(PlanningStepModal_Content, {
    "data-id": "dashboard_PlanningStepModal_Content"
  }, PlanningStepModal_jsx(TitleContainer, {
    "data-id": "dashboard_PlanningStepModal_TitleContainer"
  }, PlanningStepModal_jsx(DateIconWrapper, {
    "data-id": "dashboard_PlanningStepModal_DateIconWrapper"
  }, PlanningStepModal_jsx(StepIcon, {
    "data-id": "dashboard_PlanningStepModal_StepIcon"
  }, PlanningStepModal_jsx("span", {
    "data-id": "dashboard_PlanningStepModal_span"
  }, "stap"), PlanningStepModal_jsx("span", {
    "data-id": "dashboard_PlanningStepModal_span_7"
  }, stepNumber))), PlanningStepModal_jsx(PlanningStepModal_Title, {
    style: {
      color: styleGuide/* colorPalette.lightOrange */.K5.lightOrange
    },
    "data-id": "dashboard_PlanningStepModal_Title"
  }, title), showDate && PlanningStepModal_jsx(PublishedDate, {
    "data-id": "dashboard_PlanningStepModal_PublishedDate"
  }, getDate(date, false))), PlanningStepModal_jsx(PlanningStepModal_IntroText, {
    "data-id": "dashboard_PlanningStepModal_IntroText"
  }, text))));
};

var PlanningStepModal_Container = styled_components_browser_esm["default"].div(PlanningStepModal_templateObject || (PlanningStepModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var StepIcon = styled_components_browser_esm["default"].div(PlanningStepModal_templateObject2 || (PlanningStepModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 80rem;\n  height: 80rem;\n  background-color: ", ";\n  border-radius: 6rem;\n  color: #ffffff;\n  text-align: center;\n  font-family: ", ";\n  padding-top: 10rem;\n  box-sizing: border-box;\n  font-weight: bold;\n\n  ", " span:nth-of-type(2) {\n    position: relative;\n    font-size: 24rem;\n    line-height: 28rem;\n\n    ", ";\n  }\n\n  span:nth-of-type(1) {\n    position: relative;\n    display: block;\n    font-size: 20rem;\n\n    ", ";\n  }\n\n  &:before {\n    content: '';\n    border-radius: 6rem;\n    width: 100%;\n    height: 100%;\n    background-color: ", ";\n    opacity: 0.4;\n    position: absolute;\n    top: 5rem;\n    left: 5rem;\n\n    ", ";\n  }\n"])), styleGuide/* colorPalette.lightOrange */.K5.lightOrange, styleGuide/* fonts.primary */.Rq.primary, breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningStepModal_templateObject3 || (PlanningStepModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 15rem;\n    width: 110rem;\n    height: 110rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningStepModal_templateObject4 || (PlanningStepModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      font-size: 32rem;\n      line-height: 38rem;\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningStepModal_templateObject5 || (PlanningStepModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      font-size: 28rem;\n    "]))), styleGuide/* colorPalette.lightOrange */.K5.lightOrange, breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningStepModal_templateObject6 || (PlanningStepModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: 6rem;\n      left: 6rem;\n    "]))));
var PlanningStepModal_Title = styled_components_browser_esm["default"].h1(PlanningStepModal_templateObject7 || (PlanningStepModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-top: 0;\n  word-break: break-all;\n  word-break: break-word;\n  hyphens: auto;\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, breakpoints/* fromBreakpoint.md */.ks.md(PlanningStepModal_templateObject8 || (PlanningStepModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(100% - 50rem);\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningStepModal_templateObject9 || (PlanningStepModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n  "]))));
var PlanningStepModal_Content = styled_components_browser_esm["default"].div(PlanningStepModal_templateObject0 || (PlanningStepModal_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 0;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(PlanningStepModal_templateObject1 || (PlanningStepModal_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 20rem;\n    padding-right: 20rem;\n  "]))));
var TitleContainer = styled_components_browser_esm["default"].div(PlanningStepModal_templateObject10 || (PlanningStepModal_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  padding-right: 90rem;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(PlanningStepModal_templateObject11 || (PlanningStepModal_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-right: 60rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(PlanningStepModal_templateObject12 || (PlanningStepModal_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-right: 0;\n  "]))));
var DateIconWrapper = styled_components_browser_esm["default"].div(PlanningStepModal_templateObject13 || (PlanningStepModal_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  right: 0rem;\n  top: 0;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(PlanningStepModal_templateObject14 || (PlanningStepModal_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n    right: -40rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningStepModal_templateObject15 || (PlanningStepModal_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n    right: -120rem;\n  "]))));
var PublishedDate = styled_components_browser_esm["default"].div(PlanningStepModal_templateObject16 || (PlanningStepModal_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 10rem;\n  margin-bottom: 45rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var PlanningStepModal_IntroText = styled_components_browser_esm["default"].p(PlanningStepModal_templateObject17 || (PlanningStepModal_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 40rem;\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
/* harmony default export */ var dashboard_PlanningStepModal = (PlanningStepModal);
// EXTERNAL MODULE: ./src/entities/relationSchema.js
var relationSchema = __webpack_require__(76700);
;// CONCATENATED MODULE: ./src/components/shared/designElements/DaysCounter.js


var DaysCounter_templateObject, DaysCounter_templateObject2;

var DaysCounter_jsx = react.createElement;




var DaysCounter_defaultProps = {};

var DaysCounter = function DaysCounter(_ref) {
  var deadline = _ref.deadline,
      fontSize = _ref.fontSize;
  var today = new Date();
  var deadlineTransformed = new Date(deadline);

  if (deadlineTransformed.setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0)) {
    var days = Math.ceil(Math.abs((today.getTime() - deadlineTransformed.getTime()) / (24 * 60 * 60 * 1000)));

    if (days > 28) {
      return null;
    } else if (days === 1) {
      return DaysCounter_jsx(DaysCounter_Text, {
        fontSize: fontSize,
        color: styleGuide/* colorPalette.red */.K5.red,
        "data-id": "designElements_DaysCounter_Text"
      }, "Actie over ", days, " dag");
    } else {
      return DaysCounter_jsx(DaysCounter_Text, {
        fontSize: fontSize,
        color: days < 4 ? styleGuide/* colorPalette.red */.K5.red : styleGuide/* colorPalette.green */.K5.green,
        "data-id": "designElements_DaysCounter_Text_1"
      }, "Actie over ", days, " dagen");
    }
  } else if (deadlineTransformed.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
    return DaysCounter_jsx(DaysCounter_Text, {
      fontSize: fontSize,
      color: styleGuide/* colorPalette.red */.K5.red,
      "data-id": "designElements_DaysCounter_Text_2"
    }, "Actie vandaag");
  } else {
    return DaysCounter_jsx(DaysCounter_Text, {
      fontSize: fontSize,
      color: styleGuide/* colorPalette.textGrey */.K5.textGrey,
      "data-id": "designElements_DaysCounter_Text_3"
    }, "Actie verlopen");
  }
};

DaysCounter.defaultProps = DaysCounter_defaultProps;
var DaysCounter_Text = styled_components_browser_esm["default"].span(DaysCounter_templateObject || (DaysCounter_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-family: ", ";\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.color ? props.color : styleGuide/* colorPalette.green */.K5.green;
}, styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.fontSize ? "\n    font-size: ".concat(props.fontSize, "rem;\n    ") : "\n    font-size: 16rem;\n  ";
}, breakpoints/* fromBreakpoint.md */.ks.md(DaysCounter_templateObject2 || (DaysCounter_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n  "])), function (props) {
  return props.fontSize ? "\n    " : "\n      font-size: 18rem;\n    ";
}));
/* harmony default export */ var designElements_DaysCounter = (DaysCounter);
// EXTERNAL MODULE: ./src/processes/onNetworkStatusChange.ts
var onNetworkStatusChange = __webpack_require__(94497);
;// CONCATENATED MODULE: ./src/components/dashboard/PlanningActionModal.js









var PlanningActionModal_templateObject, PlanningActionModal_templateObject2, PlanningActionModal_templateObject3, PlanningActionModal_templateObject4, PlanningActionModal_templateObject5, PlanningActionModal_templateObject6, PlanningActionModal_templateObject7, PlanningActionModal_templateObject8, PlanningActionModal_templateObject9, PlanningActionModal_templateObject0;

var PlanningActionModal_jsx = react.createElement;

function PlanningActionModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, PlanningActionModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function PlanningActionModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (PlanningActionModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function PlanningActionModal_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function PlanningActionModal_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? PlanningActionModal_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PlanningActionModal_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


















var PlanningActionModal_mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  var postActionRequest = (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postAction', {
    projectSlug: String(projectSlug)
  });
  var patchActionRequest = (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'patchAction', {
    projectSlug: String(projectSlug),
    actionId: ownProps.id || ''
  });
  return {
    postRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postAction', {
      projectSlug: String(projectSlug)
    }),
    patchRequest: patchActionRequest,
    deleteRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'deleteAction', {
      projectSlug: String(projectSlug),
      actionId: ownProps.id || ''
    }),
    action: (0,apiData/* getEntity */.Hv)(state.apiData, relationSchema/* planningItemSchema */.XF, postActionRequest && postActionRequest.networkStatus === 'success' ? postActionRequest.result : ownProps.uniqueId)
  };
};

var PlanningActionModal_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    patchAction: function patchAction(actionId, actionValues) {
      dispatch((0,apiData/* performApiRequest */.T4)('patchAction', {
        projectSlug: String(projectSlug),
        actionId: actionId
      }, PlanningActionModal_objectSpread({}, actionValues)));
    },
    deleteAction: function deleteAction(actionId) {
      dispatch((0,apiData/* performApiRequest */.T4)('deleteAction', {
        projectSlug: String(projectSlug),
        actionId: actionId
      }));
    },
    postAction: function postAction(actionValues) {
      dispatch((0,apiData/* performApiRequest */.T4)('postAction', {
        projectSlug: String(projectSlug)
      }, PlanningActionModal_objectSpread({}, actionValues)));
    },
    clearRequest: function clearRequest() {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postAction', {
        projectSlug: String(projectSlug)
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('deleteAction', {
        projectSlug: String(projectSlug),
        actionId: ownProps.id || ''
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('patchAction', {
        projectSlug: String(projectSlug),
        actionId: ownProps.id || ''
      }));
    },
    invalidateNotifications: function invalidateNotifications() {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getNotifications', {
        projectSlug: String(projectSlug)
      }));
    },
    invalidateGetBlock: function invalidateGetBlock() {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getBlock', {
        projectSlug: String(projectSlug),
        env: 'closed',
        blockId: ownProps.blockId
      }));
    },
    closeModal: function closeModal() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var PlanningActionModal = /*#__PURE__*/function (_Component) {
  function PlanningActionModal() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, PlanningActionModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = PlanningActionModal_callSuper(this, PlanningActionModal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      mode: _this.props.mode,
      isLoading: false,
      isTransitioning: false
    });

    (0,defineProperty/* default */.Z)(_this, "handleModifyAction", function (formValues, actionType) {
      _this.setState({
        isLoading: true
      }, function () {
        var props = _this.props;

        var _ref = props.action || props,
            id = _ref.id;

        var values = {};

        if (formValues) {
          values.accomplished = !!formValues.actionAccomplished;

          if (formValues.deadline && typeof formValues.deadline === 'string') {
            var reverseDate = formValues.deadline.split('-').reverse().join('-');
            values.deadline = reverseDate;
          }

          if (formValues.title) {
            values.title = formValues.title;
          }

          if (formValues.text) {
            values.text = formValues.text;
          }
        }

        switch (actionType) {
          case 'POST':
            props.postAction(PlanningActionModal_objectSpread({}, values));
            break;

          case 'DELETE':
            props.deleteAction(Number(id));
            break;

          case 'PATCH':
          default:
            props.patchAction(Number(id), PlanningActionModal_objectSpread({}, values));
            break;
        }
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(PlanningActionModal, _Component);

  return (0,createClass/* default */.Z)(PlanningActionModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          clearRequest = _this$props.clearRequest,
          invalidateNotifications = _this$props.invalidateNotifications; // We need to clear the loaded action when the modal is opened after an action has already been added
      // Otherwise the modal will show the title of the last action that has been added to the redux store

      clearRequest();
      invalidateNotifications();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          deleteRequest = _this$props2.deleteRequest,
          postRequest = _this$props2.postRequest,
          patchRequest = _this$props2.patchRequest,
          invalidateGetBlock = _this$props2.invalidateGetBlock,
          closeModal = _this$props2.closeModal,
          action = _this$props2.action;
      var oldAction = prevProps.action;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          mode = _this$state.mode;

      if (deleteRequest && deleteRequest.networkStatus === 'success' && this.state.mode !== 'delete') {
        this.setState({
          mode: 'delete'
        });
      } else if (postRequest && postRequest.networkStatus === 'success' && isLoading) {
        this.setState({
          isLoading: false,
          isTransitioning: true
        }); // When posting an action, we want to transition the contents of the modal.
        // When patching an action, we don't want to transition.

        if (!lodash_isequal_default()(oldAction, action) && mode === 'create') {
          this.transitionFromTo('create', 'read');
        }
      }

      var callbacks = {
        onSucces: invalidateGetBlock,
        always: closeModal
      };
      (0,onNetworkStatusChange/* default */.Z)(callbacks, prevProps.patchRequest, patchRequest);
      (0,onNetworkStatusChange/* default */.Z)(callbacks, prevProps.postRequest, postRequest);
      (0,onNetworkStatusChange/* default */.Z)(callbacks, prevProps.deleteRequest, deleteRequest);
    }
  }, {
    key: "transitionFromTo",
    value: function transitionFromTo(viewCurrent, viewNext) {
      var _this2 = this;

      this.setState({
        isTransitioning: true
      }, function () {
        setTimeout(function () {
          _this2.setState({
            mode: viewNext
          });
        }, 300);
        setTimeout(function () {
          _this2.setState({
            isTransitioning: false
          });
        }, 700);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;

      var _ref2 = props.action || {},
          author = _ref2.author,
          authorType = _ref2.authorType,
          authorImage = _ref2.authorImage,
          functionTitle = _ref2.functionTitle,
          accomplished = _ref2.accomplished,
          deadline = _ref2.deadline,
          editable = _ref2.editable,
          text = _ref2.text,
          title = _ref2.title;

      var editActionForm = [{
        options: [{
          id: 'title',
          name: 'title',
          required: true,
          title: 'Actietitel',
          type: 'text'
        }, {
          id: 'deadline',
          name: 'deadline',
          required: true,
          title: 'Einddatum',
          type: 'bamDate'
        }, {
          id: 'text',
          name: 'text',
          required: true,
          title: 'Beschrijving van je actie',
          type: 'textarea'
        }, {
          id: 'actionAccomplished',
          name: 'actionAccomplished',
          required: false,
          type: 'checkbox',
          title: '',
          choices: [{
            key: 'accomplished',
            value: 'Actie voltooid',
            defaultChecked: accomplished || false
          }]
        }]
      }];
      var defaultTitle = 'Actie aanmaken of beheren';
      var defaultDescription = "Maak de planning persoonlijk met jouw eigen acties. Zo vergeet je nooit meer een belangrijke stap of afspraak!";
      var modalSettings = {
        create: {
          title: defaultTitle,
          description: defaultDescription,
          showAuthor: false,
          form: {
            fields: editActionForm,
            submitLabel: 'Opslaan',
            submitFn: function submitFn(values, action) {
              return _this3.handleModifyAction(values, 'POST');
            }
          }
        },
        read: {
          title: title,
          description: text,
          deadline: deadline,
          showAuthor: true,
          author: author,
          authorType: authorType,
          authorImage: authorImage,
          functionTitle: functionTitle,
          form: {
            fields: [{
              options: [{
                id: 'actionAccomplished',
                name: 'actionAccomplished',
                title: '',
                required: false,
                type: 'checkbox',
                choices: [{
                  key: 'accomplished',
                  value: 'Actie voltooid',
                  defaultChecked: accomplished || false
                }]
              }]
            }],
            submitLabel: 'Opslaan',
            submitFn: function submitFn(values, action) {
              return _this3.handleModifyAction(values, 'PATCH');
            },
            showCancel: editable,
            cancelLabel: 'Actie bewerken',
            cancelButtonColor: '#FFFFFF',
            cancelLabelColor: styleGuide/* colorPalette.blue */.K5.blue,
            cancelFn: function cancelFn() {
              return _this3.transitionFromTo('read', 'update');
            }
          }
        },
        update: {
          title: defaultTitle,
          description: defaultDescription,
          showAuthor: false,
          form: {
            fields: editActionForm,
            defaultValues: {
              text: text || '',
              title: title || '',
              deadline: deadline ? deadline.split('-').reverse().join('-') : '',
              actionAccomplished: accomplished
            },
            submitLabel: 'Opslaan',
            submitFn: function submitFn(values, action) {
              return _this3.handleModifyAction(values, 'PATCH');
            }
          }
        },
        "delete": {
          showAuthor: false,
          confirmation: {
            title: "Weet je zeker dat je de actie \u2018<span>".concat(title || '', "</span>\u2019 wilt verwijderen?"),
            description: 'Deze actie kan niet ongedaan gemaakt worden.',
            submitButtonLabel: 'Verwijderen',
            submitFn: function submitFn(values, action) {
              return _this3.handleModifyAction({}, 'DELETE');
            },
            cancelButtonLabel: 'Actie bewerken',
            cancelFn: function cancelFn() {
              return _this3.transitionFromTo('delete', 'update');
            }
          }
        }
      };
      var _modalSettings$this$s = modalSettings[this.state.mode],
          description = _modalSettings$this$s.description,
          form = _modalSettings$this$s.form,
          confirmation = _modalSettings$this$s.confirmation,
          showAuthor = _modalSettings$this$s.showAuthor;
      return PlanningActionModal_jsx(designElements_ModalInnerWrapper, {
        "data-id": "dashboard_PlanningActionModal_ModalInnerWrapper"
      }, PlanningActionModal_jsx(ModalView, {
        fadeIn: !this.state.isTransitioning,
        fadeOut: this.state.isTransitioning,
        "data-id": "dashboard_PlanningActionModal_ModalView"
      }, this.state.mode !== 'delete' && PlanningActionModal_jsx("div", {
        "data-id": "dashboard_PlanningActionModal_div"
      }, deadline && this.state.mode === 'read' && PlanningActionModal_jsx(PlanningActionModal_Header, {
        "data-id": "dashboard_PlanningActionModal_Header"
      }, PlanningActionModal_jsx(Deadline, {
        "data-id": "dashboard_PlanningActionModal_Deadline"
      }, getDate(deadline, false)), PlanningActionModal_jsx(designElements_DaysCounter, {
        deadline: deadline,
        "data-id": "dashboard_PlanningActionModal_DaysCounter"
      })), PlanningActionModal_jsx(PlanningActionModal_Title, {
        "data-id": "dashboard_PlanningActionModal_Title"
      }, this.state.mode === 'create' || this.state.mode === 'update' ? defaultTitle : title), description && PlanningActionModal_jsx(PlanningActionModal_Description, {
        "data-id": "dashboard_PlanningActionModal_Description"
      }, description), showAuthor && author && authorType && authorImage && PlanningActionModal_jsx(AuthorContainer, {
        "data-id": "dashboard_PlanningActionModal_AuthorContainer"
      }, PlanningActionModal_jsx(AuthorIntro, {
        "data-id": "dashboard_PlanningActionModal_AuthorIntro"
      }, "Aangemaakt door: "), PlanningActionModal_jsx(UserAvatar/* default */.Z, {
        mode: "imageLoader",
        size: "normal",
        imageUrl: authorImage,
        "data-id": "dashboard_PlanningActionModal_UserAvatar"
      }), PlanningActionModal_jsx(AuthorText, {
        "data-id": "dashboard_PlanningActionModal_AuthorText"
      }, functionTitle && PlanningActionModal_jsx(AuthorTitle, {
        "data-id": "dashboard_PlanningActionModal_AuthorTitle"
      }, functionTitle), PlanningActionModal_jsx(AuthorName, {
        isCustomer: authorType === 'customer',
        "data-id": "dashboard_PlanningActionModal_AuthorName"
      }, author))), form && PlanningActionModal_jsx(FormGenerator/* default */.Z, (0,esm_extends/* default */.Z)({
        loadingLabel: "aanvraag wordt verwerkt",
        submitButtonPosition: "left",
        loading: this.state.isLoading
      }, form, {
        "data-id": "dashboard_PlanningActionModal_FormGenerator"
      }))), confirmation && PlanningActionModal_jsx(designElements_DeleteConfirmation, {
        title: confirmation.title,
        description: confirmation.description,
        submitButtonLabel: "Verwijderen",
        submitFn: confirmation.submitFn,
        cancelButtonLabel: confirmation.cancelButtonLabel,
        loadingLabel: "aanvraag wordt verwerkt",
        loading: this.state.isLoading,
        cancelFn: confirmation.cancelFn,
        "data-id": "dashboard_PlanningActionModal_DeleteConfirmation"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var dashboard_PlanningActionModal = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(PlanningActionModal_mapStateToProps, PlanningActionModal_mapDispatchToProps)(PlanningActionModal)));
var ModalView = styled_components_browser_esm["default"].div(PlanningActionModal_templateObject || (PlanningActionModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n\n  #form_cancel {\n    background-color: #ffffff;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (props) {
  return props.fadeIn ? '1' : props.fadeOut ? '0' : '1';
}, styleGuide/* colorPalette.darkBlue */.K5.darkBlue);
var PlanningActionModal_Header = styled_components_browser_esm["default"].div(PlanningActionModal_templateObject2 || (PlanningActionModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  margin-bottom: 5rem;\n"])));
var AuthorContainer = styled_components_browser_esm["default"].div(PlanningActionModal_templateObject3 || (PlanningActionModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  padding-top: 23rem;\n  padding-bottom: 25rem;\n  border-bottom: 2rem solid ", ";\n  border-top: 2rem solid ", ";\n\n  > div {\n    margin-right: 5rem;\n  }\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, styleGuide/* colorPalette.lightGrey */.K5.lightGrey);
var Deadline = styled_components_browser_esm["default"].div(PlanningActionModal_templateObject4 || (PlanningActionModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var AuthorIntro = styled_components_browser_esm["default"].p(PlanningActionModal_templateObject5 || (PlanningActionModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  ", ";\n  color: ", ";\n  margin-bottom: 10rem;\n  margin-top: 0;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var AuthorText = styled_components_browser_esm["default"].p(PlanningActionModal_templateObject6 || (PlanningActionModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin: 0;\n  flex-direction: column;\n  justify-content: center;\n"])));
var AuthorTitle = styled_components_browser_esm["default"].span(PlanningActionModal_templateObject7 || (PlanningActionModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var AuthorName = styled_components_browser_esm["default"].span(PlanningActionModal_templateObject8 || (PlanningActionModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey, function (props) {
  return props.isCustomer && "\n    font-weight: bold;\n  ";
});
var PlanningActionModal_Title = styled_components_browser_esm["default"].h2(PlanningActionModal_templateObject9 || (PlanningActionModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var PlanningActionModal_Description = styled_components_browser_esm["default"].p(PlanningActionModal_templateObject0 || (PlanningActionModal_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0rem;\n  margin-bottom: 30rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
;// CONCATENATED MODULE: ./src/components/Pricelist.js








var Pricelist_templateObject, Pricelist_templateObject2, Pricelist_templateObject3, Pricelist_templateObject4, Pricelist_templateObject5, Pricelist_templateObject6, Pricelist_templateObject7, Pricelist_templateObject8, Pricelist_templateObject9, Pricelist_templateObject0, Pricelist_templateObject1, Pricelist_templateObject10, Pricelist_templateObject11, Pricelist_templateObject12, Pricelist_templateObject13, Pricelist_templateObject14, Pricelist_templateObject15, Pricelist_templateObject16, Pricelist_templateObject17, Pricelist_templateObject18;

var Pricelist_jsx = react.createElement;

function Pricelist_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, Pricelist_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function Pricelist_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (Pricelist_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}














var Pricelist_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env;
  return {
    showLogin: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'showLogin', {}),
    resultWishList: (0,apiData/* getResultData */.yh)(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    }),
    postWishListRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    })
  };
};

var Pricelist_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    handleClick: function handleClick(endpoint) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.beige */.K5.beige, endpoint));
    },
    createWishList: function createWishList(houseId) {
      dispatch((0,apiData/* performApiRequest */.T4)('postWishList', {
        projectSlug: String(projectSlug)
      }, {
        house: houseId
      }));
    },
    invalidateData: function invalidateData() {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getWishLists', {
        projectSlug: String(projectSlug)
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postWishList', {
        projectSlug: String(projectSlug)
      }));
    },
    closeModal: function closeModal() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var Pricelist = /*#__PURE__*/function (_Component) {
  function Pricelist() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Pricelist);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Pricelist_callSuper(this, Pricelist, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "refMap", {});

    (0,defineProperty/* default */.Z)(_this, "state", {
      openMobile: _this.props.open === 0 && _this.props.index === 0
    });

    (0,defineProperty/* default */.Z)(_this, "openMobile", function (id) {
      var subNavMaxHeight = _this.refMap[id].offsetHeight;

      _this.setState(function (prevState) {
        return (0,defineProperty/* default */.Z)({}, 'subNavMaxHeight_' + id, subNavMaxHeight);
      });

      _this.setState({
        openMobile: !_this.state.openMobile
      });
    });

    (0,defineProperty/* default */.Z)(_this, "getSubNavMaxHeight", function (state, id) {
      return state['subNavMaxHeight_' + id];
    });

    return _this;
  }

  (0,inherits/* default */.Z)(Pricelist, _Component);

  return (0,createClass/* default */.Z)(Pricelist, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          postWishListRequest = _this$props.postWishListRequest,
          resultWishList = _this$props.resultWishList,
          match = _this$props.match,
          router = _this$props.router,
          invalidateData = _this$props.invalidateData,
          closeModal = _this$props.closeModal;

      if (postWishListRequest && postWishListRequest.networkStatus === 'success') {
        closeModal();
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed/homestudio/").concat(resultWishList.id || ''));
      }

      (0,onNetworkStatusChange/* default */.Z)({
        onSucces: invalidateData,
        always: closeModal
      }, prevProps.postWishListRequest, postWishListRequest);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          bnr = _this$props2.bnr,
          renderWidth = _this$props2.renderWidth,
          status = _this$props2.status,
          showLogin = _this$props2.showLogin,
          extraField = _this$props2.extraField,
          variantCode = _this$props2.variantCode,
          createWishList = _this$props2.createWishList,
          surface = _this$props2.surface,
          auction = _this$props2.auction,
          price = _this$props2.price,
          priceListTable = _this$props2.priceListTable,
          groundLease = _this$props2.groundLease,
          gardenLocation = _this$props2.gardenLocation,
          priceLivingReady = _this$props2.priceLivingReady,
          modal = _this$props2.modal,
          nearWater = _this$props2.nearWater,
          houseVariant = _this$props2.houseVariant,
          handleClick = _this$props2.handleClick,
          parkingSpots = _this$props2.parkingSpots,
          onBoarding = _this$props2.onBoarding;
      var priceLabel = (status === 'free' || status === 'option') && (price === 0 || !price) ? 'Nog onbekend' : status === 'free' || status === 'option' ? formatPrice(price, {
        showDecimal: true
      }) : '-';
      var statusMessage = status === 'free' ? 'Te koop' : status === 'option' ? 'Onder optie' : 'Verkocht';
      var showButton = status !== 'sold' && showLogin;
      return Pricelist_jsx(react.Fragment, null, (extraField > 2 || renderWidth <= 1067) && Pricelist_jsx(StackableContainer, {
        "data-id": "components_Pricelist_StackableContainer"
      }, Pricelist_jsx(Label, {
        onClick: function onClick() {
          return _this2.openMobile(id);
        },
        "data-id": "components_Pricelist_Label"
      }, Pricelist_jsx(Left, {
        "data-id": "components_Pricelist_Left"
      }, "Bouwnr. ", bnr, " ", variantCode ? "- ".concat(variantCode) : ''), Pricelist_jsx(Right, {
        expanded: this.state.openMobile,
        "data-id": "components_Pricelist_Right"
      }, statusMessage, Pricelist_jsx("div", {
        "data-id": "components_Pricelist_div"
      }, Pricelist_jsx(Caret/* default */.Z, {
        direction: "down",
        color: styleGuide/* colorPalette.white */.K5.white,
        "data-id": "components_Pricelist_Caret"
      })))), Pricelist_jsx(Foldable, {
        expanded: this.state.openMobile,
        maxHeight: this.getSubNavMaxHeight(this.state, id),
        "data-id": "components_Pricelist_Foldable"
      }, Pricelist_jsx("div", {
        ref: function ref(input) {
          _this2.refMap[id] = input;
        },
        "data-id": "components_Pricelist_div"
      }, Pricelist_jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, Pricelist_jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Kavelopp."), Pricelist_jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, surface ? "".concat(surface, " m\xB2") : '-')), Pricelist_jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, Pricelist_jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "v.o.n. prijs"), Pricelist_jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, (auction && status === 'free' || auction && status === 'option') && 'Bieden vanaf ', priceLabel)), priceListTable.groundLease && Pricelist_jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, Pricelist_jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Erfpacht"), Pricelist_jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, status === 'free' || status === 'option' ? groundLease : '-')), priceListTable.priceLivingReady && Pricelist_jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, Pricelist_jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Woonklaar v.a."), Pricelist_jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, status === 'free' || status === 'option' ? formatPrice(priceLivingReady, {
        showDecimal: true
      }) : '-')), priceListTable.gardenLocation && Pricelist_jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, Pricelist_jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Tuinligging"), Pricelist_jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, gardenLocation)), priceListTable.parkingSpots && Pricelist_jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, Pricelist_jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Parkeerplaats(en)"), Pricelist_jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, parkingSpots)), priceListTable.nearWater && Pricelist_jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, Pricelist_jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Aan het water"), Pricelist_jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, nearWater ? 'Ja' : 'Nee')), Pricelist_jsx(StatusFold, {
        "data-id": "components_Pricelist_StatusFold"
      }, Pricelist_jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Status"), Pricelist_jsx(ContentFoldStatus, {
        status: status,
        "data-id": "components_Pricelist_ContentFoldStatus"
      }, statusMessage)), showButton && Pricelist_jsx(ButtonWrapperFold, {
        "data-id": "components_Pricelist_ButtonWrapperFold"
      }, Pricelist_jsx(ButtonSecondary/* default */.Z, {
        id: 'pricelist-make-new-design-for-house' + id,
        label: "Maak een ontwerp",
        type: "button",
        clickHandler: modal ? function (evt) {
          return createWishList(id);
        } : function (evt) {
          return handleClick({
            type: 'handshake',
            componentProps: {
              pricelistId: id,
              houseVariant: houseVariant,
              onBoarding: onBoarding
            }
          });
        },
        "data-id": "components_Pricelist_ButtonSecondary"
      }))))), extraField < 3 && renderWidth > 1067 && Pricelist_jsx(Pricetable, {
        modal: modal,
        "data-id": "components_Pricelist_Pricetable"
      }, Pricelist_jsx(Table, {
        "data-id": "components_Pricelist_Table"
      }, Pricelist_jsx(TableContainer, {
        showLogin: showLogin,
        "data-id": "components_Pricelist_TableContainer"
      }, Pricelist_jsx(HouseProperty, {
        width: 75,
        "data-id": "components_Pricelist_HouseProperty"
      }, bnr, " ", variantCode ? "- ".concat(variantCode) : ''), Pricelist_jsx(HouseProperty, {
        width: 85,
        "data-id": "components_Pricelist_HouseProperty_38"
      }, surface ? "".concat(surface, " m\xB2") : '-'), Pricelist_jsx(Pricelist_PriceContainer, {
        "data-id": "components_Pricelist_PriceContainer"
      }, Pricelist_jsx(Auction, {
        "data-id": "components_Pricelist_Auction"
      }, auction && status === 'free' || auction && status === 'option' ? 'Bieden vanaf' : ''), Pricelist_jsx(Pricelist_Price, {
        "data-id": "components_Pricelist_Price"
      }, priceLabel, (status === 'free' || status === 'option') && (priceLabel !== 0 || priceLabel) ? ' v.o.n.' : '')), priceListTable.groundLease && Pricelist_jsx(HouseProperty, {
        width: 90,
        "data-id": "components_Pricelist_HouseProperty"
      }, status === 'free' || status === 'option' ? groundLease : '-'), priceListTable.priceLivingReady && Pricelist_jsx(HouseProperty, {
        width: 120,
        "data-id": "components_Pricelist_HouseProperty_43"
      }, status === 'free' || status === 'option' ? formatPrice(priceLivingReady, {
        showDecimal: true
      }) : '-'), priceListTable.gardenLocation && Pricelist_jsx(HouseProperty, {
        width: 95,
        "data-id": "components_Pricelist_HouseProperty_44"
      }, gardenLocation), priceListTable.parkingSpots && Pricelist_jsx(HouseProperty, {
        width: 132,
        "data-id": "components_Pricelist_HouseProperty_45"
      }, parkingSpots), priceListTable.nearWater && Pricelist_jsx(HouseProperty, {
        width: 101,
        "data-id": "components_Pricelist_HouseProperty_46"
      }, nearWater ? 'Ja' : 'Nee'), Pricelist_jsx(Status, {
        status: status,
        "data-id": "components_Pricelist_Status"
      }, statusMessage)), showButton && Pricelist_jsx(ButtonWrap, {
        "data-id": "components_Pricelist_ButtonWrap"
      }, Pricelist_jsx(ButtonSecondary/* default */.Z, {
        label: "Maak een ontwerp",
        id: 'pricelist-make-new-design-for-house' + id,
        type: "button",
        clickHandler: modal ? function (evt) {
          return createWishList(id);
        } : function (evt) {
          return handleClick({
            type: 'handshake',
            componentProps: {
              pricelistId: id,
              houseVariant: houseVariant,
              onBoarding: onBoarding
            }
          });
        },
        "data-id": "components_Pricelist_ButtonSecondary"
      })))));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_Pricelist = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(Pricelist_mapStateToProps, Pricelist_mapDispatchToProps)(Pricelist)));
var ButtonWrap = styled_components_browser_esm["default"].div(Pricelist_templateObject || (Pricelist_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  > button {\n    width: 180rem;\n    letter-spacing: 0;\n    align-self: auto;\n    margin-right: 12rem;\n    cursor: pointer;\n  }\n"])));
var ButtonWrapperFold = styled_components_browser_esm["default"].div(Pricelist_templateObject2 || (Pricelist_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  > button {\n    letter-spacing: 0;\n    align-self: auto;\n    cursor: pointer;\n  }\n  margin-bottom: 32rem;\n  margin-top: 18rem;\n"])));
var ContentFoldStatus = styled_components_browser_esm["default"].div(Pricelist_templateObject3 || (Pricelist_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 16rem;\n  width: 45%;\n  color: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.status === 'free' ? styleGuide/* colorPalette.green */.K5.green : props.status === 'option' ? styleGuide/* colorPalette.orange */.K5.orange : styleGuide/* colorPalette.beige */.K5.beige;
});
var ContentFold = styled_components_browser_esm["default"].p(Pricelist_templateObject4 || (Pricelist_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 16rem;\n  color: ", ";\n  width: 45%;\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var PropertyFold = styled_components_browser_esm["default"].div(Pricelist_templateObject5 || (Pricelist_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 16rem;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1rem solid rgba(188, 173, 159, 0.1);\n  height: 30rem;\n  align-items: center;\n  width: 100%;\n"])), styleGuide/* fonts.primary */.Rq.primary);
var TitleFold = styled_components_browser_esm["default"].div(Pricelist_templateObject6 || (Pricelist_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 16rem;\n  color: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var StatusFold = styled_components_browser_esm["default"].div(Pricelist_templateObject7 || (Pricelist_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 16rem;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1rem solid rgba(188, 173, 159, 0.1);\n  height: 30rem;\n  align-items: center;\n  width: 100%;\n  color: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.status === 'free' ? styleGuide/* colorPalette.green */.K5.green : props.status === 'option' ? styleGuide/* colorPalette.orange */.K5.orange : styleGuide/* colorPalette.beige */.K5.beige;
});
var Foldable = styled_components_browser_esm["default"].div(Pricelist_templateObject8 || (Pricelist_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  padding-left: 12rem;\n  padding-right: 12rem;\n  background-color: #fff;\n  max-height: ", "rem;\n  transition: max-height 0.22s ease-in-out;\n  overflow: hidden;\n"])), function (props) {
  return props.expanded ? props.maxHeight : '0';
});
var Left = styled_components_browser_esm["default"].div(Pricelist_templateObject9 || (Pricelist_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 10rem;\n"])));
var Right = styled_components_browser_esm["default"].div(Pricelist_templateObject0 || (Pricelist_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 120rem;\n  margin-right: 10rem;\n\n  > div {\n    transition: transform 0.2s ease-in-out;\n    transform: ", ";\n    transform-origin: center center;\n  }\n"])), function (props) {
  return props.expanded ? 'scaleY(-1)' : 'scaleY(1)';
});
var StackableContainer = styled_components_browser_esm["default"].div(Pricelist_templateObject1 || (Pricelist_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  box-shadow: 0rem 0rem 2rem 0rem rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n"])));
var Label = styled_components_browser_esm["default"].div(Pricelist_templateObject10 || (Pricelist_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 40rem;\n  display: flex;\n  background-color: ", ";\n  align-items: center;\n  font-family: ", ";\n  font-size: 16rem;\n  color: #fff;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  z-index: 1;\n  cursor: pointer;\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, styleGuide/* fonts.primary */.Rq.primary);
var TableContainer = styled_components_browser_esm["default"].div(Pricelist_templateObject11 || (Pricelist_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: ", "%;\n  display: flex;\n  justify-content: space-between;\n  margin-left: 10rem;\n"])), function (props) {
  return props.showLogin ? 78 : 100;
});
var Table = styled_components_browser_esm["default"].div(Pricelist_templateObject12 || (Pricelist_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: auto;\n  background-color: white;\n  border-bottom: 1rem solid rgba(188, 173, 159, 0.1);\n  border-left: 1rem solid rgba(188, 173, 159, 0.1);\n  border-right: 1rem solid rgba(188, 173, 159, 0.1);\n"])));
var HouseProperty = styled_components_browser_esm["default"].p(Pricelist_templateObject13 || (Pricelist_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  width: ", "rem;\n  align-self: center;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey, function (props) {
  return props.width;
});
var Pricelist_PriceContainer = styled_components_browser_esm["default"].div(Pricelist_templateObject14 || (Pricelist_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  width: 134rem;\n"])));
var Auction = styled_components_browser_esm["default"].p(Pricelist_templateObject15 || (Pricelist_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 14rem;\n  color: ", ";\n  margin-top: 15rem;\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var Pricelist_Price = styled_components_browser_esm["default"].p(Pricelist_templateObject16 || (Pricelist_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: -14rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var Status = styled_components_browser_esm["default"].p(Pricelist_templateObject17 || (Pricelist_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  width: 90rem;\n  color: ", ";\n  align-self: center;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, function (props) {
  return props.status === 'free' ? styleGuide/* colorPalette.green */.K5.green : props.status === 'option' ? styleGuide/* colorPalette.orange */.K5.orange : styleGuide/* colorPalette.beige */.K5.beige;
});
var Pricetable = styled_components_browser_esm["default"].div(Pricelist_templateObject18 || (Pricelist_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: auto;\n  position: relative;\n  margin-left: ", "rem;\n"])), function (props) {
  return props.modal ? 0 : 100;
});
;// CONCATENATED MODULE: ./src/components/PricelistBlock.js


var PricelistBlock_templateObject, PricelistBlock_templateObject2, PricelistBlock_templateObject3, PricelistBlock_templateObject4, PricelistBlock_templateObject5, PricelistBlock_templateObject6, PricelistBlock_templateObject7, PricelistBlock_templateObject8, PricelistBlock_templateObject9, PricelistBlock_templateObject0;

var PricelistBlock_jsx = react.createElement;











var PricelistBlock_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env;
  return {
    showLogin: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'showLogin', false)
  };
};

var PricelistBlock_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    handleClick: function handleClick(slug) {
      var _ownProps$router;

      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
      (_ownProps$router = ownProps.router) === null || _ownProps$router === void 0 || _ownProps$router.push("/".concat(String(ownProps.match.params.projectSlug), "/open/housetype/").concat(slug));
    }
  };
};

var PricelistBlock = function PricelistBlock(_ref) {
  var match = _ref.match,
      priceListTable = _ref.priceListTable,
      _ref$houseTypes = _ref.houseTypes,
      houseTypes = _ref$houseTypes === void 0 ? [] : _ref$houseTypes,
      layoutHouseType = _ref.layoutHouseType,
      handleClick = _ref.handleClick,
      renderWidth = _ref.renderWidth,
      modal = _ref.modal,
      showLogin = _ref.showLogin,
      onBoarding = _ref.onBoarding;
  var projectSlug = match.params.projectSlug;
  var extraField = 0;
  if (priceListTable.groundLease) extraField++;
  if (priceListTable.priceLivingReady) extraField++;
  if (priceListTable.gardenLocation) extraField++;
  if (priceListTable.parkingSpots) extraField++;
  if (priceListTable.nearWater) extraField++;
  return PricelistBlock_jsx(react.Fragment, null, houseTypes.map(function (houseType, index1) {
    return PricelistBlock_jsx("div", {
      key: index1,
      "data-e2e-block-pricelistblock": true,
      "data-id": "components_PricelistBlock_div"
    }, PricelistBlock_jsx(TypeTitle, {
      "data-id": "components_PricelistBlock_TypeTitle"
    }, !layoutHouseType ? "".concat(houseType.typeName, " ").concat(houseType.typeUsp ? '- ' + houseType.typeUsp : '') : 'Heb je interesse in deze woning?'), layoutHouseType && PricelistBlock_jsx(PriceListInfo, {
      "data-id": "components_PricelistBlock_PriceListInfo"
    }, PricelistBlock_jsx(HouseDetails, {
      "data-id": "components_PricelistBlock_HouseDetails"
    }, "In de prijslijst hieronder zie je alle beschikbare woningen binnen deze woningvariant, inclusief informatie over de kaveloppervlakte, v.o.n.-prijs en verkoopstatus per bouwnummer. Kies jouw favoriete woning en ontdek op Mijn Homestudios alle mogelijkheden om van dit huis een thuis te maken."), PricelistBlock_jsx(ButtonWrapper, {
      "data-id": "components_PricelistBlock_ButtonWrapper"
    }, PricelistBlock_jsx(ButtonSecondary/* default */.Z, {
      label: "Meer over Homestudios",
      type: "internalLink",
      route: "/".concat(String(projectSlug), "/closed"),
      "data-id": "components_PricelistBlock_ButtonSecondary"
    }))), houseType.houseVariants.map(function (houseVariant, index2) {
      return PricelistBlock_jsx("div", {
        key: index2,
        "data-id": "components_PricelistBlock_div"
      }, !layoutHouseType && PricelistBlock_jsx(PriceListInfo, {
        "data-id": "components_PricelistBlock_PriceListInfo"
      }, houseVariant.variantName && PricelistBlock_jsx(HouseTitle, {
        "data-id": "components_PricelistBlock_HouseTitle"
      }, "".concat(houseVariant.variantName, " ").concat(houseVariant.variantCodes && houseVariant.variantCodes.length > 0 ? "- ".concat(houseVariant.variantCodes.join(', ')) : "")), PricelistBlock_jsx(HouseDetails, {
        "data-id": "components_PricelistBlock_HouseDetails"
      }, "Woonoppervlak:", ' ', PricelistBlock_jsx("strong", {
        "data-id": "components_PricelistBlock_strong"
      }, houseVariant.livingSpace ? houseVariant.livingSpace + ' m²' : '-')), PricelistBlock_jsx(HouseDetails, {
        "data-id": "components_PricelistBlock_HouseDetails"
      }, "Slaapkamers:", ' ', PricelistBlock_jsx("strong", {
        "data-id": "components_PricelistBlock_strong"
      }, houseVariant.bedrooms ? houseVariant.bedrooms : '-')), houseType.showPage && PricelistBlock_jsx(ButtonWrapper, {
        "data-id": "components_PricelistBlock_ButtonWrapper"
      }, houseType.externalUrl ? PricelistBlock_jsx(ButtonSecondary/* default */.Z, {
        label: "Meer over deze woningvariant",
        type: "externalLink",
        link: houseType.externalUrl,
        target: "_blank",
        "data-id": "components_PricelistBlock_ButtonSecondary"
      }) : PricelistBlock_jsx(ButtonSecondary/* default */.Z, {
        label: "Meer over deze woningvariant",
        type: "button",
        clickHandler: function clickHandler() {
          return handleClick(houseVariant.slug);
        },
        "data-id": "components_PricelistBlock_ButtonSecondary_15"
      }))), extraField < 3 && renderWidth > 1067 && PricelistBlock_jsx(PricelistContainer, {
        modal: modal,
        "data-id": "components_PricelistBlock_PricelistContainer"
      }, PricelistBlock_jsx(PricelistBlock_Pricetable, {
        "data-id": "components_PricelistBlock_Pricetable"
      }, PricelistBlock_jsx(PricelistBlock_TitleContainer, {
        "data-id": "components_PricelistBlock_TitleContainer"
      }, PricelistBlock_jsx(Titles, {
        showLogin: showLogin,
        "data-id": "components_PricelistBlock_Titles"
      }, PricelistBlock_jsx(PropertyTitle, {
        width: 75,
        "data-id": "components_PricelistBlock_PropertyTitle"
      }, "Bouwnr."), PricelistBlock_jsx(PropertyTitle, {
        width: 85,
        "data-id": "components_PricelistBlock_PropertyTitle_21"
      }, "Kavelopp."), PricelistBlock_jsx(PropertyTitle, {
        width: 134,
        "data-id": "components_PricelistBlock_PropertyTitle_22"
      }, "Prijs"), priceListTable.groundLease && PricelistBlock_jsx(PropertyTitle, {
        width: 90,
        "data-id": "components_PricelistBlock_PropertyTitle_23"
      }, "Erfpacht"), priceListTable.priceLivingReady && PricelistBlock_jsx(PropertyTitle, {
        width: 120,
        "data-id": "components_PricelistBlock_PropertyTitle_24"
      }, "Woonklaar v.a."), priceListTable.gardenLocation && PricelistBlock_jsx(PropertyTitle, {
        width: 95,
        "data-id": "components_PricelistBlock_PropertyTitle_25"
      }, "Tuinligging"), priceListTable.parkingSpots && PricelistBlock_jsx(PropertyTitle, {
        width: 132,
        "data-id": "components_PricelistBlock_PropertyTitle_26"
      }, "Parkeerplaats(en)"), priceListTable.nearWater && PricelistBlock_jsx(PropertyTitle, {
        width: 110,
        "data-id": "components_PricelistBlock_PropertyTitle_27"
      }, "Aan het water"), PricelistBlock_jsx(PropertyTitle, {
        width: 90,
        "data-id": "components_PricelistBlock_PropertyTitle_28"
      }, "Status"))))), houseVariant.houses.map(function (block, index3) {
        return PricelistBlock_jsx(components_Pricelist, {
          key: index3,
          open: index2,
          index: index3,
          id: block.id,
          modal: modal,
          width: renderWidth,
          houseVariant: houseVariant,
          priceListTable: priceListTable,
          extraField: extraField,
          onBoarding: onBoarding,
          bnr: block.bnr,
          hasCustomer: block.hasCustomer,
          status: block.status,
          auction: block.auction,
          surface: block.surface,
          price: block.price,
          variantCode: block.variantCode,
          groundLease: block.groundLease,
          priceLivingReady: block.priceLivingReady,
          gardenLocation: block.gardenLocation,
          parkingSpots: block.parkingSpots,
          nearWater: block.nearWater,
          renderWidth: renderWidth,
          "data-id": "components_PricelistBlock_Pricelist"
        });
      }));
    }));
  }));
};

/* harmony default export */ var components_PricelistBlock = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(PricelistBlock_mapStateToProps, PricelistBlock_mapDispatchToProps)(PricelistBlock)));
var ButtonWrapper = styled_components_browser_esm["default"].div(PricelistBlock_templateObject || (PricelistBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 20rem;\n  > button {\n    letter-spacing: 0;\n    align-self: auto;\n  }\n  > a {\n    letter-spacing: 0;\n    align-self: auto;\n  }\n"])));
var PriceListInfo = styled_components_browser_esm["default"].div(PricelistBlock_templateObject2 || (PricelistBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 20rem;\n"])));
var TypeTitle = styled_components_browser_esm["default"].div(PricelistBlock_templateObject3 || (PricelistBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-top: 40rem;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var HouseTitle = styled_components_browser_esm["default"].div(PricelistBlock_templateObject4 || (PricelistBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-top: 32rem;\n  margin-bottom: 12rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var HouseDetails = styled_components_browser_esm["default"].div(PricelistBlock_templateObject5 || (PricelistBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  max-width: 780rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var Titles = styled_components_browser_esm["default"].div(PricelistBlock_templateObject6 || (PricelistBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: ", "%;\n  display: flex;\n  justify-content: space-between;\n  margin-left: 10rem;\n"])), function (props) {
  return props.showLogin ? 78 : 100;
});
var PricelistBlock_Pricetable = styled_components_browser_esm["default"].div(PricelistBlock_templateObject7 || (PricelistBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: auto;\n  position: relative;\n  box-shadow: 0rem 0rem 2rem 0rem rgba(0, 0, 0, 0.15);\n"])));
var PricelistContainer = styled_components_browser_esm["default"].div(PricelistBlock_templateObject8 || (PricelistBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: ", "rem;\n"])), function (props) {
  return props.modal ? 0 : 100;
});
var PricelistBlock_TitleContainer = styled_components_browser_esm["default"].div(PricelistBlock_templateObject9 || (PricelistBlock_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  height: 50rem;\n  background-color: ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige);
var PropertyTitle = styled_components_browser_esm["default"].p(PricelistBlock_templateObject0 || (PricelistBlock_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: #fff;\n  width: ", "rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, function (props) {
  return props.width;
});
;// CONCATENATED MODULE: ./src/components/PricelistModal.js



var PricelistModal_templateObject, PricelistModal_templateObject2, PricelistModal_templateObject3, PricelistModal_templateObject4, PricelistModal_templateObject5;

var PricelistModal_jsx = react.createElement;








var PricelistModal_connectApiData = (0,withApiData/* default */.Z)({
  blocks: 'getBlock'
}, function (ownProps) {
  return {
    blocks: {
      projectSlug: ownProps.match.params.projectSlug,
      env: 'closed',
      blockId: ownProps.priceListBlockId
    }
  };
});

var PricelistModal = function PricelistModal(_ref) {
  var blocks = _ref.blocks,
      renderWidth = _ref.renderWidth;
  return PricelistModal_jsx(PricelistModal_Container, {
    "data-id": "components_PricelistModal_Container"
  }, PricelistModal_jsx(PricelistModal_Title, {
    "data-id": "components_PricelistModal_Title"
  }, "Maak een nieuw woonontwerp"), PricelistModal_jsx(Intro, {
    "data-id": "components_PricelistModal_Intro"
  }, "Kies hieronder een beschikbare woning en start een nieuw woonontwerp om te ontdekken hoe je van dit huis een thuis kunt maken."), !blocks.data && PricelistModal_jsx(ContentLoader/* default */.Z, {
    "data-id": "components_PricelistModal_ContentLoader"
  }), blocks.data && PricelistModal_jsx(components_PricelistBlock, (0,esm_extends/* default */.Z)({
    modal: true,
    renderWidth: renderWidth
  }, blocks.data, {
    "data-id": "components_PricelistModal_PricelistBlock"
  })));
};

/* harmony default export */ var components_PricelistModal = ((0,withMatch/* default */.Z)(PricelistModal_connectApiData(PricelistModal)));
var PricelistModal_Container = styled_components_browser_esm["default"].div(PricelistModal_templateObject || (PricelistModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 80rem 100rem 80rem 100rem;\n\n  ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* toBreakpoint.md */.Hx.md(PricelistModal_templateObject2 || (PricelistModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 40rem 10rem 40rem 10rem;\n  "]))));
var Intro = styled_components_browser_esm["default"].div(PricelistModal_templateObject3 || (PricelistModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  max-width: 760rem;\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var PricelistModal_Title = styled_components_browser_esm["default"].h3(PricelistModal_templateObject4 || (PricelistModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n\n  ", ";\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* toBreakpoint.md */.Hx.md(PricelistModal_templateObject5 || (PricelistModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 12rem;\n  "]))));
// EXTERNAL MODULE: ./src/styles/fonts.ts
var fonts = __webpack_require__(18833);
;// CONCATENATED MODULE: ./src/components/atoms/Pill.tsx


var Pill_templateObject;






var Pill_Container = styled_components_browser_esm["default"].div(Pill_templateObject || (Pill_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  font-weight: ", ";\n  padding: 1rem 6rem;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 4rem 0;\n  display: inline-block;\n  display: flex;\n  align-items: center;\n  gap: 4rem;\n"])), fonts/* fontStyles.body.sm */.g6.body.sm, fonts/* fontWeight.bold */.Ue.bold, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? colors/* colors.gray10 */.O.gray10 : colors/* colors.gray25 */.O.gray25;
}, colors/* colors.white */.O.white);

var Pill = function Pill(_ref2) {
  var text = _ref2.text,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      Icon = _ref2.icon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Pill_Container, {
    disabled: disabled,
    "data-id": "atoms_Pill_Container",
    children: [!!Icon && /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
      variant: "white",
      height: 12,
      "data-id": "atoms_Pill_Icon"
    }), text]
  });
};

/* harmony default export */ var atoms_Pill = (Pill);
// EXTERNAL MODULE: ./src/processes/getWidthOrHeight.ts
var getWidthOrHeight = __webpack_require__(12897);
// EXTERNAL MODULE: ./src/constants/colors.ts
var constants_colors = __webpack_require__(98366);
// EXTERNAL MODULE: ./src/components/atoms/svg/Svg.tsx
var Svg = __webpack_require__(87107);
;// CONCATENATED MODULE: ./src/components/atoms/svg/ApproximateIcon.tsx






var ApproximateIcon = function ApproximateIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'brand' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 22 22",
    "data-id": "svg_ApproximateIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: constants_colors/* ICON_COLORS */.M[variant],
      fillRule: "evenodd",
      d: "M11,22A11,11,0,1,1,22,11,11,11,0,0,1,11,22ZM16.928,6.156a4.132,4.132,0,0,1-2.864,1.686,6.579,6.579,0,0,1-2.89-.91,7.383,7.383,0,0,0-3.292-.963A5.485,5.485,0,0,0,3.52,8.484L4.885,10.17A4.093,4.093,0,0,1,7.855,8.458a7.077,7.077,0,0,1,2.944.91,7.147,7.147,0,0,0,3.292.99,5.234,5.234,0,0,0,4.336-2.623Zm0.107,5.674a3.853,3.853,0,0,1-2.944,1.686,6.7,6.7,0,0,1-2.89-.91,7.384,7.384,0,0,0-3.292-.963,5.554,5.554,0,0,0-4.362,2.489l1.365,1.713a4.259,4.259,0,0,1,2.944-1.686,6.716,6.716,0,0,1,2.971.91,7.6,7.6,0,0,0,3.265.964,5.293,5.293,0,0,0,4.389-2.676Z",
      "data-id": "svg_ApproximateIcon_path"
    })
  });
};

/* harmony default export */ var svg_ApproximateIcon = (ApproximateIcon);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var react_fontawesome_index_es = __webpack_require__(67814);
;// CONCATENATED MODULE: ./src/components/molecules/ExternalSeller.tsx


var ExternalSeller_templateObject;







var ExternalSellerContainer = styled_components_browser_esm["default"].span(ExternalSeller_templateObject || (ExternalSeller_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  font-weight: ", ";\n  padding: 1rem 6rem;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 4rem 0;\n  display: inline-block;\n  display: flex;\n  align-items: center;\n  gap: 4rem;\n  margin-left: ", ";\n\n  svg {\n    width: 14rem;\n    height: 14rem;\n  }\n"])), fonts/* fontStyles.body.sm */.g6.body.sm, fonts/* fontWeight.bold */.Ue.bold, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? colors/* colors.gray10 */.O.gray10 : colors/* colors.gray25 */.O.gray25;
}, function (props) {
  return props.labelColor ? props.labelColor : colors/* colors.white */.O.white;
}, function (_ref2) {
  var extraMarginLeft = _ref2.extraMarginLeft;
  return extraMarginLeft ? '33rem' : '0';
});

var ExternalSeller = function ExternalSeller(_ref3) {
  var text = _ref3.text,
      labelColor = _ref3.labelColor,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$extraMarginLeft = _ref3.extraMarginLeft,
      extraMarginLeft = _ref3$extraMarginLeft === void 0 ? false : _ref3$extraMarginLeft;

  if (!text) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ExternalSellerContainer, {
    labelColor: labelColor,
    disabled: disabled,
    extraMarginLeft: extraMarginLeft,
    "data-id": "molecules_ExternalSeller_ExternalSellerContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
      icon: ['fas', 'triangle-exclamation'],
      "data-id": "molecules_ExternalSeller_FontAwesomeIcon"
    }), "Verkoop door ", text]
  });
};

/* harmony default export */ var molecules_ExternalSeller = (ExternalSeller);
// EXTERNAL MODULE: ./src/components/molecules/InlineError.tsx
var InlineError = __webpack_require__(46311);
;// CONCATENATED MODULE: ./src/components/organisms/InlineRequestHandler.tsx


var InlineRequestHandler_templateObject, InlineRequestHandler_templateObject2;







var SpinnerOuter = styled_components_browser_esm["default"].div(InlineRequestHandler_templateObject || (InlineRequestHandler_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-height: 24rem;\n  min-width: 24rem;\n  position: relative;\n"])));
var SpinnerInner = styled_components_browser_esm["default"].div(InlineRequestHandler_templateObject2 || (InlineRequestHandler_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  ", "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])), function (_ref) {
  var alignRight = _ref.alignRight;
  return alignRight ? 'flex-end' : 'center';
}, function (transparent) {
  return transparent && "background-color: ".concat(colors/* RGBAColors.white50 */.$.white50, ";");
});

var getErrorText = function getErrorText(error, statusCode) {
  var result = '';

  if (error) {
    result += ": ".concat(error);
  }

  if (statusCode) {
    result += " (code ".concat(statusCode, ")");
  }

  return result;
};

var InlineRequestHandler = function InlineRequestHandler(_ref2) {
  var children = _ref2.children,
      error = _ref2.error,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      _ref2$isError = _ref2.isError,
      isError = _ref2$isError === void 0 ? false : _ref2$isError,
      statusCode = _ref2.statusCode,
      _ref2$transparent = _ref2.transparent,
      transparent = _ref2$transparent === void 0 ? false : _ref2$transparent,
      _ref2$alignRight = _ref2.alignRight,
      alignRight = _ref2$alignRight === void 0 ? false : _ref2$alignRight;

  if (isError) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(InlineError/* default */.Z, {
      text: "Onze excuses. Er is iets misgegaan bij het ophalen van de informatie".concat(getErrorText(error, statusCode), ". Herlaad de pagina a.u.b."),
      "data-id": "organisms_InlineRequestHandler_InlineError"
    });
  }

  if (isLoading) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(SpinnerOuter, {
      "data-id": "organisms_InlineRequestHandler_SpinnerOuter",
      children: [transparent && children, /*#__PURE__*/(0,jsx_runtime.jsx)(SpinnerInner, {
        transparent: transparent,
        alignRight: alignRight,
        "data-id": "organisms_InlineRequestHandler_SpinnerInner",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
          monochrome: true,
          size: "small",
          color: colors/* colors.brand */.O.brand,
          "data-id": "organisms_InlineRequestHandler_Spinner"
        })
      })]
    });
  }

  return children;
};

/* harmony default export */ var organisms_InlineRequestHandler = (InlineRequestHandler);
;// CONCATENATED MODULE: ./src/processes/priceFormatter.ts

var addThousandDots = function addThousandDots(n) {
  return n.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
var getPriceString = function getPriceString(n) {
  var formattedPrice = addThousandDots(n.toFixed(2).replace('.', ','));

  var _formattedPrice$split = formattedPrice.split(','),
      _formattedPrice$split2 = (0,slicedToArray/* default */.Z)(_formattedPrice$split, 2),
      price = _formattedPrice$split2[0],
      decimals = _formattedPrice$split2[1];

  return "\u20AC\xA0".concat(price, ",").concat(decimals === '00' ? '–' : decimals);
};
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 167 modules
var motion = __webpack_require__(18716);
;// CONCATENATED MODULE: ./src/components/atoms/AnimatedBox.tsx


var AnimatedBox_templateObject;






var MotionDiv = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div)(AnimatedBox_templateObject || (AnimatedBox_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 2rem;\n"])));

var AnimatedBox = function AnimatedBox(_ref) {
  var animationKey = _ref.animationKey,
      children = _ref.children,
      _ref$fromTextColor = _ref.fromTextColor,
      fromTextColor = _ref$fromTextColor === void 0 ? colors/* colors.gray40 */.O.gray40 : _ref$fromTextColor,
      _ref$toTextColor = _ref.toTextColor,
      toTextColor = _ref$toTextColor === void 0 ? colors/* colors.white */.O.white : _ref$toTextColor,
      _ref$fromBackgroundCo = _ref.fromBackgroundColor,
      fromBackgroundColor = _ref$fromBackgroundCo === void 0 ? 'rgba(238, 134, 62, 0)' : _ref$fromBackgroundCo,
      _ref$toBackgroundColo = _ref.toBackgroundColor,
      toBackgroundColor = _ref$toBackgroundColo === void 0 ? 'rgba(238, 134, 62, 1)' : _ref$toBackgroundColo;

  var _useState = (0,react.useState)(false),
      shouldAnimate = _useState[0],
      setShouldAnimate = _useState[1];

  var _useState2 = (0,react.useState)(animationKey),
      key = _useState2[0];

  (0,react.useEffect)(function () {
    // Start animating on key change, when the key changes for the first time. This prevents animation on mount.
    if (animationKey !== key) {
      setShouldAnimate(true);
    }
  }, [animationKey, key]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MotionDiv, {
    initial: shouldAnimate ? {
      backgroundColor: fromBackgroundColor,
      color: fromTextColor
    } : false,
    animate: shouldAnimate ? {
      backgroundColor: [fromBackgroundColor, toBackgroundColor, toBackgroundColor, fromBackgroundColor],
      color: [fromTextColor, toTextColor, toTextColor, fromTextColor]
    } : undefined,
    transition: {
      duration: 2,
      times: [0, 0.2, 0.6, 1]
    },
    "data-id": "atoms_AnimatedBox_MotionDiv",
    children: children
  }, animationKey);
};

/* harmony default export */ var atoms_AnimatedBox = (AnimatedBox);
;// CONCATENATED MODULE: ./src/components/atoms/Price.tsx


var Price_templateObject, Price_templateObject2;







var signs = {
  minus: '− ',
  plus: '+ ',
  none: ''
};
var BACKGROUND_COLOR_MAP = {
  brand: colors/* colors.brand */.O.brand,
  transparent: 'transparent',
  gray30: 'transparent',
  gray25: 'transparent',
  gray20: 'transparent'
};
var TEXT_COLOR_MAP = {
  brand: colors/* colors.white */.O.white,
  transparent: colors/* colors.gray40 */.O.gray40,
  gray30: colors/* colors.gray30 */.O.gray30,
  gray25: colors/* colors.gray25 */.O.gray25,
  gray20: colors/* colors.gray20 */.O.gray20
};
var Price_PriceText = styled_components_browser_esm["default"].span(Price_templateObject || (Price_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  background-color: ", ";\n  ", ";\n"])), function (_ref) {
  var variant = _ref.variant;
  return variant === 'brand' && 'font-weight: 700;';
}, function (_ref2) {
  var variant = _ref2.variant;
  return TEXT_COLOR_MAP[variant];
}, function (_ref3) {
  var variant = _ref3.variant;
  return BACKGROUND_COLOR_MAP[variant];
}, function (_ref4) {
  var strikeThrough = _ref4.strikeThrough;
  return strikeThrough && 'text-decoration: line-through;';
});
var Price_Content = styled_components_browser_esm["default"].span(Price_templateObject2 || (Price_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0 2rem;\n  min-width: max-content;\n  white-space: nowrap;\n"])));

var Price_Price = function Price(_ref5) {
  var price = _ref5.price,
      _ref5$sign = _ref5.sign,
      sign = _ref5$sign === void 0 ? 'none' : _ref5$sign,
      _ref5$variant = _ref5.variant,
      variant = _ref5$variant === void 0 ? 'transparent' : _ref5$variant,
      _ref5$displayZero = _ref5.displayZero,
      displayZero = _ref5$displayZero === void 0 ? false : _ref5$displayZero,
      _ref5$animation = _ref5.animation,
      animation = _ref5$animation === void 0 ? false : _ref5$animation,
      _ref5$strikeThrough = _ref5.strikeThrough,
      strikeThrough = _ref5$strikeThrough === void 0 ? false : _ref5$strikeThrough;

  if (price === undefined || price === 0 && !displayZero) {
    return null;
  }

  var content = /*#__PURE__*/(0,jsx_runtime.jsxs)(Price_Content, {
    "data-id": "atoms_Price_Content",
    children: [signs[sign], getPriceString(price)]
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Price_PriceText, {
    variant: variant,
    strikeThrough: strikeThrough,
    "data-id": "atoms_Price_PriceText",
    children: animation ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_AnimatedBox, {
      animationKey: price,
      fromTextColor: TEXT_COLOR_MAP[variant],
      fromBackgroundColor: variant === 'brand' ? colors/* colors.brand */.O.brand : undefined,
      toBackgroundColor: variant === 'brand' ? colors/* colors.lightOrange */.O.lightOrange : undefined,
      "data-id": "atoms_Price_AnimatedBox",
      children: content
    }) : content
  });
};

/* harmony default export */ var atoms_Price = (Price_Price);
;// CONCATENATED MODULE: ./src/components/atoms/SquareMeters.tsx


var SquareMeters_templateObject, SquareMeters_templateObject2;







var Meters = styled_components_browser_esm["default"].span(SquareMeters_templateObject || (SquareMeters_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  min-width: max-content;\n  white-space: nowrap;\n"])), function (_ref) {
  var variant = _ref.variant;
  return colors/* colors */.O[variant];
});
var Sup = styled_components_browser_esm["default"].sup(SquareMeters_templateObject2 || (SquareMeters_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  top: -0.25em;\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n"])));

var SquareMeters = function SquareMeters(_ref2) {
  var squareMeters = _ref2.squareMeters,
      _ref2$withPlus = _ref2.withPlus,
      withPlus = _ref2$withPlus === void 0 ? false : _ref2$withPlus,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'gray40' : _ref2$variant,
      _ref2$displayZero = _ref2.displayZero,
      displayZero = _ref2$displayZero === void 0 ? false : _ref2$displayZero,
      _ref2$animation = _ref2.animation,
      animation = _ref2$animation === void 0 ? false : _ref2$animation;

  if (squareMeters === undefined || squareMeters === 0 && !displayZero) {
    return null;
  }

  var content = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [withPlus && '+ ', squareMeters, "m", /*#__PURE__*/(0,jsx_runtime.jsx)(Sup, {
      "data-id": "atoms_SquareMeters_Sup",
      children: "2"
    })]
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Meters, {
    variant: variant,
    "data-id": "atoms_SquareMeters_Meters",
    children: animation ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_AnimatedBox, {
      animationKey: squareMeters,
      fromTextColor: colors/* colors */.O[variant],
      "data-id": "atoms_SquareMeters_AnimatedBox",
      children: content
    }) : content
  });
};

/* harmony default export */ var atoms_SquareMeters = (SquareMeters);
;// CONCATENATED MODULE: ./src/components/atoms/svg/TrashcanIcon.tsx







var SaveIcon = function SaveIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 512 512",
    "data-id": "svg_TrashcanIcon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M432,96h-48V32c0-17.672-14.328-32-32-32H160c-17.672,0-32,14.328-32,32v64H80c-17.672,0-32,14.328-32,32v32h416v-32 C464,110.328,449.672,96,432,96z M192,96V64h128v32H192z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_TrashcanIcon_path"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M80,480.004C80,497.676,94.324,512,111.996,512h288.012C417.676,512,432,497.676,432,480.008v-0.004V192H80V480.004z M320,272c0-8.836,7.164-16,16-16s16,7.164,16,16v160c0,8.836-7.164,16-16,16s-16-7.164-16-16V272z M240,272 c0-8.836,7.164-16,16-16s16,7.164,16,16v160c0,8.836-7.164,16-16,16s-16-7.164-16-16V272z M160,272c0-8.836,7.164-16,16-16 s16,7.164,16,16v160c0,8.836-7.164,16-16,16s-16-7.164-16-16V272z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_TrashcanIcon_path_2"
    })]
  });
};

/* harmony default export */ var TrashcanIcon = (SaveIcon);
// EXTERNAL MODULE: ./src/styles/shared.ts
var shared = __webpack_require__(19264);
;// CONCATENATED MODULE: ./src/components/atoms/IconButton.tsx


var IconButton_templateObject;





var SIZE_MAP = {
  sm: 14,
  md: 18
};
var IconButton_Container = styled_components_browser_esm["default"].span(IconButton_templateObject || (IconButton_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n\n  &:hover,\n  &:focus,\n  &:active {\n    path {\n      fill: ", ";\n    }\n  }\n"])), shared/* transitions.hover */.p.hover, colors/* colors.brand */.O.brand);

var IconButton = function IconButton(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      Icon = _ref.icon,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_Container, {
    size: size,
    onClick: onClick,
    "data-id": "atoms_IconButton_Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
      height: SIZE_MAP[size],
      "data-id": "atoms_IconButton_Icon"
    })
  });
};

/* harmony default export */ var atoms_IconButton = (IconButton);
;// CONCATENATED MODULE: ./src/components/atoms/svg/EditIcon.tsx







var EditIcon = function EditIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 14 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 14 14",
    "data-id": "svg_EditIcon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.11741 8.78938L5.21229 11.8825L11.3749 5.71987L8.28179 2.625L2.11741 8.78938Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_EditIcon_path"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.7436 2.11052L11.8877 0.254641C11.5456 -0.0874844 10.9917 -0.0874844 10.6505 0.254641L9.4115 1.49189L12.5064 4.58502L13.7436 3.34777C14.0857 3.00564 14.0857 2.45264 13.7436 2.11052Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_EditIcon_path_2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 14L4.0215 13.0716L0.926625 9.97852L0 14Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_EditIcon_path_3"
    })]
  });
};

/* harmony default export */ var svg_EditIcon = (EditIcon);
;// CONCATENATED MODULE: ./src/components/molecules/OptionTitleLine.tsx



var OptionTitleLine_excluded = ["children", "title", "price", "livingSurface", "disabled", "postDeadlineNotSelected", "small", "onEdit", "onDelete", "selected", "isPriceUponRequest", "optionType"];

var OptionTitleLine_templateObject, OptionTitleLine_templateObject2, OptionTitleLine_templateObject3, OptionTitleLine_templateObject4, OptionTitleLine_templateObject5, OptionTitleLine_templateObject6, OptionTitleLine_templateObject7, OptionTitleLine_templateObject8, OptionTitleLine_templateObject9, OptionTitleLine_templateObject10, OptionTitleLine_templateObject11;

function OptionTitleLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OptionTitleLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OptionTitleLine_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OptionTitleLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var OptionTitleLine_TEXT_COLOR_MAP = {
  gray30: colors/* colors.gray30 */.O.gray30,
  gray25: colors/* colors.gray25 */.O.gray25
};
var OptionTitle = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(OptionTitleLine_templateObject || (OptionTitleLine_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(OptionTitleLine_templateObject2 || (OptionTitleLine_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16rem;\n  "]))));
var Item = styled_components_browser_esm["default"].div(OptionTitleLine_templateObject3 || (OptionTitleLine_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  gap: 16rem;\n"])));
var Input = styled_components_browser_esm["default"].div(OptionTitleLine_templateObject4 || (OptionTitleLine_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-shrink: 0;\n  width: 24rem;\n"])));
var Properties = styled_components_browser_esm["default"].div(OptionTitleLine_templateObject5 || (OptionTitleLine_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 16rem;\n  padding-left: 40rem;\n  margin-top: 8rem;\n  justify-content: flex-end;\n  flex-flow: row-reverse nowrap;\n  ", "\n  ", "\n"])), function (_ref) {
  var small = _ref.small;
  return small && (0,styled_components_browser_esm.css)(OptionTitleLine_templateObject6 || (OptionTitleLine_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      flex-direction: row;\n      justify-content: flex-start;\n    "])));
}, breakpoints/* fromBreakpoint.lg */.ks.lg(OptionTitleLine_templateObject7 || (OptionTitleLine_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 0;\n    margin-top: 0;\n    flex-direction: row;\n  "]))));
var OptionTitleLine_Text = styled_components_browser_esm["default"].span(OptionTitleLine_templateObject8 || (OptionTitleLine_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n"])), function (_ref2) {
  var variant = _ref2.variant;
  return variant && OptionTitleLine_TEXT_COLOR_MAP[variant];
});
var Buttons = styled_components_browser_esm["default"].div(OptionTitleLine_templateObject9 || (OptionTitleLine_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 8rem;\n"])));
var OptionTitleLine_PriceContainer = styled_components_browser_esm["default"].div(OptionTitleLine_templateObject10 || (OptionTitleLine_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n"])));
var PriceReference = styled_components_browser_esm["default"].span(OptionTitleLine_templateObject11 || (OptionTitleLine_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 16rem;\n  color: ", ";\n  text-transform: lowercase;\n"])), colors/* colors.gray25 */.O.gray25);

var getColor = function getColor(postDeadlineNotSelected, disabled) {
  if (postDeadlineNotSelected) {
    return 'gray30';
  }

  if (disabled) {
    return 'gray25';
  }

  return undefined;
};

var OptionTitleLine = function OptionTitleLine(_ref3) {
  var children = _ref3.children,
      title = _ref3.title,
      price = _ref3.price,
      _ref3$livingSurface = _ref3.livingSurface,
      livingSurface = _ref3$livingSurface === void 0 ? 0 : _ref3$livingSurface,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$postDeadlineNot = _ref3.postDeadlineNotSelected,
      postDeadlineNotSelected = _ref3$postDeadlineNot === void 0 ? false : _ref3$postDeadlineNot,
      _ref3$small = _ref3.small,
      small = _ref3$small === void 0 ? false : _ref3$small,
      onEdit = _ref3.onEdit,
      onDelete = _ref3.onDelete,
      _ref3$selected = _ref3.selected,
      selected = _ref3$selected === void 0 ? false : _ref3$selected,
      _ref3$isPriceUponRequ = _ref3.isPriceUponRequest,
      isPriceUponRequest = _ref3$isPriceUponRequ === void 0 ? false : _ref3$isPriceUponRequ,
      optionType = _ref3.optionType,
      boxProps = (0,objectWithoutProperties/* default */.Z)(_ref3, OptionTitleLine_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OptionTitle, OptionTitleLine_objectSpread(OptionTitleLine_objectSpread({}, boxProps), {}, {
    "data-id": "molecules_OptionTitleLine_OptionTitle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
      "data-id": "molecules_OptionTitleLine_Item",
      children: [!!children && /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
        "data-id": "molecules_OptionTitleLine_Input",
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
        level: 3,
        size: small ? 'xs' : 'sm',
        text: title,
        variant: getColor(postDeadlineNotSelected, disabled),
        "data-id": "molecules_OptionTitleLine_Title"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Properties, {
      small: small,
      "data-id": "molecules_OptionTitleLine_Properties",
      children: [livingSurface > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_SquareMeters, {
        squareMeters: livingSurface,
        withPlus: true,
        variant: getColor(postDeadlineNotSelected, disabled),
        "data-id": "molecules_OptionTitleLine_SquareMeters"
      }), isPriceUponRequest ? /*#__PURE__*/(0,jsx_runtime.jsx)(OptionTitleLine_Text, {
        variant: getColor(postDeadlineNotSelected, disabled),
        "data-id": "molecules_OptionTitleLine_Text",
        children: "Op aanvraag"
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(OptionTitleLine_PriceContainer, {
        "data-id": "molecules_OptionTitleLine_PriceContainer",
        children: [optionType === 'reference' && /*#__PURE__*/(0,jsx_runtime.jsx)(PriceReference, {
          "data-id": "molecules_OptionTitleLine_PriceReference",
          children: "circa"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Price, {
          price: price,
          sign: "plus",
          variant: getColor(postDeadlineNotSelected, disabled),
          displayZero: true,
          strikeThrough: selected && disabled,
          "data-id": "molecules_OptionTitleLine_Price"
        })]
      }), (!!onEdit || !!onDelete) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Buttons, {
        "data-id": "molecules_OptionTitleLine_Buttons",
        children: [!!onEdit && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_IconButton, {
          icon: svg_EditIcon,
          onClick: onEdit,
          size: "sm",
          "data-id": "molecules_OptionTitleLine_IconButton"
        }), !!onDelete && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_IconButton, {
          icon: TrashcanIcon,
          onClick: onDelete,
          size: "sm",
          "data-id": "molecules_OptionTitleLine_IconButton_12"
        })]
      })]
    })]
  }));
};

/* harmony default export */ var molecules_OptionTitleLine = (OptionTitleLine);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
;// CONCATENATED MODULE: ./src/components/atoms/svg/CheckmarkIcon.tsx






var CheckmarkIcon = function CheckmarkIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 11 9",
    "data-id": "svg_CheckmarkIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4.1642 4.63755L2.60115 3.04632C2.2807 2.72455 1.75963 2.72455 1.43802 3.04747L0.25 4.24094L4.14821 8.09249L10.75 1.43564L9.56181 0.24234C9.24103 -0.0800924 8.71979 -0.0810814 8.39868 0.241186L4.1642 4.63755Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_CheckmarkIcon_path"
    })
  });
};

/* harmony default export */ var svg_CheckmarkIcon = (CheckmarkIcon);
;// CONCATENATED MODULE: ./src/hooks/useBreakpointInfo.ts





/**
 * Whether a the min-width requirement for a BreakpointSize is met
 */
var useBreakpointInfo = function useBreakpointInfo() {
  var isHighResolutionRef = (0,react.useRef)(false);

  var _useState = (0,react.useState)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, breakpoints/* BreakpointSize.xxl */.EC.xxl, false), breakpoints/* BreakpointSize.xl */.EC.xl, false), breakpoints/* BreakpointSize.slg */.EC.slg, false), breakpoints/* BreakpointSize.lg */.EC.lg, false), breakpoints/* BreakpointSize.md */.EC.md, false), breakpoints/* BreakpointSize.sm */.EC.sm, true)),
      breakpointInfo = _useState[0],
      setBreakpointInfo = _useState[1];

  var updateBreakpoint = (0,react.useCallback)(function () {
    var result = {};
    var entries = Object.entries(breakpoints/* breakpointSizesInEm */.uY);
    entries.forEach(function (_ref) {
      var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      result[key] = window.matchMedia("(min-width: ".concat(value, "em)")).matches;
    });
    setBreakpointInfo(result);
  }, []);
  (0,react.useEffect)(function () {
    isHighResolutionRef.current = window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)').matches;
    updateBreakpoint();
    window.addEventListener('resize', updateBreakpoint);
    return function () {
      return window.removeEventListener('resize', updateBreakpoint);
    };
  }, [updateBreakpoint]);
  return {
    isLargerThan: breakpointInfo,
    isHighResolution: isHighResolutionRef.current
  };
};

/* harmony default export */ var hooks_useBreakpointInfo = (useBreakpointInfo);
;// CONCATENATED MODULE: ./src/components/atoms/ResponsiveTable.tsx


var ResponsiveTable_templateObject, ResponsiveTable_templateObject2, ResponsiveTable_templateObject3, ResponsiveTable_templateObject4, ResponsiveTable_templateObject5, ResponsiveTable_templateObject6, ResponsiveTable_templateObject7, ResponsiveTable_templateObject8, ResponsiveTable_templateObject9, ResponsiveTable_templateObject10, ResponsiveTable_templateObject11, ResponsiveTable_templateObject12, ResponsiveTable_templateObject13, ResponsiveTable_templateObject14;








var StyledTable = styled_components_browser_esm["default"].table(ResponsiveTable_templateObject || (ResponsiveTable_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  border-spacing: 2rem;\n  width: calc(100% + 4rem);\n  margin: 0 -2rem;\n  text-align: left;\n  ", "\n  ", "\n"])), function (_ref) {
  var breakpoint = _ref.breakpoint;
  return breakpoints/* toBreakpoint */.Hx[breakpoint](ResponsiveTable_templateObject2 || (ResponsiveTable_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["display:block;"])));
}, fonts/* fontStyles.body.sm */.g6.body.sm, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && "color: ".concat(colors/* colors.gray20 */.O.gray20, ";");
});
var StyledThead = styled_components_browser_esm["default"].thead(ResponsiveTable_templateObject3 || (ResponsiveTable_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), function (_ref3) {
  var breakpoint = _ref3.breakpoint;
  return breakpoints/* toBreakpoint */.Hx[breakpoint](ResponsiveTable_templateObject4 || (ResponsiveTable_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["display:block;"])));
});
var StyledTbody = styled_components_browser_esm["default"].tbody(ResponsiveTable_templateObject5 || (ResponsiveTable_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), function (_ref4) {
  var breakpoint = _ref4.breakpoint;
  return breakpoints/* toBreakpoint */.Hx[breakpoint](ResponsiveTable_templateObject6 || (ResponsiveTable_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["display:block;"])));
});
var StyledTr = styled_components_browser_esm["default"].tr(ResponsiveTable_templateObject7 || (ResponsiveTable_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  border-bottom: 1rem solid ", ";\n  ", "\n"])), colors/* colors.gray10 */.O.gray10, colors/* colors.white */.O.white, function (_ref5) {
  var breakpoint = _ref5.breakpoint;
  return breakpoints/* toBreakpoint */.Hx[breakpoint](ResponsiveTable_templateObject8 || (ResponsiveTable_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["display: block;"])));
});
var StyledTh = styled_components_browser_esm["default"].th(ResponsiveTable_templateObject9 || (ResponsiveTable_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 2rem 4rem 1rem;\n  ", "\n"])), function (_ref6) {
  var breakpoint = _ref6.breakpoint;
  return breakpoints/* toBreakpoint */.Hx[breakpoint](ResponsiveTable_templateObject10 || (ResponsiveTable_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["display:block;"])));
});
var StyledTd = styled_components_browser_esm["default"].td(ResponsiveTable_templateObject11 || (ResponsiveTable_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 1rem 4rem;\n  ", "\n  ", "\n  ", "\n"])), function (_ref7) {
  var first = _ref7.first;
  return first && "padding-top: 2rem;";
}, function (_ref8) {
  var last = _ref8.last;
  return last && "padding-bottom: 2rem;";
}, function (_ref9) {
  var breakpoint = _ref9.breakpoint;
  return breakpoints/* toBreakpoint */.Hx[breakpoint](ResponsiveTable_templateObject12 || (ResponsiveTable_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: block;\n      position: relative;\n      padding-left: calc(30% + 8rem);\n      white-space: pre-wrap;\n      overflow-wrap: break-word;\n    "])));
});
var TdBefore = styled_components_browser_esm["default"].div(ResponsiveTable_templateObject13 || (ResponsiveTable_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), function (_ref10) {
  var breakpoint = _ref10.breakpoint,
      first = _ref10.first;
  return breakpoints/* toBreakpoint */.Hx[breakpoint](ResponsiveTable_templateObject14 || (ResponsiveTable_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: absolute;\n    display: block;\n    top: ", ";\n    left: 4rem;\n    width: calc(30% - 16rem);\n    white-space: pre-wrap;\n    overflow-wrap: break-word;\n    font-weight: 700;\n  "])), first ? "2rem" : "1rem");
});

var ResponsiveTable = function ResponsiveTable(_ref11) {
  var headers = _ref11.headers,
      content = _ref11.content,
      _ref11$breakpointSize = _ref11.breakpointSize,
      breakpointSize = _ref11$breakpointSize === void 0 ? breakpoints/* BreakpointSize.lg */.EC.lg : _ref11$breakpointSize,
      _ref11$disabled = _ref11.disabled,
      disabled = _ref11$disabled === void 0 ? false : _ref11$disabled;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      isLargerThan = _useBreakpointInfo.isLargerThan;

  if (content.length === 0) {
    return null;
  }

  var breakpoint = isLargerThan[breakpointSize];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTable, {
    breakpoint: breakpointSize,
    disabled: disabled,
    "data-id": "atoms_ResponsiveTable_StyledTable",
    children: [breakpoint && !!headers && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledThead, {
      breakpoint: breakpointSize,
      "data-id": "atoms_ResponsiveTable_StyledThead",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTr, {
        breakpoint: breakpointSize,
        "data-id": "atoms_ResponsiveTable_StyledTr",
        children: headers.map(function (header) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTh, {
            breakpoint: breakpointSize,
            "data-id": "atoms_ResponsiveTable_StyledTh",
            children: header
          }, header);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTbody, {
      breakpoint: breakpointSize,
      "data-id": "atoms_ResponsiveTable_StyledTbody",
      children: content.map(function (items, rowIndex) {
        var _headers$rowIndex;

        var trKey = (_headers$rowIndex = headers === null || headers === void 0 ? void 0 : headers[rowIndex]) !== null && _headers$rowIndex !== void 0 ? _headers$rowIndex : rowIndex;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTr, {
          breakpoint: breakpointSize,
          "data-id": "atoms_ResponsiveTable_StyledTr",
          children: items.map(function (_ref12, columnIndex) {
            var key = _ref12.key,
                item = _ref12.item;

            if (!item && !breakpoint) {
              return null;
            }

            var first = columnIndex === 0 && !breakpoint;
            var last = rowIndex === content.length - 1;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTd, {
              breakpoint: breakpointSize,
              first: first,
              last: last,
              "data-id": "atoms_ResponsiveTable_StyledTd",
              children: [!breakpoint && !!(headers !== null && headers !== void 0 && headers[columnIndex]) && /*#__PURE__*/(0,jsx_runtime.jsxs)(TdBefore, {
                breakpoint: breakpointSize,
                first: first,
                last: last,
                "data-id": "atoms_ResponsiveTable_TdBefore",
                children: [headers === null || headers === void 0 ? void 0 : headers[columnIndex], ":"]
              }), item]
            }, key);
          })
        }, trKey);
      })
    })]
  });
};

/* harmony default export */ var atoms_ResponsiveTable = (ResponsiveTable);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./src/processes/dateTime.ts

var LOCALE = 'nl-NL';
/**
 * Takes ISO 8601 datestring and considers it expired if it is after "now"
 */

var isDateExpired = function isDateExpired(isoString) {
  try {
    if (!isoString) {
      return true;
    }

    var date = new Date(isoString);
    return date.getTime() < Date.now();
  } catch (error) {
    (0,esm_exports/* captureException */.Tb)('isDateExpired failed', {
      extra: {
        isoString: isoString,
        error: error
      }
    });
    return false;
  }
};
/**
 * Takes ISO 8601 datestring and formats as date, no time, with full month, e.g. 1 januari 1970
 */

var formatDateWithFullMonth = function formatDateWithFullMonth(isoString) {
  try {
    var date = new Date(isoString);
    return new Intl.DateTimeFormat(LOCALE, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  } catch (error) {
    (0,esm_exports/* captureException */.Tb)('formatDateWithFullMonth failed', {
      extra: {
        isoString: isoString,
        error: error
      }
    });
    return isoString;
  }
};
/**
 * Takes ISO 8601 datestring and formats as date, no time, with full month, e.g. 1 januari 1970
 */

var formatShortDate = function formatShortDate(isoString) {
  try {
    var date = new Date(isoString.replace(' ', 'T'));
    return new Intl.DateTimeFormat(LOCALE, {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    }).format(date);
  } catch (error) {
    (0,esm_exports/* captureException */.Tb)('formatShortDate failed', {
      extra: {
        isoString: isoString,
        error: error
      }
    });
    return '';
  }
};
;// CONCATENATED MODULE: ./src/processes/houseDesignStatuses.ts

var OptionStatus;

(function (OptionStatus) {
  OptionStatus["disabled"] = "disabled";
  OptionStatus["excluded"] = "excluded";
  OptionStatus["final"] = "final";
  OptionStatus["new"] = "new";
  OptionStatus["pending"] = "pending";
  OptionStatus["actionRequired"] = "actionRequired";
})(OptionStatus || (OptionStatus = {}));

var ORDER_STATUS_OPTION_STATUS_MAP = {
  blocked: OptionStatus.disabled,
  confirmed: OptionStatus.pending,
  included: OptionStatus["final"],
  presold: OptionStatus["final"],
  processing: OptionStatus.pending,
  processed: OptionStatus.actionRequired,
  requested: OptionStatus.pending,
  signed: OptionStatus["final"]
}; // -------------
// Order helpers

var sortOrdersByDateDesc = function sortOrdersByDateDesc(_ref, _ref2) {
  var a = _ref.lastUpdate;
  var b = _ref2.lastUpdate;
  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};
/**
 * Filter out orders with a status that does not have to be displayed in the front end.
 * We filter out blocked and cancelled orders, unless there are only blocked and cancelled orders, in that case we display only the most recent one
 */

var filterOutIrrelevantBlockedAndCancelledOrders = function filterOutIrrelevantBlockedAndCancelledOrders(orders) {
  if (orders.length <= 1) {
    return orders;
  }

  var blockedAndCancelledOrders = [];
  var nonBlockedAndCancelledOrders = [];
  orders.forEach(function (order) {
    if (order.status === 'blocked') {
      blockedAndCancelledOrders.push(order);
      return;
    }

    nonBlockedAndCancelledOrders.push(order);
  });

  if (nonBlockedAndCancelledOrders.length === 0) {
    if (blockedAndCancelledOrders.length === 0) {
      return [];
    }

    var mostRecentBlockedOrCancelledOrder = blockedAndCancelledOrders.splice(0, 1)[0];
    blockedAndCancelledOrders.forEach(function (order) {
      if (order.lastUpdate > mostRecentBlockedOrCancelledOrder.lastUpdate) {
        mostRecentBlockedOrCancelledOrder = order;
      }
    });
    return [mostRecentBlockedOrCancelledOrder];
  }

  return nonBlockedAndCancelledOrders;
};
/**
 * Get the status of an option. This status is to determine how to display the option
 */

var getOptionStatus = function getOptionStatus(_ref3) {
  var isDisabled = _ref3.isDisabled,
      isExcluded = _ref3.isExcluded,
      isFinal = _ref3.isFinal,
      isNew = _ref3.isNew,
      isPending = _ref3.isPending,
      isActionRequired = _ref3.isActionRequired;

  if (isDisabled) {
    return OptionStatus.disabled;
  }

  if (isFinal) {
    return OptionStatus["final"];
  }

  if (isExcluded) {
    return OptionStatus.excluded;
  }

  if (isActionRequired) {
    return OptionStatus.actionRequired;
  }

  if (isPending) {
    return OptionStatus.pending;
  }

  if (isNew) {
    return OptionStatus["new"];
  }

  return undefined;
};
/**
 * Determine if an order is "final"
 */

var isOrderFinal = function isOrderFinal(_ref4) {
  var status = _ref4.status;
  return ORDER_STATUS_OPTION_STATUS_MAP[status] === OptionStatus["final"];
};
/**
 * Determine if an order is "pending"
 */

var isOrderPending = function isOrderPending(_ref5) {
  var status = _ref5.status;
  return ORDER_STATUS_OPTION_STATUS_MAP[status] === OptionStatus.pending;
};
/**
 * Determine if an order is "actionRequired"
 */

var isOrderActionRequired = function isOrderActionRequired(_ref6) {
  var status = _ref6.status;
  return ORDER_STATUS_OPTION_STATUS_MAP[status] === OptionStatus.actionRequired;
}; // -----------------
// Includes/excludes

/**
 * Is the option selected, where "selected" means either selected in the UI or having a pending/final order
 */

var isOptionSelected = function isOptionSelected(_ref7) {
  var amount = _ref7.amount,
      orders = _ref7.orders;

  if (amount >= 1) {
    return true;
  }

  for (var _i = 0; _i < orders.length; _i += 1) {
    if (isOrderFinal(orders[_i]) || isOrderPending(orders[_i])) {
      return true;
    }
  }

  return false;
};
/**
 * Get set of the ids for excluded options
 */

var getExcludedOptionIds = function getExcludedOptionIds(_ref8) {
  var categories = _ref8.categories;
  var excludeIds = [];
  categories.forEach(function (_ref9) {
    var subcategories = _ref9.subcategories;
    subcategories.forEach(function (_ref10) {
      var options = _ref10.options;
      options.forEach(function (option) {
        var selected = isOptionSelected(option);

        if (!!option.excludes && selected) {
          excludeIds = [].concat((0,toConsumableArray/* default */.Z)(excludeIds), (0,toConsumableArray/* default */.Z)(option.excludes));
        }

        if (!!option.includes && !selected) {
          excludeIds = [].concat((0,toConsumableArray/* default */.Z)(excludeIds), (0,toConsumableArray/* default */.Z)(option.includes));
        }
      });
    });
  });
  return new Set(excludeIds);
}; // --------------
// Option helpers

/**
 * Determine if an option should be disabled ("vervallen")
 */

var isOptionDisabled = function isOptionDisabled(_ref11) {
  var orders = _ref11.orders;
  return orders.some(function (_ref12) {
    var status = _ref12.status;
    return status === 'blocked';
  });
};
/**
 * Determine if an option can be displayed as "final", i.e. selected and no longer editable
 * Note that an option with multiple: true is still editable if it includes "final" orders
 */

var isOptionFinal = function isOptionFinal(_ref13) {
  var orders = _ref13.orders,
      multiple = _ref13.multiple;
  return orders.some(isOrderFinal) && multiple === false;
};
/**
 * Determine if a "new" label should be displayed for an option
 */

var isOptionNew = function isOptionNew(_ref14) {
  var flag = _ref14.flag;
  return flag === 'new';
};
/**
 * Determine if an option should be pending ("in behandeling")
 */

var isOptionPending = function isOptionPending(_ref15) {
  var orders = _ref15.orders,
      multiple = _ref15.multiple;
  return orders.some(isOrderPending) && multiple === false;
};
/**
 * Determine if an option should be actionRequired ("actie vereist")
 */

var isOptionActionRequired = function isOptionActionRequired(_ref16) {
  var orders = _ref16.orders;
  return orders.some(isOrderActionRequired);
};
/**
 * Determine if an option is excluded: this can be due to being in the excludes of a selected option, or due to not being in the includes of a not selected option
 */

var isOptionExcluded = function isOptionExcluded(option, wishList) {
  if (!wishList) {
    return false;
  }

  if (isOptionFinal(option) || isOptionPending(option)) {
    return false;
  }

  var uuid = option.uuid;
  return getExcludedOptionIds(wishList).has(uuid);
};
/**
 * Determines whether the amount of an option should be included in the cumulatives for price and living space, on top of the orders
 */

var shouldIncludeOptionForTotals = function shouldIncludeOptionForTotals(option, wishList) {
  return !isOptionFinal(option) && !isOptionDisabled(option) && !isOptionExcluded(option, wishList) && !isOptionPending(option);
};
/**
 * Get the total amount for an option, based on the amount and the orders, taking various statuses into account
 */

var houseDesignStatuses_getTotalAmountForOption = function getTotalAmountForOption(option, wishList) {
  var amount = option.amount,
      orders = option.orders;

  if (isOptionDisabled(option)) {
    return 0;
  }

  var totalAmountForOrders = orders.reduce(function (ordersTotal, _ref17) {
    var amount = _ref17.amount,
        status = _ref17.status;

    if (status === 'blocked') {
      return ordersTotal;
    }

    return ordersTotal + amount;
  }, 0);

  if (shouldIncludeOptionForTotals(option, wishList)) {
    return totalAmountForOrders + amount;
  }

  return totalAmountForOrders;
};
/**
 * Determine whether an option is final; to be used after the deadline for the subcategory has passed
 */

var isOptionFinalPostDeadline = function isOptionFinalPostDeadline(option, wishList) {
  return houseDesignStatuses_getTotalAmountForOption(option, wishList) > 0;
}; // ----------------
// Category and subategory helpers

/**
 * Return a list of final options and a list of not selected options for a subcategory; to be used after the deadline for the subcategory has passed
 */

var getPostDeadlineOptions = function getPostDeadlineOptions(_ref18) {
  var options = _ref18.options;
  var result = {
    selected: [],
    notSelected: []
  };
  options.forEach(function (option) {
    if (isOptionFinal(option) || houseDesignStatuses_getTotalAmountForOption(option) > 0) {
      result.selected.push(option);
      return;
    }

    result.notSelected.push(option);
  });
  return result;
};
/**
 * Determine if a category has options labeled as new
 */

var hasNewOptions = function hasNewOptions(subcategories) {
  return subcategories.some(function (_ref19) {
    var options = _ref19.options;
    return options.some(isOptionNew);
  });
};
/**
 * Get list of all new options in a category
 */

var getAllNewOptions = function getAllNewOptions(subcategories) {
  return subcategories.reduce(function (acc, _ref20) {
    var options = _ref20.options;
    return [].concat((0,toConsumableArray/* default */.Z)(acc), (0,toConsumableArray/* default */.Z)(options.filter(isOptionNew)));
  }, []);
};
;// CONCATENATED MODULE: ./src/components/molecules/Orders.tsx



var Orders_templateObject, Orders_templateObject2, Orders_templateObject3, Orders_templateObject4, Orders_templateObject5, Orders_templateObject6, Orders_templateObject7;
















var sharedStyles = function sharedStyles(_ref) {
  var disabled = _ref.disabled;
  return (0,styled_components_browser_esm.css)(Orders_templateObject || (Orders_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  ", "\n"])), fonts/* fontStyles.body.sm */.g6.body.sm, disabled ? "color: ".concat(colors/* colors.gray20 */.O.gray20, ";") : '');
};

var Orders_Date = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(Orders_templateObject2 || (Orders_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  min-width: 96rem;\n"])), sharedStyles);
var Amount = styled_components_browser_esm["default"].div(Orders_templateObject3 || (Orders_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  min-width: 60rem;\n  flex-grow: 1;\n"])), sharedStyles);
var Orders_Description = styled_components_browser_esm["default"].div(Orders_templateObject4 || (Orders_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  flex-grow: 10;\n  display: flex;\n  justify-content: flex-start;\n  gap: 4rem;\n  align-items: flex-start;\n"])), sharedStyles);
var PriceBox = styled_components_browser_esm["default"].div(Orders_templateObject5 || (Orders_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  min-width: 96rem;\n  ", "\n"])), sharedStyles, breakpoints/* fromBreakpoint.lg */.ks.lg(Orders_templateObject6 || (Orders_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    text-align: right;"]))));
var Icon = styled_components_browser_esm["default"].div(Orders_templateObject7 || (Orders_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 0.1em;\n"])));

var Orders = function Orders(_ref2) {
  var _ref2$option = _ref2.option,
      multiple = _ref2$option.multiple,
      orders = _ref2$option.orders,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  var tableConfig = (0,react.useMemo)(function () {
    var filteredOrders = filterOutIrrelevantBlockedAndCancelledOrders(orders);

    if (!filteredOrders || filteredOrders.length === 0) {
      return undefined;
    }

    filteredOrders.sort(sortOrdersByDateDesc);
    return {
      headers: ['Datum'].concat((0,toConsumableArray/* default */.Z)(multiple ? ['Aantal'] : []), ['Status', 'Prijs']),
      content: filteredOrders.map(function (order) {
        var amount = order.amount,
            id = order.id,
            lastUpdate = order.lastUpdate,
            placeDescription = order.placeDescription,
            salesPrice = order.salesPrice;
        var isFinal = isOrderFinal(order);
        return [{
          key: "Datum-".concat(id),
          item: lastUpdate ? /*#__PURE__*/(0,jsx_runtime.jsx)(Orders_Date, {
            disabled: disabled,
            "data-id": "molecules_Orders_Date",
            children: formatShortDate(lastUpdate)
          }) : null
        }].concat((0,toConsumableArray/* default */.Z)(multiple ? [{
          key: "Aantal-".concat(id),
          item: multiple ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Amount, {
            disabled: disabled,
            "data-id": "molecules_Orders_Amount",
            children: [amount, " stuk", amount > 1 ? 's' : '']
          }) : null
        }] : []), [{
          key: "Status-".concat(id),
          item: /*#__PURE__*/(0,jsx_runtime.jsxs)(Orders_Description, {
            disabled: disabled,
            "data-id": "molecules_Orders_Description",
            children: [isFinal && !disabled && /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
              "data-id": "molecules_Orders_Icon",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(svg_CheckmarkIcon, {
                variant: "green",
                width: 14,
                "data-id": "molecules_Orders_CheckmarkIcon"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              "data-id": "molecules_Orders_span",
              children: placeDescription
            })]
          })
        }, {
          key: "Prijs-".concat(id),
          item: /*#__PURE__*/(0,jsx_runtime.jsx)(PriceBox, {
            disabled: disabled,
            "data-id": "molecules_Orders_PriceBox",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Price, {
              price: salesPrice,
              variant: disabled ? 'gray20' : undefined,
              displayZero: true,
              "data-id": "molecules_Orders_Price"
            })
          })
        }]);
      })
    };
  }, [disabled, multiple, orders]);

  if (!tableConfig) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    marginTop: "md",
    "data-id": "molecules_Orders_Box",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
      size: "xs",
      text: "Mijn keuze".concat(multiple && orders.length > 1 ? 's' : ''),
      variant: disabled ? 'gray25' : undefined,
      "data-id": "molecules_Orders_Title"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      marginTop: "xs",
      "data-id": "molecules_Orders_Box",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_ResponsiveTable, {
        disabled: disabled,
        headers: tableConfig.headers,
        content: tableConfig.content,
        "data-id": "molecules_Orders_ResponsiveTable"
      })
    })]
  });
};

/* harmony default export */ var molecules_Orders = (Orders);
;// CONCATENATED MODULE: ./src/components/atoms/StatusLabel.tsx



var StatusLabel_templateObject;







var OPTIONS_STATUS_LABEL_MAP = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, OptionStatus.disabled, 'Vervallen'), OptionStatus.excluded, 'Niet selecteerbaar'), OptionStatus.final, 'Definitief'), OptionStatus["new"], 'Nieuw'), OptionStatus.pending, 'In behandeling'), OptionStatus.actionRequired, 'Actie vereist');

var OPTIONS_STATUS_COLOR_MAP = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, OptionStatus.disabled, colors/* colors.gray20 */.O.gray20), OptionStatus.excluded, colors/* colors.gray20 */.O.gray20), OptionStatus.final, colors/* colors.green */.O.green), OptionStatus["new"], colors/* colors.brand */.O.brand), OptionStatus.pending, colors/* colors.blue */.O.blue), OptionStatus.actionRequired, colors/* colors.brand */.O.brand);

var StatusLabel_Pill = styled_components_browser_esm["default"].span(StatusLabel_templateObject || (StatusLabel_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  font-weight: ", ";\n  background-color: ", ";\n  color: ", ";\n  padding: 4rem 8rem;\n  border-radius: 4rem;\n  position: relative;\n\n  &::after {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    left: 50%;\n    top: 100%;\n    margin-left: -6rem;\n    border-left: 6rem solid transparent;\n    border-right: 6rem solid transparent;\n    border-top: 6rem solid ", ";\n  }\n"])), fonts/* fontStyles.body.sm */.g6.body.sm, fonts/* fontWeight.bold */.Ue.bold, function (_ref) {
  var optionStatus = _ref.optionStatus;
  return OPTIONS_STATUS_COLOR_MAP[optionStatus];
}, colors/* colors.white */.O.white, function (_ref2) {
  var optionStatus = _ref2.optionStatus;
  return OPTIONS_STATUS_COLOR_MAP[optionStatus];
});

var StatusLabel = function StatusLabel(_ref3) {
  var optionStatus = _ref3.optionStatus;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StatusLabel_Pill, {
    optionStatus: optionStatus,
    "data-id": "atoms_StatusLabel_Pill",
    children: OPTIONS_STATUS_LABEL_MAP[optionStatus]
  });
};

/* harmony default export */ var atoms_StatusLabel = (StatusLabel);
// EXTERNAL MODULE: ./src/components/atoms/Button.tsx
var atoms_Button = __webpack_require__(68477);
// EXTERNAL MODULE: ./src/hooks/useParams.ts
var useParams = __webpack_require__(35847);
;// CONCATENATED MODULE: ./src/hooks/useRenderWidth.ts


var useRenderWidth = function useRenderWidth() {
  var _useState = (0,react.useState)(0),
      width = _useState[0],
      setWidth = _useState[1];

  (0,react.useEffect)(function () {
    var handleResize = function handleResize() {
      return setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return width;
};

/* harmony default export */ var hooks_useRenderWidth = (useRenderWidth);
;// CONCATENATED MODULE: ./src/hooks/useOpenLegacyModal.ts
/**
 * Note: .storybook/mocks/useOpenLegacyModal.ts is a mock for this hook.
 */
// eslint-disable-next-line import/no-cycle






/**
 * Helper to get simplified functions for opening various modal types in the old design/implementation.
 */
var useOpenLegacyModal = function useOpenLegacyModal() {
  var _useParams = (0,useParams/* default */.Z)(),
      projectSlug = _useParams.projectSlug;

  var renderWidth = hooks_useRenderWidth();
  var dispatch = (0,es/* useDispatch */.I0)();

  var dispatchOpenModal = function dispatchOpenModal(properties) {
    return dispatch((0,redux_modal/* openModal */.h7)(colors/* colors.brand */.O.brand, properties));
  };

  return {
    // CategoryDescriptionModal
    openCategoryDescriptionModal: function openCategoryDescriptionModal(modalId) {
      return dispatchOpenModal({
        type: 'categoryDescription',
        componentProps: {
          projectSlug: projectSlug,
          modalId: modalId,
          renderWidth: renderWidth
        }
      });
    },
    // DeadlineModal
    openDeadlinesDescriptionModal: function openDeadlinesDescriptionModal() {
      return dispatchOpenModal({
        type: 'deadlinesDescription'
      });
    },
    // ProductOptionDescriptionModal
    openFullDescriptionModal: function openFullDescriptionModal(modalId) {
      return dispatchOpenModal({
        type: 'fullDescription',
        componentProps: {
          projectSlug: projectSlug,
          modalId: modalId
        }
      });
    },
    // ProductOptionRequestModal
    openOrderRequestModal: function openOrderRequestModal(modalId, amount, options) {
      return dispatchOpenModal({
        type: 'orderRequest',
        componentProps: {
          projectSlug: projectSlug,
          modalId: modalId,
          amount: amount,
          options: options
        }
      });
    },
    // CategorySubDescriptionModal
    openSubcategoryDescriptionModal: function openSubcategoryDescriptionModal(modalId) {
      return dispatchOpenModal({
        type: 'subCategoryDescription',
        componentProps: {
          projectSlug: projectSlug,
          modalId: modalId,
          renderWidth: renderWidth
        }
      });
    },
    openFormWizardModal: function openFormWizardModal(formId) {
      dispatchOpenModal({
        type: 'formWizard',
        componentProps: {
          formId: formId
        }
      });
    }
  };
};

/* harmony default export */ var hooks_useOpenLegacyModal = (useOpenLegacyModal);
// EXTERNAL MODULE: ./src/components/atoms/TextButton.tsx
var TextButton = __webpack_require__(32194);
;// CONCATENATED MODULE: ./src/components/atoms/svg/UnionIcon.tsx







var UnionIcon = function UnionIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 8 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 8 8",
    "data-id": "svg_UnionIcon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#clip0_820_50465)",
      "data-id": "svg_UnionIcon_g",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.72714 0.268253C7.57092 0.103167 7.34831 0.00012207 7.0981 0.00012207H4.18327L4.16477 0.000313686H3.32127V0.83549H3.32201L3.32182 0.853934C3.32182 1.32548 3.70134 1.70775 4.18327 1.70774L6.27473 1.70774L6.27473 3.78061C6.27473 4.24933 6.64615 4.62031 7.10964 4.63401V4.63534H7.99993V3.18353H7.99768L7.99768 0.891706C7.99768 0.643716 7.89371 0.423085 7.72714 0.268253ZM0.272783 7.732C0.429004 7.89709 0.651615 8.00013 0.901831 8.00013L3.81666 8.00013L3.83515 7.99994H4.67865V7.16477H4.67791L4.67811 7.14632C4.67811 6.67478 4.29858 6.29251 3.81666 6.29251L1.72519 6.29251L1.72519 4.21965C1.72519 3.75093 1.35377 3.37995 0.890286 3.36625L0.890286 3.36491L-6.0948e-06 3.36491L-6.30647e-06 4.81672H0.00224598L0.00224573 7.10855C0.00224573 7.35654 0.106216 7.57717 0.272783 7.732ZM4.69568 3.9993C4.69568 4.40169 4.36656 4.72788 3.96056 4.72788C3.55456 4.72788 3.22544 4.40169 3.22544 3.9993C3.22544 3.59691 3.55456 3.27071 3.96056 3.27071C4.36656 3.27071 4.69568 3.59691 4.69568 3.9993Z",
        fill: constants_colors/* ICON_COLORS */.M[variant],
        "data-id": "svg_UnionIcon_path"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      "data-id": "svg_UnionIcon_defs",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_820_50465",
        "data-id": "svg_UnionIcon_clipPath",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "8",
          height: "8",
          fill: constants_colors/* ICON_COLORS */.M[variant],
          "data-id": "svg_UnionIcon_rect"
        })
      })
    })]
  });
};

/* harmony default export */ var svg_UnionIcon = (UnionIcon);
// EXTERNAL MODULE: ./src/components/molecules/Banner.tsx + 2 modules
var molecules_Banner = __webpack_require__(38105);
;// CONCATENATED MODULE: ./src/components/molecules/OptionIncludedMessage.tsx





var OptionIncludedMessage = function OptionIncludedMessage(_ref) {
  var included = _ref.included;

  if (!included || included.length === 0) {
    return null;
  }

  var _included$reduce = included.reduce(function (_ref2, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref2, 2),
        _totalAmount = _ref4[0],
        _titles = _ref4[1];

    var amount = _ref3.amount,
        title = _ref3.title;
    return [_totalAmount + amount, [].concat((0,toConsumableArray/* default */.Z)(_titles), [title])];
  }, [0, []]),
      _included$reduce2 = (0,slicedToArray/* default */.Z)(_included$reduce, 2),
      totalAmount = _included$reduce2[0],
      titles = _included$reduce2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
    bold: true,
    text: "Deze optie is al ".concat(totalAmount, "\xD7 inbegrepen bij je gekozen ").concat(titles.length === 1 ? "pakket (".concat(titles[0], ")") : "pakketten (".concat(titles.join(', '), ")")),
    "data-id": "molecules_OptionIncludedMessage_Text"
  });
};

/* harmony default export */ var molecules_OptionIncludedMessage = (OptionIncludedMessage);
;// CONCATENATED MODULE: ./src/components/organisms/Option.tsx


var Option_templateObject, Option_templateObject2, Option_templateObject3, Option_templateObject4, Option_templateObject5, Option_templateObject6, Option_templateObject7;










 // eslint-disable-next-line import/no-cycle













var Option_Container = styled_components_browser_esm["default"].div(Option_templateObject || (Option_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top: 1rem dashed ", ";\n"])), colors/* colors.gray20 */.O.gray20);
var OptionSubtitle = styled_components_browser_esm["default"].div(Option_templateObject2 || (Option_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 16rem;\n"])));
var OptionContent = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(Option_templateObject3 || (Option_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), function (_ref) {
  var hasInput = _ref.hasInput;
  return hasInput && "padding-left: 40rem;";
});
var Columns = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(Option_templateObject4 || (Option_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), function (_ref2) {
  var hasChildren = _ref2.hasChildren;
  return hasChildren && breakpoints/* fromBreakpoint.lg */.ks.lg(Option_templateObject5 || (Option_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: flex;\n      gap: 16rem;\n      flex-direction: row-reverse;\n    "])));
});
var ColumnTextBox = (0,styled_components_browser_esm["default"])(atoms_TextBox)(Option_templateObject6 || (Option_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-grow: 10;\n"])));
var OptionSubtitleContainer = styled_components_browser_esm["default"].div(Option_templateObject7 || (Option_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n"])));

var getTextColor = function getTextColor(isPostDeadlineNotSelected, disabled) {
  if (isPostDeadlineNotSelected) {
    return 'gray30';
  }

  if (disabled) {
    return 'gray25';
  }

  return undefined;
};

var getDescriptionModalTextButtonColor = function getDescriptionModalTextButtonColor(isPostDeadlineNotSelected, disabled) {
  if (isPostDeadlineNotSelected) {
    return 'gray30';
  }

  if (disabled) {
    return 'gray25';
  }

  return 'brand2';
};

var Option = function Option(_ref3) {
  var input = _ref3.input,
      children = _ref3.children,
      option = _ref3.option,
      _ref3$isLoading = _ref3.isLoading,
      isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading,
      isExcluded = _ref3.isExcluded,
      isDisabled = _ref3.isDisabled,
      isFinal = _ref3.isFinal,
      isPending = _ref3.isPending,
      isPostDeadlineSelected = _ref3.isPostDeadlineSelected,
      isPostDeadlineNotSelected = _ref3.isPostDeadlineNotSelected,
      optionStatus = _ref3.optionStatus,
      subcategory = _ref3.subcategory,
      selected = _ref3.selected;
  var id = option.id,
      amount = option.amount,
      title = option.title,
      price = option.price,
      optionCode = option.optionCode,
      description = option.description,
      livingSurface = option.livingSurface,
      isRequestable = option.isRequestable,
      hasModal = option.hasModal,
      optionType = option.optionType,
      included = option.included,
      isPriceUponRequest = option.isPriceUponRequest,
      external_seller = option.external_seller;
  var options = subcategory.options;
  var disabled = (isDisabled || isExcluded || isPostDeadlineNotSelected) && !isFinal;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      lg = _useBreakpointInfo.isLargerThan.lg;

  var _useOpenLegacyModal = hooks_useOpenLegacyModal(),
      openOrderRequestModal = _useOpenLegacyModal.openOrderRequestModal,
      openFullDescriptionModal = _useOpenLegacyModal.openFullDescriptionModal;

  var showDescriptionModalButton = !!hasModal && !isDisabled;
  var showRequestButton = isRequestable && amount > 0 && !isFinal && !isPending && !isDisabled && !isExcluded && !isPostDeadlineSelected && !isPostDeadlineNotSelected;
  var showOrders = !isDisabled && !isPostDeadlineNotSelected;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Option_Container, {
    id: "optie-".concat(option.id),
    "data-id": "organisms_Option_Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_InlineRequestHandler, {
      isLoading: isLoading,
      transparent: true,
      "data-id": "organisms_Option_InlineRequestHandler",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        marginBottom: "lg",
        paddingTop: "lg",
        "data-id": "organisms_Option_Box",
        children: [!!optionStatus && !isPostDeadlineNotSelected && /*#__PURE__*/(0,jsx_runtime.jsx)(OptionContent, {
          marginBottom: "md",
          hasInput: !!input,
          "data-id": "organisms_Option_OptionContent",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_StatusLabel, {
            optionStatus: optionStatus,
            "data-id": "organisms_Option_StatusLabel"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_OptionTitleLine, {
          title: title,
          price: price,
          optionType: optionType,
          livingSurface: livingSurface,
          disabled: disabled,
          postDeadlineNotSelected: isPostDeadlineNotSelected,
          selected: selected,
          isPriceUponRequest: isPriceUponRequest,
          "data-id": "organisms_Option_OptionTitleLine",
          children: input
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OptionContent, {
          marginTop: "sm",
          hasInput: !!input,
          "data-id": "organisms_Option_OptionContent",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OptionSubtitleContainer, {
            "data-id": "organisms_Option_OptionSubtitleContainer",
            children: [!!optionCode && /*#__PURE__*/(0,jsx_runtime.jsxs)(OptionSubtitle, {
              "data-id": "organisms_Option_OptionSubtitle",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
                text: optionCode,
                variant: isPostDeadlineNotSelected || disabled ? 'gray20' : 'gray25',
                "data-id": "organisms_Option_Text"
              }), optionType === 'reference' && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Pill, {
                icon: svg_ApproximateIcon,
                text: "Voorbeeldoptie",
                disabled: disabled,
                "data-id": "organisms_Option_Pill"
              })]
            }), !!external_seller && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
              marginLeft: "sm",
              "data-id": "organisms_Option_Box",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_ExternalSeller, {
                text: external_seller,
                "data-id": "organisms_Option_ExternalSeller"
              })
            })]
          }), isExcluded && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            marginTop: "sm",
            marginBottom: "md",
            "data-id": "organisms_Option_Box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Banner/* default */.Z, {
              content: "Deze optie is niet meer aan te vragen, in verband met een andere aanvraag.",
              shadow: false,
              "data-id": "organisms_Option_Banner"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Columns, {
            hasChildren: !!children,
            marginTop: "sm",
            "data-id": "organisms_Option_Columns",
            children: [children, /*#__PURE__*/(0,jsx_runtime.jsxs)(ColumnTextBox, {
              spacing: "sm",
              marginTop: !!children && !lg ? 'sm' : undefined,
              "data-id": "organisms_Option_ColumnTextBox",
              children: [!!description && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
                text: description,
                variant: getTextColor(isPostDeadlineNotSelected, disabled),
                "data-id": "organisms_Option_Text"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_OptionIncludedMessage, {
                included: included,
                "data-id": "organisms_Option_OptionIncludedMessage"
              }), showDescriptionModalButton && /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* default */.Z, {
                onClick: function onClick() {
                  openFullDescriptionModal(id);
                },
                text: "Volledige omschrijving",
                iconAfter: svg_UnionIcon,
                variant: getDescriptionModalTextButtonColor(isPostDeadlineNotSelected, disabled),
                "data-id": "organisms_Option_TextButton"
              })]
            })]
          }), showRequestButton && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            marginTop: "md",
            "data-id": "organisms_Option_Box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
              size: "sm",
              text: "Optie aanvragen",
              onClick: function onClick() {
                openOrderRequestModal(id, amount, options);
              },
              disabled: disabled || amount === 0,
              fullWidth: false,
              "data-id": "organisms_Option_Button"
            })
          })]
        }), showOrders && /*#__PURE__*/(0,jsx_runtime.jsx)(OptionContent, {
          hasInput: !!input,
          "data-id": "organisms_Option_OptionContent",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Orders, {
            option: option,
            disabled: disabled,
            "data-id": "organisms_Option_Orders"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var organisms_Option = (Option);
;// CONCATENATED MODULE: ./src/components/homestudio/SummaryOptionsOption.tsx


var SummaryOptionsOption_templateObject, SummaryOptionsOption_templateObject2, SummaryOptionsOption_templateObject3, SummaryOptionsOption_templateObject4, SummaryOptionsOption_templateObject5, SummaryOptionsOption_templateObject6, SummaryOptionsOption_templateObject7;









var SummaryOptionsOption_Option = styled_components_browser_esm["default"].div(SummaryOptionsOption_templateObject || (SummaryOptionsOption_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  font-size: 16rem;\n  color: ", ";\n  margin-bottom: 8rem;\n\n  ", ";\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* fromBreakpoint.md */.ks.md(SummaryOptionsOption_templateObject2 || (SummaryOptionsOption_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 18rem;\n  "]))));
var SummaryOptionsOption_OptionTitle = styled_components_browser_esm["default"].p(SummaryOptionsOption_templateObject3 || (SummaryOptionsOption_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0;\n  padding: 0;\n  font-style: ", ";\n  width: 100%;\n"])), function (props) {
  return props.noOption ? 'italic' : '';
});
var OptionEuro = styled_components_browser_esm["default"].p(SummaryOptionsOption_templateObject4 || (SummaryOptionsOption_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  margin: 0 5rem 0 auto;\n  width: 50rem;\n  text-align: right;\n"])));
var OptionEuroDifference = styled_components_browser_esm["default"].span(SummaryOptionsOption_templateObject5 || (SummaryOptionsOption_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  margin-right: 5rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(SummaryOptionsOption_templateObject6 || (SummaryOptionsOption_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-right: 10rem;\n  "]))));
var OptionPrice = styled_components_browser_esm["default"].p(SummaryOptionsOption_templateObject7 || (SummaryOptionsOption_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  margin: 0 10rem 0 auto;\n  width: 105rem;\n  text-align: right;\n"])));

var getPriceDelta = function getPriceDelta(hidePriceDelta, price) {
  if (hidePriceDelta || price === 0) {
    return '';
  }

  return price > 0 ? '+' : '-';
};

var SummaryOptionsOption = function SummaryOptionsOption(_ref) {
  var noneFound = _ref.noneFound,
      title = _ref.title,
      price = _ref.price,
      _ref$amount = _ref.amount,
      amount = _ref$amount === void 0 ? 1 : _ref$amount,
      _ref$hidePriceDelta = _ref.hidePriceDelta,
      hidePriceDelta = _ref$hidePriceDelta === void 0 ? false : _ref$hidePriceDelta;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SummaryOptionsOption_Option, {
    "data-id": "homestudio_SummaryOptionsOption_Option",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SummaryOptionsOption_OptionTitle, {
      noOption: noneFound,
      "data-id": "homestudio_SummaryOptionsOption_OptionTitle",
      children: title
    }), !noneFound && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OptionEuro, {
        "data-id": "homestudio_SummaryOptionsOption_OptionEuro",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OptionEuroDifference, {
          "data-id": "homestudio_SummaryOptionsOption_OptionEuroDifference",
          children: getPriceDelta(hidePriceDelta, price)
        }), "\u20AC"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OptionPrice, {
        "data-id": "homestudio_SummaryOptionsOption_OptionPrice",
        children: formatPrice(price * amount, {
          showDecimal: true,
          showEuroSign: false,
          showNegative: false
        })
      })]
    })]
  });
};

/* harmony default export */ var homestudio_SummaryOptionsOption = (SummaryOptionsOption);
;// CONCATENATED MODULE: ./src/components/PriceStructure.tsx


var PriceStructure_templateObject, PriceStructure_templateObject2, PriceStructure_templateObject3, PriceStructure_templateObject4, PriceStructure_templateObject5, PriceStructure_templateObject6, PriceStructure_templateObject7;








var PriceStructure_Container = styled_components_browser_esm["default"].div(PriceStructure_templateObject || (PriceStructure_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top: 2rem solid ", ";\n  margin: 50rem 20rem;\n"])), styleGuide/* colorPalette.background */.K5.background);
var PriceStructure_Title = styled_components_browser_esm["default"].h5(PriceStructure_templateObject2 || (PriceStructure_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 20rem 0 10rem;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var Items = styled_components_browser_esm["default"].ul(PriceStructure_templateObject3 || (PriceStructure_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n"])));
var PriceStructure_Item = styled_components_browser_esm["default"].li(PriceStructure_templateObject4 || (PriceStructure_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  > div {\n    width: 90%;\n    color: ", ";\n    ", ";\n\n    ", ";\n\n    p:first-of-type {\n      position: relative;\n      &::before {\n        content: '\u25CF';\n        color: ", ";\n        display: inline-flex;\n        width: 20rem;\n      }\n    }\n  }\n\n  &:last-of-type {\n    > div {\n      font-weight: ", ";\n      margin-top: 10rem;\n    }\n\n    p:first-of-type {\n      text-align: end;\n      padding-right: 14rem;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    p:last-of-type {\n      position: relative;\n\n      ", ";\n\n      &::after {\n        position: absolute;\n        content: '';\n        background-color: ", ";\n        height: 1rem;\n        width: calc(100% + 35rem);\n        right: 0;\n        top: -9rem;\n\n        ", ";\n      }\n    }\n  }\n"])), styleGuide/* colorPalette.headerGrey */.K5.headerGrey, styleGuide/* textStyles.bodyText */.sq.bodyText, breakpoints/* toBreakpoint.md */.Hx.md(PriceStructure_templateObject5 || (PriceStructure_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: 100%;\n    "]))), styleGuide/* colorPalette.lightOrange */.K5.lightOrange, fonts/* fontWeight.bold */.Ue.bold, breakpoints/* toBreakpoint.md */.Hx.md(PriceStructure_templateObject6 || (PriceStructure_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n        &:after {\n          width: calc(100% + 28rem);\n        }\n      "]))), styleGuide/* colorPalette.beige */.K5.beige, breakpoints/* toBreakpoint.md */.Hx.md(PriceStructure_templateObject7 || (PriceStructure_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n          width: calc(100% + 26rem);\n        "]))));

var PriceStructure = function PriceStructure(_ref) {
  var priceStructure = _ref.priceStructure,
      totalPrice = _ref.totalPrice;

  if (!(priceStructure !== null && priceStructure !== void 0 && priceStructure.length)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PriceStructure_Container, {
    "data-id": "components_PriceStructure_Container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PriceStructure_Title, {
      "data-id": "components_PriceStructure_Title",
      children: "Prijsopbouw"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Items, {
      "data-id": "components_PriceStructure_Items",
      children: [priceStructure.map(function (_ref2) {
        var amount = _ref2.amount,
            multiple = _ref2.multiple,
            subtotal = _ref2.subtotal,
            title = _ref2.title;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PriceStructure_Item, {
          "data-id": "components_PriceStructure_Item",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(homestudio_SummaryOptionsOption, {
            title: multiple && amount ? "".concat(title, " (").concat(amount, " ").concat(amount > 1 ? 'stuks' : 'stuk', ")") : title,
            price: subtotal,
            "data-id": "components_PriceStructure_SummaryOptionsOption"
          })
        }, title);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PriceStructure_Item, {
        "data-id": "components_PriceStructure_Item",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(homestudio_SummaryOptionsOption, {
          title: "Totaal",
          price: totalPrice,
          "data-id": "components_PriceStructure_SummaryOptionsOption"
        })
      })]
    })]
  });
};

/* harmony default export */ var components_PriceStructure = (PriceStructure);
;// CONCATENATED MODULE: ./src/processes/getOptionTotalPrice.ts
var getOptionTotalPrice = function getOptionTotalPrice(originalPrice, orders) {
  if (orders && orders.length) {
    return orders.reduce(function (acc, curr) {
      return acc + curr.amount * curr.salesPrice;
    }, 0);
  }

  return originalPrice;
};

/* harmony default export */ var processes_getOptionTotalPrice = (getOptionTotalPrice);
;// CONCATENATED MODULE: ./src/components/homestudio/ProductOptionDescriptionModal.tsx








var ProductOptionDescriptionModal_templateObject, ProductOptionDescriptionModal_templateObject2, ProductOptionDescriptionModal_templateObject3, ProductOptionDescriptionModal_templateObject4, ProductOptionDescriptionModal_templateObject5, ProductOptionDescriptionModal_templateObject6, ProductOptionDescriptionModal_templateObject7, ProductOptionDescriptionModal_templateObject8, ProductOptionDescriptionModal_templateObject9, ProductOptionDescriptionModal_templateObject10, ProductOptionDescriptionModal_templateObject11, ProductOptionDescriptionModal_templateObject12, ProductOptionDescriptionModal_templateObject13;

function ProductOptionDescriptionModal_callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = (0,getPrototypeOf/* default */.Z)(derived);
  return (0,possibleConstructorReturn/* default */.Z)(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], (0,getPrototypeOf/* default */.Z)(_this).constructor) : derived.apply(_this, args));
}

function ProductOptionDescriptionModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductOptionDescriptionModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductOptionDescriptionModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductOptionDescriptionModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member

 // eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member




 // eslint-disable-next-line import/no-cycle








 // eslint-disable-next-line import/no-cycle







var ProductOptionDescriptionModal_TypedHeroArticle = function TypedHeroArticle(props) {
  // @ts-ignore
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_HeroArticle, ProductOptionDescriptionModal_objectSpread(ProductOptionDescriptionModal_objectSpread({}, props), {}, {
    "data-id": "homestudio_ProductOptionDescriptionModal_HeroArticle"
  }));
};

var TypedButtonDownload = function TypedButtonDownload(props) {
  // @ts-ignore
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonDownload/* default */.Z, ProductOptionDescriptionModal_objectSpread(ProductOptionDescriptionModal_objectSpread({}, props), {}, {
    "data-id": "homestudio_ProductOptionDescriptionModal_ButtonDownload"
  }));
};

var ProductOptionDescriptionModal_getApiDataParams = function getApiDataParams(_ref) {
  var projectSlug = _ref.match.params.projectSlug,
      modalId = _ref.modalId;
  return {
    wishListModalProductOption: {
      projectSlug: projectSlug,
      modalId: modalId
    }
  };
};

var ProductOptionDescriptionModal_connectApiData = (0,withApiData/* default */.Z)({
  wishListModalProductOption: 'getWishListModalProductOption'
}, ProductOptionDescriptionModal_getApiDataParams); // eslint-disable-next-line @typescript-eslint/no-explicit-any

var ProductOptionDescriptionModal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getNewProductOption: function getNewProductOption(modalId, projectSlug) {
      dispatch((0,apiData/* performApiRequest */.T4)('getWishListModalProductOption', {
        projectSlug: projectSlug,
        modalId: modalId
      }));
    }
  };
};

var ProductOptionDescriptionModal_Container = styled_components_browser_esm["default"].div(ProductOptionDescriptionModal_templateObject || (ProductOptionDescriptionModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n"])), colors/* colors.white */.O.white, styleGuide/* shadows.boxPrimary */.q.boxPrimary);
var ProductOptionDescriptionModal_Wrapper = styled_components_browser_esm["default"].div(ProductOptionDescriptionModal_templateObject2 || (ProductOptionDescriptionModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 20rem;\n  margin-left: 20rem;\n  margin-top: 10rem;\n"])));
var ProductOptionDescriptionModal_Content = styled_components_browser_esm["default"].div(ProductOptionDescriptionModal_templateObject3 || (ProductOptionDescriptionModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 0;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProductOptionDescriptionModal_templateObject4 || (ProductOptionDescriptionModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 100rem 0;\n  "]))));
var ProductOptionDescriptionModal_Title = styled_components_browser_esm["default"].h3(ProductOptionDescriptionModal_templateObject5 || (ProductOptionDescriptionModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 20rem;\n  ", ";\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* toBreakpoint.lg */.Hx.lg(ProductOptionDescriptionModal_templateObject6 || (ProductOptionDescriptionModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 24rem;\n  "]))));
var ProductOptionDescriptionModal_SubTitle = styled_components_browser_esm["default"].div(ProductOptionDescriptionModal_templateObject7 || (ProductOptionDescriptionModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0 20rem 20rem;\n  ", ";\n  color: ", ";\n  font-size: 14rem;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 4rem;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.beige */.K5.beige);
var OptionSubTitle = (0,styled_components_browser_esm["default"])(ProductOptionDescriptionModal_SubTitle)(ProductOptionDescriptionModal_templateObject8 || (ProductOptionDescriptionModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0 20rem;\n"])));
var OptionSubtitleBase = (0,styled_components_browser_esm["default"])(OptionSubtitleContainer)(ProductOptionDescriptionModal_templateObject9 || (ProductOptionDescriptionModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 20rem;\n"])));
var ProductOptionDescriptionModal_Price = styled_components_browser_esm["default"].h3(ProductOptionDescriptionModal_templateObject10 || (ProductOptionDescriptionModal_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: ", ";\n  margin: 0 20rem 16rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, fonts/* fontWeight.medium */.Ue.medium);
var DownloadContainer = styled_components_browser_esm["default"].div(ProductOptionDescriptionModal_templateObject11 || (ProductOptionDescriptionModal_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top: 2rem solid ", ";\n  margin-left: 20rem;\n  margin-right: 20rem;\n"])), styleGuide/* colorPalette.background */.K5.background);
var DownloadTitle = styled_components_browser_esm["default"].h5(ProductOptionDescriptionModal_templateObject12 || (ProductOptionDescriptionModal_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 20rem 0 10rem;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionDescriptionModal_PriceReference = styled_components_browser_esm["default"].span(ProductOptionDescriptionModal_templateObject13 || (ProductOptionDescriptionModal_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 20rem;\n  font-size: 16rem;\n  color: ", ";\n  text-transform: lowercase;\n"])), colors/* colors.gray25 */.O.gray25);

var ProductOptionDescriptionModal = /*#__PURE__*/function (_Component) {
  function ProductOptionDescriptionModal() {
    (0,classCallCheck/* default */.Z)(this, ProductOptionDescriptionModal);

    return ProductOptionDescriptionModal_callSuper(this, ProductOptionDescriptionModal, arguments);
  }

  (0,inherits/* default */.Z)(ProductOptionDescriptionModal, _Component);

  return (0,createClass/* default */.Z)(ProductOptionDescriptionModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          match = _this$props.match,
          modalId = _this$props.modalId,
          getNewProductOption = _this$props.getNewProductOption;

      if (prevProps.modalId !== modalId) {
        getNewProductOption(modalId, String(match.params.projectSlug));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var renderWidth = 0;
      var wishListModalProductOption = this.props.wishListModalProductOption;
      var productOptionData = wishListModalProductOption.data;

      if (!productOptionData) {
        return null;
      }

      var heroArticleProps = {
        type: productOptionData.type,
        renderWidth: renderWidth
      };
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductOptionDescriptionModal_Container, {
        "data-id": "homestudio_ProductOptionDescriptionModal_Container",
        children: [productOptionData.type === 'slider' && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionDescriptionModal_TypedHeroArticle, ProductOptionDescriptionModal_objectSpread(ProductOptionDescriptionModal_objectSpread({}, heroArticleProps), {}, {
          media: productOptionData.media,
          theme: "algemeen",
          showDownloadButton: true,
          "data-id": "homestudio_ProductOptionDescriptionModal_TypedHeroArticle"
        })), productOptionData.type === 'image' && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionDescriptionModal_TypedHeroArticle, ProductOptionDescriptionModal_objectSpread(ProductOptionDescriptionModal_objectSpread({}, heroArticleProps), {}, {
          image: productOptionData.image,
          theme: "algemeen",
          showDownloadButton: true,
          "data-id": "homestudio_ProductOptionDescriptionModal_TypedHeroArticle_4"
        })), productOptionData.type === 'video' && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionDescriptionModal_TypedHeroArticle, ProductOptionDescriptionModal_objectSpread(ProductOptionDescriptionModal_objectSpread({}, heroArticleProps), {}, {
          youtubeId: productOptionData.youtubeId,
          theme: "algemeen",
          "data-id": "homestudio_ProductOptionDescriptionModal_TypedHeroArticle_5"
        })), /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductOptionDescriptionModal_Content, {
          "data-id": "homestudio_ProductOptionDescriptionModal_Content",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            "data-id": "homestudio_ProductOptionDescriptionModal_div",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionDescriptionModal_Title, {
              "data-id": "homestudio_ProductOptionDescriptionModal_Title",
              children: productOptionData.title
            }), productOptionData.optionType === 'reference' && !productOptionData.isPriceUponRequest && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionDescriptionModal_PriceReference, {
              "data-id": "homestudio_ProductOptionDescriptionModal_PriceReference",
              children: "circa"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionDescriptionModal_Price, {
              "data-id": "homestudio_ProductOptionDescriptionModal_Price",
              children: !productOptionData.isPriceUponRequest ? formatPrice(processes_getOptionTotalPrice(productOptionData.price), {
                showDecimal: true,
                showEuroSign: true
              }) : 'Op aanvraag'
            }), productOptionData.optionType === 'reference' && /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductOptionDescriptionModal_SubTitle, {
              "data-id": "homestudio_ProductOptionDescriptionModal_SubTitle",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Pill, {
                icon: svg_ApproximateIcon,
                text: "Voorbeeldoptie",
                "data-id": "homestudio_ProductOptionDescriptionModal_Pill"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                "data-id": "homestudio_ProductOptionDescriptionModal_span",
                children: "Let op: dit is geen offerte, maar een voorbeeldoptie. Deze is bedoeld om een beeld te geven van de mogelijkheden en mogelijke kosten."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OptionSubtitleBase, {
              "data-id": "homestudio_ProductOptionDescriptionModal_OptionSubtitleBase",
              children: [productOptionData.optionCode && /*#__PURE__*/(0,jsx_runtime.jsx)(OptionSubTitle, {
                "data-id": "homestudio_ProductOptionDescriptionModal_OptionSubTitle",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  "data-id": "homestudio_ProductOptionDescriptionModal_span",
                  children: ["Optiecode: ", productOptionData.optionCode]
                })
              }), productOptionData.external_seller && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                marginLeft: "sm",
                "data-id": "homestudio_ProductOptionDescriptionModal_Box",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_ExternalSeller, {
                  text: productOptionData.external_seller,
                  "data-id": "homestudio_ProductOptionDescriptionModal_ExternalSeller"
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionDescriptionModal_Wrapper, {
            "data-id": "homestudio_ProductOptionDescriptionModal_Wrapper",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BBCode/* default */.Z, {
              content: productOptionData.text,
              "data-id": "homestudio_ProductOptionDescriptionModal_BBCode"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_PriceStructure, {
            priceStructure: productOptionData.priceStructure,
            totalPrice: productOptionData.price,
            "data-id": "homestudio_ProductOptionDescriptionModal_PriceStructure"
          }), productOptionData.externalFiles && productOptionData.externalFiles.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(DownloadContainer, {
            "data-id": "homestudio_ProductOptionDescriptionModal_DownloadContainer",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DownloadTitle, {
              "data-id": "homestudio_ProductOptionDescriptionModal_DownloadTitle",
              children: "Bijlagen"
            }), productOptionData.externalFiles.map(function (file) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(TypedButtonDownload, {
                link: file.url,
                content: file.name,
                "data-id": "homestudio_ProductOptionDescriptionModal_TypedButtonDownload"
              }, file.name);
            })]
          })]
        })]
      });
    }
  }]);
}(react.Component);

/* harmony default export */ var homestudio_ProductOptionDescriptionModal = ((0,withMatch/* default */.Z)(ProductOptionDescriptionModal_connectApiData((0,es/* connect */.$j)(null, ProductOptionDescriptionModal_mapDispatchToProps)(ProductOptionDescriptionModal))));
;// CONCATENATED MODULE: ./src/components/homestudio/ProductOptionStatusModal.js








var ProductOptionStatusModal_templateObject, ProductOptionStatusModal_templateObject2, ProductOptionStatusModal_templateObject3, ProductOptionStatusModal_templateObject4, ProductOptionStatusModal_templateObject5, ProductOptionStatusModal_templateObject6, ProductOptionStatusModal_templateObject7, ProductOptionStatusModal_templateObject8, ProductOptionStatusModal_templateObject9, ProductOptionStatusModal_templateObject0, ProductOptionStatusModal_templateObject1, ProductOptionStatusModal_templateObject10, ProductOptionStatusModal_templateObject11, ProductOptionStatusModal_templateObject12, ProductOptionStatusModal_templateObject13, ProductOptionStatusModal_templateObject14, ProductOptionStatusModal_templateObject15;

var ProductOptionStatusModal_jsx = react.createElement;

function ProductOptionStatusModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ProductOptionStatusModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ProductOptionStatusModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ProductOptionStatusModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}




 // Services


 // Components




 // Styles



var ProductOptionStatusModal_connectApiData = (0,withApiData/* default */.Z)({
  orderDetails: 'getOptionOrder'
}, function (ownProps) {
  return {
    orderDetails: {
      projectSlug: ownProps.projectSlug,
      orderId: ownProps.orderId
    },
    options: {
      cache: "disabled"
    }
  };
});

var ProductOptionStatusModal = /*#__PURE__*/function (_PureComponent) {
  function ProductOptionStatusModal() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ProductOptionStatusModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ProductOptionStatusModal_callSuper(this, ProductOptionStatusModal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "transformLastUpdateDate", function (date) {
      var dateParts = date.split(/-| /);
      return "(".concat(dateParts[2], "-").concat(dateParts[1], "-").concat(dateParts[0], ")");
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ProductOptionStatusModal, _PureComponent);

  return (0,createClass/* default */.Z)(ProductOptionStatusModal, [{
    key: "render",
    value: function render() {
      var orderDetails = this.props.orderDetails;
      var data = orderDetails.data;
      var updateDate = data && this.transformLastUpdateDate(data.lastUpdate);
      return data && orderDetails.request.networkStatus !== 'loading' ? ProductOptionStatusModal_jsx(ProductOptionStatusModal_Container, {
        "data-id": "homestudio_ProductOptionStatusModal_Container"
      }, ProductOptionStatusModal_jsx(ProductOptionStatusModal_Content, {
        "data-id": "homestudio_ProductOptionStatusModal_Content"
      }, ProductOptionStatusModal_jsx(ProductOptionStatusModal_Title, {
        "data-id": "homestudio_ProductOptionStatusModal_Title"
      }, "Orderstatus informatie"), ProductOptionStatusModal_jsx(Section, {
        "data-id": "homestudio_ProductOptionStatusModal_Section"
      }, ProductOptionStatusModal_jsx(SectionTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_SectionTitle"
      }, "Optiespecificatie"), ProductOptionStatusModal_jsx(ProductOptionStatusModal_OptionTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_OptionTitle"
      }, data.option.title), ProductOptionStatusModal_jsx(OptionBase, {
        "data-id": "homestudio_ProductOptionStatusModal_OptionBase"
      }, data.option.optionCode && ProductOptionStatusModal_jsx(OptionCode, {
        "data-id": "homestudio_ProductOptionStatusModal_OptionCode"
      }, "Optiecode: ", data.option.optionCode), data.option.external_seller && ProductOptionStatusModal_jsx(molecules_ExternalSeller, {
        text: data.option.external_seller,
        "data-id": "homestudio_ProductOptionStatusModal_ExternalSeller"
      })), ProductOptionStatusModal_jsx(OptionDescription, {
        "data-id": "homestudio_ProductOptionStatusModal_OptionDescription"
      }, ProductOptionStatusModal_jsx(BBCode/* default */.Z, {
        content: data.option.text,
        "data-id": "homestudio_ProductOptionStatusModal_BBCode"
      })), data.option.externalFiles && data.option.externalFiles.length > 0 && ProductOptionStatusModal_jsx(react.Fragment, null, ProductOptionStatusModal_jsx(SubSectionTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_SubSectionTitle"
      }, "Bijlagen"), ProductOptionStatusModal_jsx(ProductOptionStatusModal_DownloadContainer, {
        "data-id": "homestudio_ProductOptionStatusModal_DownloadContainer"
      }, data.option.externalFiles.map(function (file) {
        return ProductOptionStatusModal_jsx(ButtonDownload/* default */.Z, {
          key: "bijlagen-".concat(file.name),
          content: file.name,
          link: file.url,
          "data-id": "homestudio_ProductOptionStatusModal_ButtonDownload"
        });
      })))), ProductOptionStatusModal_jsx(Section, {
        withTopBorder: true,
        "data-id": "homestudio_ProductOptionStatusModal_Section"
      }, ProductOptionStatusModal_jsx(SectionTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_SectionTitle"
      }, "Orderstatus"), ProductOptionStatusModal_jsx(OrderStatus, {
        color: styleGuide/* colorPalette.green */.K5.green,
        "data-id": "homestudio_ProductOptionStatusModal_OrderStatus"
      }, data.placeDescription, " ", updateDate), ProductOptionStatusModal_jsx(components_PriceStructure, {
        priceStructure: data.option.priceStructure,
        totalPrice: data.option.price,
        "data-id": "homestudio_ProductOptionStatusModal_PriceStructure"
      }), ProductOptionStatusModal_jsx(PriceAmountContainer, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountContainer"
      }, data.amount > 1 && ProductOptionStatusModal_jsx(react.Fragment, null, ProductOptionStatusModal_jsx(PriceAmountTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountTitle"
      }, "Optie aantal"), ProductOptionStatusModal_jsx(PriceAmountLabel, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountLabel"
      }, data.amount, " (\xE1", ' ', formatPrice(data.salesPrice, {
        showDecimal: true,
        showEuroSign: true
      }), " per stuk)")), ProductOptionStatusModal_jsx(PriceAmountTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountTitle"
      }, "Totaal bedrag"), ProductOptionStatusModal_jsx(PriceAmountLabel, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountLabel"
      }, formatPrice(data.salesPrice * data.amount, {
        showDecimal: true,
        showEuroSign: true
      }))), data.document && ProductOptionStatusModal_jsx(ProductOptionStatusModal_DownloadContainer, {
        "data-id": "homestudio_ProductOptionStatusModal_DownloadContainer"
      }, ProductOptionStatusModal_jsx(ButtonDownload/* default */.Z, {
        content: data.document.name,
        link: data.document.url,
        "data-id": "homestudio_ProductOptionStatusModal_ButtonDownload"
      }))))) : null;
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var homestudio_ProductOptionStatusModal = ((0,withMatch/* default */.Z)(ProductOptionStatusModal_connectApiData((0,es/* connect */.$j)(null, null)(ProductOptionStatusModal))));
var ProductOptionStatusModal_Container = styled_components_browser_esm["default"].div(ProductOptionStatusModal_templateObject || (ProductOptionStatusModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.white */.K5.white, styleGuide/* shadows.boxPrimary */.q.boxPrimary, styleGuide/* textStyles.bodyText */.sq.bodyText);
var ProductOptionStatusModal_Content = styled_components_browser_esm["default"].div(ProductOptionStatusModal_templateObject2 || (ProductOptionStatusModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 20rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProductOptionStatusModal_templateObject3 || (ProductOptionStatusModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 100rem 20rem;\n  "]))));
var ProductOptionStatusModal_Title = styled_components_browser_esm["default"].h2(ProductOptionStatusModal_templateObject4 || (ProductOptionStatusModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var Section = styled_components_browser_esm["default"].section(ProductOptionStatusModal_templateObject5 || (ProductOptionStatusModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 40rem;\n  ", ";\n"])), function (props) {
  return props.withTopBorder && "padding-top: 32px; border-top: 1px solid ".concat(styleGuide/* colorPalette.background */.K5.background, ";");
});
var SectionTitle = styled_components_browser_esm["default"].h4(ProductOptionStatusModal_templateObject6 || (ProductOptionStatusModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  letter-spacing: 0.5rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: ", ";\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.orange */.K5.orange);
var SubSectionTitle = styled_components_browser_esm["default"].h5(ProductOptionStatusModal_templateObject7 || (ProductOptionStatusModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionStatusModal_OptionTitle = styled_components_browser_esm["default"].h3(ProductOptionStatusModal_templateObject8 || (ProductOptionStatusModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 12rem;\n\n  ", ";\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* toBreakpoint.lg */.Hx.lg(ProductOptionStatusModal_templateObject9 || (ProductOptionStatusModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 24rem;\n  "]))));
var OptionCode = styled_components_browser_esm["default"].span(ProductOptionStatusModal_templateObject0 || (ProductOptionStatusModal_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-size: 14rem;\n  margin: 0 0;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.beige */.K5.beige);
var OptionDescription = styled_components_browser_esm["default"].div(ProductOptionStatusModal_templateObject1 || (ProductOptionStatusModal_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 24rem;\n"])));
var ProductOptionStatusModal_DownloadContainer = styled_components_browser_esm["default"].div(ProductOptionStatusModal_templateObject10 || (ProductOptionStatusModal_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 16rem 0 40rem;\n"])));
var OrderStatus = styled_components_browser_esm["default"].div(ProductOptionStatusModal_templateObject11 || (ProductOptionStatusModal_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-style: italic;\n  color: ", ";\n"])), styleGuide/* textStyles.title */.sq.title, function (props) {
  return props.color;
});
var PriceAmountContainer = styled_components_browser_esm["default"].div(ProductOptionStatusModal_templateObject12 || (ProductOptionStatusModal_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 40rem;\n"])));
var PriceAmountTitle = styled_components_browser_esm["default"].h4(ProductOptionStatusModal_templateObject13 || (ProductOptionStatusModal_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin: 0 0 8rem;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle);
var PriceAmountLabel = styled_components_browser_esm["default"].span(ProductOptionStatusModal_templateObject14 || (ProductOptionStatusModal_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n\n  &:first-of-type {\n    margin-bottom: 32rem;\n  }\n"])));
var OptionBase = styled_components_browser_esm["default"].div(ProductOptionStatusModal_templateObject15 || (ProductOptionStatusModal_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n"])));
// EXTERNAL MODULE: ./src/types/endpoints.ts
var endpoints = __webpack_require__(69321);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
;// CONCATENATED MODULE: ./src/hocs/withInvalidateWishListRequest.tsx


var withInvalidateWishListRequest_excluded = ["wishListItem"];

function withInvalidateWishListRequest_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function withInvalidateWishListRequest_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? withInvalidateWishListRequest_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : withInvalidateWishListRequest_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var withInvalidateWishListRequest = function withInvalidateWishListRequest(WrappedComponent) {
  return function (props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _useParams = (0,useParams/* default */.Z)(),
        wishListItem = _useParams.wishListItem,
        otherParams = (0,objectWithoutProperties/* default */.Z)(_useParams, withInvalidateWishListRequest_excluded);

    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    return (
      /*#__PURE__*/
      // @ts-ignore (ignore error due to to-be-removed hoist-non-react-statics)
      (0,jsx_runtime.jsx)(WrappedComponent, withInvalidateWishListRequest_objectSpread(withInvalidateWishListRequest_objectSpread({}, props), {}, {
        invalidateWishListRequest: function invalidateWishListRequest() {
          // Note: the params and key have to match the ones in the useWishListQuery in HouseDesign.tsx, to invalidate exactly that request
          queryClient.invalidateQueries({
            queryKey: ['getWishList', otherParams, endpoints/* WishListRequestKey.wishListLoading */.P.wishListLoading]
          });
        },
        "data-id": "hocs_withInvalidateWishListRequest_WrappedComponent"
      }))
    );
  };
};

/* harmony default export */ var hocs_withInvalidateWishListRequest = (withInvalidateWishListRequest);
// EXTERNAL MODULE: ./src/components/shared/richText/Paragraph.js
var Paragraph = __webpack_require__(38069);
;// CONCATENATED MODULE: ./src/components/shared/icons/Plus.js
var Plus_jsx = react.createElement;

var Plus_defaultProps = {
  color: '#ffffff',
  width: 12,
  height: 12
};

var Plus = function Plus(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Plus_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 12 12",
    "data-id": "icons_Plus_svg"
  }, Plus_jsx("title", {
    "data-id": "icons_Plus_title"
  }, "Plus Icon"), Plus_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Plus_g"
  }, Plus_jsx("g", {
    transform: "translate(-7.000000, -8.000000)",
    fill: color,
    "data-id": "icons_Plus_g_3"
  }, Plus_jsx("g", {
    "data-id": "icons_Plus_g_4"
  }, Plus_jsx("g", {
    transform: "translate(0.000000, 1.000000)",
    "data-id": "icons_Plus_g_5"
  }, Plus_jsx("g", {
    transform: "translate(7.000000, 7.000000)",
    "data-id": "icons_Plus_g_6"
  }, Plus_jsx("g", {
    "data-id": "icons_Plus_g_7"
  }, Plus_jsx("path", {
    d: "M12,6.155625 L11.99475,5.7279375 C11.9415,5.15475 11.4615,4.7085 10.8765,4.7085 L7.7188125,4.7085 L7.7188125,0 L6.2206875,0 L5.72625,0.0061875 C5.1585,0.064875 4.7188125,0.542625 4.7188125,1.1235 L4.7188125,4.7086875 L0,4.7086875 L0,6.2068125 L0.0061875,6.70125 C0.064875,7.269 0.542625,7.7086875 1.1235,7.7086875 L4.7188125,7.7086875 L4.7188125,12 L6.2716875,12 L6.6991875,11.99475 C7.2725625,11.9415 7.7188125,11.4615 7.7188125,10.8765 L7.7188125,7.7085 L12,7.7085 L12,6.155625 Z",
    fillRule: "nonzero",
    "data-id": "icons_Plus_path"
  }))))))));
};

Plus.defaultProps = Plus_defaultProps;
/* harmony default export */ var icons_Plus = (Plus);
;// CONCATENATED MODULE: ./src/components/shared/icons/Minus.js
var Minus_jsx = react.createElement;

var Minus_defaultProps = {
  color: '#ffffff',
  width: 12,
  height: 3.5
};

var Minus = function Minus(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Minus_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 7 2",
    "data-id": "icons_Minus_svg"
  }, Minus_jsx("title", {
    "data-id": "icons_Minus_title"
  }, "Minus"), Minus_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1126.000000, -14144.000000)",
    "data-id": "icons_Minus_g"
  }, Minus_jsx("g", {
    transform: "translate(1120.000000, 14136.000000)",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_Minus_g_3"
  }, Minus_jsx("g", {
    transform: "translate(6.000000, 8.000000)",
    "data-id": "icons_Minus_g_4"
  }, Minus_jsx("path", {
    d: "M6.9969375,0.594671875 C6.965875,0.2603125 6.685875,0 6.344625,0 L0,0 L0,0.87390625 L0.003609375,1.16232813 C0.03784375,1.49351563 0.31653125,1.75 0.655375,1.75 L7,1.75 L7,0.84415625 L6.9969375,0.594671875 Z",
    "data-id": "icons_Minus_path"
  })))));
};

Minus.defaultProps = Minus_defaultProps;
/* harmony default export */ var icons_Minus = (Minus);
;// CONCATENATED MODULE: ./src/components/shared/buttons/ButtonPlusMinus.js


var ButtonPlusMinus_templateObject;

var ButtonPlusMinus_jsx = react.createElement;






var ButtonPlusMinus = function ButtonPlusMinus(_ref) {
  var type = _ref.type,
      disabled = _ref.disabled,
      clickHandler = _ref.clickHandler,
      width = _ref.width,
      height = _ref.height;
  return ButtonPlusMinus_jsx(ButtonPlusMinus_Button, {
    onClick: !disabled ? clickHandler : undefined,
    disabled: disabled,
    "data-id": "buttons_ButtonPlusMinus_Button"
  }, type === 'add' && ButtonPlusMinus_jsx(icons_Plus, {
    width: width,
    height: height,
    "data-id": "buttons_ButtonPlusMinus_Plus"
  }), type === 'subtract' && ButtonPlusMinus_jsx(icons_Minus, {
    width: width,
    height: height,
    "data-id": "buttons_ButtonPlusMinus_Minus"
  }));
};

/* harmony default export */ var buttons_ButtonPlusMinus = (ButtonPlusMinus);
var ButtonPlusMinus_Button = styled_components_browser_esm["default"].button(ButtonPlusMinus_templateObject || (ButtonPlusMinus_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  height: 18rem;\n  width: 18rem;\n  cursor: ", ";\n  background: ", ";\n  transition: background 0.15s ease-in-out;\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return !props.disabled ? styleGuide/* colorPalette.blue */.K5.blue : styleGuide/* colorPalette.lightGrey */.K5.lightGrey;
}, function (props) {
  return !props.disabled ? styleGuide/* colorPalette.darkBlue */.K5.darkBlue : styleGuide/* colorPalette.lightGrey */.K5.lightGrey;
});
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./src/components/shared/forms/fieldTypes/MultipleSelector.js








var MultipleSelector_templateObject, MultipleSelector_templateObject2;

var MultipleSelector_jsx = react.createElement;

function MultipleSelector_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, MultipleSelector_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function MultipleSelector_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (MultipleSelector_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}






/*

  This component uses component class for its amount
  because it needs to debounce user input (add and subtract buttons
  invite pushing them multiple times in short order, and we don't
  want to spam the server)

  */

var MultipleSelector = /*#__PURE__*/function (_Component) {
  function MultipleSelector() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MultipleSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = MultipleSelector_callSuper(this, MultipleSelector, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      amount: _this.props.amount
    });

    (0,defineProperty/* default */.Z)(_this, "changeAmount", lodash_debounce_default()(function (amount) {
      var props = _this.props;

      if (typeof props.changeHandler === 'function') {
        props.changeHandler(amount);
      }
    }, 500, {
      leading: false,
      trailing: true
    }));

    (0,defineProperty/* default */.Z)(_this, "handleAdd", function () {
      _this.setState(function (prevState) {
        return {
          amount: prevState.amount + 1
        };
      }, function () {
        return _this.changeAmount(_this.state.amount);
      });
    });

    (0,defineProperty/* default */.Z)(_this, "handleSubtract", function () {
      _this.setState(function (prevState) {
        return {
          amount: prevState.amount > 1 ? prevState.amount - 1 : 0
        };
      }, function () {
        return _this.changeAmount(_this.state.amount);
      });
    });

    (0,defineProperty/* default */.Z)(_this, "handleChange", function (event) {
      var value = Number(event.target.value) >= 0 ? event.target.value : 0;

      if (typeof value === 'number') {
        _this.setState(function (prevState) {
          return {
            amount: value
          };
        }, function () {
          _this.changeAmount(_this.state.amount);
        });
      }
    });

    return _this;
  }

  (0,inherits/* default */.Z)(MultipleSelector, _Component);

  return (0,createClass/* default */.Z)(MultipleSelector, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var amount = this.props.amount;

      if (this.state.amount !== amount) {
        this.setState({
          amount: amount
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          amount = _this$props.amount,
          maxAmount = _this$props.maxAmount;
      return MultipleSelector_jsx(MultipleSelector_Container, {
        "data-id": "fieldTypes_MultipleSelector_Container"
      }, MultipleSelector_jsx(buttons_ButtonPlusMinus, {
        height: 2.3,
        width: 8,
        type: "subtract",
        clickHandler: !disabled ? this.handleSubtract : undefined,
        disabled: disabled || amount === 0,
        "data-id": "fieldTypes_MultipleSelector_ButtonPlusMinus"
      }), MultipleSelector_jsx(AmountInput, {
        type: "number",
        value: this.state.amount,
        readOnly: disabled,
        onChange: !disabled ? this.handleChange : undefined,
        min: 0,
        "data-id": "fieldTypes_MultipleSelector_AmountInput"
      }), MultipleSelector_jsx(buttons_ButtonPlusMinus, {
        height: 8,
        width: 8,
        type: "add",
        clickHandler: !disabled ? this.handleAdd : undefined,
        disabled: disabled || amount === maxAmount,
        "data-id": "fieldTypes_MultipleSelector_ButtonPlusMinus"
      }));
    }
  }]);
}(react.Component);

/* harmony default export */ var fieldTypes_MultipleSelector = (MultipleSelector);
var MultipleSelector_Container = styled_components_browser_esm["default"].div(MultipleSelector_templateObject || (MultipleSelector_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 110rem;\n  padding: 10rem;\n  box-sizing: border-box;\n  background: ", ";\n"])), styleGuide/* colorPalette.background */.K5.background);
var AmountInput = styled_components_browser_esm["default"].input(MultipleSelector_templateObject2 || (MultipleSelector_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 38rem;\n  box-sizing: border-box;\n  border: solid 1px ", ";\n  margin: 0 5rem;\n  padding: 0 5rem;\n  font-family: ", ";\n  font-size: 14rem;\n  color: ", ";\n  transition: border 0.15s ease-in-out;\n  -moz-appearance: textfield;\n\n  &:focus {\n    outline: 0;\n    border: solid 1rem ", ";\n  }\n  &:read-only:focus {\n    outline: 0;\n    border: solid 1px ", ";\n  }\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* colorPalette.lightGrey */.K5.lightGrey);
// EXTERNAL MODULE: ./src/components/shared/forms/fieldTypes/Textarea.js
var Textarea = __webpack_require__(83418);
// EXTERNAL MODULE: ./src/components/shared/forms/fieldTypes/Checkbox.js
var Checkbox = __webpack_require__(62394);
// EXTERNAL MODULE: ./src/components/shared/buttons/ButtonUpload.js + 1 modules
var ButtonUpload = __webpack_require__(66466);
;// CONCATENATED MODULE: ./src/components/homestudio/ProductOptionRequestModal.tsx









var ProductOptionRequestModal_templateObject, ProductOptionRequestModal_templateObject2, ProductOptionRequestModal_templateObject3, ProductOptionRequestModal_templateObject4, ProductOptionRequestModal_templateObject5, ProductOptionRequestModal_templateObject6, ProductOptionRequestModal_templateObject7, ProductOptionRequestModal_templateObject8, ProductOptionRequestModal_templateObject9, ProductOptionRequestModal_templateObject10, ProductOptionRequestModal_templateObject11, ProductOptionRequestModal_templateObject12, ProductOptionRequestModal_templateObject13, ProductOptionRequestModal_templateObject14, ProductOptionRequestModal_templateObject15, ProductOptionRequestModal_templateObject16, ProductOptionRequestModal_templateObject17, ProductOptionRequestModal_templateObject18, ProductOptionRequestModal_templateObject19;

function ProductOptionRequestModal_callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = (0,getPrototypeOf/* default */.Z)(derived);
  return (0,possibleConstructorReturn/* default */.Z)(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], (0,getPrototypeOf/* default */.Z)(_this).constructor) : derived.apply(_this, args));
}




















var TypedButtonUpload = ButtonUpload/* default */.Z;
var TypedButtonPrimary = ButtonPrimary/* default */.Z;

var ProductOptionRequestModal_mapStateToProps = function mapStateToProps(state, _ref) {
  var match = _ref.match;
  return {
    postRequestOptionRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postRequestOption', {
      projectSlug: String(match.params.projectSlug)
    }),
    postRequestOptionFileRequests: (0,apiData/* getApiDataRequestsForProject */.U4)(state.apiData, 'postRequestOptionFile', match.params.projectSlug)
  };
};

var ProductOptionRequestModal_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      wishListId = _ownProps$match$param.wishListId,
      projectSlug = _ownProps$match$param.projectSlug;
  return {
    postRequestOption: function postRequestOption(projectSlug, details) {
      var wishListId = ownProps.match.params.wishListId;
      dispatch((0,apiData/* performApiRequest */.T4)('postRequestOption', {
        projectSlug: projectSlug
      }, details));

      if (wishListId) {
        dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getWishList', {
          projectSlug: projectSlug,
          wishListId: wishListId
        }));
      }
    },
    postRequestOptionFile: function postRequestOptionFile(projectSlug, orderId, details) {
      dispatch((0,apiData/* performApiRequest */.T4)('postRequestOptionFile', {
        projectSlug: projectSlug,
        orderId: orderId
      }, details));
    },
    openOrderRequestResultModal: function openOrderRequestResultModal(result) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.orange */.K5.orange, {
        type: 'orderRequestResult',
        componentProps: {
          result: result
        }
      }));
    },
    invalidateData: function invalidateData() {
      if (wishListId) {
        dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getWishList', {
          projectSlug: projectSlug,
          wishListId: wishListId
        }));
      }

      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postRequestOption', {
        projectSlug: projectSlug
      }));
    },
    resetRequest: function resetRequest(projectSlug) {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postRequestOption', {
        projectSlug: projectSlug
      }));
    }
  };
};

var ProductOptionRequestModal_Container = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject || (ProductOptionRequestModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n"])), styleGuide/* colorPalette.white */.K5.white, styleGuide/* shadows.boxPrimary */.q.boxPrimary);
var ProductOptionRequestModal_Content = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject2 || (ProductOptionRequestModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 20rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProductOptionRequestModal_templateObject3 || (ProductOptionRequestModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 100rem 20rem;\n  "]))));
var ProductOptionRequestModal_Title = styled_components_browser_esm["default"].h2(ProductOptionRequestModal_templateObject4 || (ProductOptionRequestModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var RequestContainer = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject5 || (ProductOptionRequestModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 40rem;\n  padding-top: 32rem;\n  border-top: 1rem dashed ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige);
var ProductOptionRequestModal_OptionTitle = styled_components_browser_esm["default"].h3(ProductOptionRequestModal_templateObject6 || (ProductOptionRequestModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0 0 12rem;\n\n  ", ";\n  color: ", ";\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionRequestModal_OptionCode = styled_components_browser_esm["default"].span(ProductOptionRequestModal_templateObject7 || (ProductOptionRequestModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-size: 14rem;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.beige */.K5.beige);
var RequestDetails = styled_components_browser_esm["default"].section(ProductOptionRequestModal_templateObject8 || (ProductOptionRequestModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 32rem 100rem 60rem 40rem;\n  margin: 40rem 0;\n  background-color: rgba(", ", 0.25);\n  color: ", ";\n\n  ", ";\n"])), styleGuide/* colorPaletteRGB.loadingBlue */.xe.loadingBlue, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, styleGuide/* textStyles.caption */.sq.caption);
var RequestTitle = styled_components_browser_esm["default"].h4(ProductOptionRequestModal_templateObject9 || (ProductOptionRequestModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.title */.sq.title);
var RequestSubTitle = styled_components_browser_esm["default"].h5(ProductOptionRequestModal_templateObject10 || (ProductOptionRequestModal_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-bottom: 8rem;\n\n  &:last-of-type {\n    margin-bottom: 20rem;\n  }\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle);
var RequestItemPrice = styled_components_browser_esm["default"].span(ProductOptionRequestModal_templateObject11 || (ProductOptionRequestModal_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-left: 8rem;\n"])), styleGuide/* textStyles.caption */.sq.caption);
var RequestTotal = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject12 || (ProductOptionRequestModal_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-weight: 400;\n"])), styleGuide/* textStyles.title */.sq.title);
var MultipleContainer = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject13 || (ProductOptionRequestModal_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n  margin-top: 32rem;\n\n  > ", " {\n    flex: 1 0 100%;\n    margin: 0 0 8rem;\n  }\n"])), RequestSubTitle);
var TextAreaContainer = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject14 || (ProductOptionRequestModal_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0 0 22rem;\n"])));
var UploadContainer = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject15 || (ProductOptionRequestModal_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var FileInput = styled_components_browser_esm["default"].input(ProductOptionRequestModal_templateObject16 || (ProductOptionRequestModal_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: none;\n"])));
var FileName = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject17 || (ProductOptionRequestModal_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 5rem 0;\n  font-style: italic;\n"])));
var ErrorMessage = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject18 || (ProductOptionRequestModal_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n"])), styleGuide/* colorPalette.red */.K5.red);
var CheckboxContainer = styled_components_browser_esm["default"].div(ProductOptionRequestModal_templateObject19 || (ProductOptionRequestModal_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 32rem;\n"])));

var ProductOptionRequestModal = /*#__PURE__*/function (_Component) {
  function ProductOptionRequestModal(props) {
    var _this2;

    (0,classCallCheck/* default */.Z)(this, ProductOptionRequestModal);

    _this2 = ProductOptionRequestModal_callSuper(this, ProductOptionRequestModal, [props]);

    (0,defineProperty/* default */.Z)(_this2, "fileInput", null);

    (0,defineProperty/* default */.Z)(_this2, "invalidateDataAfterRequests", function () {
      var _this2$props = _this2.props,
          invalidateData = _this2$props.invalidateData,
          invalidateWishListRequest = _this2$props.invalidateWishListRequest;
      invalidateData();
      invalidateWishListRequest();
    });

    (0,defineProperty/* default */.Z)(_this2, "handleChangeAmount", function (value) {
      _this2.setState({
        optionAmount: value
      });
    });

    (0,defineProperty/* default */.Z)(_this2, "handleTextInput", function () {
      var textAreaEl = document && document.querySelector('#requestInfo');

      if (textAreaEl && textAreaEl instanceof HTMLTextAreaElement) {
        _this2.setState({
          comment: textAreaEl.value
        });
      }
    });

    (0,defineProperty/* default */.Z)(_this2, "handleUploadClick", function (e) {
      e.preventDefault();

      if (_this2.fileInput) {
        _this2.fileInput.click();
      }
    });

    (0,defineProperty/* default */.Z)(_this2, "handleFileUpload", function (e) {
      if (e.target) {
        var _e$currentTarget;

        var file = (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 || (_e$currentTarget = _e$currentTarget.files) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget[0];

        if (!file) {
          _this2.setState({
            uploadError: 'Het uploaden van dit bestand is niet gelukt.'
          });

          return;
        }

        if (file.size >= 2000000) {
          _this2.setState({
            uploadError: 'De gekozen afbeelding is te groot. Kies een afbeelding die kleiner is dan 2mb.'
          });

          return;
        }

        _this2.setState({
          uploadedFile: file,
          uploadError: null
        });
      }
    });

    (0,defineProperty/* default */.Z)(_this2, "handleCheckClick", function () {
      var termsChecked = _this2.state.termsChecked;

      _this2.setState({
        termsValid: !termsChecked,
        termsChecked: !termsChecked
      });
    });

    (0,defineProperty/* default */.Z)(_this2, "submitRequest", function (e) {
      e.preventDefault();
      var _this2$props2 = _this2.props,
          postRequestOption = _this2$props2.postRequestOption,
          projectSlug = _this2$props2.projectSlug,
          modalId = _this2$props2.modalId,
          options = _this2$props2.options;
      var _this2$state = _this2.state,
          optionAmount = _this2$state.optionAmount,
          comment = _this2$state.comment,
          termsChecked = _this2$state.termsChecked;
      var productOptionData = options.find(function (option) {
        return option.id === modalId;
      });

      if (termsChecked) {
        _this2.setState({
          isSubmitting: true
        });

        var formData = new FormData();

        if (productOptionData && productOptionData.wishlistOptionId) {
          formData.append('wishlistOption', String(productOptionData.wishlistOptionId));
        }

        formData.append('comment', comment);
        formData.append('amount', String(optionAmount));
        formData.append('option', String(modalId));
        postRequestOption(projectSlug, formData);
      } else {
        _this2.setState({
          termsValid: false
        });
      }
    });

    _this2.state = {
      optionAmount: 1,
      comment: '',
      uploadedFile: null,
      uploadError: null,
      termsValid: true,
      termsChecked: false,
      isSubmitting: false
    };
    return _this2;
  }

  (0,inherits/* default */.Z)(ProductOptionRequestModal, _Component);

  return (0,createClass/* default */.Z)(ProductOptionRequestModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var amount = this.props.amount;
      var optionAmount = this.state.optionAmount;

      if (amount !== optionAmount) {
        this.setState({
          optionAmount: amount
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var uploadedFile = this.state.uploadedFile;
      var _this$props = this.props,
          postRequestOptionRequest = _this$props.postRequestOptionRequest,
          postRequestOptionFile = _this$props.postRequestOptionFile,
          postRequestOptionFileRequests = _this$props.postRequestOptionFileRequests,
          openOrderRequestResultModal = _this$props.openOrderRequestResultModal,
          match = _this$props.match,
          resetRequest = _this$props.resetRequest;
      var postRequestOptionStatus = postRequestOptionRequest && postRequestOptionRequest.networkStatus;

      if (postRequestOptionStatus === 'success') {
        if (uploadedFile) {
          var fileData = new FormData();

          if (uploadedFile) {
            fileData.append('file', uploadedFile);
          }

          if (postRequestOptionRequest) {
            postRequestOptionFile(String(match.params.projectSlug), Number(postRequestOptionRequest.result), fileData);
          }
        } else {
          this.invalidateDataAfterRequests();
          openOrderRequestResultModal('success');
          resetRequest(String(match.params.projectSlug));
        }
      } else if (postRequestOptionStatus === 'failed') {
        this.invalidateDataAfterRequests();
        openOrderRequestResultModal('failed');
        resetRequest(String(match.params.projectSlug));
      } // eslint-disable-next-line no-restricted-syntax


      for (var _i = 0, _Object$entries = Object.entries(postRequestOptionFileRequests); _i < _Object$entries.length; _i++) {
        var _prevProps$postReques;

        var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (((_prevProps$postReques = prevProps.postRequestOptionFileRequests[key]) === null || _prevProps$postReques === void 0 ? void 0 : _prevProps$postReques.networkStatus) === 'loading' && (value.networkStatus === 'success' || value.networkStatus === 'failed')) {
          this.invalidateDataAfterRequests();
          openOrderRequestResultModal(value.networkStatus);
          break;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          projectSlug = _this$props2.projectSlug,
          modalId = _this$props2.modalId,
          options = _this$props2.options;
      var _this$state = this.state,
          optionAmount = _this$state.optionAmount,
          comment = _this$state.comment,
          uploadedFile = _this$state.uploadedFile,
          uploadError = _this$state.uploadError,
          termsValid = _this$state.termsValid,
          isSubmitting = _this$state.isSubmitting;
      var productOptionData = options.find(function (option) {
        return option.id === modalId;
      });

      if (!productOptionData) {
        return null;
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionRequestModal_Container, {
        "data-id": "homestudio_ProductOptionRequestModal_Container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductOptionRequestModal_Content, {
          "data-id": "homestudio_ProductOptionRequestModal_Content",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionRequestModal_Title, {
            "data-id": "homestudio_ProductOptionRequestModal_Title",
            children: "Optie aanvragen"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
            "data-id": "homestudio_ProductOptionRequestModal_Paragraph",
            children: "Op deze plaats kun je een aanvraag voor deze optie starten. Nadat je deze optie hebt aangevraagd, zullen wij allereerst beoordelen of de aangevraagde optie (bijvoorbeeld in combinatie met andere opties) kan worden gerealiseerd. Vervolgens verwerken we de optie en krijg je deze (eventueel voorzien van extra documentatie en een koperstekening waarop de optie is verwerkt) ter bevestiging voorgelegd. Hulp nodig? Neem contact op met je woonadviseur."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RequestContainer, {
            "data-id": "homestudio_ProductOptionRequestModal_RequestContainer",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionRequestModal_OptionTitle, {
              "data-id": "homestudio_ProductOptionRequestModal_OptionTitle",
              children: productOptionData.title
            }), productOptionData.optionCode && /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductOptionRequestModal_OptionCode, {
              "data-id": "homestudio_ProductOptionRequestModal_OptionCode",
              children: ["Optiecode: ", productOptionData.optionCode]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RequestDetails, {
              "data-id": "homestudio_ProductOptionRequestModal_RequestDetails",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RequestTitle, {
                "data-id": "homestudio_ProductOptionRequestModal_RequestTitle",
                children: "Controleer en vul aan"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                "data-id": "homestudio_ProductOptionRequestModal_p",
                children: "Controleer hier of het aantal (wanneer van toepassing) en de totaalprijs van de optie-aanvraag correct zijn. Wanneer je extra informatie wilt geven over de aanvraag (zoals de positie waarop een optie dient te worden gerealiseerd), kun je dat doen met behulp van aanvullende informatie en \xE9\xE9n of meerdere bijlagen."
              }), productOptionData.multiple && /*#__PURE__*/(0,jsx_runtime.jsxs)(MultipleContainer, {
                "data-id": "homestudio_ProductOptionRequestModal_MultipleContainer",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RequestSubTitle, {
                  "data-id": "homestudio_ProductOptionRequestModal_RequestSubTitle",
                  children: "Optie aantal"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(fieldTypes_MultipleSelector, {
                  amount: optionAmount,
                  changeHandler: this.handleChangeAmount,
                  "data-id": "homestudio_ProductOptionRequestModal_MultipleSelector"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RequestItemPrice, {
                  "data-id": "homestudio_ProductOptionRequestModal_RequestItemPrice",
                  children: ["a", ' ', formatPrice(productOptionData.price, {
                    showDecimal: true,
                    showEuroSign: true
                  }), ' ', "per stuk"]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(RequestSubTitle, {
                "data-id": "homestudio_ProductOptionRequestModal_RequestSubTitle",
                children: "Totaal bedrag"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(RequestTotal, {
                "data-id": "homestudio_ProductOptionRequestModal_RequestTotal",
                children: formatPrice(productOptionData.price * optionAmount, {
                  showDecimal: true,
                  showEuroSign: true
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextAreaContainer, {
                "data-id": "homestudio_ProductOptionRequestModal_TextAreaContainer",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RequestSubTitle, {
                  "data-id": "homestudio_ProductOptionRequestModal_RequestSubTitle",
                  children: "Aanvullende informatie (optioneel)"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Textarea/* default */.Z, {
                  id: "requestInfo",
                  name: "requestInfo",
                  title: "Toelichting (optioneel)",
                  defaultValue: comment,
                  className: comment ? 'filled' : '',
                  onChange: this.handleTextInput,
                  required: false,
                  "data-id": "homestudio_ProductOptionRequestModal_Textarea"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(UploadContainer, {
                "data-id": "homestudio_ProductOptionRequestModal_UploadContainer",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FileInput, {
                  type: "file",
                  accept: ".jpg, .png, .pdf",
                  ref: function ref(el) {
                    _this3.fileInput = el;
                  },
                  onChange: this.handleFileUpload,
                  "data-id": "homestudio_ProductOptionRequestModal_FileInput"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(TypedButtonUpload, {
                  label: "Bijlage toevoegen (optioneel)",
                  clickHandler: this.handleUploadClick,
                  "data-id": "homestudio_ProductOptionRequestModal_TypedButtonUpload"
                }), uploadedFile && /*#__PURE__*/(0,jsx_runtime.jsx)(FileName, {
                  "data-id": "homestudio_ProductOptionRequestModal_FileName",
                  children: uploadedFile.name
                }), !!uploadError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
                  "data-id": "homestudio_ProductOptionRequestModal_ErrorMessage",
                  children: uploadError
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxContainer, {
              "data-id": "homestudio_ProductOptionRequestModal_CheckboxContainer",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Checkbox/* default */.ZP, {
                id: "requestTerms",
                name: "requestTerms",
                isValid: termsValid,
                validationMessage: "U dient akkoord te gaan met de algemene voorwaarden",
                onChange: this.handleCheckClick,
                "data-id": "homestudio_ProductOptionRequestModal_Checkbox",
                children: ["Ik ga akkoord met de", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
                  href: "/".concat(String(projectSlug), "/open/sectionpage/disclaimer"),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "data-id": "homestudio_ProductOptionRequestModal_Link",
                  children: "algemene voorwaarden"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TypedButtonPrimary, {
              type: "submit",
              label: "Aanvraag verzenden",
              clickHandler: this.submitRequest,
              loading: isSubmitting,
              loadingLabel: isSubmitting ? 'Uw aanvraag wordt verzonden' : undefined,
              "data-id": "homestudio_ProductOptionRequestModal_TypedButtonPrimary"
            })]
          })]
        })
      });
    }
  }]);
}(react.Component);

/* harmony default export */ var homestudio_ProductOptionRequestModal = ((0,withMatch/* default */.Z)(hocs_withInvalidateWishListRequest((0,es/* connect */.$j)(ProductOptionRequestModal_mapStateToProps, ProductOptionRequestModal_mapDispatchToProps)(ProductOptionRequestModal))));
;// CONCATENATED MODULE: ./src/processes/modalHelpers.ts
var setHtmlStyleForModal = function setHtmlStyleForModal(open, scrollbarWidth) {
  var html = document.getElementsByTagName('html')[0];
  html.style.overflowY = open ? 'hidden' : 'scroll';
  html.style.marginRight = open ? "".concat(scrollbarWidth, "px") : '0';
};
var resetHtmlStyleForModal = function resetHtmlStyleForModal() {
  var html = document.getElementsByTagName('html')[0];
  html.style.overflowY = '';
  html.style.marginRight = '';
};
var getScrollbarWidth = function getScrollbarWidth() {
  var _outer$parentNode;

  // Creating invisible container
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear

  document.body.appendChild(outer); // Creating inner element and placing it in the container

  var inner = document.createElement('div');
  outer.appendChild(inner); // Calculating difference between container's full width and the child width

  var scrollbarWidth = outer.offsetWidth - inner.offsetWidth; // Removing temporary elements from the DOM

  (_outer$parentNode = outer.parentNode) === null || _outer$parentNode === void 0 || _outer$parentNode.removeChild(outer);
  return scrollbarWidth;
};
;// CONCATENATED MODULE: ./src/components/homestudio/ProductOptionRequestResultModal.tsx









var ProductOptionRequestResultModal_templateObject, ProductOptionRequestResultModal_templateObject2;

function ProductOptionRequestResultModal_callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = (0,getPrototypeOf/* default */.Z)(derived);
  return (0,possibleConstructorReturn/* default */.Z)(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], (0,getPrototypeOf/* default */.Z)(_this).constructor) : derived.apply(_this, args));
}

// @flow














var ProductOptionRequestResultModal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var ProductOptionRequestResultModal_Container = styled_components_browser_esm["default"].div(ProductOptionRequestResultModal_templateObject || (ProductOptionRequestResultModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, colors/* colors.white */.O.white);
var ProductOptionRequestResultModal_Content = styled_components_browser_esm["default"].div(ProductOptionRequestResultModal_templateObject2 || (ProductOptionRequestResultModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 60rem 20rem;\n"])));

var getContent = function getContent(result) {
  return result === 'success' ? ['De optie-aanvraag is verzonden', 'Bedankt voor je aanvraag. We nemen deze in behandeling en brengen je op de hoogte wanneer de aanvraag is goedgekeurd en wordt verwerkt. Je vind deze aanvraag samen met andere optie-aanvragen vanaf nu op de pagina mijn woning, inclusief de actuele orderstatus.'] : ['Er is iets misgegaan', 'Het is niet gelukt je aanvraag te verzenden. Probeer het nogmaals en neem anders contact op met de woonadviseur.'];
};

var ProductOptionRequestResultModal = /*#__PURE__*/function (_Component) {
  function ProductOptionRequestResultModal() {
    var _this2;

    (0,classCallCheck/* default */.Z)(this, ProductOptionRequestResultModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = ProductOptionRequestResultModal_callSuper(this, ProductOptionRequestResultModal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this2, "closeModal", function () {
      // eslint-disable-next-line react/destructuring-assignment
      _this2.props.onClose();

      resetHtmlStyleForModal();
    });

    return _this2;
  }

  (0,inherits/* default */.Z)(ProductOptionRequestResultModal, _Component);

  return (0,createClass/* default */.Z)(ProductOptionRequestResultModal, [{
    key: "render",
    value: function render() {
      var result = this.props.result;

      var _getContent = getContent(result),
          _getContent2 = (0,slicedToArray/* default */.Z)(_getContent, 2),
          title = _getContent2[0],
          text = _getContent2[1];

      return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOptionRequestResultModal_Container, {
        "data-id": "homestudio_ProductOptionRequestResultModal_Container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductOptionRequestResultModal_Content, {
          "data-id": "homestudio_ProductOptionRequestResultModal_Content",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_TextBox, {
            marginBottom: "xl",
            "data-id": "homestudio_ProductOptionRequestResultModal_TextBox",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
              text: title,
              "data-id": "homestudio_ProductOptionRequestResultModal_Title"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
              text: text,
              "data-id": "homestudio_ProductOptionRequestResultModal_Text"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
            text: "Terug naar het woonontwerp",
            onClick: this.closeModal,
            fullWidth: false,
            "data-id": "homestudio_ProductOptionRequestResultModal_Button"
          })]
        })
      });
    }
  }]);
}(react.Component);

/* harmony default export */ var homestudio_ProductOptionRequestResultModal = ((0,es/* connect */.$j)(null, ProductOptionRequestResultModal_mapDispatchToProps)(ProductOptionRequestResultModal));
// EXTERNAL MODULE: ./src/components/shared/forms/fieldTypes/Radio.js
var Radio = __webpack_require__(19394);
;// CONCATENATED MODULE: ./src/components/homestudio/ProductOptionConfirmModal.js








var ProductOptionConfirmModal_templateObject, ProductOptionConfirmModal_templateObject2, ProductOptionConfirmModal_templateObject3, ProductOptionConfirmModal_templateObject4, ProductOptionConfirmModal_templateObject5, ProductOptionConfirmModal_templateObject6, ProductOptionConfirmModal_templateObject7, ProductOptionConfirmModal_templateObject8, ProductOptionConfirmModal_templateObject9, ProductOptionConfirmModal_templateObject0, ProductOptionConfirmModal_templateObject1, ProductOptionConfirmModal_templateObject10, ProductOptionConfirmModal_templateObject11, ProductOptionConfirmModal_templateObject12, ProductOptionConfirmModal_templateObject13, ProductOptionConfirmModal_templateObject14, ProductOptionConfirmModal_templateObject15, ProductOptionConfirmModal_templateObject16, ProductOptionConfirmModal_templateObject17, ProductOptionConfirmModal_templateObject18, ProductOptionConfirmModal_templateObject19, ProductOptionConfirmModal_templateObject20;

var ProductOptionConfirmModal_jsx = react.createElement;

function ProductOptionConfirmModal_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function ProductOptionConfirmModal_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ProductOptionConfirmModal_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ProductOptionConfirmModal_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function ProductOptionConfirmModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ProductOptionConfirmModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ProductOptionConfirmModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ProductOptionConfirmModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}






 // Services


 // Components









 // Styles




var ProductOptionConfirmModal_connectApiData = (0,withApiData/* default */.Z)({
  orderDetails: 'getOptionOrder'
}, function (ownProps) {
  return {
    orderDetails: {
      projectSlug: ownProps.match.params.projectSlug,
      orderId: ownProps.orderId
    },
    options: {
      cache: "disabled"
    }
  };
});

var ProductOptionConfirmModal_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    postOptionOrderResult: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postOptionOrder', {
      projectSlug: ownProps.projectSlug,
      orderId: ownProps.orderId
    })
  };
};

var ProductOptionConfirmModal_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      wishListId = _ownProps$match$param.wishListId;
  var orderId = ownProps.orderId;
  return {
    postOptionOrder: function postOptionOrder(values) {
      dispatch((0,apiData/* performApiRequest */.T4)('postOptionOrder', {
        projectSlug: projectSlug,
        orderId: orderId
      }, values));
    },
    invalidateData: function invalidateData() {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postOptionOrder', {
        projectSlug: projectSlug,
        orderId: orderId
      }));

      if (wishListId) {
        dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getWishList', {
          projectSlug: projectSlug,
          wishListId: wishListId
        }));
      }

      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getSettings', {
        projectSlug: String(projectSlug),
        env: 'closed'
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getPage', {
        pagePath: String(projectSlug) + '/closed'
      }));
    },
    openNextModal: function openNextModal(modalObject) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.blue */.K5.blue, modalObject));
    }
  };
};

var ProductOptionConfirmModal = /*#__PURE__*/function (_Component) {
  function ProductOptionConfirmModal() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ProductOptionConfirmModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ProductOptionConfirmModal_callSuper(this, ProductOptionConfirmModal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      submitted: false,
      canSubmit: false,
      values: {
        attachmentsAgreed: false,
        attachmentsReason: '',
        attachmentsReasonVisible: false,
        additionsAgreed: false,
        additionsReason: '',
        additionsReasonVisible: false
      },
      termsValid: true,
      termsChecked: false
    });

    (0,defineProperty/* default */.Z)(_this, "handleConfirmationSelection", function (evt) {
      if (!evt) return;
      var target = evt.target;
      var fieldName = target.name;
      var value = target.value === 'true';

      _this.setState(function (prevState) {
        return ProductOptionConfirmModal_objectSpread(ProductOptionConfirmModal_objectSpread({}, prevState), {}, {
          values: ProductOptionConfirmModal_objectSpread(ProductOptionConfirmModal_objectSpread({}, prevState.values), {}, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, "".concat(fieldName, "Agreed"), value), "".concat(fieldName, "ReasonVisible"), !value)),
          termsChecked: false,
          termsValid: true
        });
      }, _this.checkSubmission);
    });

    (0,defineProperty/* default */.Z)(_this, "handleReasonComment", function (evt) {
      if (!evt) return;
      var target = evt.target;
      var fieldName = target.name;

      _this.setState(function (prevState) {
        return ProductOptionConfirmModal_objectSpread(ProductOptionConfirmModal_objectSpread({}, prevState), {}, {
          values: ProductOptionConfirmModal_objectSpread(ProductOptionConfirmModal_objectSpread({}, prevState.values), {}, (0,defineProperty/* default */.Z)({}, fieldName, target.value))
        });
      }, _this.checkSubmission);
    });

    (0,defineProperty/* default */.Z)(_this, "handleCheckClick", function () {
      var termsChecked = _this.state.termsChecked;

      _this.setState({
        termsValid: !termsChecked,
        termsChecked: !termsChecked
      });
    });

    (0,defineProperty/* default */.Z)(_this, "checkSubmission", function () {
      var orderDetails = _this.props.orderDetails;
      var data = orderDetails.data;
      var values = _this.state.values;
      var validation = [true]; // One default value to ensure validation works without documents

      if (data) {
        var attachmentsReasonValid = values.attachmentsReason !== '';
        var attachmentsValid = values.attachmentsAgreed || !values.attachmentsAgreed && attachmentsReasonValid;
        validation.push(attachmentsValid);

        if (data.hasTechnicalDrawing) {
          var additionsReasonValid = values.additionsReason !== '';
          var additionsValid = values.additionsAgreed || !values.additionsAgreed && additionsReasonValid;
          validation.push(additionsValid);
        }
      }

      var result = validation.every(function (item) {
        return item === true;
      });

      _this.setState({
        canSubmit: result
      });

      return result;
    });

    (0,defineProperty/* default */.Z)(_this, "handleSubmit", function () {
      var _this$props = _this.props,
          postOptionOrder = _this$props.postOptionOrder,
          orderId = _this$props.orderId,
          projectSlug = _this$props.projectSlug,
          openNextModal = _this$props.openNextModal,
          categories = _this$props.categories;
      var _this$state = _this.state,
          canSubmit = _this$state.canSubmit,
          values = _this$state.values,
          termsChecked = _this$state.termsChecked;
      var hasReason = values.attachmentsReasonVisible && values.attachmentsReason !== '' || values.additionsReasonVisible && values.additionsReason !== '';
      var hasCheckbox = !hasReason;

      if (canSubmit) {
        var statusOrder = values.attachmentsAgreed ? 'confirm_order' : 'deny_order';
        var statusDocument = values.additionsAgreed ? 'confirm_document' : 'deny_document';
        var orderData = {
          order_status: statusOrder,
          order_comment: statusOrder === 'deny_order' ? values.attachmentsReason : '',
          document_status: statusDocument,
          document_comment: statusDocument === 'deny_document' ? values.additionsReason : '',
          confirmation: termsChecked
        };

        if (hasCheckbox && !termsChecked) {
          _this.setState({
            termsValid: false
          });
        } else if (hasCheckbox && termsChecked) {
          openNextModal({
            type: 'orderVerification',
            componentProps: {
              orderId: orderId,
              projectSlug: projectSlug,
              categories: categories,
              hideCloseButtons: true
            }
          });
        } else if (hasReason) {
          postOptionOrder(orderData);
        }
      }
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ProductOptionConfirmModal, _Component);

  return (0,createClass/* default */.Z)(ProductOptionConfirmModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          orderDetails = _this$props2.orderDetails,
          postOptionOrderResult = _this$props2.postOptionOrderResult,
          orderId = _this$props2.orderId,
          projectSlug = _this$props2.projectSlug,
          openNextModal = _this$props2.openNextModal,
          categories = _this$props2.categories,
          invalidateData = _this$props2.invalidateData;

      if (orderDetails.data && orderDetails.data !== prevProps.orderDetails.data) {
        this.checkSubmission();
      }

      if (postOptionOrderResult && postOptionOrderResult.networkStatus === 'success' && prevProps.postOptionOrderResult.networkStatus !== 'success') {
        openNextModal({
          type: 'orderConfirmation',
          componentProps: {
            projectSlug: projectSlug,
            orderId: orderId,
            confirmed: false,
            success: true,
            categories: categories,
            hideCloseButtons: true
          }
        });
      } else if (postOptionOrderResult && postOptionOrderResult.networkStatus === 'failed' && prevProps.postOptionOrderResult.networkStatus !== 'failed') {
        openNextModal({
          type: 'orderConfirmation',
          componentProps: {
            projectSlug: projectSlug,
            orderId: orderId,
            confirmed: false,
            success: false,
            categories: categories
          }
        });
      }

      (0,onNetworkStatusChange/* default */.Z)({
        onSucces: invalidateData
      }, prevProps.postOptionOrderResult, postOptionOrderResult);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          projectSlug = _this$props3.projectSlug,
          orderDetails = _this$props3.orderDetails;
      var _this$state2 = this.state,
          canSubmit = _this$state2.canSubmit,
          values = _this$state2.values,
          termsValid = _this$state2.termsValid;
      var data = orderDetails.data;
      var hasReason = values.attachmentsReasonVisible && values.attachmentsReason !== '' || values.additionsReasonVisible && values.additionsReason !== '';
      return data ? ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_Container, {
        "data-id": "homestudio_ProductOptionConfirmModal_Container"
      }, ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_Content, {
        "data-id": "homestudio_ProductOptionConfirmModal_Content"
      }, ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_Title, {
        "data-id": "homestudio_ProductOptionConfirmModal_Title"
      }, "Kopersoptie ter bevestiging"), ProductOptionConfirmModal_jsx(Paragraph/* default */.Z, {
        "data-id": "homestudio_ProductOptionConfirmModal_Paragraph"
      }, "We hebben de goedgekeurde opties verwerkt en verzoeken om hieronder de optiespecificatie en de verwerking op koperstekening te controleren en aan ons te bevestigen indien akkoord. Hulp nodig? Neem contact op met je woonadviseur"), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_Section, {
        "data-id": "homestudio_ProductOptionConfirmModal_Section"
      }, ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_SectionTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_SectionTitle"
      }, "Optiespecificatie"), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_OptionTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_OptionTitle"
      }, data.option.title), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_OptionPrice, {
        "data-id": "homestudio_ProductOptionConfirmModal_OptionPrice"
      }, formatPrice(data.salesPrice, {
        showDecimal: true,
        showEuroSign: true
      })), data.option.optionCode && ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_OptionCode, {
        "data-id": "homestudio_ProductOptionConfirmModal_OptionCode"
      }, "Optiecode: ", data.option.optionCode), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_OptionDescription, {
        "data-id": "homestudio_ProductOptionConfirmModal_OptionDescription"
      }, data.option.text && ProductOptionConfirmModal_jsx(BBCode/* default */.Z, {
        content: data.option.text,
        "data-id": "homestudio_ProductOptionConfirmModal_BBCode"
      })), ProductOptionConfirmModal_jsx(components_PriceStructure, {
        priceStructure: data.option.priceStructure,
        totalPrice: data.option.price,
        "data-id": "homestudio_ProductOptionConfirmModal_PriceStructure"
      }), data.amount > 1 && ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_PriceAmountContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountContainer"
      }, ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_PriceAmountTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountTitle"
      }, "Optie aantal"), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_PriceAmountLabel, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountLabel"
      }, data.amount, " (\xE1", ' ', formatPrice(data.salesPrice, {
        showDecimal: true,
        showEuroSign: true
      }), " per stuk)"), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_PriceAmountTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountTitle"
      }, "Totaal bedrag"), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_PriceAmountLabel, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountLabel"
      }, formatPrice(data.salesPrice * data.amount, {
        showDecimal: true,
        showEuroSign: true
      }))), ProductOptionConfirmModal_jsx(SubSection, {
        "data-id": "homestudio_ProductOptionConfirmModal_SubSection"
      }, data.option.externalFiles && data.option.externalFiles.length > 0 && ProductOptionConfirmModal_jsx(react.Fragment, null, ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_SubSectionTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_SubSectionTitle"
      }, "Bijlagen"), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_DownloadContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_DownloadContainer"
      }, data.option.externalFiles.map(function (file) {
        return ProductOptionConfirmModal_jsx(ButtonDownload/* default */.Z, {
          key: "bijlagen-".concat(file.name),
          content: file.name,
          link: file.url,
          "data-id": "homestudio_ProductOptionConfirmModal_ButtonDownload"
        });
      }))), ProductOptionConfirmModal_jsx(ConfirmBox, {
        "data-id": "homestudio_ProductOptionConfirmModal_ConfirmBox"
      }, ProductOptionConfirmModal_jsx(ConfirmBoxTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_ConfirmBoxTitle"
      }, "Controleer en bevestig optiespecificatie"), ProductOptionConfirmModal_jsx(RadioContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_RadioContainer"
      }, ProductOptionConfirmModal_jsx(Radio/* default */.Z, {
        name: "attachments",
        label: "Akkoord",
        value: "true",
        onChange: this.handleConfirmationSelection,
        "data-id": "homestudio_ProductOptionConfirmModal_Radio"
      })), ProductOptionConfirmModal_jsx(RadioContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_RadioContainer"
      }, ProductOptionConfirmModal_jsx(Radio/* default */.Z, {
        name: "attachments",
        label: "Niet akkoord bevonden, omdat...",
        value: "false",
        onChange: this.handleConfirmationSelection,
        "data-id": "homestudio_ProductOptionConfirmModal_Radio"
      })), values.attachmentsReasonVisible && ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_TextAreaContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_TextAreaContainer"
      }, ProductOptionConfirmModal_jsx(Textarea/* default */.Z, {
        id: "attachmentsReason",
        name: "attachmentsReason",
        title: "Toelichting (verplicht)",
        defaultValue: values.attachmentsReason,
        className: values.attachmentsReason && 'filled',
        onChange: this.handleReasonComment,
        required: false,
        "data-id": "homestudio_ProductOptionConfirmModal_TextArea"
      }))))), data.hasTechnicalDrawing && ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_Section, {
        "data-id": "homestudio_ProductOptionConfirmModal_Section"
      }, ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_SectionTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_SectionTitle"
      }, "Verwerking op koperstekening"), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_DownloadContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_DownloadContainer"
      }, data.document && data.document.url && ProductOptionConfirmModal_jsx(ButtonDownload/* default */.Z, {
        content: data.document.name,
        link: data.document.url,
        "data-id": "homestudio_ProductOptionConfirmModal_ButtonDownload"
      })), ProductOptionConfirmModal_jsx(ConfirmBox, {
        "data-id": "homestudio_ProductOptionConfirmModal_ConfirmBox"
      }, ProductOptionConfirmModal_jsx(ConfirmBoxTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_ConfirmBoxTitle"
      }, "Controleer en bevestig verwerking op koperstekening"), ProductOptionConfirmModal_jsx(RadioContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_RadioContainer"
      }, ProductOptionConfirmModal_jsx(Radio/* default */.Z, {
        name: "additions",
        label: "Akkoord",
        value: "true",
        onChange: this.handleConfirmationSelection,
        "data-id": "homestudio_ProductOptionConfirmModal_Radio"
      })), ProductOptionConfirmModal_jsx(RadioContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_RadioContainer"
      }, ProductOptionConfirmModal_jsx(Radio/* default */.Z, {
        name: "additions",
        label: "Niet akkoord bevonden, omdat...",
        value: "false",
        onChange: this.handleConfirmationSelection,
        "data-id": "homestudio_ProductOptionConfirmModal_Radio"
      })), values.additionsReasonVisible && ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_TextAreaContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_TextAreaContainer"
      }, ProductOptionConfirmModal_jsx(Textarea/* default */.Z, {
        id: "additionsReason",
        name: "additionsReason",
        title: "Toelichting (verplicht)",
        defaultValue: values.additionsReason,
        className: values.additionsReason && 'filled',
        onChange: this.handleReasonComment,
        required: false,
        "data-id": "homestudio_ProductOptionConfirmModal_TextArea"
      })))), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_Section, {
        "data-id": "homestudio_ProductOptionConfirmModal_Section"
      }, canSubmit && hasReason ? ProductOptionConfirmModal_jsx(Paragraph/* default */.Z, {
        "data-id": "homestudio_ProductOptionConfirmModal_Paragraph"
      }, "Na het verzenden van deze reactie en toelichting, nemen we deze in behandeling en nemen we contact met je op.") : canSubmit && !hasReason ? ProductOptionConfirmModal_jsx(react.Fragment, null, ProductOptionConfirmModal_jsx(Paragraph/* default */.Z, {
        "data-id": "homestudio_ProductOptionConfirmModal_Paragraph_43"
      }, "Bij akkoord op optiespecificatie en verwerking op koperstekening geef ik opdracht aan ", data.option.commercial_company, " om deze kopersopties te leveren en factureren conform de voorwaarden in de koop-/ aannemingsovereenkomst."), ProductOptionConfirmModal_jsx(ProductOptionConfirmModal_CheckboxContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_CheckboxContainer"
      }, ProductOptionConfirmModal_jsx(Checkbox/* default */.ZP, {
        id: "requestTerms",
        name: "requestTerms",
        isValid: termsValid,
        validationMessage: "U dient akkoord te gaan met de algemene voorwaarden",
        onChange: this.handleCheckClick,
        "data-id": "homestudio_ProductOptionConfirmModal_Checkbox"
      }, "Ik ga akkoord met de", ' ', ProductOptionConfirmModal_jsx(Link/* default */.Z, {
        href: "/".concat(String(projectSlug), "/open/sectionpage/disclaimer"),
        target: "_blank",
        rel: "noopener noreferrer",
        "data-id": "homestudio_ProductOptionConfirmModal_Link"
      }, "algemene voorwaarden")))) : null, ProductOptionConfirmModal_jsx(ButtonPrimary/* default */.Z, {
        size: "small",
        type: "button",
        disabled: !canSubmit,
        buttonColor: canSubmit ? styleGuide/* colorPalette.blue */.K5.blue : styleGuide/* colorPalette.lightGrey */.K5.lightGrey,
        clickHandler: this.handleSubmit,
        "data-id": "homestudio_ProductOptionConfirmModal_ButtonPrimary"
      }, canSubmit && hasReason ? 'Verzenden' : canSubmit && !hasReason ? 'Naar ondertekenen' : 'Versturen')))) : null;
    }
  }]);
}(react.Component);

/* harmony default export */ var homestudio_ProductOptionConfirmModal = ((0,withMatch/* default */.Z)(ProductOptionConfirmModal_connectApiData((0,es/* connect */.$j)(ProductOptionConfirmModal_mapStateToProps, ProductOptionConfirmModal_mapDispatchToProps)(ProductOptionConfirmModal))));
var ProductOptionConfirmModal_Container = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject || (ProductOptionConfirmModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.white */.K5.white, styleGuide/* shadows.boxPrimary */.q.boxPrimary, styleGuide/* textStyles.bodyText */.sq.bodyText);
var ProductOptionConfirmModal_Content = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject2 || (ProductOptionConfirmModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 20rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProductOptionConfirmModal_templateObject3 || (ProductOptionConfirmModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 100rem 20rem;\n  "]))));
var ProductOptionConfirmModal_Title = styled_components_browser_esm["default"].h2(ProductOptionConfirmModal_templateObject4 || (ProductOptionConfirmModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionConfirmModal_Section = styled_components_browser_esm["default"].section(ProductOptionConfirmModal_templateObject5 || (ProductOptionConfirmModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 40rem;\n  padding-top: 32rem;\n  border-top: 1px dashed ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige);
var SubSection = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject6 || (ProductOptionConfirmModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 40rem;\n  padding-top: 32rem;\n  border-top: 1px solid ", ";\n"])), styleGuide/* colorPalette.background */.K5.background);
var ProductOptionConfirmModal_SectionTitle = styled_components_browser_esm["default"].h4(ProductOptionConfirmModal_templateObject7 || (ProductOptionConfirmModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  letter-spacing: 0.5rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: ", ";\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.orange */.K5.orange);
var ProductOptionConfirmModal_SubSectionTitle = styled_components_browser_esm["default"].h5(ProductOptionConfirmModal_templateObject8 || (ProductOptionConfirmModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionConfirmModal_OptionTitle = styled_components_browser_esm["default"].h3(ProductOptionConfirmModal_templateObject9 || (ProductOptionConfirmModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 12rem;\n\n  ", ";\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* toBreakpoint.lg */.Hx.lg(ProductOptionConfirmModal_templateObject0 || (ProductOptionConfirmModal_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 24rem;\n  "]))));
var ProductOptionConfirmModal_OptionCode = styled_components_browser_esm["default"].span(ProductOptionConfirmModal_templateObject1 || (ProductOptionConfirmModal_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-size: 14rem;\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.beige */.K5.beige);
var ProductOptionConfirmModal_OptionPrice = styled_components_browser_esm["default"].h3(ProductOptionConfirmModal_templateObject10 || (ProductOptionConfirmModal_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: normal;\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionConfirmModal_OptionDescription = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject11 || (ProductOptionConfirmModal_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 24rem;\n"])));
var ProductOptionConfirmModal_PriceAmountContainer = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject12 || (ProductOptionConfirmModal_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 40rem;\n"])));
var ProductOptionConfirmModal_PriceAmountTitle = styled_components_browser_esm["default"].h4(ProductOptionConfirmModal_templateObject13 || (ProductOptionConfirmModal_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin: 0 0 8rem;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle);
var ProductOptionConfirmModal_PriceAmountLabel = styled_components_browser_esm["default"].span(ProductOptionConfirmModal_templateObject14 || (ProductOptionConfirmModal_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n\n  &:first-of-type {\n    margin-bottom: 32rem;\n  }\n"])));
var ProductOptionConfirmModal_DownloadContainer = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject15 || (ProductOptionConfirmModal_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 16rem 0 40rem;\n"])));
var RadioContainer = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject16 || (ProductOptionConfirmModal_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 12rem;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])));
var ProductOptionConfirmModal_TextAreaContainer = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject17 || (ProductOptionConfirmModal_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 16rem;\n"])));
var ConfirmBox = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject18 || (ProductOptionConfirmModal_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  padding: 32rem 40rem;\n  box-sizing: border-box;\n  background: rgba(", ", 0.25);\n"])), styleGuide/* colorPaletteRGB.loadingBlue */.xe.loadingBlue);
var ConfirmBoxTitle = styled_components_browser_esm["default"].h5(ProductOptionConfirmModal_templateObject19 || (ProductOptionConfirmModal_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 24rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionConfirmModal_CheckboxContainer = styled_components_browser_esm["default"].div(ProductOptionConfirmModal_templateObject20 || (ProductOptionConfirmModal_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 32rem;\n"])));
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/components/shared/forms/fieldTypes/Input.js + 3 modules
var fieldTypes_Input = __webpack_require__(10001);
// EXTERNAL MODULE: ./src/components/shared/icons/Check.js
var Check = __webpack_require__(45880);
;// CONCATENATED MODULE: ./src/components/homestudio/ProductOptionVerificationModal.js








var ProductOptionVerificationModal_templateObject, ProductOptionVerificationModal_templateObject2, ProductOptionVerificationModal_templateObject3, ProductOptionVerificationModal_templateObject4, ProductOptionVerificationModal_templateObject5, ProductOptionVerificationModal_templateObject6, ProductOptionVerificationModal_templateObject7, ProductOptionVerificationModal_templateObject8, ProductOptionVerificationModal_templateObject9, ProductOptionVerificationModal_templateObject0, ProductOptionVerificationModal_templateObject1;

var ProductOptionVerificationModal_jsx = react.createElement;

function ProductOptionVerificationModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ProductOptionVerificationModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ProductOptionVerificationModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ProductOptionVerificationModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}










 // Components




 // Styles



var ProductOptionVerificationModal_connectApiData = (0,withApiData/* default */.Z)({
  verificationStatus: 'getVerificationStatus'
});

var ProductOptionVerificationModal_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    postOptionOrderRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postOptionOrder', {
      projectSlug: ownProps.projectSlug,
      orderId: ownProps.orderId
    }),
    verificationToken: (0,apiData/* getResultData */.yh)(state.apiData, 'getVerificationToken'),
    postVerificationRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postVerificationToken')
  };
};

var ProductOptionVerificationModal_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      wishListId = _ownProps$match$param.wishListId;
  return {
    getVerificationToken: function getVerificationToken() {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postVerificationToken'));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getVerificationToken'));
      dispatch((0,apiData/* performApiRequest */.T4)('getVerificationToken'));
    },
    getVerificationStatus: function getVerificationStatus() {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getVerificationStatus'));
      dispatch((0,apiData/* performApiRequest */.T4)('getVerificationStatus'));
    },
    postVerification: function postVerification(id, code) {
      dispatch((0,apiData/* performApiRequest */.T4)('postVerificationToken', {}, {
        id: id,
        token: code
      }));
    },
    postOptionOrder: function postOptionOrder(orderId, projectSlug, values) {
      dispatch((0,apiData/* performApiRequest */.T4)('postOptionOrder', {
        projectSlug: projectSlug,
        orderId: orderId
      }, values));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postOptionOrder', {
        projectSlug: projectSlug,
        orderId: orderId
      }));
    },
    invalidateData: function invalidateData() {
      if (wishListId) {
        dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getWishList', {
          projectSlug: projectSlug,
          wishListId: wishListId
        }));
      }

      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getSettings', {
        projectSlug: String(projectSlug),
        env: 'closed'
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getPage', {
        pagePath: String(projectSlug) + '/closed'
      }));
    },
    openConfirmationModal: function openConfirmationModal(success) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.blue */.K5.blue, {
        type: 'orderConfirmation',
        componentProps: {
          projectSlug: ownProps.projectSlug,
          orderId: ownProps.orderId,
          confirmed: true,
          success: success,
          categories: ownProps.categories,
          hideCloseButtons: true
        }
      }));
    },
    closeModal: function closeModal() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var ProductOptionVerificationModal = /*#__PURE__*/function (_PureComponent) {
  function ProductOptionVerificationModal() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ProductOptionVerificationModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ProductOptionVerificationModal_callSuper(this, ProductOptionVerificationModal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      sentSMS: false,
      codeValue: '',
      hasError: false,
      errorMessage: ''
    });

    (0,defineProperty/* default */.Z)(_this, "isTokenValid", function () {
      var verificationToken = _this.props.verificationToken;

      if (verificationToken) {
        return !isDateExpired(verificationToken.validUntil);
      }

      return true;
    });

    (0,defineProperty/* default */.Z)(_this, "handleSubmit", function () {
      var codeValue = _this.state.codeValue;
      var _this$props = _this.props,
          verificationStatus = _this$props.verificationStatus,
          postVerification = _this$props.postVerification,
          verificationToken = _this$props.verificationToken,
          postOptionOrder = _this$props.postOptionOrder,
          orderId = _this$props.orderId,
          projectSlug = _this$props.projectSlug;

      if (verificationStatus.data && verificationStatus.data.valid) {
        // IS ALREADY VERIFIED - POST ORDER
        postOptionOrder(orderId, projectSlug, {
          order_status: 'confirm_order',
          document_status: 'confirm_document',
          confirmation: true
        });
      } else if (!_this.isTokenValid()) {
        // TOKEN IS INVALID
        _this.setState({
          hasError: true,
          errorMessage: codeValue === '' ? 'De code is niet correct. Vraag een nieuwe code aan of neem contact op met de woonadviseur.' : 'De code is niet meer geldig. Vraag een nieuwe code aan of neem contact op met de woonadviseur. '
        });
      } else {
        // POST VERIFICATION TO BE CHECKED BY BACKEND
        postVerification(verificationToken.id, codeValue);
      }
    });

    (0,defineProperty/* default */.Z)(_this, "handleCodeInput", function (evt) {
      var el = evt.target;

      if (el) {
        _this.setState({
          codeValue: el.value
        });
      }
    });

    (0,defineProperty/* default */.Z)(_this, "handleSendCode", function () {
      var getVerificationToken = _this.props.getVerificationToken;
      getVerificationToken();

      _this.setState({
        codeValue: '',
        hasError: false,
        errorMessage: ''
      });
    });

    (0,defineProperty/* default */.Z)(_this, "handleClose", function () {
      var closeModal = _this.props.closeModal;
      closeModal();
    });

    (0,defineProperty/* default */.Z)(_this, "getExpiryTime", function (date) {
      var RADIX_VALUE = 10;
      var hours = parseInt(moment_default()(date).format('H').toString(), RADIX_VALUE);
      var minutes = parseInt(moment_default()(date).format('m').toString(), RADIX_VALUE);
      return {
        hours: hours < 10 ? "0".concat(hours) : hours.toString(),
        minutes: minutes < 10 ? "0".concat(minutes) : minutes.toString()
      };
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ProductOptionVerificationModal, _PureComponent);

  return (0,createClass/* default */.Z)(ProductOptionVerificationModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var getVerificationStatus = this.props.getVerificationStatus;
      getVerificationStatus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var sentSMS = this.state.sentSMS;
      var _this$props2 = this.props,
          verificationStatus = _this$props2.verificationStatus,
          getVerificationToken = _this$props2.getVerificationToken,
          postVerificationRequest = _this$props2.postVerificationRequest,
          postOptionOrderRequest = _this$props2.postOptionOrderRequest,
          postOptionOrder = _this$props2.postOptionOrder,
          openConfirmationModal = _this$props2.openConfirmationModal,
          orderId = _this$props2.orderId,
          projectSlug = _this$props2.projectSlug,
          invalidateData = _this$props2.invalidateData;

      if (postVerificationRequest && postVerificationRequest.networkStatus === 'success' && !postOptionOrderRequest && sentSMS) {
        // VERIFICATION SUCCEEDED - POST ORDER
        postOptionOrder(orderId, projectSlug, {
          order_status: 'confirm_order',
          document_status: 'confirm_document',
          confirmation: true
        });
      }

      if (postOptionOrderRequest && postOptionOrderRequest.networkStatus === 'success') {
        openConfirmationModal(true);
      } else if (postOptionOrderRequest && postOptionOrderRequest.networkStatus === 'failed') {
        openConfirmationModal(false);
      }

      if (postVerificationRequest && postVerificationRequest.networkStatus === 'failed') {
        // VERIFICATION FAILED
        this.setState({
          hasError: true,
          errorMessage: 'De ingevulde code is niet correct. Vraag een nieuwe code aan of neem contact op met de woonadviseur.'
        });
      } else if (postVerificationRequest && postVerificationRequest.networkStatus !== 'failed') {
        this.setState({
          hasError: false,
          errorMessage: ''
        });
      }

      if (verificationStatus.request && verificationStatus.request.networkStatus !== 'loading' && verificationStatus.data && !verificationStatus.data.valid) {
        // VERIFICATION IS INVALID
        if (!sentSMS) {
          // SEND TOKEN ONCE
          getVerificationToken();
        }

        this.setState({
          sentSMS: true
        });
      }

      (0,onNetworkStatusChange/* default */.Z)({
        onSucces: invalidateData
      }, prevProps.postOptionOrderRequest, postOptionOrderRequest);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          codeValue = _this$state.codeValue,
          hasError = _this$state.hasError,
          errorMessage = _this$state.errorMessage;
      var verificationStatus = this.props.verificationStatus;
      var data = verificationStatus.data;
      var verificationExpiry = null;

      if (data && data.valid) {
        verificationExpiry = this.getExpiryTime(data.validUntil);
      }

      return data ? ProductOptionVerificationModal_jsx(ProductOptionVerificationModal_Container, {
        "data-id": "homestudio_ProductOptionVerificationModal_Container"
      }, ProductOptionVerificationModal_jsx(ProductOptionVerificationModal_Content, {
        "data-id": "homestudio_ProductOptionVerificationModal_Content"
      }, ProductOptionVerificationModal_jsx(ProductOptionVerificationModal_Title, {
        "data-id": "homestudio_ProductOptionVerificationModal_Title"
      }, "Onderteken om te bevestigen"), ProductOptionVerificationModal_jsx(ProductOptionVerificationModal_Intro, {
        "data-id": "homestudio_ProductOptionVerificationModal_Intro"
      }, "Het maken van keuzes voor je nieuwe thuis is al spannend genoeg; dat moet je op een veilige manier kunnen doen. Daarom werken we voor het ondertekenen van de bevestiging met SMS-verificatie."), !data.valid ? ProductOptionVerificationModal_jsx(react.Fragment, null, ProductOptionVerificationModal_jsx(Paragraph/* default */.Z, {
        "data-id": "homestudio_ProductOptionVerificationModal_Paragraph"
      }, "Er is een SMS verstuurd naar ", data.phone, " met een code waarmee je de bevestiging kunt ondertekenen. De verificatie is geldig tot 30 minuten na het invullen van de code. Je kunt na het ondertekenen van deze bevestiging dan ook direct doorgaan met het bevestigen van andere kopersopties."), ProductOptionVerificationModal_jsx(Paragraph/* default */.Z, {
        "data-id": "homestudio_ProductOptionVerificationModal_Paragraph_5"
      }, "Let op: het kan tot 5 minuten duren voordat je de code ontvangt. Heb je geen code ontvangen, of is het nummer hierboven niet jouw mobiele nummer? Neem dan contact op met de woonadviseur."), ProductOptionVerificationModal_jsx(CodeContainer, {
        "data-id": "homestudio_ProductOptionVerificationModal_CodeContainer"
      }, ProductOptionVerificationModal_jsx(fieldTypes_Input/* default */.Z, {
        id: "verificationCode",
        name: "verificationCode",
        type: "text",
        title: "Code",
        defaultValue: codeValue,
        isValid: !hasError,
        validationMessage: hasError ? errorMessage : '',
        color: hasError ? styleGuide/* colorPalette.red */.K5.red : '',
        className: hasError ? 'filled' : '',
        onChange: this.handleCodeInput,
        maxLength: 6,
        "data-id": "homestudio_ProductOptionVerificationModal_Input"
      }), ProductOptionVerificationModal_jsx(SendCodeButton, {
        hasError: hasError,
        onClick: this.handleSendCode,
        "data-id": "homestudio_ProductOptionVerificationModal_SendCodeButton"
      }, "SMS opnieuw versturen"))) : ProductOptionVerificationModal_jsx(VerifiedContainer, {
        "data-id": "homestudio_ProductOptionVerificationModal_VerifiedContainer"
      }, ProductOptionVerificationModal_jsx(Check/* default */.Z, {
        width: 13,
        height: 10,
        "data-id": "homestudio_ProductOptionVerificationModal_CheckIcon"
      }), ProductOptionVerificationModal_jsx(VerifiedMessage, {
        "data-id": "homestudio_ProductOptionVerificationModal_VerifiedMessage"
      }, "Je hebt je identiteit reeds bevestigd door middel van SMS-verificatie. De huidige verificatie is geldig tot", ' ', verificationExpiry && "".concat(verificationExpiry.hours, ":").concat(verificationExpiry.minutes), ".")), ProductOptionVerificationModal_jsx(ButtonContainer, {
        "data-id": "homestudio_ProductOptionVerificationModal_ButtonContainer"
      }, ProductOptionVerificationModal_jsx(ButtonPrimary/* default */.Z, {
        type: "button",
        onClick: this.handleSubmit,
        "data-id": "homestudio_ProductOptionVerificationModal_ButtonPrimary"
      }, "Bevestiging ondertekenen"), ProductOptionVerificationModal_jsx(CloseModalButton, {
        onClick: this.handleClose,
        "data-id": "homestudio_ProductOptionVerificationModal_CloseModalButton"
      }, "Sluiten zonder bevestigen")))) : null;
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var homestudio_ProductOptionVerificationModal = ((0,withMatch/* default */.Z)(ProductOptionVerificationModal_connectApiData((0,es/* connect */.$j)(ProductOptionVerificationModal_mapStateToProps, ProductOptionVerificationModal_mapDispatchToProps)(ProductOptionVerificationModal))));
var ProductOptionVerificationModal_Container = styled_components_browser_esm["default"].div(ProductOptionVerificationModal_templateObject || (ProductOptionVerificationModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.white */.K5.white, styleGuide/* shadows.boxPrimary */.q.boxPrimary, styleGuide/* textStyles.bodyText */.sq.bodyText);
var ProductOptionVerificationModal_Content = styled_components_browser_esm["default"].div(ProductOptionVerificationModal_templateObject2 || (ProductOptionVerificationModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 20rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProductOptionVerificationModal_templateObject3 || (ProductOptionVerificationModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 100rem 20rem;\n  "]))));
var ProductOptionVerificationModal_Title = styled_components_browser_esm["default"].h2(ProductOptionVerificationModal_templateObject4 || (ProductOptionVerificationModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionVerificationModal_Intro = styled_components_browser_esm["default"].p(ProductOptionVerificationModal_templateObject5 || (ProductOptionVerificationModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var CodeContainer = styled_components_browser_esm["default"].div(ProductOptionVerificationModal_templateObject6 || (ProductOptionVerificationModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  margin-bottom: 40rem;\n"])));
var SendCodeButton = styled_components_browser_esm["default"].button(ProductOptionVerificationModal_templateObject7 || (ProductOptionVerificationModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: ", ";\n  color: ", ";\n"])), function (props) {
  return props.hasError ? '30rem' : '12rem';
}, styleGuide/* colorPalette.blue */.K5.blue);
var VerifiedContainer = styled_components_browser_esm["default"].div(ProductOptionVerificationModal_templateObject8 || (ProductOptionVerificationModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  margin: 0 0 40rem;\n\n  > svg {\n    flex-shrink: 0;\n    margin-right: 17rem;\n    margin-top: 8rem;\n    align-self: flex-start;\n  }\n"])));
var VerifiedMessage = styled_components_browser_esm["default"].span(ProductOptionVerificationModal_templateObject9 || (ProductOptionVerificationModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1 0;\n"])));
var ButtonContainer = styled_components_browser_esm["default"].div(ProductOptionVerificationModal_templateObject0 || (ProductOptionVerificationModal_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n"])));
var CloseModalButton = styled_components_browser_esm["default"].button(ProductOptionVerificationModal_templateObject1 || (ProductOptionVerificationModal_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: bold;\n  color: ", ";\n  margin-left: 24rem;\n"])), styleGuide/* colorPalette.blue */.K5.blue);
;// CONCATENATED MODULE: ./src/constants/orderStatusses.js


var getOrderStatusColor = function getOrderStatusColor(status) {
  switch (status) {
    case 'processing':
    case 'processed':
    case 'confirmed':
    case 'signed':
    case 'signed-revised':
    case 'presale':
    case 'presold':
    case 'presold-revised':
    case 'include':
    case 'included':
    case 'included-revised':
      return styleGuide/* colorPalette.green */.K5.green;

    case 'blocked':
      return styleGuide/* colorPalette.textGrey */.K5.textGrey;

    case 'requested':
    case 'requested-revised':
    default:
      return styleGuide/* colorPalette.blue */.K5.blue;
  }
};


/* harmony default export */ var orderStatusses = ({
  requested: {
    color: styleGuide/* colorPalette.blue */.K5.blue
  },
  processing: {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  processed: {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  confirmed: {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  signed: {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  'signed-revised': {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  'requested-revised': {
    color: styleGuide/* colorPalette.blue */.K5.blue
  },
  presale: {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  presold: {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  'presold-revised': {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  include: {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  included: {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  'included-revised': {
    color: styleGuide/* colorPalette.green */.K5.green
  },
  blocked: {
    color: styleGuide/* colorPalette.textGrey */.K5.textGrey
  }
});
;// CONCATENATED MODULE: ./src/components/homestudio/TriggerLabel.js


var TriggerLabel_templateObject;

var TriggerLabel_jsx = react.createElement;




var TriggerLabel_triggerLabels = {
  updated: 'Geüpdatet',
  "new": 'Nieuw',
  cancelled: 'Vervallen',
  processed: 'Actie vereist'
};

var TriggerLabel = function TriggerLabel(_ref) {
  var type = _ref.type;
  return type && TriggerLabel_jsx(TriggerLabel_Label, {
    type: type,
    "data-id": "homestudio_TriggerLabel_Label"
  }, TriggerLabel_jsx(Triangle, {
    width: 8,
    height: 8,
    direction: "bottom",
    color: type === 'cancelled' ? colorPalette.lightBeige : colorPalette.lightOrange,
    "data-id": "homestudio_TriggerLabel_Triangle"
  }), TriggerLabel_triggerLabels[type]);
};

/* harmony default export */ var homestudio_TriggerLabel = ((/* unused pure expression or super */ null && (TriggerLabel)));
var TriggerLabel_Label = styled_components_browser_esm["default"].div(TriggerLabel_templateObject || (TriggerLabel_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-flex;\n  align-items: center;\n  height: 26rem;\n  padding-left: 10rem;\n  padding-right: 10rem;\n  background: ", ";\n  font-family: ", ";\n  font-size: 12rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #fff;\n  position: relative;\n\n  > svg {\n    position: absolute;\n    bottom: -4rem;\n  }\n"])), function (props) {
  return props.type === 'cancelled' ? styleGuide/* colorPalette.lightBeige */.K5.lightBeige : styleGuide/* colorPalette.lightOrange */.K5.lightOrange;
}, styleGuide/* fonts.primary */.Rq.primary);
;// CONCATENATED MODULE: ./src/components/homestudio/utils/optionDetails.js


var getOptionLabelType = function getOptionLabelType(flag, place) {
  var labelType;

  if (Object.keys(triggerLabels).includes(place)) {
    labelType = place;
  }

  if (flag) {
    labelType = flag;
  }

  return {
    type: labelType,
    hasLabel: !!labelType
  };
};

var getOptionStyleType = function getOptionStyleType(place) {
  var label = getOptionLabelType(place);
  var styleType = '';

  if (label.type) {
    styleType = label.type;
  } else if (place === 'signed') {
    styleType = 'signed';
  } else if (place === 'presold') {
    styleType = 'presold';
  }

  return {
    type: styleType,
    hasOptionStyle: !!label.hasLabel || place === 'signed' || place === 'presold'
  };
};

var getOptionUpdateDate = function getOptionUpdateDate(date) {
  var parts = date.split(' ')[0].split('-');
  return "".concat(parts[2], "-").concat(parts[1], "-").concat(parts[0]);
};


;// CONCATENATED MODULE: ./src/components/homestudio/OrderStatusMessage.js


var OrderStatusMessage_templateObject;


/* harmony default export */ var OrderStatusMessage = (styled_components_browser_esm["default"].p(OrderStatusMessage_templateObject || (OrderStatusMessage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 14rem;\n  font-style: italic;\n  color: ", ";\n  margin: 0;\n  padding: 0;\n"])), function (props) {
  return props.color;
}));
;// CONCATENATED MODULE: ./src/components/shared/icons/Alert.js
var Alert_jsx = react.createElement;


var Alert_defaultProps = {
  color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
  width: 21,
  height: 22
};

var Alert = function Alert(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Alert_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 21 22",
    version: "1.1",
    "data-id": "icons_Alert_svg"
  }, Alert_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Alert_g"
  }, Alert_jsx("g", {
    transform: "translate(-1177.000000, -16.000000)",
    fill: color,
    "data-id": "icons_Alert_g_2"
  }, Alert_jsx("g", {
    transform: "translate(1177.000000, 16.000000)",
    "data-id": "icons_Alert_g_3"
  }, Alert_jsx("g", {
    "data-id": "icons_Alert_g_4"
  }, Alert_jsx("path", {
    d: "M16.8645196,11.8461538 C16.8645196,8.76953846 16.8459686,2.90569231 11.7697482,1.86830769 C11.776494,1.80738462 11.8051637,1.75492308 11.8051637,1.69230769 C11.8051637,0.758153846 11.0496332,0 10.1187117,0 C9.18779026,0 8.43225978,0.758153846 8.43225978,1.69230769 C8.43225978,1.75492308 8.46092946,1.80738462 8.46767527,1.86830769 C3.39145488,2.90569231 3.37290391,8.76953846 3.37290391,11.8461538 C3.37290391,15.2307692 0,16.9230769 0,16.9230769 L0,18.6153846 L20.2374235,18.6153846 L20.2374235,16.9230769 C20.2374235,16.9230769 16.8645196,15.2307692 16.8645196,11.8461538",
    "data-id": "icons_Alert_path"
  }), Alert_jsx("path", {
    d: "M8.43225978,22 L11.8051637,22 C12.7327123,22 13.4916157,21.2401538 13.4916157,20.3076923 L6.74580783,20.3076923 C6.74580783,21.2401538 7.50471121,22 8.43225978,22",
    "data-id": "icons_Alert_path_6"
  }))))));
};

Alert.defaultProps = Alert_defaultProps;
/* harmony default export */ var icons_Alert = (Alert);
;// CONCATENATED MODULE: ./src/components/homestudio/ProductOptionFinalConfirmationModal.js








var ProductOptionFinalConfirmationModal_templateObject, ProductOptionFinalConfirmationModal_templateObject2, ProductOptionFinalConfirmationModal_templateObject3, ProductOptionFinalConfirmationModal_templateObject4, ProductOptionFinalConfirmationModal_templateObject5, ProductOptionFinalConfirmationModal_templateObject6, ProductOptionFinalConfirmationModal_templateObject7, ProductOptionFinalConfirmationModal_templateObject8, ProductOptionFinalConfirmationModal_templateObject9, ProductOptionFinalConfirmationModal_templateObject0, ProductOptionFinalConfirmationModal_templateObject1, ProductOptionFinalConfirmationModal_templateObject10, ProductOptionFinalConfirmationModal_templateObject11, ProductOptionFinalConfirmationModal_templateObject12;

var ProductOptionFinalConfirmationModal_jsx = react.createElement;

function ProductOptionFinalConfirmationModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ProductOptionFinalConfirmationModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ProductOptionFinalConfirmationModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ProductOptionFinalConfirmationModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}






 // Services




 // Components



 // Styles



var ProductOptionFinalConfirmationModal_connectApiData = (0,withApiData/* default */.Z)({
  orderDetails: 'getOptionOrder'
}, function (ownProps) {
  return {
    orderDetails: {
      projectSlug: ownProps.projectSlug,
      orderId: ownProps.orderId
    }
  };
});

var ProductOptionFinalConfirmationModal_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    wishList: (0,apiData/* getResultData */.yh)(state.apiData, 'getWishList', {
      projectSlug: ownProps.projectSlug,
      wishListId: String(ownProps.match.params.wishListId)
    })
  };
};

var ProductOptionFinalConfirmationModal_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getWishList: function getWishList() {
      dispatch((0,apiData/* performApiRequest */.T4)('getWishList', {
        projectSlug: ownProps.projectSlug,
        wishListId: String(ownProps.match.params.wishListId)
      }));
    },
    openConfirmModal: function openConfirmModal(orderId) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.blue */.K5.blue, {
        type: 'orderConfirm',
        componentProps: {
          projectSlug: String(ownProps.projectSlug),
          orderId: orderId
        }
      }));
    },
    closeModal: function closeModal() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    }
  };
};

var ProductOptionFinalConfirmationModal = /*#__PURE__*/function (_PureComponent) {
  function ProductOptionFinalConfirmationModal() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ProductOptionFinalConfirmationModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ProductOptionFinalConfirmationModal_callSuper(this, ProductOptionFinalConfirmationModal, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "handleClose", function () {
      var closeModal = _this.props.closeModal;
      closeModal();
      window.location.reload();
    });

    (0,defineProperty/* default */.Z)(_this, "getOpenOrders", function () {
      var _this$props = _this.props,
          wishList = _this$props.wishList,
          orderId = _this$props.orderId,
          categories = _this$props.categories;
      var openOrders = [];

      if (wishList) {
        wishList.categories && wishList.categories.map(function (_ref) {
          var subcategories = _ref.subcategories;
          return (subcategories || []).map(function (_ref2) {
            var options = _ref2.options;
            return (options.length > 0 && options || []).map(function (option) {
              return (option.orders.length > 0 && option.orders || []).map(function (order) {
                if (order.place === 'processed' && order.id !== orderId) {
                  return openOrders.push({
                    id: order.id,
                    title: option.title,
                    price: option.price,
                    optionCode: option.optionCode,
                    place: order.place,
                    placeDescription: order.placeDescription,
                    lastUpdate: order.lastUpdate
                  });
                } else {
                  return null;
                }
              });
            });
          });
        });
      }

      if (categories) {
        categories.map(function (category) {
          return category.orders.map(function (order) {
            if (order.place === 'processed' && order.id !== orderId) {
              return openOrders.push({
                id: order.id,
                title: order.option.title,
                price: order.option.price,
                optionCode: order.option.optionCode,
                place: order.place,
                placeDescription: order.placeDescription,
                lastUpdate: order.lastUpdate
              });
            } else {
              return null;
            }
          });
        });
      }

      return openOrders;
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ProductOptionFinalConfirmationModal, _PureComponent);

  return (0,createClass/* default */.Z)(ProductOptionFinalConfirmationModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.match.params.wishListId) {
        this.props.getWishList();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          confirmed = _this$props2.confirmed,
          orderDetails = _this$props2.orderDetails,
          success = _this$props2.success,
          openConfirmModal = _this$props2.openConfirmModal;
      var data = orderDetails.data;
      var openOrders = this.getOpenOrders();
      return data && success ? ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Container, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Container"
      }, ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Content, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Content"
      }, ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Title, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Title"
      }, confirmed ? "De bevestiging is ondertekend" : "Reactie is verzonden"), ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Intro, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Intro"
      }, confirmed ? "Bedankt! We hebben de door jou ondertekende bevestiging ontvangen voor de optie:" : "Je hebt aangegeven niet akkoord te zijn met de manier waarop deze kopersoptie ter bevestiging aan je is voorgelegd. We nemen je reactie en de toelichting die je hebt gegeven in behandeling en zullen contact met je opnemen om deze te bespreken. In de tussentijd wijzigt de status van deze order naar \u2018Reactie in behandeling\u2019. Je vindt deze order samen met andere orders en optie-aanvragen op de pagina mijn woning, inclusief de actuele orderstatus. Heb je vragen over deze of andere orders? Neem contact op met de woonadviseur."), confirmed && ProductOptionFinalConfirmationModal_jsx(react.Fragment, null, ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_OptionTitle, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionTitle"
      }, data.option.title), ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_OptionPrice, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionPrice"
      }, formatPrice(data.option.price, {
        showDecimal: true,
        showEuroSign: true
      })), data.option.optionCode && ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_OptionCode, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionCode"
      }, "Optiecode: ", data.option.optionCode), ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Text, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Text"
      }, "We nemen deze bevestiging in behandeling. Wanneer je order definitief is goedgekeurd, wijzigt de status van de order naar \u2018Definitief, meer-/minderwerk\u2019. Je vindt deze order samen met andere orders en optie-aanvragen op de pagina mijn woning, inclusief de actuele orderstatus. Heb je vragen over deze of andere orders? Neem contact op met de woonadviseur.")), ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_ButtonContainer, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_ButtonContainer"
      }, ProductOptionFinalConfirmationModal_jsx(ButtonPrimary/* default */.Z, {
        type: "button",
        onClick: this.handleClose,
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_ButtonPrimary"
      }, "Terug naar mijn woning"))), openOrders.length > 0 && ProductOptionFinalConfirmationModal_jsx(OtherOptions, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_OtherOptions"
      }, ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Content, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Content"
      }, ProductOptionFinalConfirmationModal_jsx(NotificationTitle, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_NotificationTitle"
      }, ProductOptionFinalConfirmationModal_jsx(icons_Alert, {
        color: styleGuide/* colorPalette.orange */.K5.orange,
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Alert"
      }), ProductOptionFinalConfirmationModal_jsx("span", {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_span"
      }, "In afwachting van bevestiging (", openOrders.length, ")")), openOrders.map(function (order, orderIndex) {
        var handleOrderClick = function handleOrderClick() {
          return openConfirmModal(order.id);
        };

        return ProductOptionFinalConfirmationModal_jsx(OtherOption, {
          key: orderIndex,
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OtherOption"
        }, ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_OptionTitle, {
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionTitle"
        }, order.title), ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_OptionPrice, {
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionPrice"
        }, formatPrice(order.price, {
          showDecimal: true,
          showEuroSign: true
        })), order.optionCode && ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_OptionCode, {
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionCode"
        }, "Optiecode: ", order.optionCode), order.place && ProductOptionFinalConfirmationModal_jsx(OrderStatusMessage, {
          color: getOrderStatusColor(order.place),
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OrderStatusMessage"
        }, order.placeDescription, " (", getOptionUpdateDate(order.lastUpdate), ")"), order.place === 'processed' && ProductOptionFinalConfirmationModal_jsx(ButtonOrderContainer, {
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_ButtonOrderContainer"
        }, ProductOptionFinalConfirmationModal_jsx(ButtonPrimary/* default */.Z, {
          type: "button",
          size: "small",
          label: "Controleren en bevestigen",
          clickHandler: handleOrderClick,
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_ButtonPrimary"
        })));
      })))) : ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Container, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Container"
      }, ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Content, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Content"
      }, ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Title, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Title"
      }, "Er is iets misgegaan"), ProductOptionFinalConfirmationModal_jsx(ProductOptionFinalConfirmationModal_Intro, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Intro"
      }, "Het is niet gelukt je reactie te verzenden. ", ProductOptionFinalConfirmationModal_jsx("br", {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_br"
      }), ProductOptionFinalConfirmationModal_jsx("br", {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_br_27"
      }), "Probeer het nogmaals en neem anders contact op met de woonadviseur.")));
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var homestudio_ProductOptionFinalConfirmationModal = ((0,withMatch/* default */.Z)(ProductOptionFinalConfirmationModal_connectApiData((0,es/* connect */.$j)(ProductOptionFinalConfirmationModal_mapStateToProps, ProductOptionFinalConfirmationModal_mapDispatchToProps)(ProductOptionFinalConfirmationModal))));
var NotificationTitle = styled_components_browser_esm["default"].h3(ProductOptionFinalConfirmationModal_templateObject || (ProductOptionFinalConfirmationModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  display: flex;\n  align-items: center;\n  color: ", ";\n  margin: 0 0 20rem;\n\n  > span {\n    margin-left: 12px;\n  }\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.orange */.K5.orange);
var OtherOption = styled_components_browser_esm["default"].div(ProductOptionFinalConfirmationModal_templateObject2 || (ProductOptionFinalConfirmationModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 40rem;\n"])));
var ButtonOrderContainer = styled_components_browser_esm["default"].div(ProductOptionFinalConfirmationModal_templateObject3 || (ProductOptionFinalConfirmationModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 20rem;\n"])));
var OtherOptions = styled_components_browser_esm["default"].div(ProductOptionFinalConfirmationModal_templateObject4 || (ProductOptionFinalConfirmationModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: rgba(", ", 0.15);\n"])), styleGuide/* colorPaletteRGB.loadingOrange */.xe.loadingOrange);
var ProductOptionFinalConfirmationModal_Container = styled_components_browser_esm["default"].div(ProductOptionFinalConfirmationModal_templateObject5 || (ProductOptionFinalConfirmationModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.white */.K5.white, styleGuide/* shadows.boxPrimary */.q.boxPrimary, styleGuide/* textStyles.bodyText */.sq.bodyText);
var ProductOptionFinalConfirmationModal_Content = styled_components_browser_esm["default"].div(ProductOptionFinalConfirmationModal_templateObject6 || (ProductOptionFinalConfirmationModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 20rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProductOptionFinalConfirmationModal_templateObject7 || (ProductOptionFinalConfirmationModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 100rem 20rem;\n  "]))));
var ProductOptionFinalConfirmationModal_OptionTitle = styled_components_browser_esm["default"].h4(ProductOptionFinalConfirmationModal_templateObject8 || (ProductOptionFinalConfirmationModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionFinalConfirmationModal_OptionCode = styled_components_browser_esm["default"].span(ProductOptionFinalConfirmationModal_templateObject9 || (ProductOptionFinalConfirmationModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-size: 14rem;\n  display: block;\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.beige */.K5.beige);
var ProductOptionFinalConfirmationModal_OptionPrice = styled_components_browser_esm["default"].p(ProductOptionFinalConfirmationModal_templateObject0 || (ProductOptionFinalConfirmationModal_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: normal;\n  margin: 0 0 10rem;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionFinalConfirmationModal_Title = styled_components_browser_esm["default"].h2(ProductOptionFinalConfirmationModal_templateObject1 || (ProductOptionFinalConfirmationModal_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionFinalConfirmationModal_Intro = styled_components_browser_esm["default"].p(ProductOptionFinalConfirmationModal_templateObject10 || (ProductOptionFinalConfirmationModal_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProductOptionFinalConfirmationModal_Text = styled_components_browser_esm["default"].p(ProductOptionFinalConfirmationModal_templateObject11 || (ProductOptionFinalConfirmationModal_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-top: 24rem;\n  margin-bottom: 30rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText);
var ProductOptionFinalConfirmationModal_ButtonContainer = styled_components_browser_esm["default"].div(ProductOptionFinalConfirmationModal_templateObject12 || (ProductOptionFinalConfirmationModal_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n"])));
// EXTERNAL MODULE: ./src/hooks/requestHooks.ts + 63 modules
var requestHooks = __webpack_require__(1873);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/homestudio/AnonymizeUserModal.tsx


var AnonymizeUserModal_templateObject, AnonymizeUserModal_templateObject2, AnonymizeUserModal_templateObject3, AnonymizeUserModal_templateObject4, AnonymizeUserModal_templateObject5, AnonymizeUserModal_templateObject6;
















var AnonymizeUserModal_Container = styled_components_browser_esm["default"].div(AnonymizeUserModal_templateObject || (AnonymizeUserModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, colors/* colors.white */.O.white);
var AnonymizeUserModal_Content = styled_components_browser_esm["default"].div(AnonymizeUserModal_templateObject2 || (AnonymizeUserModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding-bottom: 60rem;\n"])));
var AnonymizeUserModal_Title = styled_components_browser_esm["default"].h1(AnonymizeUserModal_templateObject3 || (AnonymizeUserModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* toBreakpoint.md */.Hx.md(AnonymizeUserModal_templateObject4 || (AnonymizeUserModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(AnonymizeUserModal_templateObject5 || (AnonymizeUserModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))));
var AnonymizeUserModal_ButtonContainer = styled_components_browser_esm["default"].div(AnonymizeUserModal_templateObject6 || (AnonymizeUserModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  margin-top: 24rem;\n  gap: 24rem;\n"])));

var AnonymizeUserModal = function AnonymizeUserModal() {
  var dispatch = (0,es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();

  var _useMutationRequest = (0,requestHooks/* useMutationRequest */.iO)('patchAnonymizeUser'),
      patchAnonymizeUser = _useMutationRequest.mutate,
      patchAnonymizeUserIsError = _useMutationRequest.isError,
      patchAnonymizeUserIsLoading = _useMutationRequest.isLoading,
      patchAnonymizeUserIsSuccess = _useMutationRequest.isSuccess;

  var _useParams = (0,useParams/* default */.Z)(),
      projectSlug = _useParams.projectSlug;

  (0,react.useEffect)(function () {
    if (patchAnonymizeUserIsSuccess) {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
      router.push("/".concat(projectSlug, "/open"));
    }
  }, [dispatch, patchAnonymizeUserIsSuccess, projectSlug, router]);
  var handleSubmit = (0,react.useCallback)(function () {
    patchAnonymizeUser({});
  }, [patchAnonymizeUser]);
  var handleCancel = (0,react.useCallback)(function () {
    dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
    dispatch((0,redux_modal/* clearModalState */.TR)());
  }, [dispatch]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnonymizeUserModal_Container, {
    "data-id": "homestudio_AnonymizeUserModal_Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(AnonymizeUserModal_Content, {
      "data-id": "homestudio_AnonymizeUserModal_Content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AnonymizeUserModal_Title, {
        "data-id": "homestudio_AnonymizeUserModal_Title",
        children: "Weet je het zeker?"
      }), patchAnonymizeUserIsLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
        "data-id": "homestudio_AnonymizeUserModal_Spinner"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
        "data-id": "homestudio_AnonymizeUserModal_Text",
        children: patchAnonymizeUserIsError ? "Verwijderen van account is niet gelukt." : "Wanneer je op de 'Ik weet het zeker' knop drukt, worden jouw persoonlijke gegevens verwijderd en heb je niet langer toegang tot jouw persoonlijke Homestudios omgeving."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AnonymizeUserModal_ButtonContainer, {
        "data-id": "homestudio_AnonymizeUserModal_ButtonContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
          centerText: true,
          onClick: handleSubmit,
          text: "Ik weet het zeker",
          disabled: patchAnonymizeUserIsLoading,
          "data-id": "homestudio_AnonymizeUserModal_Button"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
          centerText: true,
          onClick: handleCancel,
          text: "Annuleren",
          variant: "secondary",
          disabled: patchAnonymizeUserIsLoading,
          "data-id": "homestudio_AnonymizeUserModal_Button_7"
        })]
      })]
    })
  });
};

/* harmony default export */ var homestudio_AnonymizeUserModal = (AnonymizeUserModal);
// EXTERNAL MODULE: ./src/components/formWizard/FormWizardSlider.tsx + 6 modules
var FormWizardSlider = __webpack_require__(60984);
;// CONCATENATED MODULE: ./src/components/formWizard/FormWizardSliderModal.tsx


var FormWizardSliderModal_templateObject, FormWizardSliderModal_templateObject2;


 // eslint-disable-next-line import/no-cycle



var FormWizardSliderModal_Container = styled_components_browser_esm["default"].div(FormWizardSliderModal_templateObject || (FormWizardSliderModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 32rem;\n  padding-bottom: 32rem;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  max-width: 100%;\n  background: ", ";\n"])), colors/* colors.white */.O.white);
var FormWizardSliderModal_Wrapper = styled_components_browser_esm["default"].div(FormWizardSliderModal_templateObject2 || (FormWizardSliderModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n"])));

var FormWizardSliderModal = function FormWizardSliderModal(_ref) {
  var formId = _ref.formId;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormWizardSliderModal_Container, {
    "data-id": "formWizard_FormWizardSliderModal_Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormWizardSliderModal_Wrapper, {
      "data-id": "formWizard_FormWizardSliderModal_Wrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormWizardSlider/* default */.Z, {
        formId: formId,
        "data-id": "formWizard_FormWizardSliderModal_FormWizardSlider"
      })
    })
  });
};

/* harmony default export */ var formWizard_FormWizardSliderModal = (FormWizardSliderModal);
;// CONCATENATED MODULE: ./src/components/RichTextBlock.js


var RichTextBlock_templateObject;

var RichTextBlock_jsx = react.createElement;




var RichTextBlock = function RichTextBlock(_ref) {
  var bbcode = _ref.bbcode;
  return bbcode ? RichTextBlock_jsx(RichTextStyling, {
    "data-e2e-block-richtextblock": true,
    "data-id": "components_RichTextBlock_RichTextStyling"
  }, RichTextBlock_jsx(BBCode/* default */.Z, {
    content: bbcode,
    "data-id": "components_RichTextBlock_BBCode"
  })) : null;
};

/* harmony default export */ var components_RichTextBlock = (RichTextBlock);
var RichTextStyling = styled_components_browser_esm["default"].div(RichTextBlock_templateObject || (RichTextBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 30rem 0rem;\n"])));
;// CONCATENATED MODULE: ./src/components/dashboard/ProfileModal.js


var ProfileModal_templateObject, ProfileModal_templateObject2, ProfileModal_templateObject3;

var ProfileModal_jsx = react.createElement;






var ProfileModal = function ProfileModal(_ref) {
  var content = _ref.content;
  return ProfileModal_jsx(ProfileModal_Container, {
    "data-id": "dashboard_ProfileModal_Container"
  }, ProfileModal_jsx(components_RichTextBlock, {
    bbcode: content,
    "data-id": "dashboard_ProfileModal_RichText"
  }));
};

var ProfileModal_Container = styled_components_browser_esm["default"].div(ProfileModal_templateObject || (ProfileModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  background-color: #fff;\n  padding: 80rem 200rem 80rem 200rem;\n\n  ", " ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* toBreakpoint.lg */.Hx.lg(ProfileModal_templateObject2 || (ProfileModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 70rem 60rem 70rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(ProfileModal_templateObject3 || (ProfileModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 40rem 30rem 40rem 30rem;\n  "]))));
/* harmony default export */ var dashboard_ProfileModal = (ProfileModal);
;// CONCATENATED MODULE: ./src/components/shared/designElements/CardElements.js


var CardElements_templateObject, CardElements_templateObject2, CardElements_templateObject3, CardElements_templateObject4, CardElements_templateObject5, CardElements_templateObject6, CardElements_templateObject7;





var CardCollectionContainer = styled_components_browser_esm["default"].div(CardElements_templateObject || (CardElements_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-flow: row wrap;\n  width: 100%;\n  box-sizing: border-box;\n  padding-top: 30rem;\n  margin-bottom: 15rem;\n  position: relative;\n\n  > * {\n    width: 100%;\n    ", ";\n\n    ", ";\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(CardElements_templateObject2 || (CardElements_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc( ((1/2) * 100%) - 10rem );\n\n      &:nth-of-type(2n + 1) {\n        margin-right: 20rem;\n      }\n\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(CardElements_templateObject3 || (CardElements_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc( ((1/3) * 100%) - 13.333rem );\n\n      &:nth-of-type(3n) {\n        margin-right: 0;\n      }\n\n      &:nth-of-type(3n + 1) {\n        margin-right: 20rem;\n      }\n\n      &:nth-of-type(3n + 2) {\n        margin-right: 20rem;\n      }\n    "]))));
var CardTitle = styled_components_browser_esm["default"].h3(CardElements_templateObject4 || (CardElements_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0;\n  transition: color 0.25s ease-in-out;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, function (props) {
  return props.color;
});
var Card = styled_components_browser_esm["default"].div(CardElements_templateObject5 || (CardElements_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  box-sizing: border-box;\n  height: 516rem;\n  margin-bottom: 20rem;\n  transition: color 0.25s ease-in-out;\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n  }\n"])), CardTitle, function (props) {
  return props.hoverColor;
});
var CardLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(CardElements_templateObject6 || (CardElements_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n  height: 100%;\n  background-color: #ffffff;\n  ", ";\n  transition: box-shadow 0.25s ease;\n  position: relative;\n\n  &:hover {\n    box-shadow: 0rem 0rem 20rem 0rem rgba(0, 0, 0, 0.25);\n  }\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary);
var CardTextContainer = styled_components_browser_esm["default"].div(CardElements_templateObject7 || (CardElements_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 2;\n  padding: 24rem 24rem 24rem 24rem;\n  box-sizing: border-box;\n"])));
;// CONCATENATED MODULE: ./src/components/shared/designElements/ThemeLabel.js


var ThemeLabel_templateObject, ThemeLabel_templateObject2;

var ThemeLabel_jsx = react.createElement;




var ThemeLabel_defaultProps = {};

var ThemeLabel = function ThemeLabel(_ref) {
  var twoTriangles = _ref.twoTriangles,
      theme = _ref.theme,
      label = _ref.label;
  return ThemeLabel_jsx(ThemeLabel_Container, {
    "data-id": "designElements_ThemeLabel_Container"
  }, twoTriangles && ThemeLabel_jsx(designElements_Triangle, {
    direction: "bottomright",
    color: styleGuide/* themes */.np[theme].primary,
    height: 40,
    width: 40,
    "data-id": "designElements_ThemeLabel_Triangle"
  }), ThemeLabel_jsx(ThemeLabel_Label, {
    color: styleGuide/* themes */.np[theme].secondary,
    "data-id": "designElements_ThemeLabel_Label"
  }, label), ThemeLabel_jsx(designElements_Triangle, {
    direction: "bottomleft",
    color: styleGuide/* themes */.np[theme].primary,
    height: 40,
    width: 40,
    "data-id": "designElements_ThemeLabel_Triangle"
  }));
};

var ThemeLabel_Container = styled_components_browser_esm["default"].div(ThemeLabel_templateObject || (ThemeLabel_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: flex-end;\n  > svg {\n    width: 40px;\n    height: 40px;\n    margin-top: auto;\n  }\n"])));
var ThemeLabel_Label = styled_components_browser_esm["default"].span(ThemeLabel_templateObject2 || (ThemeLabel_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  height: 40rem;\n  box-sizing: border-box;\n  width: max-content;\n  min-width: 210rem;\n  padding: 0 25rem;\n  background-color: ", ";\n  ", ";\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #ffffff;\n"])), function (props) {
  return props.color;
}, styleGuide/* textStyles.standardText */.sq.standardText);
ThemeLabel.defaultProps = ThemeLabel_defaultProps;
/* harmony default export */ var designElements_ThemeLabel = (ThemeLabel);
;// CONCATENATED MODULE: ./src/services/truncateText.js
/* harmony default export */ var truncateText = (function (string) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  if (!string) return '';
  var ending = '...';

  if (string.length > length) {
    // Remove last space from string
    var rtrim = function rtrim(string) {
      return string.replace(/((\s*\S+)*)\s*/, '$1');
    };

    return rtrim(string.substring(0, length)) + ending;
  } else {
    return string;
  }
});
;// CONCATENATED MODULE: ./src/components/ProjectCard.js


var ProjectCard_templateObject, ProjectCard_templateObject2, ProjectCard_templateObject3, ProjectCard_templateObject4, ProjectCard_templateObject5, ProjectCard_templateObject6;

var ProjectCard_jsx = react.createElement;











var ProjectCard_mapStateToProps = function mapStateToProps(state) {
  return {
    currentlyOpenedModal: lodash_get_default()(state, 'modal.modalConfig.componentProps.projectSlug')
  };
};

var ProjectCard_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openModal: function openModal(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
        type: 'project',
        componentProps: {
          projectSlug: ownProps.slug
        }
      }));
    }
  };
};

var ProjectCard = function ProjectCard(_ref) {
  var openModal = _ref.openModal,
      slug = _ref.slug,
      image = _ref.image,
      isNewBuild = _ref.isNewBuild,
      title = _ref.title,
      description = _ref.description;
  return ProjectCard_jsx(CardContainer, {
    hoverColor: styleGuide/* colorPalette.darkOrange */.K5.darkOrange,
    "data-id": "components_ProjectCard_CardContainer"
  }, ProjectCard_jsx(CardLink, {
    href: "/".concat(String(slug), "/open"),
    onClick: openModal,
    "data-id": "components_ProjectCard_CardLink"
  }, ProjectCard_jsx(CardImageContainer, {
    "data-id": "components_ProjectCard_CardImageContainer"
  }, ProjectCard_jsx(ImageLoader/* default */.Z, {
    mode: "bg",
    src: image,
    width: 380,
    "data-id": "components_ProjectCard_ImageLoader"
  }), ProjectCard_jsx(ThemeLabelContainer, {
    "data-id": "components_ProjectCard_ThemeLabelContainer"
  }, ProjectCard_jsx(designElements_ThemeLabel, {
    label: isNewBuild ? 'Nieuwbouw' : 'Bestaande bouw',
    theme: "projectUpdate",
    "data-id": "components_ProjectCard_ThemeLabel"
  }))), ProjectCard_jsx(TextContainer, {
    "data-id": "components_ProjectCard_TextContainer"
  }, ProjectCard_jsx(CardTitle, {
    color: styleGuide/* colorPalette.orange */.K5.orange,
    isNewBuild: isNewBuild,
    "data-id": "components_ProjectCard_CardTitle"
  }, title), ProjectCard_jsx(ProjectCard_Text, {
    "data-id": "components_ProjectCard_Text"
  }, truncateText(description, 155), ProjectCard_jsx(SeeMoreLink, {
    "data-id": "components_ProjectCard_SeeMoreLink"
  }, "Bekijk dit project")))));
};

/* harmony default export */ var components_ProjectCard = ((0,es/* connect */.$j)(ProjectCard_mapStateToProps, ProjectCard_mapDispatchToProps)(ProjectCard));
var CardContainer = (0,styled_components_browser_esm["default"])(Card)(ProjectCard_templateObject || (ProjectCard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: unset;\n  min-height: 516rem;\n  > ", " {\n    color: ", ";\n    margin: 0;\n  }\n"])), CardTitle, styleGuide/* colorPalette.orange */.K5.orange);
var TextContainer = (0,styled_components_browser_esm["default"])(CardTextContainer)(ProjectCard_templateObject2 || (ProjectCard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  position: relative;\n  padding: 24rem 24rem 48rem;\n"])));
var ProjectCard_Text = styled_components_browser_esm["default"].div(ProjectCard_templateObject3 || (ProjectCard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  ", ";\n  color: ", ";\n  margin-top: 15rem;\n  margin-bottom: 0;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var CardImageContainer = styled_components_browser_esm["default"].div(ProjectCard_templateObject4 || (ProjectCard_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 238rem;\n  flex-shrink: 0;\n"])));
var SeeMoreLink = styled_components_browser_esm["default"].span(ProjectCard_templateObject5 || (ProjectCard_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: bold;\n  position: absolute;\n  bottom: 20px;\n  left: 24px;\n  width: 100%;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.blue */.K5.blue);
var ThemeLabelContainer = styled_components_browser_esm["default"].div(ProjectCard_templateObject6 || (ProjectCard_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  z-index: 2;\n  margin-top: -40rem;\n"])));
// EXTERNAL MODULE: ./src/components/shared/richText/PageLinkInternal.js
var PageLinkInternal = __webpack_require__(28444);
;// CONCATENATED MODULE: ./src/components/ProjectBio.js


var ProjectBio_templateObject, ProjectBio_templateObject2, ProjectBio_templateObject3, ProjectBio_templateObject4, ProjectBio_templateObject5, ProjectBio_templateObject6, ProjectBio_templateObject7, ProjectBio_templateObject8, ProjectBio_templateObject9, ProjectBio_templateObject0;

var ProjectBio_jsx = react.createElement;








var getProjectBioFields = function getProjectBioFields(_ref) {
  var type = _ref.type,
      features = _ref.features,
      partners = _ref.partners,
      energyLabel = _ref.energyLabel,
      location = _ref.location,
      latitude = _ref.latitude,
      longitude = _ref.longitude;
  return [{
    id: 'type',
    label: 'Type',
    value: type,
    type: 'text'
  }, {
    id: 'features',
    label: 'Kenmerken',
    value: features,
    type: 'text'
  }, {
    id: 'partners',
    label: 'Partners',
    value: partners,
    type: 'text'
  }, {
    id: 'city',
    label: 'Plaats',
    value: location,
    type: 'text'
  }, {
    id: 'location',
    label: 'Locatie',
    value: "https://www.google.com/maps/search/?api=1&query=".concat(latitude, ",").concat(longitude),
    type: 'link'
  }];
};

var ProjectBio = function ProjectBio(_ref2) {
  var projectSlug = _ref2.projectSlug,
      title = _ref2.title,
      image = _ref2.image,
      type = _ref2.type,
      features = _ref2.features,
      energyLabel = _ref2.energyLabel,
      location = _ref2.location,
      latitude = _ref2.latitude,
      longitude = _ref2.longitude,
      partners = _ref2.partners;
  return ProjectBio_jsx(ProjectBio_Container, {
    "data-id": "components_ProjectBio_Container"
  }, ProjectBio_jsx(ProjectLogo, {
    href: "/".concat(projectSlug, "/open"),
    target: "_blank",
    "data-id": "components_ProjectBio_ProjectLogo"
  }, ProjectBio_jsx(ImageLoader/* default */.Z, {
    src: image,
    width: 260,
    height: 0,
    mode: "img",
    alt: title,
    "data-id": "components_ProjectBio_ImageLoader"
  })), ProjectBio_jsx(ProjectDetails, {
    "data-id": "components_ProjectBio_ProjectDetails"
  }, ProjectBio_jsx(ProjectDetailsHeader, {
    "data-id": "components_ProjectBio_ProjectDetailsHeader"
  }, "Projectinformatie"), ProjectBio_jsx(ProjectTitle, {
    "data-id": "components_ProjectBio_ProjectTitle"
  }, title), ProjectBio_jsx(List, {
    "data-id": "components_ProjectBio_List"
  }, getProjectBioFields({
    type: type,
    features: features,
    partners: partners,
    energyLabel: energyLabel,
    location: location,
    latitude: latitude,
    longitude: longitude
  }).map(function (field) {
    return field.value ? ProjectBio_jsx(ProjectBio_ListItem, {
      key: field.id,
      "data-id": "components_ProjectBio_ListItem"
    }, field.label, ":", ' ', field.type === 'text' ? field.value : ProjectBio_jsx(SmallLink, {
      href: field.value,
      target: "_blank",
      rel: "noopener noreferrer",
      "data-id": "components_ProjectBio_SmallLink"
    }, "Bekijk op kaart")) : null;
  })), ProjectBio_jsx(ButtonSecondary/* default */.Z, {
    color: styleGuide/* colorPalette.blue */.K5.blue,
    type: "externalLink",
    label: "Naar de projectwebsite",
    link: "/".concat(projectSlug, "/open"),
    target: "_blank",
    "data-id": "components_ProjectBio_ButtonSecondary"
  })));
};

/* harmony default export */ var components_ProjectBio = (ProjectBio);
var ProjectBio_Container = styled_components_browser_esm["default"].div(ProjectBio_templateObject || (ProjectBio_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  padding: 20rem 0;\n  border-top: dashed 1rem ", ";\n  border-bottom: dashed 1rem ", ";\n  font-family: ", ";\n  margin-bottom: 30rem;\n  ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, styleGuide/* colorPalette.lightBeige */.K5.lightBeige, styleGuide/* fonts.primary */.Rq.primary, breakpoints/* fromBreakpoint.md */.ks.md(ProjectBio_templateObject2 || (ProjectBio_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: row;\n  "]))));
var ProjectLogo = styled_components_browser_esm["default"].a(ProjectBio_templateObject3 || (ProjectBio_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  align-self: flex-start;\n  flex-shrink: 0;\n  max-width: 280rem;\n  width: 100%;\n  height: 262rem;\n  padding: 20rem;\n  box-sizing: border-box;\n  border: solid 1rem #e3e3e3;\n  margin-bottom: 20rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProjectBio_templateObject4 || (ProjectBio_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 280rem;\n    margin-bottom: 0;\n    margin-right: 20rem;\n  "]))));
var ProjectDetails = styled_components_browser_esm["default"].div(ProjectBio_templateObject5 || (ProjectBio_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  > a {\n    margin-top: auto;\n    margin-bottom: 3rem;\n  }\n"])));
var ProjectTitle = styled_components_browser_esm["default"].h3(ProjectBio_templateObject6 || (ProjectBio_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 18rem;\n  font-weight: bold;\n  margin: 0 0 10rem 0;\n  color: ", ";\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ProjectDetailsHeader = styled_components_browser_esm["default"].h4(ProjectBio_templateObject7 || (ProjectBio_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 18rem;\n  font-weight: normal;\n  margin: 0 0 5rem 0;\n  padding: 0;\n  color: ", ";\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var List = styled_components_browser_esm["default"].ul(ProjectBio_templateObject8 || (ProjectBio_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0;\n  padding: 0;\n  margin-bottom: 5rem;\n  color: ", ";\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ProjectBio_ListItem = styled_components_browser_esm["default"].li(ProjectBio_templateObject9 || (ProjectBio_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  list-style: none;\n  margin-bottom: 5rem;\n  font-size: 14rem;\n"])));
var SmallLink = styled_components_browser_esm["default"].a(ProjectBio_templateObject0 || (ProjectBio_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-size: inherit;\n"])), PageLinkInternal/* LinkStyles */.U);
;// CONCATENATED MODULE: ./src/components/ProjectModal.js








var ProjectModal_templateObject, ProjectModal_templateObject2, ProjectModal_templateObject3, ProjectModal_templateObject4, ProjectModal_templateObject5, ProjectModal_templateObject6, ProjectModal_templateObject7, ProjectModal_templateObject8, ProjectModal_templateObject9, ProjectModal_templateObject0, ProjectModal_templateObject1, ProjectModal_templateObject10;

var ProjectModal_jsx = react.createElement;

function ProjectModal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ProjectModal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ProjectModal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ProjectModal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
















var ProjectModal_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    request: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'getProjectShowcase', {
      projectSlug: String(ownProps.projectSlug)
    }),
    project: (0,apiData/* getResultData */.yh)(state.apiData, 'getProjectShowcase', {
      projectSlug: String(ownProps.projectSlug)
    })
  };
};

var ProjectModal_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getProject: function getProject(projectSlug) {
      dispatch((0,apiData/* performApiRequest */.T4)('getProjectShowcase', {
        projectSlug: projectSlug
      }));
    },
    closeModal: function closeModal(projectSlug) {
      var _ownProps$router;

      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
      (_ownProps$router = ownProps.router) === null || _ownProps$router === void 0 || _ownProps$router.push("/".concat((0,getLinkFromPageObject/* default */.Z)({
        projectSlug: projectSlug,
        env: 'open'
      })));
    }
  };
};

var ProjectModal = /*#__PURE__*/function (_Component) {
  function ProjectModal() {
    (0,classCallCheck/* default */.Z)(this, ProjectModal);

    return ProjectModal_callSuper(this, ProjectModal, arguments);
  }

  (0,inherits/* default */.Z)(ProjectModal, _Component);

  return (0,createClass/* default */.Z)(ProjectModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.fetchData(this.props);
    }
  }, {
    key: "fetchData",
    value: function fetchData(props) {
      var project = props.project,
          request = props.request,
          getProject = props.getProject,
          projectSlug = props.projectSlug;

      if (!project && (!request || request && request.networkStatus !== 'loading')) {
        getProject(projectSlug);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          project = _this$props.project,
          projectSlug = _this$props.projectSlug,
          closeModal = _this$props.closeModal;
      return project ? ProjectModal_jsx(ProjectModal_Container, {
        "data-id": "components_ProjectModal_Container"
      }, ProjectModal_jsx(TopContainer, {
        "data-id": "components_ProjectModal_TopContainer"
      }, ProjectModal_jsx(ui_Slider, {
        heroes: project.media,
        showBullets: false,
        showPrimaryArrows: false,
        showSecondaryArrows: true,
        heightRatio: 664 / 1180,
        currentIndex: 0,
        "data-id": "components_ProjectModal_Slider"
      }), ProjectModal_jsx(ProjectModal_Content, {
        "data-id": "components_ProjectModal_Content"
      }, ProjectModal_jsx(ProjectModal_TitleContainer, {
        "data-id": "components_ProjectModal_TitleContainer"
      }, ProjectModal_jsx(ProjectModal_Title, {
        color: styleGuide/* colorPalette.orange */.K5.orange,
        "data-id": "components_ProjectModal_Title"
      }, project.title)), ProjectModal_jsx(components_ProjectBio, (0,esm_extends/* default */.Z)({}, project.bio, {
        projectSlug: project.projectSlug,
        "data-id": "components_ProjectModal_ProjectBio"
      })), ProjectModal_jsx(ProjectModal_Description, {
        "data-id": "components_ProjectModal_Description"
      }, ProjectModal_jsx(BBCode/* default */.Z, {
        content: project.content,
        "data-id": "components_ProjectModal_BBCode"
      })), ProjectModal_jsx(ButtonPrimary/* default */.Z, {
        type: "button",
        label: "Naar de projectwebsite",
        clickHandler: function clickHandler() {
          return closeModal(projectSlug);
        },
        buttonColor: styleGuide/* colorPalette.blue */.K5.blue,
        "data-id": "components_ProjectModal_ButtonPrimary"
      }))), ProjectModal_jsx(ProjectCardRow, {
        "data-id": "components_ProjectModal_ProjectCardRow"
      }, (project.closestProjects || []).map(function (item) {
        return ProjectModal_jsx(components_ProjectCard, {
          key: item.slug,
          image: item.image,
          isNewBuild: item.isNewBuild,
          title: item.title,
          description: item.description,
          slug: item.slug,
          "data-id": "components_ProjectModal_ProjectCard"
        });
      }))) : null;
    }
  }]);
}(react.Component);

/* harmony default export */ var components_ProjectModal = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(ProjectModal_mapStateToProps, ProjectModal_mapDispatchToProps)(ProjectModal)));
var ProjectModal_Container = styled_components_browser_esm["default"].div(ProjectModal_templateObject || (ProjectModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
var ProjectModal_Content = styled_components_browser_esm["default"].div(ProjectModal_templateObject2 || (ProjectModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 0;\n  padding-left: 20rem;\n  padding-right: 20rem;\n"])));
var TopContainer = styled_components_browser_esm["default"].div(ProjectModal_templateObject3 || (ProjectModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: #fff;\n  padding-bottom: 60rem;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 40rem;\n  ", ";\n\n  ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* fromBreakpoint.md */.ks.md(ProjectModal_templateObject4 || (ProjectModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-bottom: 80rem;\n  "]))));
var ProjectModal_TitleContainer = styled_components_browser_esm["default"].div(ProjectModal_templateObject5 || (ProjectModal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var ProjectCardRow = styled_components_browser_esm["default"].div(ProjectModal_templateObject6 || (ProjectModal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -10rem;\n  margin-right: -10rem;\n  justify-content: space-between;\n  padding: 0 10rem;\n\n  > div {\n    ", ";\n\n    ", ";\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProjectModal_templateObject7 || (ProjectModal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc( ((1/2) * 100%) - 10rem );\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ProjectModal_templateObject8 || (ProjectModal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc( ((1/3) * 100%) - 13.333rem );\n    "]))));
var ProjectModal_Title = styled_components_browser_esm["default"].h1(ProjectModal_templateObject9 || (ProjectModal_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, function (props) {
  return props.color;
}, breakpoints/* toBreakpoint.md */.Hx.md(ProjectModal_templateObject0 || (ProjectModal_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(ProjectModal_templateObject1 || (ProjectModal_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))));
var ProjectModal_Description = styled_components_browser_esm["default"].div(ProjectModal_templateObject10 || (ProjectModal_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 45rem;\n"])));
;// CONCATENATED MODULE: ./src/components/GenericModal.tsx


var GenericModal_templateObject, GenericModal_templateObject2, GenericModal_templateObject3;






var GenericModal_Button = ButtonPrimary/* default */.Z;
var GenericModal_Wrapper = styled_components_browser_esm["default"].div(GenericModal_templateObject || (GenericModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 20rem;\n  margin-left: 20rem;\n"])));
var GenericModal_Container = styled_components_browser_esm["default"].div(GenericModal_templateObject2 || (GenericModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  align-self: center;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, styleGuide/* colorPalette.white */.K5.white);
var ContentWrapper = styled_components_browser_esm["default"].div(GenericModal_templateObject3 || (GenericModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 60rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 30rem;\n"])));

var GenericModal = function GenericModal(_ref) {
  var content = _ref.content,
      _ref$dismissButtonTex = _ref.dismissButtonText,
      dismissButtonText = _ref$dismissButtonTex === void 0 ? 'OK' : _ref$dismissButtonTex,
      _ref$showDismissButto = _ref.showDismissButton,
      showDismissButton = _ref$showDismissButto === void 0 ? false : _ref$showDismissButto,
      onDismiss = _ref.onDismiss;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModal_Container, {
    "data-id": "components_GenericModal_Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentWrapper, {
      "data-id": "components_GenericModal_ContentWrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GenericModal_Wrapper, {
        "data-id": "components_GenericModal_Wrapper",
        children: content
      }), !!onDismiss && showDismissButton && /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModal_Wrapper, {
        "data-id": "components_GenericModal_Wrapper_3",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModal_Button, {
          type: "button",
          label: dismissButtonText,
          clickHandler: onDismiss,
          "data-id": "components_GenericModal_Button"
        })
      })]
    })
  });
};

/* harmony default export */ var components_GenericModal = (GenericModal);
;// CONCATENATED MODULE: ./src/components/ModalComponentLoader.js

var ModalComponentLoader_jsx = react.createElement;

































/*
 * Note: 32 different modal types is too many, let's use GenericModal for any new functionality
 */

var ModalComponentLoader = function ModalComponentLoader(_ref) {
  var type = _ref.type,
      modalConfig = _ref.modalConfig,
      renderWidth = _ref.renderWidth;

  switch (type) {
    case 'genericModal':
      return ModalComponentLoader_jsx(components_GenericModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_GenericModal"
      }));

    case 'article':
      return ModalComponentLoader_jsx(components_Article, (0,esm_extends/* default */.Z)({
        modal: true
      }, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_Article"
      }));

    case 'form':
      return ModalComponentLoader_jsx(components_FormContainer, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_FormContainer"
      }));

    case 'image':
      return ModalComponentLoader_jsx(components_ImageContainer, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ImageContainer"
      }));

    case 'formWizard':
      return ModalComponentLoader_jsx(formWizard_FormWizardSliderModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_FormWizardSliderModal"
      }));

    case 'slider':
      return ModalComponentLoader_jsx(PictureCollageSliderContainer, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_PictureCollageSliderContainer"
      }));

    case 'handshake':
      return ModalComponentLoader_jsx(components_Handshake, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_Handshake"
      }));

    case 'categoryDescription':
      return ModalComponentLoader_jsx(homestudio_CategoryDescriptionModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_CategoryDescriptionModal"
      }));

    case 'subCategoryDescription':
      return ModalComponentLoader_jsx(homestudio_CategorySubDescriptionModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_CategorySubDescriptionModal"
      }));

    case 'fullDescription':
      return ModalComponentLoader_jsx(homestudio_ProductOptionDescriptionModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ProductOptionDescriptionModal"
      }));

    case 'firstWelcomeCJ1':
      return ModalComponentLoader_jsx(components_FirstWelcomeModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        type: type,
        "data-id": "components_ModalComponentLoader_FirstWelcomeModal"
      }));

    case 'firstWelcomeCJ2':
      return ModalComponentLoader_jsx(components_FirstWelcomeCJ2Modal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_FirstWelcomeCJ2Modal"
      }));

    case 'firstWelcomeCJ3':
      return ModalComponentLoader_jsx(components_FirstWelcomeModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        type: type,
        "data-id": "components_ModalComponentLoader_FirstWelcomeModal"
      }));

    case 'firstWelcomeWishlist':
      return ModalComponentLoader_jsx(components_FirstWelcomeWishlistModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_FirstWelcomeWishlistModal"
      }));

    case 'password':
      return ModalComponentLoader_jsx(ForgotPasswordModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_ForgotPasswordModal"
      }));

    case 'pricelist':
      return ModalComponentLoader_jsx(components_PricelistModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_PricelistModal"
      }));

    case 'profile':
      return ModalComponentLoader_jsx(dashboard_ProfileModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_ProfileModal"
      }));

    case 'feedback':
      return ModalComponentLoader_jsx(components_FeedbackModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_FeedbackModal"
      }));

    case 'editProfile':
      return ModalComponentLoader_jsx(dashboard_EditProfileModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_EditProfileModal"
      }));

    case 'deleteWishList':
      return ModalComponentLoader_jsx(components_DeleteWishListModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_DeleteWishListModal"
      }));

    case 'planningStep':
      return ModalComponentLoader_jsx(dashboard_PlanningStepModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_PlanningStepModal"
      }));

    case 'planningAction':
      return ModalComponentLoader_jsx(dashboard_PlanningActionModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_PlanningActionModal"
      }));

    case 'activation':
      return ModalComponentLoader_jsx(dashboard_ActivationModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ActivationModal"
      }));

    case 'interests':
      return ModalComponentLoader_jsx(dashboard_ECWInterestModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        "data-id": "components_ModalComponentLoader_ECWInterestModal"
      }));

    case 'project':
      return ModalComponentLoader_jsx(components_ProjectModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ProjectModal"
      }));

    case 'deadlinesDescription':
      return ModalComponentLoader_jsx(homestudio_DeadlineModal, {
        "data-id": "components_ModalComponentLoader_DeadlineModal"
      });

    case 'orderRequest':
      return ModalComponentLoader_jsx(homestudio_ProductOptionRequestModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ProductOptionRequestModal"
      }));

    case 'orderRequestResult':
      return ModalComponentLoader_jsx(homestudio_ProductOptionRequestResultModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ProductOptionRequestResultModal"
      }));

    case 'orderConfirm':
      return ModalComponentLoader_jsx(homestudio_ProductOptionConfirmModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ProductOptionConfirmModal"
      }));

    case 'orderVerification':
      return ModalComponentLoader_jsx(homestudio_ProductOptionVerificationModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ProductOptionVerificationModal"
      }));

    case 'orderConfirmation':
      return ModalComponentLoader_jsx(homestudio_ProductOptionFinalConfirmationModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ProductOptionFinalConfirmationModal"
      }));

    case 'optionOrderStatus':
      return ModalComponentLoader_jsx(homestudio_ProductOptionStatusModal, (0,esm_extends/* default */.Z)({}, modalConfig.componentProps, {
        renderWidth: renderWidth,
        "data-id": "components_ModalComponentLoader_ProductOptionStatusModal"
      }));

    case 'anonymizeUser':
      return ModalComponentLoader_jsx(homestudio_AnonymizeUserModal, {
        "data-id": "components_ModalComponentLoader_AnonymizeUserModal"
      });

    default:
      return null;
  }
};

/* harmony default export */ var components_ModalComponentLoader = (ModalComponentLoader);
// EXTERNAL MODULE: ./src/components/shared/icons/CloseCross.js
var CloseCross = __webpack_require__(54317);
;// CONCATENATED MODULE: ./src/components/shared/buttons/ButtonClose.js


var ButtonClose_templateObject, ButtonClose_templateObject2, ButtonClose_templateObject3, ButtonClose_templateObject4, ButtonClose_templateObject5;

var ButtonClose_jsx = react.createElement;






var ButtonClose_defaultProps = {
  label: 'sluit',
  colorText: false
};

var ButtonClose = function ButtonClose(_ref) {
  var label = _ref.label,
      color = _ref.color,
      colorText = _ref.colorText,
      renderWidth = _ref.renderWidth,
      clickHandler = _ref.clickHandler;
  return ButtonClose_jsx(ButtonClose_Button, {
    onClick: clickHandler,
    "data-e2e-button-close": true,
    "data-id": "buttons_ButtonClose_Button"
  }, ButtonClose_jsx(ButtonClose_Label, {
    colorText: colorText,
    color: color,
    "data-id": "buttons_ButtonClose_Label"
  }, label), ButtonClose_jsx(CloseCrossContainer, {
    color: color,
    "data-id": "buttons_ButtonClose_CloseCrossContainer"
  }, ButtonClose_jsx(CloseCross/* default */.Z, {
    width: renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? 12 : 16,
    height: renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? 12 : 16,
    color: "#fff",
    "data-id": "buttons_ButtonClose_CloseCross"
  })));
};

ButtonClose.defaultProps = ButtonClose_defaultProps;
/* harmony default export */ var buttons_ButtonClose = (ButtonClose);
var ButtonClose_Button = styled_components_browser_esm["default"].button(ButtonClose_templateObject || (ButtonClose_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n"])));
var ButtonClose_Label = styled_components_browser_esm["default"].span(ButtonClose_templateObject2 || (ButtonClose_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-self: center;\n  margin-right: 10rem;\n  font-family: ", ";\n  font-size: 16rem;\n  font-weight: bold;\n  color: ", ";\n  text-transform: uppercase;\n\n  ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.colorText ? props.color : '#ffffff';
}, breakpoints/* fromBreakpoint.md */.ks.md(ButtonClose_templateObject3 || (ButtonClose_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 20rem;"]))));
var CloseCrossContainer = styled_components_browser_esm["default"].div(ButtonClose_templateObject4 || (ButtonClose_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 30rem;\n  width: 30rem;\n  background: ", ";\n  border-radius: 4rem 0 4rem 0;\n\n  ", ";\n"])), function (props) {
  return props.color ? "".concat(props.color) : "".concat((0,utils/* darken */._j)(styleGuide/* colorPalette.beige */.K5.beige, 5));
}, breakpoints/* fromBreakpoint.md */.ks.md(ButtonClose_templateObject5 || (ButtonClose_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 40rem;\n    width: 40rem;\n  "]))));
;// CONCATENATED MODULE: ./src/services/isWhite.js
/* harmony default export */ var isWhite = (function (colorString) {
  return colorString === '#fff' || colorString === '#ffffff' || colorString === '#FFF' || colorString === '#FFFFFF' || colorString === 'white';
});
;// CONCATENATED MODULE: ./src/components/Modal.js








var Modal_templateObject, Modal_templateObject2, Modal_templateObject3, Modal_templateObject4, Modal_templateObject5, Modal_templateObject6, Modal_templateObject7, Modal_templateObject8;

var Modal_jsx = react.createElement;

function Modal_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, Modal_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function Modal_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (Modal_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

















var Modal_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    modalIsOpen: state.modal.modalIsOpen,
    color: state.modal.color,
    modalConfig: state.modal.modalConfig,
    showLoader: state.modal.showLoader,
    initialized: state.modal.initialized,
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};

var Modal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    },
    closeOnLocationChange: function closeOnLocationChange() {
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
      dispatch((0,redux_modal/* clearModalState */.TR)());
    },
    setInitialized: function setInitialized() {
      dispatch((0,redux_modal/* setModalInitialized */.h4)());
    }
  };
};

var Modal = /*#__PURE__*/function (_Component) {
  function Modal(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Modal);

    _this = Modal_callSuper(this, Modal, [props]);

    (0,defineProperty/* default */.Z)(_this, "scrollEl", null);

    (0,defineProperty/* default */.Z)(_this, "handleModalClose", function (evt) {
      if (evt && evt.type === 'click' || evt && evt.type === 'keydown' && evt.keyCode === 27) {
        var _this$props$modalConf, _this$props$modalConf2;

        _this.props.onClose();

        (_this$props$modalConf = (_this$props$modalConf2 = _this.props.modalConfig).onClose) === null || _this$props$modalConf === void 0 || _this$props$modalConf.call(_this$props$modalConf2);
      }
    });

    _this.state = {};
    return _this;
  }

  (0,inherits/* default */.Z)(Modal, _Component);

  return (0,createClass/* default */.Z)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleModalClose, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.closeOnLocationChange();
      window.removeEventListener('keydown', this.handleModalClose, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          modalIsOpen = _this$props.modalIsOpen,
          closeOnLocationChange = _this$props.closeOnLocationChange,
          initialized = _this$props.initialized,
          setInitialized = _this$props.setInitialized;
      var previousPathname = this.state.previousPathname; // reset scoll position, only if the modal was just opened

      if (!initialized) {
        if (this.scrollEl) {
          this.scrollEl.scrollTop = 0;
        }

        setInitialized();
      }

      if (modalIsOpen && !prevProps.modalIsOpen) {
        setHtmlStyleForModal(true, getScrollbarWidth());
      }

      if (!modalIsOpen && prevProps.modalIsOpen) {
        resetHtmlStyleForModal();
      }

      if (previousPathname !== window.location.pathname) {
        closeOnLocationChange();
        this.setState({
          previousPathname: window.location.pathname
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          match = _this$props2.match,
          modalIsOpen = _this$props2.modalIsOpen,
          color = _this$props2.color,
          showLoader = _this$props2.showLoader,
          modalConfig = _this$props2.modalConfig,
          renderWidth = _this$props2.renderWidth,
          styling = _this$props2.styling;
      var env = match.params.env;
      var buttonColor = env === 'open' ? styling.button ? styling.button : styleGuide/* colorPalette.beige */.K5.beige : styleGuide/* colorPalette.blue */.K5.blue;
      return Modal_jsx(ModalBackground, {
        isOpen: modalIsOpen,
        color: color,
        "data-id": "components_Modal_ModalBackground"
      }, Modal_jsx(ScrollContainer, {
        ref: function ref(scrollEl) {
          _this2.scrollEl = scrollEl;
        },
        className: "scrollable",
        "data-id": "components_Modal_ScrollContainer"
      }, modalConfig && modalConfig.type && Modal_jsx(ModalGridWrapper, {
        "data-e2e-modalcomponent-wrapper": true,
        "data-id": "components_Modal_ModalGridWrapper"
      }, showLoader && Modal_jsx(ContentLoader/* default */.Z, {
        "data-id": "components_Modal_ContentLoader"
      }), !showLoader && (!modalConfig.componentProps || !modalConfig.componentProps.hideCloseButtons) && Modal_jsx(Modal_ButtonContainer, {
        color: color,
        "data-id": "components_Modal_ButtonContainer"
      }, Modal_jsx(buttons_ButtonClose, {
        clickHandler: this.handleModalClose,
        color: isWhite(color) ? buttonColor : color ? (0,utils/* darken */._j)(color, 8) : '',
        colorText: isWhite(color),
        renderWidth: renderWidth,
        "data-id": "components_Modal_ButtonClose"
      })), Modal_jsx(AnimationWrapper, {
        "data-e2e-modalcomponent": modalConfig.type,
        doneLoading: !showLoader,
        "data-id": "components_Modal_AnimationWrapper"
      }, Modal_jsx(components_ModalComponentLoader, {
        type: modalConfig.type,
        modalConfig: modalConfig,
        renderWidth: renderWidth,
        "data-id": "components_Modal_ModalComponentLoader"
      })), !showLoader && (!modalConfig.componentProps || !modalConfig.componentProps.hideCloseButtons) && Modal_jsx(Modal_ButtonContainer, {
        color: color,
        second: 1,
        "data-id": "components_Modal_ButtonContainer"
      }, Modal_jsx(buttons_ButtonClose, {
        clickHandler: this.handleModalClose,
        color: isWhite(color) ? buttonColor : color ? (0,utils/* darken */._j)(color, 8) : '',
        colorText: isWhite(color),
        renderWidth: renderWidth,
        "data-id": "components_Modal_ButtonClose"
      })))));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_Modal = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(Modal_mapStateToProps, Modal_mapDispatchToProps)(Modal)));
var ModalBackground = styled_components_browser_esm["default"].div(Modal_templateObject || (Modal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  position: fixed;\n  z-index: 100;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  transition: background 0.4s ease-in;\n  background: ", ";\n  visibility: ", ";\n  animation: ", ";\n  animation-fill-mode: forwards;\n"])), function (props) {
  var _props$color;

  if (isWhite(props.color)) {
    return 'rgba(255, 255, 255, 1)';
  }

  return (0,utils/* hex2rgb */.wK)((_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : styleGuide/* colorPalette.beige */.K5.beige, 0.9);
}, function (props) {
  return props.isOpen ? 'visible' : 'hidden';
}, function (props) {
  return props.isOpen ? (0,styled_components_browser_esm.css)(Modal_templateObject2 || (Modal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    ", " 0.5s\n                  "])), styleGuide/* fadeIn */.Ji) : (0,styled_components_browser_esm.css)(Modal_templateObject3 || (Modal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    ", " 0.5s\n                  "])), styleGuide/* fadeOutDown */.lM);
});
var ModalGridWrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(Modal_templateObject4 || (Modal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: flex-start;\n  flex-direction: row;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: 40rem 20rem;\n"])));
var ScrollContainer = styled_components_browser_esm["default"].div(Modal_templateObject5 || (Modal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: scroll;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n"])));
var Modal_ButtonContainer = styled_components_browser_esm["default"].div(Modal_templateObject6 || (Modal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin-bottom: ", ";\n  width: 100%;\n  margin-top: ", ";\n\n  &:before {\n    content: '';\n    display: flex;\n    flex-grow: 1;\n    width: 100%;\n  }\n"])), function (props) {
  return props.second ? 0 : '20rem';
}, function (props) {
  return props.second ? '20rem' : 0;
});
var AnimationWrapper = styled_components_browser_esm["default"].div(Modal_templateObject7 || (Modal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  opacity: 0;\n  animation: ", ";\n  animation-delay: 0.5s;\n  animation-fill-mode: forwards;\n"])), function (props) {
  return props.doneLoading ? (0,styled_components_browser_esm.css)(Modal_templateObject8 || (Modal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    ", " 0.6s ", "\n                  "])), styleGuide/* fadeInUp */.eu, styleGuide/* CUBIC_TIMING */.I5) : '';
});
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/shared/meta/Head.tsx





var HeadComponent = function HeadComponent(_ref) {
  var title = _ref.title,
      metaTitle = _ref.metaTitle,
      metaKeywords = _ref.metaKeywords,
      metaDescription = _ref.metaDescription;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    "data-id": "meta_Head_Head",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      "data-id": "meta_Head_title",
      children: title !== null && title !== void 0 ? title : 'Homestudios'
    }, "title"), metaTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "title",
      content: metaTitle,
      "data-id": "meta_Head_meta"
    }), metaKeywords && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: metaKeywords,
      "data-id": "meta_Head_meta_3"
    }), metaDescription && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: metaDescription,
      "data-id": "meta_Head_meta_4"
    })]
  });
};

/* harmony default export */ var Head = (HeadComponent);
// EXTERNAL MODULE: ./src/redux/globalApiError.js
var globalApiError = __webpack_require__(68171);
;// CONCATENATED MODULE: ./src/components/shared/ui/ErrorBar.js







var ErrorBar_templateObject, ErrorBar_templateObject2, ErrorBar_templateObject3, ErrorBar_templateObject4, ErrorBar_templateObject5, ErrorBar_templateObject6;

var ErrorBar_jsx = react.createElement;

function ErrorBar_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ErrorBar_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ErrorBar_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ErrorBar_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}













var ErrorBar_mapStateToProps = function mapStateToProps(state) {
  return {
    globalApiConfig: state.apiData.globalConfig,
    error: state.globalApiError
  };
};

var ErrorBar_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clearCache: function clearCache() {
      return dispatch((0,apiData/* clearCache */.LK)());
    },
    hideError: function hideError() {
      return dispatch((0,globalApiError/* hideApiError */.T3)());
    }
  };
};

var ErrorBar = /*#__PURE__*/function (_Component) {
  function ErrorBar() {
    (0,classCallCheck/* default */.Z)(this, ErrorBar);

    return ErrorBar_callSuper(this, ErrorBar, arguments);
  }

  (0,inherits/* default */.Z)(ErrorBar, _Component);

  return (0,createClass/* default */.Z)(ErrorBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.init(this.props);
    }
  }, {
    key: "init",
    value: function init(_ref) {
      var error = _ref.error,
          hideError = _ref.hideError,
          clearCache = _ref.clearCache,
          match = _ref.match,
          router = _ref.router;

      switch (error.showError && error.body && error.body.status_code) {
        case 401:
        case 403:
          setTimeout(function () {
            hideError();
            router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug || ''), "/closed"));
            clearCache();
          }, 3000);
          break;

        default:
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          hideError = _this$props.hideError,
          globalApiConfig = _this$props.globalApiConfig;
      var errorCode = lodash_get_default()(error, 'body.status_code', undefined);
      var message;
      var buttons;

      switch (globalApiConfig && globalApiConfig.errorMessages && error.showError && errorCode) {
        case 401:
        case 403:
          message = lodash_get_default()(globalApiConfig, "errorMessages[".concat(errorCode, "]"), globalApiConfig.errorMessages && globalApiConfig.errorMessages["default"]);
          buttons = ErrorBar_jsx(SpinnerContainer, {
            "data-id": "ui_ErrorBar_SpinnerContainer"
          }, ErrorBar_jsx(Spinner/* default */.Z, {
            monochrome: true,
            color: "#ffffff",
            size: "small",
            "data-id": "ui_ErrorBar_Spinner"
          }));
          break;

        case 500:
          message = lodash_get_default()(globalApiConfig, "errorMessages[500]", globalApiConfig.errorMessages && globalApiConfig.errorMessages["default"]);
          buttons = ErrorBar_jsx(ErrorBar_Button, {
            onClick: hideError,
            "data-id": "ui_ErrorBar_Button"
          }, ErrorBar_jsx(CloseCross/* default */.Z, {
            "data-id": "ui_ErrorBar_CloseCross"
          }));
          break;

        default:
          break;
      }

      return error.showError ? ErrorBar_jsx(ErrorBar_Bar, {
        "data-id": "ui_ErrorBar_Bar"
      }, ErrorBar_jsx(ErrorBar_Content, {
        "data-id": "ui_ErrorBar_Content"
      }, message), ErrorBar_jsx(ErrorBar_Buttons, {
        "data-id": "ui_ErrorBar_Buttons"
      }, buttons)) : null;
    }
  }]);
}(react.Component);

/* harmony default export */ var ui_ErrorBar = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(ErrorBar_mapStateToProps, ErrorBar_mapDispatchToProps)(ErrorBar)));
var ErrorBar_Bar = styled_components_browser_esm["default"].div(ErrorBar_templateObject || (ErrorBar_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  position: fixed;\n  z-index: 9;\n  bottom: 20rem;\n  left: 20rem;\n  background: ", ";\n  color: #fff;\n  max-width: 320rem;\n  width: 100%;\n  font-family: ", ";\n  ", ";\n  transform-origin: 0 0;\n  animation: ", " 0.6s ", ";\n  animation-fill-mode: forwards;\n\n  ", ";\n"])), styleGuide/* colorPalette.blue */.K5.blue, styleGuide/* fonts.primary */.Rq.primary, styleGuide/* shadows.boxPrimary */.q.boxPrimary, styleGuide/* rollOutLeft */.O3, styleGuide/* CUBIC_TIMING */.I5, breakpoints/* fromBreakpoint.md */.ks.md(ErrorBar_templateObject2 || (ErrorBar_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    max-width: 450rem;\n  "]))));
var ErrorBar_Content = styled_components_browser_esm["default"].span(ErrorBar_templateObject3 || (ErrorBar_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n  padding: 0 15rem;\n  opacity: 0;\n  animation: ", " 0.6s ", ";\n  animation-delay: 0.6s;\n  animation-fill-mode: forwards;\n"])), styleGuide/* fadeIn */.Ji, styleGuide/* CUBIC_TIMING */.I5);
var ErrorBar_Buttons = styled_components_browser_esm["default"].div(ErrorBar_templateObject4 || (ErrorBar_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin-left: auto;\n"])));
var SpinnerContainer = styled_components_browser_esm["default"].div(ErrorBar_templateObject5 || (ErrorBar_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  max-height: 40rem;\n  max-width: 40rem;\n  padding: 15rem;\n"])));
var ErrorBar_Button = styled_components_browser_esm["default"].button(ErrorBar_templateObject6 || (ErrorBar_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  padding: 15rem;\n"])));
;// CONCATENATED MODULE: ./src/components/shared/ui/CMSPreviewMessage.js


var CMSPreviewMessage_templateObject, CMSPreviewMessage_templateObject2, CMSPreviewMessage_templateObject3;

var CMSPreviewMessage_jsx = react.createElement;





var isCMSPreviewModeEnabled = function isCMSPreviewModeEnabled() {
  return window.location.search && window.location.search.includes('phase') && (window.location.search.includes('preview') || window.location.search.includes('concept'));
};

var CMSPreviewMessage = function CMSPreviewMessage() {
  return isCMSPreviewModeEnabled() ? CMSPreviewMessage_jsx(CMSPreviewMessage_Bar, {
    "data-id": "ui_CMSPreviewMessage_Bar"
  }, CMSPreviewMessage_jsx(CMSPreviewMessage_Content, {
    "data-id": "ui_CMSPreviewMessage_Content"
  }, CMSPreviewMessage_jsx(icons_Alert, {
    color: "#ffffff",
    "data-id": "ui_CMSPreviewMessage_Alert"
  }), CMSPreviewMessage_jsx(CMSPreviewMessage_Message, {
    "data-id": "ui_CMSPreviewMessage_Message"
  }, "U zit in CMS Preview mode."))) : null;
};

/* harmony default export */ var ui_CMSPreviewMessage = (CMSPreviewMessage);
var CMSPreviewMessage_Bar = styled_components_browser_esm["default"].div(CMSPreviewMessage_templateObject || (CMSPreviewMessage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: fixed;\n  z-index: 1;\n  top: 50%;\n  left: 0;\n  width: 100rem;\n  padding: 15rem;\n  background: ", ";\n  opacity: 0.8;\n  ", ";\n  transform-origin: 0 0;\n  animation: ", " 0.6s ", ";\n  animation-fill-mode: forwards;\n"])), styleGuide/* colorPalette.blue */.K5.blue, styleGuide/* shadows.boxPrimary */.q.boxPrimary, styleGuide/* rollOutLeft */.O3, styleGuide/* CUBIC_TIMING */.I5);
var CMSPreviewMessage_Content = styled_components_browser_esm["default"].div(CMSPreviewMessage_templateObject2 || (CMSPreviewMessage_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex-direction: column;\n  opacity: 0;\n  animation: ", " 0.6s ", ";\n  animation-delay: 0.6s;\n  animation-fill-mode: forwards;\n"])), styleGuide/* fadeIn */.Ji, styleGuide/* CUBIC_TIMING */.I5);
var CMSPreviewMessage_Message = styled_components_browser_esm["default"].span(CMSPreviewMessage_templateObject3 || (CMSPreviewMessage_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  font-family: ", ";\n  color: #fff;\n  font-weight: bold;\n  margin-top: 10rem;\n  text-align: center;\n  line-height: 18rem;\n"])), styleGuide/* fonts.primary */.Rq.primary);
;// CONCATENATED MODULE: ./src/components/CookieNotice.js








var CookieNotice_templateObject, CookieNotice_templateObject2, CookieNotice_templateObject3, CookieNotice_templateObject4, CookieNotice_templateObject5;

var CookieNotice_jsx = react.createElement;

function CookieNotice_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, CookieNotice_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function CookieNotice_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (CookieNotice_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}











var CookieNotice = /*#__PURE__*/function (_PureComponent) {
  function CookieNotice() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, CookieNotice);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = CookieNotice_callSuper(this, CookieNotice, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      show: false
    });

    (0,defineProperty/* default */.Z)(_this, "setVisibility", function (_ref) {
      var match = _ref.match,
          loggedIn = _ref.loggedIn;
      var cookies = document.cookie;

      if (!loggedIn && match.params.env === 'open' && !cookies.includes('acceptTerms=yes')) {
        _this.setState({
          show: true
        });
      } else {
        _this.setState({
          show: false
        });
      }
    });

    (0,defineProperty/* default */.Z)(_this, "handleClick", function () {
      _this.setState({
        show: false
      }, function () {
        document.cookie = 'acceptTerms=yes; expires=Thu, 31 Dec 2099 12:00:00 UTC';
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(CookieNotice, _PureComponent);

  return (0,createClass/* default */.Z)(CookieNotice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setVisibility(this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          renderWidth = _this$props.renderWidth,
          match = _this$props.match;
      var _match$params = match.params,
          projectSlug = _match$params.projectSlug,
          env = _match$params.env;
      return this.state.show ? CookieNotice_jsx(CookieNotice_Bar, {
        "data-id": "components_CookieNotice_Bar"
      }, CookieNotice_jsx(gridElements/* GridWrapper */.zc, {
        "data-id": "components_CookieNotice_GridWrapper"
      }, CookieNotice_jsx(CookieNotice_Message, {
        "data-id": "components_CookieNotice_Message"
      }, CookieNotice_jsx("span", {
        "data-id": "components_CookieNotice_span"
      }, "Homestudios gebruikt cookies om uw gebruikerservaring te verbeteren. Voor meer informatie bekijk onze", ' ', CookieNotice_jsx(StyledLink, {
        href: "/".concat(String(projectSlug), "/").concat(String(env), "/sectionpage/disclaimer"),
        "data-id": "components_CookieNotice_StyledLink"
      }, "disclaimer"), "."), CookieNotice_jsx(ButtonPrimary/* default */.Z, {
        type: "button",
        label: "Accepteer",
        clickHandler: this.handleClick,
        buttonColor: "#fff",
        buttonHoverColor: styleGuide/* colorPalette.darkBlue */.K5.darkBlue,
        labelColor: styleGuide/* colorPalette.blue */.K5.blue,
        labelHoverColor: "#fff",
        size: renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? 'small' : 'normal',
        "data-id": "components_CookieNotice_ButtonPrimary"
      })))) : null;
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var components_CookieNotice = ((0,withMatch/* default */.Z)(CookieNotice));
var CookieNotice_Bar = styled_components_browser_esm["default"].div(CookieNotice_templateObject || (CookieNotice_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 15rem;\n  position: fixed;\n  z-index: 1;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  color: #fff;\n  background: ", ";\n  font-family: ", ";\n\n  > div {\n    flex-wrap: wrap;\n  }\n\n  ", ";\n"])), (0,utils/* hex2rgb */.wK)(styleGuide/* colorPalette.blue */.K5.blue, 0.9), styleGuide/* fonts.primary */.Rq.primary, breakpoints/* fromBreakpoint.md */.ks.md(CookieNotice_templateObject2 || (CookieNotice_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 80rem;\n\n    > div {\n      flex-wrap: initial;\n    }\n  "]))));
var CookieNotice_Message = styled_components_browser_esm["default"].div(CookieNotice_templateObject3 || (CookieNotice_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  font-size: 14rem;\n\n  ", ";\n\n  > button {\n    margin-top: auto;\n  }\n\n  > span {\n    padding-right: 20rem;\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(CookieNotice_templateObject4 || (CookieNotice_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 18rem;\n\n    > button {\n      margin-top: 0;\n      margin-left: auto;\n    }\n\n    > div {\n      flex-wrap: initial;\n    }\n  "]))));
var StyledLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(CookieNotice_templateObject5 || (CookieNotice_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-style: italic;\n  text-decoration: none;\n  color: #fff;\n\n  text-decoration: none;\n  border-bottom: 1rem solid transparent;\n  transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n  :hover {\n    border-bottom: 1rem solid #fff;\n  }\n"])));
;// CONCATENATED MODULE: ./src/components/shared/layout/LayoutBase.js









var LayoutBase_templateObject, LayoutBase_templateObject2, LayoutBase_templateObject3;

var LayoutBase_jsx = react.createElement;

function LayoutBase_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, LayoutBase_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function LayoutBase_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (LayoutBase_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


















var LayoutBase_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    mobileMenuIsOpen: lodash_get_default()(state, 'menu.mobileMenuIsOpen'),
    redirect: lodash_get_default()(state, 'redirect')
  };
};

var LayoutBase_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPressMenuClose: function onPressMenuClose() {
      return dispatch((0,menu/* updateMobileMenuState */.WY)(false));
    }
  };
};

var LayoutBase = /*#__PURE__*/function (_React$PureComponent) {
  function LayoutBase(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, LayoutBase);

    _this = LayoutBase_callSuper(this, LayoutBase, [props]);

    (0,defineProperty/* default */.Z)(_this, "mainScrollView", null);

    _this.state = {};
    return _this;
  }

  (0,inherits/* default */.Z)(LayoutBase, _React$PureComponent);

  return (0,createClass/* default */.Z)(LayoutBase, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var _this$props = this.props,
          settings = _this$props.settings,
          redirect = _this$props.redirect;
      var oldSettings = oldProps.settings;
      var previousPathname = this.state.previousPathname; // We need to scroll the page back to the top when we log in and land on the dashboard from the open env.
      // Both pages exist on /:projectSlug/closed, so we need something other than route params to determine
      // whether or not we landed on the dashboard as a result of logging in or merely navigating.

      if ((oldSettings && oldSettings.phase) !== (settings && settings.phase) && !redirect.params) {
        if (this.mainScrollView) {
          this.mainScrollView.scrollTop = 0;
          window.scrollTo(0, 0); // need this for iOS 10
        }
      }

      if (previousPathname !== window.location.pathname) {
        if (this.mainScrollView) {
          this.mainScrollView.scrollTop = 0;
          window.scrollTo(0, 0); // need this for iOS 10
        }

        this.setState({
          previousPathname: window.location.pathname
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          loggedIn = _this$props2.loggedIn,
          settings = _this$props2.settings,
          mobileMenuIsOpen = _this$props2.mobileMenuIsOpen,
          renderWidth = _this$props2.renderWidth,
          onPressMenuClose = _this$props2.onPressMenuClose,
          match = _this$props2.match,
          children = _this$props2.children,
          layoutSettings = _this$props2.layoutSettings,
          title = _this$props2.title,
          meta = _this$props2.meta;
      var layout = whichLayout(renderWidth);
      var isMobileMenuIsOpen = mobileMenuIsOpen && layout === 'small';
      var isLoggedIn = !!(settings && settings.user);
      return LayoutBase_jsx("div", {
        "data-id": "layout_LayoutBase_div"
      }, layout === 'small' ? LayoutBase_jsx(MobileMenuView, {
        color: loggedIn ? styleGuide/* colorPalette.beige */.K5.beige : styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
        "data-id": "layout_LayoutBase_MobileMenuView"
      }, LayoutBase_jsx(components_MobileLoginBar, {
        settings: settings,
        "data-id": "layout_LayoutBase_MobileLoginBar"
      }), LayoutBase_jsx(components_MobileMenu, {
        menuItems: settings && settings.menu,
        loggedIn: loggedIn,
        "data-id": "layout_LayoutBase_MobileMenu"
      })) : LayoutBase_jsx("div", {
        "data-id": "layout_LayoutBase_div"
      }), LayoutBase_jsx(MainView, {
        mobileMenuIsOpen: isMobileMenuIsOpen,
        onClick: function onClick() {
          if (isMobileMenuIsOpen) {
            onPressMenuClose();
          }
        },
        "data-id": "layout_LayoutBase_MainView"
      }, LayoutBase_jsx(components_Header, {
        renderWidth: renderWidth,
        settings: settings,
        hasMenu: layoutSettings.hasMenu,
        "data-id": "layout_LayoutBase_Header"
      }), LayoutBase_jsx(ContentView, {
        ref: function ref(el) {
          _this2.mainScrollView = el;
        },
        isClosedEnvOrPortal: match.params.env === 'closed' || match.params.projectSlug === 'portal',
        className: "scrollable",
        "data-id": "layout_LayoutBase_ContentView"
      }, children, settings && layoutSettings && layoutSettings.hasFooter && LayoutBase_jsx(components_Footer, {
        footer: settings && settings.footer,
        siteName: settings.siteName,
        "data-id": "layout_LayoutBase_Footer"
      }))), title && LayoutBase_jsx(Head, (0,esm_extends/* default */.Z)({
        title: title
      }, meta, {
        "data-id": "layout_LayoutBase_Head"
      })), LayoutBase_jsx(components_Modal, {
        renderWidth: renderWidth,
        "data-id": "layout_LayoutBase_Modal"
      }), LayoutBase_jsx(ui_ErrorBar, {
        settings: settings,
        "data-id": "layout_LayoutBase_ErrorBar"
      }), LayoutBase_jsx(ui_CMSPreviewMessage, {
        "data-id": "layout_LayoutBase_CMSPreviewMessage"
      }), LayoutBase_jsx(components_CookieNotice, {
        loggedIn: isLoggedIn,
        renderWidth: renderWidth,
        "data-id": "layout_LayoutBase_CookieNotice"
      }));
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var layout_LayoutBase = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(LayoutBase_mapStateToProps, LayoutBase_mapDispatchToProps)(LayoutBase)));
var MainView = styled_components_browser_esm["default"].div(LayoutBase_templateObject || (LayoutBase_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  box-shadow: 0 2rem 10rem 0 rgba(0, 0, 0, 0.5);\n  transform: ", ";\n  transition: transform 0.22s;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"])), function (props) {
  return props.mobileMenuIsOpen ? 'translate3d(-280rem, 0, 0)' : 'none';
});
var MobileMenuView = styled_components_browser_esm["default"].div(LayoutBase_templateObject2 || (LayoutBase_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 320rem;\n  height: 100vh;\n  overflow: auto;\n  -webkit-transform: translate3d(0, 0, 0);\n  -webkit-overflow-scrolling: touch;\n  position: absolute;\n  right: 0;\n  top: 0;\n  background: ", ";\n"])), styleGuide/* colorPalette.beige */.K5.beige);
var ContentView = styled_components_browser_esm["default"].div(LayoutBase_templateObject3 || (LayoutBase_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1;\n  overflow: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  background-color: ", ";\n  position: relative;\n"])), function (props) {
  return props.isClosedEnvOrPortal ? styleGuide/* colorPalette.background */.K5.background : 'white';
});
;// CONCATENATED MODULE: ./src/constants/staticData.js
var staticData = {
  passedEventNotification: 'Dit event is verlopen'
};
/* harmony default export */ var constants_staticData = (staticData);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(16573);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(46616);
// EXTERNAL MODULE: ./node_modules/react-share/es/PinterestShareButton.js
var PinterestShareButton = __webpack_require__(61366);
// EXTERNAL MODULE: ./node_modules/react-share/es/WhatsappShareButton.js
var WhatsappShareButton = __webpack_require__(12834);
;// CONCATENATED MODULE: ./src/components/shared/icons/Facebook.js
var Facebook_jsx = react.createElement;


var Facebook_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var Facebook = function Facebook(_ref) {
  var color = _ref.color;
  return Facebook_jsx("svg", {
    width: "13px",
    height: "26px",
    viewBox: "0 0 13 26",
    version: "1.1",
    "data-id": "icons_Facebook_svg"
  }, Facebook_jsx("title", {
    "data-id": "icons_Facebook_title"
  }, "Facebook"), Facebook_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Facebook_g"
  }, Facebook_jsx("g", {
    transform: "translate(-345.000000, -1181.000000)",
    fill: color,
    "data-id": "icons_Facebook_g_3"
  }, Facebook_jsx("g", {
    transform: "translate(331.000000, 1173.000000)",
    "data-id": "icons_Facebook_g_4"
  }, Facebook_jsx("path", {
    d: "M17.2261667,34 L17.2261667,21.7995 L14,21.7995 L14,17.4076667 L17.2261667,17.4076667 L17.2261667,13.6560833 C17.2261667,10.70725 19.13175,8 23.5225,8 C25.30025,8 26.6154167,8.17008333 26.6154167,8.17008333 L26.5114167,12.2715833 C26.5114167,12.2715833 25.17025,12.2596667 23.70775,12.2596667 C22.1239167,12.2596667 21.8704167,12.98875 21.8704167,14.1999167 L21.8704167,17.4076667 L26.6370833,17.4076667 L26.4301667,21.7995 L21.8704167,21.7995 L21.8704167,34 L17.2261667,34 Z",
    "data-id": "icons_Facebook_path"
  })))));
};

Facebook.defaultProps = Facebook_defaultProps;
/* harmony default export */ var icons_Facebook = (Facebook);
;// CONCATENATED MODULE: ./src/components/shared/icons/Twitter.js
var Twitter_jsx = react.createElement;


var Twitter_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var Twitter = function Twitter(_ref) {
  var color = _ref.color;
  return Twitter_jsx("svg", {
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    version: "1.1",
    "data-id": "icons_Twitter_svg"
  }, Twitter_jsx("title", {
    "data-id": "icons_Twitter_title"
  }, "Twitter"), Twitter_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Twitter_g"
  }, Twitter_jsx("g", {
    transform: "translate(-390.000000, -1185.000000)",
    fill: color,
    "data-id": "icons_Twitter_g_3"
  }, Twitter_jsx("g", {
    transform: "translate(331.000000, 1173.000000)",
    "data-id": "icons_Twitter_g_4"
  }, Twitter_jsx("g", {
    transform: "translate(50.000000, 0.000000)",
    "data-id": "icons_Twitter_g_5"
  }, Twitter_jsx("g", {
    transform: "translate(9.000000, 12.000000)",
    "data-id": "icons_Twitter_g_6"
  }, Twitter_jsx("path", {
    d: "M20,1.9238 C19.264,2.2498 18.473,2.4708 17.644,2.5698 C18.49,2.0618 19.141,1.2578 19.447,0.2998 C18.654,0.7698 17.776,1.1118 16.842,1.2958 C16.093,0.4978 15.027,-0.0002 13.847,-0.0002 C11.581,-0.0002 9.744,1.8368 9.744,4.1028 C9.744,4.4238 9.78,4.7368 9.85,5.0378 C6.439,4.8668 3.416,3.2328 1.393,0.7508 C1.039,1.3568 0.837,2.0608 0.837,2.8138 C0.837,4.2368 1.562,5.4928 2.662,6.2288 C1.99,6.2078 1.357,6.0228 0.804,5.7158 C0.803,5.7328 0.803,5.7498 0.803,5.7668 C0.803,7.7558 2.218,9.4138 4.095,9.7908 C3.75,9.8838 3.388,9.9348 3.014,9.9348 C2.75,9.9348 2.492,9.9088 2.242,9.8608 C2.764,11.4908 4.279,12.6778 6.075,12.7108 C4.67,13.8108 2.901,14.4668 0.979,14.4668 C0.647,14.4668 0.321,14.4478 0,14.4098 C1.816,15.5738 3.973,16.2528 6.29,16.2528 C13.837,16.2528 17.964,10.0008 17.964,4.5778 C17.964,4.4008 17.96,4.2238 17.953,4.0478 C18.754,3.4688 19.45,2.7468 20,1.9238",
    "data-id": "icons_Twitter_path"
  })))))));
};

Twitter.defaultProps = Twitter_defaultProps;
/* harmony default export */ var icons_Twitter = (Twitter);
;// CONCATENATED MODULE: ./src/components/shared/icons/Pinterest.js
var Pinterest_jsx = react.createElement;


var Pinterest_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var Pinterest = function Pinterest(_ref) {
  var color = _ref.color;
  return Pinterest_jsx("svg", {
    width: "19px",
    height: "25px",
    viewBox: "0 0 19 25",
    version: "1.1",
    "data-id": "icons_Pinterest_svg"
  }, Pinterest_jsx("title", {
    "data-id": "icons_Pinterest_title"
  }, "Pintrest"), Pinterest_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Pinterest_g"
  }, Pinterest_jsx("g", {
    transform: "translate(-442.000000, -1182.000000)",
    fill: color,
    "data-id": "icons_Pinterest_g_3"
  }, Pinterest_jsx("g", {
    transform: "translate(331.000000, 1173.000000)",
    "data-id": "icons_Pinterest_g_4"
  }, Pinterest_jsx("g", {
    transform: "translate(100.000000, 0.000000)",
    "data-id": "icons_Pinterest_g_5"
  }, Pinterest_jsx("g", {
    transform: "translate(11.000000, 9.000000)",
    "data-id": "icons_Pinterest_g_6"
  }, Pinterest_jsx("path", {
    d: "M7.83774783,15.8415037 C7.2684559,18.3342801 6.7108472,20.7378391 5.49366708,22.6337087 C5.12299006,23.2125596 4.74700248,23.9432925 4.11079752,24.2566155 C3.16870435,19.416572 5.13467329,15.3423112 5.91426335,11.2733609 C4.92118882,9.25322422 5.53827578,5.83003789 7.65825093,5.44236708 C10.7320025,4.87944783 9.92161118,8.58728012 9.40011429,10.3110876 C9.11440621,11.2563671 8.59928199,12.1591621 8.67894037,13.1968453 C8.84887826,15.3826714 11.5986857,15.5228702 13.0059839,14.3991559 C15.0250584,12.7889944 15.6070957,9.67913106 15.4116671,7.12581429 C15.1110894,3.23636087 10.7054497,1.30225528 6.81705839,2.85718696 C4.81285342,3.65908137 2.99239379,5.50078323 2.72792795,8.2070441 C2.58985342,9.63239814 2.88830683,10.770982 3.45016398,11.5728764 C3.53513292,11.6960814 3.82721366,11.910628 3.86969814,12.2356342 C3.95785342,12.8952056 3.56699627,13.6057584 3.2090646,14.0975161 C1.21654286,13.5229137 0.188418634,11.7343174 0.0227291925,9.47095714 C-0.351134161,4.3186528 3.87713292,0.398398137 8.85737516,0.033031677 C14.1711205,-0.356763354 18.3866422,2.71167764 18.7753752,7.18635466 C19.0663938,10.5118267 17.8874497,13.8596031 16.0128224,15.6609447 C14.6034,17.0140752 11.6082447,18.3385286 9.16007702,17.0438143 C8.61627578,16.755982 8.37623851,16.4054851 7.83774783,15.8415037",
    "data-id": "icons_Pinterest_path"
  })))))));
};

Pinterest.defaultProps = Pinterest_defaultProps;
/* harmony default export */ var icons_Pinterest = (Pinterest);
;// CONCATENATED MODULE: ./src/components/shared/icons/Clipboard.js
var Clipboard_jsx = react.createElement;


var Clipboard_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var Clipboard = function Clipboard(_ref) {
  var color = _ref.color;
  return Clipboard_jsx("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    "data-id": "icons_Clipboard_svg"
  }, Clipboard_jsx("title", {
    "data-id": "icons_Clipboard_title"
  }, "Clipboard"), Clipboard_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Clipboard_g"
  }, Clipboard_jsx("g", {
    transform: "translate(-490.000000, -1183.000000)",
    fill: color,
    "data-id": "icons_Clipboard_g_3"
  }, Clipboard_jsx("g", {
    transform: "translate(331.000000, 1173.000000)",
    "data-id": "icons_Clipboard_g_4"
  }, Clipboard_jsx("g", {
    transform: "translate(150.000000, 0.000000)",
    "data-id": "icons_Clipboard_g_5"
  }, Clipboard_jsx("g", {
    transform: "translate(9.000000, 10.000000)",
    "data-id": "icons_Clipboard_g_6"
  }, Clipboard_jsx("path", {
    d: "M18.8184,2.18093333 L17.8757333,1.23826667 C16.3130667,-0.323066667 13.7810667,-0.323066667 12.2184,1.23693333 L9.42106667,4.0356 C10.5637333,3.57026667 11.8677333,3.6596 12.9584,4.26893333 L14.1037333,3.12493333 C14.6237333,2.60226667 15.4690667,2.60226667 15.9904,3.12493333 L16.9330667,4.06626667 C17.4530667,4.58626667 17.4530667,5.4316 16.9317333,5.95293333 L11.2757333,11.6089333 C10.7557333,12.1289333 9.9104,12.1289333 9.3904,11.6089333 L8.60773333,10.8249333 L6.6664,12.6556 L7.50506667,13.4929333 C9.0664,15.0569333 11.5997333,15.0569333 13.1610667,13.4929333 L18.8184,7.83693333 C20.3797333,6.2756 20.3797333,3.74226667 18.8184,2.18093333",
    "data-id": "icons_Clipboard_path"
  }), Clipboard_jsx("path", {
    d: "M7.03053333,15.7974667 L5.88653333,16.9414667 C5.3652,17.4628 4.51986667,17.4628 3.99986667,16.9414667 L3.0572,15.9988 C2.53586667,15.4788 2.53586667,14.6348 3.0572,14.1134667 L8.7132,8.45746667 C9.23453333,7.93613333 10.0785333,7.93613333 10.5985333,8.45746667 L11.3812,9.24013333 L13.3238667,7.4108 L12.4852,6.57213333 C10.9225333,5.00946667 8.39053333,5.00946667 6.82786667,6.57213333 L1.17053333,12.2281333 C-0.3908,13.7908 -0.3908,16.3228 1.17053333,17.8841333 L2.1132,18.8268 C3.67586667,20.3894667 6.2092,20.3894667 7.77053333,18.8281333 L10.5692,16.0294667 C9.4252,16.4948 8.12253333,16.4054667 7.03053333,15.7974667",
    "data-id": "icons_Clipboard_path_8"
  })))))));
};

Clipboard.defaultProps = Clipboard_defaultProps;
/* harmony default export */ var icons_Clipboard = (Clipboard);
;// CONCATENATED MODULE: ./src/components/shared/icons/Whatsapp.js
var Whatsapp_jsx = react.createElement;


var Whatsapp_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var Whatsapp = function Whatsapp(_ref) {
  var color = _ref.color;
  return Whatsapp_jsx("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    "data-id": "icons_Whatsapp_svg"
  }, Whatsapp_jsx("title", {
    "data-id": "icons_Whatsapp_title"
  }, "Whatsapp"), Whatsapp_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Whatsapp_g"
  }, Whatsapp_jsx("g", {
    transform: "translate(-540.000000, -1181.000000)",
    fill: color,
    "data-id": "icons_Whatsapp_g_3"
  }, Whatsapp_jsx("g", {
    transform: "translate(331.000000, 1173.000000)",
    "data-id": "icons_Whatsapp_g_4"
  }, Whatsapp_jsx("g", {
    transform: "translate(201.000000, 0.000000)",
    "data-id": "icons_Whatsapp_g_5"
  }, Whatsapp_jsx("g", {
    transform: "translate(8.000000, 8.000000)",
    "data-id": "icons_Whatsapp_g_6"
  }, Whatsapp_jsx("path", {
    d: "M17.4290531,14.3328819 C17.1316525,14.1848027 15.6695325,13.4687747 15.396901,13.3699417 C15.1242695,13.2711654 14.9260595,13.2218057 14.7277353,13.5180208 C14.5294682,13.8142926 13.9594931,14.4810746 13.7860522,14.6786838 C13.6126113,14.8761226 13.4391133,14.9010012 13.1416556,14.7527517 C12.844255,14.604559 11.885964,14.2920422 10.7500659,13.283548 C9.86591107,12.4987344 9.26899813,11.5294893 9.09555723,11.2331607 C8.92205925,10.9367753 9.07700892,10.7766544 9.22596607,10.6290297 C9.35974214,10.4964572 9.52342378,10.2833414 9.6720385,10.1104973 C9.82076735,9.9377099 9.87036266,9.81411185 9.96943914,9.61672984 C10.0685727,9.41912062 10.0190915,9.24627646 9.94461295,9.09814056 C9.87036266,8.95000465 9.27550431,7.49306981 9.02769897,6.90029898 C8.78628567,6.3232051 8.54116271,6.4013627 8.35853326,6.3922746 C8.18526357,6.38369772 7.98682526,6.3818801 7.78861523,6.3818801 C7.59029107,6.3818801 7.26806423,6.45589125 6.99548978,6.75221987 C6.72285825,7.04849169 5.95455899,7.76463338 5.95455899,9.22151141 C5.95455899,10.678503 7.0202589,12.085851 7.16898776,12.2834602 C7.31771661,12.4810126 9.26608748,15.4706542 12.2495107,16.7528137 C12.9590832,17.0578328 13.5130782,17.2399355 13.9449398,17.3762568 C14.657423,17.6016415 15.3057575,17.5697764 15.8181472,17.4936068 C16.3895491,17.4086332 17.5777249,16.7775787 17.8255873,16.0862021 C18.0733927,15.3946551 18.0733927,14.8021114 17.9990282,14.6786838 C17.9247779,14.5551425 17.7265108,14.4810746 17.4290531,14.3328819 M12.0025615,21.7070169 L11.9986235,21.7070169 C10.2234082,21.7063353 8.48220764,21.2316529 6.96335841,20.3346014 L6.60209453,20.1212016 L2.8578484,21.0987395 L3.85717391,17.4654337 L3.6220385,17.0929356 C2.63173031,15.5252964 2.10866815,13.7135283 2.10941009,11.8530822 C2.11157881,6.42448053 6.54964564,2.00789476 12.0064994,2.00789476 C14.6489193,2.00874677 17.132851,3.03428121 19.0006937,4.89540896 C20.8685364,6.75636631 21.8965119,9.2302019 21.8955417,11.8609775 C21.8933159,17.2900904 17.4553632,21.7070169 12.0025615,21.7070169 M20.4222357,3.48124497 C18.1750374,1.24205257 15.1865347,0.00845760611 12.0024473,0.00715119281 C5.44188389,0.00715119281 0.102369513,5.3209021 0.099744215,11.852287 C0.0989452112,13.9402195 0.646947702,15.9780538 1.68856335,17.7745993 L-1.71215106e-05,23.9130378 L6.3097162,22.2657642 C8.04823441,23.2095058 10.0056797,23.7069653 11.9977104,23.7076469 L12.0025615,23.7076469 L12.0026756,23.7076469 C18.5624971,23.7076469 23.9025252,18.3932712 23.9052075,11.8617727 C23.906349,8.69656047 22.669434,5.72032376 20.4222357,3.48124497",
    "data-id": "icons_Whatsapp_path"
  })))))));
};

Whatsapp.defaultProps = Whatsapp_defaultProps;
/* harmony default export */ var icons_Whatsapp = (Whatsapp);
;// CONCATENATED MODULE: ./src/components/SocialShare.js








var SocialShare_templateObject, SocialShare_templateObject2, SocialShare_templateObject3, SocialShare_templateObject4, SocialShare_templateObject5;

var SocialShare_jsx = react.createElement;

function SocialShare_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, SocialShare_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function SocialShare_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (SocialShare_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}













var SocialShare = /*#__PURE__*/function (_Component) {
  function SocialShare() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, SocialShare);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = SocialShare_callSuper(this, SocialShare, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      hasCopiedToClipboard: false
    });

    (0,defineProperty/* default */.Z)(_this, "addClipboardData", function () {
      var shareUrl = _this.props.shareLink;
      var body = document.querySelector('body');
      var copyFrom = document.createElement('textarea');
      copyFrom.textContent = shareUrl;

      if (body) {
        body.appendChild(copyFrom);
        copyFrom.select();
        document.execCommand('copy');
        body.removeChild(copyFrom);
      }

      _this.setState({
        hasCopiedToClipboard: true
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(SocialShare, _Component);

  return (0,createClass/* default */.Z)(SocialShare, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          shareLink = _this$props.shareLink,
          image = _this$props.image,
          colorPrimary = _this$props.colorPrimary,
          colorSecondary = _this$props.colorSecondary,
          _this$props$buttons = _this$props.buttons,
          buttons = _this$props$buttons === void 0 ? [] : _this$props$buttons;
      var shareUrl = shareLink;

      var socialButtons = function socialButtons(button) {
        switch (button.type) {
          case 'facebook':
            return SocialShare_jsx(FacebookShareButton/* default */.Z, {
              url: shareUrl,
              image: image,
              "data-id": "components_SocialShare_FacebookShareButton"
            }, SocialShare_jsx(SocialShare_IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, SocialShare_jsx(icons_Facebook, {
              "data-id": "components_SocialShare_FacebookIcon"
            })));

          case 'twitter':
            return SocialShare_jsx(TwitterShareButton/* default */.Z, {
              url: shareUrl,
              "data-id": "components_SocialShare_TwitterShareButton"
            }, SocialShare_jsx(SocialShare_IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, SocialShare_jsx(icons_Twitter, {
              "data-id": "components_SocialShare_TwitterIcon"
            })));

          case 'pinterest':
            return SocialShare_jsx(PinterestShareButton/* default */.Z, {
              url: shareUrl,
              media: image,
              "data-id": "components_SocialShare_PinterestShareButton"
            }, SocialShare_jsx(SocialShare_IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, SocialShare_jsx(icons_Pinterest, {
              "data-id": "components_SocialShare_PinterestIcon"
            })));

          case 'clipboard':
            return SocialShare_jsx("div", {
              onClick: _this2.addClipboardData,
              "data-id": "components_SocialShare_div"
            }, SocialShare_jsx(SocialShare_IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, _this2.state.hasCopiedToClipboard ? SocialShare_jsx(CheckWrapper, {
              "data-id": "components_SocialShare_CheckWrapper"
            }, SocialShare_jsx(Check/* default */.Z, {
              color: styleGuide/* colorPalette.white */.K5.white,
              "data-id": "components_SocialShare_CheckIcon"
            })) : SocialShare_jsx(icons_Clipboard, {
              "data-id": "components_SocialShare_ClipboardIcon"
            })));

          case 'whatsapp':
            return SocialShare_jsx(WhatsappShareButton/* default */.Z, {
              url: shareUrl,
              "data-id": "components_SocialShare_WhatsappShareButton"
            }, SocialShare_jsx(SocialShare_IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, SocialShare_jsx(icons_Whatsapp, {
              "data-id": "components_SocialShare_WhatsappIcon"
            })));

          case 'mail':
          default:
            return SocialShare_jsx(SocialShare_Link, {
              href: "mailto:?body=".concat(shareUrl),
              "data-id": "components_SocialShare_Link"
            }, SocialShare_jsx(SocialShare_IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, SocialShare_jsx(icons_Message, {
              width: 24,
              height: 16,
              color: styleGuide/* colorPalette.white */.K5.white,
              "data-id": "components_SocialShare_MailIcon"
            })));
        }
      };

      return SocialShare_jsx(View, {
        "data-id": "components_SocialShare_View"
      }, buttons.map(function (btn, index) {
        return SocialShare_jsx(ShareBtn, {
          key: index,
          colorPrimary: colorPrimary,
          colorSecondary: colorSecondary,
          "data-id": "components_SocialShare_ShareBtn"
        }, socialButtons(btn));
      }));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_SocialShare = (SocialShare);
var View = styled_components_browser_esm["default"].div(SocialShare_templateObject || (SocialShare_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  margin-bottom: 50rem;\n"])));
var SocialShare_Link = styled_components_browser_esm["default"].a(SocialShare_templateObject2 || (SocialShare_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  width: 100%;\n"])));
var ShareBtn = styled_components_browser_esm["default"].div(SocialShare_templateObject3 || (SocialShare_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  float: left;\n  width: 40rem;\n  height: 40rem;\n  margin-right: 10rem;\n  margin-bottom: 10rem;\n  background-color: ", ";\n  transition: background-color 0.25s ease-in-out;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.colorPrimary;
}, function (props) {
  return props.colorSecondary;
});
var CheckWrapper = styled_components_browser_esm["default"].div(SocialShare_templateObject4 || (SocialShare_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 25rem;\n  height: 25rem;\n  position: relative;\n\n  svg {\n    position: relative;\n    transform: scale(1.4);\n    top: 2rem;\n    left: 5rem;\n  }\n"])));
var SocialShare_IconWrapper = styled_components_browser_esm["default"].div(SocialShare_templateObject5 || (SocialShare_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  height: 40rem;\n  align-items: center;\n  justify-content: center;\n"])));
;// CONCATENATED MODULE: ./src/components/shared/icons/CalendarDate.js
var CalendarDate_jsx = react.createElement;


var CalendarDate_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var CalendarDate = function CalendarDate(_ref) {
  var color = _ref.color;
  return CalendarDate_jsx("svg", {
    style: {
      width: '50px',
      height: '56px'
    },
    viewBox: "0 0 50 56",
    version: "1.1",
    "data-id": "icons_CalendarDate_svg"
  }, CalendarDate_jsx("title", {
    "data-id": "icons_CalendarDate_title"
  }, "Datum icoon"), CalendarDate_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_CalendarDate_g"
  }, CalendarDate_jsx("g", {
    transform: "translate(-250.000000, -351.000000)",
    fill: color,
    "data-id": "icons_CalendarDate_g_3"
  }, CalendarDate_jsx("g", {
    transform: "translate(210.000000, 312.000000)",
    "data-id": "icons_CalendarDate_g_4"
  }, CalendarDate_jsx("g", {
    transform: "translate(39.000000, 35.000000)",
    "data-id": "icons_CalendarDate_g_5"
  }, CalendarDate_jsx("path", {
    d: "M45,5 L51,5 L51,60 L1,60 L1,5 L8,5 L8,4 L11,4 L11,5 L42,5 L42,4 L45,4 L45,5 Z M8.5,10 C7.67157288,10 7,10.6715729 7,11.5 C7,12.3284271 7.67157288,13 8.5,13 L43.5,13 C44.3284271,13 45,12.3284271 45,11.5 C45,10.6715729 44.3284271,10 43.5,10 L8.5,10 Z",
    "data-id": "icons_CalendarDate_path"
  }))))));
};

CalendarDate.defaultProps = CalendarDate_defaultProps;
/* harmony default export */ var icons_CalendarDate = (CalendarDate);
;// CONCATENATED MODULE: ./src/components/shared/icons/CalendarDateTime.js
var CalendarDateTime_jsx = react.createElement;


var CalendarDateTime_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var CalendarDateTime = function CalendarDateTime(_ref) {
  var color = _ref.color;
  return CalendarDateTime_jsx("svg", {
    style: {
      width: '50px',
      height: '78px'
    },
    viewBox: "0 0 50 78",
    "data-id": "icons_CalendarDateTime_svg"
  }, CalendarDateTime_jsx("title", {
    "data-id": "icons_CalendarDateTime_title"
  }, "Datum en tijd icoon"), CalendarDateTime_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_CalendarDateTime_g"
  }, CalendarDateTime_jsx("g", {
    transform: "translate(-250.000000, -99.000000)",
    fill: color,
    "data-id": "icons_CalendarDateTime_g_3"
  }, CalendarDateTime_jsx("g", {
    transform: "translate(210.000000, 60.000000)",
    "data-id": "icons_CalendarDateTime_g_4"
  }, CalendarDateTime_jsx("g", {
    transform: "translate(36.000000, 34.000000)",
    "data-id": "icons_CalendarDateTime_g_5"
  }, CalendarDateTime_jsx("path", {
    d: "M48,6.05405405 L54,6.05405405 L54,83 L4,83 L4,6.05405405 L11,6.05405405 L11,5 L14,5 L14,6.05405405 L45,6.05405405 L45,5 L48,5 L48,6.05405405 Z M11.5810811,11.3243243 C10.7078741,11.3243243 10,12.0321984 10,12.9054054 C10,13.7786124 10.7078741,14.4864865 11.5810811,14.4864865 L11.5810811,14.4864865 L46.4189189,14.4864865 C47.2921259,14.4864865 48,13.7786124 48,12.9054054 L48,12.9054054 C48,12.0321984 47.2921259,11.3243243 46.4189189,11.3243243 L46.4189189,11.3243243 L11.5810811,11.3243243 Z",
    "data-id": "icons_CalendarDateTime_path"
  }))))));
};

CalendarDateTime.defaultProps = CalendarDateTime_defaultProps;
/* harmony default export */ var icons_CalendarDateTime = (CalendarDateTime);
;// CONCATENATED MODULE: ./src/components/shared/designElements/DateIcon.js


var DateIcon_templateObject, DateIcon_templateObject2, DateIcon_templateObject3, DateIcon_templateObject4, DateIcon_templateObject5, DateIcon_templateObject6, DateIcon_templateObject7;

var DateIcon_jsx = react.createElement;









var DateIcon_defaultProps = {
  textColor: styleGuide/* colorPalette.green */.K5.green,
  bgColor: '#ffffff',
  size: 'medium'
};

var DateIcon = function DateIcon(_ref) {
  var date = _ref.date,
      size = _ref.size,
      bgColor = _ref.bgColor,
      textColor = _ref.textColor;
  if (date === '' || date === undefined) return DateIcon_jsx("span", {
    "data-id": "designElements_DateIcon_span"
  });

  var _parseTimestamp = parseTimestamp(date),
      day = _parseTimestamp.day,
      month = _parseTimestamp.month,
      time = _parseTimestamp.time;

  return DateIcon_jsx(DateIcon_DateIconWrapper, {
    size: size,
    "data-id": "designElements_DateIcon_DateIconWrapper"
  }, time && DateIcon_jsx("div", {
    "data-id": "designElements_DateIcon_div"
  }, DateIcon_jsx(icons_CalendarDateTime, {
    color: bgColor,
    "data-id": "designElements_DateIcon_CalendarDateTime"
  }), DateIcon_jsx(icons_CalendarDateTime, {
    color: (0,utils/* hex2rgb */.wK)(bgColor || DateIcon_defaultProps.bgColor, 0.5),
    "data-id": "designElements_DateIcon_CalendarDateTime_4"
  })), !time && DateIcon_jsx("div", {
    "data-id": "designElements_DateIcon_div"
  }, DateIcon_jsx(icons_CalendarDate, {
    color: bgColor,
    "data-id": "designElements_DateIcon_CalendarDate"
  }), DateIcon_jsx(icons_CalendarDate, {
    color: (0,utils/* hex2rgb */.wK)(bgColor || DateIcon_defaultProps.bgColor, 0.5),
    "data-id": "designElements_DateIcon_CalendarDate_7"
  })), DateIcon_jsx(DateIconInnerWrapper, {
    color: textColor,
    "data-id": "designElements_DateIcon_DateIconInnerWrapper"
  }, DateIcon_jsx(CalendarDay, {
    size: size,
    "data-id": "designElements_DateIcon_CalendarDay"
  }, day), DateIcon_jsx(CalendarMonth, {
    size: size,
    "data-id": "designElements_DateIcon_CalendarMonth"
  }, lodash_get_default()(month, 'shortName')), time && DateIcon_jsx(CalendarTime, {
    "data-id": "designElements_DateIcon_CalendarTime"
  }, time)));
};

DateIcon.defaultProps = DateIcon_defaultProps;
/* harmony default export */ var designElements_DateIcon = (DateIcon);
var DateIcon_DateIconWrapper = styled_components_browser_esm["default"].div(DateIcon_templateObject || (DateIcon_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  flex-basis: 50rem;\n  width: 50rem;\n  height: 77rem;\n  transform: ", ";\n  margin-right: ", ";\n  margin-top: ", ";\n  font-family: ", ";\n\n  svg {\n    position: absolute;\n    left: 0;\n    transform: rotate(-12deg);\n\n    &:first-child {\n      transform: rotate(0deg);\n    }\n  }\n"])), function (props) {
  switch (props.size) {
    case 'mini':
      return 'scale(0.66,0.66)';

    case 'small':
      return 'scale(0.85,0.85)';

    case 'medium':
      return 'scale(1,1)';

    case 'big':
      return 'scale(1.5,1.5)';

    case 'huge':
    default:
      return 'scale(2.3,2.3)';
  }
}, function (props) {
  return props.size === 'medium' ? '0' : '15rem';
}, function (props) {
  return props.size === 'medium' ? '0' : '15rem';
}, styleGuide/* fonts.primary */.Rq.primary);
var DateIconInnerWrapper = styled_components_browser_esm["default"].div(DateIcon_templateObject2 || (DateIcon_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  line-height: 18rem;\n  padding-top: 14rem;\n  width: 100%;\n  text-align: center;\n  color: ", ";\n\n  span {\n    display: block;\n  }\n"])), function (props) {
  return props.color;
});
var CalendarDay = styled_components_browser_esm["default"].span(DateIcon_templateObject3 || (DateIcon_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 16rem;\n  font-weight: bold;\n  margin-bottom: 3rem;\n  position: relative;\n  transform: ", ";\n  top: ", ";\n\n  ", ";\n"])), function (props) {
  return props.size === 'huge' ? 'scale(0.8,0.8)' : 'none';
}, function (props) {
  return props.size === 'huge' ? '2rem' : 'auto';
}, breakpoints/* fromBreakpoint.md */.ks.md(DateIcon_templateObject4 || (DateIcon_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 18rem;\n  "]))));
var CalendarMonth = styled_components_browser_esm["default"].span(DateIcon_templateObject5 || (DateIcon_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 16rem;\n  margin-bottom: 4rem;\n  position: relative;\n  top: ", ";\n  transform: ", ";\n\n  ", ";\n"])), function (props) {
  return props.size === 'huge' ? '-3rem' : 'auto';
}, function (props) {
  return props.size === 'huge' ? 'scale(0.7,0.7)' : 'none';
}, breakpoints/* fromBreakpoint.md */.ks.md(DateIcon_templateObject6 || (DateIcon_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 18rem;\n  "]))));
var CalendarTime = styled_components_browser_esm["default"].span(DateIcon_templateObject7 || (DateIcon_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 14rem;\n  font-weight: bold;\n  border-top: solid 1rem ", ";\n  margin-top: 3rem;\n  padding-top: 1rem;\n"])), function (props) {
  return props.textColor;
});
;// CONCATENATED MODULE: ./src/services/hasEventPassed.js
/* harmony default export */ var hasEventPassed = (function (date) {
  if (!date) return false;
  var eventDate = new Date(String(date.replace(' ', 'T'))).getTime(); // for Safari as it only accepts formats like this '2018-05-02T14:00:00'

  var currentDate = new Date().getTime();
  return eventDate - currentDate < 0;
});
;// CONCATENATED MODULE: ./src/components/ArticleCard.js


var ArticleCard_templateObject, ArticleCard_templateObject2, ArticleCard_templateObject3, ArticleCard_templateObject4, ArticleCard_templateObject5, ArticleCard_templateObject6, ArticleCard_templateObject7, ArticleCard_templateObject8, ArticleCard_templateObject9, ArticleCard_templateObject0;

var ArticleCard_jsx = react.createElement;















var ArticleCard = function ArticleCard(_ref) {
  var renderWidth = _ref.renderWidth,
      match = _ref.match,
      slug = _ref.slug,
      eventDate = _ref.eventDate,
      type = _ref.type,
      theme = _ref.theme,
      title = _ref.title,
      isBig = _ref.isBig,
      leader = _ref.leader,
      image = _ref.image,
      label = _ref.label,
      author = _ref.author;
  var _match$params = match.params,
      projectSlug = _match$params.projectSlug,
      env = _match$params.env;
  var articleSlug = slug;

  if (type === 'event') {
    var eventHasPassed = hasEventPassed(eventDate);
    return ArticleCard_jsx(ArticleCard_CardContainer, {
      theme: theme,
      hoverColor: eventHasPassed ? styleGuide/* colorPalette.headerGrey */.K5.headerGrey : styleGuide/* themes */.np[theme].active,
      color: eventHasPassed ? 'Grey' : styleGuide/* themes */.np[theme].active,
      "data-e2e-articlecard-title": articleSlug,
      "data-id": "components_ArticleCard_CardContainer"
    }, ArticleCard_jsx(CardLink, {
      href: "/".concat(String(projectSlug), "/").concat(String(env), "/article/").concat(articleSlug),
      "data-id": "components_ArticleCard_CardLink"
    }, ArticleCard_jsx(CalenderContainer, {
      "data-id": "components_ArticleCard_CalenderContainer"
    }, eventDate && ArticleCard_jsx(designElements_DateIcon, {
      textColor: "#ffffff",
      bgColor: eventHasPassed ? styleGuide/* colorPalette.lightBeige */.K5.lightBeige : styleGuide/* themes */.np[theme].primary,
      date: eventDate,
      size: "big",
      "data-id": "components_ArticleCard_DateIcon"
    })), ArticleCard_jsx(ArticleCard_TextContainer, {
      "data-id": "components_ArticleCard_TextContainer"
    }, ArticleCard_jsx(CardTitle, {
      color: eventHasPassed ? styleGuide/* colorPalette.beige */.K5.beige : styleGuide/* themes */.np[theme].primary,
      hoverColor: styleGuide/* themes */.np[theme].active,
      "data-id": "components_ArticleCard_CardTitle"
    }, truncateText(title, isBig ? 110 : 60)), ArticleCard_jsx(ArticleCard_Text, {
      "data-id": "components_ArticleCard_Text"
    }, truncateText(leader, 170))), eventHasPassed && ArticleCard_jsx(Warning, {
      "data-id": "components_ArticleCard_Warning"
    }, constants_staticData.passedEventNotification)));
  }

  return ArticleCard_jsx(ArticleCard_CardContainer, {
    theme: theme,
    hoverColor: styleGuide/* themes */.np[theme].active,
    "data-e2e-articlecard-title": articleSlug,
    "data-id": "components_ArticleCard_CardContainer"
  }, ArticleCard_jsx(CardLink, {
    href: "/".concat(String(projectSlug), "/").concat(String(env), "/article/").concat(articleSlug),
    "data-id": "components_ArticleCard_CardLink"
  }, ArticleCard_jsx(ArticleCard_ImageContainer, {
    sizeBig: !!leader,
    theme: theme,
    "data-id": "components_ArticleCard_ImageContainer"
  }, image && image.src && ArticleCard_jsx(LoaderWrapper, {
    "data-id": "components_ArticleCard_LoaderWrapper"
  }, ArticleCard_jsx(ImageLoader/* default */.Z, {
    src: image.src,
    color: styleGuide/* themes */.np[theme].tertiary,
    mode: "bg",
    width: renderWidth,
    "data-id": "components_ArticleCard_ImageLoader"
  })), type === 'video' && ArticleCard_jsx(icons_Play, {
    color: "#FFFFFF",
    "data-id": "components_ArticleCard_PlayIcon"
  }), ArticleCard_jsx(ArticleCard_ThemeLabelContainer, {
    "data-id": "components_ArticleCard_ThemeLabelContainer"
  }, ArticleCard_jsx(designElements_ThemeLabel, {
    label: label,
    theme: theme,
    "data-id": "components_ArticleCard_ThemeLabel"
  }))), ArticleCard_jsx(ArticleCard_TextContainer, {
    hasLeader: leader,
    "data-id": "components_ArticleCard_TextContainer"
  }, author && ArticleCard_jsx(UserAvatar/* default */.Z, {
    mode: "imageLoader",
    size: "larger",
    imageUrl: author.image,
    name: author.name,
    "data-id": "components_ArticleCard_UserAvatar"
  }), ArticleCard_jsx(CardTitle, {
    color: styleGuide/* themes */.np[theme].primary,
    hoverColor: styleGuide/* themes */.np[theme].active,
    "data-id": "components_ArticleCard_CardTitle"
  }, truncateText(title, isBig ? 110 : 60)), leader && ArticleCard_jsx(ArticleCard_Text, {
    "data-id": "components_ArticleCard_Text"
  }, truncateText(leader, 170)))));
};

/* harmony default export */ var components_ArticleCard = ((0,withMatch/* default */.Z)(ArticleCard));
var LoaderWrapper = styled_components_browser_esm["default"].div(ArticleCard_templateObject || (ArticleCard_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var ArticleCard_CardContainer = (0,styled_components_browser_esm["default"])(Card)(ArticleCard_templateObject2 || (ArticleCard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  &:hover {\n    ", " {\n      transform: scale(1.03) translateZ(0);\n    }\n  }\n"])), LoaderWrapper);
var ArticleCard_ImageContainer = styled_components_browser_esm["default"].div(ArticleCard_templateObject3 || (ArticleCard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-grow: 1;\n  max-height: 367rem;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  background: ", ";\n  backface-visibility: hidden;\n  transform: translateZ(0);\n\n  > svg {\n    position: absolute;\n    z-index: 3;\n    box-shadow: 0 0 200rem 0 rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    backface-visibility: hidden;\n    transform: translateZ(0);\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  ", " {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    transform: scale(1) translateZ(0);\n    transition: transform 1s ease;\n    will-change: transform;\n    backface-visibility: visible;\n  }\n"])), function (props) {
  return styleGuide/* themes */.np[props.theme].tertiary;
}, LoaderWrapper);
var CalenderContainer = styled_components_browser_esm["default"].div(ArticleCard_templateObject4 || (ArticleCard_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 30rem 20rem 30rem 20rem;\n\n  > div {\n    margin-left: auto;\n  }\n"])));
var ArticleCard_Text = styled_components_browser_esm["default"].p(ArticleCard_templateObject5 || (ArticleCard_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 15rem;\n  margin-bottom: 0;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ArticleCard_TextContainer = (0,styled_components_browser_esm["default"])(CardTextContainer)(ArticleCard_templateObject6 || (ArticleCard_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  > div {\n    position: absolute;\n    right: 15rem;\n    top: -84rem;\n    border-width: 3rem;\n  }\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ArticleCard_templateObject7 || (ArticleCard_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: ", ";\n  "])), function (props) {
  return props.hasLeader ? '245rem' : '170rem';
}), breakpoints/* fromBreakpoint.lg */.ks.lg(ArticleCard_templateObject8 || (ArticleCard_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: ", ";\n  "])), function (props) {
  return props.hasLeader ? '255rem' : '170rem';
}));
var Warning = styled_components_browser_esm["default"].span(ArticleCard_templateObject9 || (ArticleCard_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " font-weight: bold;\n  color: ", ";\n  position: absolute;\n  bottom: 20rem;\n  left: 20rem;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ArticleCard_ThemeLabelContainer = styled_components_browser_esm["default"].div(ArticleCard_templateObject0 || (ArticleCard_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  position: absolute;\n  z-index: 2;\n  bottom: 0;\n\n  > * {\n    position: absolute;\n    bottom: 0;\n  }\n"])));
;// CONCATENATED MODULE: ./src/constants/sharing.js
var defaultSharingImage = '/images/default_share.jpg';
;// CONCATENATED MODULE: ./src/components/ArticleContent.js



var ArticleContent_templateObject, ArticleContent_templateObject2, ArticleContent_templateObject3, ArticleContent_templateObject4, ArticleContent_templateObject5, ArticleContent_templateObject6, ArticleContent_templateObject7, ArticleContent_templateObject8, ArticleContent_templateObject9, ArticleContent_templateObject0, ArticleContent_templateObject1, ArticleContent_templateObject10, ArticleContent_templateObject11, ArticleContent_templateObject12, ArticleContent_templateObject13, ArticleContent_templateObject14, ArticleContent_templateObject15, ArticleContent_templateObject16, ArticleContent_templateObject17;

var ArticleContent_jsx = react.createElement;

















var ArticleContent = function ArticleContent(_ref) {
  var planningObj = _ref.planningObj,
      article = _ref.article,
      renderWidth = _ref.renderWidth,
      modal = _ref.modal;
  var isPlanningObj = planningObj;
  var disableShare = article.env === 'closed';
  var eventDate = article.eventDate,
      type = article.type,
      title = article.title,
      author = article.author,
      image = article.image,
      theme = article.theme,
      media = article.media,
      youtubeId = article.youtubeId,
      leader = article.leader,
      text = article.text,
      credits = article.credits,
      relatedArticles = article.relatedArticles,
      publishedDate = article.publishedDate,
      projectSlug = article.projectSlug,
      env = article.env,
      articleSlug = article.articleSlug;

  var _parseTimestamp = parseTimestamp(publishedDate),
      day = _parseTimestamp.day,
      month = _parseTimestamp.month,
      year = _parseTimestamp.year;

  var eventHasPassed = hasEventPassed(eventDate);
  var smallView = renderWidth < 1068;
  var primaryColor = isPlanningObj ? styleGuide/* colorPalette.orange */.K5.orange : styleGuide/* themes */.np[theme].primary;
  var activeColor = isPlanningObj ? styleGuide/* colorPalette.orange */.K5.orange : styleGuide/* themes */.np[theme].active;
  var themeColorPrimary = eventHasPassed && type === 'event' ? styleGuide/* colorPalette.headerGrey */.K5.headerGrey : primaryColor;
  var themeColorPrimaryLight = eventHasPassed && type === 'event' ? styleGuide/* colorPalette.lightBeige */.K5.lightBeige : primaryColor;
  var themeColorActive = eventHasPassed && type === 'event' ? styleGuide/* colorPalette.textGrey */.K5.textGrey : activeColor;
  var socialShareProps = {
    colorPrimary: themeColorPrimary,
    colorSecondary: themeColorActive,
    shareLink: "".concat(window.location.origin, "/").concat(String(projectSlug), "/").concat(String(env), "/article/").concat(String(articleSlug), "/"),
    image: image ? image.src : defaultSharingImage,
    buttons: [{
      type: 'facebook'
    }, {
      type: 'twitter'
    }, {
      type: 'pinterest'
    }, {
      type: 'clipboard'
    }, {
      type: 'whatsapp'
    }, {
      type: 'mail'
    }]
  };
  return ArticleContent_jsx(ArticleContent_Container, {
    "data-id": "components_ArticleContent_Container"
  }, ArticleContent_jsx(ArticleContent_TopContainer, {
    modal: modal,
    "data-id": "components_ArticleContent_TopContainer"
  }, image && type !== 'event' && ArticleContent_jsx(components_HeroArticle, {
    type: type,
    title: title,
    author: author,
    image: image,
    theme: theme,
    media: media,
    youtubeId: youtubeId,
    credits: credits,
    renderWidth: renderWidth,
    "data-id": "components_ArticleContent_HeroArticle"
  }), ArticleContent_jsx(ArticleContent_Content, {
    modal: modal,
    "data-id": "components_ArticleContent_Content"
  }, ArticleContent_jsx(ArticleContent_TitleContainer, {
    type: type,
    "data-id": "components_ArticleContent_TitleContainer"
  }, type === 'event' && eventDate && ArticleContent_jsx(ArticleContent_DateIconWrapper, {
    iconSmall: smallView,
    "data-id": "components_ArticleContent_DateIconWrapper"
  }, ArticleContent_jsx(designElements_DateIcon, {
    textColor: "#FFFFFF",
    bgColor: themeColorPrimaryLight,
    size: smallView ? 'big' : 'huge',
    date: eventDate,
    "data-id": "components_ArticleContent_DateIcon"
  })), ArticleContent_jsx(ArticleContent_Title, {
    color: themeColorPrimary,
    "data-id": "components_ArticleContent_Title"
  }, title), ArticleContent_jsx(ArticleContent_PublishedDate, {
    "data-id": "components_ArticleContent_PublishedDate"
  }, day, " ", lodash_get_default()(month, 'shortName', '').toLowerCase(), " ", year, author && author.name && ArticleContent_jsx("span", {
    "data-id": "components_ArticleContent_span"
  }, "| Door ", author.name))), !eventHasPassed && !disableShare && ArticleContent_jsx(components_SocialShare, (0,esm_extends/* default */.Z)({}, socialShareProps, {
    "data-id": "components_ArticleContent_SocialShare"
  })), ArticleContent_jsx(ArticleContent_IntroText, {
    "data-id": "components_ArticleContent_IntroText"
  }, leader), ArticleContent_jsx(BBCode/* default */.Z, {
    content: text,
    "data-id": "components_ArticleContent_BBCode"
  }), eventHasPassed && ArticleContent_jsx(PassedEventNotification, {
    "data-id": "components_ArticleContent_PassedEventNotification"
  }, constants_staticData.passedEventNotification), author && ArticleContent_jsx(AuthorInfo, {
    "data-id": "components_ArticleContent_AuthorInfo"
  }, ArticleContent_jsx(UserAvatar/* default */.Z, {
    mode: "imageLoader",
    size: renderWidth > breakpoints/* breakpointSizes.md */.YA.md ? 'large' : 'normal',
    imageUrl: author.image,
    name: author.name,
    "data-id": "components_ArticleContent_UserAvatar"
  }), ArticleContent_jsx(ArticleContent_AuthorText, {
    "data-id": "components_ArticleContent_AuthorText"
  }, ArticleContent_jsx(ArticleContent_AuthorName, {
    "data-id": "components_ArticleContent_AuthorName"
  }, author.name), ArticleContent_jsx(AuthorDescription, {
    "data-id": "components_ArticleContent_AuthorDescription"
  }, ArticleContent_jsx(BBCode/* default */.Z, {
    content: author.description,
    "data-id": "components_ArticleContent_BBCode"
  })))))), !isPlanningObj && ArticleContent_jsx(ArticleRow, {
    "data-id": "components_ArticleContent_ArticleRow"
  }, (relatedArticles || []).map(function (article, index) {
    return ArticleContent_jsx(components_ArticleCard, {
      key: index,
      id: index,
      isBig: false,
      type: article.type,
      leader: article.leader,
      image: article.image,
      title: article.title,
      theme: article.theme,
      label: article.label,
      author: article.author,
      eventDate: article.eventDate,
      renderWidth: renderWidth,
      slug: article.slug,
      "data-id": "components_ArticleContent_ArticleCard"
    });
  })));
};

/* harmony default export */ var components_ArticleContent = ((0,withMatch/* default */.Z)(ArticleContent));
var ArticleContent_Content = styled_components_browser_esm["default"].div(ArticleContent_templateObject || (ArticleContent_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n"])), function (props) {
  return props.modal ? '0' : '40rem';
}, function (props) {
  return props.modal ? '20rem' : '0';
}, function (props) {
  return props.modal ? '20rem' : '0';
});
var ArticleContent_TopContainer = styled_components_browser_esm["default"].div(ArticleContent_templateObject2 || (ArticleContent_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: #fff;\n  padding-bottom: 60rem;\n  overflow: hidden;\n  position: relative;\n\n  ", ";\n  margin-bottom: ", ";\n  ", ";\n"])), function (props) {
  return props.modal ? styleGuide/* shadows.boxPrimary */.q.boxPrimary : '';
}, function (props) {
  return props.modal ? '40rem' : '0';
}, breakpoints/* fromBreakpoint.md */.ks.md(ArticleContent_templateObject3 || (ArticleContent_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 80rem;\n    "]))));
var ArticleContent_TitleContainer = styled_components_browser_esm["default"].div(ArticleContent_templateObject4 || (ArticleContent_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  @media only screen and (max-width: 1120px) {\n    padding-right: ", ";\n  }\n"])), function (props) {
  return props.type === 'event' ? '160rem' : '0';
});
var ArticleContent_DateIconWrapper = styled_components_browser_esm["default"].div(ArticleContent_templateObject5 || (ArticleContent_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  right: ", ";\n  top: ", ";\n"])), function (props) {
  return props.iconSmall ? '40rem' : '80rem';
}, function (props) {
  return props.iconSmall ? '35rem' : '80rem';
});
var AuthorInfo = styled_components_browser_esm["default"].div(ArticleContent_templateObject6 || (ArticleContent_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin-top: 60rem;\n  margin-bottom: 50rem;\n  overflow: hidden;\n  width: 100%;\n  padding-top: 20rem;\n  border-top: 1rem dashed ", ";\n  border-bottom: 1rem dashed ", ";\n\n  > div:first-of-type {\n    margin-bottom: 20rem;\n  }\n"])), styleGuide/* colorPalette.beige */.K5.beige, styleGuide/* colorPalette.beige */.K5.beige);
var ArticleContent_AuthorText = styled_components_browser_esm["default"].div(ArticleContent_templateObject7 || (ArticleContent_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: auto;\n  margin-left: 20rem;\n"])));
var PassedEventNotification = styled_components_browser_esm["default"].p(ArticleContent_templateObject8 || (ArticleContent_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-weight: bold;\n  color: ", ";\n  margin-top: 30rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ArticleContent_AuthorName = styled_components_browser_esm["default"].h4(ArticleContent_templateObject9 || (ArticleContent_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 0;\n  margin-bottom: 10rem;\n  ", ";\n  font-weight: bold;\n  color: ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var AuthorDescription = styled_components_browser_esm["default"].div(ArticleContent_templateObject0 || (ArticleContent_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ArticleRow = styled_components_browser_esm["default"].div(ArticleContent_templateObject1 || (ArticleContent_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -10rem;\n  margin-right: -10rem;\n  justify-content: space-between;\n  padding: 0 10rem;\n\n  > div {\n    ", ";\n\n    ", ";\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ArticleContent_templateObject10 || (ArticleContent_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc( ((1/2) * 100%) - 10rem );\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ArticleContent_templateObject11 || (ArticleContent_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc( ((1/3) * 100%) - 13.333rem );\n    "]))));
var ArticleContent_Container = styled_components_browser_esm["default"].div(ArticleContent_templateObject12 || (ArticleContent_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
var ArticleContent_Title = styled_components_browser_esm["default"].h1(ArticleContent_templateObject13 || (ArticleContent_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, function (props) {
  return props.color;
}, breakpoints/* toBreakpoint.md */.Hx.md(ArticleContent_templateObject14 || (ArticleContent_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(ArticleContent_templateObject15 || (ArticleContent_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))));
var ArticleContent_PublishedDate = styled_components_browser_esm["default"].div(ArticleContent_templateObject16 || (ArticleContent_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 10rem;\n  margin-bottom: 45rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ArticleContent_IntroText = styled_components_browser_esm["default"].p(ArticleContent_templateObject17 || (ArticleContent_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 40rem;\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
;// CONCATENATED MODULE: ./src/components/Article.js








var Article_templateObject;

var Article_jsx = react.createElement;

function Article_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, Article_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function Article_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (Article_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}















var Article_connectApiData = (0,withApiData/* default */.Z)({
  article: 'getArticle'
}, function (ownProps) {
  var _ref = ownProps.modal ? ownProps : ownProps.match.params,
      projectSlug = _ref.projectSlug,
      env = _ref.env,
      articleSlug = _ref.articleSlug;

  return {
    article: {
      projectSlug: projectSlug,
      env: env,
      articleSlug: articleSlug
    }
  };
});

var Article_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    completeLoading: function completeLoading() {
      dispatch((0,redux_modal/* hideModalLoader */.OF)());
    },
    getNewArticle: function getNewArticle(projectSlug, env, articleSlug) {
      dispatch((0,apiData/* performApiRequest */.T4)('getArticle', {
        projectSlug: projectSlug,
        env: env,
        articleSlug: articleSlug
      }));
    }
  };
};

var Article = /*#__PURE__*/function (_PureComponent) {
  function Article() {
    (0,classCallCheck/* default */.Z)(this, Article);

    return Article_callSuper(this, Article, arguments);
  }

  (0,inherits/* default */.Z)(Article, _PureComponent);

  return (0,createClass/* default */.Z)(Article, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          modal = _this$props.modal,
          article = _this$props.article,
          completeLoading = _this$props.completeLoading;

      if (modal && article.data) {
        completeLoading();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var _this$props2 = this.props,
          modal = _this$props2.modal,
          article = _this$props2.article,
          completeLoading = _this$props2.completeLoading,
          projectSlug = _this$props2.projectSlug,
          env = _this$props2.env,
          articleSlug = _this$props2.articleSlug,
          getNewArticle = _this$props2.getNewArticle;
      var oldArticle = oldProps.article;

      if (modal && !oldArticle.data && article.data) {
        completeLoading();
      }

      if (oldProps.articleSlug !== articleSlug) {
        getNewArticle(projectSlug, env, articleSlug);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          article = _this$props3.article,
          settings = _this$props3.settings,
          modal = _this$props3.modal,
          planningObj = _this$props3.planningObj,
          _this$props3$renderWi = _this$props3.renderWidth,
          renderWidth = _this$props3$renderWi === void 0 ? 0 : _this$props3$renderWi,
          match = _this$props3.match;
      var pageNotFound = lodash_get_default()(article, 'request.response.status') === 404;
      var title = article.data && settings ? "".concat(article.data.title, " - ").concat(settings.siteName) : undefined;
      var meta = article.data ? {
        metaTitle: title
      } : {};
      var layoutSettings = {
        hasHeader: true,
        hasFooter: true,
        hasMenu: true
      };
      return modal ? article.data ? Article_jsx(components_ArticleContent, {
        article: article.data,
        planningObj: planningObj || false,
        modal: true,
        renderWidth: renderWidth,
        "data-id": "components_Article_ArticleContent"
      }) : null : Article_jsx(layout_LayoutBase, {
        settings: settings,
        layoutSettings: layoutSettings,
        renderWidth: renderWidth,
        title: title,
        meta: meta,
        "data-id": "components_Article_LayoutBase"
      }, article.data && !pageNotFound && Article_jsx(ArticleGridWrapper, {
        "data-id": "components_Article_ArticleGridWrapper"
      }, Article_jsx(components_ArticleContent, {
        article: article.data,
        modal: false,
        renderWidth: renderWidth,
        planningObj: false,
        "data-id": "components_Article_ArticleContent"
      })), article.request.networkStatus === 'loading' && Article_jsx(ContentLoader/* default */.Z, {
        "data-id": "components_Article_ContentLoader"
      }), pageNotFound && Article_jsx(ErrorBlock/* default */.Z, (0,esm_extends/* default */.Z)({}, (0,errorMessages/* getErrorBlockProps */.k)(match, 'article', 404), {
        "data-id": "components_Article_ErrorBlock"
      })));
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var components_Article = ((0,withMatch/* default */.Z)(Article_connectApiData((0,es/* connect */.$j)(null, Article_mapDispatchToProps)(Article))));
var ArticleGridWrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(Article_templateObject || (Article_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-sizing: border-box;\n  padding: 40rem 20rem 100rem 20rem;\n"])));
;// CONCATENATED MODULE: ./src/components/contentTypes/ArticlePage.tsx


var ArticlePage_excluded = ["match"];

function ArticlePage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ArticlePage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ArticlePage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ArticlePage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ArticlePage = function ArticlePage(_ref) {
  var params = _ref.match.params,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ArticlePage_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_Article // @ts-ignore
  , ArticlePage_objectSpread(ArticlePage_objectSpread({
    articleSlug: params.articleSlug,
    env: params.env,
    projectSlug: params.projectSlug
  }, rest), {}, {
    "data-id": "contentTypes_ArticlePage_Article"
  }));
};

/* harmony default export */ var contentTypes_ArticlePage = (WithSettings(ArticlePage));
;// CONCATENATED MODULE: ./src/components/shared/layout/LayoutFooterPage.js


var LayoutFooterPage_templateObject, LayoutFooterPage_templateObject2, LayoutFooterPage_templateObject3, LayoutFooterPage_templateObject4, LayoutFooterPage_templateObject5;

var LayoutFooterPage_jsx = react.createElement;








var LayoutFooterPage = function LayoutFooterPage(_ref) {
  var match = _ref.match,
      title = _ref.title,
      footerPage = _ref.footerPage;
  var footerPageSlug = match.params.footerPageSlug;
  return LayoutFooterPage_jsx(gridElements/* GridWrapper */.zc, {
    "data-id": "layout_LayoutFooterPage_GridWrapper"
  }, LayoutFooterPage_jsx(CopyCell, {
    "data-id": "layout_LayoutFooterPage_CopyCell"
  }, footerPageSlug && LayoutFooterPage_jsx(LayoutFooterPage_Title, {
    "data-id": "layout_LayoutFooterPage_Title"
  }, title)), LayoutFooterPage_jsx(BlockCell, {
    "data-id": "layout_LayoutFooterPage_BlockCell"
  }, footerPage && LayoutFooterPage_jsx(components_RichTextBlock, {
    bbcode: footerPage,
    "data-id": "layout_LayoutFooterPage_RichTextBlock"
  })));
};

var CopyCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LayoutFooterPage_templateObject || (LayoutFooterPage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 820rem;\n  margin-left: auto;\n  margin-right: auto;\n"])));
var BlockCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LayoutFooterPage_templateObject2 || (LayoutFooterPage_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 20rem;\n  padding-bottom: 20rem;\n  margin-right: 10rem;\n  margin-left: 10rem;\n  padding-right: 10rem;\n  padding-left: 10rem;\n"])));
var LayoutFooterPage_Title = styled_components_browser_esm["default"].h1(LayoutFooterPage_templateObject3 || (LayoutFooterPage_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* toBreakpoint.md */.Hx.md(LayoutFooterPage_templateObject4 || (LayoutFooterPage_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(LayoutFooterPage_templateObject5 || (LayoutFooterPage_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))));
/* harmony default export */ var layout_LayoutFooterPage = ((0,withMatch/* default */.Z)(LayoutFooterPage));
;// CONCATENATED MODULE: ./src/components/contentTypes/FooterPage.js






var FooterPage_jsx = react.createElement;

function FooterPage_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, FooterPage_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function FooterPage_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (FooterPage_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}












var FooterPage_connectApiData = (0,withApiData/* default */.Z)({
  footerPage: 'getFooterPage'
}, function (_ref) {
  var match = _ref.match;
  var _match$params = match.params,
      projectSlug = _match$params.projectSlug,
      env = _match$params.env,
      footerPageSlug = _match$params.footerPageSlug;
  return {
    footerPage: {
      projectSlug: projectSlug,
      env: env,
      footerPageSlug: footerPageSlug
    }
  };
});

var FooterPage_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getNewFooterPage: function getNewFooterPage(_ref2) {
      var params = _ref2.params;
      dispatch((0,apiData/* performApiRequest */.T4)('getPage', params));
    }
  };
}; // You may ask: why store the titles of these pages in the frontend, statically?
// That is due to the fact the CMS can't serve these types of pages (yet).


var PAGETITLE = {
  about: 'Over Homestudios',
  disclaimer: 'Disclaimer',
  'privacy-statement': 'Privacy Statement'
};

var FooterPageContainer = /*#__PURE__*/function (_Component) {
  function FooterPageContainer() {
    (0,classCallCheck/* default */.Z)(this, FooterPageContainer);

    return FooterPage_callSuper(this, FooterPageContainer, arguments);
  }

  (0,inherits/* default */.Z)(FooterPageContainer, _Component);

  return (0,createClass/* default */.Z)(FooterPageContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          getNewFooterPage = _this$props.getNewFooterPage,
          match = _this$props.match;
      var footerPageSlug = match.params.footerPageSlug;
      var oldFooterPageSlug = prevProps.match.params.footerPageSlug;

      if (oldFooterPageSlug !== footerPageSlug) {
        getNewFooterPage(match.params);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          match = _this$props2.match,
          footerPage = _this$props2.footerPage,
          settings = _this$props2.settings,
          renderWidth = _this$props2.renderWidth;
      var footerPageSlug = match.params.footerPageSlug;
      var pageNotFound = lodash_get_default()(footerPage, 'request.response.status') === 404;
      var title = footerPageSlug && settings ? "".concat(PAGETITLE[footerPageSlug], " - ").concat(settings.siteName) : undefined;
      var meta = footerPage.data ? {
        metaTitle: title
      } : {};
      var layoutSettings = {
        hasHeader: true,
        hasFooter: true,
        hasMenu: true
      };
      return FooterPage_jsx(layout_LayoutBase, {
        settings: settings,
        layoutSettings: layoutSettings,
        renderWidth: renderWidth,
        title: title,
        meta: meta,
        "data-id": "contentTypes_FooterPage_LayoutBase"
      }, footerPage.data && !pageNotFound && FooterPage_jsx(layout_LayoutFooterPage, {
        footerPage: footerPage.data,
        renderWidth: renderWidth,
        title: title,
        "data-id": "contentTypes_FooterPage_LayoutFooterPage"
      }), footerPage.request.networkStatus === 'loading' && FooterPage_jsx(ContentLoader/* default */.Z, {
        "data-id": "contentTypes_FooterPage_ContentLoader"
      }), pageNotFound && FooterPage_jsx(ErrorBlock/* default */.Z, (0,esm_extends/* default */.Z)({}, (0,errorMessages/* getErrorBlockProps */.k)(match, 'footerpage', 404), {
        "data-id": "contentTypes_FooterPage_ErrorBlock"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var FooterPage = (WithSettings(FooterPage_connectApiData((0,es/* connect */.$j)(null, FooterPage_mapDispatchToProps)(FooterPageContainer))));
;// CONCATENATED MODULE: ./src/components/PictureCollage.js


var PictureCollage_templateObject, PictureCollage_templateObject2, PictureCollage_templateObject3, PictureCollage_templateObject4, PictureCollage_templateObject5, PictureCollage_templateObject6, PictureCollage_templateObject7, PictureCollage_templateObject8, PictureCollage_templateObject9, PictureCollage_templateObject0, PictureCollage_templateObject1, PictureCollage_templateObject10;

var PictureCollage_jsx = react.createElement;










var PictureCollage_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPress: function onPress(evt, images, currentIndex) {
      evt.preventDefault();
      evt.stopPropagation();
      dispatch((0,redux_modal/* openModal */.h7)('#ffffff', {
        type: 'slider',
        componentProps: {
          currentIndex: currentIndex,
          images: images
        }
      }));
    }
  };
};

var PictureCollage = function PictureCollage(_ref) {
  var renderWidth = _ref.renderWidth,
      media = _ref.media,
      onPress = _ref.onPress;
  var size = renderWidth > 689 ? 'medium' : 'small';
  var remainingPictureAvailable = media.length > 6;
  var remainingPictureCount = (media.length - 5).toString();
  return media && media.length ? PictureCollage_jsx(PictureCollage_View, {
    "data-id": "components_PictureCollage_View"
  }, size === 'medium' ? PictureCollage_jsx(CollageWrapper, {
    "data-id": "components_PictureCollage_CollageWrapper"
  }, PictureCollage_jsx(Collage, {
    mediumView: size === 'medium',
    "data-id": "components_PictureCollage_Collage"
  }, PictureCollage_jsx(ColumnOne, {
    "data-id": "components_PictureCollage_ColumnOne"
  }, PictureCollage_jsx(ShowBtn, {
    onClick: function onClick(evt) {
      return onPress(evt, media, 0);
    },
    "data-id": "components_PictureCollage_ShowBtn"
  }, PictureCollage_jsx(ImageLoader/* default */.Z, {
    src: media[0].image.src,
    mode: "bg",
    "data-id": "components_PictureCollage_ImageLoader"
  }))), media[1] && PictureCollage_jsx(ColumnOne, {
    "data-id": "components_PictureCollage_ColumnOne"
  }, PictureCollage_jsx(RowOne, {
    "data-id": "components_PictureCollage_RowOne"
  }, PictureCollage_jsx(ShowBtn, {
    onClick: function onClick(evt) {
      return onPress(evt, media, 1);
    },
    "data-id": "components_PictureCollage_ShowBtn"
  }, PictureCollage_jsx(ImageLoader/* default */.Z, {
    src: media[1].image.src,
    mode: "bg",
    "data-id": "components_PictureCollage_ImageLoader"
  }))), media[2] && PictureCollage_jsx(RowOne, {
    "data-id": "components_PictureCollage_RowOne"
  }, PictureCollage_jsx(RowTwo, {
    "data-id": "components_PictureCollage_RowTwo"
  }, PictureCollage_jsx(ColumnTwo, {
    "data-id": "components_PictureCollage_ColumnTwo"
  }, PictureCollage_jsx(ShowBtn, {
    onClick: function onClick(evt) {
      return onPress(evt, media, 2);
    },
    "data-id": "components_PictureCollage_ShowBtn"
  }, PictureCollage_jsx(ImageLoader/* default */.Z, {
    src: media[2].image.src,
    mode: "bg",
    "data-id": "components_PictureCollage_ImageLoader"
  }))), media[3] && PictureCollage_jsx(ColumnTwo, {
    "data-id": "components_PictureCollage_ColumnTwo"
  }, PictureCollage_jsx(ShowBtn, {
    onClick: function onClick(evt) {
      return onPress(evt, media, 3);
    },
    "data-id": "components_PictureCollage_ShowBtn"
  }, PictureCollage_jsx(ImageLoader/* default */.Z, {
    src: media[3].image.src,
    mode: "bg",
    "data-id": "components_PictureCollage_ImageLoader"
  })))), media[4] && PictureCollage_jsx(RowTwo, {
    "data-id": "components_PictureCollage_RowTwo"
  }, PictureCollage_jsx(ColumnTwo, {
    "data-id": "components_PictureCollage_ColumnTwo"
  }, PictureCollage_jsx(ShowBtn, {
    onClick: function onClick(evt) {
      return onPress(evt, media, 4);
    },
    "data-id": "components_PictureCollage_ShowBtn"
  }, PictureCollage_jsx(ImageLoader/* default */.Z, {
    src: media[4].image.src,
    mode: "bg",
    "data-id": "components_PictureCollage_ImageLoader"
  }))), media[5] && PictureCollage_jsx(ColumnTwo, {
    "data-id": "components_PictureCollage_ColumnTwo"
  }, PictureCollage_jsx(ShowBtn, {
    onClick: function onClick(evt) {
      return onPress(evt, media, 5);
    },
    "data-id": "components_PictureCollage_ShowBtn"
  }, PictureCollage_jsx(ImageLoader/* default */.Z, {
    src: media[5].image.src,
    mode: "bg",
    "data-id": "components_PictureCollage_ImageLoader"
  }), remainingPictureAvailable && PictureCollage_jsx(Overlay, {
    "data-id": "components_PictureCollage_Overlay"
  }, PictureCollage_jsx(PictureCountText, {
    "data-id": "components_PictureCollage_PictureCountText"
  }, PictureCollage_jsx(PlusIconWrapper, {
    "data-id": "components_PictureCollage_PlusIconWrapper"
  }, PictureCollage_jsx(icons_Plus, {
    "data-id": "components_PictureCollage_PlusIcon"
  })), remainingPictureCount, " beelden"))))))))) : PictureCollage_jsx(SliderContainer, {
    "data-id": "components_PictureCollage_SliderContainer"
  }, PictureCollage_jsx(ui_Slider, {
    heroes: media,
    showPrimaryArrows: false,
    heightRatio: 544 / 780,
    currentIndex: 0,
    "data-id": "components_PictureCollage_Slider"
  }))) : null;
};

/* harmony default export */ var components_PictureCollage = ((0,es/* connect */.$j)(null, PictureCollage_mapDispatchToProps)(PictureCollage));
var PictureCollage_View = styled_components_browser_esm["default"].div(PictureCollage_templateObject || (PictureCollage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
var SliderContainer = styled_components_browser_esm["default"].div(PictureCollage_templateObject2 || (PictureCollage_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: calc(100% + 40rem);\n  position: relative;\n  left: -20rem;\n"])));
var ShowBtn = styled_components_browser_esm["default"].button(PictureCollage_templateObject3 || (PictureCollage_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  box-shadow: 0rem 0rem 4rem 0rem rgba(0, 0, 0, 0.16);\n\n  > div:nth-of-type(1) > div {\n    transform: scale(1) translateZ(0);\n    transition: transform 1s ease;\n    will-change: transform;\n  }\n\n  &:hover > div {\n    > div:nth-of-type(1) {\n      transform: scale(1.03) translateZ(0);\n    }\n  }\n"])));
var Overlay = styled_components_browser_esm["default"].div(PictureCollage_templateObject4 || (PictureCollage_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), (0,utils/* hex2rgb */.wK)(styleGuide/* colorPalette.beige */.K5.beige, 0.75));
var PlusIconWrapper = styled_components_browser_esm["default"].div(PictureCollage_templateObject5 || (PictureCollage_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 13rem;\n  height: 13rem;\n  display: inline-block;\n  margin-right: 6rem;\n  position: relative;\n"])));
var PictureCountText = styled_components_browser_esm["default"].span(PictureCollage_templateObject6 || (PictureCollage_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 20rem;\n  font-weight: bold;\n  line-height: 20rem;\n  display: block;\n"])), styleGuide/* fonts.primary */.Rq.primary);
var ColumnTwo = styled_components_browser_esm["default"].div(PictureCollage_templateObject7 || (PictureCollage_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  width: calc(50% - 10rem);\n  position: relative;\n  float: left;\n"])));
var RowTwo = styled_components_browser_esm["default"].div(PictureCollage_templateObject8 || (PictureCollage_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  float: left;\n  width: 100%;\n  height: calc(50% - 10rem);\n\n  > ", ":nth-of-type(1) {\n    margin-right: 10rem;\n  }\n\n  > ", ":nth-of-type(2) {\n    margin-left: 10rem;\n  }\n"])), ColumnTwo, ColumnTwo);
var RowOne = styled_components_browser_esm["default"].div(PictureCollage_templateObject9 || (PictureCollage_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  float: left;\n  width: 100%;\n  height: calc(50% - 10rem);\n\n  > ", ":nth-of-type(1) {\n    margin-bottom: 10rem;\n  }\n\n  > ", ":nth-of-type(2) {\n    margin-top: 10rem;\n  }\n"])), RowTwo, RowTwo);
var ColumnOne = styled_components_browser_esm["default"].div(PictureCollage_templateObject0 || (PictureCollage_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  width: calc(50% - 20rem);\n\n  > ", ":nth-of-type(1) {\n    margin-bottom: 10rem;\n  }\n\n  > ", ":nth-of-type(2) {\n    margin-top: 10rem;\n  }\n"])), RowOne, RowOne);
var CollageWrapper = styled_components_browser_esm["default"].div(PictureCollage_templateObject1 || (PictureCollage_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  padding-top: calc((544 / 1311) * 100%);\n  width: 100%;\n  margin-top: 20rem;\n  margin-bottom: 20rem;\n\n  &:before {\n    position: absolute;\n    content: '';\n    top: -20rem;\n    height: 1rem;\n    width: 100%;\n    border-top: 1rem dashed ", ";\n  }\n\n  &:after {\n    position: absolute;\n    content: '';\n    bottom: -20rem;\n    height: 1rem;\n    width: 100%;\n    border-top: 1rem dashed ", ";\n  }\n"])), (0,utils/* hex2rgb */.wK)(styleGuide/* colorPalette.lightGrey */.K5.lightGrey, 0.5), (0,utils/* hex2rgb */.wK)(styleGuide/* colorPalette.lightGrey */.K5.lightGrey, 0.5));
var Collage = styled_components_browser_esm["default"].div(PictureCollage_templateObject10 || (PictureCollage_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  position: absolute;\n  justify-content: space-between;\n\n  ", ":nth-of-type(1) {\n    width: calc(((8 / 12) * 100%) - 10rem);\n  }\n\n  ", ":nth-of-type(2) {\n    width: calc(((4 / 12) * 100%) - 10rem);\n  }\n"])), ColumnOne, ColumnOne);
;// CONCATENATED MODULE: ./src/components/shared/buttons/ButtonShowMoreLess.js


var ButtonShowMoreLess_templateObject, ButtonShowMoreLess_templateObject2, ButtonShowMoreLess_templateObject3;

var ButtonShowMoreLess_jsx = react.createElement;





var ButtonShowMoreLess_defaultProps = {
  color: styleGuide/* colorPalette.blue */.K5.blue,
  direction: 'down'
};

var ButtonShowMoreLess = function ButtonShowMoreLess(_ref) {
  var clickHandler = _ref.clickHandler,
      color = _ref.color,
      label = _ref.label,
      direction = _ref.direction;
  return ButtonShowMoreLess_jsx(ButtonShowMoreLess_Button, {
    onClick: clickHandler,
    "data-id": "buttons_ButtonShowMoreLess_Button"
  }, ButtonShowMoreLess_jsx(ButtonShowMoreLess_Label, {
    color: color,
    "data-id": "buttons_ButtonShowMoreLess_Label"
  }, label), ButtonShowMoreLess_jsx(ButtonShowMoreLess_Container, {
    color: color,
    "data-id": "buttons_ButtonShowMoreLess_Container"
  }, ButtonShowMoreLess_jsx(Caret/* default */.Z, {
    color: "white",
    direction: direction,
    width: 12,
    height: 7,
    "data-id": "buttons_ButtonShowMoreLess_Caret"
  })));
};

ButtonShowMoreLess.defaultProps = ButtonShowMoreLess_defaultProps;
/* harmony default export */ var buttons_ButtonShowMoreLess = (ButtonShowMoreLess);
var ButtonShowMoreLess_Button = styled_components_browser_esm["default"].button(ButtonShowMoreLess_templateObject || (ButtonShowMoreLess_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  font-family: ", ";\n  padding: 10rem 0;\n\n  &:hover {\n    > span {\n      color: ", ";\n    }\n    > div {\n      background-color: ", ";\n    }\n  }\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.color ? (0,utils/* darken */._j)(props.color, 15) : styleGuide/* colorPalette.darkBlue */.K5.darkBlue;
}, function (props) {
  return props.color ? (0,utils/* darken */._j)(props.color, 15) : styleGuide/* colorPalette.darkBlue */.K5.darkBlue;
});
var ButtonShowMoreLess_Container = styled_components_browser_esm["default"].span(ButtonShowMoreLess_templateObject2 || (ButtonShowMoreLess_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  height: 20rem;\n  width: 20rem;\n  background: ", ";\n  border-radius: 4rem 0 4rem 0;\n  margin-left: 10rem;\n  margin-top: 2rem;\n  transition: background 0.2s ease-in-out;\n"])), function (props) {
  return props.color ? props.color : styleGuide/* colorPalette.blue */.K5.blue;
});
var ButtonShowMoreLess_Label = styled_components_browser_esm["default"].span(ButtonShowMoreLess_templateObject3 || (ButtonShowMoreLess_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-weight: bold;\n  font-size: 18rem;\n  transition: color 0.2s ease-in-out;\n"])), function (props) {
  return props.color;
});
;// CONCATENATED MODULE: ./src/components/RichTextBlockExpand.js








var RichTextBlockExpand_templateObject, RichTextBlockExpand_templateObject2, RichTextBlockExpand_templateObject3;

var RichTextBlockExpand_jsx = react.createElement;

function RichTextBlockExpand_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, RichTextBlockExpand_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function RichTextBlockExpand_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (RichTextBlockExpand_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}






var RichTextBlockExpand = /*#__PURE__*/function (_PureComponent) {
  function RichTextBlockExpand() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, RichTextBlockExpand);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = RichTextBlockExpand_callSuper(this, RichTextBlockExpand, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      expanded: false
    });

    (0,defineProperty/* default */.Z)(_this, "toggleExpand", function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(RichTextBlockExpand, _PureComponent);

  return (0,createClass/* default */.Z)(RichTextBlockExpand, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var expanded = this.state.expanded;
      var richtext = this.props.richtext;
      return RichTextBlockExpand_jsx(react.Fragment, null, RichTextBlockExpand_jsx(RichTextBlockExpand_Container, {
        expanded: expanded,
        maxHeight: this.textContent && this.textContent.offsetHeight,
        "data-id": "components_RichTextBlockExpand_Container"
      }, RichTextBlockExpand_jsx("div", {
        ref: function ref(input) {
          _this2.textContent = input;
        },
        "data-id": "components_RichTextBlockExpand_div"
      }, RichTextBlockExpand_jsx(BBCode/* default */.Z, {
        content: richtext,
        "data-id": "components_RichTextBlockExpand_BBCode"
      })), !expanded && RichTextBlockExpand_jsx(Fade, {
        showMore: expanded,
        "data-id": "components_RichTextBlockExpand_Fade"
      })), RichTextBlockExpand_jsx(RichTextBlockExpand_ButtonContainer, {
        showMore: expanded,
        "data-id": "components_RichTextBlockExpand_ButtonContainer"
      }, RichTextBlockExpand_jsx(buttons_ButtonShowMoreLess, {
        label: expanded ? 'Toon minder' : 'Toon meer',
        direction: expanded ? 'up' : 'down',
        clickHandler: this.toggleExpand,
        "data-id": "components_RichTextBlockExpand_ButtonShowMoreLess"
      })));
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var components_RichTextBlockExpand = (RichTextBlockExpand);
var RichTextBlockExpand_Container = styled_components_browser_esm["default"].div(RichTextBlockExpand_templateObject || (RichTextBlockExpand_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  max-height: ", "rem;\n  overflow: hidden;\n  transition: max-height 0.4s ease-in-out;\n"])), function (props) {
  return props.expanded ? props.maxHeight : '300';
});
var RichTextBlockExpand_ButtonContainer = styled_components_browser_esm["default"].div(RichTextBlockExpand_templateObject2 || (RichTextBlockExpand_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 120rem;\n"])));
var Fade = styled_components_browser_esm["default"].div(RichTextBlockExpand_templateObject3 || (RichTextBlockExpand_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  position: absolute;\n  bottom: 0;\n  height: 60rem;\n  width: 100%;\n  background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 1));\n"])));
;// CONCATENATED MODULE: ./src/components/StorySlider.js


var StorySlider_templateObject;

var StorySlider_jsx = react.createElement;







var StorySlider_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: (0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }).styling
  };
};

var StorySlider = function StorySlider(_ref) {
  var heroes = _ref.heroes,
      styling = _ref.styling;
  return StorySlider_jsx(StorySlider_Container, {
    "data-e2e-block-storyslider": true,
    "data-id": "components_StorySlider_Container"
  }, StorySlider_jsx(ui_Slider, {
    heroes: heroes,
    paginationColor: styling.button,
    currentIndex: 0,
    "data-id": "components_StorySlider_Slider"
  }));
};

/* harmony default export */ var components_StorySlider = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(StorySlider_mapStateToProps)(StorySlider)));
var StorySlider_Container = styled_components_browser_esm["default"].div(StorySlider_templateObject || (StorySlider_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 30rem 0rem;\n"])));
;// CONCATENATED MODULE: ./src/components/ArticleCardCollection.js


var ArticleCardCollection_templateObject, ArticleCardCollection_templateObject2, ArticleCardCollection_templateObject3;

var ArticleCardCollection_jsx = react.createElement;








var ArticleCardCollection = function ArticleCardCollection(_ref) {
  var articles = _ref.articles,
      renderWidth = _ref.renderWidth,
      label = _ref.label,
      link = _ref.link;
  return ArticleCardCollection_jsx(ArticleBlock, {
    "data-e2e-block-articlecardcollection": true,
    "data-id": "components_ArticleCardCollection_ArticleBlock"
  }, ArticleCardCollection_jsx(ArticleContainer, {
    "data-id": "components_ArticleCardCollection_ArticleContainer"
  }, (articles || []).map(function (article, index) {
    return ArticleCardCollection_jsx(components_ArticleCard, {
      key: index,
      id: index,
      isBig: false,
      type: article.type,
      leader: article.leader,
      image: article.image,
      title: article.title,
      theme: article.theme,
      label: article.label,
      author: article.author,
      eventDate: article.eventDate,
      slug: article.slug,
      renderWidth: renderWidth,
      "data-id": "components_ArticleCardCollection_ArticleCard"
    });
  })), label && link && ArticleCardCollection_jsx(ArticleCardCollection_ButtonWrapper, {
    "data-id": "components_ArticleCardCollection_ButtonWrapper"
  }, ArticleCardCollection_jsx(ButtonSecondary/* default */.Z, {
    label: label,
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(link),
    type: "internalLink",
    "data-id": "components_ArticleCardCollection_ButtonSecondary"
  })));
};

/* harmony default export */ var components_ArticleCardCollection = ((0,withMatch/* default */.Z)(ArticleCardCollection));
var ArticleBlock = styled_components_browser_esm["default"].div(ArticleCardCollection_templateObject || (ArticleCardCollection_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 40rem;\n  position: relative;\n\n  > svg {\n    position: absolute;\n    bottom: 0;\n    max-width: 800rem;\n    width: 100%;\n  }\n"])));
var ArticleContainer = (0,styled_components_browser_esm["default"])(CardCollectionContainer)(ArticleCardCollection_templateObject2 || (ArticleCardCollection_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var ArticleCardCollection_ButtonWrapper = styled_components_browser_esm["default"].div(ArticleCardCollection_templateObject3 || (ArticleCardCollection_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: center;\n"])));
;// CONCATENATED MODULE: ./src/components/HouseCard.js


var HouseCard_templateObject, HouseCard_templateObject2, HouseCard_templateObject3, HouseCard_templateObject4, HouseCard_templateObject5, HouseCard_templateObject6, HouseCard_templateObject7, HouseCard_templateObject8, HouseCard_templateObject9, HouseCard_templateObject0, HouseCard_templateObject1, HouseCard_templateObject10, HouseCard_templateObject11, HouseCard_templateObject12, HouseCard_templateObject13, HouseCard_templateObject14, HouseCard_templateObject15, HouseCard_templateObject16;

var HouseCard_jsx = react.createElement;









var HouseCard = function HouseCard(_ref) {
  var match = _ref.match,
      slug = _ref.slug,
      media = _ref.media,
      variantName = _ref.variantName,
      variantCodes = _ref.variantCodes,
      totalCount = _ref.totalCount,
      isSold = _ref.isSold,
      optionCount = _ref.optionCount,
      availableCount = _ref.availableCount,
      livingSpace = _ref.livingSpace,
      bedrooms = _ref.bedrooms,
      energyLabel = _ref.energyLabel,
      price = _ref.price;
  return HouseCard_jsx(HouseCard_Card, {
    "data-id": "components_HouseCard_Card"
  }, HouseCard_jsx(LinkElement, {
    href: "/".concat(String(match.params.projectSlug), "/").concat(String(match.params.env), "/housetype/").concat(slug),
    "data-id": "components_HouseCard_LinkElement"
  }, HouseCard_jsx(HouseCard_ImageContainer, {
    "data-id": "components_HouseCard_ImageContainer"
  }, media.length > 0 && HouseCard_jsx(ImageLoader/* default */.Z, {
    src: media[0].image.src,
    width: 380,
    mode: "bg",
    position: "absolute",
    scaleTransition: true,
    "data-id": "components_HouseCard_ImageLoader"
  })), HouseCard_jsx(HouseCard_TextContainer, {
    "data-id": "components_HouseCard_TextContainer"
  }, HouseCard_jsx(HouseCard_Title, {
    "data-id": "components_HouseCard_Title"
  }, variantName, ' ', variantCodes && variantCodes.length > 0 ? "- ".concat(variantCodes.join(', ')) : ""), HouseCard_jsx(Availability, {
    "data-id": "components_HouseCard_Availability"
  }, HouseCard_jsx(Quantity, {
    "data-id": "components_HouseCard_Quantity"
  }, totalCount === 1 ? "".concat(totalCount, " woning") : "".concat(totalCount, " woningen")), !isSold && availableCount > 0 && HouseCard_jsx(Seperation, {
    "data-id": "components_HouseCard_Seperation"
  }, "|"), !isSold && availableCount > 0 && HouseCard_jsx(Available, {
    "data-id": "components_HouseCard_Available"
  }, availableCount, " te koop"), optionCount > 0 && !isSold && HouseCard_jsx(Seperation, {
    "data-id": "components_HouseCard_Seperation"
  }, " | "), optionCount > 0 && !isSold && HouseCard_jsx(HouseCard_Option, {
    "data-id": "components_HouseCard_Option"
  }, optionCount, " onder optie")), HouseCard_jsx(HouseCard_PriceContainer, {
    "data-id": "components_HouseCard_PriceContainer"
  }, !isSold && HouseCard_jsx(StartingPrice, {
    "data-id": "components_HouseCard_StartingPrice"
  }, "Vanaf"), HouseCard_jsx(designElements_PriceTag, {
    price: price,
    isSold: isSold,
    "data-id": "components_HouseCard_PriceTag"
  }), !isSold && HouseCard_jsx(FreeOnName, {
    "data-id": "components_HouseCard_FreeOnName"
  }, "v.o.n.")), HouseCard_jsx(HouseCard_List, {
    "data-id": "components_HouseCard_List"
  }, HouseCard_jsx(HouseCard_ListItem, {
    "data-id": "components_HouseCard_ListItem"
  }, "Woonoppervlak: ", HouseCard_jsx(Strong, {
    "data-id": "components_HouseCard_Strong"
  }, livingSpace, " m\xB2")), HouseCard_jsx(HouseCard_ListItem, {
    "data-id": "components_HouseCard_ListItem"
  }, "Slaapkamers: ", HouseCard_jsx(Strong, {
    "data-id": "components_HouseCard_Strong"
  }, bedrooms))))));
};

/* harmony default export */ var components_HouseCard = ((0,withMatch/* default */.Z)(HouseCard));
var HouseCard_Card = styled_components_browser_esm["default"].div(HouseCard_templateObject || (HouseCard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n"])));
var HouseCard_ImageContainer = styled_components_browser_esm["default"].div(HouseCard_templateObject2 || (HouseCard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  top: 0;\n  left: 0;\n  height: 160rem;\n  width: 100%;\n  position: absolute;\n  overflow: hidden;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(HouseCard_templateObject3 || (HouseCard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 215rem;\n  "]))));
var LinkElement = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(HouseCard_templateObject4 || (HouseCard_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-decoration: none;\n  background-color: #ffffff;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  padding-top: 160rem;\n  padding-bottom: 15rem;\n  ", ";\n  transition: box-shadow 0.25s ease;\n\n  ", " > div:first-of-type {\n    backface-visibility: visible;\n  }\n\n  &:hover {\n    ", ";\n\n    ", " > div:first-of-type {\n      transform: scale(1.03) translateZ(0);\n    }\n  }\n\n  ", ";\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, HouseCard_ImageContainer, styleGuide/* shadows.boxPrimaryHover */.q.boxPrimaryHover, HouseCard_ImageContainer, breakpoints/* fromBreakpoint.md */.ks.md(HouseCard_templateObject5 || (HouseCard_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 215rem;\n  "]))));
var HouseCard_TextContainer = styled_components_browser_esm["default"].div(HouseCard_templateObject6 || (HouseCard_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0 20rem;\n"])));
var HouseCard_Title = styled_components_browser_esm["default"].h3(HouseCard_templateObject7 || (HouseCard_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 25rem;\n  margin-bottom: 10rem;\n  min-height: 60rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var Availability = styled_components_browser_esm["default"].div(HouseCard_templateObject8 || (HouseCard_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 14rem;\n"])));
var Quantity = styled_components_browser_esm["default"].div(HouseCard_templateObject9 || (HouseCard_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-size: 16rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText);
var Available = styled_components_browser_esm["default"].div(HouseCard_templateObject0 || (HouseCard_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-size: 16rem;\n  color: ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.green */.K5.green);
var HouseCard_Option = styled_components_browser_esm["default"].div(HouseCard_templateObject1 || (HouseCard_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-size: 16rem;\n  color: ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.signalOrange */.K5.signalOrange);
var Seperation = styled_components_browser_esm["default"].span(HouseCard_templateObject10 || (HouseCard_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-size: 16rem;\n  color: ", ";\n  margin-left: 5rem;\n  margin-right: 5rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.lightGrey */.K5.lightGrey);
var HouseCard_PriceContainer = styled_components_browser_esm["default"].div(HouseCard_templateObject11 || (HouseCard_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var HouseCard_List = styled_components_browser_esm["default"].ul(HouseCard_templateObject12 || (HouseCard_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  padding: 0;\n  margin-top: 0;\n  list-style: none;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var HouseCard_ListItem = styled_components_browser_esm["default"].li(HouseCard_templateObject13 || (HouseCard_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 4rem;\n"])));
var StartingPrice = styled_components_browser_esm["default"].span(HouseCard_templateObject14 || (HouseCard_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  margin-right: 12rem;\n"])));
var FreeOnName = styled_components_browser_esm["default"].span(HouseCard_templateObject15 || (HouseCard_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  margin-left: 10rem;\n"])));
var Strong = styled_components_browser_esm["default"].span(HouseCard_templateObject16 || (HouseCard_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: bold;\n"])));
;// CONCATENATED MODULE: ./src/components/HouseTypeCollection.js








var HouseTypeCollection_templateObject, HouseTypeCollection_templateObject2, HouseTypeCollection_templateObject3, HouseTypeCollection_templateObject4, HouseTypeCollection_templateObject5, HouseTypeCollection_templateObject6;

var HouseTypeCollection_jsx = react.createElement;

function HouseTypeCollection_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, HouseTypeCollection_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function HouseTypeCollection_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (HouseTypeCollection_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}









var HouseTypeCollection = /*#__PURE__*/function (_Component) {
  function HouseTypeCollection() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, HouseTypeCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = HouseTypeCollection_callSuper(this, HouseTypeCollection, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      renderWidth: 0
    });

    (0,defineProperty/* default */.Z)(_this, "renderHouseCard", function (_ref, index) {
      var availableCount = _ref.availableCount,
          bedrooms = _ref.bedrooms,
          energyLabel = _ref.energyLabel,
          isSold = _ref.isSold,
          livingSpace = _ref.livingSpace,
          media = _ref.media,
          optionCount = _ref.optionCount,
          price = _ref.price,
          slug = _ref.slug,
          totalCount = _ref.totalCount,
          variantName = _ref.variantName,
          variantCodes = _ref.variantCodes;
      return HouseTypeCollection_jsx(components_HouseCard, {
        key: index,
        availableCount: availableCount,
        bedrooms: bedrooms,
        energyLabel: energyLabel,
        isSold: isSold,
        livingSpace: livingSpace,
        media: media,
        optionCount: optionCount,
        price: price,
        slug: slug,
        totalCount: totalCount,
        variantName: variantName,
        variantCodes: variantCodes,
        "data-id": "components_HouseTypeCollection_HouseCard"
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(HouseTypeCollection, _Component);

  return (0,createClass/* default */.Z)(HouseTypeCollection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$houseType = this.props.houseTypes,
          houseTypes = _this$props$houseType === void 0 ? [] : _this$props$houseType;
      var swipeView = this.state.renderWidth < 480;
      return HouseTypeCollection_jsx(HouseTypeBlock, {
        "data-e2e-block-housetypecollection": true,
        "data-id": "components_HouseTypeCollection_HouseTypeBlock"
      }, HouseTypeCollection_jsx(ObserveSize/* default */.Z, {
        observerFn: function observerFn(contentRect) {
          return _this2.setState({
            renderWidth: contentRect.width
          });
        },
        "data-id": "components_HouseTypeCollection_ObserveSize"
      }, houseTypes.map(function (houseType, index) {
        return HouseTypeCollection_jsx("div", {
          key: index,
          "data-id": "components_HouseTypeCollection_div"
        }, HouseTypeCollection_jsx(HouseTypeCollection_Title, {
          "data-id": "components_HouseTypeCollection_Title"
        }, houseType.typeName, " : ", houseType.typeUsp), swipeView ? HouseTypeCollection_jsx(HouseCardRow, {
          swipeView: swipeView,
          "data-id": "components_HouseTypeCollection_HouseCardRow"
        }, HouseTypeCollection_jsx(lib/* default */.ZP, {
          enableMouseEvents: true,
          style: {
            overflow: 'visible',
            padding: '0',
            boxSizing: 'border-box'
          },
          slideStyle: {
            overflow: 'visible',
            padding: '0 5px',
            boxSizing: 'border-box'
          },
          "data-id": "components_HouseTypeCollection_SwipeableViews"
        }, houseType.houseVariants.map(function (house, index) {
          return _this2.renderHouseCard(house, index);
        }))) : HouseTypeCollection_jsx(HouseCardRow, {
          "data-id": "components_HouseTypeCollection_HouseCardRow"
        }, houseType.houseVariants.map(function (house, index) {
          return _this2.renderHouseCard(house, index);
        })));
      })));
    }
  }]);
}(react.Component);

var HouseTypeCollection_Title = styled_components_browser_esm["default"].h2(HouseTypeCollection_templateObject || (HouseTypeCollection_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 35rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var HouseCardRow = styled_components_browser_esm["default"].div(HouseTypeCollection_templateObject2 || (HouseTypeCollection_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  margin-bottom: 30rem;\n  display: flex;\n  box-sizing: border-box;\n  flex-flow: row wrap;\n  padding: 0;\n  position: relative;\n\n  ", ";\n\n  > div {\n    width: 100%;\n    margin-bottom: 20rem;\n\n    ", ";\n\n    ", ";\n  }\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(HouseTypeCollection_templateObject3 || (HouseTypeCollection_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0 0 5rem 0;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(HouseTypeCollection_templateObject4 || (HouseTypeCollection_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      height: auto;\n      width: calc( ((1/2) * 100%) - 10rem );\n\n      &:nth-of-type(2n + 1) {\n        margin-right: 20rem;\n      }\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(HouseTypeCollection_templateObject5 || (HouseTypeCollection_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc( ((1/3) * 100%) - 13.333rem );\n\n      &:nth-of-type(3n + 2) {\n        margin-right: 20rem;\n      }\n\n      &:nth-of-type(3n + 1) {\n        margin-right: 20rem;\n      }\n\n      &:nth-of-type(3n) {\n        margin-right: 0;\n      }\n    "]))), function (props) {
  return props.swipeView ? "\n  > div > div > div > div {\n    height: 100%;\n  }\n  " : "\n  > div > div > div > div {\n    height: auto;\n  }\n  ";
});
var HouseTypeBlock = styled_components_browser_esm["default"].div(HouseTypeCollection_templateObject6 || (HouseTypeCollection_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 40rem;\n"])));
/* harmony default export */ var components_HouseTypeCollection = (HouseTypeCollection);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/index.js
var dist = __webpack_require__(43352);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./src/components/Pagination.js


var Pagination_templateObject, Pagination_templateObject2, Pagination_templateObject3, Pagination_templateObject4, Pagination_templateObject5;

var Pagination_jsx = react.createElement;







var Pagination = function Pagination(_ref) {
  var isLoading = _ref.isLoading,
      totalPages = _ref.totalPages,
      currentPage = _ref.currentPage,
      visiblePages = _ref.visiblePages,
      goToPageValue = _ref.goToPageValue;
  return Pagination_jsx(PaginationBlock, {
    "data-id": "components_Pagination_PaginationBlock"
  }, Pagination_jsx(Pagination_SpinnerContainer, {
    isLoading: isLoading,
    "data-id": "components_Pagination_SpinnerContainer"
  }, Pagination_jsx(Spinner/* default */.Z, {
    monochrome: true,
    color: styleGuide/* colorPalette.lightBlue */.K5.lightBlue,
    size: "small",
    "data-id": "components_Pagination_Spinner"
  })), Pagination_jsx(PaginationContainer, {
    "data-id": "components_Pagination_PaginationContainer"
  }, Pagination_jsx(PrevCaret, {
    "data-id": "components_Pagination_PrevCaret"
  }, Pagination_jsx(Caret/* default */.Z, {
    direction: "left",
    color: styleGuide/* colorPalette.white */.K5.white,
    scale: 0.9,
    "data-id": "components_Pagination_Caret"
  })), Pagination_jsx(NextCaret, {
    "data-id": "components_Pagination_NextCaret"
  }, Pagination_jsx(Caret/* default */.Z, {
    direction: "right",
    color: styleGuide/* colorPalette.white */.K5.white,
    scale: 0.9,
    "data-id": "components_Pagination_Caret"
  })), Pagination_jsx((dist_default()), {
    pageCount: totalPages,
    pageRangeDisplayed: visiblePages,
    disableInitialCallback: true,
    marginPagesDisplayed: 1,
    forcePage: currentPage,
    initialPage: currentPage,
    previousLabel: "<",
    nextLabel: ">",
    onPageChange: function onPageChange(goToPageNumber) {
      return goToPageValue(goToPageNumber.selected + 1);
    },
    "data-id": "components_Pagination_ReactPaginate"
  })));
};

/* harmony default export */ var components_Pagination = (Pagination);
var PaginationContainer = styled_components_browser_esm["default"].div(Pagination_templateObject || (Pagination_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  overflow: hidden;\n"])));
var Pagination_SpinnerContainer = styled_components_browser_esm["default"].div(Pagination_templateObject2 || (Pagination_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  opacity: ", ";\n  position: absolute;\n  left: -60rem;\n  box-sizing: border-box;\n  padding: 5rem;\n  width: 35rem;\n  height: 35rem;\n\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    top: -60rem;\n  }\n"])), function (props) {
  return props.isLoading ? '1' : '0';
});
var PaginationBlock = styled_components_browser_esm["default"].div(Pagination_templateObject3 || (Pagination_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  display: inline-block;\n\n  ul {\n    display: inline-block;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    float: left;\n\n    li {\n      display: inline-block;\n      color: ", ";\n\n      &.selected {\n        a {\n          color: #ffffff;\n          pointer-events: none;\n          background-color: ", ";\n        }\n      }\n\n      &.break {\n        margin-left: 10rem;\n        margin-right: 10rem;\n      }\n\n      &.previous,\n      &.next {\n        a {\n          cursor: pointer;\n          text-indent: -1000rem;\n          z-index: 1;\n          opacity: 0.85;\n          background-color: ", ";\n          width: 32rem;\n          min-width: none;\n          margin: 0;\n          height: 32rem;\n          border-radius: 50%;\n          transition: opacity 0.2s ease-in-out;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          -webkit-tap-highlight-color: transparent;\n\n          &:hover {\n            opacity: 1;\n            background-color: ", ";\n          }\n        }\n\n        &.disabled {\n          opacity: 0.3;\n          pointer-events: none;\n        }\n      }\n\n      &.previous {\n        margin-right: 10rem;\n      }\n\n      &.next {\n        margin-left: 10rem;\n      }\n\n      > a {\n        outline: none;\n        ", ";\n        font-weight: bold;\n        text-decoration: none;\n        color: ", ";\n        cursor: pointer;\n        background-color: transparent;\n        padding: 4rem 8rem;\n        margin: 0 2rem;\n        display: inline-block;\n        box-sizing: border-box;\n        text-align: center;\n        min-width: 34rem;\n        border-radius: 4rem 0;\n        transition: 0.3s ease-in-out;\n\n        &:hover {\n          color: #ffffff;\n          background-color: ", ";\n        }\n      }\n    }\n  }\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* colorPalette.lightBlue */.K5.lightBlue, styleGuide/* colorPalette.lightBeige */.K5.lightBeige, styleGuide/* colorPalette.lightBeige */.K5.lightBeige, styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.beige */.K5.beige, styleGuide/* colorPalette.lightBlue */.K5.lightBlue);
var PrevCaret = styled_components_browser_esm["default"].div(Pagination_templateObject4 || (Pagination_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 6rem;\n  left: 8rem;\n  z-index: 1;\n  pointer-events: none;\n"])));
var NextCaret = styled_components_browser_esm["default"].div(Pagination_templateObject5 || (Pagination_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 6rem;\n  right: 8rem;\n  z-index: 1;\n  pointer-events: none;\n"])));
;// CONCATENATED MODULE: ./src/components/ArticleCollection.js








var ArticleCollection_templateObject, ArticleCollection_templateObject2, ArticleCollection_templateObject3, ArticleCollection_templateObject4, ArticleCollection_templateObject5;

var ArticleCollection_jsx = react.createElement;

function ArticleCollection_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ArticleCollection_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ArticleCollection_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ArticleCollection_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}











var ArticleCollection_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env;
  return {
    latestRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'getArticlePage', {
      projectSlug: String(projectSlug),
      env: String(env),
      blockId: ownProps.id,
      pageNumber: ownProps.pagination.pageNumber
    })
  };
};

var ArticleCollection_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPress: function onPress(projectSlug, env, blockId, pageNumber, currentPage) {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getArticlePage', {
        projectSlug: String(projectSlug),
        env: String(env),
        blockId: blockId,
        pageNumber: currentPage
      }));
      dispatch((0,apiData/* performApiRequest */.T4)('getArticlePage', {
        projectSlug: projectSlug,
        env: env,
        blockId: blockId,
        pageNumber: pageNumber
      }));
    }
  };
};

var ArticleCollection = /*#__PURE__*/function (_PureComponent) {
  function ArticleCollection() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ArticleCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ArticleCollection_callSuper(this, ArticleCollection, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "containerRef", null);

    (0,defineProperty/* default */.Z)(_this, "state", {
      isLoading: false
    });

    (0,defineProperty/* default */.Z)(_this, "handleClick", function (pageNumber) {
      _this.setState({
        isLoading: true
      });

      var _this$props = _this.props,
          match = _this$props.match,
          id = _this$props.id,
          pagination = _this$props.pagination,
          onPress = _this$props.onPress;
      onPress(String(match.params.projectSlug), String(match.params.env), id, pageNumber, pagination.pageNumber);
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ArticleCollection, _PureComponent);

  return (0,createClass/* default */.Z)(ArticleCollection, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var latestRequest = this.props.latestRequest;

      if (latestRequest && latestRequest.networkStatus === 'success' && this.state.isLoading) {
        this.setState({
          isLoading: false
        });
        setTimeout(function () {
          if (_this2.containerRef) {
            _this2.containerRef.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          pagination = _this$props2.pagination,
          id = _this$props2.id,
          articles = _this$props2.articles,
          renderWidth = _this$props2.renderWidth;
      var totalPages = Math.ceil(pagination.totalItemCount / pagination.itemNumberPerPage);
      var currentPage = pagination.pageNumber - 1;
      return articles ? ArticleCollection_jsx(ArticleCollection_ArticleBlock, {
        id: "article-block-".concat(id),
        ref: function ref(el) {
          _this3.containerRef = el;
        },
        "data-e2e-block-articlecollection": true,
        "data-id": "components_ArticleCollection_ArticleBlock"
      }, ArticleCollection_jsx(ArticleCollection_ArticleContainer, {
        "data-id": "components_ArticleCollection_ArticleContainer"
      }, (articles[pagination.pageNumber] || []).map(function (article, index) {
        return ArticleCollection_jsx(components_ArticleCard, {
          key: index,
          id: index,
          isBig: index === 0 || index % 11 === 0,
          type: article.type,
          leader: article.leader,
          image: article.image,
          title: article.title,
          theme: article.theme,
          label: article.label,
          author: article.author,
          eventDate: article.eventDate,
          slug: article.slug,
          renderWidth: renderWidth,
          "data-id": "components_ArticleCollection_ArticleCard"
        });
      })), totalPages > 1 && ArticleCollection_jsx(PaginationWrapper, {
        "data-id": "components_ArticleCollection_PaginationWrapper"
      }, ArticleCollection_jsx(components_Pagination, {
        blockId: id,
        totalPages: totalPages,
        currentPage: currentPage,
        isLoading: this.state.isLoading,
        visiblePages: 2,
        goToPageValue: this.handleClick,
        "data-id": "components_ArticleCollection_Pagination"
      }))) : null;
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var components_ArticleCollection = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(ArticleCollection_mapStateToProps, ArticleCollection_mapDispatchToProps)(ArticleCollection)));
var ArticleCollection_ArticleBlock = styled_components_browser_esm["default"].div(ArticleCollection_templateObject || (ArticleCollection_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 40rem;\n  margin-top: -40rem;\n  position: relative;\n  padding-top: 40rem;\n"])));
var ArticleCollection_ArticleContainer = (0,styled_components_browser_esm["default"])(CardCollectionContainer)(ArticleCollection_templateObject2 || (ArticleCollection_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  > * {\n    width: 100%;\n    ", ";\n\n    ", ";\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ArticleCollection_templateObject3 || (ArticleCollection_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc( ((1/2) * 100%) - 20rem );\n\n      &:nth-of-type(2n) {\n        margin-right: 20rem;\n      }\n\n      &:first-child {\n        width: 100%;\n      }\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ArticleCollection_templateObject4 || (ArticleCollection_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc( ((1/3) * 100%) - 13.333rem );\n\n      &:nth-of-type(3n) {\n        margin-right: 20rem;\n      }\n\n      &:nth-of-type(3n + 1) {\n        margin-right: 20rem;\n      }\n\n      &:nth-of-type(3n + 2) {\n        margin: 0rem;\n      }\n\n      &:first-child {\n        margin-right: 20rem;\n        width: calc( ((2/3) * 100%) - 7rem );\n      }\n    "]))));
var PaginationWrapper = styled_components_browser_esm["default"].div(ArticleCollection_templateObject5 || (ArticleCollection_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: flex-end;\n"])));
;// CONCATENATED MODULE: ./src/components/HouseTypeCarousel.js








var HouseTypeCarousel_templateObject, HouseTypeCarousel_templateObject2, HouseTypeCarousel_templateObject3, HouseTypeCarousel_templateObject4, HouseTypeCarousel_templateObject5, HouseTypeCarousel_templateObject6, HouseTypeCarousel_templateObject7, HouseTypeCarousel_templateObject8, HouseTypeCarousel_templateObject9;

var HouseTypeCarousel_jsx = react.createElement;

function HouseTypeCarousel_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, HouseTypeCarousel_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function HouseTypeCarousel_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (HouseTypeCarousel_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}













var HouseTypeCarousel = /*#__PURE__*/function (_React$PureComponent) {
  function HouseTypeCarousel() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, HouseTypeCarousel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = HouseTypeCarousel_callSuper(this, HouseTypeCarousel, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      swipeIndex: 0,
      renderWidth: 0
    });

    (0,defineProperty/* default */.Z)(_this, "handleChangeIndex", function (index) {
      _this.setState({
        swipeIndex: index
      });
    });

    (0,defineProperty/* default */.Z)(_this, "renderHouseCardView", function (_ref) {
      var availableCount = _ref.availableCount,
          bedrooms = _ref.bedrooms,
          energyLabel = _ref.energyLabel,
          isSold = _ref.isSold,
          livingSpace = _ref.livingSpace,
          slug = _ref.slug,
          media = _ref.media,
          optionCount = _ref.optionCount,
          price = _ref.price,
          totalCount = _ref.totalCount,
          variantCodes = _ref.variantCodes,
          variantName = _ref.variantName;
      return HouseTypeCarousel_jsx(components_HouseCard, {
        availableCount: availableCount,
        bedrooms: bedrooms,
        energyLabel: energyLabel,
        isSold: isSold,
        livingSpace: livingSpace,
        media: media,
        optionCount: optionCount,
        price: price,
        slug: slug,
        totalCount: totalCount,
        variantCodes: variantCodes,
        variantName: variantName,
        "data-id": "components_HouseTypeCarousel_HouseCard"
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(HouseTypeCarousel, _React$PureComponent);

  return (0,createClass/* default */.Z)(HouseTypeCarousel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          bbcode = _this$props.bbcode,
          houseTypes = _this$props.houseTypes,
          link = _this$props.link,
          label = _this$props.label;
      var _this$state = this.state,
          renderWidth = _this$state.renderWidth,
          swipeIndex = _this$state.swipeIndex;
      var swipeView = renderWidth < 680;
      var mediumView = renderWidth >= 680 && renderWidth < 1027;
      var largeView = renderWidth >= 1027;
      var xLargeView = window.innerWidth - renderWidth > 140;
      return HouseTypeCarousel_jsx(HouseTypeCarousel_HouseTypeBlock, {
        largeView: largeView,
        "data-e2e-block-housetypecarousel": true,
        "data-id": "components_HouseTypeCarousel_HouseTypeBlock"
      }, HouseTypeCarousel_jsx(ObserveSize/* default */.Z, {
        observerFn: function observerFn(contentRect) {
          return _this2.setState({
            renderWidth: contentRect.width
          });
        },
        "data-id": "components_HouseTypeCarousel_ObserveSize"
      }, title && HouseTypeCarousel_jsx(HouseTypeCarousel_Title, {
        "data-id": "components_HouseTypeCarousel_Title"
      }, title), bbcode && HouseTypeCarousel_jsx(HouseTypeCarousel_Description, {
        "data-id": "components_HouseTypeCarousel_Description"
      }, HouseTypeCarousel_jsx(BBCode/* default */.Z, {
        content: bbcode,
        "data-id": "components_HouseTypeCarousel_BBCode"
      })), HouseTypeCarousel_jsx(HouseTypeCarousel_HouseCardRow, {
        swipeView: swipeView,
        mediumView: mediumView,
        largeView: largeView,
        xLargeView: xLargeView,
        "data-id": "components_HouseTypeCarousel_HouseCardRow"
      }, HouseTypeCarousel_jsx(lib/* default */.ZP, {
        style: swipeView ? {
          padding: '0',
          overflow: 'visible',
          overflowX: 'visible'
        } : mediumView ? {
          width: '50%',
          overflow: 'visible',
          overflowX: 'visible'
        } : {
          width: '33.333%',
          overflow: 'visible',
          overflowX: 'visible'
        },
        onChangeIndex: this.handleChangeIndex,
        index: swipeIndex,
        slideStyle: swipeView ? {
          overflow: 'visible',
          overflowX: 'visible',
          padding: '0 5px',
          boxSizing: 'border-box'
        } : {
          overflow: 'visible',
          overflowX: 'visible',
          padding: '0 10px',
          boxSizing: 'border-box'
        },
        ignoreNativeScroll: true,
        "data-id": "components_HouseTypeCarousel_SwipeableViews"
      }, houseTypes && houseTypes.map(function (houseType, index) {
        return HouseTypeCarousel_jsx(HousCardWrapper, {
          key: index,
          "data-id": "components_HouseTypeCarousel_HousCardWrapper"
        }, _this2.renderHouseCardView(houseType));
      })), !swipeView && HouseTypeCarousel_jsx(HouseTypeCarousel_ArrowPrimaryNext, {
        key: "next",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: _this2.state.swipeIndex + 1
          });
        },
        disabled: !houseTypes || swipeIndex >= (mediumView ? houseTypes.length - 2 : houseTypes.length - 3),
        "data-id": "components_HouseTypeCarousel_ArrowPrimaryNext"
      }, HouseTypeCarousel_jsx(Caret/* default */.Z, {
        direction: "right",
        color: styleGuide/* colorPalette.white */.K5.white,
        "data-id": "components_HouseTypeCarousel_Caret"
      })), !swipeView && HouseTypeCarousel_jsx(HouseTypeCarousel_ArrowPrimaryPrev, {
        key: "prev",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex - 1
          });
        },
        disabled: !houseTypes || swipeIndex === 0,
        "data-id": "components_HouseTypeCarousel_ArrowPrimaryPrev"
      }, HouseTypeCarousel_jsx(Caret/* default */.Z, {
        direction: "left",
        color: styleGuide/* colorPalette.white */.K5.white,
        "data-id": "components_HouseTypeCarousel_Caret"
      })))), link && link !== null && HouseTypeCarousel_jsx(HouseTypeCarousel_ButtonWrapper, {
        "data-id": "components_HouseTypeCarousel_ButtonWrapper"
      }, HouseTypeCarousel_jsx(ButtonPrimary/* default */.Z, {
        label: label || '',
        link: '/' + (0,getLinkFromPageObject/* default */.Z)(link),
        type: "internalLink",
        "data-id": "components_HouseTypeCarousel_ButtonPrimary"
      })));
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var components_HouseTypeCarousel = ((0,withMatch/* default */.Z)(HouseTypeCarousel));
var HouseTypeCarousel_Title = styled_components_browser_esm["default"].h2(HouseTypeCarousel_templateObject || (HouseTypeCarousel_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var HouseTypeCarousel_Description = styled_components_browser_esm["default"].h2(HouseTypeCarousel_templateObject2 || (HouseTypeCarousel_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 35rem;\n  max-width: 780rem;\n"])));
var HousCardWrapper = styled_components_browser_esm["default"].div(HouseTypeCarousel_templateObject3 || (HouseTypeCarousel_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n"])));
var HouseTypeCarousel_HouseCardRow = styled_components_browser_esm["default"].div(HouseTypeCarousel_templateObject4 || (HouseTypeCarousel_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  margin-bottom: 40rem;\n  display: flex;\n  box-sizing: border-box;\n  flex-flow: row wrap;\n  position: relative;\n\n  > div {\n    width: 100%;\n  }\n\n  > div > div {\n    height: 100%;\n  }\n\n  > div > div > div {\n    height: 100%;\n    box-sizing: border-box;\n    transition: opacity 0.4s ease-in-out;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.mediumView ? "\n    width: calc(100% - 100rem);\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 815rem;\n\n    > div > div > div {\n      opacity: 0;\n      pointer-events: none;\n\n      &[aria-hidden=\"false\"], &[aria-hidden=\"false\"] + div {\n        pointer-events: auto;\n        opacity: 1;\n      }\n    }\n  " : '';
}, function (props) {
  return props.largeView ? "\n    width: calc(100% - 120rem);\n    margin-left: auto;\n    margin-right: auto;\n\n        > div > div > div {\n          opacity: 0;\n          pointer-events: none;\n\n          &[aria-hidden=\"false\"], &[aria-hidden=\"false\"] + div,  &[aria-hidden=\"false\"] + div + div {\n            pointer-events: auto;\n            opacity: 1;\n          }\n        }\n\n  " : '';
}, function (props) {
  return props.xLargeView ? "\n    width: calc(100% + 20rem);\n    left: -10rem;\n  " : '';
});
var HouseTypeCarousel_ArrowStyle = (0,styled_components_browser_esm.css)(HouseTypeCarousel_templateObject5 || (HouseTypeCarousel_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 45%;\n  transform: translateY(-50%);\n  z-index: 1;\n  opacity: 0.85;\n  background-color: ", ";\n  width: 40rem;\n  height: 40rem;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n  ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, function (props) {
  return props.disabled ? 'opacity: 0; pointer-events: none;' : ' &:hover { opacity: 1; } ';
});
var HouseTypeCarousel_ArrowPrimaryNext = styled_components_browser_esm["default"].button(HouseTypeCarousel_templateObject6 || (HouseTypeCarousel_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " right: -50rem;\n"])), HouseTypeCarousel_ArrowStyle);
var HouseTypeCarousel_ArrowPrimaryPrev = styled_components_browser_esm["default"].button(HouseTypeCarousel_templateObject7 || (HouseTypeCarousel_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " left: -50rem;\n"])), HouseTypeCarousel_ArrowStyle);
var HouseTypeCarousel_HouseTypeBlock = styled_components_browser_esm["default"].div(HouseTypeCarousel_templateObject8 || (HouseTypeCarousel_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n"])), function (props) {
  return props.largeView ? "\n    margin-bottom: 60rem;\n  " : "\n    margin-bottom: 40rem;\n  ";
});
var HouseTypeCarousel_ButtonWrapper = styled_components_browser_esm["default"].div(HouseTypeCarousel_templateObject9 || (HouseTypeCarousel_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: center;\n  > a {\n    padding-left: 30rem;\n    padding-right: 30rem;\n  }\n"])));
;// CONCATENATED MODULE: ./src/components/CTAPrimary.js


var CTAPrimary_templateObject, CTAPrimary_templateObject2, CTAPrimary_templateObject3, CTAPrimary_templateObject4, CTAPrimary_templateObject5, CTAPrimary_templateObject6, CTAPrimary_templateObject7, CTAPrimary_templateObject8, CTAPrimary_templateObject9, CTAPrimary_templateObject0, CTAPrimary_templateObject1, CTAPrimary_templateObject10;

var CTAPrimary_jsx = react.createElement;












var CTAPrimary_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};

var CTAPrimary_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleClick: function handleClick(evt, endpoint) {
      evt.preventDefault();
      dispatch((0,redux_modal/* hideModalLoader */.OF)());
      dispatch((0,redux_modal/* openModalWithLoader */.XV)(styleGuide/* colorPalette.beige */.K5.beige, endpoint));
      dispatch((0,redux_modal/* updateModalOpenState */.WU)(true));
    }
  };
};

var CTAPrimary = function CTAPrimary(_ref) {
  var title = _ref.title,
      content = _ref.content,
      date = _ref.date,
      match = _ref.match,
      formId = _ref.formId,
      styling = _ref.styling,
      handleClick = _ref.handleClick;
  var projectSlug = match.params.projectSlug;
  var _styling$formPrimaryT = styling.formPrimaryTriangle,
      formPrimaryTriangle = _styling$formPrimaryT === void 0 ? '#F8EA1B' : _styling$formPrimaryT,
      _styling$formPrimaryB = styling.formPrimaryBackground,
      formPrimaryBackground = _styling$formPrimaryB === void 0 ? styleGuide/* colorPalette.lightGreen */.K5.lightGreen : _styling$formPrimaryB,
      _styling$formPrimaryD = styling.formPrimaryDate,
      formPrimaryDate = _styling$formPrimaryD === void 0 ? styleGuide/* colorPalette.green */.K5.green : _styling$formPrimaryD,
      _styling$formPrimaryT2 = styling.formPrimaryText,
      formPrimaryText = _styling$formPrimaryT2 === void 0 ? styleGuide/* colorPalette.textGrey */.K5.textGrey : _styling$formPrimaryT2;
  return CTAPrimary_jsx(CTAWrapper, {
    onClick: function onClick(evt) {
      return handleClick(evt, {
        type: 'form',
        componentProps: {
          projectSlug: String(projectSlug),
          formId: formId
        }
      });
    },
    "data-e2e-block-ctaprimary": true,
    "data-id": "components_CTAPrimary_CTAWrapper"
  }, CTAPrimary_jsx(CTAWrapperInner, {
    bgColor: formPrimaryBackground,
    triangleColor: formPrimaryTriangle,
    textColor: formPrimaryText,
    "data-id": "components_CTAPrimary_CTAWrapperInner"
  }, CTAPrimary_jsx(CTAContent, {
    "data-id": "components_CTAPrimary_CTAContent"
  }, CTAPrimary_jsx(CTAContentHeader, {
    "data-id": "components_CTAPrimary_CTAContentHeader"
  }, CTAPrimary_jsx(CTADateIconContainer, {
    "data-id": "components_CTAPrimary_CTADateIconContainer"
  }, CTAPrimary_jsx(designElements_DateIcon, {
    date: date,
    textColor: formPrimaryDate,
    "data-id": "components_CTAPrimary_DateIcon"
  })), CTAPrimary_jsx(CTAPrimary_Header, {
    "data-id": "components_CTAPrimary_Header"
  }, title)), CTAPrimary_jsx(CTAPrimary_Content, {
    textColor: formPrimaryText,
    "data-id": "components_CTAPrimary_Content"
  }, content))));
};

/* harmony default export */ var components_CTAPrimary = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(CTAPrimary_mapStateToProps, CTAPrimary_mapDispatchToProps)(CTAPrimary)));
var CTAWrapper = styled_components_browser_esm["default"].div(CTAPrimary_templateObject || (CTAPrimary_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-sizing: border-box;\n  max-width: 1020rem;\n  width: 100%;\n  margin: 30rem auto;\n  padding-left: 0;\n  padding-right: 0;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(CTAPrimary_templateObject2 || (CTAPrimary_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 20rem;\n    padding-right: 20rem;\n    margin-bottom: 60rem;\n  "]))));
var CTAWrapperInner = styled_components_browser_esm["default"].div(CTAPrimary_templateObject3 || (CTAPrimary_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  max-width: 980rem;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  background: ", ";\n  border-radius: 10rem 0 10rem 0;\n  font-size: 20rem;\n  color: ", ";\n  box-shadow: 0 0 10rem 0 rgba(0, 0, 0, 0.16);\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: 0 0 10rem 0 rgba(0, 0, 0, 0.32);\n    transition: box-shadow 0.15s ease-in-out;\n\n    > div {\n      transition: background 0.15s ease-in-out;\n      background: rgba(0, 0, 0, 0.2);\n    }\n  }\n\n  &:before {\n    content: '';\n    display: block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: -10rem;\n    left: -10rem;\n    border-style: solid;\n    border-width: 142rem 142rem 0 0;\n    border-color: ", " transparent transparent\n      transparent;\n\n    ", ";\n  }\n"])), function (props) {
  return props.bgColor;
}, function (props) {
  return props.textColor;
}, function (props) {
  return (0,utils/* hex2rgb */.wK)(props.triangleColor, 0.65);
}, breakpoints/* fromBreakpoint.md */.ks.md(CTAPrimary_templateObject4 || (CTAPrimary_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: -20rem;\n      left: -20rem;\n      border-width: 166rem 166rem 0 0;\n    "]))));
var CTAContent = styled_components_browser_esm["default"].div(CTAPrimary_templateObject5 || (CTAPrimary_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  padding: 10rem 10rem 15rem 10rem;\n  border-radius: 10rem 0 10rem 0;\n  width: 100%;\n  text-align: left;\n  min-height: 110rem;\n  text-align: center;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(CTAPrimary_templateObject6 || (CTAPrimary_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 70rem;\n    padding: 30rem 100rem;\n  "]))));
var CTAContentHeader = styled_components_browser_esm["default"].div(CTAPrimary_templateObject7 || (CTAPrimary_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n"])));
var CTADateIconContainer = styled_components_browser_esm["default"].div(CTAPrimary_templateObject8 || (CTAPrimary_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  margin-right: 15rem;\n  margin-bottom: 15rem;\n  min-width: 50rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(CTAPrimary_templateObject9 || (CTAPrimary_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: absolute;\n    left: 20rem;\n    top: 15rem;\n    margin-right: 0;\n    margin-bottom: 0;\n  "]))));
var CTAPrimary_Header = styled_components_browser_esm["default"].h3(CTAPrimary_templateObject0 || (CTAPrimary_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " margin-top: 0;\n  margin-bottom: 15rem;\n  flex-basis: 20rem;\n  flex-grow: 2;\n"])), styleGuide/* textStyles.title */.sq.title);
var CTAPrimary_Content = styled_components_browser_esm["default"].p(CTAPrimary_templateObject1 || (CTAPrimary_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-bottom: 10rem;\n\n  ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, function (props) {
  return props.textColor;
}, breakpoints/* toBreakpoint.md */.Hx.md(CTAPrimary_templateObject10 || (CTAPrimary_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 65rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/CTASecondary.js


var CTASecondary_templateObject, CTASecondary_templateObject2, CTASecondary_templateObject3, CTASecondary_templateObject4, CTASecondary_templateObject5, CTASecondary_templateObject6, CTASecondary_templateObject7, CTASecondary_templateObject8;

var CTASecondary_jsx = react.createElement;














var CTASecondary_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};

var CTASecondary_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleClick: function handleClick(evt, endpoint) {
      evt.preventDefault();
      dispatch((0,redux_modal/* openModalWithLoader */.XV)(styleGuide/* colorPalette.beige */.K5.beige, endpoint));
    }
  };
};

var CTASecondary = function CTASecondary(_ref) {
  var renderWidth = _ref.renderWidth,
      match = _ref.match,
      content = _ref.content,
      title = _ref.title,
      formOneLabel = _ref.formOneLabel,
      formOneId = _ref.formOneId,
      formTwoLabel = _ref.formTwoLabel,
      formTwoId = _ref.formTwoId,
      comboMode = _ref.comboMode,
      image = _ref.image,
      styling = _ref.styling,
      handleClick = _ref.handleClick;
  var twoButtons = typeof formTwoId === 'number';
  var _styling$formSecondar = styling.formSecondaryBackground,
      formSecondaryBackground = _styling$formSecondar === void 0 ? styleGuide/* colorPalette.lightGreen */.K5.lightGreen : _styling$formSecondar,
      _styling$formSecondar2 = styling.formSecondaryText,
      formSecondaryText = _styling$formSecondar2 === void 0 ? styleGuide/* colorPalette.headerGrey */.K5.headerGrey : _styling$formSecondar2;
  var projectSlug = match.params.projectSlug;
  return CTASecondary_jsx(OuterView, {
    renderWidth: renderWidth,
    comboMode: comboMode,
    "data-e2e-block-ctasecondary": true,
    "data-id": "components_CTASecondary_OuterView"
  }, CTASecondary_jsx(ImageView, {
    renderWidth: renderWidth,
    comboMode: comboMode,
    "data-id": "components_CTASecondary_ImageView"
  }, CTASecondary_jsx(ImageLoader/* default */.Z, {
    width: 600,
    mode: "bg",
    src: image,
    "data-id": "components_CTASecondary_ImageLoader"
  })), CTASecondary_jsx(BalloonView, {
    renderWidth: renderWidth,
    comboMode: comboMode,
    "data-id": "components_CTASecondary_BalloonView"
  }, CTASecondary_jsx(Balloon, {
    renderWidth: renderWidth,
    bgColor: formSecondaryBackground,
    comboMode: comboMode,
    "data-id": "components_CTASecondary_Balloon"
  }, CTASecondary_jsx(CTASecondary_Title, {
    textColor: formSecondaryText === 'default' ? styleGuide/* colorPalette.headerGrey */.K5.headerGrey : 'white',
    "data-id": "components_CTASecondary_Title"
  }, title), CTASecondary_jsx(BodyText, {
    textColor: formSecondaryText,
    "data-id": "components_CTASecondary_BodyText"
  }, content), twoButtons ? CTASecondary_jsx(LinksView, {
    renderWidth: renderWidth,
    "data-id": "components_CTASecondary_LinksView"
  }, CTASecondary_jsx(ButtonSecondary/* default */.Z, {
    label: formOneLabel,
    color: formSecondaryText === 'default' ? styleGuide/* colorPalette.headerGrey */.K5.headerGrey : 'white',
    colorHover: (0,utils/* darken */._j)(formSecondaryBackground, 20),
    type: "button",
    clickHandler: function clickHandler(evt) {
      return handleClick(evt, {
        type: 'form',
        componentProps: {
          projectSlug: String(projectSlug),
          formId: formOneId
        }
      });
    },
    "data-id": "components_CTASecondary_ButtonSecondary"
  }), CTASecondary_jsx(ButtonSecondary/* default */.Z, {
    color: formSecondaryText === 'default' ? styleGuide/* colorPalette.headerGrey */.K5.headerGrey : 'white',
    colorHover: (0,utils/* darken */._j)(formSecondaryBackground, 20),
    type: "button",
    label: formTwoLabel || formOneLabel,
    clickHandler: function clickHandler(evt) {
      return handleClick(evt, {
        type: 'form',
        componentProps: {
          projectSlug: String(projectSlug),
          formId: Number(formTwoId)
        }
      });
    },
    "data-id": "components_CTASecondary_ButtonSecondary_9"
  })) : CTASecondary_jsx(ButtonPrimary/* default */.Z, {
    type: "button",
    color: "white",
    labelColor: formSecondaryBackground,
    buttonHoverColor: (0,utils/* darken */._j)(formSecondaryBackground, 20),
    labelHoverColor: "white",
    label: formOneLabel,
    clickHandler: function clickHandler(evt) {
      return handleClick(evt, {
        type: 'form',
        componentProps: {
          projectSlug: String(projectSlug),
          formId: formOneId
        }
      });
    },
    "data-id": "components_CTASecondary_ButtonPrimary"
  }))));
};

/* harmony default export */ var components_CTASecondary = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(CTASecondary_mapStateToProps, CTASecondary_mapDispatchToProps)(CTASecondary)));
var OuterView = styled_components_browser_esm["default"].aside(CTASecondary_templateObject || (CTASecondary_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  flex-direction: ", ";\n  margin-bottom: 50rem;\n\n  ", ";\n"])), function (props) {
  return props.comboMode ? 'column' : props.renderWidth > breakpoints/* breakpointSizes.md */.YA.md ? 'row' : 'column';
}, breakpoints/* fromBreakpoint.md */.ks.md(CTASecondary_templateObject2 || (CTASecondary_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 60rem;\n  "]))));
var ImageView = styled_components_browser_esm["default"].div(CTASecondary_templateObject3 || (CTASecondary_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: ", ";\n\n  ", ";\n\n  ", ";\n\n  > div {\n    min-height: 200rem;\n  }\n"])), function (props) {
  return props.renderWidth < 800 && props.comboMode ? '200px' : 'unset';
}, function (props) {
  return props.renderWidth > breakpoints/* breakpointSizes.md */.YA.md ? "\n    flex: 3;\n  " : "\n    height: 250rem;\n  ";
}, function (props) {
  return props.comboMode ? "\n    max-height: 250rem;\n    height: 100%;" : '';
});
var BalloonView = styled_components_browser_esm["default"].div(CTASecondary_templateObject4 || (CTASecondary_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  height: 100%;\n  z-index: 2;\n  margin-top: ", ";\n"])), function (props) {
  return props.renderWidth > breakpoints/* breakpointSizes.md */.YA.md ? 'flex: 5;' : '';
}, function (props) {
  return props.comboMode ? '-16rem' : '0';
});
var Balloon = styled_components_browser_esm["default"].div(CTASecondary_templateObject5 || (CTASecondary_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  padding-bottom: 30rem;\n  position: relative;\n  height: 100%;\n  box-sizing: border-box;\n\n  &:after{\n    content: '';\n    display: block;\n    width: ", ";\n    height: ", ";\n    position: absolute;\n    z-index: 1;\n    top: ", ";\n    left: ", ";\n    border-radius: 10rem 0 0 0;\n    background: ", ";\n  }\n\n  &:before {\n    content: '';\n    display: block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    z-index: 2;\n    border: 16rem solid transparent;\n    ", ";\n"])), function (props) {
  return props.bgColor;
}, function (props) {
  return props.renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? '0 0 10rem 0' : '0 0 10rem 0';
}, function (props) {
  return props.renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? '10rem 20rem 20rem 20rem' : '20rem';
}, function (props) {
  return props.renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? '100%' : '10rem';
}, function (props) {
  return props.renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? '10rem' : '100%';
}, function (props) {
  return props.renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? '-9rem' : '0';
}, function (props) {
  return props.renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? '0' : '-9rem';
}, function (props) {
  return props.bgColor;
}, function (props) {
  return props.comboMode || props.renderWidth < breakpoints/* breakpointSizes.md */.YA.md ? "\n        border-bottom-color: ".concat(props.bgColor, ";\n        border-top: none;\n        top: -16rem;\n        right: 80rem;\n    ") : "\n      border-right-color: ".concat(props.bgColor, ";\n      border-left: none;\n      left: -25rem;\n      top: 55rem;\n    ");
});
var CTASecondary_Title = styled_components_browser_esm["default"].h3(CTASecondary_templateObject6 || (CTASecondary_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-top: 0;\n  color: ", ";\n"])), styleGuide/* textStyles.title */.sq.title, function (props) {
  return props.textColor;
});
var BodyText = styled_components_browser_esm["default"].p(CTASecondary_templateObject7 || (CTASecondary_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, function (props) {
  return props.textColor;
});
var LinksView = styled_components_browser_esm["default"].div(CTASecondary_templateObject8 || (CTASecondary_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: flex-start;\n\n  > button {\n    &:nth-of-type(1) {\n      margin-right: 20px;\n    }\n  }\n"])), function (props) {
  return props.renderWidth > breakpoints/* breakpointSizes.md */.YA.md ? 'row' : 'column';
});
;// CONCATENATED MODULE: ./src/components/ComboBlock.js



var ComboBlock_templateObject, ComboBlock_templateObject2, ComboBlock_templateObject3;

var ComboBlock_jsx = react.createElement;





var ComboBlock = function ComboBlock(_ref) {
  var blocks = _ref.blocks,
      renderWidth = _ref.renderWidth;
  var mediumView = renderWidth >= 800 && renderWidth < 1080;
  var largeView = renderWidth >= 1080;
  return ComboBlock_jsx(ComboWrapper, {
    largeView: largeView,
    "data-e2e-block-comboblock": true,
    "data-id": "components_ComboBlock_ComboWrapper"
  }, ComboBlock_jsx(SizeTwoColumn, {
    mediumView: mediumView,
    largeView: largeView,
    "data-id": "components_ComboBlock_SizeTwoColumn"
  }, ComboBlock_jsx(components_StorySlider, (0,esm_extends/* default */.Z)({}, blocks[0], {
    "data-id": "components_ComboBlock_StorySlider"
  }))), ComboBlock_jsx(SizeOneColumn, {
    mediumView: mediumView,
    largeView: largeView,
    "data-id": "components_ComboBlock_SizeOneColumn"
  }, ComboBlock_jsx(components_CTASecondary, (0,esm_extends/* default */.Z)({
    comboMode: true,
    renderWidth: renderWidth
  }, blocks[1], {
    "data-id": "components_ComboBlock_CTASecondary"
  }))));
};

/* harmony default export */ var components_ComboBlock = (ComboBlock);
var ComboWrapper = styled_components_browser_esm["default"].div(ComboBlock_templateObject || (ComboBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  margin-bottom: 50rem;\n  justify-content: space-between;\n  display: flex;\n  ", ";\n"])), function (props) {
  return !props.largeView ? "flex-wrap: wrap;" : '';
});
var SizeTwoColumn = styled_components_browser_esm["default"].div(ComboBlock_templateObject2 || (ComboBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  margin-bottom: 60rem;\n\n  > div {\n    padding: 0;\n  }\n\n  ", " ", ";\n"])), function (props) {
  return props.mediumView ? "width: calc((1/2 * 100%) - 10rem);\n      margin-bottom: 0rem;\n    " : '';
}, function (props) {
  return props.largeView ? "width: calc((2/3 * 100%) - 10rem);\n    margin-bottom: 0rem;\n    " : '';
});
var SizeOneColumn = styled_components_browser_esm["default"].div(ComboBlock_templateObject3 || (ComboBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n\n  ", " ", "\n\n  > *, > * > * {\n    height: 100%;\n  }\n"])), function (props) {
  return props.mediumView ? "width: calc((1/2 * 100%) - 10rem);" : '';
}, function (props) {
  return props.largeView ? "width: calc((1/3 * 100%) - 10rem);" : '';
});
;// CONCATENATED MODULE: ./src/processes/getRedirectUrl.ts
var getRedirectUrl = function getRedirectUrl() {
  var url = window.location.href;
  var parsedUrl = new URL(url);
  return parsedUrl.searchParams.get('redirectUrl');
};
;// CONCATENATED MODULE: ./src/hocs/withMutationRequest.tsx


function withMutationRequest_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function withMutationRequest_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? withMutationRequest_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : withMutationRequest_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var withMutationRequest = function withMutationRequest(WrappedComponent, endpointKey, mutationKey, options) {
  return function (props) {
    var mutation = (0,requestHooks/* useMutationRequest */.iO)(endpointKey, mutationKey, options);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrappedComponent, withMutationRequest_objectSpread(withMutationRequest_objectSpread({}, props), {}, {
      mutation: mutation,
      "data-id": "hocs_withMutationRequest_WrappedComponent"
    }));
  };
};

/* harmony default export */ var hocs_withMutationRequest = (withMutationRequest);
;// CONCATENATED MODULE: ./src/components/LoginForm.js








var LoginForm_templateObject, LoginForm_templateObject2, LoginForm_templateObject3, LoginForm_templateObject4, LoginForm_templateObject5, LoginForm_templateObject6, LoginForm_templateObject7, LoginForm_templateObject8, LoginForm_templateObject9, LoginForm_templateObject0;

var LoginForm_jsx = react.createElement;

function LoginForm_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, LoginForm_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function LoginForm_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (LoginForm_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function LoginForm_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function LoginForm_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? LoginForm_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : LoginForm_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}
/* eslint-disable no-useless-computed-key */















var LoginForm_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env;
  return {
    facebookLoginUrl: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'facebookLoginUrl', undefined),
    signUpRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'signupUser', {
      projectSlug: String(projectSlug)
    })
  };
};

var LoginForm_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    onSignup: function onSignup(loginValues) {
      dispatch((0,apiData/* performApiRequest */.T4)('signupUser', {
        projectSlug: String(projectSlug)
      }, LoginForm_objectSpread({}, loginValues)));
    },
    redirectToLoggedIn: function redirectToLoggedIn(redirectUrl) {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getSettings', {
        projectSlug: String(projectSlug),
        env: 'closed'
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getPage', {
        pagePath: String(projectSlug) + '/closed'
      }));
      window.location.href = redirectUrl;
    },
    handleClick: function handleClick(evt, object) {
      evt.preventDefault();
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.beige */.K5.beige, object));
    }
  };
};

var LoginForm = /*#__PURE__*/function (_Component) {
  function LoginForm() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, LoginForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = LoginForm_callSuper(this, LoginForm, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      register: false,
      type: 'password',
      error: '',
      loading: false
    });

    (0,defineProperty/* default */.Z)(_this, "handleSubmit", function (_ref) {
      var email = _ref.email,
          name = _ref.name,
          password = _ref.password,
          _remember_me = _ref._remember_me;
      var _this$props = _this.props,
          onSignup = _this$props.onSignup,
          mutation = _this$props.mutation;
      var register = _this.state.register;
      var redirectUrl = getRedirectUrl();

      _this.setState({
        loading: true
      }, function () {
        if (register) {
          onSignup({
            name: name,
            email: email,
            plainPassword: password,
            privacyCheck: true
          });
        } else {
          mutation.mutate({
            body: {
              email: email,
              password: password,
              _remember_me: _remember_me
            },
            params: {
              redirectUrl: redirectUrl
            }
          });
        }
      });
    });

    (0,defineProperty/* default */.Z)(_this, "toggleForm", function () {
      _this.setState({
        register: !_this.state.register,
        error: ''
      });
    });

    (0,defineProperty/* default */.Z)(_this, "togglePassword", function () {
      _this.setState({
        type: _this.state.type === 'password' ? 'text' : 'password'
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(LoginForm, _Component);

  return (0,createClass/* default */.Z)(LoginForm, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
          signUpRequest = _this$props2.signUpRequest,
          redirectToLoggedIn = _this$props2.redirectToLoggedIn,
          mutation = _this$props2.mutation,
          match = _this$props2.match;
      var register = this.state.register;

      if (mutation.isSuccess || signUpRequest && signUpRequest.networkStatus === 'success') {
        var _mutation$data;

        if (!!((_mutation$data = mutation.data) !== null && _mutation$data !== void 0 && _mutation$data.redirectUrl)) {
          redirectToLoggedIn(mutation.data.redirectUrl);
          return;
        }

        redirectToLoggedIn("/".concat(String(match.params.projectSlug), "/closed"));
        return;
      }

      if ((mutation.isError || signUpRequest && signUpRequest.networkStatus === 'failed') && this.state.loading) {
        var _mutation$error;

        var error = register ? lodash_get_default()(signUpRequest, 'errorBody.message') : (_mutation$error = mutation.error) === null || _mutation$error === void 0 || (_mutation$error = _mutation$error.data) === null || _mutation$error === void 0 ? void 0 : _mutation$error.message;

        if (error === 'Email-address/password combination not found') {
          error = 'Combinatie van e-mailadres en wachtwoord is niet correct.';
        }

        this.setState({
          error: error,
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          match = _this$props3.match,
          handleClick = _this$props3.handleClick;
      var _this$state = this.state,
          type = _this$state.type,
          loading = _this$state.loading,
          register = _this$state.register,
          error = _this$state.error;
      var loginForm = [{
        options: [{
          id: 'email',
          name: 'email',
          label: 'E-mailadres',
          required: true,
          title: 'E-mailadres',
          type: 'email'
        }, {
          id: 'password',
          name: 'password',
          label: 'Wachtwoord',
          required: true,
          title: 'Wachtwoord',
          type: type,
          toggle: true
        }, {
          id: '_remember_me',
          name: '_remember_me',
          label: 'Onthoud mij',
          required: false,
          title: '',
          type: 'checkbox',
          choices: [{
            key: '_remember_me',
            value: 'Onthoud mij',
            defaultChecked: true
          }],
          excludeFromSubmit: true
        }]
      }];
      var registerForm = [{
        options: [{
          id: 'name',
          name: 'name',
          label: 'Aanspreeknaam',
          required: true,
          title: 'Aanspreeknaam',
          type: 'text'
        }, {
          id: 'email',
          name: 'email',
          label: 'E-mailadres',
          required: true,
          title: 'E-mailadres',
          type: 'email'
        }, {
          id: 'email_double',
          name: 'email_double',
          doubleFor: 'email',
          label: 'Herhaal e-mailadres',
          required: true,
          title: 'Herhaal e-mailadres',
          type: 'email',
          validationMessage: 'De e-mailadressen die je hebt ingevuld, komen niet overeen'
        }, {
          id: 'password',
          name: 'password',
          label: 'Wachtwoord',
          required: true,
          title: 'Wachtwoord',
          type: type,
          toggle: true,
          help: 'Gebruik acht of meer tekens met een combinatie van letters, cijfers en symbolen'
        }, {
          id: 'privacy',
          type: 'readOnly',
          title: 'privacy-note',
          name: 'Privacy beleid',
          label: '[p]We gebruiken de gegevens die je achterlaat om onze producten en diensten steeds beter te maken en jouw gebruikerservaring zo goed mogelijk af te stemmen op jouw profiel. In ons [pagenode="0" type="link"]privacybeleid[/pagenode] lees je precies hoe we omgaan met de door jou opgegeven informatie.[/p]',
          pages: (0,defineProperty/* default */.Z)({}, 0, {
            env: 'open',
            projectSlug: String(match.params.projectSlug),
            menuSlug: 'sectionpage',
            pageSlug: 'privacy-statement'
          }),
          excludeFromSubmit: true
        }, {
          id: 'privacyCheck',
          name: 'privacyCheck',
          label: 'Ik ga akkoord met het privacybeleid',
          validationMessage: 'Je bent nog niet akkoord gegaan met het privacy statement',
          required: true,
          title: '',
          type: 'checkbox',
          choices: [{
            key: 'privacyCheck',
            value: 'Ik ga akkoord met het privacybeleid',
            defaultChecked: false
          }]
        }]
      }];
      return LoginForm_jsx(LoginForm_Form, {
        loading: loading,
        "data-id": "components_LoginForm_Form"
      }, LoginForm_jsx(FormTitle, {
        "data-id": "components_LoginForm_FormTitle"
      }, register ? 'Maak een account aan' : 'Log in met je account'), LoginForm_jsx(FormIntro, {
        "data-id": "components_LoginForm_FormIntro"
      }, register ? 'Heb je al een account?' : 'Heb je nog geen account?', LoginForm_jsx("span", {
        "data-e2e-login-form-toggle": true,
        onClick: this.toggleForm,
        "data-id": "components_LoginForm_span"
      }, register ? 'Log dan in' : 'Maak een account aan')), error && LoginForm_jsx(LoginForm_FormError, {
        "data-id": "components_LoginForm_FormError"
      }, error), LoginForm_jsx(FormFields, {
        "data-id": "components_LoginForm_FormFields"
      }, LoginForm_jsx(FormGenerator/* default */.Z, {
        fields: register ? registerForm : loginForm,
        submitLabel: register ? 'Aanmelden' : 'Inloggen',
        loadingLabel: "aanvraag wordt verwerkt",
        submitFn: this.handleSubmit,
        loading: loading,
        togglePassword: this.togglePassword,
        "data-id": "components_LoginForm_FormGenerator"
      })), LoginForm_jsx(FormFooter, {
        "data-id": "components_LoginForm_FormFooter"
      }, !register && LoginForm_jsx(Span, {
        onClick: function onClick(evt) {
          return handleClick(evt, {
            type: 'password',
            componentProps: {
              changePassword: false
            }
          });
        },
        "data-id": "components_LoginForm_Span"
      }, "Wachtwoord vergeten?")));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_LoginForm = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(LoginForm_mapStateToProps, LoginForm_mapDispatchToProps)(hocs_withMutationRequest(LoginForm, 'postLogin'))));
var LoginForm_Form = styled_components_browser_esm["default"].div(LoginForm_templateObject || (LoginForm_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  opacity: ", ";\n  transition: opacity 0.25s ease-in-out;\n"])), function (props) {
  return props.loading ? '0.5' : '1';
});
var FormFields = styled_components_browser_esm["default"].div(LoginForm_templateObject2 || (LoginForm_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n\n  .formfield_privacyCheck {\n    margin-top: -40rem;\n    margin-bottom: 50rem;\n  }\n  .formfield_privacy {\n    > div > p {\n      color: ", ";\n      margin-top: 10rem;\n    }\n  }\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var LoginForm_FormError = styled_components_browser_esm["default"].div(LoginForm_templateObject3 || (LoginForm_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  padding: 20rem;\n  justify-content: center;\n  border: solid 1px #eee;\n  border-radius: 5rem;\n  background: ", ";\n  font-family: ", ";\n  color: red;\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, styleGuide/* fonts.primary */.Rq.primary);
var Span = styled_components_browser_esm["default"].div(LoginForm_templateObject4 || (LoginForm_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " font-weight: normal;\n  font-style: italic;\n  color: ", ";\n  margin-bottom: 40rem;\n  cursor: pointer;\n  width: fit-content;\n\n  ", ";\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.blue */.K5.blue, breakpoints/* toBreakpoint.md */.Hx.md(LoginForm_templateObject5 || (LoginForm_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 32rem;\n  "]))));
var FormFooter = styled_components_browser_esm["default"].div(LoginForm_templateObject6 || (LoginForm_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-top: 30rem;\n  margin-bottom: 40rem;\n  color: ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* toBreakpoint.md */.Hx.md(LoginForm_templateObject7 || (LoginForm_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 12rem;\n    margin-top: 28rem;\n    margin-bottom: 32rem;\n  "]))));
var FormTitle = styled_components_browser_esm["default"].h2(LoginForm_templateObject8 || (LoginForm_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-top: 60rem;\n\n  ", "\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* toBreakpoint.md */.Hx.md(LoginForm_templateObject9 || (LoginForm_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 30rem;\n  "]))));
var FormIntro = styled_components_browser_esm["default"].div(LoginForm_templateObject0 || (LoginForm_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " font-weight: normal;\n  font-style: italic;\n  color: ", ";\n  margin-bottom: 25rem;\n  margin-top: -15rem;\n\n  > span {\n    color: ", ";\n    cursor: pointer;\n    margin-left: 5rem;\n    border-bottom: 1rem solid transparent;\n    transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n    &:hover {\n      color: ", ";\n      border-bottom: 1rem solid ", ";\n    }\n  }\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* colorPalette.blue */.K5.blue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue);
;// CONCATENATED MODULE: ./src/components/LoginBlock.js


var LoginBlock_templateObject;

var LoginBlock_jsx = react.createElement;






var LoginBlock = function LoginBlock() {
  return LoginBlock_jsx(LoginBlock_FormContainer, {
    "data-e2e-block-login": true,
    "data-id": "components_LoginBlock_FormContainer"
  }, LoginBlock_jsx(components_LoginForm, {
    "data-id": "components_LoginBlock_LoginForm"
  }));
};

/* harmony default export */ var components_LoginBlock = (LoginBlock);
var LoginBlock_FormContainer = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LoginBlock_templateObject || (LoginBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  padding-left: 20rem;\n  padding-right: 20rem;\n  background-color: #fff;\n  ", ";\n\n  > div {\n    max-width: 778rem;\n  }\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary);
;// CONCATENATED MODULE: ./src/components/ContactBlock.js


var ContactBlock_templateObject, ContactBlock_templateObject2, ContactBlock_templateObject3, ContactBlock_templateObject4, ContactBlock_templateObject5, ContactBlock_templateObject6, ContactBlock_templateObject7, ContactBlock_templateObject8, ContactBlock_templateObject9, ContactBlock_templateObject0, ContactBlock_templateObject1, ContactBlock_templateObject10, ContactBlock_templateObject11, ContactBlock_templateObject12, ContactBlock_templateObject13, ContactBlock_templateObject14, ContactBlock_templateObject15, ContactBlock_templateObject16, ContactBlock_templateObject17, ContactBlock_templateObject18, ContactBlock_templateObject19, ContactBlock_templateObject20, _templateObject21, _templateObject22, _templateObject23;

var ContactBlock_jsx = react.createElement;












var ContactBlock_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};

var ContactBlock = function ContactBlock(_ref) {
  var title = _ref.title,
      description = _ref.description,
      companies = _ref.companies,
      styling = _ref.styling,
      professionals = _ref.professionals;
  return ContactBlock_jsx(Block, {
    "data-e2e-block-contactblock": true,
    "data-id": "components_ContactBlock_Block"
  }, ContactBlock_jsx(ContactBlock_TextContainer, {
    "data-id": "components_ContactBlock_TextContainer"
  }, ContactBlock_jsx(ContactBlock_Title, {
    "data-id": "components_ContactBlock_Title"
  }, title), ContactBlock_jsx(ContactBlock_SubTitle, {
    "data-id": "components_ContactBlock_SubTitle"
  }, description)), companies && companies.map(function (company, index) {
    return ContactBlock_jsx(ContactBlock_DetailsBlock, {
      key: index,
      "data-id": "components_ContactBlock_DetailsBlock"
    }, ContactBlock_jsx(ContactBlock_Details, {
      "data-id": "components_ContactBlock_Details"
    }, ContactBlock_jsx(Name, {
      "data-id": "components_ContactBlock_Name"
    }, company.name), ContactBlock_jsx(Address, {
      "data-id": "components_ContactBlock_Address"
    }, ContactBlock_jsx("span", {
      "data-id": "components_ContactBlock_span"
    }, company.address), ContactBlock_jsx("span", {
      "data-id": "components_ContactBlock_span_9"
    }, company.zipcode, " ", company.city)), ContactBlock_jsx(Contact, {
      "data-id": "components_ContactBlock_Contact"
    }, company.phone1 && ContactBlock_jsx(NumberLink, {
      "aria-label": company.phone1,
      href: "tel:".concat(company.phone1),
      "data-id": "components_ContactBlock_NumberLink"
    }, company.phone1), company.phone2 && ContactBlock_jsx(NumberLink, {
      "aria-label": company.phone1,
      href: "tel:".concat(company.phone2),
      "data-id": "components_ContactBlock_NumberLink_12"
    }, company.phone2), ContactBlock_jsx(ContactBlock_Link, {
      color: styling && styling.button,
      "aria-label": company.email,
      href: "mailto:".concat(company.email),
      "data-id": "components_ContactBlock_Link"
    }, company.email), ContactBlock_jsx(ContactBlock_Link, {
      color: styling && styling.button,
      "aria-label": company.url,
      href: company.url,
      target: "_blank",
      rel: "noopener noreferrer",
      "data-id": "components_ContactBlock_Link_14"
    }, company.url)), company.image && ContactBlock_jsx(ContactBlock_Logo, {
      "data-id": "components_ContactBlock_Logo"
    }, ContactBlock_jsx(ImageLoader/* default */.Z, {
      src: company.image,
      alt: company.name,
      mode: "img",
      "data-id": "components_ContactBlock_ImageLoader"
    }))), ContactBlock_jsx(Photos, {
      "data-id": "components_ContactBlock_Photos"
    }, company.professionals && company.professionals.sort(function (a, b) {
      return a.name.toLowerCase() !== b.name.toLowerCase() ? a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1 : 0;
    }).map(function (professional, index1) {
      return ContactBlock_jsx(Person, {
        key: index1,
        "data-id": "components_ContactBlock_Person"
      }, ContactBlock_jsx(UserAvatar/* default */.Z, {
        mode: "imageLoader",
        size: "large",
        name: professional.name,
        imageUrl: professional.image,
        "data-id": "components_ContactBlock_UserAvatar"
      }), ContactBlock_jsx(User, {
        "data-id": "components_ContactBlock_User"
      }, professional.name));
    })));
  }), professionals && professionals.sort(function (a, b) {
    return a.name.toLowerCase() !== b.name.toLowerCase() ? a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1 : 0;
  }).map(function (professional, index) {
    return ContactBlock_jsx(ContactBlock_DetailsBlock, {
      key: index,
      "data-id": "components_ContactBlock_DetailsBlock"
    }, ContactBlock_jsx(Person, {
      "data-id": "components_ContactBlock_Person"
    }, ContactBlock_jsx(UserAvatar/* default */.Z, {
      mode: "imageLoader",
      size: "large",
      name: professional.name,
      imageUrl: professional.image,
      "data-id": "components_ContactBlock_UserAvatar"
    }), ContactBlock_jsx(User, {
      "data-id": "components_ContactBlock_User"
    }, professional.name)));
  }));
};

/* harmony default export */ var components_ContactBlock = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(ContactBlock_mapStateToProps)(ContactBlock)));
var Block = styled_components_browser_esm["default"].div(ContactBlock_templateObject || (ContactBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: #fff;\n  padding: 40rem 18rem 0 15rem;\n  margin-bottom: 50rem;\n\n  ", "\n\n  ", "\n  ", "\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ContactBlock_templateObject2 || (ContactBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 73rem 0 73rem;\n    margin-bottom: 60rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ContactBlock_templateObject3 || (ContactBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 125rem 0 42rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(ContactBlock_templateObject4 || (ContactBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 150rem 0 129rem;\n  "]))));
var ContactBlock_Title = styled_components_browser_esm["default"].h3(ContactBlock_templateObject5 || (ContactBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 8rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ContactBlock_SubTitle = styled_components_browser_esm["default"].div(ContactBlock_templateObject6 || (ContactBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ContactBlock_TextContainer = styled_components_browser_esm["default"].div(ContactBlock_templateObject7 || (ContactBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 782rem;\n"])));
var ContactBlock_DetailsBlock = styled_components_browser_esm["default"].div(ContactBlock_templateObject8 || (ContactBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top: 1px dashed ", ";\n  margin-top: 40rem;\n  padding-top: 20rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, breakpoints/* toBreakpoint.sm */.Hx.sm(ContactBlock_templateObject9 || (ContactBlock_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 28rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(ContactBlock_templateObject0 || (ContactBlock_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: column;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ContactBlock_templateObject1 || (ContactBlock_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 82rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(ContactBlock_templateObject10 || (ContactBlock_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 200rem;\n  "]))));
var ContactBlock_Details = styled_components_browser_esm["default"].div(ContactBlock_templateObject11 || (ContactBlock_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var Name = styled_components_browser_esm["default"].div(ContactBlock_templateObject12 || (ContactBlock_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " margin-bottom: 8rem;\n"])), styleGuide/* textStyles.title */.sq.title);
var Address = styled_components_browser_esm["default"].div(ContactBlock_templateObject13 || (ContactBlock_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20rem;\n  ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText);
var Contact = styled_components_browser_esm["default"].div(ContactBlock_templateObject14 || (ContactBlock_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " display: flex;\n  flex-direction: column;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText);
var ContactBlock_Link = styled_components_browser_esm["default"].a(ContactBlock_templateObject15 || (ContactBlock_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-self: flex-start;\n  margin-bottom: 5rem;\n  text-decoration: none;\n  color: ", ";\n  border-bottom: 1rem solid transparent;\n  transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n  &:hover {\n    color: ", ";\n    border-bottom: 1rem solid\n      ", ";\n  }\n"])), function (props) {
  return props.color ? props.color : styleGuide/* colorPalette.blue */.K5.blue;
}, function (props) {
  return props.color ? (0,utils/* darken */._j)(props.color, 15) : styleGuide/* colorPalette.darkBlue */.K5.darkBlue;
}, function (props) {
  return props.color ? (0,utils/* darken */._j)(props.color, 15) : styleGuide/* colorPalette.darkBlue */.K5.darkBlue;
});
var NumberLink = styled_components_browser_esm["default"].a(ContactBlock_templateObject16 || (ContactBlock_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  display: inline-block;\n  text-decoration: none;\n  margin-bottom: 5rem;\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ContactBlock_Logo = styled_components_browser_esm["default"].div(ContactBlock_templateObject17 || (ContactBlock_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 150rem;\n  max-height: 100rem;\n  margin-top: 40rem;\n  margin-bottom: 30rem;\n\n  ", ";\n\n  > div {\n    max-width: 150rem;\n    max-height: 100rem;\n  }\n"])), breakpoints/* toBreakpoint.sm */.Hx.sm(ContactBlock_templateObject18 || (ContactBlock_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 20rem;\n  "]))));
var Photos = styled_components_browser_esm["default"].div(ContactBlock_templateObject19 || (ContactBlock_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-wrap: wrap;\n  width: 280rem;\n  padding: 0 20rem;\n  justify-content: space-between;\n\n  ", ";\n"])), breakpoints/* toBreakpoint.md */.Hx.md(ContactBlock_templateObject20 || (ContactBlock_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0;\n  "]))));
var Person = styled_components_browser_esm["default"].div(_templateObject21 || (_templateObject21 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 30rem;\n  max-width: 110rem;\n"])));
var User = styled_components_browser_esm["default"].div(_templateObject22 || (_templateObject22 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 4rem;\n  text-align: center;\n  ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* toBreakpoint.sm */.Hx.sm(_templateObject23 || (_templateObject23 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 12rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/ContactExpert.js


var ContactExpert_templateObject, ContactExpert_templateObject2, ContactExpert_templateObject3, ContactExpert_templateObject4, ContactExpert_templateObject5, ContactExpert_templateObject6, ContactExpert_templateObject7, ContactExpert_templateObject8, ContactExpert_templateObject9, ContactExpert_templateObject0, ContactExpert_templateObject1, ContactExpert_templateObject10, ContactExpert_templateObject11, ContactExpert_templateObject12, ContactExpert_templateObject13, ContactExpert_templateObject14, ContactExpert_templateObject15, ContactExpert_templateObject16, ContactExpert_templateObject17, ContactExpert_templateObject18, ContactExpert_templateObject19, ContactExpert_templateObject20;

var ContactExpert_jsx = react.createElement;








var ContactExpert = function ContactExpert(_ref) {
  var isLastItem = _ref.isLastItem,
      title = _ref.title,
      description = _ref.description,
      _ref$professionals = _ref.professionals,
      professionals = _ref$professionals === void 0 ? [] : _ref$professionals;
  return ContactExpert_jsx(ContactExpert_Block, {
    isLastItem: isLastItem,
    "data-e2e-block-contactexpert": true,
    "data-id": "components_ContactExpert_Block"
  }, ContactExpert_jsx(ContactExpert_TextContainer, {
    isLastItem: isLastItem,
    "data-id": "components_ContactExpert_TextContainer"
  }, ContactExpert_jsx(ContactExpert_Title, {
    "data-id": "components_ContactExpert_Title"
  }, title), ContactExpert_jsx(ContactExpert_SubTitle, {
    "data-id": "components_ContactExpert_SubTitle"
  }, description)), ContactExpert_jsx(ContactExpert_DetailsBlock, {
    "data-id": "components_ContactExpert_DetailsBlock"
  }, professionals.map(function (expert, index) {
    return ContactExpert_jsx(Expert, {
      key: index,
      "data-id": "components_ContactExpert_Expert"
    }, ContactExpert_jsx(UserAvatar/* default */.Z, {
      mode: "imageLoader",
      size: "large",
      name: expert.name,
      imageUrl: expert.image,
      "data-id": "components_ContactExpert_UserAvatar"
    }), ContactExpert_jsx(ExpertInfo, {
      "data-id": "components_ContactExpert_ExpertInfo"
    }, expert.functionTitle && ContactExpert_jsx(ExpertTitle, {
      "data-id": "components_ContactExpert_ExpertTitle"
    }, expert.functionTitle), expert.name && ContactExpert_jsx(ExpertName, {
      "data-id": "components_ContactExpert_ExpertName"
    }, expert.name), expert.mobile && ContactExpert_jsx(ExpertPhone, {
      href: "tel:".concat(expert.mobile),
      "data-id": "components_ContactExpert_ExpertPhone"
    }, expert.mobile), expert.phone && ContactExpert_jsx(ExpertPhone, {
      href: "tel:".concat(expert.phone),
      "data-id": "components_ContactExpert_ExpertPhone_11"
    }, expert.phone), expert.link && ContactExpert_jsx(ContactExpert_ButtonWrapper, {
      "data-id": "components_ContactExpert_ButtonWrapper"
    }, ContactExpert_jsx(ButtonSecondary/* default */.Z, {
      type: "internalLink",
      route: '/' + (0,getLinkFromPageObject/* default */.Z)(expert.link),
      color: styleGuide/* colorPalette.blue */.K5.blue,
      label: "Stuur bericht",
      "data-id": "components_ContactExpert_ButtonSecondary"
    }))));
  })));
};

var ContactExpert_DetailsBlock = styled_components_browser_esm["default"].div(ContactExpert_templateObject || (ContactExpert_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  border-top: 1rem dashed ", ";\n  margin-top: 40rem;\n  padding-top: 20rem;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, breakpoints/* fromBreakpoint.md */.ks.md(ContactExpert_templateObject2 || (ContactExpert_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 40rem;\n    flex-wrap: wrap;\n    flex-direction: row;\n    justify-content: space-between;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ContactExpert_templateObject3 || (ContactExpert_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 0 80rem;\n    width: calc(100% - 160rem);\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(ContactExpert_templateObject4 || (ContactExpert_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 0 200rem;\n    width: calc(100% - 400rem);\n  "]))));
var ExpertInfo = styled_components_browser_esm["default"].div(ContactExpert_templateObject5 || (ContactExpert_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-left: 20rem;\n\n  ", "\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* fromBreakpoint.md */.ks.md(ContactExpert_templateObject6 || (ContactExpert_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: flex;\n    flex-direction: column;\n  "]))));
var ExpertPhone = styled_components_browser_esm["default"].a(ContactExpert_templateObject7 || (ContactExpert_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  text-decoration: none;\n  display: block;\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ExpertTitle = styled_components_browser_esm["default"].h3(ContactExpert_templateObject8 || (ContactExpert_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " font-weight: bold;\n  margin-top: 0;\n  margin-bottom: 12rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText);
var Expert = styled_components_browser_esm["default"].div(ContactExpert_templateObject9 || (ContactExpert_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-wrap: no-wrap;\n  justify-content: flex-start;\n  margin-bottom: 40rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ContactExpert_templateObject0 || (ContactExpert_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0;\n    width: calc(50% - 40rem);\n  "]))));
var ExpertName = styled_components_browser_esm["default"].span(ContactExpert_templateObject1 || (ContactExpert_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n"])));
var ContactExpert_Block = styled_components_browser_esm["default"].section(ContactExpert_templateObject10 || (ContactExpert_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: #ffffff;\n  padding: 40rem 20rem 30rem 20rem;\n  position: relative;\n  box-sizing: border-box;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.isLastItem ? "\n    &:before {\n      content: '';\n      z-index: 0;\n      position: absolute;\n      top: 0;\n      background-color: #FFFFFF;\n      width: 100vw;\n      height: calc(100% + 30rem);\n      left: calc((-50vw + 50%));\n    }\n  " : "\n    ''\n\n    ".concat(breakpoints/* fromBreakpoint.md */.ks.md(ContactExpert_templateObject11 || (ContactExpert_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-bottom: 60rem;\n    "]))), ";\n  ");
}, breakpoints/* fromBreakpoint.md */.ks.md(ContactExpert_templateObject12 || (ContactExpert_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n  "])), function (props) {
  return props.isLastItem ? "\n      padding: 60rem 0 40rem 0;\n    " : "\n      padding: 60rem 73rem 40rem 73rem;\n    ";
}), breakpoints/* fromBreakpoint.lg */.ks.lg(ContactExpert_templateObject13 || (ContactExpert_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n  "])), function (props) {
  return props.isLastItem ? "\n    &:before {\n      height: calc(100% + 30rem);\n    }\n    " : "\n      padding: 60rem 20rem 40rem 20rem;\n    ";
}));
var ContactExpert_Title = styled_components_browser_esm["default"].h3(ContactExpert_templateObject14 || (ContactExpert_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: bold;\n  margin-top: 0;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ContactExpert_SubTitle = styled_components_browser_esm["default"].div(ContactExpert_templateObject15 || (ContactExpert_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ContactExpert_TextContainer = styled_components_browser_esm["default"].div(ContactExpert_templateObject16 || (ContactExpert_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 40rem;\n  position: relative;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ContactExpert_templateObject17 || (ContactExpert_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 50rem;\n    max-width: 70%;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ContactExpert_templateObject18 || (ContactExpert_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n    max-width: 50%;\n    ", "\n  "])), function (props) {
  return props.isLastItem ? "\n    " : "\n      margin-left: 22rem;\n      margin-right: 22rem;\n    ";
}), breakpoints/* fromBreakpoint.xl */.ks.xl(ContactExpert_templateObject19 || (ContactExpert_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n  "])), function (props) {
  return props.isLastItem ? "\n    " : "\n      max-width: 570rem;\n      margin-left: 110rem;\n      margin-right: 110rem;\n    ";
}));
var ContactExpert_ButtonWrapper = styled_components_browser_esm["default"].div(ContactExpert_templateObject20 || (ContactExpert_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 12rem;\n  margin-top: auto;\n"])));
/* harmony default export */ var components_ContactExpert = (ContactExpert);
;// CONCATENATED MODULE: ./src/components/ExpandableListBlock.js








var ExpandableListBlock_templateObject, ExpandableListBlock_templateObject2, ExpandableListBlock_templateObject3, ExpandableListBlock_templateObject4, ExpandableListBlock_templateObject5, ExpandableListBlock_templateObject6, ExpandableListBlock_templateObject7, ExpandableListBlock_templateObject8, ExpandableListBlock_templateObject9;

var ExpandableListBlock_jsx = react.createElement;

function ExpandableListBlock_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function ExpandableListBlock_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ExpandableListBlock_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ExpandableListBlock_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function ExpandableListBlock_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ExpandableListBlock_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ExpandableListBlock_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ExpandableListBlock_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}




 // Components



 // Styles


 // Types
// Analytics


var LIKED = 'liked';
var DISLIKED = 'disliked';
var FAQ_ITEM = 'FAQ';

var ExpandableListBlock_mapStateToProps = function mapStateToProps(_state, _props) {
  return {};
};

var ExpandableListBlock = /*#__PURE__*/function (_React$Component) {
  function ExpandableListBlock() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ExpandableListBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ExpandableListBlock_callSuper(this, ExpandableListBlock, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "refObject", {});

    (0,defineProperty/* default */.Z)(_this, "state", {
      listOpen: {},
      buttonFeedback: {}
    });

    (0,defineProperty/* default */.Z)(_this, "toUpperCase", function (title) {
      return title.toUpperCase();
    }); // Used to give feedback to FAQ item


    (0,defineProperty/* default */.Z)(_this, "handleFeedbackClick", function (index, id, feedbackType) {
      var dispatch = _this.props.dispatch;
      dispatch((0,apiData/* performApiRequest */.T4)('postFAQFeedback', {}, {
        id: id,
        action: feedbackType === LIKED ? LIKED : DISLIKED
      }));

      _this.setState(function (prevState) {
        return ExpandableListBlock_objectSpread(ExpandableListBlock_objectSpread({}, prevState), {}, {
          buttonFeedback: (0,defineProperty/* default */.Z)({}, index, {
            clicked: feedbackType === LIKED ? LIKED : DISLIKED
          })
        });
      });
    });

    (0,defineProperty/* default */.Z)(_this, "toggleList", function (index, id, title) {
      // If listitem is not open and title is equal to FAQ, send tracker
      var dispatch = _this.props.dispatch;
      var projectName = _this.props.match ? _this.props.match.params.projectSlug : '';

      if ((!_this.state.listOpen[index] || _this.state.listOpen[index] && !_this.state.listOpen[index].expanded) && _this.toUpperCase(_this.props.list.title) === FAQ_ITEM) {
        dispatch((0,apiData/* performApiRequest */.T4)('postOpenFaq', {}, {
          id: id,
          action: 'open'
        }));
      }

      _this.setState(function (prevState) {
        return ExpandableListBlock_objectSpread(ExpandableListBlock_objectSpread({}, prevState), {}, {
          listOpen: (0,defineProperty/* default */.Z)({}, index, {
            expanded: !_this.state.listOpen[index] ? true : !_this.state.listOpen[index].expanded,
            height: _this.refObject[index].clientHeight
          })
        });
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ExpandableListBlock, _React$Component);

  return (0,createClass/* default */.Z)(ExpandableListBlock, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          list = _this$props.list,
          title = _this$props.title,
          description = _this$props.description;
      var _this$state = this.state,
          listOpen = _this$state.listOpen,
          buttonFeedback = _this$state.buttonFeedback;
      return ExpandableListBlock_jsx(ExpandableListBlock_Container, {
        "data-id": "components_ExpandableListBlock_Container"
      }, title && ExpandableListBlock_jsx(ListTitle, {
        "data-id": "components_ExpandableListBlock_ListTitle"
      }, title), description && ExpandableListBlock_jsx(BBCode/* default */.Z, {
        content: description,
        "data-id": "components_ExpandableListBlock_BBCode"
      }), list && (list.items || []).map(function (item, index) {
        return ExpandableListBlock_jsx(ListContainer, {
          key: index,
          "data-id": "components_ExpandableListBlock_ListContainer"
        }, ExpandableListBlock_jsx(ExpandableListBlock_TitleContainer, {
          onClick: function onClick() {
            return _this2.toggleList(index, item.id, item.title);
          },
          "data-id": "components_ExpandableListBlock_TitleContainer"
        }, ExpandableListBlock_jsx(Caret/* default */.Z, {
          direction: listOpen[index] && listOpen[index].expanded ? 'down' : 'right',
          "data-id": "components_ExpandableListBlock_Caret"
        }), ExpandableListBlock_jsx(ExpandableListBlock_Title, {
          "data-id": "components_ExpandableListBlock_Title"
        }, item.title)), ExpandableListBlock_jsx(ContentContainer, {
          height: listOpen[index] && listOpen[index].expanded ? listOpen[index].height : 0,
          expanded: listOpen[index] && listOpen[index].expanded,
          "data-id": "components_ExpandableListBlock_ContentContainer"
        }, ExpandableListBlock_jsx(InnerContent, {
          ref: function ref(el) {
            _this2.refObject[index] = el;
          },
          "data-id": "components_ExpandableListBlock_InnerContent"
        }, ExpandableListBlock_jsx(BBCode/* default */.Z, {
          content: item.content,
          "data-id": "components_ExpandableListBlock_BBCode"
        }), list.title && list.title.toUpperCase() === FAQ_ITEM && ExpandableListBlock_jsx(FeedbackContainer, {
          "data-id": "components_ExpandableListBlock_FeedbackContainer"
        }, ExpandableListBlock_jsx("span", {
          "data-id": "components_ExpandableListBlock_span"
        }, "Was dit antwoord nuttig?"), ExpandableListBlock_jsx(ExpandableListBlock_Button, {
          type: LIKED,
          onClick: function onClick() {
            return _this2.handleFeedbackClick(index, item.id, LIKED);
          },
          clicked: buttonFeedback[index] && buttonFeedback[index].clicked === LIKED ? LIKED : false,
          "data-id": "components_ExpandableListBlock_Button"
        }, ExpandableListBlock_jsx(icons_Like, {
          "data-id": "components_ExpandableListBlock_LikeIcon"
        })), ExpandableListBlock_jsx(ExpandableListBlock_Button, {
          type: DISLIKED,
          onClick: function onClick() {
            return _this2.handleFeedbackClick(index, item.id, DISLIKED);
          },
          clicked: buttonFeedback[index] && buttonFeedback[index].clicked === DISLIKED ? DISLIKED : false,
          "data-id": "components_ExpandableListBlock_Button"
        }, ExpandableListBlock_jsx(icons_Like, {
          "data-id": "components_ExpandableListBlock_LikeIcon"
        }))))));
      }));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_ExpandableListBlock = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(ExpandableListBlock_mapStateToProps)(ExpandableListBlock)));
var ListTitle = styled_components_browser_esm["default"].h2(ExpandableListBlock_templateObject || (ExpandableListBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 5rem;\n  margin-bottom: 10rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ExpandableListBlock_Container = styled_components_browser_esm["default"].section(ExpandableListBlock_templateObject2 || (ExpandableListBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 30rem auto 40rem;\n  max-width: 1020rem;\n"])));
var ListContainer = styled_components_browser_esm["default"].div(ExpandableListBlock_templateObject3 || (ExpandableListBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  overflow: hidden;\n  border-bottom: 1rem solid ", ";\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey);
var ExpandableListBlock_TitleContainer = styled_components_browser_esm["default"].div(ExpandableListBlock_templateObject4 || (ExpandableListBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  > svg {\n    flex-shrink: 0;\n    transition: transform 0.3s ease-in-out;\n  }\n"])));
var ExpandableListBlock_Title = styled_components_browser_esm["default"].h3(ExpandableListBlock_templateObject5 || (ExpandableListBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-left: 20rem;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.blue */.K5.blue);
var ContentContainer = styled_components_browser_esm["default"].div(ExpandableListBlock_templateObject6 || (ExpandableListBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-bottom: ", "px;\n  transition: all 0.3s ease-in-out;\n  max-height: ", "px;\n  overflow: hidden;\n"])), function (props) {
  return props.expanded ? '20' : '0';
}, function (props) {
  return props.height;
});
var InnerContent = styled_components_browser_esm["default"].div(ExpandableListBlock_templateObject7 || (ExpandableListBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var FeedbackContainer = styled_components_browser_esm["default"].div(ExpandableListBlock_templateObject8 || (ExpandableListBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 15rem;\n\n  > span {\n    padding-right: 20rem;\n  }\n"])));
var ExpandableListBlock_Button = styled_components_browser_esm["default"].button(ExpandableListBlock_templateObject9 || (ExpandableListBlock_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 30rem;\n  height: 30rem;\n  background-color: ", ";\n  transition: background-color 0.3s ease-in-out;\n  border-radius: 50%;\n  box-sizing: border-box;\n  position: relative;\n  margin: 0 6rem;\n\n  > svg {\n    transition: transform 0.1s ease-in-out;\n    transform: scale(0.5);\n    position: relative;\n    transform-origin: center center;\n    will-change: transform;\n  }\n\n  ", ";\n"])), function (props) {
  return props.clicked ? props.clicked === LIKED ? (0,utils/* darken */._j)(styleGuide/* colorPalette.darkGreen */.K5.darkGreen, 10) : (0,utils/* darken */._j)(styleGuide/* colorPalette.darkOrange */.K5.darkOrange, 10) : styleGuide/* colorPalette.lightBeige */.K5.lightBeige;
}, function (props) {
  return props.type === LIKED ? "\n\n    &:hover {\n      background-color: ".concat(styleGuide/* colorPalette.darkGreen */.K5.darkGreen, ";\n\n      > svg {\n        transform: scale(0.6)\n      }\n    }\n\n    &:active {\n      background-color: ").concat((0,utils/* darken */._j)(styleGuide/* colorPalette.darkGreen */.K5.darkGreen, 10), ";\n    }\n\n  ") : "\n    > svg {\n     transform: scale(0.5) rotate(180deg);\n     top: 1rem;\n    }\n\n    &:hover {\n      background-color: ".concat(styleGuide/* colorPalette.darkOrange */.K5.darkOrange, ";\n\n      > svg {\n        transform: scale(0.6) rotate(180deg);\n      }\n    }\n\n    &:active {\n      background-color: ").concat((0,utils/* darken */._j)(styleGuide/* colorPalette.darkOrange */.K5.darkOrange, 10), ";\n    }\n  ");
});
;// CONCATENATED MODULE: ./src/components/IFrameBlock.js








var IFrameBlock_templateObject, IFrameBlock_templateObject2, IFrameBlock_templateObject3;

var IFrameBlock_jsx = react.createElement;

function IFrameBlock_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, IFrameBlock_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function IFrameBlock_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (IFrameBlock_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}








var IFRAMEPADDING = 30;

var dispatchToProps = function dispatchToProps(dispatch) {
  return {
    getNotifications: function getNotifications(projectSlug) {
      dispatch((0,apiData/* performApiRequest */.T4)('getNotifications', {
        projectSlug: projectSlug
      }));
    }
  };
};

var IFrameBlock = /*#__PURE__*/function (_Component) {
  function IFrameBlock() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, IFrameBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = IFrameBlock_callSuper(this, IFrameBlock, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      iFrameHeight: 0,
      isFrameVisible: false,
      isLoading: true,
      componentMinHeight: _this.props.type === 'forum' ? 132 : _this.props.type === 'messageCenter' ? 432 : _this.props.type === 'documentCenter' ? 320 : 0
    });

    (0,defineProperty/* default */.Z)(_this, "handleIframeEvent", function (event) {
      var _this$props = _this.props,
          type = _this$props.type,
          iframe = _this$props.iframe,
          getNotifications = _this$props.getNotifications,
          match = _this$props.match;
      var data = event.data;

      if (data.type === 'SET_HEIGHT' && data.url.includes(iframe)) {
        var iFrameHeight = type === 'documentCenter' ? Math.max(500, data.height) : data.height;

        _this.setState({
          iFrameHeight: iFrameHeight,
          isFrameVisible: !!data.height
        }, function () {
          setTimeout(function () {
            _this.setState({
              isLoading: false
            });
          }, 500);
        });
      }

      if (data.type === 'LOAD' || data.type === 'XHR_RESPONSE') {
        getNotifications(String(match.params.projectSlug));
      }
    });

    (0,defineProperty/* default */.Z)(_this, "getIframeWidth", function (width) {
      if (width >= 1180) {
        return 1180;
      } else if (width >= 980 && width < 1180) {
        return 941;
      } else if (width >= 680 && width < 980) {
        return 641;
      } else {
        return 320;
      }
    });

    return _this;
  }

  (0,inherits/* default */.Z)(IFrameBlock, _Component);

  return (0,createClass/* default */.Z)(IFrameBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('message', this.handleIframeEvent, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleIframeEvent, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          renderWidth = _this$props2.renderWidth,
          type = _this$props2.type,
          iframe = _this$props2.iframe;
      var _this$state = this.state,
          componentMinHeight = _this$state.componentMinHeight,
          isFrameVisible = _this$state.isFrameVisible,
          iFrameHeight = _this$state.iFrameHeight,
          isLoading = _this$state.isLoading;
      return IFrameBlock_jsx(IFrameBlock_Block, {
        minHeight: componentMinHeight + IFRAMEPADDING,
        "data-e2e-block-iframe": true,
        "data-id": "components_IFrameBlock_Block"
      }, isLoading && IFrameBlock_jsx(IFrameBlock_SpinnerContainer, {
        "data-id": "components_IFrameBlock_SpinnerContainer"
      }, IFrameBlock_jsx(Spinner/* default */.Z, {
        monochrome: true,
        color: styleGuide/* colorPalette.lightBlue */.K5.lightBlue,
        size: "small",
        "data-id": "components_IFrameBlock_Spinner"
      })), IFrameBlock_jsx(Frame, {
        visible: isFrameVisible,
        title: type,
        src: iframe,
        width: this.getIframeWidth(renderWidth),
        height: iFrameHeight + IFRAMEPADDING,
        "data-id": "components_IFrameBlock_Frame"
      }));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_IFrameBlock = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(null, dispatchToProps)(IFrameBlock)));
var IFrameBlock_Block = styled_components_browser_esm["default"].div(IFrameBlock_templateObject || (IFrameBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  width: 100%;\n  min-height: ", "rem;\n\n  > div {\n    display: flex;\n  }\n"])), function (props) {
  return props.minHeight ? props.minHeight : 200;
});
var Frame = styled_components_browser_esm["default"].iframe(IFrameBlock_templateObject2 || (IFrameBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  position: relative;\n  margin: 0 auto;\n  border: none !important;\n  opacity: ", ";\n  transition: opacity 0.3s 0.5s ease-in;\n"])), function (props) {
  return props.visible ? '1' : '0';
});
var IFrameBlock_SpinnerContainer = styled_components_browser_esm["default"].div(IFrameBlock_templateObject3 || (IFrameBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n\n  > div {\n    width: 40rem;\n  }\n"])));
// EXTERNAL MODULE: ./node_modules/react-transition-group/index.js
var react_transition_group = __webpack_require__(64317);
;// CONCATENATED MODULE: ./src/components/shared/designElements/WishlistFooter.js


var WishlistFooter_templateObject, WishlistFooter_templateObject2, WishlistFooter_templateObject3, WishlistFooter_templateObject4, WishlistFooter_templateObject5, WishlistFooter_templateObject6;

var WishlistFooter_jsx = react.createElement;







var WishlistFooter = function WishlistFooter(_ref) {
  var smallColumn = _ref.smallColumn,
      bedrooms = _ref.bedrooms,
      notAvailable = _ref.notAvailable,
      small = _ref.small,
      price = _ref.price,
      livingSpace = _ref.livingSpace,
      userWishTotal = _ref.userWishTotal,
      hasExternalSellers = _ref.hasExternalSellers;
  return WishlistFooter_jsx(WishlistFooter_Container, {
    smallColumn: smallColumn,
    "data-id": "designElements_WishlistFooter_Container"
  }, WishlistFooter_jsx(UserOptionsMessage, {
    smallColumn: smallColumn,
    small: small,
    "data-id": "designElements_WishlistFooter_UserOptionsMessage"
  }, userWishTotal ? "Dit bedrag is inclusief ".concat(formatPrice(userWishTotal, {
    showDecimal: true,
    showEuroSign: true
  }), " aan eigen woonwensen") : '', livingSpace && bedrooms ? "".concat(livingSpace, " m\xB2 woonoppervlak, ").concat(bedrooms, " slaapkamer").concat(bedrooms > 1 ? 's' : '') : ''), WishlistFooter_jsx(PriceTagContainer, {
    small: small,
    "data-id": "designElements_WishlistFooter_PriceTagContainer"
  }, WishlistFooter_jsx(designElements_PriceTag, {
    price: price,
    small: small,
    notAvailable: notAvailable,
    hasExternalSellers: hasExternalSellers,
    "data-id": "designElements_WishlistFooter_PriceTag"
  })));
};

/* harmony default export */ var designElements_WishlistFooter = (WishlistFooter);
var WishlistFooter_Container = styled_components_browser_esm["default"].div(WishlistFooter_templateObject || (WishlistFooter_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  font-family: ", ";\n  ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, breakpoints/* toBreakpoint.md */.Hx.md(WishlistFooter_templateObject2 || (WishlistFooter_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: ", ";\n    align-items: ", ";\n  "])), function (props) {
  return props.smallColumn ? 'column' : 'row';
}, function (props) {
  return props.smallColumn ? 'flex-start' : 'center';
}));
var UserOptionsMessage = styled_components_browser_esm["default"].span(WishlistFooter_templateObject3 || (WishlistFooter_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-style: italic;\n  font-size: ", ";\n  color: ", ";\n  padding-right: 25rem;\n\n  ", ";\n"])), function (props) {
  return props.small ? '12rem' : '14rem';
}, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* toBreakpoint.md */.Hx.md(WishlistFooter_templateObject4 || (WishlistFooter_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: ", "rem;\n  "])), function (props) {
  return props.smallColumn ? 10 : 0;
}));
var PriceTagContainer = styled_components_browser_esm["default"].div(WishlistFooter_templateObject5 || (WishlistFooter_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n\n  > div > div {\n    width: 100%;\n    >span: first-of-type {\n      margin-left: 5rem;\n    }\n    > span:last-of-type {\n      margin-left: auto;\n    }\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(WishlistFooter_templateObject6 || (WishlistFooter_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 0;\n  "]))));
;// CONCATENATED MODULE: ./src/components/shared/icons/Favorite.js
var Favorite_jsx = react.createElement;

var Favorite_defaultProps = {
  color: '#ffffff',
  filled: false
};

var Favorite = function Favorite(_ref) {
  var filled = _ref.filled,
      color = _ref.color;
  return Favorite_jsx("svg", {
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    version: "1.1",
    "data-id": "icons_Favorite_svg"
  }, Favorite_jsx("title", {
    "data-id": "icons_Favorite_title"
  }, "Favorite icon"), Favorite_jsx("defs", {
    "data-id": "icons_Favorite_defs"
  }), Favorite_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Favorite_g"
  }, Favorite_jsx("g", {
    transform: "translate(-871.000000, -586.000000)",
    fill: color,
    "data-id": "icons_Favorite_g_4"
  }, Favorite_jsx("g", {
    transform: "translate(871.000000, 586.000000)",
    "data-id": "icons_Favorite_g_5"
  }, !filled ? Favorite_jsx("path", {
    d: "M19.8590674,7.24334286 C19.5641417,10.4380571 16.6338103,14.1073429 11.1485074,18.1710571 C5.66162743,14.1089143 2.73602743,10.4380571 2.43637029,7.24334286 L2.43637029,6.18105714 C2.676096,3.63848571 4.24535314,2.56834286 5.25472457,2.47091429 C5.52914743,2.44262857 5.78779886,2.43005714 6.02752457,2.43005714 C7.47534171,2.43005714 8.08254171,2.8732 9.28117029,4.29534286 L11.1485074,6.51262857 L13.0174217,4.29534286 C14.2160503,2.8732 14.820096,2.43005714 16.2710674,2.43005714 C16.5076389,2.43005714 16.7662903,2.44262857 17.0438674,2.47091429 C18.0516617,2.56834286 19.622496,3.63848571 19.8590674,6.18105714 L19.8590674,7.24334286 Z M17.2804389,0.0524857143 C16.9208503,0.0179142857 16.5849189,0.000628571404 16.2710674,0.000628571404 C13.7444846,0.000628571404 12.5332389,1.08648571 11.1485074,2.73334286 C9.76219886,1.08648571 8.55095314,0.000628571404 6.02752457,0.000628571404 C5.71051886,0.000628571404 5.37458743,0.0179142857 5.01815314,0.0524857143 C2.830656,0.264628571 0.305650286,2.2572 -0.000315428559,6.07734286 L-0.000315428559,7.34705714 C0.286724571,11.0037714 3.05618743,15.5122 11.1485074,21.1677714 C19.2424046,15.5122 22.0118674,11.0037714 22.2989074,7.34705714 L22.2989074,6.07734286 C21.9913646,2.2572 19.4647817,0.264628571 17.2804389,0.0524857143 L17.2804389,0.0524857143 Z",
    "data-id": "icons_Favorite_path"
  }) : Favorite_jsx("path", {
    d: "M17.2804389,0.0524857143 C19.4647817,0.264628571 21.9913646,2.2572 22.2989074,6.07734286 L22.2989074,7.34705714 C22.0118674,11.0037714 19.2424046,15.5122 11.1485074,21.1677714 C3.05618743,15.5122 0.286724571,11.0037714 -0.000315428559,7.34705714 L-0.000315428559,6.07734286 C0.305650286,2.2572 2.830656,0.264628571 5.01815314,0.0524857143 C5.37458743,0.0179142857 5.71051886,0.000628571404 6.02752457,0.000628571404 C8.55095314,0.000628571404 9.76219886,1.08648571 11.1485074,2.73334286 C12.5332389,1.08648571 13.7444846,0.000628571404 16.2710674,0.000628571404 C16.5849189,0.000628571404 16.9208503,0.0179142857 17.2804389,0.0524857143 Z",
    fill: color,
    "data-id": "icons_Favorite_path_7"
  })))));
};

Favorite.defaultProps = Favorite_defaultProps;
/* harmony default export */ var icons_Favorite = (Favorite);
;// CONCATENATED MODULE: ./src/components/shared/icons/Copy.js
var Copy_jsx = react.createElement;


var Copy_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var Duplicate = function Duplicate(_ref) {
  var color = _ref.color;
  return Copy_jsx("svg", {
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    version: "1.1",
    "data-id": "icons_Copy_svg"
  }, Copy_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Copy_g"
  }, Copy_jsx("g", {
    transform: "translate(-1275.000000, -486.000000)",
    fill: color,
    "data-id": "icons_Copy_g_2"
  }, Copy_jsx("path", {
    d: "M1286.4,490.75 L1292.1,490.75 L1292.1,505 L1280.7,505 L1280.7,500.25 L1275,500.25 L1275,486 L1286.4,486 L1286.4,490.75 Z M1284.5,490.75 L1284.5,487.9 L1276.9,487.9 L1276.9,498.35 L1280.7,498.35 L1280.7,490.75 L1284.5,490.75 Z M1282.5,492.5 L1282.5,503 L1290.5,503 L1290.5,492.5 L1282.5,492.5 Z",
    id: "Combined-Shape",
    "data-id": "icons_Copy_path"
  }))));
};

Duplicate.defaultProps = Copy_defaultProps;
/* harmony default export */ var Copy = (Duplicate);
;// CONCATENATED MODULE: ./src/components/shared/icons/Delete.js
var Delete_jsx = react.createElement;


var Delete_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var Delete = function Delete(_ref) {
  var color = _ref.color;
  return Delete_jsx("svg", {
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    version: "1.1",
    "data-id": "icons_Delete_svg"
  }, Delete_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Delete_g"
  }, Delete_jsx("g", {
    transform: "translate(-875.000000, -519.000000)",
    fillRule: "nonzero",
    fill: color,
    "data-id": "icons_Delete_g_2"
  }, Delete_jsx("path", {
    d: "M879.15625,520.78125 L879.15625,519.59375 L879.15625,519.59375 C879.15625,519.265831 879.422081,519 879.75,519 L885.984375,519 C886.312294,519 886.578125,519.265831 886.578125,519.59375 L886.578125,520.78125 L889.546875,520.78125 C890.202713,520.78125 890.734375,521.312912 890.734375,521.96875 L890.734375,524.34375 L889.546875,524.34375 L889.546875,536.21875 C889.546875,537.202507 888.749382,538 887.765625,538 L877.96875,538 C876.984993,538 876.1875,537.202507 876.1875,536.21875 L876.1875,524.34375 L875,524.34375 L875,521.96875 C875,521.312912 875.531662,520.78125 876.1875,520.78125 L876.1875,520.78125 L879.15625,520.78125 Z M887.765625,524.34375 L877.96875,524.34375 L877.96875,535.328125 C877.96875,535.983963 878.500412,536.515625 879.15625,536.515625 L886.578125,536.515625 C887.233963,536.515625 887.765625,535.983963 887.765625,535.328125 L887.765625,524.34375 Z M880.34375,519.890625 L880.34375,520.78125 L885.390625,520.78125 L885.390625,519.890625 L880.34375,519.890625 Z M880.9375,526.71875 L881.53125,526.71875 C881.859169,526.71875 882.125,526.984581 882.125,527.3125 L882.125,533.25 C882.125,533.577919 881.859169,533.84375 881.53125,533.84375 L880.9375,533.84375 C880.609581,533.84375 880.34375,533.577919 880.34375,533.25 L880.34375,527.3125 C880.34375,526.984581 880.609581,526.71875 880.9375,526.71875 Z M884.5,526.71875 L885.09375,526.71875 C885.421669,526.71875 885.6875,526.984581 885.6875,527.3125 L885.6875,533.25 C885.6875,533.577919 885.421669,533.84375 885.09375,533.84375 L884.5,533.84375 C884.172081,533.84375 883.90625,533.577919 883.90625,533.25 L883.90625,527.3125 C883.90625,526.984581 884.172081,526.71875 884.5,526.71875 Z",
    "data-id": "icons_Delete_path"
  }))));
};

Delete.defaultProps = Delete_defaultProps;
/* harmony default export */ var icons_Delete = (Delete);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseFloor0.js
var HouseFloor0_jsx = react.createElement;


var HouseFloor0_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseFloor0 = function HouseFloor0(_ref) {
  var color = _ref.color;
  return HouseFloor0_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseFloor0_svg"
  }, HouseFloor0_jsx("title", {
    "data-id": "icons_HouseFloor0_title"
  }, "Begane Grond Verdieping"), HouseFloor0_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseFloor0_g"
  }, HouseFloor0_jsx("g", {
    transform: "translate(-78.000000, -767.000000)",
    fill: color,
    "data-id": "icons_HouseFloor0_g_3"
  }, HouseFloor0_jsx("g", {
    transform: "translate(40.000000, 761.000000)",
    "data-id": "icons_HouseFloor0_g_4"
  }, HouseFloor0_jsx("g", {
    transform: "translate(38.000000, 6.000000)",
    "data-id": "icons_HouseFloor0_g_5"
  }, HouseFloor0_jsx("g", {
    transform: "translate(4.375000, 8.437500)",
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor0_g_6"
  }, HouseFloor0_jsx("path", {
    d: "M5.125,5.5 C5.125,6.21875 4.90625,6.78125 4.40625,7.09375 C3.9375,7.4375 3.1875,7.5625 2.125,7.5625 L0,7.5625 L0,0.5 C0.75,0.4375 1.40625,0.375 1.96875,0.375 C2.9375,0.375 3.65625,0.53125 4.09375,0.8125 C4.53125,1.09375 4.75,1.5625 4.75,2.1875 C4.75,2.4375 4.71875,2.65625 4.59375,2.90625 C4.53125,3.125 4.375,3.3125 4.21875,3.46875 C4.0625,3.625 3.875,3.71875 3.65625,3.8125 C4.625,4.09375 5.125,4.65625 5.125,5.5 Z M2.0625,6.53125 C2.625,6.53125 3.03125,6.46875 3.25,6.28125 C3.46875,6.09375 3.59375,5.84375 3.59375,5.46875 C3.59375,4.75 3.15625,4.4375 2.21875,4.4375 L1.4375,4.4375 L1.4375,6.5625 L2.0625,6.5625 L2.0625,6.53125 Z M3.28125,2.28125 C3.28125,1.96875 3.15625,1.75 2.96875,1.625 C2.78125,1.46875 2.46875,1.40625 2.03125,1.40625 C1.875,1.40625 1.78125,1.40625 1.6875,1.40625 C1.625,1.40625 1.53125,1.40625 1.46875,1.4375 L1.46875,3.40625 L2.1875,3.40625 C2.53125,3.40625 2.78125,3.28125 3,3.09375 C3.21875,2.9375 3.28125,2.625 3.28125,2.28125 Z M9.03125,4.78125 L9.03125,3.6875 L11.625,3.6875 L11.625,6.875 C11.46875,7.03125 11.28125,7.1875 11.03125,7.3125 C10.78125,7.46875 10.46875,7.53125 10.125,7.625 C9.75,7.6875 9.40625,7.75 9.03125,7.75 C8.3125,7.75 7.6875,7.59375 7.21875,7.3125 C6.75,7 6.375,6.5625 6.09375,6 C5.84375,5.4375 5.71875,4.78125 5.71875,4 C5.71875,3.21875 5.875,2.5625 6.125,2 C6.375,1.4375 6.78125,1.03125 7.3125,0.71875 C7.84375,0.40625 8.4375,0.28125 9.1875,0.28125 C9.5625,0.28125 9.9375,0.34375 10.3125,0.46875 C10.65625,0.59375 10.9375,0.71875 11.125,0.90625 C11.34375,1.09375 11.4375,1.25 11.4375,1.4375 C11.4375,1.5625 11.40625,1.6875 11.28125,1.8125 C11.15625,1.96875 11.0625,2.125 10.90625,2.21875 C10.59375,1.96875 10.34375,1.78125 10.09375,1.65625 C9.84375,1.53125 9.53125,1.5 9.1875,1.5 C8.5625,1.5 8.03125,1.71875 7.6875,2.125 C7.34375,2.5625 7.15625,3.15625 7.15625,4 C7.15625,4.84375 7.34375,5.5 7.6875,5.9375 C8.03125,6.375 8.53125,6.59375 9.1875,6.59375 C9.5,6.59375 9.75,6.5625 9.96875,6.4375 C10.03125,6.40625 10.15625,6.375 10.21875,6.28125 L10.21875,4.75 L9.03125,4.75 L9.03125,4.78125 Z",
    "data-id": "icons_HouseFloor0_path"
  })), HouseFloor0_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor0_path_8"
  }))))));
};

HouseFloor0.defaultProps = HouseFloor0_defaultProps;
/* harmony default export */ var icons_HouseFloor0 = (HouseFloor0);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseFloor1.js
var HouseFloor1_jsx = react.createElement;


var HouseFloor1_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseFloor1 = function HouseFloor1(_ref) {
  var color = _ref.color;
  return HouseFloor1_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseFloor1_svg"
  }, HouseFloor1_jsx("title", {
    "data-id": "icons_HouseFloor1_title"
  }, "Eerste Verdieping"), HouseFloor1_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseFloor1_g"
  }, HouseFloor1_jsx("g", {
    transform: "translate(-110.000000, -767.000000)",
    fill: color,
    "data-id": "icons_HouseFloor1_g_3"
  }, HouseFloor1_jsx("g", {
    transform: "translate(40.000000, 761.000000)",
    "data-id": "icons_HouseFloor1_g_4"
  }, HouseFloor1_jsx("g", {
    transform: "translate(70.000000, 6.000000)",
    "data-id": "icons_HouseFloor1_g_5"
  }, HouseFloor1_jsx("g", {
    transform: "translate(7.500000, 8.125000)",
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor1_g_6"
  }, HouseFloor1_jsx("path", {
    d: "M2.09375,8.125 L2.09375,1.9375 L0.53125,2.75 C0.21875,2.3125 0.03125,1.96875 0.03125,1.75 C0.03125,1.53125 0.15625,1.34375 0.4375,1.1875 L2.1875,0.28125 C2.34375,0.1875 2.5,0.125 2.6875,0.09375 C2.84375,0.03125 3,0 3.15625,0 C3.40625,0 3.65625,0.09375 3.84375,0.1875 L3.84375,8.125 L2.09375,8.125 Z",
    "data-id": "icons_HouseFloor1_path"
  })), HouseFloor1_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor1_path_8"
  }))))));
};

HouseFloor1.defaultProps = HouseFloor1_defaultProps;
/* harmony default export */ var icons_HouseFloor1 = (HouseFloor1);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseFloor2.js
var HouseFloor2_jsx = react.createElement;


var HouseFloor2_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseFloor2 = function HouseFloor2(_ref) {
  var color = _ref.color;
  return HouseFloor2_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseFloor2_svg"
  }, HouseFloor2_jsx("title", {
    "data-id": "icons_HouseFloor2_title"
  }, "Tweede Verdieping"), HouseFloor2_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseFloor2_g"
  }, HouseFloor2_jsx("g", {
    transform: "translate(-142.000000, -767.000000)",
    fill: color,
    "data-id": "icons_HouseFloor2_g_3"
  }, HouseFloor2_jsx("g", {
    transform: "translate(40.000000, 761.000000)",
    "data-id": "icons_HouseFloor2_g_4"
  }, HouseFloor2_jsx("g", {
    transform: "translate(102.000000, 6.000000)",
    "data-id": "icons_HouseFloor2_g_5"
  }, HouseFloor2_jsx("g", {
    transform: "translate(7.187500, 8.125000)",
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor2_g_6"
  }, HouseFloor2_jsx("path", {
    d: "M0.125,8.125 L0.125,6.96875 C0.5,6.6875 0.875,6.3125 1.34375,5.875 C1.8125,5.4375 2.21875,5 2.59375,4.59375 C3.28125,3.84375 3.625,3.15625 3.625,2.53125 C3.625,2.15625 3.53125,1.875 3.34375,1.6875 C3.125,1.5 2.84375,1.40625 2.5,1.40625 C2.1875,1.40625 1.84375,1.5 1.53125,1.59375 C1.21875,1.75 0.875,1.96875 0.5625,2.28125 C0.21875,1.84375 0,1.53125 0,1.34375 C0,1.1875 0.09375,1.03125 0.28125,0.875 C0.96875,0.28125 1.78125,0 2.65625,0 C3.46875,0 4.09375,0.1875 4.59375,0.59375 C5.03125,1 5.28125,1.5625 5.28125,2.3125 C5.28125,3.28125 4.71875,4.3125 3.59375,5.46875 C3.125,5.9375 2.71875,6.34375 2.34375,6.6875 L4.625,6.6875 C4.9375,6.6875 5.1875,6.78125 5.34375,6.9375 C5.5,7.09375 5.59375,7.3125 5.59375,7.59375 C5.59375,7.6875 5.59375,7.75 5.59375,7.84375 C5.59375,7.9375 5.59375,7.96875 5.59375,8.03125 L0.125,8.03125 L0.125,8.125 Z",
    "data-id": "icons_HouseFloor2_path"
  })), HouseFloor2_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor2_path_8"
  }))))));
};

HouseFloor2.defaultProps = HouseFloor2_defaultProps;
/* harmony default export */ var icons_HouseFloor2 = (HouseFloor2);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseFloor3.js
var HouseFloor3_jsx = react.createElement;


var HouseFloor3_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseFloor3 = function HouseFloor3(_ref) {
  var color = _ref.color;
  return HouseFloor3_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseFloor3_svg"
  }, HouseFloor3_jsx("title", {
    "data-id": "icons_HouseFloor3_title"
  }, "Derde Verdieping"), HouseFloor3_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseFloor3_g"
  }, HouseFloor3_jsx("g", {
    transform: "translate(-173.000000, -767.000000)",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor3_g_3"
  }, HouseFloor3_jsx("g", {
    transform: "translate(173.000000, 767.000000)",
    "data-id": "icons_HouseFloor3_g_4"
  }, HouseFloor3_jsx("g", {
    "data-id": "icons_HouseFloor3_g_5"
  }, HouseFloor3_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    "data-id": "icons_HouseFloor3_path"
  })), HouseFloor3_jsx("path", {
    d: "M12.5625,13.78125 C12.5625,14.5625 12.3125,15.15625 11.8125,15.59375 C11.34375,16.03125 10.625,16.25 9.71875,16.25 C8.875,16.25 8.125,16.0625 7.53125,15.71875 C7.40625,15.65625 7.34375,15.5625 7.28125,15.46875 C7.21875,15.375 7.1875,15.28125 7.1875,15.1875 C7.1875,14.96875 7.34375,14.625 7.65625,14.125 C7.9375,14.40625 8.21875,14.59375 8.5625,14.75 C8.90625,14.90625 9.25,14.96875 9.59375,14.96875 C10,14.96875 10.3125,14.84375 10.5625,14.625 C10.8125,14.40625 10.90625,14.09375 10.90625,13.71875 C10.90625,13.34375 10.78125,13.0625 10.53125,12.84375 C10.28125,12.625 9.96875,12.53125 9.53125,12.53125 L8.9375,12.53125 L8.9375,11.34375 L9.53125,11.34375 C9.75,11.34375 9.9375,11.3125 10.125,11.21875 C10.3125,11.125 10.4375,11 10.53125,10.84375 C10.625,10.6875 10.6875,10.5 10.6875,10.28125 C10.6875,9.6875 10.3125,9.375 9.5625,9.375 C9.28125,9.375 9,9.4375 8.71875,9.53125 C8.4375,9.625 8.125,9.84375 7.75,10.15625 C7.59375,10.03125 7.46875,9.875 7.375,9.6875 C7.28125,9.5 7.21875,9.375 7.21875,9.25 C7.21875,9.125 7.25,9.0625 7.3125,8.96875 C7.375,8.90625 7.4375,8.8125 7.5,8.75 C7.75,8.53125 8.09375,8.375 8.5,8.25 C8.90625,8.125 9.34375,8.0625 9.8125,8.0625 C10.625,8.0625 11.25,8.25 11.6875,8.59375 C12.125,8.9375 12.34375,9.4375 12.34375,10.0625 C12.34375,10.46875 12.25,10.84375 12.03125,11.15625 C11.8125,11.46875 11.53125,11.71875 11.15625,11.875 C11.625,12.0625 11.96875,12.28125 12.1875,12.59375 C12.46875,12.9375 12.5625,13.3125 12.5625,13.78125 Z",
    "data-id": "icons_HouseFloor3_path_7"
  })))));
};

HouseFloor3.defaultProps = HouseFloor3_defaultProps;
/* harmony default export */ var icons_HouseFloor3 = (HouseFloor3);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseFloor4.js
var HouseFloor4_jsx = react.createElement;


var HouseFloor4_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseFloor4 = function HouseFloor4(_ref) {
  var color = _ref.color;
  return HouseFloor4_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseFloor4_svg"
  }, HouseFloor4_jsx("title", {
    "data-id": "icons_HouseFloor4_title"
  }, "Derde Verdieping"), HouseFloor4_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseFloor4_g"
  }, HouseFloor4_jsx("g", {
    transform: "translate(-185.000000, -130.000000)",
    fill: color,
    "data-id": "icons_HouseFloor4_g_3"
  }, HouseFloor4_jsx("g", {
    transform: "translate(185.000000, 130.000000)",
    "data-id": "icons_HouseFloor4_g_4"
  }, HouseFloor4_jsx("g", {
    strokeWidth: "1",
    "data-id": "icons_HouseFloor4_g_5"
  }, HouseFloor4_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor4_path"
  })), HouseFloor4_jsx("path", {
    d: "M6.875,14.3001527 L6.875,13.1851946 L9.98708094,8.87238952 C10.1831185,8.60283785 10.3791531,8.41088727 10.5751907,8.29653202 C10.7712283,8.18217677 10.9835992,8.125 11.2123097,8.125 C11.3184967,8.125 11.4410183,8.14337825 11.5798783,8.18013529 C11.7187382,8.21689234 11.8208396,8.25977491 11.8861855,8.30878431 L11.8861855,13.0871763 L12.2660064,13.0871763 C12.6907544,13.0871763 12.9031253,13.2832109 12.9031253,13.6752861 C12.9031253,13.7488002 12.8990412,13.8202711 12.890873,13.8897011 C12.8827048,13.9591311 12.8745367,14.026518 12.8663684,14.0918639 L12.8418639,14.3001527 L11.8861855,14.3001527 L11.8861855,16.2482664 L10.2198744,16.2482664 L10.2198744,14.3001527 L6.875,14.3001527 Z M10.2198744,13.0504194 L10.2198744,10.3304117 L8.19824701,13.0504194 L10.2198744,13.0504194 Z",
    "data-id": "icons_HouseFloor4_path_7"
  })))));
};

HouseFloor4.defaultProps = HouseFloor4_defaultProps;
/* harmony default export */ var icons_HouseFloor4 = (HouseFloor4);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseOptions.js
var HouseOptions_jsx = react.createElement;


var HouseOptions_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseOptions = function HouseOptions(_ref) {
  var color = _ref.color;
  return HouseOptions_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseOptions_svg"
  }, HouseOptions_jsx("title", {
    "data-id": "icons_HouseOptions_title"
  }, "Huis Opties"), HouseOptions_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseOptions_g"
  }, HouseOptions_jsx("g", {
    transform: "translate(-242.000000, -130.000000)",
    fill: color,
    "data-id": "icons_HouseOptions_g_3"
  }, HouseOptions_jsx("g", {
    transform: "translate(0.000000, 124.000000)",
    "data-id": "icons_HouseOptions_g_4"
  }, HouseOptions_jsx("g", {
    transform: "translate(242.000000, 6.000000)",
    "data-id": "icons_HouseOptions_g_5"
  }, HouseOptions_jsx("g", {
    "data-id": "icons_HouseOptions_g_6"
  }, HouseOptions_jsx("g", {
    transform: "translate(4.062500, 13.125000)",
    fillRule: "nonzero",
    "data-id": "icons_HouseOptions_g_7"
  }, HouseOptions_jsx("g", {
    "data-id": "icons_HouseOptions_g_8"
  }, HouseOptions_jsx("circle", {
    cx: "1.40625",
    cy: "1.40625",
    r: "1.40625",
    "data-id": "icons_HouseOptions_circle"
  }), HouseOptions_jsx("circle", {
    cx: "5.90625",
    cy: "1.40625",
    r: "1.40625",
    "data-id": "icons_HouseOptions_circle_10"
  }), HouseOptions_jsx("circle", {
    cx: "10.375",
    cy: "1.40625",
    r: "1.40625",
    "data-id": "icons_HouseOptions_circle_11"
  }))), HouseOptions_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    fillRule: "nonzero",
    "data-id": "icons_HouseOptions_path"
  })))))));
};

HouseOptions.defaultProps = HouseOptions_defaultProps;
/* harmony default export */ var icons_HouseOptions = (HouseOptions);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseReady.js
var HouseReady_jsx = react.createElement;


var HouseReady_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseReady = function HouseReady(_ref) {
  var color = _ref.color;
  return HouseReady_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseReady_svg"
  }, HouseReady_jsx("title", {
    "data-id": "icons_HouseReady_title"
  }, "Huis Woonklaar"), HouseReady_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseReady_g"
  }, HouseReady_jsx("g", {
    transform: "translate(-196.000000, -130.000000)",
    fill: color,
    "data-id": "icons_HouseReady_g_3"
  }, HouseReady_jsx("g", {
    transform: "translate(0.000000, 124.000000)",
    "data-id": "icons_HouseReady_g_4"
  }, HouseReady_jsx("g", {
    transform: "translate(196.000000, 6.000000)",
    "data-id": "icons_HouseReady_g_5"
  }, HouseReady_jsx("g", {
    "data-id": "icons_HouseReady_g_6"
  }, HouseReady_jsx("g", {
    transform: "translate(5.312500, 8.437500)",
    fillRule: "nonzero",
    "data-id": "icons_HouseReady_g_7"
  }, HouseReady_jsx("g", {
    "data-id": "icons_HouseReady_g_8"
  }, HouseReady_jsx("g", {
    "data-id": "icons_HouseReady_g_9"
  }, HouseReady_jsx("path", {
    d: "M3.59375,4.28125 L2.15625,2.84375 C1.875,2.53125 1.40625,2.53125 1.125,2.84375 L0,3.9375 L3.5625,7.5 L9.65625,1.34375 L8.5625,0.25 C8.25,-0.0625 7.8125,-0.0625 7.5,0.25 L3.59375,4.28125 Z",
    "data-id": "icons_HouseReady_path"
  })))), HouseReady_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    fillRule: "nonzero",
    "data-id": "icons_HouseReady_path_11"
  })))))));
};

HouseReady.defaultProps = HouseReady_defaultProps;
/* harmony default export */ var icons_HouseReady = (HouseReady);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseEuro.js
var HouseEuro_jsx = react.createElement;


var HouseEuro_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseEuro = function HouseEuro(_ref) {
  var color = _ref.color;
  return HouseEuro_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseEuro_svg"
  }, HouseEuro_jsx("title", {
    "data-id": "icons_HouseEuro_title"
  }, "Huis Prijs"), HouseEuro_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseEuro_g"
  }, HouseEuro_jsx("g", {
    transform: "translate(-334.000000, -767.000000)",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_HouseEuro_g_3"
  }, HouseEuro_jsx("g", {
    transform: "translate(40.000000, 761.000000)",
    "data-id": "icons_HouseEuro_g_4"
  }, HouseEuro_jsx("g", {
    transform: "translate(294.000000, 6.000000)",
    "data-id": "icons_HouseEuro_g_5"
  }, HouseEuro_jsx("g", {
    transform: "translate(6.875000, 8.125000)",
    "data-id": "icons_HouseEuro_g_6"
  }, HouseEuro_jsx("path", {
    d: "M3.99436091,8.07095866 C3.40695194,8.07095866 2.89591381,7.95739463 2.46123119,7.73026316 C2.02654859,7.50313169 1.6741085,7.17810362 1.40390038,6.75516919 C1.13369225,6.33223472 0.955514219,5.83098659 0.869360906,5.25140978 L0,5.25140978 L0,4.51127819 L0.798872188,4.51127819 C0.791040063,4.42512487 0.787124062,4.29589684 0.787124062,4.12359022 C0.787124062,3.95911572 0.791040063,3.81422369 0.798872188,3.68890978 L0,3.68890978 L0,2.96052631 L0.869360906,2.96052631 C1.01817116,2.04416834 1.37452725,1.32166619 1.93843984,0.792998125 C2.50235244,0.264330062 3.21114863,0 4.06484962,0 C4.76190825,0 5.34539238,0.160556031 5.81531956,0.481672937 C6.10510797,0.677475906 6.25,0.888939969 6.25,1.11607144 C6.25,1.23355322 6.197134,1.37452925 6.09140038,1.53900375 C5.98566675,1.70347828 5.85448072,1.86011831 5.69783834,2.00892856 C5.48637112,1.79746134 5.30819309,1.64669531 5.16329887,1.55662594 C5.01840466,1.46655656 4.86176463,1.39802656 4.69337406,1.35103384 C4.5249835,1.30404112 4.34288944,1.28054512 4.14708647,1.28054512 C3.67715931,1.28054512 3.30122322,1.41760516 3.01926691,1.69172931 C2.73731063,1.9658535 2.54151056,2.38878159 2.43186091,2.96052631 L4.85197369,2.96052631 L4.85197369,3.68890978 L2.34962406,3.68890978 C2.34179194,3.77506309 2.33787594,3.89254313 2.33787594,4.04135337 L2.33787594,4.25869359 C2.33787594,4.34093087 2.34570794,4.42512487 2.36137219,4.51127819 L4.85197369,4.51127819 L4.85197369,5.25140978 L2.45535716,5.25140978 C2.55717469,5.77616178 2.74514275,6.16776187 3.01926691,6.42622181 C3.29339109,6.68468175 3.66149519,6.81390978 4.12359022,6.81390978 C4.31156109,6.81390978 4.49169713,6.79041378 4.66400375,6.74342106 C4.83631037,6.69642834 4.99882444,6.62594031 5.15155075,6.53195487 C5.30427709,6.43796947 5.46679112,6.29307741 5.63909775,6.09727444 C5.69392259,6.1677635 5.76441059,6.25195753 5.85056391,6.34985903 C5.93671722,6.4477605 6.01307925,6.55545053 6.07965225,6.67293234 C6.14622528,6.79041412 6.17951128,6.90397816 6.17951128,7.01362781 C6.17951128,7.20159869 6.06594725,7.38565072 5.83881578,7.56578947 C5.61168431,7.73809609 5.34931225,7.86536612 5.05169172,7.94760337 C4.75407119,8.02984062 4.40163109,8.07095866 3.99436091,8.07095866 Z",
    "data-id": "icons_HouseEuro_path"
  })), HouseEuro_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    "data-id": "icons_HouseEuro_path_8"
  }))))));
};

HouseEuro.defaultProps = HouseEuro_defaultProps;
/* harmony default export */ var icons_HouseEuro = (HouseEuro);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseComfort.js
var HouseComfort_jsx = react.createElement;


var HouseComfort_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseComfort = function HouseComfort(_ref) {
  var color = _ref.color;
  return HouseComfort_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseComfort_svg"
  }, HouseComfort_jsx("title", {
    "data-id": "icons_HouseComfort_title"
  }, "Huis Comfort"), HouseComfort_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseComfort_g"
  }, HouseComfort_jsx("g", {
    transform: "translate(-270.000000, -767.000000)",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_HouseComfort_g_3"
  }, HouseComfort_jsx("g", {
    transform: "translate(40.000000, 761.000000)",
    "data-id": "icons_HouseComfort_g_4"
  }, HouseComfort_jsx("g", {
    transform: "translate(230.000000, 6.000000)",
    "data-id": "icons_HouseComfort_g_5"
  }, HouseComfort_jsx("path", {
    d: "M10,1.8125 L1.5625,6.84375 L1.59375,18.375 L17.46875,18.40625 C18,18.40625 18.40625,18 18.40625,17.46875 L18.40625,6.875 L10,1.8125 Z M10,0 L20,6 L19.96875,18.09375 C19.96875,19.125 19.125,19.96875 18.09375,19.96875 L0,19.96875 L0,5.96875 L10,0 Z",
    "data-id": "icons_HouseComfort_path"
  }), HouseComfort_jsx("path", {
    d: "M8.09375,14.21875 C7.96875,14.34375 7.75,14.34375 7.625,14.21875 C7.5625,14.15625 7.53125,14.0625 7.53125,13.96875 C7.53125,13.875 7.59375,13.78125 7.65625,13.71875 L12.75,9.5625 L8.09375,14.21875 Z M6.8125,14.59375 L5.90625,15.5625 L6.25,15.90625 L7.1875,15.03125 C12.3125,16.71875 13.71875,12.40625 13.71875,8.09375 C10.84375,10.5 5.625,9.125 6.8125,14.59375 Z",
    "data-id": "icons_HouseComfort_path_7"
  }))))));
};

HouseComfort.defaultProps = HouseComfort_defaultProps;
/* harmony default export */ var icons_HouseComfort = (HouseComfort);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseAdditionalOptions.js
var HouseAdditionalOptions_jsx = react.createElement;


var HouseAdditionalOptions_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseAdditionalOptions = function HouseAdditionalOptions(_ref) {
  var color = _ref.color;
  return HouseAdditionalOptions_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseAdditionalOptions_svg"
  }, HouseAdditionalOptions_jsx("title", {
    "data-id": "icons_HouseAdditionalOptions_title"
  }, "Huis aanvullende opties"), HouseAdditionalOptions_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseAdditionalOptions_g"
  }, HouseAdditionalOptions_jsx("g", {
    transform: "translate(-302.000000, -767.000000)",
    fill: color,
    "data-id": "icons_HouseAdditionalOptions_g_3"
  }, HouseAdditionalOptions_jsx("g", {
    transform: "translate(302.000000, 767.000000)",
    "data-id": "icons_HouseAdditionalOptions_g_4"
  }, HouseAdditionalOptions_jsx("g", {
    "data-id": "icons_HouseAdditionalOptions_g_5"
  }, HouseAdditionalOptions_jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    fillRule: "nonzero",
    "data-id": "icons_HouseAdditionalOptions_path"
  })), HouseAdditionalOptions_jsx("g", {
    transform: "translate(5.937500, 8.125000)",
    "data-id": "icons_HouseAdditionalOptions_g"
  }, HouseAdditionalOptions_jsx("path", {
    d: "M2.68749996,1.62499998 C2.90624996,1.49999998 3.15624995,1.40624998 3.40624995,1.34374998 L3.40624995,0 L4.31249994,0 C4.65624993,0 4.93749993,0.281249996 4.93749993,0.624999991 L4.93749993,1.40624998 C5.12499993,1.46874998 5.31249992,1.56249998 5.49999992,1.65624998 L6.53124991,0.624999991 L7.1562499,1.24999998 C7.40624989,1.49999998 7.40624989,1.87499997 7.1562499,2.12499997 L6.53124991,2.74999996 C6.6249999,2.90624996 6.6874999,3.09374996 6.7499999,3.28124995 L8.24999988,3.28124995 L8.24999988,4.18749994 C8.24999988,4.53124993 7.96874988,4.81249993 7.62499989,4.81249993 L6.7499999,4.81249993 C6.6874999,4.99999993 6.6249999,5.15624993 6.53124991,5.34374992 L7.46874989,6.28124991 L6.8437499,6.9062499 C6.5937499,7.1562499 6.21874991,7.1562499 5.96874991,6.9062499 L5.49999992,6.43749991 C5.31249992,6.53124991 5.15624993,6.6249999 4.93749993,6.6874999 L4.93749993,8.12499988 L4.06249994,8.12499988 C3.71874995,8.12499988 3.43749995,7.84374989 3.43749995,7.49999989 L3.43749995,6.7812499 C3.21874995,6.7187499 2.99999996,6.6562499 2.78124996,6.53124991 L1.78124997,7.53124989 L1.15624998,6.9062499 C0.906249987,6.6562499 0.906249987,6.28124991 1.15624998,6.03124991 L1.68749998,5.49999992 C1.56249998,5.28124992 1.46874998,5.06249993 1.40624998,4.81249993 L0,4.81249993 L0,3.90624994 C0,3.56249995 0.281249996,3.28124995 0.624999991,3.28124995 L1.37499998,3.28124995 C1.43749998,3.06249996 1.53124998,2.87499996 1.62499998,2.68749996 L0.749999989,1.81249997 L1.37499998,1.18749998 C1.62499998,0.937499986 1.99999997,0.937499986 2.24999997,1.18749998 L2.68749996,1.62499998 Z M4.06249994,5.34374992 C4.74999993,5.34374992 5.34374992,4.78124993 5.34374992,4.06249994 C5.34374992,3.34374995 4.78124993,2.78124996 4.06249994,2.78124996 C3.34374995,2.78124996 2.78124996,3.34374995 2.78124996,4.06249994 C2.78124996,4.78124993 3.37499995,5.34374992 4.06249994,5.34374992 Z",
    fillRule: "nonzero",
    "data-id": "icons_HouseAdditionalOptions_path"
  }))))));
};

HouseAdditionalOptions.defaultProps = HouseAdditionalOptions_defaultProps;
/* harmony default export */ var icons_HouseAdditionalOptions = (HouseAdditionalOptions);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseLivingReady.js
var HouseLivingReady_jsx = react.createElement;


var HouseLivingReady_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseLivingReady = function HouseLivingReady(_ref) {
  var color = _ref.color;
  return HouseLivingReady_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseLivingReady_svg"
  }, HouseLivingReady_jsx("title", {
    "data-id": "icons_HouseLivingReady_title"
  }, "Huis Woonklaar"), HouseLivingReady_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseLivingReady_g"
  }, HouseLivingReady_jsx("g", {
    transform: "translate(-238.000000, -767.000000)",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_HouseLivingReady_g_3"
  }, HouseLivingReady_jsx("g", {
    transform: "translate(238.000000, 767.000000)",
    "data-id": "icons_HouseLivingReady_g_4"
  }, HouseLivingReady_jsx("path", {
    d: "M7.34375,12.28125 L6.15625,11.09375 C5.90625,10.84375 5.53125,10.84375 5.28125,11.09375 L4.34375,12 L7.3125,14.96875 L12.40625,9.84375 L11.5,8.9375 C11.25,8.6875 10.875,8.6875 10.625,8.9375 L7.34375,12.28125 Z",
    "data-id": "icons_HouseLivingReady_path"
  }), HouseLivingReady_jsx("path", {
    d: "M15.90625,14.09375 L15.90625,13.9375 C15.875,13.71875 15.71875,13.5625 15.5,13.5625 L14.34375,13.5625 L14.34375,11.84375 L13.8125,11.84375 L13.625,11.84375 C13.40625,11.875 13.25,12.03125 13.25,12.25 L13.25,13.5625 L11.53125,13.5625 L11.53125,14.09375 L11.53125,14.28125 C11.5625,14.5 11.71875,14.65625 11.9375,14.65625 L13.25,14.65625 L13.25,16.21875 L13.8125,16.21875 L13.96875,16.21875 C14.1875,16.1875 14.34375,16.03125 14.34375,15.8125 L14.34375,14.65625 L15.90625,14.65625 L15.90625,14.09375 Z",
    "data-id": "icons_HouseLivingReady_path_6"
  }), HouseLivingReady_jsx("path", {
    d: "M10,1.8125 L1.5625,6.84375 L1.59375,18.375 L17.46875,18.40625 C18,18.40625 18.40625,18 18.40625,17.46875 L18.40625,6.875 L10,1.8125 Z M10,0 L20,6 L19.96875,18.09375 C19.96875,19.125 19.125,19.96875 18.09375,19.96875 L0,19.96875 L0,5.96875 L10,0 Z",
    "data-id": "icons_HouseLivingReady_path_7"
  })))));
};

HouseLivingReady.defaultProps = HouseLivingReady_defaultProps;
/* harmony default export */ var icons_HouseLivingReady = (HouseLivingReady);
;// CONCATENATED MODULE: ./src/components/shared/icons/HouseOneLayer.js
var HouseOneLayer_jsx = react.createElement;


var HouseOneLayer_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange
};

var HouseOneLayer = function HouseOneLayer(_ref) {
  var color = _ref.color;
  return HouseOneLayer_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseOneLayer_svg"
  }, HouseOneLayer_jsx("title", {
    "data-id": "icons_HouseOneLayer_title"
  }, "Appartement met een verdieping"), HouseOneLayer_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseOneLayer_g"
  }, HouseOneLayer_jsx("g", {
    transform: "translate(-40.000000, -212.000000)",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_HouseOneLayer_g_3"
  }, HouseOneLayer_jsx("g", {
    transform: "translate(40.000000, 212.000000)",
    "data-id": "icons_HouseOneLayer_g_4"
  }, HouseOneLayer_jsx("g", {
    "data-id": "icons_HouseOneLayer_g_5"
  }, HouseOneLayer_jsx("path", {
    d: "M10,0 L0,6 L0,20 L8.40625,20 L8.40625,13.125 L11.53125,13.125 L11.53125,20 L18.09375,20 C19.125,20 19.96875,19.15625 19.96875,18.125 L20,6 L10,0 Z M18.40625,17.5 C18.40625,18.03125 18,18.4375 17.46875,18.4375 L12.78125,18.4375 L12.78125,11.875 L7.15625,11.875 L7.15625,18.375 L7.15625,18.4375 L1.59375,18.4375 L1.5625,6.875 L10,1.84375 L18.40625,6.875 L18.40625,17.5 Z",
    "data-id": "icons_HouseOneLayer_path"
  }))))));
};

HouseOneLayer.defaultProps = HouseOneLayer_defaultProps;
/* harmony default export */ var icons_HouseOneLayer = (HouseOneLayer);
;// CONCATENATED MODULE: ./src/components/shared/designElements/HouseIconsMap.js
var HouseIconsMap_jsx = react.createElement;














var ICONMAPPING = {
  houseEmpty: icons_HouseBase,
  houseGroundFloor: icons_HouseFloor0,
  houseFirstFloor: icons_HouseFloor1,
  houseSecondFloor: icons_HouseFloor2,
  houseThirdFloor: icons_HouseFloor3,
  houseFourthFloor: icons_HouseFloor4,
  houseEllipsis: icons_HouseOptions,
  houseCheck: icons_HouseReady,
  houseEuro: icons_HouseEuro,
  houseLeaf: icons_HouseComfort,
  houseGear: icons_HouseAdditionalOptions,
  houseCheckPlus: icons_HouseLivingReady,
  houseOneLayer: icons_HouseOneLayer
};

var HouseIconsMap = function HouseIconsMap(_ref) {
  var icon = _ref.icon,
      color = _ref.color;
  var Icon = ICONMAPPING[icon];
  return HouseIconsMap_jsx(Icon, {
    color: color,
    "data-id": "designElements_HouseIconsMap_Icon"
  });
};

/* harmony default export */ var designElements_HouseIconsMap = (HouseIconsMap);
;// CONCATENATED MODULE: ./src/components/WishListCard.js








var WishListCard_templateObject, WishListCard_templateObject2, WishListCard_templateObject3, WishListCard_templateObject4, WishListCard_templateObject5, WishListCard_templateObject6, WishListCard_templateObject7, WishListCard_templateObject8, WishListCard_templateObject9, WishListCard_templateObject0, WishListCard_templateObject1, WishListCard_templateObject10, WishListCard_templateObject11, WishListCard_templateObject12, WishListCard_templateObject13, WishListCard_templateObject14, WishListCard_templateObject15, WishListCard_templateObject16, WishListCard_templateObject17, WishListCard_templateObject18, WishListCard_templateObject19, WishListCard_templateObject20;

var WishListCard_jsx = react.createElement;

function WishListCard_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, WishListCard_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function WishListCard_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (WishListCard_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}





















var WishListCard_mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  var wishListId = ownProps.wishList && ownProps.wishList.id;
  return {
    wishListId: wishListId,
    resultWishListFave: (0,apiData/* getResultData */.yh)(state.apiData, 'patchWishList', {
      projectSlug: String(projectSlug),
      wishListId: wishListId
    }),
    patchWishListRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'patchWishList', {
      projectSlug: String(projectSlug),
      wishListId: wishListId
    })
  };
};

var WishListCard_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    duplicateWishlist: function duplicateWishlist(wishListId, title, type) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
        type: 'deleteWishList',
        componentProps: {
          title: title,
          wishListId: wishListId,
          projectSlug: String(projectSlug),
          type: type
        }
      }));
    },
    deleteWishlist: function deleteWishlist(wishListId, title, bnr, type) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
        type: 'deleteWishList',
        componentProps: {
          title: title,
          wishListId: wishListId,
          projectSlug: String(projectSlug),
          bnr: bnr,
          ownBNRWishlists: ownProps.ownBNRWishlists,
          ownBNR: Number(ownProps.ownBNR),
          type: type
        }
      }));
    },
    patchWishlist: function patchWishlist(wishListId, favorite, type) {
      dispatch((0,apiData/* performApiRequest */.T4)('patchWishList', {
        projectSlug: String(projectSlug),
        wishListId: wishListId
      }, {
        isFavorite: !favorite
      }));
    },
    forceFetchWishlists: function forceFetchWishlists() {
      dispatch((0,apiData/* performApiRequest */.T4)('getWishLists', {
        projectSlug: String(projectSlug)
      }, undefined, {
        cache: 'disabled'
      }));
    }
  };
};

var WishListCard = /*#__PURE__*/function (_Component) {
  function WishListCard() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, WishListCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = WishListCard_callSuper(this, WishListCard, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      selected: undefined
    });

    (0,defineProperty/* default */.Z)(_this, "handleEditAction", function (evt, actionObject) {
      var _this$props = _this.props,
          duplicateWishlist = _this$props.duplicateWishlist,
          deleteWishlist = _this$props.deleteWishlist,
          patchWishlist = _this$props.patchWishlist;
      evt.preventDefault();
      evt.stopPropagation();

      switch (actionObject.action) {
        case 'DUPLICATE':
          duplicateWishlist(actionObject.wishListId, String(actionObject.title), actionObject.type);
          break;

        case 'DELETE':
          deleteWishlist(actionObject.wishListId, String(actionObject.title), actionObject.bnr, actionObject.type);
          break;

        case 'FAVORITE':
          patchWishlist(actionObject.wishListId, Boolean(actionObject.favorite), actionObject.type);

          _this.setState({
            selected: actionObject.wishListId
          });

          break;

        default:
          break;
      }
    });

    return _this;
  }

  (0,inherits/* default */.Z)(WishListCard, _Component);

  return (0,createClass/* default */.Z)(WishListCard, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$patchWishL;

      var _this$props2 = this.props,
          patchWishListRequest = _this$props2.patchWishListRequest,
          forceFetchWishlists = _this$props2.forceFetchWishlists;
      var selected = this.state.selected;

      if ((patchWishListRequest && patchWishListRequest.networkStatus === 'success' || patchWishListRequest && patchWishListRequest.networkStatus === 'failed') && selected !== undefined) {
        this.setState({
          selected: undefined
        });
      } // force the parent component to refetch the wishlist endpoint without caching, AFTER a change


      var patchRequestDone = ((_prevProps$patchWishL = prevProps.patchWishListRequest) === null || _prevProps$patchWishL === void 0 ? void 0 : _prevProps$patchWishL.networkStatus) === 'loading' && (patchWishListRequest === null || patchWishListRequest === void 0 ? void 0 : patchWishListRequest.networkStatus) !== 'loading';

      if (patchRequestDone) {
        forceFetchWishlists();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          wishList = _this$props3.wishList,
          match = _this$props3.match,
          router = _this$props3.router,
          ownBNR = _this$props3.ownBNR,
          patchWishListRequest = _this$props3.patchWishListRequest;
      var projectSlug = match.params.projectSlug;
      var _wishList$house = wishList.house,
          bnr = _wishList$house.bnr,
          variantCode = _wishList$house.variantCode;
      var selected = this.state.selected;
      var fullBNR = "Bouwnummer ".concat(bnr, " ").concat(variantCode ? '(' + variantCode + ')' : '');
      var categories = [{
        name: 'base',
        title: 'Basis',
        icon: 'houseEmpty',
        hidePriceDelta: true,
        total: wishList.house.price
      }].concat(wishList.totals.categories);
      var notAvailable = wishList.house.status === 'sold' && wishList.house.hasCustomer;
      var isSold = wishList.house.status === 'sold';
      var wishListUrl = "/".concat(projectSlug, "/closed/homestudio/").concat(wishList.id);
      return wishList && wishList.totals ? WishListCard_jsx(WishListCard_Card, {
        isSelected: this.state.selected === wishList.id,
        "data-e2e-wishlistcard": true,
        "data-e2e-wishlistcard-id": wishList.id,
        "data-e2e-wishlistcard-favorite": wishList.isFavorite,
        "data-id": "components_WishListCard_Card"
      }, selected === wishList.id && (patchWishListRequest === null || patchWishListRequest === void 0 ? void 0 : patchWishListRequest.networkStatus) === 'loading' && WishListCard_jsx(WishListCard_SpinnerContainer, {
        "data-id": "components_WishListCard_SpinnerContainer"
      }, WishListCard_jsx(Spinner/* default */.Z, {
        monochrome: true,
        color: styleGuide/* colorPalette.blue */.K5.blue,
        size: "small",
        "data-id": "components_WishListCard_Spinner"
      })), WishListCard_jsx(WishListCard_LinkElement, {
        href: wishListUrl,
        onClick: function onClick(evt) {
          if (ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable) {
            _this2.handleEditAction(evt, {
              action: 'DELETE',
              wishListId: wishList.id,
              title: wishList.title,
              bnr: wishList.house.bnr,
              type: 'confirmation'
            });
          }
        },
        "data-id": "components_WishListCard_LinkElement"
      }, WishListCard_jsx(WishListCard_ImageContainer, {
        notAvailable: ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable,
        sold: ownBNR ? isSold && wishList.house.bnr !== ownBNR : isSold,
        "data-id": "components_WishListCard_ImageContainer"
      }, wishList.image && WishListCard_jsx(ImageLoader/* default */.Z, {
        src: wishList.image.image.src,
        width: 380,
        height: 0,
        mode: "bg",
        position: "absolute",
        scaleTransition: true,
        "data-id": "components_WishListCard_ImageLoader"
      }), isSold && WishListCard_jsx(WishListCard_PriceTagContainer, {
        "data-id": "components_WishListCard_PriceTagContainer"
      }, !wishList.house.hasCustomer && WishListCard_jsx(designElements_PriceTag, {
        isSold: true,
        small: false,
        "data-id": "components_WishListCard_PriceTag"
      }), (ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable) && WishListCard_jsx("div", {
        "data-id": "components_WishListCard_div"
      }, WishListCard_jsx("p", {
        "data-id": "components_WishListCard_p"
      }, "Niet meer beschikbaar"), WishListCard_jsx(DeleteIconButton, {
        onClick: function onClick(evt) {
          return _this2.handleEditAction(evt, {
            action: 'DELETE',
            wishListId: wishList.id,
            title: wishList.title,
            bnr: wishList.house.bnr,
            type: 'delete'
          });
        },
        "data-id": "components_WishListCard_DeleteIconButton"
      }, WishListCard_jsx(icons_Delete, {
        "data-id": "components_WishListCard_DeleteIcon"
      }), "Verwijderen"))), !(ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable) && WishListCard_jsx(InteractContainer, {
        "data-id": "components_WishListCard_InteractContainer"
      }, WishListCard_jsx(FavoriteIconWrapper, {
        onClick: function onClick(evt) {
          return _this2.handleEditAction(evt, {
            action: 'FAVORITE',
            wishListId: wishList.id,
            favorite: wishList.isFavorite,
            type: 'favo'
          });
        },
        "data-e2e-wishlistcard-actions-favorite": true,
        "data-id": "components_WishListCard_FavoriteIconWrapper"
      }, WishListCard_jsx(icons_Favorite, {
        filled: wishList.isFavorite,
        "data-id": "components_WishListCard_FavoriteIcon"
      })), WishListCard_jsx(DuplicateIconWrapper, {
        onClick: function onClick(evt) {
          return _this2.handleEditAction(evt, {
            action: 'DUPLICATE',
            wishListId: wishList.id,
            title: wishList.title,
            type: 'copy'
          });
        },
        "data-e2e-wishlistcard-actions-duplicate": true,
        "data-id": "components_WishListCard_DuplicateIconWrapper"
      }, WishListCard_jsx(Copy, {
        "data-id": "components_WishListCard_DuplicateIcon"
      })), WishListCard_jsx(DeleteIconWrapper, {
        onClick: function onClick(evt) {
          return _this2.handleEditAction(evt, {
            action: 'DELETE',
            wishListId: wishList.id,
            title: wishList.title,
            bnr: wishList.house.bnr,
            type: 'delete'
          });
        },
        "data-e2e-wishlistcard-actions-delete": true,
        "data-id": "components_WishListCard_DeleteIconWrapper"
      }, WishListCard_jsx(icons_Delete, {
        "data-id": "components_WishListCard_DeleteIcon"
      })))), WishListCard_jsx(WishListCard_TextContainer, {
        "data-id": "components_WishListCard_TextContainer"
      }, WishListCard_jsx(WishListCard_Title, {
        notAvailable: ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable,
        "data-id": "components_WishListCard_Title"
      }, truncateText(wishList.title, 50)), WishListCard_jsx(BuildingSummary, {
        "data-id": "components_WishListCard_BuildingSummary"
      }, WishListCard_jsx("span", {
        "data-id": "components_WishListCard_span"
      }, fullBNR), wishList.livingSpace, " m\xB2 woonoppervlakte, ", wishList.bedrooms, " slaapkamers"), WishListCard_jsx(CatList, {
        "data-id": "components_WishListCard_CatList"
      }, categories.map(function (category, index) {
        return WishListCard_jsx(CatItem, {
          key: index,
          "data-id": "components_WishListCard_CatItem"
        }, WishListCard_jsx(WishListCard_IconWrapper, {
          "data-id": "components_WishListCard_IconWrapper"
        }, WishListCard_jsx(designElements_HouseIconsMap, {
          icon: category.icon,
          color: (ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable) ? styleGuide/* colorPalette.lightBeige */.K5.lightBeige : styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
          "data-id": "components_WishListCard_HouseIconsMap"
        })), category.title, WishListCard_jsx(WishListCard_PriceContainer, {
          "data-id": "components_WishListCard_PriceContainer"
        }, WishListCard_jsx(WishListCard_Plus, {
          "data-id": "components_WishListCard_Plus"
        }, category.hidePriceDelta ? '' : category.total > 0 ? '+' : category.total === 0 ? '' : '-'), "\u20AC", WishListCard_jsx(WishListCard_Price, {
          "data-id": "components_WishListCard_Price"
        }, formatPrice(category.total, {
          showDecimal: true,
          showEuroSign: false
        }))));
      })), WishListCard_jsx(WishListCard_Footer, {
        "data-id": "components_WishListCard_Footer"
      }, WishListCard_jsx(designElements_WishlistFooter, {
        userWishTotal: wishList.totals.userWishTotal,
        price: wishList.price,
        small: true,
        notAvailable: ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable,
        "data-id": "components_WishListCard_WishlistFooter"
      }))))) : null;
    }
  }]);
}(react.Component);

/* harmony default export */ var components_WishListCard = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(WishListCard_mapStateToProps, WishListCard_mapDispatchToProps)(WishListCard)));
var WishListCard_Card = styled_components_browser_esm["default"].div(WishListCard_templateObject || (WishListCard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  transition: opacity 0.25s ease-in-out;\n  opacity: ", ";\n  filter: ", ";\n  position: relative;\n"])), function (props) {
  return props.isSelected ? '0.5' : '1';
}, function (props) {
  return props.notAvailable ? 'grayscale(100%)' : 'grayscale(0%)';
});
var WishListCard_SpinnerContainer = styled_components_browser_esm["default"].div(WishListCard_templateObject2 || (WishListCard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  z-index: 9;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var buttonStyling = (0,styled_components_browser_esm.css)(WishListCard_templateObject3 || (WishListCard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  right: 20rem;\n  top: 20rem;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1);\n  background: none;\n  border: none;\n\n  &:hover {\n    transform: scale(1.2);\n  }\n"])));
var FavoriteIconWrapper = styled_components_browser_esm["default"].button(WishListCard_templateObject4 || (WishListCard_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n"])), buttonStyling);
var DuplicateIconWrapper = styled_components_browser_esm["default"].button(WishListCard_templateObject5 || (WishListCard_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  top: 52rem;\n"])), buttonStyling);
var DeleteIconWrapper = styled_components_browser_esm["default"].button(WishListCard_templateObject6 || (WishListCard_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  top: 83rem;\n"])), buttonStyling);
var DeleteIconButton = styled_components_browser_esm["default"].div(WishListCard_templateObject7 || (WishListCard_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 14rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  transition: transform 0.2s ease-in-out;\n  transform: scale(1);\n\n  &:hover {\n    transform: scale(1.2);\n  }\n\n  > svg {\n    margin-right: 10rem;\n  }\n"])));
var WishListCard_PriceTagContainer = styled_components_browser_esm["default"].div(WishListCard_templateObject8 || (WishListCard_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  z-index: 2;\n  ", ";\n  font-weight: bold;\n  color: white;\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    > p {\n      margin-top: 0;\n      text-transform: uppercase;\n    }\n  }\n"])), styleGuide/* textStyles.standardText */.sq.standardText);
var InteractContainer = styled_components_browser_esm["default"].div(WishListCard_templateObject9 || (WishListCard_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 95rem;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  z-index: 2;\n\n  &:before {\n    content: '';\n    opacity: 0.5;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);\n  }\n"])));
var WishListCard_Footer = styled_components_browser_esm["default"].div(WishListCard_templateObject0 || (WishListCard_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 6rem;\n"])));
var WishListCard_Plus = styled_components_browser_esm["default"].span(WishListCard_templateObject1 || (WishListCard_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  left: 0;\n"])));
var WishListCard_PriceContainer = styled_components_browser_esm["default"].div(WishListCard_templateObject10 || (WishListCard_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-left: 16rem;\n  width: 100rem;\n  position: absolute;\n  top: 0;\n  right: 0;\n"])));
var WishListCard_IconWrapper = styled_components_browser_esm["default"].div(WishListCard_templateObject11 || (WishListCard_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  left: 0;\n"])));
var WishListCard_ImageContainer = styled_components_browser_esm["default"].div(WishListCard_templateObject12 || (WishListCard_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  top: 0;\n  left: 0;\n  height: 215rem;\n  width: 100%;\n  position: absolute;\n  overflow: hidden;\n  > div {\n    &:nth-of-type(1) {\n      filter: ", ";\n      > div {\n        filter: ", ";\n      }\n    }\n  }\n"])), function (props) {
  return props.notAvailable ? 'grayscale(100%)' : props.sold ? 'brightness(85%)' : 'contrast(100%)';
}, function (props) {
  return props.notAvailable ? 'brightness(70%)' : 'none';
});
var WishListCard_LinkElement = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(WishListCard_templateObject13 || (WishListCard_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-decoration: none;\n  background-color: #ffffff;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  padding-top: 215rem;\n  padding-bottom: 24rem;\n  ", ";\n  transition: box-shadow 0.25s ease;\n\n  &:hover {\n    ", ";\n\n    ", " > div:first-of-type {\n      transform: scale(1.03) translateZ(0);\n    }\n  }\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, styleGuide/* shadows.boxPrimaryHover */.q.boxPrimaryHover, WishListCard_ImageContainer);
var WishListCard_TextContainer = styled_components_browser_esm["default"].div(WishListCard_templateObject14 || (WishListCard_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0 20rem;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var WishListCard_Title = styled_components_browser_esm["default"].h3(WishListCard_templateObject15 || (WishListCard_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 25rem;\n  margin-bottom: 20rem;\n\n  ", ";\n"])), styleGuide/* textStyles.title */.sq.title, function (props) {
  return props.notAvailable ? '#696259' : styleGuide/* colorPalette.orange */.K5.orange;
}, breakpoints/* fromBreakpoint.md */.ks.md(WishListCard_templateObject16 || (WishListCard_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: -20rem;\n    height: 90rem;\n  "]))));
var BuildingSummary = styled_components_browser_esm["default"].p(WishListCard_templateObject17 || (WishListCard_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  display: flex;\n  flex-direction: column;\n  color: ", ";\n  margin-top: 0rem;\n  margin-bottom: 24rem;\n\n  > span {\n    font-weight: bold;\n  }\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var CatList = styled_components_browser_esm["default"].ul(WishListCard_templateObject18 || (WishListCard_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  padding: 0;\n  margin-top: 0;\n  list-style: none;\n  margin-bottom: auto;\n"])), styleGuide/* textStyles.standardText */.sq.standardText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var CatItem = styled_components_browser_esm["default"].li(WishListCard_templateObject19 || (WishListCard_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  padding-left: 30rem;\n  padding-right: 110rem;\n  margin-bottom: 14rem;\n"])));
var WishListCard_Price = styled_components_browser_esm["default"].span(WishListCard_templateObject20 || (WishListCard_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  right: 10rem;\n"])));
;// CONCATENATED MODULE: ./src/components/MakeWishListCard.js







var MakeWishListCard_templateObject, MakeWishListCard_templateObject2, MakeWishListCard_templateObject3, MakeWishListCard_templateObject4;

var MakeWishListCard_jsx = react.createElement;

function MakeWishListCard_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, MakeWishListCard_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function MakeWishListCard_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (MakeWishListCard_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}











var MakeWishListCard_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env;
  return {
    logoUrl: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'logoUrl', undefined),
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'phase', undefined),
    houseId: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'user.customer.houseId', undefined),
    wishLists: (0,apiData/* getResultData */.yh)(state.apiData, 'getWishLists', {
      projectSlug: String(projectSlug)
    }),
    postWishListRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    })
  };
};

var MakeWishListCard_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    handleClick: function handleClick(evt, phase, priceListBlockId, houseId) {
      evt.preventDefault();

      if (phase === 'cj1') {
        dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
          type: 'pricelist',
          componentProps: {
            projectSlug: String(projectSlug),
            priceListBlockId: priceListBlockId
          }
        }));
      } else {
        // immediately start a new design for house that customer is bound to
        dispatch((0,apiData/* performApiRequest */.T4)('postWishList', {
          projectSlug: String(projectSlug)
        }, {
          house: houseId
        }));
        dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getWishLists', {
          projectSlug: String(projectSlug)
        }));
      }
    }
  };
};

var MakeWishListCard = /*#__PURE__*/function (_Component) {
  function MakeWishListCard() {
    (0,classCallCheck/* default */.Z)(this, MakeWishListCard);

    return MakeWishListCard_callSuper(this, MakeWishListCard, arguments);
  }

  (0,inherits/* default */.Z)(MakeWishListCard, _Component);

  return (0,createClass/* default */.Z)(MakeWishListCard, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          match = _this$props.match,
          postWishListRequest = _this$props.postWishListRequest,
          router = _this$props.router;

      if (postWishListRequest && postWishListRequest.networkStatus === 'success') {
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed/homestudio/").concat(String(postWishListRequest.result)));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          handleClick = _this$props2.handleClick,
          houseId = _this$props2.houseId,
          phase = _this$props2.phase,
          priceListBlockId = _this$props2.priceListBlockId,
          wishLists = _this$props2.wishLists,
          logoUrl = _this$props2.logoUrl;
      return MakeWishListCard_jsx(MakeWishListCard_Card, {
        "data-e2e-card-makewishlistcard": true,
        onClick: function onClick(evt) {
          return phase ? handleClick(evt, phase, priceListBlockId, houseId) : undefined;
        },
        "data-id": "components_MakeWishListCard_Card"
      }, MakeWishListCard_jsx(MakeWishListCard_Logo, {
        src: logoUrl,
        "data-id": "components_MakeWishListCard_Logo"
      }), MakeWishListCard_jsx(CreateCTA, {
        "data-id": "components_MakeWishListCard_CreateCTA"
      }, MakeWishListCard_jsx(MakeWishListCard_Icon, {
        "data-id": "components_MakeWishListCard_Icon"
      }, MakeWishListCard_jsx(icons_Plus, {
        "data-id": "components_MakeWishListCard_PlusIcon"
      })), wishLists && wishLists.length ? 'Maak een nieuw woonontwerp' : 'Maak een woonontwerp'));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_MakeWishListCard = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(MakeWishListCard_mapStateToProps, MakeWishListCard_mapDispatchToProps)(MakeWishListCard)));
var MakeWishListCard_Card = styled_components_browser_esm["default"].div(MakeWishListCard_templateObject || (MakeWishListCard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 20rem;\n  position: relative;\n  min-height: 500rem;\n  cursor: pointer;\n  border: 1rem dashed #979797;\n  background-color: transparent;\n  transition: background-color 0.2s ease-in-out;\n\n  &:hover {\n    background: #fff;\n    > img {\n      filter: grayscale(0%);\n    }\n    > div {\n      color: ", ";\n\n      > span {\n        background-color: ", ";\n      }\n    }\n  }\n"])), styleGuide/* colorPalette.darkBlue */.K5.darkBlue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue);
var MakeWishListCard_Logo = styled_components_browser_esm["default"].img(MakeWishListCard_templateObject2 || (MakeWishListCard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 220rem;\n  height: auto;\n  filter: grayscale(100%);\n  background-blend-mode: multiply;\n"])));
var CreateCTA = styled_components_browser_esm["default"].div(MakeWishListCard_templateObject3 || (MakeWishListCard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n  text-align: center;\n  ", ";\n  font-weight: bold;\n  text-decoration: none;\n  color: ", ";\n  transition: color 0.2s ease-in-out;\n  justify-content: center;\n  margin-top: 40rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, styleGuide/* colorPalette.blue */.K5.blue);
var MakeWishListCard_Icon = styled_components_browser_esm["default"].span(MakeWishListCard_templateObject4 || (MakeWishListCard_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 26rem;\n  height: 26rem;\n  background-color: ", ";\n  transition: background-color 0.2s ease-in-out;\n  box-sizing: border-box;\n  padding: 7rem;\n  margin-right: 12rem;\n  border-radius: 50%;\n"])), styleGuide/* colorPalette.lightBlue */.K5.lightBlue);
// EXTERNAL MODULE: ./node_modules/lodash.partition/index.js
var lodash_partition = __webpack_require__(46748);
var lodash_partition_default = /*#__PURE__*/__webpack_require__.n(lodash_partition);
// EXTERNAL MODULE: ./src/components/atoms/ErrorBoundaryWithSentry.tsx + 2 modules
var ErrorBoundaryWithSentry = __webpack_require__(8942);
;// CONCATENATED MODULE: ./src/components/WishListCollection.js










var WishListCollection_templateObject, WishListCollection_templateObject2, WishListCollection_templateObject3, WishListCollection_templateObject4, WishListCollection_templateObject5, WishListCollection_templateObject6, WishListCollection_templateObject7, WishListCollection_templateObject8, WishListCollection_templateObject9;

var WishListCollection_excluded = ["children"];
var WishListCollection_jsx = react.createElement;

function WishListCollection_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, WishListCollection_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function WishListCollection_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (WishListCollection_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


















var WishListCollection_connectApiData = (0,withApiData/* default */.Z)({
  wishLists: 'getWishLists'
}, function (ownProps) {
  return {
    wishLists: {
      projectSlug: ownProps.match.params.projectSlug
    }
  };
});

var WishListCollection_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'user', {})
  };
};

var WishListCollection_Fade = function Fade(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, WishListCollection_excluded);

  return WishListCollection_jsx(react_transition_group.CSSTransition, (0,esm_extends/* default */.Z)({}, props, {
    timeout: 1000,
    classNames: "fade",
    "data-id": "components_WishListCollection_CSSTransition"
  }), children);
};

var WishListCollection = /*#__PURE__*/function (_Component) {
  function WishListCollection() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, WishListCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = WishListCollection_callSuper(this, WishListCollection, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      items: [],
      itemsOwnBnr: [],
      itemsOtherBnr: [],
      loaded: false,
      expanded: false
    });

    (0,defineProperty/* default */.Z)(_this, "initializeItems", function (newProps, prevProps) {
      var user = newProps.user,
          wishLists = newProps.wishLists;

      if (wishLists.request.networkStatus === 'success' && !_this.state.loaded) {
        _this.setState({
          loaded: true
        });
      }

      if (wishLists.request.networkStatus === 'success' && !lodash_isequal_default()(newProps, prevProps)) {
        var partitionedWishlists = lodash_partition_default()(wishLists.data, function (wishList) {
          return !user.customer || wishList.house.bnr === lodash_get_default()(user, 'customer.bnr');
        });

        _this.setState({
          items: (partitionedWishlists[0] || []).concat({
            id: 0,
            type: 'newWishlist'
          }),
          itemsOwnBnr: partitionedWishlists[0],
          itemsOtherBnr: partitionedWishlists[1]
        });
      }
    });

    (0,defineProperty/* default */.Z)(_this, "expand", function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(WishListCollection, _Component);

  return (0,createClass/* default */.Z)(WishListCollection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeItems(this.props, {});
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.initializeItems(this.props, prevProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          user = _this$props.user,
          priceListBlockId = _this$props.priceListBlockId;
      var _this$state = this.state,
          loaded = _this$state.loaded,
          items = _this$state.items,
          itemsOwnBnr = _this$state.itemsOwnBnr,
          itemsOtherBnr = _this$state.itemsOtherBnr,
          expanded = _this$state.expanded;
      return loaded ? WishListCollection_jsx(WishListCollection_Container, {
        expanded: expanded,
        "data-e2e-block-wishlist-collection": true,
        "data-id": "components_WishListCollection_Container"
      }, WishListCollection_jsx(ErrorBoundaryWithSentry/* default */.Z, {
        "data-id": "components_WishListCollection_ErrorBoundaryWithSentry"
      }, WishListCollection_jsx(react_transition_group.TransitionGroup, {
        "data-id": "components_WishListCollection_TransitionGroup"
      }, items.map(function (item) {
        return WishListCollection_jsx(WishListCollection_Fade, {
          key: item.id,
          "data-id": "components_WishListCollection_Fade"
        }, WishListCollection_jsx(Column, {
          "data-id": "components_WishListCollection_Column"
        }, item.type !== 'newWishlist' ? WishListCollection_jsx(components_WishListCard, {
          wishList: item,
          ownBNR: user.customer && user.customer.bnr ? user.customer.bnr : null,
          ownBNRWishlists: itemsOwnBnr.length,
          "data-id": "components_WishListCollection_WishListCard"
        }) : WishListCollection_jsx(components_MakeWishListCard, {
          priceListBlockId: priceListBlockId,
          "data-id": "components_WishListCollection_MakeWishListCard"
        })));
      })), user.customer && itemsOtherBnr.length > 0 && WishListCollection_jsx(react.Fragment, null, WishListCollection_jsx(WishListCollection_Bar, {
        onClick: this.expand,
        "data-id": "components_WishListCollection_Bar"
      }, WishListCollection_jsx("div", {
        "data-id": "components_WishListCollection_div"
      }, WishListCollection_jsx(ExpansionTitle, {
        expanded: expanded,
        "data-id": "components_WishListCollection_ExpansionTitle"
      }, "Woonontwerpen voor de overige woningen (", itemsOtherBnr.length, ")"), WishListCollection_jsx(WishListCollection_CaretContainer, {
        expanded: expanded,
        "data-id": "components_WishListCollection_CaretContainer"
      }, WishListCollection_jsx(Caret/* default */.Z, {
        color: expanded ? styleGuide/* colorPalette.darkBlue */.K5.darkBlue : styleGuide/* colorPalette.blue */.K5.blue,
        direction: "down",
        "data-id": "components_WishListCollection_Caret"
      })))), WishListCollection_jsx("div", {
        "data-id": "components_WishListCollection_div"
      }, WishListCollection_jsx(react_transition_group.TransitionGroup, {
        "data-id": "components_WishListCollection_TransitionGroup"
      }, itemsOtherBnr.map(function (item) {
        return WishListCollection_jsx(WishListCollection_Fade, {
          key: item.id,
          "data-id": "components_WishListCollection_Fade"
        }, WishListCollection_jsx(Column, {
          "data-id": "components_WishListCollection_Column"
        }, WishListCollection_jsx(components_WishListCard, {
          wishList: item,
          ownBNR: user.customer && user.customer.bnr ? user.customer.bnr : null,
          ownBNRWishlists: itemsOwnBnr.length,
          "data-id": "components_WishListCollection_WishListCard"
        })));
      })))))) : WishListCollection_jsx(WishListCollection_Container, {
        "data-id": "components_WishListCollection_Container"
      }, WishListCollection_jsx(ContentLoader/* default */.Z, {
        "data-id": "components_WishListCollection_ContentLoader"
      }));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_WishListCollection = ((0,withMatch/* default */.Z)(WishListCollection_connectApiData((0,es/* connect */.$j)(WishListCollection_mapStateToProps)(WishListCollection))));
var WishListCollection_Container = styled_components_browser_esm["default"].div(WishListCollection_templateObject || (WishListCollection_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  > div {\n    &:nth-of-type(1) {\n      display: flex;\n      width: 100%;\n      box-sizing: border-box;\n      flex-flow: row wrap;\n    }\n    &:nth-of-type(3) {\n      display: flex;\n      justify-content: center;\n      position: relative;\n      background-color: ", ";\n      width: 100vw;\n      left: calc(-50vw + 50%);\n      padding-bottom: ", "rem;\n      overflow: hidden;\n      height: ", ";\n\n      > div {\n        display: flex;\n        width: 1180rem;\n        box-sizing: border-box;\n        flex-flow: row wrap;\n        ", ";\n\n        > div {\n          opacity: ", ";\n          transition: opacity 0.25s ease-in-out;\n          transition-delay: 0.1s;\n        }\n      }\n    }\n  }\n\n  .fade-enter {\n    opacity: 0.01;\n  }\n\n  .fade-enter.fade-enter-active {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n    transition: all 1000ms ", ";\n  }\n\n  .fade-exit {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  .fade-exit.fade-exit-active {\n    opacity: 0.01;\n    transform: translate3d(0, -30rem, 0);\n    transition: all 800ms ", ";\n  }\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, function (props) {
  return props.expanded ? 40 : 0;
}, function (props) {
  return !props.expanded ? 0 : "auto";
}, breakpoints/* toBreakpoint.slg */.Hx.slg(WishListCollection_templateObject2 || (WishListCollection_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n          padding: 0 20px;\n        "]))), function (props) {
  return props.expanded ? 1 : 0;
}, styleGuide/* CUBIC_TIMING */.I5, styleGuide/* CUBIC_TIMING */.I5);
var Column = styled_components_browser_esm["default"].div(WishListCollection_templateObject3 || (WishListCollection_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n  margin-bottom: 20rem;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(WishListCollection_templateObject4 || (WishListCollection_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc( ((1/2) * 100%) - 10rem );\n\n    &:nth-of-type(2n + 1) {\n      margin-right: 20rem;\n    }\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(WishListCollection_templateObject5 || (WishListCollection_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc( ((1/3) * 100%) - 13.333rem );\n\n    &:nth-of-type(3n + 2) {\n      margin-right: 20rem;\n    }\n\n    &:nth-of-type(3n + 1) {\n      margin-right: 20rem;\n    }\n\n    &:nth-of-type(3n) {\n      margin-right: 0;\n    }\n  "]))));
var WishListCollection_Bar = styled_components_browser_esm["default"].div(WishListCollection_templateObject6 || (WishListCollection_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  background-color: ", ";\n  width: 100vw;\n  left: calc(-50vw + 50%);\n  margin-top: 40px;\n\n  > div {\n    width: 1180rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    ", ";\n  }\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, breakpoints/* toBreakpoint.slg */.Hx.slg(WishListCollection_templateObject7 || (WishListCollection_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding: 0 20px;\n    "]))));
var ExpansionTitle = styled_components_browser_esm["default"].h3(WishListCollection_templateObject8 || (WishListCollection_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  transition: color 0.25s;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, function (props) {
  return props.expanded ? styleGuide/* colorPalette.darkBlue */.K5.darkBlue : styleGuide/* colorPalette.blue */.K5.blue;
});
var WishListCollection_CaretContainer = styled_components_browser_esm["default"].div(WishListCollection_templateObject9 || (WishListCollection_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  transform: rotateX(", "deg);\n  transition: transform 0.25s;\n  padding-left: 15rem;\n"])), function (props) {
  return props.expanded ? 180 : 0;
});
;// CONCATENATED MODULE: ./src/components/FeedbackBlock.js








var FeedbackBlock_templateObject, FeedbackBlock_templateObject2, FeedbackBlock_templateObject3, FeedbackBlock_templateObject4, FeedbackBlock_templateObject5, FeedbackBlock_templateObject6, FeedbackBlock_templateObject7, FeedbackBlock_templateObject8, FeedbackBlock_templateObject9, FeedbackBlock_templateObject0, FeedbackBlock_templateObject1;

var FeedbackBlock_jsx = react.createElement;

function FeedbackBlock_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, FeedbackBlock_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function FeedbackBlock_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (FeedbackBlock_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function FeedbackBlock_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function FeedbackBlock_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? FeedbackBlock_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FeedbackBlock_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var FeedbackBlock_mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    feedbackResponseData: (0,apiData/* getResultData */.yh)(state.apiData, 'postFeedback', {
      projectSlug: String(projectSlug)
    }),
    feedbackRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postFeedback', {
      projectSlug: String(projectSlug)
    })
  };
};

var FeedbackBlock_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openModal: function openModal(actions) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, actions));
    },
    onSendFeedback: function onSendFeedback(projectSlug, feedbackValues) {
      dispatch((0,apiData/* performApiRequest */.T4)('postFeedback', {
        projectSlug: projectSlug
      }, FeedbackBlock_objectSpread({}, feedbackValues)));
    },
    clearRequest: function clearRequest(projectSlug) {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postFeedback', {
        projectSlug: projectSlug
      }));
    }
  };
};

var FeedbackBlock = /*#__PURE__*/function (_Component) {
  function FeedbackBlock() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, FeedbackBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = FeedbackBlock_callSuper(this, FeedbackBlock, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      feedbackType: ''
    });

    (0,defineProperty/* default */.Z)(_this, "handleClick", function (feedbackType) {
      var _this$props = _this.props,
          onSendFeedback = _this$props.onSendFeedback,
          match = _this$props.match;

      _this.setState({
        feedbackType: feedbackType
      });

      onSendFeedback(String(match.params.projectSlug), {
        value: feedbackType === 'like' ? 1 : -1
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(FeedbackBlock, _Component);

  return (0,createClass/* default */.Z)(FeedbackBlock, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          match = _this$props2.match,
          feedbackResponseData = _this$props2.feedbackResponseData,
          feedbackRequest = _this$props2.feedbackRequest,
          openModal = _this$props2.openModal,
          clearRequest = _this$props2.clearRequest;

      if (feedbackResponseData && feedbackRequest && feedbackRequest.networkStatus === 'success') {
        var feedbackId = feedbackResponseData.id;
        var feedbackType = this.state.feedbackType;
        var positive = prevProps.positive,
            negative = prevProps.negative,
            thanks = prevProps.thanks;

        if (feedbackType === 'like' || feedbackType === 'dislike') {
          openModal({
            type: 'feedback',
            componentProps: {
              feedbackId: feedbackId,
              feedbackType: feedbackType,
              positive: positive,
              negative: negative,
              thanks: thanks
            }
          });
          clearRequest(String(match.params.projectSlug));
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var question = this.props.question;
      return FeedbackBlock_jsx(FeedbackBlock_Block, {
        "data-e2e-block-feedback": true,
        "data-id": "components_FeedbackBlock_Block"
      }, FeedbackBlock_jsx(FeedbackBlock_Actions, {
        "data-id": "components_FeedbackBlock_Actions"
      }, FeedbackBlock_jsx(FeedbackBlock_Button, {
        type: "like",
        onClick: function onClick() {
          return _this2.handleClick('like');
        },
        "data-e2e-feedback-button-like": true,
        "data-id": "components_FeedbackBlock_Button"
      }, FeedbackBlock_jsx(icons_Like, {
        "data-id": "components_FeedbackBlock_LikeIcon"
      })), FeedbackBlock_jsx(FeedbackBlock_Button, {
        type: "dislike",
        onClick: function onClick() {
          return _this2.handleClick('dislike');
        },
        "data-e2e-feedback-button-dislike": true,
        "data-id": "components_FeedbackBlock_Button"
      }, FeedbackBlock_jsx(icons_Like, {
        "data-id": "components_FeedbackBlock_LikeIcon"
      }))), FeedbackBlock_jsx(FeedbackBlock_TextContainer, {
        "data-id": "components_FeedbackBlock_TextContainer"
      }, FeedbackBlock_jsx(FeedbackBlock_Title, {
        "data-id": "components_FeedbackBlock_Title"
      }, question.title), FeedbackBlock_jsx(FeedbackBlock_Description, {
        "data-id": "components_FeedbackBlock_Description"
      }, question.description)));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_FeedbackBlock = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(FeedbackBlock_mapStateToProps, FeedbackBlock_mapDispatchToProps)(FeedbackBlock)));
var FeedbackBlock_Actions = styled_components_browser_esm["default"].div(FeedbackBlock_templateObject || (FeedbackBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  top: -20rem;\n  position: relative;\n  margin-bottom: -5rem;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(FeedbackBlock_templateObject2 || (FeedbackBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: absolute;\n    top: -10rem;\n    left: 20rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(FeedbackBlock_templateObject3 || (FeedbackBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    left: 75rem;\n  "]))));
var FeedbackBlock_Button = styled_components_browser_esm["default"].button(FeedbackBlock_templateObject4 || (FeedbackBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 60rem;\n  height: 60rem;\n  background-color: ", ";\n  transition: background-color 0.3s ease-in-out;\n  border-radius: 50%;\n  box-sizing: border-box;\n  border: 4rem solid #ffffff;\n  position: relative;\n  margin: 0 6rem;\n\n  > svg {\n    transition: transform 0.1s ease-in-out;\n    transform: scale(1);\n    position: relative;\n    transform-origin: center center;\n    will-change: transform;\n  }\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, function (props) {
  return props.type === 'like' ? "\n    top: -20rem;\n\n    > svg {\n      top: 2rem;\n    }\n\n    &:hover {\n      background-color: ".concat(styleGuide/* colorPalette.darkGreen */.K5.darkGreen, ";\n\n      > svg {\n        transform: scale(1.1)\n      }\n    }\n\n    &:active {\n      background-color: ").concat((0,utils/* darken */._j)(styleGuide/* colorPalette.darkGreen */.K5.darkGreen, 10), ";\n    }\n\n  ") : "\n    > svg {\n     transform: scale(1) rotate(180deg);\n     top: 4rem;\n    }\n\n    &:hover {\n      background-color: ".concat(styleGuide/* colorPalette.darkOrange */.K5.darkOrange, ";\n\n      > svg {\n        transform: scale(1.1) rotate(180deg);\n      }\n    }\n\n    &:active {\n      background-color: ").concat((0,utils/* darken */._j)(styleGuide/* colorPalette.darkOrange */.K5.darkOrange, 10), ";\n    }\n  ");
}, breakpoints/* fromBreakpoint.md */.ks.md(FeedbackBlock_templateObject5 || (FeedbackBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n  "])), function (props) {
  return props.type === 'like' ? "" : "\n      left: -25rem;\n      bottom: -30rem;\n    ";
}));
var FeedbackBlock_TextContainer = styled_components_browser_esm["default"].section(FeedbackBlock_templateObject6 || (FeedbackBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var FeedbackBlock_Title = styled_components_browser_esm["default"].h3(FeedbackBlock_templateObject7 || (FeedbackBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 18rem;\n  line-height: 26rem;\n  color: #ffffff;\n  margin-top: 0;\n  margin-bottom: 5rem;\n"])), styleGuide/* fonts.primary */.Rq.primary);
var FeedbackBlock_Description = styled_components_browser_esm["default"].p(FeedbackBlock_templateObject8 || (FeedbackBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0;\n  color: #ffffff;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 18rem;\n  line-height: 26rem;\n"])), styleGuide/* fonts.primary */.Rq.primary);
var FeedbackBlock_Block = styled_components_browser_esm["default"].div(FeedbackBlock_templateObject9 || (FeedbackBlock_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  min-height: 100rem;\n  margin-bottom: -10rem;\n  box-sizing: border-box;\n  background-color: ", ";\n  padding: 0 20rem 20rem 20rem;\n  top: -20rem;\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.lightGreen */.K5.lightGreen, breakpoints/* fromBreakpoint.md */.ks.md(FeedbackBlock_templateObject0 || (FeedbackBlock_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 30rem;\n    padding-bottom: 30rem;\n    padding-left: 160rem;\n    padding-right: 90rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(FeedbackBlock_templateObject1 || (FeedbackBlock_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 220rem;\n    padding-right: 105rem;\n  "]))));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
;// CONCATENATED MODULE: ./src/services/formatOptionsToNotifications.js

/* harmony default export */ var formatOptionsToNotifications = (function (data) {
  return data.reduce(function (result, category) {
    var next = {
      newOpts: (0,toConsumableArray/* default */.Z)(result.newOpts),
      ordersToConfirm: (0,toConsumableArray/* default */.Z)(result.ordersToConfirm)
    }; // WishList notifications

    if (category.subcategories) {
      category.subcategories.forEach(function (subcategory) {
        return subcategory.options.forEach(function (option) {
          var added = false;
          option.orders.forEach(function (order) {
            // Add processed orders
            if (order.place === 'processed') {
              next.ordersToConfirm.push(option);
              added = true;
            }
          }); // Add new options to result

          if (!added && option && option.flag && option.flag === 'new') {
            next.newOpts.push(option);
          }
        });
      });
    } else {
      // MyHouse notifications
      category.orders.forEach(function (order) {
        // Add processed orders
        if (order.place === 'processed') {
          next.ordersToConfirm.push(order.option);
        }
      });
    }

    return next;
  }, {
    newOpts: [],
    ordersToConfirm: []
  });
});
// EXTERNAL MODULE: ./src/constants/apiUrls.ts
var apiUrls = __webpack_require__(6109);
;// CONCATENATED MODULE: ./src/components/shared/icons/List.js
var List_jsx = react.createElement;


var List_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white,
  width: 12,
  height: 9
};

var List_List = function List(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return List_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 12 9",
    "data-id": "icons_List_svg"
  }, List_jsx("path", {
    d: "M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1V2C12 2.55228 11.5523 3 11 3H1C0.447715 3 0 2.55228 0 2V1Z",
    fill: color,
    "data-id": "icons_List_path"
  }), List_jsx("path", {
    d: "M0 7C0 6.44772 0.447715 6 1 6H7C7.55228 6 8 6.44772 8 7V8C8 8.55228 7.55228 9 7 9H1C0.447715 9 0 8.55228 0 8V7Z",
    fill: color,
    "data-id": "icons_List_path_2"
  }));
};

List_List.defaultProps = List_defaultProps;
/* harmony default export */ var icons_List = (List_List);
;// CONCATENATED MODULE: ./src/components/shared/buttons/ButtonCaret.js


var ButtonCaret_templateObject, ButtonCaret_templateObject2, ButtonCaret_templateObject3;

var ButtonCaret_jsx = react.createElement;





var ButtonCaret_defaultProps = {
  color: styleGuide/* colorPalette.blue */.K5.blue
};

var ButtonAdd = function ButtonAdd(_ref) {
  var id = _ref.id,
      clickHandler = _ref.clickHandler,
      color = _ref.color,
      label = _ref.label;
  return ButtonCaret_jsx(ButtonCaret_Button, {
    id: id,
    onClick: clickHandler,
    "data-id": "buttons_ButtonCaret_Button"
  }, ButtonCaret_jsx(IconContainer, {
    color: color,
    "data-id": "buttons_ButtonCaret_IconContainer"
  }, ButtonCaret_jsx(Caret/* default */.Z, {
    direction: "down",
    color: styleGuide/* colorPalette.white */.K5.white,
    width: 6,
    height: 10,
    "data-id": "buttons_ButtonCaret_Caret"
  })), ButtonCaret_jsx(ButtonCaret_Label, {
    color: color,
    "data-id": "buttons_ButtonCaret_Label"
  }, label));
};

ButtonAdd.defaultProps = ButtonCaret_defaultProps;
/* harmony default export */ var ButtonCaret = (ButtonAdd);
var ButtonCaret_Button = styled_components_browser_esm["default"].button(ButtonCaret_templateObject || (ButtonCaret_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  font-family: ", ";\n\n  &:hover {\n    > span {\n      color: ", ";\n    }\n    > div {\n      background-color: ", ";\n    }\n  }\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.color ? (0,utils/* darken */._j)(props.color, 15) : styleGuide/* colorPalette.darkBlue */.K5.darkBlue;
}, function (props) {
  return props.color ? (0,utils/* darken */._j)(props.color, 15) : styleGuide/* colorPalette.darkBlue */.K5.darkBlue;
});
var IconContainer = styled_components_browser_esm["default"].div(ButtonCaret_templateObject2 || (ButtonCaret_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  border-radius: 100%;\n  width: 16rem;\n  height: 16rem;\n  background-color: ", ";\n  align-items: center;\n  justify-content: center;\n  margin-right: 6rem;\n  transition: background 0.2s ease-in-out;\n"])), function (props) {
  return props.color;
});
var ButtonCaret_Label = styled_components_browser_esm["default"].span(ButtonCaret_templateObject3 || (ButtonCaret_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-weight: bold;\n  font-size: 14rem;\n  transition: color 0.2s ease-in-out;\n"])), function (props) {
  return props.color;
});
;// CONCATENATED MODULE: ./src/components/homestudio/OptionNotifications.js








var OptionNotifications_templateObject, OptionNotifications_templateObject2, OptionNotifications_templateObject3, OptionNotifications_templateObject4, OptionNotifications_templateObject5, OptionNotifications_templateObject6, OptionNotifications_templateObject7, OptionNotifications_templateObject8, OptionNotifications_templateObject9, OptionNotifications_templateObject0, OptionNotifications_templateObject1, OptionNotifications_templateObject10, OptionNotifications_templateObject11, OptionNotifications_templateObject12;

var OptionNotifications_jsx = react.createElement;

function OptionNotifications_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, OptionNotifications_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function OptionNotifications_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (OptionNotifications_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


 // Components






 // Styles





var OptionNotifications = /*#__PURE__*/function (_PureComponent) {
  function OptionNotifications() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, OptionNotifications);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = OptionNotifications_callSuper(this, OptionNotifications, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      expanded: true,
      flippedButton: false,
      showAll: true
    });

    (0,defineProperty/* default */.Z)(_this, "notificationButton", null);

    (0,defineProperty/* default */.Z)(_this, "MAX_VISIBLE_NOTIFICIATIONS", 8);

    (0,defineProperty/* default */.Z)(_this, "scrollToOption", function (optionId) {
      if (document) {
        var optionEl = document.querySelector(".option-".concat(optionId));
        optionEl && optionEl.scrollIntoView({
          behavior: 'smooth',
          // $FlowFixMe
          block: 'center'
        });
      }
    });

    (0,defineProperty/* default */.Z)(_this, "toggleExpansion", function () {
      var expanded = _this.state.expanded;

      _this.setState({
        expanded: !expanded
      });
    });

    (0,defineProperty/* default */.Z)(_this, "toggleShowAll", function () {
      var showAll = _this.state.showAll;

      _this.setState({
        showAll: !showAll
      });
    });

    (0,defineProperty/* default */.Z)(_this, "onResize", function () {
      var flippedButton = _this.state.flippedButton;
      var viewWidth = window.innerWidth;

      if (viewWidth <= breakpoints/* breakpointSizes.md */.YA.md && !flippedButton) {
        _this.setState({
          flippedButton: true
        });
      }

      if (viewWidth > breakpoints/* breakpointSizes.md */.YA.md && flippedButton) {
        _this.setState({
          flippedButton: false
        });
      }
    });

    (0,defineProperty/* default */.Z)(_this, "getAmount", function (notifications) {
      return notifications.newOpts.length + notifications.ordersToConfirm.length;
    });

    return _this;
  }

  (0,inherits/* default */.Z)(OptionNotifications, _PureComponent);

  return (0,createClass/* default */.Z)(OptionNotifications, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var notifications = this.props.notifications;
      var amount = this.getAmount(notifications);

      if (amount > this.MAX_VISIBLE_NOTIFICIATIONS) {
        this.setState({
          showAll: false
        });
      }

      this.onResize();
      window.addEventListener('resize', this.onResize, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var notifications = this.props.notifications;
      var _this$state = this.state,
          expanded = _this$state.expanded,
          flippedButton = _this$state.flippedButton,
          showAll = _this$state.showAll;
      var notificationAmount = this.getAmount(notifications);
      var itemCounter = 0;
      return OptionNotifications_jsx(OptionNotifications_Container, {
        "data-id": "homestudio_OptionNotifications_Container"
      }, OptionNotifications_jsx(designElements_Triangle, {
        color: styleGuide/* colorPalette.orange */.K5.orange,
        direction: flippedButton ? 'bottomright' : 'bottomleft',
        width: 30,
        height: 30,
        "data-id": "homestudio_OptionNotifications_Triangle"
      }), OptionNotifications_jsx(NotificationContainer, {
        "data-id": "homestudio_OptionNotifications_NotificationContainer"
      }, OptionNotifications_jsx(NotificationText, {
        show: expanded,
        color: styleGuide/* colorPaletteRGB.loadingOrange */.xe.loadingOrange,
        "data-id": "homestudio_OptionNotifications_NotificationText"
      }, OptionNotifications_jsx(OptionNotifications_NotificationTitle, {
        expanded: expanded,
        "data-id": "homestudio_OptionNotifications_NotificationTitle"
      }, OptionNotifications_jsx(icons_Alert, {
        color: styleGuide/* colorPalette.orange */.K5.orange,
        "data-id": "homestudio_OptionNotifications_Alert"
      }), OptionNotifications_jsx("span", {
        "data-id": "homestudio_OptionNotifications_span"
      }, "Het woonontwerp bevat ", notificationAmount, " nieuwe aandachtspunten")), OptionNotifications_jsx(NotificationLists, {
        show: expanded,
        "data-id": "homestudio_OptionNotifications_NotificationLists"
      }, notifications.newOpts.length > 0 && OptionNotifications_jsx(react.Fragment, null, OptionNotifications_jsx(NotificationCategory, {
        "data-id": "homestudio_OptionNotifications_NotificationCategory"
      }, "Nieuw (", notifications.newOpts.length, ")"), OptionNotifications_jsx(NotificationList, {
        "data-id": "homestudio_OptionNotifications_NotificationList"
      }, notifications.newOpts.map(function (item, i) {
        var handleOptionClick = function handleOptionClick() {
          return _this2.scrollToOption(item.id);
        };

        itemCounter++;
        return OptionNotifications_jsx(NotificationListItem, {
          visible: itemCounter <= _this2.MAX_VISIBLE_NOTIFICIATIONS || showAll,
          key: "notification-newOpts-".concat(i),
          "data-id": "homestudio_OptionNotifications_NotificationListItem"
        }, OptionNotifications_jsx(ButtonCaret, {
          clickHandler: handleOptionClick,
          color: styleGuide/* colorPalette.blue */.K5.blue,
          label: item.title,
          "data-id": "homestudio_OptionNotifications_ButtonCaret"
        }));
      }))), notifications.ordersToConfirm.length > 0 && OptionNotifications_jsx(react.Fragment, null, OptionNotifications_jsx(NotificationCategory, {
        "data-id": "homestudio_OptionNotifications_NotificationCategory"
      }, "In afwachting van bevestiging (", notifications.ordersToConfirm.length, ")"), OptionNotifications_jsx(NotificationList, {
        "data-id": "homestudio_OptionNotifications_NotificationList"
      }, notifications.ordersToConfirm.map(function (item, i) {
        var handleOptionClick = function handleOptionClick() {
          return _this2.scrollToOption(item.id);
        };

        itemCounter++;
        return OptionNotifications_jsx(NotificationListItem, {
          visible: itemCounter <= _this2.MAX_VISIBLE_NOTIFICIATIONS || showAll,
          key: "notification-ordersToConfirm-".concat(i),
          "data-id": "homestudio_OptionNotifications_NotificationListItem"
        }, OptionNotifications_jsx(ButtonCaret, {
          clickHandler: handleOptionClick,
          color: styleGuide/* colorPalette.blue */.K5.blue,
          label: item.title,
          "data-id": "homestudio_OptionNotifications_ButtonCaret"
        }));
      })))), notificationAmount > this.MAX_VISIBLE_NOTIFICIATIONS && OptionNotifications_jsx(ToggleButton, {
        show: expanded,
        onClick: this.toggleShowAll,
        "data-id": "homestudio_OptionNotifications_ToggleButton"
      }, OptionNotifications_jsx("span", {
        "data-id": "homestudio_OptionNotifications_span"
      }, "Toon ", showAll ? 'minder' : 'alle', " notificaties"), OptionNotifications_jsx(Caret/* default */.Z, {
        direction: showAll ? 'up' : 'down',
        color: styleGuide/* colorPalette.blue */.K5.blue,
        "data-id": "homestudio_OptionNotifications_Caret"
      }))), OptionNotifications_jsx(ExpandButton, {
        expandable: true,
        color: styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
        onClick: this.toggleExpansion,
        "data-id": "homestudio_OptionNotifications_ExpandButton"
      }, expanded ? OptionNotifications_jsx(CloseCross/* default */.Z, {
        color: "white",
        width: 12,
        height: 12,
        "data-id": "homestudio_OptionNotifications_Cross"
      }) : OptionNotifications_jsx(icons_List, {
        color: "white",
        "data-id": "homestudio_OptionNotifications_Expand"
      }))), OptionNotifications_jsx(designElements_Triangle, {
        color: styleGuide/* colorPalette.orange */.K5.orange,
        direction: flippedButton ? 'topright' : 'topleft',
        width: 30,
        height: 30,
        "data-id": "homestudio_OptionNotifications_Triangle"
      }));
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var homestudio_OptionNotifications = (OptionNotifications);
var OptionNotifications_Container = styled_components_browser_esm["default"].div(OptionNotifications_templateObject || (OptionNotifications_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-bottom: 10rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(OptionNotifications_templateObject2 || (OptionNotifications_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(100% + 30px);\n  "]))));
var ExpandButton = styled_components_browser_esm["default"].button(OptionNotifications_templateObject3 || (OptionNotifications_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border: none;\n  padding: 25rem 9rem;\n  width: 30px;\n  box-sizing: border-box;\n  display: flex;\n  cursor: ", ";\n  flex-direction: column;\n  background-color: ", ";\n\n  ", ";\n"])), function (props) {
  return props.expandable ? 'pointer' : 'default';
}, function (props) {
  return (0,utils/* darken */._j)(props.color, 10);
}, breakpoints/* fromBreakpoint.md */.ks.md(OptionNotifications_templateObject4 || (OptionNotifications_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 40rem 9rem;\n  "]))));
var NotificationContainer = styled_components_browser_esm["default"].div(OptionNotifications_templateObject5 || (OptionNotifications_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n"])));
var NotificationText = styled_components_browser_esm["default"].div(OptionNotifications_templateObject6 || (OptionNotifications_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  background-color: rgba(", ", 0.25);\n  box-sizing: border-box;\n  padding: 20rem;\n  width: 100%;\n\n  p {\n    margin: 0;\n  }\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.color;
}, breakpoints/* fromBreakpoint.md */.ks.md(OptionNotifications_templateObject7 || (OptionNotifications_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 32rem 40rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(OptionNotifications_templateObject8 || (OptionNotifications_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 32rem 40rem 32rem 100rem;\n  "]))));
var OptionNotifications_NotificationTitle = styled_components_browser_esm["default"].h4(OptionNotifications_templateObject9 || (OptionNotifications_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n\n  ", ";\n  color: ", ";\n  margin: ", ";\n  transition: margin 0.5s ease;\n\n  > span {\n    margin-left: 11px;\n  }\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.orange */.K5.orange, function (props) {
  return props.expanded ? "0 0 20rem" : 0;
});
var NotificationLists = styled_components_browser_esm["default"].div(OptionNotifications_templateObject0 || (OptionNotifications_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  transition: max-height 0.5s ease, opacity 0.5s ease, visibility 0.5s ease;\n  opacity: ", ";\n  visibility: ", ";\n  max-height: ", ";\n"])), function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return props.show ? 'visible' : 'hidden';
}, function (props) {
  return props.show ? 'auto' : 0;
});
var NotificationCategory = styled_components_browser_esm["default"].h5(OptionNotifications_templateObject1 || (OptionNotifications_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-style: normal;\n  margin: 0 0 12rem;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var NotificationList = styled_components_browser_esm["default"].ul(OptionNotifications_templateObject10 || (OptionNotifications_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  margin: 0 0 18rem;\n  list-style: none;\n  font-style: normal;\n"])));
var NotificationListItem = styled_components_browser_esm["default"].li(OptionNotifications_templateObject11 || (OptionNotifications_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0 0 12rem;\n\n  display: ", ";\n\n  ", ";\n  font-weight: bold;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])), function (props) {
  return props.visible ? 'block' : 'none';
}, styleGuide/* textStyles.caption */.sq.caption);
var ToggleButton = styled_components_browser_esm["default"].button(OptionNotifications_templateObject12 || (OptionNotifications_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-style: normal;\n  display: ", ";\n\n  > span {\n    margin-right: 8rem;\n  }\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.blue */.K5.blue, function (props) {
  return props.show ? 'block' : 'none';
});
;// CONCATENATED MODULE: ./src/components/MyHouseBase.js



var MyHouseBase_templateObject, MyHouseBase_templateObject2, MyHouseBase_templateObject3, MyHouseBase_templateObject4, MyHouseBase_templateObject5, MyHouseBase_templateObject6, MyHouseBase_templateObject7, MyHouseBase_templateObject8, MyHouseBase_templateObject9, MyHouseBase_templateObject0, MyHouseBase_templateObject1, MyHouseBase_templateObject10, MyHouseBase_templateObject11, MyHouseBase_templateObject12, MyHouseBase_templateObject13, MyHouseBase_templateObject14;

var MyHouseBase_jsx = react.createElement;

function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }

    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}


 // Services




 // Styles




var getNotificationsFromCategories = function getNotificationsFromCategories(categories) {
  return formatOptionsToNotifications(categories);
};

var MyHouseBase = function MyHouseBase(_ref) {
  var house = _ref.house,
      houseType = _ref.houseType,
      categories = _ref.categories;
  var notifications = getNotificationsFromCategories(categories);

  var _useState = (0,react.useState)(null),
      buyerDrawingUrl = _useState[0],
      setBuyerDrawingUrl = _useState[1];

  var hasNotifications = notifications.newOpts.length > 0 || notifications.ordersToConfirm.length > 0;
  (0,react.useEffect)(function () {
    var fetchBuyerDrawing = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/_regenerator().m(function _callee() {
        var response, data;
        return _regenerator().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return fetch("".concat(apiUrls/* BASE_URL */._, "/ecw/latest-buyer-drawing/"), {
                  credentials: 'include',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 1:
                response = _context.v;

                if (!response.ok) {
                  _context.n = 3;
                  break;
                }

                _context.n = 2;
                return response.json();

              case 2:
                data = _context.v; // Extract JSON data

                setBuyerDrawingUrl(data.latestBuyerDrawing);
                _context.n = 4;
                break;

              case 3:
                setBuyerDrawingUrl(null);

              case 4:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      return function fetchBuyerDrawing() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchBuyerDrawing();
  }, []);
  return house && houseType ? MyHouseBase_jsx(MyHouseBaseContainer, {
    "data-id": "components_MyHouseBase_MyHouseBaseContainer"
  }, MyHouseBase_jsx(MyHouseBase_Block, {
    hasNotifications: hasNotifications,
    "data-id": "components_MyHouseBase_Block"
  }, MyHouseBase_jsx(MyHouseBase_Address, {
    "data-id": "components_MyHouseBase_Address"
  }, house.address ? MyHouseBase_jsx(react.Fragment, null, house.address.street, " ", house.address.houseNumber, " ", house.address.houseNumberAddition, MyHouseBase_jsx("br", {
    "data-id": "components_MyHouseBase_br"
  }), house.address.zipcode, " ", house.address.city) : 'Adres nog onbekend')), hasNotifications && MyHouseBase_jsx(homestudio_OptionNotifications, {
    notifications: notifications,
    "data-id": "components_MyHouseBase_OptionNotifications"
  }), MyHouseBase_jsx(Info, {
    "data-id": "components_MyHouseBase_Info"
  }, MyHouseBase_jsx(HouseInfo, {
    "data-id": "components_MyHouseBase_HouseInfo"
  }, house.address ? MyHouseBase_jsx("div", {
    "data-id": "components_MyHouseBase_div"
  }, MyHouseBase_jsx("p", {
    "data-id": "components_MyHouseBase_p"
  }, house.address.street, " ", house.address.houseNumber, ' ', house.address.houseNumberAddition), MyHouseBase_jsx("p", {
    "data-id": "components_MyHouseBase_p_9"
  }, house.address.zipcode, " ", house.address.city)) : MyHouseBase_jsx("div", {
    "data-id": "components_MyHouseBase_div"
  }, MyHouseBase_jsx("p", {
    "data-id": "components_MyHouseBase_p"
  }, "Adres nog onbekend")), MyHouseBase_jsx("p", {
    "data-id": "components_MyHouseBase_p_12"
  }, "Bouwnummer: ".concat(house.bnr)), MyHouseBase_jsx("p", {
    "data-id": "components_MyHouseBase_p_13"
  }, "Variant: ".concat(houseType.typeName, " - ").concat(houseType.variantName, " ").concat(house.variantCode)), house.surface && MyHouseBase_jsx("p", {
    "data-id": "components_MyHouseBase_p_14"
  }, "Kaveloppervlak: ".concat(house.surface, " m\xB2")), houseType.bedrooms !== undefined || houseType.bedrooms !== null && MyHouseBase_jsx("p", {
    "data-id": "components_MyHouseBase_p_15"
  }, "Slaapkamers: ".concat(houseType.bedrooms)), !!buyerDrawingUrl && MyHouseBase_jsx(MyHouseDrawingLinkContainer, {
    "data-id": "components_MyHouseBase_MyHouseDrawingLinkContainer"
  }, "Actuele koperstekening:", ' ', MyHouseBase_jsx("a", {
    target: "_blank",
    href: buyerDrawingUrl,
    "data-id": "components_MyHouseBase_a"
  }, "Bekijk koperstekening"))), MyHouseBase_jsx(MyHouseBase_ImageContainer, {
    "data-id": "components_MyHouseBase_ImageContainer"
  }, MyHouseBase_jsx(ImageLoader/* default */.Z, {
    src: houseType.media[0].image.src,
    mode: "bg",
    alt: "jouw woning",
    "data-id": "components_MyHouseBase_ImageLoader"
  })))) : null;
};

/* harmony default export */ var components_MyHouseBase = (MyHouseBase);
var MyHouseDrawingLinkContainer = styled_components_browser_esm["default"].p(MyHouseBase_templateObject || (MyHouseBase_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  > a {\n    color: ", ";\n  }\n"])), styleGuide/* colorPalette.blue */.K5.blue);
var MyHouseBaseContainer = styled_components_browser_esm["default"].div(MyHouseBase_templateObject2 || (MyHouseBase_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 980rem;\n  width: 100%;\n  position: relative;\n  background-color: white;\n  margin: 0 auto;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseBase_templateObject3 || (MyHouseBase_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(100% - 98rem);\n  "]))));
var MyHouseBase_Block = styled_components_browser_esm["default"].div(MyHouseBase_templateObject4 || (MyHouseBase_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  padding: 20rem 20rem ", ";\n\n  box-sizing: border-box;\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.hasNotifications ? "8rem" : "20rem";
}, breakpoints/* fromBreakpoint.md */.ks.md(MyHouseBase_templateObject5 || (MyHouseBase_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 30rem 40rem ", ";\n  "])), function (props) {
  return props.hasNotifications ? "8rem" : "30rem";
}), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseBase_templateObject6 || (MyHouseBase_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 120rem ", " 100rem;\n  "])), function (props) {
  return props.hasNotifications ? "8rem" : "40rem";
}));
var MyHouseBase_Address = styled_components_browser_esm["default"].h2(MyHouseBase_templateObject7 || (MyHouseBase_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 32rem;\n  line-height: 38rem;\n  color: ", ";\n  margin: 0;\n\n  ", ";\n\n  > p {\n    margin: 0;\n  }\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.orange */.K5.orange, breakpoints/* fromBreakpoint.md */.ks.md(MyHouseBase_templateObject8 || (MyHouseBase_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 48rem;\n    line-height: 56rem;\n  "]))));
var Info = styled_components_browser_esm["default"].div(MyHouseBase_templateObject9 || (MyHouseBase_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  margin: 0 20rem 20rem;\n  box-sizing: border-box;\n  border-top: 1rem dashed ", ";\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, breakpoints/* fromBreakpoint.md */.ks.md(MyHouseBase_templateObject0 || (MyHouseBase_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 40rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseBase_templateObject1 || (MyHouseBase_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n    transform: translateX(98rem);\n  "]))));
var HouseInfo = styled_components_browser_esm["default"].div(MyHouseBase_templateObject10 || (MyHouseBase_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  display: flex;\n  order: 1;\n  margin-top: 20rem;\n  flex-direction: column;\n\n  > div {\n    margin-bottom: 12rem;\n\n    > p {\n      font-size: 16rem;\n      margin-bottom: 0;\n      margin-top: 5rem;\n    }\n  }\n\n  > p {\n    margin-bottom: 0;\n    margin-top: 8rem;\n  }\n\n  ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* toBreakpoint.md */.Hx.md(MyHouseBase_templateObject11 || (MyHouseBase_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n    max-width: 250rem;\n  "]))));
var MyHouseBase_ImageContainer = styled_components_browser_esm["default"].div(MyHouseBase_templateObject12 || (MyHouseBase_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  overflow: hidden;\n  margin-top: 20rem;\n  order: 0;\n  height: 160rem;\n\n  ", ";\n\n  ", ";\n\n  > div {\n    transition: transform 0.45s ease-in-out;\n    transform: scale(1);\n\n    &:hover {\n      transform: scale(1.04);\n    }\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(MyHouseBase_templateObject13 || (MyHouseBase_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 50%;\n    order: 2;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseBase_templateObject14 || (MyHouseBase_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 230rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/shared/icons/Expand.js
var Expand_jsx = react.createElement;

var Expand_defaultProps = {
  color: '#ffffff'
};

var Expand = function Expand(_ref) {
  var color = _ref.color;
  return Expand_jsx("svg", {
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    "data-id": "icons_Expand_svg"
  }, Expand_jsx("title", {
    "data-id": "icons_Expand_title"
  }, "Expand"), Expand_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Expand_g"
  }, Expand_jsx("g", {
    transform: "translate(-3.000000, -3.000000)",
    fill: color,
    "data-id": "icons_Expand_g_3"
  }, Expand_jsx("g", {
    "data-id": "icons_Expand_g_4"
  }, Expand_jsx("g", {
    "data-id": "icons_Expand_g_5"
  }, Expand_jsx("path", {
    d: "M15.3923812,5.70854651 L13.166766,7.93416176 C12.9260866,8.17484112 12.6119519,8.28896071 12.3014653,8.27900953 L12.3014653,8.27900953 C11.9909786,8.28896071 11.6768439,8.17484112 11.4361646,7.93416176 L9.19758792,5.69558513 L7.80344434,4.30157521 L8.61400043,3.49101913 L8.61448728,3.49150598 C8.62039345,3.48534391 8.62638002,3.47922874 8.63244702,3.47316174 C9.09009294,3.01551582 9.826149,3.00958124 10.2897097,3.47314196 L12.3014653,5.48489752 L14.3132208,3.47314196 C14.7680826,3.01828016 15.4853087,3.01545842 15.9444293,3.44787526 L15.9470829,3.44522164 L16.8034443,4.30158311 L15.3944311,5.71059636 L15.3923812,5.70854651 Z",
    transform: "translate(12.303444, 5.703652) scale(-1, 1) rotate(-225.000000) translate(-12.303444, -5.703652) ",
    "data-id": "icons_Expand_path"
  }), Expand_jsx("path", {
    d: "M8.89238125,12.3081559 L6.666766,14.5337711 C6.42608664,14.7744505 6.11195192,14.8885701 5.80146528,14.8786189 L5.80146528,14.8786189 C5.49097864,14.8885701 5.17684392,14.7744505 4.93616456,14.5337711 L2.69758792,12.2951945 L1.30344434,10.9011846 L2.11400043,10.0906285 L2.11448728,10.0911154 C2.12039345,10.0849533 2.12638002,10.0788381 2.13244702,10.0727711 C2.59009294,9.6151252 3.326149,9.60919061 3.78970973,10.0727513 L5.80146528,12.0845069 L7.81322083,10.0727513 C8.26808263,9.61788954 8.98530872,9.61506779 9.44442926,10.0474846 L9.44708287,10.044831 L10.3034443,10.9011925 L8.8944311,12.3102057 L8.89238125,12.3081559 Z",
    transform: "translate(5.803444, 12.303261) scale(1, -1) rotate(-225.000000) translate(-5.803444, -12.303261) ",
    "data-id": "icons_Expand_path_7"
  }), Expand_jsx("circle", {
    cx: "9",
    cy: "9",
    r: "1",
    "data-id": "icons_Expand_circle"
  }))))));
};

Expand.defaultProps = Expand_defaultProps;
/* harmony default export */ var icons_Expand = (Expand);
;// CONCATENATED MODULE: ./src/components/shared/buttons/ButtonExpand.js


var ButtonExpand_templateObject, ButtonExpand_templateObject2;

var ButtonExpand_jsx = react.createElement;





var ButtonExpand = function ButtonExpand(_ref) {
  var clickHandler = _ref.clickHandler,
      label = _ref.label;
  return ButtonExpand_jsx(SeeMoreButton, {
    onClick: clickHandler,
    "data-id": "buttons_ButtonExpand_SeeMoreButton"
  }, label, ButtonExpand_jsx(ExpandContainer, {
    "data-id": "buttons_ButtonExpand_ExpandContainer"
  }, ButtonExpand_jsx(icons_Expand, {
    "data-id": "buttons_ButtonExpand_Expand"
  })));
};

/* harmony default export */ var buttons_ButtonExpand = (ButtonExpand);
var SeeMoreButton = styled_components_browser_esm["default"].button(ButtonExpand_templateObject || (ButtonExpand_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  border: none;\n  color: ", ";\n  background: none;\n  text-align: left;\n  align-self: flex-start;\n  transition: color 0.25s ease-in-out;\n  font-weight: bold;\n\n  &:hover {\n    color: ", ";\n  }\n"])), styleGuide/* colorPalette.blue */.K5.blue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue);
var ExpandContainer = styled_components_browser_esm["default"].span(ButtonExpand_templateObject2 || (ButtonExpand_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  width: 16rem;\n  height: 16rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4rem 0 4rem 0;\n  margin-left: 5rem;\n"])), styleGuide/* colorPalette.blue */.K5.blue);
// EXTERNAL MODULE: ./src/components/shared/icons/Download.js
var Download = __webpack_require__(31533);
;// CONCATENATED MODULE: ./src/components/ConfirmedOrdersDownload.js


var ConfirmedOrdersDownload_templateObject, ConfirmedOrdersDownload_templateObject2;

var ConfirmedOrdersDownload_jsx = react.createElement;







var ConfirmedOrdersDownload = function ConfirmedOrdersDownload(_ref) {
  var url = _ref.url;

  if (!url) {
    return null;
  }

  return ConfirmedOrdersDownload_jsx(ConfirmedOrdersDownload_Container, {
    "data-id": "components_ConfirmedOrdersDownload_Container"
  }, ConfirmedOrdersDownload_jsx(ButtonPrimary/* default */.Z, {
    label: "Download afschrift",
    type: "externalLink",
    link: url,
    size: "small",
    "data-id": "components_ConfirmedOrdersDownload_ButtonPrimary"
  }, ConfirmedOrdersDownload_jsx(Download/* default */.Z, {
    color: styleGuide/* colorPalette.white */.K5.white,
    "data-id": "components_ConfirmedOrdersDownload_Download"
  })));
};

/* harmony default export */ var components_ConfirmedOrdersDownload = (ConfirmedOrdersDownload);
var ConfirmedOrdersDownload_Container = styled_components_browser_esm["default"].div(ConfirmedOrdersDownload_templateObject || (ConfirmedOrdersDownload_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 15rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ConfirmedOrdersDownload_templateObject2 || (ConfirmedOrdersDownload_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: flex;\n    flex-direction: row-reverse;\n  "]))));
;// CONCATENATED MODULE: ./src/components/MyHouseChoices.js








var MyHouseChoices_templateObject, MyHouseChoices_templateObject2, MyHouseChoices_templateObject3, MyHouseChoices_templateObject4, MyHouseChoices_templateObject5, MyHouseChoices_templateObject6, MyHouseChoices_templateObject7, MyHouseChoices_templateObject8, MyHouseChoices_templateObject9, MyHouseChoices_templateObject0, MyHouseChoices_templateObject1, MyHouseChoices_templateObject10, MyHouseChoices_templateObject11, MyHouseChoices_templateObject12, MyHouseChoices_templateObject13, MyHouseChoices_templateObject14, MyHouseChoices_templateObject15, MyHouseChoices_templateObject16, MyHouseChoices_templateObject17, MyHouseChoices_templateObject18, MyHouseChoices_templateObject19, MyHouseChoices_templateObject20, MyHouseChoices_templateObject21, MyHouseChoices_templateObject22, MyHouseChoices_templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32;

var MyHouseChoices_jsx = react.createElement;

function MyHouseChoices_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, MyHouseChoices_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function MyHouseChoices_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (MyHouseChoices_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}




 // Services

 // Components








 // Styles





var MyHouseChoices_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openConfirmModal: function openConfirmModal(orderId) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.blue */.K5.blue, {
        type: 'orderConfirm',
        componentProps: {
          projectSlug: String(ownProps.match.params.projectSlug),
          orderId: orderId,
          categories: ownProps.categories,
          houseOverviewTotalPerCompany: ownProps.houseOverviewTotalPerCompany
        }
      }));
    },
    openStatusModal: function openStatusModal(orderId) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.blue */.K5.blue, {
        type: 'optionOrderStatus',
        componentProps: {
          projectSlug: String(ownProps.match.params.projectSlug),
          orderId: orderId
        }
      }));
    }
  };
};

var MyHouseChoices = /*#__PURE__*/function (_PureComponent) {
  function MyHouseChoices() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MyHouseChoices);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = MyHouseChoices_callSuper(this, MyHouseChoices, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "calculateTotalPrice", function (categories, price) {
      if (!categories) return;
      return categories.reduce(function (categoryAcc, category) {
        return categoryAcc + category.orders.reduce(function (ordersAcc, order) {
          return ordersAcc + order.salesPrice * order.amount;
        }, 0);
      }, price || 0);
    });

    (0,defineProperty/* default */.Z)(_this, "hasExternalSellers", function (houseOverviewTotalPerCompany) {
      if (!houseOverviewTotalPerCompany) return false;
      return houseOverviewTotalPerCompany.length > 1;
    });

    (0,defineProperty/* default */.Z)(_this, "transformLastUpdateDate", function (date) {
      var dateParts = date.split(/-| /);
      return "(".concat(dateParts[2], "-").concat(dateParts[1], "-").concat(dateParts[0], ")");
    });

    (0,defineProperty/* default */.Z)(_this, "handleConfirmModal", function (orderId) {
      var openConfirmModal = _this.props.openConfirmModal;

      if (typeof openConfirmModal === 'function') {
        openConfirmModal(orderId);
      }
    });

    (0,defineProperty/* default */.Z)(_this, "handleStatusModal", function (orderId) {
      var openStatusModal = _this.props.openStatusModal;

      if (typeof openStatusModal === 'function') {
        openStatusModal(orderId);
      }
    });

    return _this;
  }

  (0,inherits/* default */.Z)(MyHouseChoices, _PureComponent);

  return (0,createClass/* default */.Z)(MyHouseChoices, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$categorie = _this$props.categories,
          categories = _this$props$categorie === void 0 ? [] : _this$props$categorie,
          bnr = _this$props.bnr,
          price = _this$props.price,
          renderWidth = _this$props.renderWidth,
          livingSpace = _this$props.livingSpace,
          bedrooms = _this$props.bedrooms,
          houseConfirmationExport = _this$props.houseConfirmationExport,
          houseOverviewTotalPerCompany = _this$props.houseOverviewTotalPerCompany;
      var totalPrice = this.calculateTotalPrice(categories, price);
      var hasExternalSellers = this.hasExternalSellers(houseOverviewTotalPerCompany);
      return MyHouseChoices_jsx(MyHouseChoicesContainer, {
        "data-id": "components_MyHouseChoices_MyHouseChoicesContainer"
      }, MyHouseChoices_jsx(MyHouseChoices_Title, {
        "data-id": "components_MyHouseChoices_Title"
      }, "Mijn keuzes"), MyHouseChoices_jsx(Choices, {
        "data-id": "components_MyHouseChoices_Choices"
      }, MyHouseChoices_jsx(Base, {
        "data-id": "components_MyHouseChoices_Base"
      }, MyHouseChoices_jsx(CategoryTitleContainer, {
        "data-id": "components_MyHouseChoices_CategoryTitleContainer"
      }, MyHouseChoices_jsx(designElements_HouseIconsMap, {
        icon: "houseEmpty",
        color: styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
        "data-id": "components_MyHouseChoices_HouseIconsMap"
      }), MyHouseChoices_jsx(CategoryTitle, {
        "data-id": "components_MyHouseChoices_CategoryTitle"
      }, "Basisprijs")), MyHouseChoices_jsx(Order, {
        "data-id": "components_MyHouseChoices_Order"
      }, MyHouseChoices_jsx(OrderContainer, {
        "data-id": "components_MyHouseChoices_OrderContainer"
      }, MyHouseChoices_jsx(OrderTitle, {
        "data-id": "components_MyHouseChoices_OrderTitle"
      }, "Bouwnummer ", bnr), renderWidth > 689 && MyHouseChoices_jsx(OrderPrice, {
        "data-id": "components_MyHouseChoices_OrderPrice"
      }, formatPrice(price, {
        showDecimal: true,
        showEuroSign: true,
        showNegative: false
      }))), renderWidth <= 689 && MyHouseChoices_jsx(OrderPrice, {
        "data-id": "components_MyHouseChoices_OrderPrice_11"
      }, formatPrice(price, {
        showDecimal: true,
        showEuroSign: true,
        showNegative: false
      })))), (categories || []).map(function (cat, i) {
        return MyHouseChoices_jsx(Category, {
          key: i,
          "data-id": "components_MyHouseChoices_Category"
        }, MyHouseChoices_jsx(CategoryTitleContainer, {
          firstStatus: cat.orders.length > 0 && cat.orders[0].place,
          "data-id": "components_MyHouseChoices_CategoryTitleContainer"
        }, MyHouseChoices_jsx(designElements_HouseIconsMap, {
          icon: cat.icon,
          color: styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
          "data-id": "components_MyHouseChoices_HouseIconsMap"
        }), MyHouseChoices_jsx(CategoryTitle, {
          "data-id": "components_MyHouseChoices_CategoryTitle"
        }, cat.title)), (cat.orders || []).map(function (order, index) {
          var updateDate = _this2.transformLastUpdateDate(order.lastUpdate);

          var handleConfirm = function handleConfirm() {
            return _this2.handleConfirmModal(order.id);
          };

          var handleStatus = function handleStatus() {
            return _this2.handleStatusModal(order.id);
          };

          return order.place !== 'blocked' && order.place !== 'cancelled' && order.place !== 'cancelled-postsale' && MyHouseChoices_jsx(Order, {
            key: index,
            className: "option-".concat(order.option.id),
            status: order.place,
            "data-id": "components_MyHouseChoices_Order"
          }, MyHouseChoices_jsx(OrderContainer, {
            status: order.place,
            "data-id": "components_MyHouseChoices_OrderContainer"
          }, order.place === 'processed' && MyHouseChoices_jsx(icons_Alert, {
            color: styleGuide/* colorPalette.orange */.K5.orange,
            "data-id": "components_MyHouseChoices_AlertIcon"
          }), MyHouseChoices_jsx(OrderTitle, {
            status: order.place,
            "data-id": "components_MyHouseChoices_OrderTitle"
          }, order.option.title, " ", order.amount > 1 && MyHouseChoices_jsx("span", {
            "data-id": "components_MyHouseChoices_span"
          }, "(", order.amount, "x)")), renderWidth > 689 && MyHouseChoices_jsx(OrderPrice, {
            "data-id": "components_MyHouseChoices_OrderPrice"
          }, order.salesPrice > 0 ? '+' : order.salesPrice === 0 ? '' : '-', formatPrice(order.salesPrice * order.amount, {
            showDecimal: true,
            showEuroSign: true,
            showNegative: false
          }))), MyHouseChoices_jsx(MyHouseChoices_OrderStatus, {
            color: styleGuide/* colorPalette.green */.K5.green,
            "data-id": "components_MyHouseChoices_OrderStatus"
          }, MyHouseChoices_jsx("p", {
            "data-id": "components_MyHouseChoices_p"
          }, order.placeDescription, " ", updateDate)), MyHouseChoices_jsx(MyHouseChoices_OptionSubtitleBase, {
            "data-id": "components_MyHouseChoices_OptionSubtitleBase"
          }, order.option.external_seller && MyHouseChoices_jsx(molecules_ExternalSeller, {
            text: order.option.external_seller,
            extraMarginLeft: true,
            "data-id": "components_MyHouseChoices_ExternalSeller"
          })), MyHouseChoices_jsx(MyHouseChoices_OptionSubtitleBase, {
            "data-id": "components_MyHouseChoices_OptionSubtitleBase"
          }, order.option.optionCode && MyHouseChoices_jsx(OrderOptionCode, {
            "data-id": "components_MyHouseChoices_OrderOptionCode"
          }, "Optiecode: ", order.option.optionCode)), renderWidth <= 689 && MyHouseChoices_jsx(OrderPrice, {
            "data-id": "components_MyHouseChoices_OrderPrice"
          }, formatPrice(order.salesPrice * order.amount, {
            showDecimal: true,
            showEuroSign: true,
            showNegative: false
          })), (order.place === 'requested' || order.place === 'confirmed' || order.place === 'process' || order.place === 'controle' || order.place === 'signed' || order.place === 'presold' || order.place === 'presale') && MyHouseChoices_jsx(ButtonExpandContainer, {
            "data-id": "components_MyHouseChoices_ButtonExpandContainer"
          }, MyHouseChoices_jsx(buttons_ButtonExpand, {
            label: "Order informatie",
            clickHandler: handleStatus,
            "data-id": "components_MyHouseChoices_ButtonExpand"
          })), order.place === 'processed' && order.option.isConfirmable && MyHouseChoices_jsx(MyHouseChoices_ButtonContainer, {
            "data-id": "components_MyHouseChoices_ButtonContainer"
          }, MyHouseChoices_jsx(ButtonPrimary/* default */.Z, {
            type: "button",
            size: "small",
            label: "Controleren en bevestigen",
            onClick: handleConfirm,
            "data-id": "components_MyHouseChoices_ButtonPrimary"
          })));
        }), cat.orders && cat.orders.length === 0 && MyHouseChoices_jsx(Order, {
          "data-id": "components_MyHouseChoices_Order"
        }, MyHouseChoices_jsx(OrderContainer, {
          "data-id": "components_MyHouseChoices_OrderContainer"
        }, MyHouseChoices_jsx(OrderTitle, {
          noOption: true,
          "data-id": "components_MyHouseChoices_OrderTitle"
        }, "Geen opties gekozen"))));
      })), MyHouseChoices_jsx(MyHouseChoices_Footer, {
        "data-id": "components_MyHouseChoices_Footer"
      }, MyHouseChoices_jsx(designElements_WishlistFooter, {
        livingSpace: livingSpace,
        bedrooms: bedrooms,
        myHouseBlock: true,
        smallColumn: true,
        price: totalPrice,
        small: false,
        hasExternalSellers: hasExternalSellers,
        "data-id": "components_MyHouseChoices_WishlistFooter"
      }), hasExternalSellers && MyHouseChoices_jsx(SellerListContainer, {
        "data-id": "components_MyHouseChoices_SellerListContainer"
      }, houseOverviewTotalPerCompany.map(function (company, index) {
        return MyHouseChoices_jsx(SellerListItem, {
          key: index,
          "data-id": "components_MyHouseChoices_SellerListItem"
        }, MyHouseChoices_jsx(SellerListItemLabel, {
          "data-id": "components_MyHouseChoices_SellerListItemLabel"
        }, company.name), MyHouseChoices_jsx(OrderPrice, {
          "data-id": "components_MyHouseChoices_OrderPrice"
        }, formatPrice(company.salesPrice, {
          showDecimal: true,
          showEuroSign: true,
          showNegative: false
        })));
      })), MyHouseChoices_jsx(components_ConfirmedOrdersDownload, {
        url: houseConfirmationExport,
        "data-id": "components_MyHouseChoices_ConfirmedOrdersDownload"
      })));
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var components_MyHouseChoices = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(null, MyHouseChoices_mapDispatchToProps)(MyHouseChoices)));
var SellerListContainer = styled_components_browser_esm["default"].div(MyHouseChoices_templateObject || (MyHouseChoices_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 10rem;\n"])));
var SellerListItem = styled_components_browser_esm["default"].div(MyHouseChoices_templateObject2 || (MyHouseChoices_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  border-top: 1px solid ", ";\n  padding: 10rem 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey);
var SellerListItemLabel = styled_components_browser_esm["default"].p(MyHouseChoices_templateObject3 || (MyHouseChoices_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0;\n  font-size: 14rem;\n  color: ", ";\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var MyHouseChoicesContainer = styled_components_browser_esm["default"].div(MyHouseChoices_templateObject4 || (MyHouseChoices_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 980rem;\n  margin: 8rem auto 0;\n  font-family: ", ";\n  background-color: white;\n  padding: 20rem 0 40rem;\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, breakpoints/* fromBreakpoint.md */.ks.md(MyHouseChoices_templateObject5 || (MyHouseChoices_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 0;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseChoices_templateObject6 || (MyHouseChoices_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 0;\n  "]))));
var MyHouseChoices_Title = styled_components_browser_esm["default"].h2(MyHouseChoices_templateObject7 || (MyHouseChoices_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: bold;\n  font-size: 32rem;\n  line-height: 38rem;\n  color: ", ";\n  margin: 0rem;\n\n  padding: 0 20rem;\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.orange */.K5.orange, breakpoints/* fromBreakpoint.md */.ks.md(MyHouseChoices_templateObject8 || (MyHouseChoices_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 0 0 0 30rem;\n    padding: 0 40rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseChoices_templateObject9 || (MyHouseChoices_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0 120rem 0 100rem;\n  "]))));
var Choices = styled_components_browser_esm["default"].div(MyHouseChoices_templateObject0 || (MyHouseChoices_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: 16rem;\n  color: ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* fromBreakpoint.md */.ks.md(MyHouseChoices_templateObject1 || (MyHouseChoices_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 24rem;\n  "]))));
var Base = styled_components_browser_esm["default"].div(MyHouseChoices_templateObject10 || (MyHouseChoices_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n"])));
var CategoryTitleContainer = styled_components_browser_esm["default"].div(MyHouseChoices_templateObject11 || (MyHouseChoices_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  padding: 0 20rem;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.firstStatus === 'processed' && "margin-bottom: 10rem;";
}, breakpoints/* fromBreakpoint.md */.ks.md(MyHouseChoices_templateObject12 || (MyHouseChoices_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0 40rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseChoices_templateObject13 || (MyHouseChoices_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0 120rem 0 100rem;\n  "]))));
var CategoryTitle = styled_components_browser_esm["default"].p(MyHouseChoices_templateObject14 || (MyHouseChoices_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: bold;\n  font-size: 18rem;\n  padding: 0;\n  margin: 0 0 0 12rem;\n  color: ", ";\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey);
var OrderTitle = styled_components_browser_esm["default"].p(MyHouseChoices_templateObject15 || (MyHouseChoices_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0;\n  font-style: ", ";\n  ", ";\n"])), function (props) {
  return props.noOption ? 'italic' : '';
}, function (props) {
  return props.status === 'processed' && "margin-left: 12rem;";
});
var OrderOptionCode = styled_components_browser_esm["default"].span(MyHouseChoices_templateObject16 || (MyHouseChoices_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-size: 14rem;\n  margin-left: 33rem;\n"])), styleGuide/* colorPalette.beige */.K5.beige);
var MyHouseChoices_OptionSubtitleBase = (0,styled_components_browser_esm["default"])(OptionSubtitleContainer)(MyHouseChoices_templateObject17 || (MyHouseChoices_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 4px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n"])));
var OrderPrice = styled_components_browser_esm["default"].p(MyHouseChoices_templateObject18 || (MyHouseChoices_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0;\n\n  ", ";\n"])), breakpoints/* toBreakpoint.md */.Hx.md(MyHouseChoices_templateObject19 || (MyHouseChoices_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 33rem;\n    margin-top: 12rem;\n  "]))));
var OrderContainer = styled_components_browser_esm["default"].div(MyHouseChoices_templateObject20 || (MyHouseChoices_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 0 20rem;\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", " {\n    margin-left: auto;\n  }\n\n  > svg {\n    flex-shrink: 0;\n    align-self: flex-start;\n  }\n"])), function (props) {
  return props.status !== 'processed' && "margin-left: 33rem;";
}, breakpoints/* fromBreakpoint.md */.ks.md(MyHouseChoices_templateObject21 || (MyHouseChoices_templateObject21 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0 40rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseChoices_templateObject22 || (MyHouseChoices_templateObject22 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0 120rem 0 100rem;\n  "]))), OrderPrice);
var MyHouseChoices_OrderStatus = styled_components_browser_esm["default"].div(MyHouseChoices_templateObject23 || (MyHouseChoices_templateObject23 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 14rem;\n  font-style: italic;\n  color: ", ";\n  margin-top: 4px;\n  margin-bottom: 0;\n  margin-left: 33rem;\n\n  > p {\n    margin: 0;\n  }\n"])), function (props) {
  return props.color;
});
var Category = styled_components_browser_esm["default"].div(_templateObject24 || (_templateObject24 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 20rem;\n"])));
var MyHouseChoices_ButtonContainer = styled_components_browser_esm["default"].div(_templateObject25 || (_templateObject25 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 20rem;\n  margin-left: 33rem;\n"])));
var Order = styled_components_browser_esm["default"].div(_templateObject26 || (_templateObject26 = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-sizing: border-box;\n  padding: ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", " {\n    padding: 0;\n  }\n\n  ", " {\n    ", ";\n  }\n"])), function (props) {
  return props.status === 'processed' ? '20rem' : '10rem 20rem';
}, function (props) {
  return props.status === 'processed' && "\n      margin-bottom: 1rem;\n      background-color: rgba(".concat(styleGuide/* colorPaletteRGB.loadingOrange */.xe.loadingOrange, ", 0.25);\n    ");
}, breakpoints/* fromBreakpoint.md */.ks.md(_templateObject27 || (_templateObject27 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: ", ";\n  "])), function (props) {
  return props.status === 'processed' ? '20rem 40rem' : '10rem 40rem';
}), breakpoints/* fromBreakpoint.lg */.ks.lg(_templateObject28 || (_templateObject28 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: ", ";\n  "])), function (props) {
  return props.status === 'processed' ? '20rem 120rem 20rem 100rem' : '10rem 120rem 10rem 100rem';
}), OrderContainer, OrderTitle, function (props) {
  return props.status === 'processed' && "\n      font-weight: bold;\n      font-size: 18rem;\n      color: ".concat(styleGuide/* colorPalette.orange */.K5.orange, ";\n    ");
});
var MyHouseChoices_Footer = styled_components_browser_esm["default"].div(_templateObject29 || (_templateObject29 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 16rem;\n  padding: 10rem 20rem 0;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(_templateObject30 || (_templateObject30 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 10rem 40rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(_templateObject31 || (_templateObject31 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 10rem 120rem 10rem 100rem;\n  "]))));
var ButtonExpandContainer = styled_components_browser_esm["default"].div(_templateObject32 || (_templateObject32 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 8px;\n  margin-left: 33rem;\n"])));
;// CONCATENATED MODULE: ./src/components/MyHouseBlock.js


var MyHouseBlock_templateObject;

var MyHouseBlock_jsx = react.createElement;





var MyHouseBlock = function MyHouseBlock(_ref) {
  var house = _ref.house,
      houseType = _ref.houseType,
      categories = _ref.categories,
      renderWidth = _ref.renderWidth,
      houseConfirmationExport = _ref.houseConfirmationExport,
      houseOverviewTotalPerCompany = _ref.houseOverviewTotalPerCompany;

  if (!house || !houseType || !categories) {
    return null;
  }

  return MyHouseBlock_jsx(MyHouseBlock_Container, {
    "data-e2e-block-myhouse": true,
    "data-id": "components_MyHouseBlock_Container"
  }, MyHouseBlock_jsx(components_MyHouseBase, {
    house: house,
    houseType: houseType,
    categories: categories,
    "data-id": "components_MyHouseBlock_MyHouseBase"
  }), MyHouseBlock_jsx(components_MyHouseChoices, {
    bnr: house.bnr,
    price: house.price,
    livingSpace: houseType.livingSpace,
    bedrooms: houseType.bedrooms,
    categories: categories,
    renderWidth: renderWidth,
    houseConfirmationExport: houseConfirmationExport,
    houseOverviewTotalPerCompany: houseOverviewTotalPerCompany,
    "data-id": "components_MyHouseBlock_MyHouseChoices"
  }));
};

/* harmony default export */ var components_MyHouseBlock = (MyHouseBlock);
var MyHouseBlock_Container = styled_components_browser_esm["default"].div(MyHouseBlock_templateObject || (MyHouseBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n"])));
;// CONCATENATED MODULE: ./src/components/shared/designElements/ProgressCircle.js


var ProgressCircle_templateObject, ProgressCircle_templateObject2, ProgressCircle_templateObject3, ProgressCircle_templateObject4, ProgressCircle_templateObject5;

var ProgressCircle_jsx = react.createElement;





var ProgressCircle = function ProgressCircle(_ref) {
  var theme = _ref.theme,
      progress = _ref.progress;
  return ProgressCircle_jsx(BackgroundCircle, {
    "data-id": "designElements_ProgressCircle_BackgroundCircle"
  }, ProgressCircle_jsx(InnerCircle, {
    color: styleGuide/* themes */.np[theme].primary,
    "data-id": "designElements_ProgressCircle_InnerCircle"
  }, ProgressCircle_jsx(FirstHalf, {
    color: styleGuide/* themes */.np[theme].primary,
    lightColor: styleGuide/* themes */.np[theme].tertiary,
    "data-id": "designElements_ProgressCircle_FirstHalf"
  }, ProgressCircle_jsx(SecondHalfWrap, {
    progress: progress,
    "data-id": "designElements_ProgressCircle_SecondHalfWrap"
  }, ProgressCircle_jsx(SecondHalf, {
    color: styleGuide/* themes */.np[theme].primary,
    progress: progress,
    lightColor: styleGuide/* themes */.np[theme].tertiary,
    "data-id": "designElements_ProgressCircle_SecondHalf"
  })))), progress === 1 && ProgressCircle_jsx(Check/* default */.Z, {
    color: "white",
    "data-id": "designElements_ProgressCircle_Check"
  }));
};

/* harmony default export */ var designElements_ProgressCircle = (ProgressCircle);
var BackgroundCircle = styled_components_browser_esm["default"].div(ProgressCircle_templateObject || (ProgressCircle_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 36rem;\n  height: 36rem;\n  border-radius: 18px;\n  background-color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  > svg {\n    position: absolute;\n  }\n"])));
var InnerCircle = styled_components_browser_esm["default"].div(ProgressCircle_templateObject2 || (ProgressCircle_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 32rem;\n  height: 32rem;\n  border-radius: 16px;\n  background-color: ", ";\n  position: relative;\n"])), function (props) {
  return props.color;
});
var FirstHalf = styled_components_browser_esm["default"].div(ProgressCircle_templateObject3 || (ProgressCircle_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 16rem;\n  height: 32rem;\n  border-radius: 16px;\n  background-color: ", ";\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  z-index: 1;\n"])), function (props) {
  return props.lightColor;
});
var SecondHalfWrap = styled_components_browser_esm["default"].div(ProgressCircle_templateObject4 || (ProgressCircle_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 32rem;\n  height: 32rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: rotate(\n    -", "deg\n  );\n"])), function (props) {
  return props.progress === 1 ? 0 : (0.5 - props.progress % 0.5) * 360;
});
var SecondHalf = (0,styled_components_browser_esm["default"])(FirstHalf)(ProgressCircle_templateObject5 || (ProgressCircle_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n"])), function (props) {
  return props.progress >= 0.5 ? props.color : props.lightColor;
});
;// CONCATENATED MODULE: ./src/components/dashboard/ECWSpaceBlockHotspotOptions.js








var ECWSpaceBlockHotspotOptions_templateObject, ECWSpaceBlockHotspotOptions_templateObject2, ECWSpaceBlockHotspotOptions_templateObject3, ECWSpaceBlockHotspotOptions_templateObject4, ECWSpaceBlockHotspotOptions_templateObject5, ECWSpaceBlockHotspotOptions_templateObject6, ECWSpaceBlockHotspotOptions_templateObject7, ECWSpaceBlockHotspotOptions_templateObject8;

var ECWSpaceBlockHotspotOptions_jsx = react.createElement;

function ECWSpaceBlockHotspotOptions_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ECWSpaceBlockHotspotOptions_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ECWSpaceBlockHotspotOptions_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ECWSpaceBlockHotspotOptions_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}










var ECWSpaceBlockHotspotOptions_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openInterestModal: function openInterestModal(hotspotId) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* themes */.np[ownProps.theme].secondary, {
        type: 'interests',
        componentProps: {
          color: styleGuide/* themes */.np[ownProps.theme].primary,
          hotspotId: hotspotId
        }
      }));
    }
  };
};

var ECWSpaceBlockHotspotOptions = /*#__PURE__*/function (_Component) {
  function ECWSpaceBlockHotspotOptions() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ECWSpaceBlockHotspotOptions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ECWSpaceBlockHotspotOptions_callSuper(this, ECWSpaceBlockHotspotOptions, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "containerRef", null);

    return _this;
  }

  (0,inherits/* default */.Z)(ECWSpaceBlockHotspotOptions, _Component);

  return (0,createClass/* default */.Z)(ECWSpaceBlockHotspotOptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.containerRef) {
        this.props.onMeasureHeight(this.containerRef.offsetHeight);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          show = _this$props.show,
          index = _this$props.index,
          theme = _this$props.theme,
          _this$props$options = _this$props.options,
          options = _this$props$options === void 0 ? [] : _this$props$options,
          openInterestModal = _this$props.openInterestModal;
      return ECWSpaceBlockHotspotOptions_jsx(ECWSpaceBlockHotspotOptions_Container, {
        ref: function ref(el) {
          _this2.containerRef = el;
        },
        show: show,
        color: styleGuide/* themes */.np[theme].secondary,
        index: index,
        "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Container"
      }, ECWSpaceBlockHotspotOptions_jsx(ECWSpaceBlockHotspotOptions_InnerContainer, {
        "data-id": "dashboard_ECWSpaceBlockHotspotOptions_InnerContainer"
      }, (options || []).map(function (hotspot, index) {
        return ECWSpaceBlockHotspotOptions_jsx(Fold, {
          key: index,
          onClick: function onClick() {
            return openInterestModal(hotspot.id);
          },
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Fold"
        }, ECWSpaceBlockHotspotOptions_jsx(Circle, {
          color: hotspot.hasRating ? styleGuide/* themes */.np[theme].active : styleGuide/* themes */.np[theme].primary,
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Circle"
        }, hotspot.hasRating && ECWSpaceBlockHotspotOptions_jsx(Check/* default */.Z, {
          color: "white",
          width: 9,
          height: 7,
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Check"
        })), ECWSpaceBlockHotspotOptions_jsx(HotspotTitle, {
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_HotspotTitle"
        }, hotspot.title), ECWSpaceBlockHotspotOptions_jsx(Caret/* default */.Z, {
          color: "white",
          direction: "right",
          width: 8,
          height: 13,
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Caret"
        }));
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var dashboard_ECWSpaceBlockHotspotOptions = ((0,es/* connect */.$j)(null, ECWSpaceBlockHotspotOptions_mapDispatchToProps)(ECWSpaceBlockHotspotOptions));
var ECWSpaceBlockHotspotOptions_Container = styled_components_browser_esm["default"].div(ECWSpaceBlockHotspotOptions_templateObject || (ECWSpaceBlockHotspotOptions_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  position: absolute;\n  top: ", "rem;\n  z-index: 2;\n  width: 290rem;\n  opacity: ", ";\n  transition: max-height 0.3s ease-in-out, top 0.3s ease-in-out;\n  overflow: hidden;\n  ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.show ? 220 : 200;
}, function (props) {
  return props.show ? 1 : 0;
}, breakpoints/* fromBreakpoint.md */.ks.md(ECWSpaceBlockHotspotOptions_templateObject2 || (ECWSpaceBlockHotspotOptions_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 600rem;\n    right: ", ";\n  "])), function (props) {
  return props.index % 2 === 1 ? 0 : undefined;
}));
var ECWSpaceBlockHotspotOptions_InnerContainer = styled_components_browser_esm["default"].div(ECWSpaceBlockHotspotOptions_templateObject3 || (ECWSpaceBlockHotspotOptions_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 24rem 40rem 24rem 0rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ECWSpaceBlockHotspotOptions_templateObject4 || (ECWSpaceBlockHotspotOptions_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-flow: wrap;\n  "]))));
var Fold = styled_components_browser_esm["default"].div(ECWSpaceBlockHotspotOptions_templateObject5 || (ECWSpaceBlockHotspotOptions_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 16rem;\n  cursor: pointer;\n  width: 100%;\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ECWSpaceBlockHotspotOptions_templateObject6 || (ECWSpaceBlockHotspotOptions_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 50%;\n  "]))));
var Circle = styled_components_browser_esm["default"].div(ECWSpaceBlockHotspotOptions_templateObject7 || (ECWSpaceBlockHotspotOptions_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  width: 18rem;\n  height: 18rem;\n  border-radius: 50%;\n  background-color: ", ";\n  align-items: center;\n  margin-right: 8rem;\n  margin-left: 40rem;\n"])), function (props) {
  return props.color;
});
var HotspotTitle = styled_components_browser_esm["default"].p(ECWSpaceBlockHotspotOptions_templateObject8 || (ECWSpaceBlockHotspotOptions_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  display: inline;\n  color: white;\n  font-weight: bold;\n  margin: 0 5rem 0 0;\n"])), styleGuide/* textStyles.standardText */.sq.standardText);
;// CONCATENATED MODULE: ./src/components/dashboard/ECWSpaceBlock.js








var ECWSpaceBlock_templateObject, ECWSpaceBlock_templateObject2, ECWSpaceBlock_templateObject3, ECWSpaceBlock_templateObject4, ECWSpaceBlock_templateObject5, ECWSpaceBlock_templateObject6;

var ECWSpaceBlock_jsx = react.createElement;

function ECWSpaceBlock_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ECWSpaceBlock_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ECWSpaceBlock_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ECWSpaceBlock_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}










var SpaceBlock = /*#__PURE__*/function (_Component) {
  function SpaceBlock() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, SpaceBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ECWSpaceBlock_callSuper(this, SpaceBlock, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      maxHeight: 0
    });

    (0,defineProperty/* default */.Z)(_this, "calculateProgress", function (space) {
      var hotspots = space.hotspots;
      if (hotspots.length === 0) return 0;
      return hotspots.filter(function (hotspot) {
        return hotspot.hasRating;
      }).length / hotspots.length;
    });

    (0,defineProperty/* default */.Z)(_this, "setMaxHeight", function (maxHeight) {
      _this.setState({
        maxHeight: maxHeight
      });
    });

    (0,defineProperty/* default */.Z)(_this, "toggleShow", function () {
      _this.props.onToggle(_this.props.space.id);
    });

    return _this;
  }

  (0,inherits/* default */.Z)(SpaceBlock, _Component);

  return (0,createClass/* default */.Z)(SpaceBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          space = _this$props.space,
          isOpen = _this$props.isOpen;
      return ECWSpaceBlock_jsx(ECWSpaceBlock_Container, {
        "data-id": "dashboard_ECWSpaceBlock_Container"
      }, ECWSpaceBlock_jsx(SpaceContainer, {
        index: index,
        onClick: this.toggleShow,
        "data-id": "dashboard_ECWSpaceBlock_SpaceContainer"
      }, ECWSpaceBlock_jsx(ImageLoader/* default */.Z, {
        src: '/images/interestsimage.jpg',
        mode: "img",
        alt: "interestsimage",
        "data-id": "dashboard_ECWSpaceBlock_ImageLoader"
      }), ECWSpaceBlock_jsx(Progress, {
        "data-id": "dashboard_ECWSpaceBlock_Progress"
      }, ECWSpaceBlock_jsx(designElements_ProgressCircle, {
        theme: styleGuide/* ECWthemeMap */.iJ[space.theme.slug],
        progress: this.calculateProgress(space),
        "data-id": "dashboard_ECWSpaceBlock_ProgressCircle"
      })), ECWSpaceBlock_jsx(ECWSpaceBlock_Label, {
        show: isOpen,
        "data-id": "dashboard_ECWSpaceBlock_Label"
      }, ECWSpaceBlock_jsx(designElements_ThemeLabel, {
        twoTriangles: true,
        label: space.title,
        theme: styleGuide/* ECWthemeMap */.iJ[space.theme.slug],
        "data-id": "dashboard_ECWSpaceBlock_ThemeLabel"
      }))), ECWSpaceBlock_jsx(FoldContainer, {
        show: isOpen,
        maxHeight: this.state.maxHeight,
        "data-id": "dashboard_ECWSpaceBlock_FoldContainer"
      }, isOpen && ECWSpaceBlock_jsx(dashboard_ECWSpaceBlockHotspotOptions, {
        index: index,
        show: isOpen,
        options: space.hotspots,
        theme: styleGuide/* ECWthemeMap */.iJ[space.theme.slug],
        maxHeight: this.state.maxHeight,
        onMeasureHeight: this.setMaxHeight,
        "data-id": "dashboard_ECWSpaceBlock_ECWSpaceBlockHotspotOptions"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var ECWSpaceBlock = (SpaceBlock);
var ECWSpaceBlock_Container = styled_components_browser_esm["default"].div(ECWSpaceBlock_templateObject || (ECWSpaceBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n"])));
var SpaceContainer = styled_components_browser_esm["default"].div(ECWSpaceBlock_templateObject2 || (ECWSpaceBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  width: 290rem;\n  height: 180rem;\n  margin-top: 20rem;\n  cursor: pointer;\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ECWSpaceBlock_templateObject3 || (ECWSpaceBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: ", "rem;\n  "])), function (props) {
  return props.index % 2 === 1 ? 20 : 0;
}));
var FoldContainer = styled_components_browser_esm["default"].div(ECWSpaceBlock_templateObject4 || (ECWSpaceBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: ", "rem;\n  opacity: ", ";\n  transition: margin 0.3s ease-in-out, opacity 0.25s ease-in-out;\n"])), function (props) {
  return props.show ? props.maxHeight + 20 : 0;
}, function (props) {
  return props.show ? 1 : 0;
});
var Progress = styled_components_browser_esm["default"].div(ECWSpaceBlock_templateObject5 || (ECWSpaceBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 12rem;\n  right: 12rem;\n  z-index: 2;\n"])));
var ECWSpaceBlock_Label = styled_components_browser_esm["default"].div(ECWSpaceBlock_templateObject6 || (ECWSpaceBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: ", "rem;\n  z-index: 2;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  transition: bottom 0.3s ease-in-out;\n\n  > div > span {\n    width: 180rem;\n    padding: 0 15rem;\n    justify-content: center;\n  }\n"])), function (props) {
  return props.show ? -20 : 0;
});
;// CONCATENATED MODULE: ./src/components/dashboard/ECWInterestsBlock.js








var ECWInterestsBlock_templateObject, ECWInterestsBlock_templateObject2, ECWInterestsBlock_templateObject3, ECWInterestsBlock_templateObject4, ECWInterestsBlock_templateObject5, ECWInterestsBlock_templateObject6, ECWInterestsBlock_templateObject7, ECWInterestsBlock_templateObject8, ECWInterestsBlock_templateObject9, ECWInterestsBlock_templateObject0, ECWInterestsBlock_templateObject1;

var ECWInterestsBlock_jsx = react.createElement;

function ECWInterestsBlock_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ECWInterestsBlock_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ECWInterestsBlock_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ECWInterestsBlock_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}







var InterestsBlock = /*#__PURE__*/function (_Component) {
  function InterestsBlock() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, InterestsBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ECWInterestsBlock_callSuper(this, InterestsBlock, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      openBlock: -1
    });

    (0,defineProperty/* default */.Z)(_this, "handleToggle", function (id) {
      _this.setState({
        openBlock: _this.state.openBlock !== id ? id : -1
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(InterestsBlock, _Component);

  return (0,createClass/* default */.Z)(InterestsBlock, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          layout = _this$props.layout,
          renderWidth = _this$props.renderWidth;
      var openBlock = this.state.openBlock;
      var spaces = layout.length > 0 ? layout[0].spaces : null;
      return spaces ? ECWInterestsBlock_jsx(ECWInterestsBlock_Container, {
        "data-e2e-block-ecwinterests": true,
        "data-id": "dashboard_ECWInterestsBlock_Container"
      }, ECWInterestsBlock_jsx(ECWInterestsBlock_Title, {
        "data-id": "dashboard_ECWInterestsBlock_Title"
      }, "Mijn interesses"), ECWInterestsBlock_jsx(ECWInterestsBlock_SubTitle, {
        "data-id": "dashboard_ECWInterestsBlock_SubTitle"
      }, "Kies \xE9\xE9n van de categorie\xEBn en bekijk per onderwerp welke voorkeuren je in het Homestudios experience center hebt aangegeven."), ECWInterestsBlock_jsx(Spaces, {
        "data-id": "dashboard_ECWInterestsBlock_Spaces"
      }, (spaces || []).map(function (space, index) {
        return ECWInterestsBlock_jsx(ECWSpaceBlock, {
          key: renderWidth > 689 ? index : index + 20,
          index: index,
          space: space,
          renderWidth: renderWidth,
          isOpen: openBlock === space.id,
          onToggle: _this2.handleToggle,
          "data-id": "dashboard_ECWInterestsBlock_ECWSpaceBlock"
        });
      }))) : null;
    }
  }]);
}(react.Component);

/* harmony default export */ var ECWInterestsBlock = (InterestsBlock);
var ECWInterestsBlock_Container = styled_components_browser_esm["default"].div(ECWInterestsBlock_templateObject || (ECWInterestsBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: white;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: 20rem 10rem 20rem 10rem;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestsBlock_templateObject2 || (ECWInterestsBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 40rem 10rem 30rem 10rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ECWInterestsBlock_templateObject3 || (ECWInterestsBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 60rem 10rem 80rem 10rem;\n  "]))));
var ECWInterestsBlock_Title = styled_components_browser_esm["default"].h2(ECWInterestsBlock_templateObject4 || (ECWInterestsBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestsBlock_templateObject5 || (ECWInterestsBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 40rem;\n    max-width: 450rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ECWInterestsBlock_templateObject6 || (ECWInterestsBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 80rem;\n    max-width: 760rem;\n  "]))));
var ECWInterestsBlock_SubTitle = styled_components_browser_esm["default"].h4(ECWInterestsBlock_templateObject7 || (ECWInterestsBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: normal;\n  font-style: italic;\n  margin-top: 0;\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestsBlock_templateObject8 || (ECWInterestsBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 40rem;\n    max-width: 450rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ECWInterestsBlock_templateObject9 || (ECWInterestsBlock_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: 80rem;\n    max-width: 760rem;\n  "]))));
var Spaces = styled_components_browser_esm["default"].div(ECWInterestsBlock_templateObject0 || (ECWInterestsBlock_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 600rem;\n  align-self: center;\n  align-items: center;\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestsBlock_templateObject1 || (ECWInterestsBlock_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-flow: wrap;\n    align-items: flex-start;\n  "]))));
;// CONCATENATED MODULE: ./src/components/dashboard/ProfileWidget.js








var ProfileWidget_templateObject, ProfileWidget_templateObject2, ProfileWidget_templateObject3, ProfileWidget_templateObject4, ProfileWidget_templateObject5, ProfileWidget_templateObject6, ProfileWidget_templateObject7, ProfileWidget_templateObject8;

var ProfileWidget_jsx = react.createElement;

function ProfileWidget_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ProfileWidget_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ProfileWidget_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ProfileWidget_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}













var ProfileWidget_connectApiData = (0,withApiData/* default */.Z)({
  profile: 'getProfile'
}, function (ownProps) {
  return {
    profile: {
      projectSlug: ownProps.match.params.projectSlug
    }
  };
});

var ProfileWidget_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase', undefined)
  };
};

var GREETINGS = [{
  hour: 0,
  greeting: 'Goedenacht'
}, {
  hour: 6,
  greeting: 'Goedemorgen'
}, {
  hour: 12,
  greeting: 'Goedemiddag'
}, {
  hour: 18,
  greeting: 'Goedenavond'
}, {
  hour: 24,
  greeting: 'Goedenacht'
}];

var ProfileWidget = /*#__PURE__*/function (_Component) {
  function ProfileWidget() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ProfileWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ProfileWidget_callSuper(this, ProfileWidget, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "sortArray", function (profileData) {
      if (!profileData || !profileData.customer || !profileData.customer.users) return []; // We want to order the array of users, so the logged in user is first, then the other users in the household.

      return profileData.customer.users.sort(function (user) {
        return user.email === profileData.email ? 0 : 1;
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ProfileWidget, _Component);

  return (0,createClass/* default */.Z)(ProfileWidget, [{
    key: "getGreeting",
    value: function getGreeting(hours) {
      var timeFrame = GREETINGS.find(function (time) {
        return time.hour === hours || time.hour < hours && time.hour > hours - 6;
      });
      return timeFrame ? timeFrame.greeting : 'Goedendag';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          phase = _this$props.phase,
          match = _this$props.match,
          profile = _this$props.profile,
          isSmall = _this$props.isSmall,
          router = _this$props.router;
      var projectSlug = match.params.projectSlug;
      var profileData = profile.data;
      var date = new Date();
      var hours = date.getHours();
      var imageUrl = lodash_get_default()(profileData, 'customer.customerImage') ? lodash_get_default()(profileData, 'customer.customerImage') : lodash_get_default()(profileData, 'image', undefined);
      var name = lodash_get_default()(profileData, 'customer.customerName') ? lodash_get_default()(profileData, 'customer.customerName') : lodash_get_default()(profileData, 'name', undefined);
      return profileData ? ProfileWidget_jsx(ProfileWidget_Container, {
        isSmall: isSmall,
        "data-e2e-profile-widget": true,
        "data-e2e-profile-widget-small": isSmall,
        "data-id": "dashboard_ProfileWidget_Container"
      }, ProfileWidget_jsx(Top, {
        small: isSmall,
        "data-id": "dashboard_ProfileWidget_Top"
      }, ProfileWidget_jsx(UserAvatarContainer, {
        onClick: function onClick() {
          return router === null || router === void 0 ? void 0 : router.push("/".concat(String(projectSlug), "/closed/profiel"));
        },
        "data-id": "dashboard_ProfileWidget_UserAvatarContainer"
      }, ProfileWidget_jsx(UserAvatar/* default */.Z, {
        phase: phase,
        size: "xlarge",
        mode: "imageLoader",
        imageUrl: imageUrl,
        name: name,
        "data-id": "dashboard_ProfileWidget_UserAvatar"
      })), ProfileWidget_jsx(Greeting, {
        "data-id": "dashboard_ProfileWidget_Greeting"
      }, this.getGreeting(hours), " ", name), phase !== 'cj1' && ProfileWidget_jsx(react.Fragment, null, this.sortArray(profileData).map(function (user, index) {
        return index < 2 && ProfileWidget_jsx(CustomerUsers, {
          key: index,
          "data-id": "dashboard_ProfileWidget_CustomerUsers"
        }, ProfileWidget_jsx(UserAvatar/* default */.Z, {
          size: "xsmall",
          mode: "imageLoader",
          imageUrl: "",
          name: user.name,
          "data-id": "dashboard_ProfileWidget_UserAvatar"
        }), ProfileWidget_jsx("span", {
          "data-id": "dashboard_ProfileWidget_span"
        }, user.name));
      }), profileData && profileData.customer && profileData.customer.users.length > 2 && ProfileWidget_jsx(ExtraUsers, {
        "data-id": "dashboard_ProfileWidget_ExtraUsers"
      }, "+", profileData.customer.users.length - 2, ' ', profileData.customer.users.length - 2 > 1 ? 'accounts' : 'account', " gekoppeld"))), !isSmall && ProfileWidget_jsx(ProfileWidget_Text, {
        "data-id": "dashboard_ProfileWidget_Text"
      }, ((phase === 'cj2' || phase === 'cj3') && profileData.customer && !profileData.customer.bio || phase === 'cj1') && ProfileWidget_jsx("div", {
        "data-id": "dashboard_ProfileWidget_div"
      }, "Het is belangrijk je persoonlijke gegevens up to date te houden."), (phase === 'cj2' || phase === 'cj3') && profileData.customer && profileData.customer.bio && truncateText(profileData.customer.bio, 180), ProfileWidget_jsx(Link/* default */.Z, {
        href: "/".concat(String(match.params.projectSlug), "/closed/profiel"),
        "data-id": "dashboard_ProfileWidget_Link"
      }, "Profiel beheren")), isSmall && ProfileWidget_jsx(ProfileWidget_Text, {
        "data-id": "dashboard_ProfileWidget_Text"
      }, phase !== 'cj1' && profileData.customer && profileData.customer.bio && profileData.customer.bio)) : null;
    }
  }]);
}(react.Component);

/* harmony default export */ var dashboard_ProfileWidget = ((0,withMatch/* default */.Z)(ProfileWidget_connectApiData((0,es/* connect */.$j)(ProfileWidget_mapStateToProps)(ProfileWidget))));
var ProfileWidget_Container = styled_components_browser_esm["default"].div(ProfileWidget_templateObject || (ProfileWidget_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: center;\n  align-self: flex-start;\n  justify-content: space-between;\n  background-color: white;\n  margin-top: ", ";\n  height: ", ";\n  padding-left: 20rem;\n  padding-right: 20rem;\n  padding-bottom: 20rem;\n  opacity: 0;\n  animation: ", " 0.25s ease-in;\n  animation-fill-mode: forwards;\n\n  ", " @media all and (max-width: 969px) {\n    height: ", ";\n  }\n"])), function (props) {
  return !props.isSmall ? '-60rem' : '0rem';
}, function (props) {
  return !props.isSmall ? '466rem' : 'auto';
}, styleGuide/* fadeIn */.Ji, breakpoints/* toBreakpoint.xl */.Hx.xl(ProfileWidget_templateObject2 || (ProfileWidget_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n  "]))), function (props) {
  return !props.isSmall ? '386rem' : 'auto';
});
var ExtraUsers = styled_components_browser_esm["default"].div(ProfileWidget_templateObject3 || (ProfileWidget_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-top: 15rem;\n  text-align: center;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var CustomerUsers = styled_components_browser_esm["default"].div(ProfileWidget_templateObject4 || (ProfileWidget_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  display: flex;\n  font-weight: bold;\n  color: ", ";\n  margin-top: 12rem;\n  justify-content: center;\n  max-width: 280rem;\n\n  > div {\n    margin-right: 8rem;\n  }\n\n  > span {\n    max-width: 240rem;\n    word-wrap: break-word;\n    text-align: center;\n  }\n"])), styleGuide/* textStyles.standardText */.sq.standardText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var Top = styled_components_browser_esm["default"].div(ProfileWidget_templateObject5 || (ProfileWidget_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: ", "rem;\n"])), function (props) {
  return props.small ? 20 : 0;
});
var ProfileWidget_Text = styled_components_browser_esm["default"].div(ProfileWidget_templateObject6 || (ProfileWidget_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  color: ", ";\n  width: 100%;\n\n  > a {\n    align-self: flex-start;\n    margin: 6rem auto 0 auto;\n    cursor: pointer;\n    color: ", ";\n    text-decoration: none;\n    border-bottom: 1rem solid transparent;\n    transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n    &:hover {\n      color: ", ";\n      border-bottom: 1rem solid ", ";\n    }\n  }\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* colorPalette.blue */.K5.blue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue);
var Greeting = styled_components_browser_esm["default"].div(ProfileWidget_templateObject7 || (ProfileWidget_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-top: 18rem;\n  text-align: center;\n  max-width: 280rem;\n  word-wrap: break-word;\n  margin-bottom: 10rem;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.orange */.K5.orange);
var UserAvatarContainer = styled_components_browser_esm["default"].div(ProfileWidget_templateObject8 || (ProfileWidget_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: -60rem;\n  &:hover {\n    cursor: pointer;\n  }\n"])));
;// CONCATENATED MODULE: ./src/components/shared/designElements/WidgetScroller.js


var WidgetScroller_templateObject;



var WidgetScroller = styled_components_browser_esm["default"].div(WidgetScroller_templateObject || (WidgetScroller_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: auto;\n  flex-grow: 1;\n\n  ::-webkit-scrollbar {\n    width: 8rem;\n    height: 0;\n    background-color: ", ";\n    border-radius: 5rem;\n    overflow: hidden;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 5rem;\n  }\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, styleGuide/* colorPalette.blue */.K5.blue);
;// CONCATENATED MODULE: ./src/components/shared/designElements/WidgetFooter.js


var WidgetFooter_templateObject;


var WidgetFooter = styled_components_browser_esm["default"].div(WidgetFooter_templateObject || (WidgetFooter_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-basis: 20rem;\n  flex-shrink: 0;\n  align-items: center;\n  margin-top: auto;\n  padding-top: 12rem;\n"])));
;// CONCATENATED MODULE: ./src/components/shared/icons/AvatarHS.js
var AvatarHS_jsx = react.createElement;


var AvatarHS_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var AvatarHS = function AvatarHS(_ref) {
  var color = _ref.color;
  return AvatarHS_jsx("svg", {
    width: "24px",
    height: "28px",
    viewBox: "0 0 24 28",
    version: "1.1",
    "data-id": "icons_AvatarHS_svg"
  }, AvatarHS_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_AvatarHS_g"
  }, AvatarHS_jsx("g", {
    transform: "translate(-159.000000, -870.000000)",
    fill: "#FEFEFE",
    "data-id": "icons_AvatarHS_g_2"
  }, AvatarHS_jsx("g", {
    transform: "translate(159.000000, 870.000000)",
    "data-id": "icons_AvatarHS_g_3"
  }, AvatarHS_jsx("path", {
    d: "M12.6456,26.1304465 L12.6456,24.5995628 L20.6408432,19.9606791 L21.9653838,20.7284 L12.6456,26.1304465 Z M12.6456,21.5137023 L17.9872216,18.4232837 L19.3325189,19.2020744 L12.6456,23.0817023 L12.6456,21.5137023 Z M12.6456,18.4486791 L15.3400865,16.888493 L16.6782486,17.6640279 L12.6456,19.9971442 L12.6456,18.4486791 Z M12.6456,15.3270047 L14.0304649,16.1292372 L12.6456,16.9308186 L12.6456,15.3270047 Z M23.9294919,20.7284 C23.9294919,20.4855163 23.7978162,20.2732372 23.602573,20.1592837 L12.6456,13.8091442 L12.6456,12.0568651 L22.3617081,17.6887721 C22.5134919,17.7760279 22.6840865,17.8222605 22.8579243,17.8222605 C23.2114378,17.8222605 23.5416,17.6314698 23.7180324,17.3241209 L23.8769514,17.0486791 L12.6456,10.5390047 L12.6456,8.78672558 L22.3617081,14.4186326 C22.5134919,14.5058884 22.6840865,14.5521209 22.8579243,14.5521209 C23.2114378,14.5521209 23.5416,14.3613302 23.7180324,14.0539814 L23.8769514,13.7778884 L12.6456,7.26886512 L12.6456,5.51658605 L22.3617081,11.148493 C22.5134919,11.2357488 22.6847351,11.2819814 22.8579243,11.2819814 C23.2120865,11.2819814 23.5416,11.0911907 23.7180324,10.7838419 L23.8769514,10.5084 L12.6456,3.99872558 L12.6456,2.24644651 L22.3617081,7.87835349 C22.5134919,7.9656093 22.6840865,8.01184186 22.8579243,8.01184186 C23.2114378,8.01184186 23.5416,7.82105116 23.7180324,7.51435349 L23.8769514,7.23891163 L12.3193297,0.539748837 L12.3173838,0.539748837 C12.2213838,0.483748837 12.1098162,0.451190698 11.9911135,0.451190698 C11.6304649,0.451190698 11.3359784,0.746167442 11.3359784,1.10821395 L11.3359784,27.2686791 C11.336627,27.6313767 11.6298162,27.9250512 11.9911135,27.9250512 C12.1072216,27.9250512 12.2161946,27.8944465 12.3108973,27.8410512 L12.3115459,27.8410512 C12.3134919,27.8397488 12.3160865,27.8390977 12.3180324,27.8377953 L23.602573,21.2975163 C23.6038703,21.2968651 23.6045189,21.296214 23.6051676,21.2955628 C23.7991135,21.1809581 23.9294919,20.9699814 23.9294919,20.7284 L23.9294919,20.7284 Z",
    "data-id": "icons_AvatarHS_path"
  }), AvatarHS_jsx("path", {
    d: "M0.0520864865,8.3268093 L0.0520864865,21.0466233 L1.36235676,21.0466233 L1.36235676,7.33053023 L1.04451892,7.33053023 C0.497708108,7.33053023 0.0520864865,7.77787907 0.0520864865,8.3268093",
    "data-id": "icons_AvatarHS_path_5"
  }), AvatarHS_jsx("path", {
    d: "M8.51487568,3.11972093 L8.51487568,25.9853023 L9.8244973,25.9853023 L9.8244973,2.12344186 L9.50730811,2.12344186 C8.9604973,2.12344186 8.51487568,2.57013953 8.51487568,3.11972093",
    "data-id": "icons_AvatarHS_path_6"
  }), AvatarHS_jsx("path", {
    d: "M5.69416216,4.83664186 L5.69416216,24.3168279 L7.00378378,24.3168279 L7.00378378,3.84036279 L6.68659459,3.84036279 C6.13978378,3.84036279 5.69416216,4.28771163 5.69416216,4.83664186",
    "data-id": "icons_AvatarHS_path_7"
  }), AvatarHS_jsx("path", {
    d: "M2.8728,6.59204651 L2.8728,22.6484186 L4.18242162,22.6484186 L4.18242162,5.59576744 L3.86523243,5.59576744 C3.31842162,5.59576744 2.8728,6.04246512 2.8728,6.59204651",
    "data-id": "icons_AvatarHS_path_8"
  })))));
};

AvatarHS.defaultProps = AvatarHS_defaultProps;
/* harmony default export */ var icons_AvatarHS = (AvatarHS);
;// CONCATENATED MODULE: ./src/components/dashboard/MessagesWidget.js



var MessagesWidget_templateObject, MessagesWidget_templateObject2, MessagesWidget_templateObject3, MessagesWidget_templateObject4, MessagesWidget_templateObject5, MessagesWidget_templateObject6, MessagesWidget_templateObject7, MessagesWidget_templateObject8, MessagesWidget_templateObject9, MessagesWidget_templateObject0, MessagesWidget_templateObject1, MessagesWidget_templateObject10;

var MessagesWidget_jsx = react.createElement;

function MessagesWidget_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function MessagesWidget_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? MessagesWidget_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MessagesWidget_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




















var MessagesWidget_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase', undefined)
  };
};

var MessagesWidget_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openModal: function openModal() {
      if (ownProps.dummyContent) {
        dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
          type: 'profile',
          componentProps: {
            type: 'messages',
            content: ownProps.dummyContent.modal
          }
        }));
      }
    }
  };
};

var MessagesWidget_redirect = function redirect(link, router) {
  if (!link) return;
  router === null || router === void 0 || router.push('/' + (0,getLinkFromPageObject/* default */.Z)(link));
};

var countMessages = function countMessages(unreadCount) {
  if (unreadCount === undefined) return '1 ongelezen bericht';

  if (unreadCount === 0) {
    return 'Geen ongelezen berichten';
  } else if (unreadCount === 1) {
    return '1 ongelezen bericht';
  } else {
    return "".concat(unreadCount, " ongelezen berichten");
  }
};

var MessagesWidget = function MessagesWidget(_ref) {
  var phase = _ref.phase,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      link = _ref.link,
      unreadCount = _ref.unreadCount,
      openModal = _ref.openModal,
      router = _ref.router;
  var messages = phase === 'cj1' ? [{
    sender: {
      name: 'Team Homestudios',
      icon: MessagesWidget_jsx(icons_AvatarHS, {
        "data-id": "dashboard_MessagesWidget_AvatarHSIcon"
      })
    },
    onClick: openModal,
    subject: 'Welkom bij Homestudios',
    content: 'Als koper kun je vanaf deze plaats straks direct communiceren met de woonadviseur en andere Homestudios specialisten.',
    type: 'defaultMessage'
  }] : items.map(function (item) {
    return MessagesWidget_objectSpread(MessagesWidget_objectSpread({}, item), {}, {
      onClick: link ? function () {
        return MessagesWidget_redirect(link, router);
      } : undefined
    });
  });
  return MessagesWidget_jsx(MessagesWidget_Container, {
    "data-id": "dashboard_MessagesWidget_Container"
  }, MessagesWidget_jsx(MessagesWidget_Label, {
    "data-id": "dashboard_MessagesWidget_Label"
  }, MessagesWidget_jsx(designElements_ThemeLabel, {
    label: "Berichtencentrum",
    theme: "projectUpdate",
    "data-id": "dashboard_MessagesWidget_ThemeLabel"
  }), MessagesWidget_jsx(icons_Message, {
    width: 20,
    height: 14,
    color: styleGuide/* colorPalette.white */.K5.white,
    "data-id": "dashboard_MessagesWidget_MailIcon"
  })), MessagesWidget_jsx(MessageCount, {
    "data-id": "dashboard_MessagesWidget_MessageCount"
  }, countMessages(unreadCount)), MessagesWidget_jsx(WidgetScroller, {
    "data-id": "dashboard_MessagesWidget_WidgetScroller"
  }, messages.map(function (item, index) {
    return index < 2 && MessagesWidget_jsx(MessagesWidget_Message, {
      key: index,
      border: index === 1,
      onClick: item.onClick,
      "data-id": "dashboard_MessagesWidget_Message"
    }, MessagesWidget_jsx(MessagesWidget_Icon, {
      "data-id": "dashboard_MessagesWidget_Icon"
    }, item.type === 'defaultMessage' ? item.sender.icon : MessagesWidget_jsx(UserAvatar/* default */.Z, {
      size: "small",
      mode: "imageLoader",
      name: item.sender.name,
      imageUrl: item.sender.image,
      "data-id": "dashboard_MessagesWidget_UserAvatar"
    })), MessagesWidget_jsx(TextBlock, {
      "data-id": "dashboard_MessagesWidget_TextBlock"
    }, MessagesWidget_jsx(Author, {
      "data-id": "dashboard_MessagesWidget_Author"
    }, MessagesWidget_jsx("span", {
      "data-id": "dashboard_MessagesWidget_span"
    }, item.sender.name)), MessagesWidget_jsx(MessagesWidget_Title, {
      "data-id": "dashboard_MessagesWidget_Title"
    }, truncateText(item.subject, 30)), MessagesWidget_jsx(MessageContent, {
      "data-id": "dashboard_MessagesWidget_MessageContent"
    }, truncateText(item.content, 85))));
  })), unreadCount === 0 && MessagesWidget_jsx(MailIconContainer, {
    "data-id": "dashboard_MessagesWidget_MailIconContainer"
  }, MessagesWidget_jsx(icons_Message, {
    width: 200,
    height: 140,
    color: styleGuide/* colorPalette.lightGrey */.K5.lightGrey,
    "data-id": "dashboard_MessagesWidget_MailIcon"
  })), MessagesWidget_jsx(WidgetFooter, {
    "data-id": "dashboard_MessagesWidget_WidgetFooter"
  }, (phase === 'cj2' || phase === 'cj3') && link && MessagesWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Bekijk alle berichten",
    type: "internalLink",
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(link),
    "data-id": "dashboard_MessagesWidget_ButtonSecondary"
  })));
};

/* harmony default export */ var dashboard_MessagesWidget = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(MessagesWidget_mapStateToProps, MessagesWidget_mapDispatchToProps)(MessagesWidget)));
var ActionsAndMessageWidgetStyles = (0,styled_components_browser_esm.css)(MessagesWidget_templateObject || (MessagesWidget_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n  height: 346rem;\n  position: relative;\n  box-sizing: border-box;\n  padding: 20rem;\n  background-color: white;\n  opacity: 0;\n  animation-delay: 0.25s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ", ";\n  animation-duration: 0.5s;\n  animation-name: ", ";\n\n  @media all and (max-width: 969px) {\n    min-height: 346rem;\n    margin-right: 0;\n  }\n"])), styleGuide/* CUBIC_TIMING */.I5, styleGuide/* fadeInLeft */.O2);
var MessagesWidget_Container = styled_components_browser_esm["default"].div(MessagesWidget_templateObject2 || (MessagesWidget_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n"])), ActionsAndMessageWidgetStyles);
var MessagesWidget_Message = styled_components_browser_esm["default"].div(MessagesWidget_templateObject3 || (MessagesWidget_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  padding-top: ", "rem;\n  padding-bottom: 14rem;\n  margin-top: ", "rem;\n  margin-bottom: ", "rem;\n  border-top: ", ";\n  border-bottom: 1rem dashed #979797;\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (props) {
  return props.border ? 0 : 12;
}, function (props) {
  return props.border ? 14 : 16;
}, function (props) {
  return props.border ? 49 : 0;
}, function (props) {
  return props.border ? 'none' : '1rem dashed #979797';
});
var MessageContent = styled_components_browser_esm["default"].div(MessagesWidget_templateObject4 || (MessagesWidget_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var MessagesWidget_Title = styled_components_browser_esm["default"].div(MessagesWidget_templateObject5 || (MessagesWidget_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  font-weight: bold;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var Author = styled_components_browser_esm["default"].div(MessagesWidget_templateObject6 || (MessagesWidget_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  ", ";\n  font-size: 12rem;\n  color: ", ";\n  justify-content: space-between;\n  width: 100%;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.beige */.K5.beige);
var TextBlock = styled_components_browser_esm["default"].div(MessagesWidget_templateObject7 || (MessagesWidget_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 82%;\n  ", ";\n"])), breakpoints/* fromBreakpoint.xl */.ks.xl(MessagesWidget_templateObject8 || (MessagesWidget_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 85%\n  "]))));
var MessagesWidget_Icon = styled_components_browser_esm["default"].div(MessagesWidget_templateObject9 || (MessagesWidget_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin-right: 12rem;\n  background-color: ", ";\n  border-radius: 50%;\n  width: 36rem;\n  height: 36rem;\n  justify-content: center;\n  align-items: center;\n"])), styleGuide/* colorPalette.orange */.K5.orange);
var MessageCount = styled_components_browser_esm["default"].div(MessagesWidget_templateObject0 || (MessagesWidget_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  font-weight: bold;\n"])), styleGuide/* textStyles.standardText */.sq.standardText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var MailIconContainer = styled_components_browser_esm["default"].div(MessagesWidget_templateObject1 || (MessagesWidget_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n  padding: 10rem;\n  height: 100%;\n"])));
var MessagesWidget_Label = styled_components_browser_esm["default"].div(MessagesWidget_templateObject10 || (MessagesWidget_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: -40rem;\n  margin-left: -20rem;\n\n  > div {\n    > span {\n      padding-left: 50rem;\n      padding-right: 41rem;\n    }\n  }\n\n  > svg {\n    position: absolute;\n    top: 0;\n    margin-top: 14rem;\n    margin-left: 20rem;\n  }\n"])));
;// CONCATENATED MODULE: ./src/components/dashboard/ActionsWidget.js



var ActionsWidget_templateObject, ActionsWidget_templateObject2, ActionsWidget_templateObject3, ActionsWidget_templateObject4, ActionsWidget_templateObject5, ActionsWidget_templateObject6, ActionsWidget_templateObject7;

var ActionsWidget_jsx = react.createElement;

function ActionsWidget_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function ActionsWidget_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ActionsWidget_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ActionsWidget_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



















var ActionsWidget_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase', undefined)
  };
};

var ActionsWidget_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openModal: function openModal() {
      if (ownProps.dummyContent) {
        dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
          type: 'profile',
          componentProps: {
            type: 'actions',
            content: ownProps.dummyContent.modal
          }
        }));
      }
    }
  };
};

var ActionsWidget_redirect = function redirect(link, router) {
  if (!link) return;
  router === null || router === void 0 || router.push('/' + (0,getLinkFromPageObject/* default */.Z)(link));
};

var calculateDeadline = function calculateDeadline(deadline) {
  if (!deadline) return {
    days: -2,
    label: ''
  };
  var deadlineTransformed = new Date(deadline);
  var today = new Date();
  var diff = deadlineTransformed.setHours(0, 0, 0, 0) - today.setHours(0, 0, 0, 0);

  if (diff > 0) {
    var days = Math.ceil(Math.abs((today.getTime() - deadlineTransformed.getTime()) / (24 * 60 * 60 * 1000)));
    return days === 1 ? {
      days: days,
      label: "Actie over ".concat(days, " dag")
    } : {
      days: days,
      label: "Actie over ".concat(days, " dagen")
    };
  } else if (diff === 0) {
    return {
      days: 0,
      label: 'Actie vandaag'
    };
  }

  return {
    days: -1,
    label: 'Actie verlopen'
  };
};

var getActionsString = function getActionsString(items) {
  if (!items) return '';

  if (items.length === 0) {
    return 'Geen openstaande acties';
  } else if (items.length === 1) {
    return '1 openstaande actie';
  } else {
    return "".concat(items.length, " openstaande acties");
  }
};

var ActionsWidget = function ActionsWidget(_ref) {
  var dummyContent = _ref.dummyContent,
      openModal = _ref.openModal,
      link = _ref.link,
      phase = _ref.phase,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      router = _ref.router;
  var actionItems = phase === 'cj1' && dummyContent ? [{
    id: 0,
    title: dummyContent && dummyContent.label,
    deadline: '',
    type: '',
    onClick: openModal
  }] : items.map(function (item) {
    return ActionsWidget_objectSpread(ActionsWidget_objectSpread({}, item), {}, {
      onClick: link ? function () {
        return ActionsWidget_redirect(link, router);
      } : undefined
    });
  });
  return ActionsWidget_jsx(ActionsWidget_Container, {
    "data-id": "dashboard_ActionsWidget_Container"
  }, ActionsWidget_jsx(ActionsWidget_Label, {
    "data-id": "dashboard_ActionsWidget_Label"
  }, ActionsWidget_jsx(designElements_ThemeLabel, {
    label: "ACTIES",
    theme: "projectUpdate",
    "data-id": "dashboard_ActionsWidget_ThemeLabel"
  }), ActionsWidget_jsx(icons_Actions, {
    width: 20,
    height: 20,
    color: styleGuide/* colorPalette.white */.K5.white,
    "data-id": "dashboard_ActionsWidget_ActionsIcon"
  })), ActionsWidget_jsx(ActionCount, {
    "data-id": "dashboard_ActionsWidget_ActionCount"
  }, getActionsString(items)), actionItems && actionItems.length > 0 && ActionsWidget_jsx(WidgetScroller, {
    "data-id": "dashboard_ActionsWidget_WidgetScroller"
  }, actionItems.map(function (item, index) {
    var deadline = calculateDeadline(item.deadline);
    return ActionsWidget_jsx(Action, {
      key: index,
      border: index > 0,
      cj2: phase !== 'cj1',
      onClick: item.onClick,
      "data-id": "dashboard_ActionsWidget_Action"
    }, (phase === 'cj2' || phase === 'cj3') && ActionsWidget_jsx(ActionsWidget_Deadline, {
      days: deadline.days,
      "data-id": "dashboard_ActionsWidget_Deadline"
    }, ActionsWidget_jsx("div", {
      "data-id": "dashboard_ActionsWidget_div"
    }, "Deadline: ", getDate(item.deadline)), ActionsWidget_jsx("span", {
      "data-id": "dashboard_ActionsWidget_span"
    }, deadline.label)), ActionsWidget_jsx(ActionContent, {
      "data-id": "dashboard_ActionsWidget_ActionContent"
    }, truncateText(item.title, 100)));
  })), actionItems && actionItems.length === 0 && ActionsWidget_jsx(ActionContainer, {
    "data-id": "dashboard_ActionsWidget_ActionContainer"
  }, ActionsWidget_jsx(icons_Actions, {
    width: 144,
    height: 149,
    color: styleGuide/* colorPalette.lightGrey */.K5.lightGrey,
    "data-id": "dashboard_ActionsWidget_ActionsIcon"
  })), ActionsWidget_jsx(WidgetFooter, {
    "data-id": "dashboard_ActionsWidget_WidgetFooter"
  }, (phase === 'cj2' || phase === 'cj3') && link && ActionsWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Toon alle acties",
    type: "internalLink",
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(link),
    "data-id": "dashboard_ActionsWidget_ButtonSecondary"
  })));
};

/* harmony default export */ var dashboard_ActionsWidget = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(ActionsWidget_mapStateToProps, ActionsWidget_mapDispatchToProps)(ActionsWidget)));
var ActionsWidget_Container = styled_components_browser_esm["default"].div(ActionsWidget_templateObject || (ActionsWidget_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  animation-name: ", ";\n"])), ActionsAndMessageWidgetStyles, styleGuide/* fadeInRight */.ER);
var ActionsWidget_Deadline = styled_components_browser_esm["default"].div(ActionsWidget_templateObject2 || (ActionsWidget_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " display: flex;\n  font-size: 12rem;\n  color: ", ";\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 2rem;\n\n  > span {\n    color: ", ";\n  }\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, function (props) {
  return props.days === -1 ? styleGuide/* colorPalette.headerGrey */.K5.headerGrey : props.days > 3 ? styleGuide/* colorPalette.green */.K5.green : styleGuide/* colorPalette.red */.K5.red;
});
var ActionContainer = styled_components_browser_esm["default"].div(ActionsWidget_templateObject3 || (ActionsWidget_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 68%;\n"])));
var ActionContent = styled_components_browser_esm["default"].div(ActionsWidget_templateObject4 || (ActionsWidget_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  font-weight: bold;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var Action = styled_components_browser_esm["default"].div(ActionsWidget_templateObject5 || (ActionsWidget_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  margin-right: ", "rem;\n  padding-top: 10rem;\n  padding-bottom: 14rem;\n  border-top: ", ";\n  border-bottom: 1px dashed #979797;\n  cursor: pointer;\n"])), function (props) {
  return props.cj2 ? 12 : 0;
}, function (props) {
  return props.border ? 'none' : '1px dashed #979797';
});
var ActionCount = styled_components_browser_esm["default"].div(ActionsWidget_templateObject6 || (ActionsWidget_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  font-weight: bold;\n  margin-bottom: 14rem;\n"])), styleGuide/* textStyles.standardText */.sq.standardText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var ActionsWidget_Label = styled_components_browser_esm["default"].div(ActionsWidget_templateObject7 || (ActionsWidget_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: -40rem;\n  margin-left: -20rem;\n\n  > div {\n    > span {\n      padding-left: 51rem;\n      padding-right: 140rem;\n    }\n  }\n\n  > svg {\n    position: absolute;\n    top: 0;\n    margin-top: 9rem;\n    margin-left: 20rem;\n  }\n"])));
;// CONCATENATED MODULE: ./src/components/dashboard/ProfileBlock.js


var ProfileBlock_templateObject, ProfileBlock_templateObject2, ProfileBlock_templateObject3, ProfileBlock_templateObject4;

var ProfileBlock_jsx = react.createElement;







var ProfileBlock = function ProfileBlock(_ref) {
  var messages = _ref.messages,
      actions = _ref.actions;
  return ProfileBlock_jsx(ProfileBlock_Container, {
    "data-e2e-block-profileblock": true,
    "data-id": "dashboard_ProfileBlock_Container"
  }, ProfileBlock_jsx(dashboard_MessagesWidget, {
    dummyContent: messages.dummyContent,
    items: messages.items,
    link: messages.link,
    unreadCount: messages.unreadCount,
    "data-id": "dashboard_ProfileBlock_MessagesWidget"
  }), ProfileBlock_jsx(dashboard_ProfileWidget, {
    isSmall: false,
    "data-id": "dashboard_ProfileBlock_ProfileWidget"
  }), ProfileBlock_jsx(dashboard_ActionsWidget, {
    dummyContent: actions.dummyContent,
    items: actions.items,
    link: actions.link,
    "data-id": "dashboard_ProfileBlock_ActionsWidget"
  }));
};

/* harmony default export */ var dashboard_ProfileBlock = (ProfileBlock);
var ProfileBlock_Container = styled_components_browser_esm["default"].div(ProfileBlock_templateObject || (ProfileBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  flex-flow: row wrap;\n  z-index: 10;\n  align-items: flex-end;\n  margin-top: -20px;\n\n  ", ";\n\n  > *:nth-child(1),\n  > *:nth-child(3) {\n    margin-top: 60rem;\n\n    ", ";\n\n    ", ";\n  }\n\n  @media only all and (max-width: 969px) {\n    > *:nth-child(1) {\n      order: 2;\n    }\n    > *:nth-child(2) {\n      order: 1;\n    }\n    > *:nth-child(3) {\n      order: 3;\n    }\n  }\n\n  @media only all and (min-width: 970px) {\n    flex-direction: row;\n    flex-wrap: nowrap;\n\n    > *:nth-child(1),\n    > *:nth-child(2),\n    > *:nth-child(3) {\n      width: calc((100% / 3) - (40rem / 3));\n    }\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProfileBlock_templateObject2 || (ProfileBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    justify-content: space-between;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(ProfileBlock_templateObject3 || (ProfileBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc(50% - 10rem);\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(ProfileBlock_templateObject4 || (ProfileBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-top: 0;\n    "]))));
;// CONCATENATED MODULE: ./src/components/shared/icons/PlanningEvent.js
var PlanningEvent_jsx = react.createElement;


var PlanningEvent_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var PlanningEvent = function PlanningEvent(_ref) {
  var color = _ref.color;
  return PlanningEvent_jsx("svg", {
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    version: "1.1",
    "data-id": "icons_PlanningEvent_svg"
  }, PlanningEvent_jsx("title", {
    "data-id": "icons_PlanningEvent_title"
  }, "Planning Event"), PlanningEvent_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_PlanningEvent_g"
  }, PlanningEvent_jsx("g", {
    transform: "translate(-543.000000, -363.000000)",
    fill: color,
    "data-id": "icons_PlanningEvent_g_3"
  }, PlanningEvent_jsx("g", {
    transform: "translate(534.000000, 354.000000)",
    "data-id": "icons_PlanningEvent_g_4"
  }, PlanningEvent_jsx("g", {
    transform: "translate(9.000000, 9.000000)",
    "data-id": "icons_PlanningEvent_g_5"
  }, PlanningEvent_jsx("path", {
    d: "M6.5946825,11.249945 L6.3267575,12.84192 C6.2905325,13.060145 6.3792575,13.278895 6.5577575,13.409445 C6.7360825,13.538595 6.9733825,13.55627 7.1681575,13.453895 L8.6003575,12.70647 L10.0318575,13.453895 C10.1165575,13.49817 10.2094825,13.520045 10.3011825,13.520045 C10.4214075,13.520045 10.5411075,13.482595 10.6422575,13.409445 C10.8205825,13.27942 10.9101825,13.060145 10.8732575,12.84192 L10.6060325,11.249945 L11.7585825,10.11927 C11.9164325,9.96457 11.9724325,9.734445 11.9048825,9.524445 C11.8371575,9.314445 11.6553325,9.16132 11.4372825,9.12947 L9.8397075,8.891995 L9.1199325,7.44632 C9.0228075,7.248745 8.8205075,7.12362 8.5996575,7.12362 C8.3795075,7.12362 8.1779075,7.248745 8.0793825,7.44632 L7.3603075,8.891995 L5.7634325,9.12947 C5.5446825,9.16132 5.3635575,9.314445 5.2958325,9.524445 C5.2274075,9.734445 5.2835825,9.96457 5.4414325,10.11927 L6.5946825,11.249945 Z",
    "data-id": "icons_PlanningEvent_path"
  }), PlanningEvent_jsx("path", {
    d: "M1.961925,15.512 L15.23865,15.512 L15.23865,6.057275 L1.961925,6.057275 L1.961925,15.512 Z M15.465625,1.857275 L13.63635,1.857275 L13.63635,0.8428 C13.63635,0.3773 13.25905,0 12.79285,0 L12.6595,0 C12.194,0 11.8167,0.3773 11.8167,0.8428 L11.8167,1.857275 L5.362875,1.857275 L5.362875,0.8428 C5.362875,0.3773 4.985575,0 4.5199,0 L4.386025,0 C3.920525,0 3.54305,0.3773 3.54305,0.8428 L3.54305,1.857275 L1.73495,1.857275 C0.778575,1.857275 0,2.63585 0,3.592925 L0,15.738975 C0,16.69535 0.778575,17.473925 1.73495,17.473925 L15.465625,17.473925 C16.422,17.473925 17.200575,16.69535 17.200575,15.738975 L17.200575,3.592925 C17.200575,2.63585 16.422,1.857275 15.465625,1.857275 L15.465625,1.857275 Z",
    "data-id": "icons_PlanningEvent_path_7"
  }))))));
};

PlanningEvent.defaultProps = PlanningEvent_defaultProps;
/* harmony default export */ var icons_PlanningEvent = (PlanningEvent);
;// CONCATENATED MODULE: ./src/components/shared/icons/PlanningUpdate.js
var PlanningUpdate_jsx = react.createElement;


var PlanningUpdate_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var PlanningUpdate = function PlanningUpdate(_ref) {
  var color = _ref.color;
  return PlanningUpdate_jsx("svg", {
    width: "15px",
    height: "19px",
    viewBox: "0 0 15 19",
    version: "1.1",
    "data-id": "icons_PlanningUpdate_svg"
  }, PlanningUpdate_jsx("title", {
    "data-id": "icons_PlanningUpdate_title"
  }, "Planning Update"), PlanningUpdate_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_PlanningUpdate_g"
  }, PlanningUpdate_jsx("g", {
    transform: "translate(-278.000000, -289.000000)",
    fill: color,
    "data-id": "icons_PlanningUpdate_g_3"
  }, PlanningUpdate_jsx("g", {
    transform: "translate(244.000000, 289.000000)",
    "data-id": "icons_PlanningUpdate_g_4"
  }, PlanningUpdate_jsx("g", {
    transform: "translate(34.000000, 0.000000)",
    "data-id": "icons_PlanningUpdate_g_5"
  }, PlanningUpdate_jsx("polygon", {
    points: "3.70408034 8.63308668 10.4937844 8.63308668 10.4937844 7.21281184 3.70408034 7.21281184",
    "data-id": "icons_PlanningUpdate_polygon"
  }), PlanningUpdate_jsx("polygon", {
    points: "3.73737844 11.5087104 10.5270825 11.5087104 10.5270825 10.0884355 3.73737844 10.0884355",
    "data-id": "icons_PlanningUpdate_polygon_7"
  }), PlanningUpdate_jsx("polygon", {
    points: "3.77023256 14.3838901 6.52420719 14.3838901 6.52420719 12.9636152 3.77023256 12.9636152",
    "data-id": "icons_PlanningUpdate_polygon_8"
  }), PlanningUpdate_jsx("path", {
    d: "M1.77589852,16.8847992 L12.4312896,16.8847992 L12.4312896,5.3987315 L1.77589852,5.3987315 L1.77589852,16.8847992 Z M8.8794926,1.62139535 L8.8794926,0.711247357 C8.8794926,0.319217759 8.56027484,0 8.16824524,0 L6.03672304,0 C5.64469345,0 5.32769556,0.319217759 5.32769556,0.711247357 L5.32769556,1.62139535 L0,1.62139535 L0,4.0512685 L0,17.2404228 C0,18.024482 0.636215645,18.6606977 1.42027484,18.6606977 L12.7864693,18.6606977 C13.5705285,18.6606977 14.2071882,18.024482 14.2071882,17.2404228 L14.2071882,1.62139535 L8.8794926,1.62139535 Z",
    "data-id": "icons_PlanningUpdate_path"
  }))))));
};

PlanningUpdate.defaultProps = PlanningUpdate_defaultProps;
/* harmony default export */ var icons_PlanningUpdate = (PlanningUpdate);
;// CONCATENATED MODULE: ./src/components/shared/icons/PlanningStep.js
var PlanningStep_jsx = react.createElement;


var PlanningStep_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var PlanningStep = function PlanningStep(_ref) {
  var color = _ref.color;
  return PlanningStep_jsx("svg", {
    width: "15px",
    height: "20px",
    viewBox: "0 0 15 20",
    version: "1.1",
    "data-id": "icons_PlanningStep_svg"
  }, PlanningStep_jsx("title", {
    "data-id": "icons_PlanningStep_title"
  }, "Planning Step"), PlanningStep_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_PlanningStep_g"
  }, PlanningStep_jsx("g", {
    transform: "translate(-441.000000, -362.000000)",
    fill: color,
    "data-id": "icons_PlanningStep_g_3"
  }, PlanningStep_jsx("g", {
    transform: "translate(389.000000, 354.000000)",
    "data-id": "icons_PlanningStep_g_4"
  }, PlanningStep_jsx("path", {
    d: "M54.2255865,19.3744444 C54.7519272,26.0184317 61.0345507,23.3799764 57.6255185,18.3481827 C56.5475916,18.7186467 55.5947182,18.9531957 54.2255865,19.3744444 M57.7849179,16.7486119 C58.0796452,15.5984708 58.2252475,13.6801013 57.9751403,12.3130246 C57.520133,9.82721691 56.54994,8.38557764 55.2380512,8.04270762 C52.4390224,7.6334946 52.0882264,10.2502269 52.0171866,12.2455073 C51.8598421,13.3613027 52.8047895,17.6691944 53.9537564,18.4811623 C55.0845229,18.1955351 56.1944472,17.915779 57.3169942,17.6624427 C57.6073182,17.5089144 57.5154361,17.559112 57.7849179,16.7486119 M66.4218372,16.9009659 C66.3519715,14.9068597 65.9997078,12.2901274 63.200679,12.699634 C61.8887902,13.042504 60.920065,14.4826755 60.4635899,16.9687767 C60.2134827,18.3355599 60.3593785,20.2551037 60.6538123,21.4052447 C60.9244683,22.2148641 60.8328797,22.1655472 61.1217359,22.3190755 C62.244283,22.5727054 63.3545008,22.8524615 64.486148,23.1363273 C65.6351148,22.3261208 66.5788881,18.0179355 66.4218372,16.9009659 M60.8132116,23.0048155 C61.8911386,23.3741053 62.844012,23.6104156 64.2131436,24.029903 C63.6865094,30.6738902 57.4041795,28.035435 60.8132116,23.0048155",
    "data-id": "icons_PlanningStep_path"
  })))));
};

PlanningStep.defaultProps = PlanningStep_defaultProps;
/* harmony default export */ var icons_PlanningStep = (PlanningStep);
;// CONCATENATED MODULE: ./src/components/shared/icons/PlanningAction.js
var PlanningAction_jsx = react.createElement;


var PlanningAction_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var PlanningAction = function PlanningAction(_ref) {
  var color = _ref.color;
  return PlanningAction_jsx("svg", {
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    version: "1.1",
    "data-id": "icons_PlanningAction_svg"
  }, PlanningAction_jsx("title", {
    "data-id": "icons_PlanningAction_title"
  }, "Planning Action"), PlanningAction_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_PlanningAction_g"
  }, PlanningAction_jsx("g", {
    transform: "translate(-681.000000, -328.000000)",
    fill: color,
    "data-id": "icons_PlanningAction_g_3"
  }, PlanningAction_jsx("g", {
    transform: "translate(681.000000, 328.000000)",
    "data-id": "icons_PlanningAction_g_4"
  }, PlanningAction_jsx("path", {
    d: "M13.8018703,13.3205333 C13.8018703,13.4181324 13.7713929,13.4970965 13.7104828,13.5579619 C13.6496175,13.6189167 13.5704746,13.6493493 13.4731437,13.6493493 L11.0625265,13.6493493 C10.9651508,13.6493493 10.8860527,13.6189167 10.8251426,13.5579619 C10.7642326,13.4970965 10.7338446,13.4181324 10.7338446,13.3205333 L10.7338446,9.72299682 L7.95799051,9.72299682 L7.95799051,13.3206674 C7.95799051,13.4181324 7.92760251,13.4970965 7.86673715,13.5579619 C7.8057824,13.6189167 7.72668424,13.6493493 7.62935327,13.6493493 L5.21869143,13.6493493 C5.13342628,13.6493493 5.06045041,13.6189167 4.99958504,13.5579619 C4.93867498,13.4970965 4.90815292,13.4181324 4.90815292,13.3206674 L4.90815292,7.45846548 C4.90815292,7.34893463 4.94479727,7.26366949 5.01777315,7.20293819 L9.07188932,3.95213763 C9.21806451,3.85485135 9.35199514,3.85485135 9.47377056,3.95213763 L13.6739279,7.20293819 C13.7591483,7.26366949 13.8018703,7.34893463 13.8018703,7.45846548 L13.8018703,13.3205333 Z M15.6873114,0 L3.02101368,0 C2.34876865,0 1.80535978,0.543408869 1.80535978,1.21551984 L1.80535978,3.40694123 L0.872314237,3.40694123 C0.389636672,3.40694123 0,3.79675666 0,4.27947891 L0,4.70120173 C0,5.18383461 0.389636672,5.57351597 0.872314237,5.57351597 L1.80535978,5.57351597 L1.80535978,7.6649251 L0.872314237,7.6649251 C0.389636672,7.6649251 0,8.05451709 0,8.53719465 L0,8.95909623 C0,9.44181848 0.389636672,9.83145515 0.872314237,9.83145515 L1.80535978,9.83145515 L1.80535978,11.922909 L0.872314237,11.922909 C0.389636672,11.922909 0,12.312501 0,12.7951338 L0,13.2206105 C0,13.7032433 0.389636672,14.0928353 0.872314237,14.0928353 L1.80535978,14.0928353 L1.80535978,16.2843014 C1.80535978,16.9565464 2.34876865,17.5 3.02101368,17.5 L15.6873114,17.5 C16.3595564,17.5 16.9030099,16.9565464 16.9030099,16.2843014 L16.9030099,1.21918427 C16.9064956,0.546894551 16.3595564,0 15.6873114,0 L15.6873114,0 Z",
    "data-id": "icons_PlanningAction_path"
  })))));
};

PlanningAction.defaultProps = PlanningAction_defaultProps;
/* harmony default export */ var icons_PlanningAction = (PlanningAction);
;// CONCATENATED MODULE: ./src/components/shared/designElements/PlanningIconsMap.js
var PlanningIconsMap_jsx = react.createElement;





var PlanningIconsMap_ICONMAPPING = {
  event: icons_PlanningEvent,
  update: icons_PlanningUpdate,
  step: icons_PlanningStep,
  action: icons_PlanningAction
};

var PlanningIconsMap = function PlanningIconsMap(_ref) {
  var icon = _ref.icon,
      color = _ref.color;
  var Icon = PlanningIconsMap_ICONMAPPING[icon] || PlanningIconsMap_ICONMAPPING['action'];
  return PlanningIconsMap_jsx(Icon, {
    color: color,
    "data-id": "designElements_PlanningIconsMap_Icon"
  });
};

/* harmony default export */ var designElements_PlanningIconsMap = (PlanningIconsMap);
;// CONCATENATED MODULE: ./src/components/shared/designElements/DottedVerticalLine.js
var DottedVerticalLine_jsx = react.createElement;


var DottedVerticalLine = function DottedVerticalLine(_ref) {
  var height = _ref.height;
  return DottedVerticalLine_jsx("svg", {
    width: "5",
    height: "".concat(height),
    viewBox: "0 0 3 ".concat(height),
    version: "1.1",
    "data-id": "designElements_DottedVerticalLine_svg"
  }, DottedVerticalLine_jsx("line", {
    strokeDasharray: "5, 4",
    y1: "0",
    x1: "0",
    y2: "".concat(height),
    x2: "0",
    style: {
      stroke: 'white',
      strokeWidth: 2
    },
    "data-id": "designElements_DottedVerticalLine_line"
  }));
};

/* harmony default export */ var designElements_DottedVerticalLine = (DottedVerticalLine);
;// CONCATENATED MODULE: ./src/components/dashboard/PlanningCard.js








var PlanningCard_templateObject, PlanningCard_templateObject2, PlanningCard_templateObject3, PlanningCard_templateObject4, PlanningCard_templateObject5, PlanningCard_templateObject6, PlanningCard_templateObject7, PlanningCard_templateObject8, PlanningCard_templateObject9, PlanningCard_templateObject0, PlanningCard_templateObject1, PlanningCard_templateObject10, PlanningCard_templateObject11, PlanningCard_templateObject12, PlanningCard_templateObject13, PlanningCard_templateObject14, PlanningCard_templateObject15, PlanningCard_templateObject16, PlanningCard_templateObject17, PlanningCard_templateObject18;

var PlanningCard_jsx = react.createElement;

function PlanningCard_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, PlanningCard_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function PlanningCard_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (PlanningCard_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}



















var PlanningCard_getColor = function getColor(color, variant) {
  return styleGuide/* colorPalette */.K5["".concat(variant).concat(color)];
};

var PlanningCard_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    handleClick: function handleClick(evt, actionType) {
      evt.preventDefault();
      evt.stopPropagation();
      var _ownProps$match$param = ownProps.match.params,
          projectSlug = _ownProps$match$param.projectSlug,
          env = _ownProps$match$param.env;
      var themeColor = '';
      var endpointConfig = {};

      switch (ownProps.type) {
        case 'update':
        case 'event':
          themeColor = hasEventPassed(ownProps.eventDate) ? PlanningCard_getColor('Grey', 'dark') : styleGuide/* colorPalette.lightOrange */.K5.lightOrange;
          endpointConfig = {
            type: 'article',
            componentProps: {
              projectSlug: projectSlug,
              env: env,
              articleSlug: ownProps.slug,
              planningObj: true
            },
            planningObj: true,
            projectSlug: projectSlug,
            env: env,
            articleSlug: ownProps.slug
          };
          break;

        case 'step':
          themeColor = styleGuide/* colorPalette.lightOrange */.K5.lightOrange;
          endpointConfig = {
            type: 'planningStep',
            componentProps: {
              id: ownProps.id,
              uniqueId: ownProps.uniqueId,
              type: ownProps.type,
              date: ownProps.date,
              showDate: ownProps.showDate,
              stepNumber: ownProps.stepNumber,
              text: ownProps.text,
              title: ownProps.title,
              subTitle: ownProps.subTitle
            }
          };
          break;

        case 'deadline':
          // Ignore clicks on deadline block BAMECW-2410
          return;

        case 'action':
        default:
          themeColor = styleGuide/* colorPalette.lightOrange */.K5.lightOrange;
          endpointConfig = {
            type: 'planningAction',
            componentProps: {
              id: ownProps.id,
              mode: actionType,
              blockId: ownProps.blockId,
              uniqueId: ownProps.uniqueId
            }
          };
          break;
      }

      dispatch((0,redux_modal/* openModal */.h7)(themeColor, endpointConfig));
    }
  };
};

var PlanningCard = /*#__PURE__*/function (_Component) {
  function PlanningCard() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, PlanningCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = PlanningCard_callSuper(this, PlanningCard, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      renderWidth: 0
    });

    (0,defineProperty/* default */.Z)(_this, "renderCard", function (props) {
      var renderWidth = _this.state.renderWidth;
      var isCardLarge = renderWidth > 240;

      switch (props.type) {
        case 'update':
          return PlanningCard_jsx(UpdateContainter, {
            "data-id": "dashboard_PlanningCard_UpdateContainter"
          }, PlanningCard_jsx(PlanningCard_ImageContainer, {
            "data-id": "dashboard_PlanningCard_ImageContainer"
          }, props.image && PlanningCard_jsx(ImageLoader/* default */.Z, {
            src: props.image,
            width: renderWidth + 100,
            mode: "bg",
            "data-id": "dashboard_PlanningCard_ImageLoader"
          })), PlanningCard_jsx(PlanningCard_TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, PlanningCard_jsx(PlanningCard_PublishedDate, {
            color: "#FFFFFF",
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_PublishedDate"
          }, getDate(props.publishedDate, false)), PlanningCard_jsx(PlanningCard_Title, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_Title"
          }, truncateText(props.title, 65)), props.leader && PlanningCard_jsx(PlanningCard_Text, {
            "data-id": "dashboard_PlanningCard_Text"
          }, truncateText(props.leader, 50)), PlanningCard_jsx(ReadMoreBtn, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_ReadMoreBtn"
          }, PlanningCard_jsx(ButtonSecondary/* default */.Z, {
            label: "Lees meer",
            type: "button",
            link: "#",
            color: "#FFFFFF",
            size: isCardLarge ? 'normal' : 'small',
            caretColor: styleGuide/* colorPalette.textGrey */.K5.textGrey,
            "data-id": "dashboard_PlanningCard_ButtonSecondary"
          }))));

        case 'deadline':
          return PlanningCard_jsx(PlanningCard_TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, PlanningCard_jsx(IconHeader, {
            isCardLarge: isCardLarge,
            hasTime: props.hasTime,
            "data-id": "dashboard_PlanningCard_IconHeader"
          }, PlanningCard_jsx(PlanningCard_DateIconWrapper, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_DateIconWrapper"
          }, PlanningCard_jsx(designElements_DateIcon, {
            textColor: "#FFFFFF",
            bgColor: styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
            size: isCardLarge ? 'small' : 'mini',
            date: props.eventDate,
            "data-id": "dashboard_PlanningCard_DateIcon"
          })), PlanningCard_jsx(TitleBig, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TitleBig"
          }, truncateText(props.title, 65))), PlanningCard_jsx(PlanningCard_Text, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_Text"
          }, truncateText(props.text, 150)), PlanningCard_jsx(CreatedBy, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_CreatedBy"
          }, "Aangemaakt door:", PlanningCard_jsx(PlanningCard_Author, {
            "data-id": "dashboard_PlanningCard_Author"
          }, props.author)));

        case 'event':
          var eventPassed = hasEventPassed(props.eventDate);
          return PlanningCard_jsx(PlanningCard_TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, PlanningCard_jsx(IconHeader, {
            isCardLarge: isCardLarge,
            hasTime: props.hasTime,
            "data-id": "dashboard_PlanningCard_IconHeader"
          }, PlanningCard_jsx(PlanningCard_DateIconWrapper, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_DateIconWrapper"
          }, PlanningCard_jsx(designElements_DateIcon, {
            textColor: "#FFFFFF",
            bgColor: eventPassed ? styleGuide/* colorPalette.lightBeige */.K5.lightBeige : styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
            size: isCardLarge ? 'small' : 'mini',
            date: props.eventDate,
            "data-id": "dashboard_PlanningCard_DateIcon"
          })), PlanningCard_jsx(TitleBig, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TitleBig"
          }, truncateText(props.title, 65))), PlanningCard_jsx(PlanningCard_Text, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_Text"
          }, truncateText(props.text, 50)), eventPassed && PlanningCard_jsx(PlanningCard_PassedEventNotification, {
            "data-id": "dashboard_PlanningCard_PassedEventNotification"
          }, "Dit event ", PlanningCard_jsx("br", {
            "data-id": "dashboard_PlanningCard_br"
          }), "is verlopen"), PlanningCard_jsx(ReadMoreBtn, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_ReadMoreBtn"
          }, PlanningCard_jsx(ButtonSecondary/* default */.Z, {
            label: "Lees meer",
            type: "button",
            link: "#",
            size: isCardLarge ? 'normal' : 'small',
            "data-id": "dashboard_PlanningCard_ButtonSecondary"
          })));

        case 'step':
          return PlanningCard_jsx(PlanningCard_TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, PlanningCard_jsx(IconHeader, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_IconHeader"
          }, PlanningCard_jsx(PlanningCard_StepIcon, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_StepIcon"
          }, PlanningCard_jsx("span", {
            "data-id": "dashboard_PlanningCard_span"
          }, "stap"), props.stepNumber), props.showDate && PlanningCard_jsx(PlanningCard_PublishedDate, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_PublishedDate"
          }, getDate(props.date, false)), props.subTitle && PlanningCard_jsx(PlanningCard_SubTitle, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_SubTitle"
          }, props.subTitle)), PlanningCard_jsx(TitleBig, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TitleBig"
          }, truncateText(props.title, 50)), PlanningCard_jsx(PlanningCard_Text, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_Text"
          }, truncateText(props.text, 50)), PlanningCard_jsx(ReadMoreBtn, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_ReadMoreBtn"
          }, PlanningCard_jsx(ButtonSecondary/* default */.Z, {
            label: "Lees meer",
            type: "button",
            link: "#",
            size: isCardLarge ? 'normal' : 'small',
            "data-id": "dashboard_PlanningCard_ButtonSecondary"
          })));

        case 'action':
        default:
          return PlanningCard_jsx(PlanningCard_TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, PlanningCard_jsx(PlanningCard_PublishedDate, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_PublishedDate"
          }, getDate(props.deadline, false)), PlanningCard_jsx(DaysCounterWrapper, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_DaysCounterWrapper"
          }, PlanningCard_jsx(designElements_DaysCounter, {
            deadline: props.deadline,
            fontSize: "12",
            "data-id": "dashboard_PlanningCard_DaysCounter"
          })), PlanningCard_jsx(TitleBig, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TitleBig"
          }, truncateText(props.title, 50)), PlanningCard_jsx(PlanningCard_Action, {
            isCardLarge: isCardLarge,
            "data-e2e-action-completed": props.accomplished,
            "data-id": "dashboard_PlanningCard_Action"
          }, props.accomplished ? 'Voltooid' : 'Openstaand', props.accomplished && PlanningCard_jsx(CheckContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_CheckContainer"
          }, PlanningCard_jsx(Check/* default */.Z, {
            color: styleGuide/* colorPalette.blue */.K5.blue,
            "data-id": "dashboard_PlanningCard_Check"
          }))), PlanningCard_jsx(CreatedBy, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_CreatedBy"
          }, "Aangemaakt door:", PlanningCard_jsx(PlanningCard_Author, {
            "data-id": "dashboard_PlanningCard_Author"
          }, props.authorImage && PlanningCard_jsx(UserAvatar/* default */.Z, {
            mode: "imageLoader",
            imageUrl: props.authorImage,
            size: "xsmall",
            name: props.author,
            "data-id": "dashboard_PlanningCard_UserAvatar"
          }), props.author)), props.editable && PlanningCard_jsx(DeleteIconContainer, {
            onClick: function onClick(evt) {
              return props.handleClick(evt, 'delete');
            },
            "data-e2e-planningcard-button-delete": true,
            "data-id": "dashboard_PlanningCard_DeleteIconContainer"
          }, PlanningCard_jsx(icons_Delete, {
            color: styleGuide/* colorPalette.blue */.K5.blue,
            "data-id": "dashboard_PlanningCard_DeleteIcon"
          })), PlanningCard_jsx(ReadMoreBtn, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_ReadMoreBtn"
          }, PlanningCard_jsx(ButtonSecondary/* default */.Z, {
            label: "Lees meer",
            type: "button",
            link: "#",
            size: isCardLarge ? 'normal' : 'small',
            "data-id": "dashboard_PlanningCard_ButtonSecondary"
          })));
      }
    });

    return _this;
  }

  (0,inherits/* default */.Z)(PlanningCard, _Component);

  return (0,createClass/* default */.Z)(PlanningCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      return PlanningCard_jsx(PlanningCard_Card, {
        onClick: function onClick(evt) {
          return props.handleClick(evt, 'read');
        },
        "data-e2e-planningcard": true,
        "data-e2e-planningcard-type": props.type,
        "data-e2e-planningcard-title": props.title,
        "data-id": "dashboard_PlanningCard_Card"
      }, PlanningCard_jsx(ObserveSize/* default */.Z, {
        observerFn: function observerFn(contentRect) {
          return _this2.setState({
            renderWidth: contentRect.width
          });
        },
        "data-id": "dashboard_PlanningCard_ObserveSize"
      }, this.renderCard(props)));
    }
  }]);
}(react.Component);

/* harmony default export */ var dashboard_PlanningCard = ((0,withMatch/* default */.Z)( // $FlowFixMe
(0,es/* connect */.$j)(null, PlanningCard_mapDispatchToProps)(PlanningCard)));
var PlanningCard_PassedEventNotification = styled_components_browser_esm["default"].p(PlanningCard_templateObject || (PlanningCard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 12rem;\n  line-height: 16rem;\n  font-weight: bold;\n  color: ", ";\n  margin: 0;\n  position: absolute;\n  bottom: ", "rem;\n  left: ", "rem;\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.beige */.K5.beige, function (props) {
  return props.isCardLarge ? '25' : '15';
}, function (props) {
  return props.isCardLarge ? '25' : '15';
});
var DeleteIconContainer = styled_components_browser_esm["default"].button(PlanningCard_templateObject2 || (PlanningCard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  left: 15rem;\n  bottom: 15rem;\n  padding: 0 5rem;\n\n  > * {\n    transform: scale(1);\n  }\n\n  svg * {\n    transition: fill 0.2s ease-in-out;\n  }\n"])));
var CheckContainer = styled_components_browser_esm["default"].div(PlanningCard_templateObject3 || (PlanningCard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  ", ";\n"])), function (props) {
  return props.isCardLarge ? "\n    right: 5rem;\n    top: 2rem;\n  " : "\n    right: 1rem;\n    top: 2rem;\n    > svg {\n      transform: scale(.8);\n    }\n  ";
});
var UpdateContainter = styled_components_browser_esm["default"].div(PlanningCard_templateObject4 || (PlanningCard_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n"])));
var DaysCounterWrapper = styled_components_browser_esm["default"].div(PlanningCard_templateObject5 || (PlanningCard_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: ", "rem;\n  right: ", "rem;\n"])), function (props) {
  return props.isCardLarge ? '17' : '12';
}, function (props) {
  return props.isCardLarge ? '20' : '15';
});
var CreatedBy = styled_components_browser_esm["default"].div(PlanningCard_templateObject6 || (PlanningCard_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.textGrey */.K5.textGrey, function (props) {
  return props.isCardLarge ? '14' : '12';
}, function (props) {
  return props.isCardLarge ? '18' : '16';
});
var PlanningCard_Author = styled_components_browser_esm["default"].div(PlanningCard_templateObject7 || (PlanningCard_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 5rem;\n\n  > div {\n    margin-right: 5rem;\n  }\n"])));
var PlanningCard_Action = styled_components_browser_esm["default"].div(PlanningCard_templateObject8 || (PlanningCard_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-table;\n  margin-top: ", "rem;\n  margin-bottom: 8rem;\n  font-weight: bold;\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n  padding-right: ", "rem;\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    border: 1px solid ", ";\n    border-radius: 4rem;\n    width: ", "rem;\n    height: ", "rem;\n  }\n"])), function (props) {
  return props.isCardLarge ? '10' : '8';
}, styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.textGrey */.K5.textGrey, function (props) {
  return props.isCardLarge ? '14' : '12';
}, function (props) {
  return props.isCardLarge ? '26' : '18';
}, function (props) {
  return props.isCardLarge ? '36' : '28';
}, styleGuide/* colorPalette.lightBeige */.K5.lightBeige, function (props) {
  return props.isCardLarge ? '24' : '16';
}, function (props) {
  return props.isCardLarge ? '24' : '16';
});
var PlanningCard_SubTitle = styled_components_browser_esm["default"].h4(PlanningCard_templateObject9 || (PlanningCard_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 0rem;\n  margin-bottom: 8rem;\n  font-weight: bold;\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.textGrey */.K5.textGrey, function (props) {
  return props.isCardLarge ? '14' : '12';
}, function (props) {
  return props.isCardLarge ? '20' : '10';
});
var PlanningCard_StepIcon = styled_components_browser_esm["default"].div(PlanningCard_templateObject0 || (PlanningCard_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  left: -2rem;\n  top: 0;\n  width: ", "rem;\n  height: ", "rem;\n  background-color: ", ";\n  border-radius: 6rem;\n  color: #ffffff;\n  text-align: center;\n  font-weight: bold;\n  font-family: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n\n  span {\n    position: relative;\n    display: block;\n    font-size: ", "rem;\n  }\n\n  &:before {\n    content: '';\n    z-index: -1;\n    border-radius: 6rem;\n    width: 100%;\n    height: 100%;\n    background-color: ", ";\n    opacity: 0.4;\n    position: absolute;\n    top: 4rem;\n    left: 4rem;\n  }\n"])), function (props) {
  return props.isCardLarge ? '40' : '32';
}, function (props) {
  return props.isCardLarge ? '40' : '32';
}, styleGuide/* colorPalette.lightOrange */.K5.lightOrange, styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.isCardLarge ? '16' : '12';
}, function (props) {
  return props.isCardLarge ? '18' : '14';
}, function (props) {
  return props.isCardLarge ? '14' : '10';
}, styleGuide/* colorPalette.lightOrange */.K5.lightOrange);
var IconHeader = styled_components_browser_esm["default"].div(PlanningCard_templateObject1 || (PlanningCard_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  min-height: ", "rem;\n\n  padding-left: ", "rem;\n"])), function (props) {
  return props.isCardLarge ? "\n    ".concat(props.hasTime ? "75" : "55") : "\n    ".concat(props.hasTime ? "60" : "45");
}, function (props) {
  return props.isCardLarge ? '55' : '40';
});
var PlanningCard_DateIconWrapper = styled_components_browser_esm["default"].div(PlanningCard_templateObject10 || (PlanningCard_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 45rem;\n\n  > * {\n    position: relative;\n    margin-top: 0;\n    margin-right: 0;\n    left: ", "rem;\n    top: ", "rem;\n  }\n"])), function (props) {
  return props.isCardLarge ? '-5' : '-10';
}, function (props) {
  return props.isCardLarge ? '-5' : '-10';
});
var TitleBig = styled_components_browser_esm["default"].h3(PlanningCard_templateObject11 || (PlanningCard_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  font-family: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n  margin-top: 0;\n  margin-bottom: 8rem;\n  box-sizing: border-box;\n  font-weight: bold;\n  color: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.isCardLarge ? '18' : '16';
}, function (props) {
  return props.isCardLarge ? '22' : '20';
}, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var PlanningCard_PublishedDate = styled_components_browser_esm["default"].span(PlanningCard_templateObject12 || (PlanningCard_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 12rem;\n  line-height: 20rem;\n  margin-bottom: 5rem;\n  display: block;\n  color: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.color ? props.color : styleGuide/* colorPalette.textGrey */.K5.textGrey;
});
var ReadMoreBtn = styled_components_browser_esm["default"].div(PlanningCard_templateObject13 || (PlanningCard_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: ", "rem;\n  right: ", "rem;\n"])), function (props) {
  return props.isCardLarge ? '20' : '15';
}, function (props) {
  return props.isCardLarge ? '20' : '15';
});
var PlanningCard_ImageContainer = styled_components_browser_esm["default"].div(PlanningCard_templateObject14 || (PlanningCard_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: #000000;\n\n  > * {\n    opacity: 0.8;\n  }\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  > svg {\n    position: absolute;\n    z-index: 3;\n    box-shadow: 0 0 200rem 0 rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    backface-visibility: hidden;\n    transform: translateZ(0);\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n"])));
var PlanningCard_Card = styled_components_browser_esm["default"].div(PlanningCard_templateObject15 || (PlanningCard_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  box-sizing: border-box;\n  height: 100%;\n  width: 100%;\n  margin-bottom: 20rem;\n  background-color: #ffffff;\n  ", ";\n  transition: box-shadow 0.25s ease;\n\n  &:hover {\n    box-shadow: 0rem 0rem 20rem 0rem rgba(0, 0, 0, 0.25);\n    cursor: pointer;\n  }\n\n  > * {\n    height: 100%;\n  }\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary);
var PlanningCard_Title = styled_components_browser_esm["default"].h3(PlanningCard_templateObject16 || (PlanningCard_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  margin: 0;\n  color: #ffffff;\n  font-weight: bold;\n  font-size: ", "rem;\n  line-height: ", "rem;\n  color: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.isCardLarge ? '18' : '14';
}, function (props) {
  return props.isCardLarge ? '22' : '18';
}, function (props) {
  return props.type === 'update' ? '#FFFFFF' : styleGuide/* colorPalette.textGrey */.K5.textGrey;
});
var PlanningCard_Text = styled_components_browser_esm["default"].p(PlanningCard_templateObject17 || (PlanningCard_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "rem;\n  line-height: ", "rem;\n  font-family: ", ";\n  color: ", ";\n  margin-top: 0rem;\n  margin-bottom: 0;\n"])), function (props) {
  return props.isCardLarge ? '18' : '14';
}, function (props) {
  return props.isCardLarge ? '28' : '22';
}, styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var PlanningCard_TextContainer = styled_components_browser_esm["default"].div(PlanningCard_templateObject18 || (PlanningCard_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  position: relative;\n  z-index: 2;\n  padding: ", "rem;\n  box-sizing: border-box;\n"])), function (props) {
  return props.isCardLarge ? '20' : '15';
});
;// CONCATENATED MODULE: ./src/components/dashboard/PlanningSummaryBlock.js



var PlanningSummaryBlock_templateObject, PlanningSummaryBlock_templateObject2, PlanningSummaryBlock_templateObject3, PlanningSummaryBlock_templateObject4, PlanningSummaryBlock_templateObject5, PlanningSummaryBlock_templateObject6, PlanningSummaryBlock_templateObject7, PlanningSummaryBlock_templateObject8, PlanningSummaryBlock_templateObject9, PlanningSummaryBlock_templateObject0, PlanningSummaryBlock_templateObject1, PlanningSummaryBlock_templateObject10, PlanningSummaryBlock_templateObject11, PlanningSummaryBlock_templateObject12, PlanningSummaryBlock_templateObject13, PlanningSummaryBlock_templateObject14, PlanningSummaryBlock_templateObject15, PlanningSummaryBlock_templateObject16, PlanningSummaryBlock_templateObject17, PlanningSummaryBlock_templateObject18, PlanningSummaryBlock_templateObject19, PlanningSummaryBlock_templateObject20, PlanningSummaryBlock_templateObject21, PlanningSummaryBlock_templateObject22, PlanningSummaryBlock_templateObject23, PlanningSummaryBlock_templateObject24, PlanningSummaryBlock_templateObject25, PlanningSummaryBlock_templateObject26, PlanningSummaryBlock_templateObject27, PlanningSummaryBlock_templateObject28, PlanningSummaryBlock_templateObject29, PlanningSummaryBlock_templateObject30, PlanningSummaryBlock_templateObject31, PlanningSummaryBlock_templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44;

var PlanningSummaryBlock_jsx = react.createElement;














var PlanningSummaryBlock_connectApiData = (0,withApiData/* default */.Z)({
  planningBlock: 'getBlock'
}, function (ownProps) {
  return {
    planningBlock: {
      projectSlug: ownProps.match.params.projectSlug,
      env: 'closed',
      blockId: ownProps.id
    }
  };
});

var renderItems = function renderItems(items, blockId) {
  return items.map(function (item, index) {
    return PlanningSummaryBlock_jsx(PlanningSummaryBlock_CardContainer, {
      key: index,
      "data-id": "dashboard_PlanningSummaryBlock_CardContainer"
    }, PlanningSummaryBlock_jsx(LineContainer, {
      "data-id": "dashboard_PlanningSummaryBlock_LineContainer"
    }, PlanningSummaryBlock_jsx(designElements_DottedVerticalLine, {
      height: 60,
      "data-id": "dashboard_PlanningSummaryBlock_DottedVerticalLine"
    })), PlanningSummaryBlock_jsx(PlanningSummaryBlock_IconContainer, {
      "data-id": "dashboard_PlanningSummaryBlock_IconContainer"
    }, PlanningSummaryBlock_jsx(designElements_PlanningIconsMap, {
      icon: item.type,
      color: styleGuide/* colorPalette.white */.K5.white,
      "data-id": "dashboard_PlanningSummaryBlock_PlanningIconsMap"
    })), PlanningSummaryBlock_jsx(PlanningSummaryBlock_ArticleCard, {
      "data-id": "dashboard_PlanningSummaryBlock_ArticleCard"
    }, PlanningSummaryBlock_jsx(dashboard_PlanningCard, (0,esm_extends/* default */.Z)({
      blockId: blockId
    }, item, {
      "data-id": "dashboard_PlanningSummaryBlock_PlanningCard"
    }))));
  });
};

var PlanningSummaryBlock = function PlanningSummaryBlock(_ref) {
  var id = _ref.id,
      link = _ref.link,
      match = _ref.match,
      planningBlock = _ref.planningBlock,
      renderWidth = _ref.renderWidth,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  var slides = planningBlock.request.networkStatus === 'success' ? lodash_get_default()(planningBlock, 'data.items') : items;
  var swipeView = renderWidth < 768;
  var sliderPadding = renderWidth > 290 ? (renderWidth - 320) / 2 + 35 : 35;
  return PlanningSummaryBlock_jsx(PlanningSummaryBlock_Container, {
    "data-e2e-block-planningsummary": true,
    "data-id": "dashboard_PlanningSummaryBlock_Container"
  }, swipeView ? PlanningSummaryBlock_jsx(MobileTimeline, {
    swipeView: swipeView,
    "data-id": "dashboard_PlanningSummaryBlock_MobileTimeline"
  }, PlanningSummaryBlock_jsx(lib/* default */.ZP, {
    index: slides.length > 1 ? 1 : 0,
    enableMouseEvents: true,
    style: {
      overflow: 'visible',
      padding: "0 ".concat(sliderPadding, "px"),
      boxSizing: 'border-box'
    },
    slideStyle: {
      overflow: 'visible',
      padding: '0 5px',
      boxSizing: 'border-box'
    },
    "data-id": "dashboard_PlanningSummaryBlock_SwipeableViews"
  }, renderItems(slides, id)), link && PlanningSummaryBlock_jsx(PlanningSummaryBlock_ButtonContainer, {
    "data-id": "dashboard_PlanningSummaryBlock_ButtonContainer"
  }, PlanningSummaryBlock_jsx(ButtonSecondary/* default */.Z, {
    label: "Planning bekijken",
    type: "internalLink",
    color: "#ffffff",
    colorHover: "#993D00",
    caretColor: styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(link),
    "data-id": "dashboard_PlanningSummaryBlock_ButtonSecondary"
  }))) : PlanningSummaryBlock_jsx(DesktopTimeline, {
    swipeView: swipeView,
    items: slides.length > 2,
    "data-id": "dashboard_PlanningSummaryBlock_DesktopTimeline"
  }, renderItems(slides, id), PlanningSummaryBlock_jsx(BackDrop, {
    "data-id": "dashboard_PlanningSummaryBlock_BackDrop"
  }, PlanningSummaryBlock_jsx(PastColumn, {
    "data-id": "dashboard_PlanningSummaryBlock_PastColumn"
  }, PlanningSummaryBlock_jsx(Divider, {
    "data-id": "dashboard_PlanningSummaryBlock_Divider"
  }, PlanningSummaryBlock_jsx(designElements_DottedVerticalLine, {
    height: renderWidth > 1439 ? 360 : renderWidth > 1027 ? 284 : 225,
    "data-id": "dashboard_PlanningSummaryBlock_DottedVerticalLine"
  })), PlanningSummaryBlock_jsx(PlanningSummaryBlock_Text, {
    "data-id": "dashboard_PlanningSummaryBlock_Text"
  }, "Verleden")), PlanningSummaryBlock_jsx(FutureColumn, {
    "data-id": "dashboard_PlanningSummaryBlock_FutureColumn"
  }, PlanningSummaryBlock_jsx(PlanningSummaryBlock_Text, {
    "data-id": "dashboard_PlanningSummaryBlock_Text"
  }, "Toekomst"), link && PlanningSummaryBlock_jsx(PlanningSummaryBlock_ButtonContainer, {
    "data-id": "dashboard_PlanningSummaryBlock_ButtonContainer"
  }, PlanningSummaryBlock_jsx(ButtonSecondary/* default */.Z, {
    label: "Planning bekijken",
    type: "internalLink",
    color: "#ffffff",
    colorHover: "#993D00",
    caretColor: styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(link),
    "data-id": "dashboard_PlanningSummaryBlock_ButtonSecondary"
  }))))));
};

/* harmony default export */ var dashboard_PlanningSummaryBlock = ((0,withMatch/* default */.Z)(PlanningSummaryBlock_connectApiData(PlanningSummaryBlock)));
var PlanningSummaryBlock_ButtonContainer = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject || (PlanningSummaryBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  bottom: 30rem;\n"])));
var PlanningSummaryBlock_Text = styled_components_browser_esm["default"].p(PlanningSummaryBlock_templateObject2 || (PlanningSummaryBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  opacity: 0.7;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 12rem;\n  line-height: 16rem;\n  color: #ffffff;\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningSummaryBlock_templateObject3 || (PlanningSummaryBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 14rem;\n    line-height: 18rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject4 || (PlanningSummaryBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 16rem;\n    line-height: 20rem;\n  "]))));
var Divider = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject5 || (PlanningSummaryBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  width: 2rem;\n  position: absolute;\n  right: 0;\n  top: 0;\n  opacity: 0.5;\n"])));
var PastColumn = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject6 || (PlanningSummaryBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  width: calc(165rem + 5%);\n  background-color: ", ";\n  height: 100%;\n\n  ", " {\n    position: absolute;\n    right: 16rem;\n    top: 60rem;\n\n    ", ";\n\n    ", ";\n  }\n\n  ", ";\n\n  ", ";\n"])), (0,utils/* darken */._j)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, 10), PlanningSummaryBlock_Text, breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningSummaryBlock_templateObject7 || (PlanningSummaryBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      right: 20rem;\n      top: 86rem;\n    "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject8 || (PlanningSummaryBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n      right: 24rem;\n      top: 110rem;\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningSummaryBlock_templateObject9 || (PlanningSummaryBlock_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(190rem + 7%);\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject0 || (PlanningSummaryBlock_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 322rem;\n  "]))));
var FutureColumn = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject1 || (PlanningSummaryBlock_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  width: calc(95% - 165rem);\n  height: 100%;\n\n  &:before {\n    content: '';\n    width: 100%;\n    background-color: ", ";\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  ", " {\n    position: absolute;\n    left: 16rem;\n    top: 60rem;\n\n    ", ";\n\n    ", ";\n  }\n\n\n  @media screen and (min-width: 940px) {\n    &:after {\n      content: '';\n      display: block;\n      width: 0;\n      height: 0;\n      position: absolute;\n      z-index: -1;\n      top: -20rem;\n      right: -20rem;\n      border-top: 220rem solid ", ";\n      border-left: 220rem solid transparent};\n    }\n  }\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* colorPalette.lightOrange */.K5.lightOrange, PlanningSummaryBlock_Text, breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningSummaryBlock_templateObject10 || (PlanningSummaryBlock_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n      left: 20rem;\n      top: 86rem;\n    "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject11 || (PlanningSummaryBlock_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n      left: 24rem;\n      top: 110rem;\n    "]))), (0,utils/* hex2rgb */.wK)(styleGuide/* colorPalette.lightGrey */.K5.lightGrey, 0.65), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningSummaryBlock_templateObject12 || (PlanningSummaryBlock_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: calc(93% - 190rem);\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject13 || (PlanningSummaryBlock_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(100% - 322rem);\n\n    &:after {\n      border-top: 275rem solid ", ";\n      border-left: 275rem solid transparent};\n    }\n  "])), (0,utils/* hex2rgb */.wK)(styleGuide/* colorPalette.lightGrey */.K5.lightGrey, 0.65)));
var BackDrop = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject14 || (PlanningSummaryBlock_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 225rem;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  z-index: 0;\n  display: flex;\n\n  ", ";\n\n  ", ";\n\n  &:after {\n    content: '';\n    width: 100%;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 2rem;\n    background-color: #fff;\n  }\n\n  ", " {\n    bottom: auto;\n    right: 5%;\n    width: 21%;\n    top: 24rem;\n    text-align: right;\n\n    ", ";\n\n    ", ";\n\n    ", ";\n  }\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningSummaryBlock_templateObject15 || (PlanningSummaryBlock_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 284rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject16 || (PlanningSummaryBlock_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 360rem;\n  "]))), PlanningSummaryBlock_ButtonContainer, breakpoints/* toBreakpoint.lg */.Hx.lg(PlanningSummaryBlock_templateObject17 || (PlanningSummaryBlock_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n      span {\n        font-size: 12rem;\n        line-height: 16rem;\n      }\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningSummaryBlock_templateObject18 || (PlanningSummaryBlock_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: 200rem;\n      right: 40rem;\n      top: 65rem;\n\n      span {\n        font-size: 16rem;\n        line-height: 24rem;\n      }\n    "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject19 || (PlanningSummaryBlock_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: 85rem;\n      right: 65rem;\n\n      span {\n        font-size: 18rem;\n        line-height: 26rem;\n      }\n    "]))));
var PlanningSummaryBlock_IconContainer = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject20 || (PlanningSummaryBlock_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  z-index: 1;\n  background-color: ", ";\n  width: 36rem;\n  height: 36rem;\n  border-radius: 50%;\n  border: 2rem solid #fff;\n  bottom: -62rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", ";\n"])), (0,utils/* darken */._j)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, 10), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject21 || (PlanningSummaryBlock_templateObject21 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 44rem;\n    height: 44rem;\n\n    > svg {\n      transform: scale(1.25);\n    }\n  "]))));
var LineContainer = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject22 || (PlanningSummaryBlock_templateObject22 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  width: 5rem;\n  height: 36rem;\n  bottom: -30rem;\n  left: 50%;\n  transform: translateX(-50%);\n"])));
var PlanningSummaryBlock_Container = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject23 || (PlanningSummaryBlock_templateObject23 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  width: 100vw;\n  left: -10rem;\n\n  ", ";\n\n  @media screen and (min-width: 768px) {\n    left: auto;\n    width: 100%;\n    box-sizing: border-box;\n    padding-left: 75rem;\n    padding-right: 75rem;\n  }\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(PlanningSummaryBlock_templateObject24 || (PlanningSummaryBlock_templateObject24 = (0,taggedTemplateLiteral/* default */.Z)(["\n    left: -20rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningSummaryBlock_templateObject25 || (PlanningSummaryBlock_templateObject25 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 120rem;\n    padding-right: 120rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject26 || (PlanningSummaryBlock_templateObject26 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 0;\n    padding-right: 0;\n  "]))));
var PlanningSummaryBlock_ArticleCard = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject27 || (PlanningSummaryBlock_templateObject27 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 240rem;\n  background-color: #fff;\n  box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.25);\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject28 || (PlanningSummaryBlock_templateObject28 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 280rem;\n  "]))));
var MobileTimeline = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject29 || (PlanningSummaryBlock_templateObject29 = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-height: 420rem;\n  width: 100%;\n  position: relative;\n  padding-top: 20rem;\n  box-sizing: border-box;\n\n  &:after {\n    background-color: ", ";\n    content: '';\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    height: 75%;\n    z-index: -1;\n  }\n\n  &:before {\n    content: '';\n    width: 100%;\n    position: absolute;\n    bottom: 115rem;\n    left: 0;\n    height: 2rem;\n    background-color: #fff;\n  }\n"])), styleGuide/* colorPalette.lightOrange */.K5.lightOrange);
var PlanningSummaryBlock_CardContainer = styled_components_browser_esm["default"].div(PlanningSummaryBlock_templateObject30 || (PlanningSummaryBlock_templateObject30 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 240rem;\n  position: relative;\n  z-index: 1;\n\n  @media screen and (min-width: 768px) {\n    width: 240rem;\n    margin-right: 3%;\n  }\n\n  ", ";\n\n  ", ";\n\n  &:nth-of-type(1) {\n    @media screen and (min-width: 768px) {\n      order: 1;\n      padding-bottom: 55rem;\n\n      ", " {\n        bottom: 30rem;\n      }\n\n      ", " {\n        bottom: -20rem;\n\n        ", ";\n      }\n    }\n\n    ", ";\n  }\n\n  &:nth-of-type(3) {\n    @media screen and (min-width: 768px) {\n      order: 2;\n      padding-bottom: 55rem;\n\n      ", " {\n        bottom: 30rem;\n      }\n\n      ", " {\n        bottom: -20rem;\n\n        ", ";\n      }\n    }\n\n    ", ";\n  }\n\n  &:nth-of-type(2) {\n    @media screen and (min-width: 768px) {\n      order: 3;\n      margin-left: calc(70rem + 5%);\n      padding-top: 55rem;\n\n      ", " {\n        bottom: auto;\n        top: 20rem;\n      }\n\n      ", " {\n        bottom: auto;\n        top: -20rem;\n\n        ", ";\n      }\n    }\n\n    ", ";\n\n    ", ";\n  }\n\n  &:nth-of-type(4) {\n    @media screen and (min-width: 768px) {\n      order: 4;\n      padding-top: 55rem;\n      margin-right: 0;\n\n      ", " {\n        bottom: auto;\n        top: 20rem;\n      }\n\n      ", " {\n        bottom: auto;\n        top: -20rem;\n\n        ", ";\n      }\n    }\n\n    ", ";\n  }\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(PlanningSummaryBlock_templateObject31 || (PlanningSummaryBlock_templateObject31 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-right: 10%;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningSummaryBlock_templateObject32 || (PlanningSummaryBlock_templateObject32 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 280rem;\n    margin-right: 120rem;\n  "]))), LineContainer, PlanningSummaryBlock_IconContainer, breakpoints/* fromBreakpoint.xl */.ks.xl(_templateObject33 || (_templateObject33 = (0,taggedTemplateLiteral/* default */.Z)(["\n          bottom: -24rem;\n        "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(_templateObject34 || (_templateObject34 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 63rem;\n    "]))), LineContainer, PlanningSummaryBlock_IconContainer, breakpoints/* fromBreakpoint.xl */.ks.xl(_templateObject35 || (_templateObject35 = (0,taggedTemplateLiteral/* default */.Z)(["\n          bottom: -24rem;\n        "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(_templateObject36 || (_templateObject36 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 63rem;\n    "]))), LineContainer, PlanningSummaryBlock_IconContainer, breakpoints/* fromBreakpoint.xl */.ks.xl(_templateObject37 || (_templateObject37 = (0,taggedTemplateLiteral/* default */.Z)(["\n          top: -24rem;\n        "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(_templateObject38 || (_templateObject38 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-left: calc(110rem + 7%);\n    "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(_templateObject39 || (_templateObject39 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-left: 200rem;\n      padding-top: 63rem;\n    "]))), LineContainer, PlanningSummaryBlock_IconContainer, breakpoints/* fromBreakpoint.xl */.ks.xl(_templateObject40 || (_templateObject40 = (0,taggedTemplateLiteral/* default */.Z)(["\n          top: -24rem;\n        "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(_templateObject41 || (_templateObject41 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-top: 63rem;\n    "]))));
var DesktopTimeline = styled_components_browser_esm["default"].div(_templateObject42 || (_templateObject42 = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-width: 620rem;\n  min-height: 590rem;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  padding-left: 10rem;\n  padding-right: 10rem;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: wrap;\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.items ? 'row' : 'column';
}, breakpoints/* fromBreakpoint.lg */.ks.lg(_templateObject43 || (_templateObject43 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-width: 780rem;\n    padding-left: 20rem;\n    padding-right: 20rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(_templateObject44 || (_templateObject44 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 1000rem;\n    min-height: 686rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/shared/buttons/ButtonAdd.js


var ButtonAdd_templateObject, ButtonAdd_templateObject2, ButtonAdd_templateObject3;

var ButtonAdd_jsx = react.createElement;





var ButtonAdd_defaultProps = {
  color: styleGuide/* colorPalette.blue */.K5.blue
};

var ButtonAdd_ButtonAdd = function ButtonAdd(_ref) {
  var id = _ref.id,
      clickHandler = _ref.clickHandler,
      color = _ref.color,
      label = _ref.label;
  return ButtonAdd_jsx(ButtonAdd_Button, {
    id: id,
    onClick: clickHandler,
    "data-e2e-button-add": true,
    "data-id": "buttons_ButtonAdd_Button"
  }, ButtonAdd_jsx(ButtonAdd_IconContainer, {
    color: color,
    "data-id": "buttons_ButtonAdd_IconContainer"
  }, ButtonAdd_jsx(icons_Plus, {
    "data-id": "buttons_ButtonAdd_Plus"
  })), ButtonAdd_jsx(ButtonAdd_Label, {
    color: color,
    "data-id": "buttons_ButtonAdd_Label"
  }, label));
};

ButtonAdd_ButtonAdd.defaultProps = ButtonAdd_defaultProps;
/* harmony default export */ var buttons_ButtonAdd = (ButtonAdd_ButtonAdd);
var ButtonAdd_Button = styled_components_browser_esm["default"].button(ButtonAdd_templateObject || (ButtonAdd_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  font-family: ", ";\n  padding: 10rem 0;\n\n  &:hover {\n    > span {\n      color: ", ";\n    }\n    > div {\n      background-color: ", ";\n    }\n  }\n"])), styleGuide/* fonts.primary */.Rq.primary, function (props) {
  return props.color ? (0,utils/* darken */._j)(props.color, 15) : styleGuide/* colorPalette.darkBlue */.K5.darkBlue;
}, function (props) {
  return props.color ? (0,utils/* darken */._j)(props.color, 15) : styleGuide/* colorPalette.darkBlue */.K5.darkBlue;
});
var ButtonAdd_IconContainer = styled_components_browser_esm["default"].div(ButtonAdd_templateObject2 || (ButtonAdd_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  border-radius: 100%;\n  width: 26rem;\n  height: 26rem;\n  background-color: ", ";\n  align-items: center;\n  justify-content: center;\n  margin-right: 10rem;\n  transition: background 0.2s ease-in-out;\n"])), function (props) {
  return props.color;
});
var ButtonAdd_Label = styled_components_browser_esm["default"].span(ButtonAdd_templateObject3 || (ButtonAdd_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-weight: bold;\n  font-size: 18rem;\n  transition: color 0.2s ease-in-out;\n"])), function (props) {
  return props.color;
});
;// CONCATENATED MODULE: ./src/components/shared/designElements/DottedHorizontalLine.js
var DottedHorizontalLine_jsx = react.createElement;


var DottedHorizontalLine = function DottedHorizontalLine(_ref) {
  var width = _ref.width;
  return DottedHorizontalLine_jsx("svg", {
    width: "".concat(width),
    height: "5",
    viewBox: "0 0 ".concat(width, " 3"),
    version: "1.1",
    "data-id": "designElements_DottedHorizontalLine_svg"
  }, DottedHorizontalLine_jsx("line", {
    strokeDasharray: "5, 4",
    y1: "0",
    x1: "0",
    y2: "0",
    x2: "".concat(width),
    style: {
      stroke: 'white',
      strokeWidth: 2
    },
    "data-id": "designElements_DottedHorizontalLine_line"
  }));
};

/* harmony default export */ var designElements_DottedHorizontalLine = (DottedHorizontalLine);
;// CONCATENATED MODULE: ./src/components/dashboard/PlanningBlock.js









var PlanningBlock_templateObject, PlanningBlock_templateObject2, PlanningBlock_templateObject3, PlanningBlock_templateObject4, PlanningBlock_templateObject5, PlanningBlock_templateObject6, PlanningBlock_templateObject7, PlanningBlock_templateObject8, PlanningBlock_templateObject9, PlanningBlock_templateObject0, PlanningBlock_templateObject1, PlanningBlock_templateObject10, PlanningBlock_templateObject11, PlanningBlock_templateObject12, PlanningBlock_templateObject13, PlanningBlock_templateObject14, PlanningBlock_templateObject15, PlanningBlock_templateObject16, PlanningBlock_templateObject17, PlanningBlock_templateObject18, PlanningBlock_templateObject19;

var PlanningBlock_jsx = react.createElement;

function PlanningBlock_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, PlanningBlock_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function PlanningBlock_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (PlanningBlock_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

















var PlanningBlock_connectApiData = (0,withApiData/* default */.Z)({
  planningBlock: 'getBlock'
}, function (ownProps) {
  return {
    planningBlock: {
      projectSlug: ownProps.match.params.projectSlug,
      env: ownProps.match.params.env,
      blockId: ownProps.id
    },
    options: {
      cache: 'disabled'
    }
  };
});

var PlanningBlock_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase', undefined)
  };
};

var PlanningBlock_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    createAction: function createAction(evt) {
      var endpoint = {
        type: 'planningAction',
        componentProps: {
          blockId: ownProps.id,
          mode: 'create'
        }
      };
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, endpoint));
    }
  };
};

var PlanningBlock = /*#__PURE__*/function (_Component) {
  function PlanningBlock() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, PlanningBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = PlanningBlock_callSuper(this, PlanningBlock, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      maxPastItemsShowing: 1
    });

    (0,defineProperty/* default */.Z)(_this, "loadMorePastItems", function () {
      _this.setState(function (prevState) {
        return {
          maxPastItemsShowing: prevState.maxPastItemsShowing + 8
        };
      });
    });

    (0,defineProperty/* default */.Z)(_this, "renderItems", function (items) {
      var sliceAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : items.length;
      var id = _this.props.id;
      return (items || []).slice(0, sliceAmount).map(function (item, index) {
        return PlanningBlock_jsx(PlanningBlock_CardContainer, {
          key: index,
          "data-id": "dashboard_PlanningBlock_CardContainer"
        }, PlanningBlock_jsx(PlanningBlock_LineContainer, {
          "data-id": "dashboard_PlanningBlock_LineContainer"
        }, PlanningBlock_jsx(designElements_DottedHorizontalLine, {
          width: 160,
          "data-id": "dashboard_PlanningBlock_DottedHorizontalLine"
        })), PlanningBlock_jsx(PlanningBlock_IconContainer, {
          "data-id": "dashboard_PlanningBlock_IconContainer"
        }, PlanningBlock_jsx(designElements_PlanningIconsMap, {
          icon: item.type,
          color: styleGuide/* colorPalette.white */.K5.white,
          "data-id": "dashboard_PlanningBlock_PlanningIconsMap"
        })), PlanningBlock_jsx(ArticleThing, {
          "data-id": "dashboard_PlanningBlock_ArticleThing"
        }, PlanningBlock_jsx(dashboard_PlanningCard, (0,esm_extends/* default */.Z)({
          blockId: id
        }, item, {
          "data-id": "dashboard_PlanningBlock_PlanningCard"
        }))));
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(PlanningBlock, _Component);

  return (0,createClass/* default */.Z)(PlanningBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          createAction = _this$props.createAction,
          phase = _this$props.phase,
          planningBlock = _this$props.planningBlock,
          futureItems = _this$props.futureItems,
          pastItems = _this$props.pastItems,
          env = _this$props.env;
      var isNotCJ1 = phase !== 'cj1';
      var futureItemsCalculated = planningBlock.request.networkStatus === 'success' ? lodash_get_default()(planningBlock, 'data.futureItems', undefined) : futureItems;
      var pastItemsCalculated = planningBlock.request.networkStatus === 'success' ? lodash_get_default()(planningBlock, 'data.pastItems', undefined) : pastItems;
      var pastItemsIsEven = pastItems.length % 2 === 0;
      var futureItemsIsEven = futureItems.length % 2 === 0;
      var showMorePastItems = this.state.maxPastItemsShowing <= pastItems.length;
      return PlanningBlock_jsx(PlanningBlock_Container, {
        marginTop: !isNotCJ1,
        openBlockPadding: env === 'open',
        "data-e2e-block-planning": true,
        "data-id": "dashboard_PlanningBlock_Container"
      }, isNotCJ1 && env === 'closed' && PlanningBlock_jsx(ActionCTA, {
        onClick: createAction,
        "data-id": "dashboard_PlanningBlock_ActionCTA"
      }, PlanningBlock_jsx(buttons_ButtonAdd, {
        label: "Actie aanmaken",
        "data-id": "dashboard_PlanningBlock_ButtonAdd"
      })), PlanningBlock_jsx(PastTimelineContainer, {
        "data-id": "dashboard_PlanningBlock_PastTimelineContainer"
      }, showMorePastItems && PlanningBlock_jsx(LoadMoreBtnContainer, {
        "data-id": "dashboard_PlanningBlock_LoadMoreBtnContainer"
      }, PlanningBlock_jsx(ButtonPrimary/* default */.Z, {
        label: "Laad meer",
        type: "button",
        buttonColor: (0,utils/* darken */._j)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, 10),
        labelColor: styleGuide/* colorPalette.white */.K5.white,
        buttonHoverColor: styleGuide/* colorPalette.darkOrange */.K5.darkOrange,
        labelHoverColor: styleGuide/* colorPalette.white */.K5.white,
        clickHandler: this.loadMorePastItems,
        "data-id": "dashboard_PlanningBlock_ButtonPrimary"
      })), PlanningBlock_jsx(PastTimeline, {
        loadMoreBtn: showMorePastItems,
        isEvenItems: pastItemsIsEven && !showMorePastItems,
        "data-id": "dashboard_PlanningBlock_PastTimeline"
      }, this.renderItems(pastItemsCalculated, this.state.maxPastItemsShowing), PlanningBlock_jsx(BackDropPast, {
        "data-id": "dashboard_PlanningBlock_BackDropPast"
      }, PlanningBlock_jsx(PastText, {
        "data-id": "dashboard_PlanningBlock_PastText"
      }, "Verleden"), PlanningBlock_jsx(BackDropDivider, {
        "data-id": "dashboard_PlanningBlock_BackDropDivider"
      }, PlanningBlock_jsx(designElements_DottedHorizontalLine, {
        width: 380,
        "data-id": "dashboard_PlanningBlock_DottedHorizontalLine"
      }))))), PlanningBlock_jsx(FutureTimeline, {
        isEvenItems: futureItemsIsEven,
        "data-id": "dashboard_PlanningBlock_FutureTimeline"
      }, this.renderItems(futureItemsCalculated), PlanningBlock_jsx(BackDropFuture, {
        "data-id": "dashboard_PlanningBlock_BackDropFuture"
      }, PlanningBlock_jsx(FutureText, {
        "data-id": "dashboard_PlanningBlock_FutureText"
      }, "Toekomst"))));
    }
  }]);
}(react.Component);

/* harmony default export */ var dashboard_PlanningBlock = ((0,withMatch/* default */.Z)(PlanningBlock_connectApiData((0,es/* connect */.$j)(PlanningBlock_mapStateToProps, PlanningBlock_mapDispatchToProps)(PlanningBlock))));
var BackDropDivider = styled_components_browser_esm["default"].div(PlanningBlock_templateObject || (PlanningBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  opacity: 0.6;\n  position: absolute;\n  bottom: -9rem;\n  width: 100%;\n  overflow: hidden;\n\n  @media screen and (min-width: 840px) {\n    bottom: 51rem;\n  }\n"])));
var FutureText = styled_components_browser_esm["default"].span(PlanningBlock_templateObject2 || (PlanningBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: #ffffff;\n  ", ";\n  position: absolute;\n  top: 3rem;\n  right: 10rem;\n  opacity: 0.6;\n\n  @media screen and (min-width: 840px) {\n    right: auto;\n    left: 100rem;\n    top: 10rem;\n  }\n"])), styleGuide/* textStyles.standardText */.sq.standardText);
var PastText = styled_components_browser_esm["default"].span(PlanningBlock_templateObject3 || (PlanningBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: #ffffff;\n  ", ";\n  position: absolute;\n  bottom: 5rem;\n  right: 10rem;\n  opacity: 0.6;\n\n  @media screen and (min-width: 840px) {\n    right: auto;\n    left: 100rem;\n    bottom: 72rem;\n  }\n"])), styleGuide/* textStyles.standardText */.sq.standardText);
var PastTimelineContainer = styled_components_browser_esm["default"].div(PlanningBlock_templateObject4 || (PlanningBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  position: relative;\n"])));
var LoadMoreBtnContainer = styled_components_browser_esm["default"].div(PlanningBlock_templateObject5 || (PlanningBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 380rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: -80rem;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n\n  > * {\n    border: 2px solid white;\n\n    ", ";\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(PlanningBlock_templateObject6 || (PlanningBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      min-width: 180rem;\n    "]))));
var ActionCTA = styled_components_browser_esm["default"].div(PlanningBlock_templateObject7 || (PlanningBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 64rem;\n  background-color: #ffffff;\n  cursor: pointer;\n  margin-bottom: 70rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var PlanningBlock_IconContainer = styled_components_browser_esm["default"].div(PlanningBlock_templateObject8 || (PlanningBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  background-color: ", ";\n  border-radius: 50%;\n  border: 2rem solid #fff;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44rem;\n  height: 44rem;\n\n  > svg {\n    transform: scale(1.25);\n  }\n"])), (0,utils/* darken */._j)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, 10));
var PlanningBlock_LineContainer = styled_components_browser_esm["default"].div(PlanningBlock_templateObject9 || (PlanningBlock_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  width: 5rem;\n  height: 20rem;\n  top: 50%;\n  transform: translateY(-50%);\n"])));
var PlanningBlock_CardContainer = styled_components_browser_esm["default"].div(PlanningBlock_templateObject0 || (PlanningBlock_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 280rem;\n  position: relative;\n  margin-bottom: 60rem;\n  z-index: 1;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(PlanningBlock_templateObject1 || (PlanningBlock_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 70rem;\n  "]))));
var timelineStyles = (0,styled_components_browser_esm.css)(PlanningBlock_templateObject10 || (PlanningBlock_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 10rem;\n  padding-right: 10rem;\n  box-sizing: border-box;\n\n  @media screen and (min-width: 768px) {\n    padding-left: 0;\n    padding-right: 0;\n    width: calc(100% - 450rem);\n  }\n\n  @media screen and (min-width: 840px) {\n    width: 780rem;\n    justify-content: space-between;\n    align-items: flex-end;\n  }\n"])));
var FutureTimeline = styled_components_browser_esm["default"].div(PlanningBlock_templateObject11 || (PlanningBlock_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  flex-direction: column;\n  padding-top: 30rem;\n\n  ", ";\n\n  @media screen and (min-width: 840px) {\n    padding-top: 60rem;\n    flex-direction: row-reverse;\n\n    ", ";\n\n    > ", ":nth-last-of-type(2) {\n      ", ";\n    }\n  }\n\n  > ", ":nth-of-type(2n) {\n    background: green !important;\n    @media (min-width: 320px) and (max-width: 499px) {\n      align-self: flex-start;\n    }\n\n    @media screen and (min-width: 500px) {\n      left: -90rem;\n    }\n\n    @media screen and (min-width: 768px) {\n      align-self: flex-start;\n    }\n\n    @media screen and (min-width: 840px) {\n      left: auto;\n      bottom: -90rem;\n\n      ", " {\n        right: -133rem;\n      }\n\n      ", " {\n        right: 40rem;\n      }\n    }\n  }\n\n  > ", ":nth-of-type(2n + 1) {\n    @media (min-width: 320px) and (max-width: 499px) {\n      align-self: flex-end;\n    }\n\n    @media screen and (min-width: 500px) {\n      right: -90rem;\n    }\n\n    @media screen and (min-width: 768px) {\n      align-self: flex-end;\n    }\n\n    @media screen and (min-width: 840px) {\n      right: auto;\n      top: -80rem;\n\n      ", " {\n        left: -133rem;\n      }\n\n      ", " {\n        left: -110rem;\n      }\n    }\n  }\n"])), timelineStyles, breakpoints/* fromBreakpoint.md */.ks.md(PlanningBlock_templateObject12 || (PlanningBlock_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 35rem;\n  "]))), function (props) {
  return props.isEvenItems ? "\n      padding-bottom: 90rem;\n      " : "";
}, PlanningBlock_CardContainer, function (props) {
  return props.isEvenItems ? "" : "\n          margin-bottom: 0;\n      ";
}, PlanningBlock_CardContainer, PlanningBlock_IconContainer, PlanningBlock_LineContainer, PlanningBlock_CardContainer, PlanningBlock_IconContainer, PlanningBlock_LineContainer);
var PastTimeline = styled_components_browser_esm["default"].div(PlanningBlock_templateObject13 || (PlanningBlock_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  flex-direction: column-reverse;\n\n  ", ";\n\n  @media screen and (min-width: 840px) {\n    flex-flow: row wrap-reverse;\n    margin-bottom: -60rem;\n    justify-content: flex-start;\n\n    ", ";\n\n    ", ";\n  }\n\n  > ", ":nth-of-type(1) {\n    @media screen and (max-width: 839px) {\n      margin-bottom: 35rem;\n    }\n  }\n\n  > ", ":nth-of-type(2n) {\n    @media (min-width: 320px) and (max-width: 499px) {\n      align-self: flex-end;\n    }\n\n    @media screen and (min-width: 500px) {\n      right: -90rem;\n    }\n\n    @media screen and (min-width: 768px) {\n      align-self: flex-end;\n    }\n\n    @media screen and (min-width: 840px) {\n      right: -220px;\n      top: -90rem;\n\n      ", ", ", " {\n        left: -133rem;\n      }\n    }\n  }\n\n  > ", ":nth-of-type(2n + 1) {\n    @media (min-width: 320px) and (max-width: 499px) {\n      align-self: flex-start;\n    }\n\n    @media screen and (min-width: 500px) {\n      left: -80rem;\n    }\n\n    @media screen and (min-width: 768px) {\n      align-self: flex-start;\n    }\n\n    @media screen and (min-width: 840px) {\n      bottom: -90rem;\n      left: auto;\n\n      ", " {\n        right: -133rem;\n      }\n\n      ", " {\n        right: 20rem;\n      }\n    }\n  }\n"])), timelineStyles, function (props) {
  return props.loadMoreBtn ? "\n    padding-top: 120rem;\n    " : "\n    padding-top: 50rem;\n  ";
}, function (props) {
  return props.loadMoreBtn ? "\n      padding-top: 30rem;\n      " : "\n      padding-top: 0rem;\n    ";
}, function (props) {
  return props.isEvenItems ? "\n      padding-top: 150rem;\n      " : "";
}, PlanningBlock_CardContainer, PlanningBlock_CardContainer, PlanningBlock_IconContainer, PlanningBlock_LineContainer, PlanningBlock_CardContainer, PlanningBlock_IconContainer, PlanningBlock_LineContainer);
var ArticleThing = styled_components_browser_esm["default"].div(PlanningBlock_templateObject14 || (PlanningBlock_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 280rem;\n  background-color: #fff;\n  box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.25);\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.xl */.ks.xl(PlanningBlock_templateObject15 || (PlanningBlock_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 280rem;\n  "]))));
var backDropStyes = (0,styled_components_browser_esm.css)(PlanningBlock_templateObject16 || (PlanningBlock_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: calc(100% - 120rem);\n  max-width: 300rem;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 0;\n\n  @media screen and (min-width: 768px) {\n    max-width: 380rem;\n    width: calc(100% + 20rem);\n  }\n\n  &:after {\n    content: '';\n    height: 100%;\n    width: 2rem;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #fff;\n  }\n"])));
var BackDropFuture = styled_components_browser_esm["default"].div(PlanningBlock_templateObject17 || (PlanningBlock_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  background-color: ", ";\n"])), backDropStyes, styleGuide/* colorPalette.lightOrange */.K5.lightOrange);
var BackDropPast = styled_components_browser_esm["default"].div(PlanningBlock_templateObject18 || (PlanningBlock_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  background-color: ", ";\n"])), backDropStyes, (0,utils/* darken */._j)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, 10));
var PlanningBlock_Container = styled_components_browser_esm["default"].div(PlanningBlock_templateObject19 || (PlanningBlock_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n\n  ", ";\n\n  @media screen and (min-width: 1001px) {\n    ", ";\n  }\n"])), function (props) {
  return props.marginTop ? "\n    margin-top: 25rem;\n  " : "\n    margin-top: 0rem;\n  ";
}, function (props) {
  return props.openBlockPadding && "\n      padding: 60rem 0 30rem;\n    ";
}, function (props) {
  return props.marginTop ? "\n      margin-top: -5rem;\n    " : "\n      margin-top: 0rem;\n    ";
});
;// CONCATENATED MODULE: ./src/components/shared/icons/Neighbours.js
var Neighbours_jsx = react.createElement;


var Neighbours_defaultProps = {
  color: styleGuide/* colorPalette.background */.K5.background
};

var Neighbour = function Neighbour(_ref) {
  var color = _ref.color;
  return Neighbours_jsx("svg", {
    width: "130px",
    height: "128px",
    viewBox: "0 0 130 128",
    version: "1.1",
    "data-id": "icons_Neighbours_svg"
  }, Neighbours_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Neighbours_g"
  }, Neighbours_jsx("g", {
    transform: "translate(-259.000000, -258.000000)",
    fill: color,
    "data-id": "icons_Neighbours_g_2"
  }, Neighbours_jsx("g", {
    transform: "translate(130.000000, 50.000000)",
    "data-id": "icons_Neighbours_g_3"
  }, Neighbours_jsx("g", {
    transform: "translate(0.000000, 40.000000)",
    "data-id": "icons_Neighbours_g_4"
  }, Neighbours_jsx("g", {
    transform: "translate(129.000000, 168.000000)",
    "data-id": "icons_Neighbours_g_5"
  }, Neighbours_jsx("path", {
    d: "M27.1497237,26.4435763 C21.6197432,26.4435763 17.138495,21.9618549 17.138495,16.4323476 C17.138495,10.9028404 21.6197432,6.42159222 27.1497237,6.42159222 C32.6792309,6.42159222 37.1604791,10.9028404 37.1604791,16.4323476 C37.1604791,21.9618549 32.6792309,26.4435763 27.1497237,26.4435763 M27.1497237,0 C18.0816915,0 10.7169028,7.36431547 10.7169028,16.4323476 C10.7169028,25.5003798 18.0816915,32.8651685 27.1497237,32.8651685 C36.2172826,32.8651685 43.5820713,25.5003798 43.5820713,16.4323476 C43.5820713,7.36431547 36.2172826,0 27.1497237,0",
    "data-id": "icons_Neighbours_path"
  }), Neighbours_jsx("path", {
    d: "M65.0158769,6.42159222 C70.5453045,6.42159222 75.0279079,10.9028404 75.0279079,16.4323476 C75.0279079,21.9618549 70.5453045,26.4435763 65.0158769,26.4435763 C59.485976,26.4435763 55.0052656,21.9618549 55.0052656,16.4323476 C55.0052656,10.9028404 59.5115314,6.42159222 65.0158769,6.42159222 M65.0158769,32.8651685 C74.0837785,32.8651685 81.4484612,25.5003798 81.4484612,16.4323476 C81.4484612,7.36431547 74.0837785,0 65.0158769,0 C55.9484485,0 48.5832926,7.36431547 48.5832926,16.4323476 C48.5832926,25.5003798 55.9484485,32.8651685 65.0158769,32.8651685",
    "data-id": "icons_Neighbours_path_7"
  }), Neighbours_jsx("path", {
    d: "M0,51.9591531 L0,72.7301225 C0,78.7252598 3.35262914,84.1984874 8.52376864,86.9868687 L8.52376864,114.273944 C8.52376864,121.388669 14.293726,127.173913 21.3889668,127.173913 L36.0989556,127.173913 C37.8653745,127.173913 39.2953102,125.740897 39.2953102,123.968569 C39.2953102,122.19577 37.8653745,120.762754 36.0989556,120.762754 L21.3889668,120.762754 C17.8026297,120.762754 14.8916053,117.843542 14.8916053,114.247119 L14.8916053,84.9542917 C14.8916053,83.6243397 14.0600181,82.4256888 12.8126373,81.9560171 C8.96678122,80.5484141 6.39317845,76.8484557 6.39317845,72.7564769 L6.39317845,51.9591531 C6.39317845,46.5381635 10.7848223,42.1341683 16.1910776,42.1341683 L30.0952904,42.1341683 C31.8617092,42.1341683 33.2916449,40.7011522 33.2916449,38.9283535 C33.2916449,37.1555548 31.8617092,35.7230093 30.0952904,35.7230093 L16.1910776,35.7230093 C7.25104604,35.7752473 0,43.0466867 0,51.9591531",
    "data-id": "icons_Neighbours_path_8"
  }), Neighbours_jsx("path", {
    d: "M42.1318919,51.938246 C42.1318919,46.5157496 46.5542383,42.1105303 51.9951274,42.1105303 L77.3207489,42.1105303 C82.7625829,42.1105303 87.1839844,46.5157496 87.1839844,51.938246 L87.1839844,72.7149891 C87.1839844,76.8085761 84.5927474,80.5100336 80.7207731,81.918028 C79.4655468,82.3878302 78.6284142,83.5868143 78.6284142,84.9161945 L78.6284142,114.270358 C78.6284142,117.867781 75.6979779,120.787804 72.0881981,120.787804 L57.2801171,120.787804 C53.6698649,120.787804 50.7394286,117.867781 50.7394286,114.270358 L50.7394286,84.9425561 C50.7394286,83.6122345 49.9027685,82.4132503 48.6470697,81.9434481 C44.774623,80.5354538 42.1843308,76.834467 42.1843308,72.7413507 L42.1843308,51.938246 L42.1318919,51.938246 Z M35.7230093,51.938246 L35.7230093,72.7149891 C35.7230093,78.7117928 39.0979951,84.1865418 44.3036178,86.9756981 L44.3036178,114.270358 C44.3036178,121.387061 50.1120516,127.173913 57.2546063,127.173913 L72.0626873,127.173913 C79.2047696,127.173913 85.0122585,121.387061 85.0122585,114.270358 L85.0122585,86.9756981 C90.2192985,84.1865418 93.5942843,78.7117928 93.5942843,72.7149891 L93.5942843,51.938246 C93.5942843,42.9959991 86.294413,35.7230093 77.3207489,35.7230093 L51.9951274,35.7230093 C42.9954801,35.7498417 35.7230093,43.0233023 35.7230093,51.938246 L35.7230093,51.938246 Z",
    "data-id": "icons_Neighbours_path_9"
  }), Neighbours_jsx("path", {
    d: "M102.167807,26.4435763 C96.6383789,26.4435763 92.1571953,21.9618549 92.1571953,16.4323476 C92.1571953,10.9028404 96.6383789,6.42159222 102.167807,6.42159222 C107.697234,6.42159222 112.178418,10.9028404 112.178418,16.4323476 C112.178418,21.9618549 107.697234,26.4435763 102.167807,26.4435763 M102.167807,0 C93.0999049,0 85.7352223,7.36431547 85.7352223,16.4323476 C85.7352223,25.5003798 93.0999049,32.8651685 102.167807,32.8651685 C111.235708,32.8651685 118.600391,25.5003798 118.600391,16.4323476 C118.600391,7.36431547 111.235708,0 102.167807,0",
    "data-id": "icons_Neighbours_path_10"
  }), Neighbours_jsx("path", {
    d: "M129.317294,51.9591531 C129.317294,43.0466867 122.066248,35.7752473 113.126216,35.7230093 L99.2215339,35.7230093 C97.4551151,35.7230093 96.0256487,37.1555548 96.0256487,38.9283535 C96.0256487,40.7011522 97.4551151,42.1341683 99.2215339,42.1341683 L113.126216,42.1341683 C118.532471,42.1341683 122.924115,46.5381635 122.924115,51.9591531 L122.924115,72.7564769 C122.924115,76.8484557 120.350512,80.5484141 116.504187,81.9560171 C115.256806,82.4256888 114.425688,83.6243397 114.425688,84.9542917 L114.425688,114.247119 C114.425688,117.843542 111.514195,120.762754 107.928327,120.762754 L93.218338,120.762754 C91.4514498,120.762754 90.0219834,122.19577 90.0219834,123.968569 C90.0219834,125.740897 91.4514498,127.173913 93.218338,127.173913 L107.928327,127.173913 C115.023098,127.173913 120.793525,121.388669 120.793525,114.273944 L120.793525,86.9868687 C125.964195,84.1984874 129.317294,78.7252598 129.317294,72.7301225 L129.317294,51.9591531 Z",
    "data-id": "icons_Neighbours_path_11"
  })))))));
};

Neighbour.defaultProps = Neighbours_defaultProps;
/* harmony default export */ var Neighbours = (Neighbour);
;// CONCATENATED MODULE: ./src/components/shared/designElements/WidgetHeader.js


var WidgetHeader_templateObject, WidgetHeader_templateObject2, WidgetHeader_templateObject3;

var WidgetHeader_jsx = react.createElement;





var WidgetHeader = function WidgetHeader(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return WidgetHeader_jsx(react.Fragment, null, WidgetHeader_jsx(WidgetHeader_Title, {
    "data-id": "designElements_WidgetHeader_Title"
  }, title), subtitle && WidgetHeader_jsx(WidgetHeader_SubTitle, {
    "data-id": "designElements_WidgetHeader_SubTitle"
  }, subtitle));
};

/* harmony default export */ var designElements_WidgetHeader = (WidgetHeader);
var WidgetHeader_Title = styled_components_browser_esm["default"].h3(WidgetHeader_templateObject || (WidgetHeader_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 22rem;\n  line-height: 28rem;\n  color: ", ";\n  margin-top: 5rem;\n  margin-bottom: 10rem;\n\n  ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* fromBreakpoint.md */.ks.md(WidgetHeader_templateObject2 || (WidgetHeader_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 15rem;\n  "]))));
var WidgetHeader_SubTitle = styled_components_browser_esm["default"].p(WidgetHeader_templateObject3 || (WidgetHeader_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-style: italic;\n  margin-top: -10rem;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.standardText */.sq.standardText, styleGuide/* colorPalette.textGrey */.K5.textGrey);
;// CONCATENATED MODULE: ./src/components/dashboard/NeighbourWidget.js


var NeighbourWidget_templateObject, NeighbourWidget_templateObject2, NeighbourWidget_templateObject3, NeighbourWidget_templateObject4, NeighbourWidget_templateObject5, NeighbourWidget_templateObject6, NeighbourWidget_templateObject7, NeighbourWidget_templateObject8, NeighbourWidget_templateObject9, NeighbourWidget_templateObject0, NeighbourWidget_templateObject1, NeighbourWidget_templateObject10;

var NeighbourWidget_jsx = react.createElement;

















var NeighbourWidget_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase', undefined)
  };
};

var NeighbourWidget_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openNeighbourModal: function openNeighbourModal() {
      if (ownProps.dummyContent) {
        dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
          type: 'profile',
          componentProps: {
            type: 'neighbours',
            content: ownProps.dummyContent.modal
          }
        }));
      }
    }
  };
};

var NeighbourWidget = function NeighbourWidget(_ref) {
  var phase = _ref.phase,
      openNeighbourModal = _ref.openNeighbourModal,
      _ref$neighbours = _ref.neighbours,
      neighbours = _ref$neighbours === void 0 ? [] : _ref$neighbours,
      link = _ref.link;
  return NeighbourWidget_jsx(NeighbourWidget_Container, {
    "data-id": "dashboard_NeighbourWidget_Container"
  }, NeighbourWidget_jsx(NeighbourWidget_Header, {
    "data-id": "dashboard_NeighbourWidget_Header"
  }, NeighbourWidget_jsx(designElements_WidgetHeader, {
    title: "Ontmoet de nieuwe buren",
    subtitle: phase === 'cj1' ? 'Op deze plaats maak je straks kennis met alle nieuwe buurtbewoners.' : undefined,
    "data-id": "dashboard_NeighbourWidget_WidgetHeader"
  })), NeighbourWidget_jsx(WidgetScroller, {
    "data-id": "dashboard_NeighbourWidget_WidgetScroller"
  }, phase === 'cj1' ? NeighbourWidget_jsx(NeighbourWidget_IconWrapper, {
    onClick: openNeighbourModal,
    "data-id": "dashboard_NeighbourWidget_IconWrapper"
  }, NeighbourWidget_jsx(Neighbours, {
    "data-id": "dashboard_NeighbourWidget_NeighboursIcon"
  })) : (neighbours || []).map(function (neighbour, index) {
    return NeighbourWidget_jsx(NeighbourWidget_Neighbour, {
      key: index,
      "data-id": "dashboard_NeighbourWidget_Neighbour"
    }, NeighbourWidget_jsx(UserAvatar/* default */.Z, {
      size: "normal",
      mode: "imageLoader",
      name: neighbour.customerName,
      imageUrl: neighbour.customerImage,
      phase: phase,
      "data-id": "dashboard_NeighbourWidget_UserAvatar"
    }), NeighbourWidget_jsx(NeighbourWidget_Info, {
      "data-id": "dashboard_NeighbourWidget_Info"
    }, NeighbourWidget_jsx(NeighbourWidget_Name, {
      "data-id": "dashboard_NeighbourWidget_Name"
    }, neighbour.customerName ? neighbour.customerName : 'Toekomstige bewoner(s)'), NeighbourWidget_jsx(BNR, {
      "data-id": "dashboard_NeighbourWidget_BNR"
    }, "Bouwnummer ", neighbour.bnr)));
  })), NeighbourWidget_jsx(WidgetFooter, {
    "data-id": "dashboard_NeighbourWidget_WidgetFooter"
  }, phase === 'cj1' && NeighbourWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Lees meer",
    type: "button",
    clickHandler: openNeighbourModal,
    "data-id": "dashboard_NeighbourWidget_ButtonSecondary"
  }), (phase === 'cj2' || phase === 'cj3') && link && NeighbourWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Bekijk alle buren",
    type: "internalLink",
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(link),
    "data-id": "dashboard_NeighbourWidget_ButtonSecondary_13"
  })));
};

/* harmony default export */ var dashboard_NeighbourWidget = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(NeighbourWidget_mapStateToProps, NeighbourWidget_mapDispatchToProps)(NeighbourWidget)));
var NeighbourWidget_Container = styled_components_browser_esm["default"].div(NeighbourWidget_templateObject || (NeighbourWidget_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 400rem;\n  max-height: 470rem;\n  position: relative;\n  background-color: white;\n  padding: 0 24rem 0 0;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  > .scrollHeight {\n    height: 100%;\n\n    > svg {\n      position: absolute;\n      right: 0;\n      top: 0;\n    }\n  }\n\n  ", ";\n"])), breakpoints/* toBreakpoint.lg */.Hx.lg(NeighbourWidget_templateObject2 || (NeighbourWidget_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    max-height: 705rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(NeighbourWidget_templateObject3 || (NeighbourWidget_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0 0 24rem 0;\n    max-height: 470rem;\n    &:after {\n      content: '';\n      width: calc(100% + 40rem);\n      position: absolute;\n      height: 2rem;\n      bottom: 0;\n      left: -20rem;\n      background-color: ", "\n    }\n  "])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey), breakpoints/* fromBreakpoint.md */.ks.md(NeighbourWidget_templateObject4 || (NeighbourWidget_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 480rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(NeighbourWidget_templateObject5 || (NeighbourWidget_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 480rem;\n    margin-bottom: 0;\n    border-bottom: 0;\n    border-right: dashed 0.5rem #979797;\n  "]))));
var NeighbourWidget_Header = styled_components_browser_esm["default"].div(NeighbourWidget_templateObject6 || (NeighbourWidget_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 10rem;\n"])));
var NeighbourWidget_IconWrapper = styled_components_browser_esm["default"].div(NeighbourWidget_templateObject7 || (NeighbourWidget_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  &:hover {\n    cursor: pointer;\n  }\n\n  > svg {\n    align-self: center;\n    transform: scale(1.4);\n    position: absolute;\n    top: 40%;\n\n    ", ";\n  }\n"])), breakpoints/* toBreakpoint.md */.Hx.md(NeighbourWidget_templateObject8 || (NeighbourWidget_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: 37%;\n    "]))));
var NeighbourWidget_Info = styled_components_browser_esm["default"].div(NeighbourWidget_templateObject9 || (NeighbourWidget_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-left: 16rem;\n"])));
var NeighbourWidget_Name = styled_components_browser_esm["default"].div(NeighbourWidget_templateObject0 || (NeighbourWidget_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: bold;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var BNR = styled_components_browser_esm["default"].div(NeighbourWidget_templateObject1 || (NeighbourWidget_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var NeighbourWidget_Neighbour = styled_components_browser_esm["default"].div(NeighbourWidget_templateObject10 || (NeighbourWidget_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin-bottom: 20rem;\n"])));
;// CONCATENATED MODULE: ./src/components/shared/icons/Forum.js
var Forum_jsx = react.createElement;


var Forum_defaultProps = {
  color: styleGuide/* colorPalette.background */.K5.background
};

var Forum = function Forum(_ref) {
  var color = _ref.color;
  return Forum_jsx("svg", {
    width: "130px",
    height: "111px",
    viewBox: "0 0 130 111",
    version: "1.1",
    "data-id": "icons_Forum_svg"
  }, Forum_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Forum_g"
  }, Forum_jsx("g", {
    transform: "translate(-669.000000, -208.000000)",
    fill: color,
    "data-id": "icons_Forum_g_2"
  }, Forum_jsx("g", {
    "data-id": "icons_Forum_g_3"
  }, Forum_jsx("g", {
    transform: "translate(0.000000, 40.000000)",
    "data-id": "icons_Forum_g_4"
  }, Forum_jsx("g", {
    transform: "translate(669.000000, 168.000000)",
    "data-id": "icons_Forum_g_5"
  }, Forum_jsx("path", {
    d: "M122.961071,11.9498692 L122.961071,59.484837 C122.961071,62.4990642 120.503358,64.9584304 117.4888,64.9584304 L110.8536,64.9584304 C109.055507,64.9584304 107.601764,66.4118424 107.601764,68.2102664 L107.601764,81.2430564 L94.4890004,66.0942597 C93.8796116,65.380442 92.9810606,64.9842072 92.0296342,64.9842072 L37.0128,64.9842072 C33.9985728,64.9842072 31.5405285,62.5261629 31.5405285,59.5119357 L31.5405285,11.9498692 C31.5405285,8.9369639 33.9985728,6.4779282 37.0128,6.4779282 L117.4888,6.4779282 C120.503358,6.4779282 122.961071,8.9369639 122.961071,11.9498692 L122.961071,11.9498692 Z M37.0128,3.30471133e-05 C30.4291541,3.30471133e-05 25.0629638,5.36754519 25.0629638,11.9498692 L25.0629638,59.484837 C25.0629638,66.0684829 30.4291541,71.4346732 37.0128,71.4346732 L90.5749003,71.4346732 L105.672144,88.9109781 C106.596141,89.9681553 107.892249,90.5762222 109.293116,90.5762222 C111.936885,90.5762222 114.105436,88.4347692 114.105436,85.7910002 L114.105436,71.4617718 L117.515898,71.4617718 C124.098223,71.4617718 129.466065,66.0942597 129.466065,59.5119357 L129.466065,11.9498692 C129.466065,5.36754519 124.098223,3.30471133e-05 117.515898,3.30471133e-05 L37.0128,3.30471133e-05 Z",
    "data-id": "icons_Forum_path"
  }), Forum_jsx("path", {
    d: "M18.4805737,109.822431 C19.0357652,110.033933 19.6167334,110.140014 20.1715945,110.140014 C21.5205776,110.140014 22.8424622,109.559046 23.7681118,108.47444 L38.8640332,90.999787 L86.0282123,90.999787 C87.8266363,90.999787 89.2800483,89.5447226 89.2800483,87.7479511 C89.2800483,85.9495272 87.8266363,84.4961151 86.0282123,84.4961151 L37.383192,84.4961151 C36.4304437,84.4961151 35.5593218,84.89235 34.9241563,85.6061677 L21.8368385,100.80784 L21.8368385,87.7737278 C21.8368385,85.9753039 20.3834264,84.5218919 18.5850025,84.5218919 L11.9498031,84.5218919 C8.93557592,84.5218919 6.47786211,82.0628562 6.47786211,79.0496204 L6.47786211,31.5149831 C6.47786211,28.5004254 8.93557592,26.0413897 11.9498031,26.0413897 C13.748227,26.0413897 15.2016391,24.5879776 15.2016391,22.7895537 C15.2016391,20.9927822 13.748227,19.5648164 11.9498031,19.5648164 C5.36615721,19.5648164 -3.30471133e-05,24.9313371 -3.30471133e-05,31.5149831 L-3.30471133e-05,79.0496204 C-3.30471133e-05,85.6319444 5.36615721,90.999787 11.9498031,90.999787 L15.3605957,90.999787 L15.3605957,105.328685 C15.3605957,107.364387 16.576399,109.135382 18.4805737,109.822431",
    "data-id": "icons_Forum_path_7"
  }), Forum_jsx("path", {
    d: "M106.32294,21.8169111 L48.2066173,21.8169111 C46.4432234,21.8169111 45.0136052,23.2458683 45.0136052,25.0105841 C45.0136052,26.7739781 46.4432234,28.2029353 48.2066173,28.2029353 L106.32294,28.2029353 C108.086334,28.2029353 109.514961,26.7739781 109.514961,25.0105841 C109.514961,23.2458683 108.086334,21.8169111 106.32294,21.8169111",
    "data-id": "icons_Forum_path_8"
  }), Forum_jsx("path", {
    d: "M70.2628887,42.9284976 L48.2065843,42.9284976 C46.4431903,42.9284976 45.0139027,44.3587767 45.0139027,46.1221707 C45.0139027,47.8855646 46.4431903,49.3145218 48.2065843,49.3145218 L70.2628887,49.3145218 C72.0262826,49.3145218 73.4552398,47.8855646 73.4552398,46.1221707 C73.4552398,44.3587767 72.0262826,42.9284976 70.2628887,42.9284976",
    "data-id": "icons_Forum_path_9"
  })))))));
};

Forum.defaultProps = Forum_defaultProps;
/* harmony default export */ var icons_Forum = (Forum);
;// CONCATENATED MODULE: ./src/services/calculateDays.js
/* harmony default export */ var calculateDays = (function (date) {
  if (!date) return '';
  var today = new Date();
  var dateTransformed = new Date(date.replace(' ', 'T')); // for Safari as it only accepts formats like this '2018-05-02T14:00:00'

  var differenceInHours = Math.floor(Math.abs((today.getTime() - dateTransformed.getTime()) / (60 * 60 * 1000)));

  if (differenceInHours < 24) {
    return "".concat(differenceInHours, " uur geleden");
  } else if (differenceInHours >= 24 && differenceInHours < 48) {
    return "".concat(Math.floor(Math.abs((today.getTime() - dateTransformed.getTime()) / (24 * 60 * 60 * 1000))), " dag geleden");
  } else {
    return "".concat(Math.floor(Math.abs((today.getTime() - dateTransformed.getTime()) / (24 * 60 * 60 * 1000))), " dagen geleden");
  }
});
;// CONCATENATED MODULE: ./src/components/dashboard/ForumWidget.js


var ForumWidget_templateObject, ForumWidget_templateObject2, ForumWidget_templateObject3, ForumWidget_templateObject4, ForumWidget_templateObject5, ForumWidget_templateObject6, ForumWidget_templateObject7, ForumWidget_templateObject8, ForumWidget_templateObject9, ForumWidget_templateObject0, ForumWidget_templateObject1;

var ForumWidget_jsx = react.createElement;



















var ForumWidget_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase', {})
  };
};

var ForumWidget_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openModal: function openModal() {
      if (ownProps.dummyContent) {
        dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
          type: 'profile',
          componentProps: {
            type: 'topics',
            content: ownProps.dummyContent.modal
          }
        }));
      }
    }
  };
};

var ForumWidget = function ForumWidget(_ref) {
  var link = _ref.link,
      phase = _ref.phase,
      openModal = _ref.openModal,
      _ref$topics = _ref.topics,
      topics = _ref$topics === void 0 ? [] : _ref$topics,
      renderWidth = _ref.renderWidth;
  var router = (0,next_router.useRouter)();
  return ForumWidget_jsx(ForumWidget_Container, {
    "data-id": "dashboard_ForumWidget_Container"
  }, ForumWidget_jsx(designElements_WidgetHeader, {
    title: "Onderwerp van gesprek op het forum",
    subtitle: phase === 'cj1' ? 'Vanaf deze plaats heb je straks toegang tot het forum, waar je vragen en ervaringen met de nieuwe buurtbewoners kunt delen.' : 'Bekijk hier de laatste actieve topics op het forum.',
    "data-id": "dashboard_ForumWidget_WidgetHeader"
  }), ForumWidget_jsx(WidgetScroller, {
    "data-id": "dashboard_ForumWidget_WidgetScroller"
  }, phase === 'cj1' && ForumWidget_jsx(ForumWidget_IconWrapper, {
    onClick: openModal,
    "data-id": "dashboard_ForumWidget_IconWrapper"
  }, ForumWidget_jsx(icons_Forum, {
    "data-id": "dashboard_ForumWidget_ForumIcon"
  })), topics && topics.length > 0 && link && topics.map(function (topic, index) {
    return ForumWidget_jsx(Topic, {
      key: index,
      border: index !== 0,
      last: index === (topics && topics.length - 1),
      onClick: function onClick() {
        return router === null || router === void 0 ? void 0 : router.push('/' + (0,getLinkFromPageObject/* default */.Z)(link));
      },
      "data-id": "dashboard_ForumWidget_Topic"
    }, ForumWidget_jsx(TopicTitle, {
      "data-id": "dashboard_ForumWidget_TopicTitle"
    }, truncateText(topic.title, renderWidth > 1097 ? 68 : 38)), ForumWidget_jsx(Last, {
      "data-id": "dashboard_ForumWidget_Last"
    }, ForumWidget_jsx("span", {
      "data-id": "dashboard_ForumWidget_span"
    }, "Laatste reactie: "), ForumWidget_jsx("span", {
      "data-id": "dashboard_ForumWidget_span_9"
    }, topic.lastreaction), ForumWidget_jsx(ForumWidget_Divider, {
      "data-id": "dashboard_ForumWidget_Divider"
    }, "|"), ForumWidget_jsx("span", {
      "data-id": "dashboard_ForumWidget_span"
    }, calculateDays(topic.date)), ForumWidget_jsx(ForumWidget_Divider, {
      "data-id": "dashboard_ForumWidget_Divider"
    }, "|"), ForumWidget_jsx("span", {
      "data-id": "dashboard_ForumWidget_span"
    }, topic.replies, " ", topic.replies === 1 ? 'reactie' : 'reacties')));
  })), ForumWidget_jsx(WidgetFooter, {
    "data-id": "dashboard_ForumWidget_WidgetFooter"
  }, phase === 'cj1' && ForumWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Lees meer",
    type: "button",
    clickHandler: openModal,
    "data-id": "dashboard_ForumWidget_ButtonSecondary"
  }), (phase === 'cj2' || phase === 'cj3') && link && ForumWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Bekijk alle topics",
    type: "internalLink",
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(link),
    "data-id": "dashboard_ForumWidget_ButtonSecondary_16"
  })));
};

/* harmony default export */ var dashboard_ForumWidget = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(ForumWidget_mapStateToProps, ForumWidget_mapDispatchToProps)(ForumWidget)));
var ForumWidget_Container = styled_components_browser_esm["default"].div(ForumWidget_templateObject || (ForumWidget_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  min-height: 480rem;\n  background-color: white;\n  position: relative;\n  width: 100%;\n  padding: 0 0 0 24rem;\n\n  ", ";\n\n  > svg {\n    position: absolute;\n    bottom: -20rem;\n    right: -20rem;\n    width: 310rem;\n    height: 310rem;\n    z-index: -1;\n    ", ";\n  }\n"])), breakpoints/* toBreakpoint.md */.Hx.md(ForumWidget_templateObject2 || (ForumWidget_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 24rem 0 0 0;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(ForumWidget_templateObject3 || (ForumWidget_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: none;\n    "]))));
var ForumWidget_Divider = styled_components_browser_esm["default"].div(ForumWidget_templateObject4 || (ForumWidget_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  margin-right: 4rem;\n  ", ";\n"])), breakpoints/* toBreakpoint.lg */.Hx.lg(ForumWidget_templateObject5 || (ForumWidget_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: none;\n  "]))));
var Last = styled_components_browser_esm["default"].div(ForumWidget_templateObject6 || (ForumWidget_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  ", ";\n  color: ", ";\n  font-size: 12rem;\n\n  > span {\n    margin-right: 4rem;\n  }\n\n  ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* toBreakpoint.lg */.Hx.lg(ForumWidget_templateObject7 || (ForumWidget_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: column;\n  "]))));
var TopicTitle = styled_components_browser_esm["default"].div(ForumWidget_templateObject8 || (ForumWidget_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: bold;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var Topic = styled_components_browser_esm["default"].div(ForumWidget_templateObject9 || (ForumWidget_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top: ", ";\n  border-bottom: 1px dashed #979797;\n  padding: 14rem 0;\n  margin-bottom: ", ";\n  cursor: pointer;\n"])), function (props) {
  return props.border ? 'none' : '1px dashed #979797';
}, function (props) {
  return props.last ? '48rem' : 0;
});
var ForumWidget_IconWrapper = styled_components_browser_esm["default"].div(ForumWidget_templateObject0 || (ForumWidget_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  &:hover {\n    cursor: pointer;\n  }\n\n  > svg {\n    transform: scale(1.6);\n    position: absolute;\n    top: 42%;\n    ", ";\n  }\n"])), breakpoints/* toBreakpoint.md */.Hx.md(ForumWidget_templateObject1 || (ForumWidget_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: 50%;\n    "]))));
;// CONCATENATED MODULE: ./src/components/shared/icons/Brush.js
var Brush_jsx = react.createElement;


var Brush_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var Brush = function Brush(_ref) {
  var color = _ref.color;
  return Brush_jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    version: "1.1",
    "data-id": "icons_Brush_svg"
  }, Brush_jsx("title", {
    "data-id": "icons_Brush_title"
  }, "Brush Icon"), Brush_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-69.000000, -110.000000)",
    "data-id": "icons_Brush_g"
  }, Brush_jsx("g", {
    transform: "translate(42.000000, 100.000000)",
    fill: color,
    "data-id": "icons_Brush_g_3"
  }, Brush_jsx("g", {
    transform: "translate(27.000000, 10.000000)",
    "data-id": "icons_Brush_g_4"
  }, Brush_jsx("path", {
    d: "M11.5583849,13 L8,9.42306451 C8,9.42306451 11.0907532,8.17234374 12.1752829,7.08320938 C13.2587688,5.99407502 18.6772423,0.546304682 18.6772423,0.546304682 C18.6772423,0.546304682 19.7596843,-0.541780418 20.6490196,0.353240402 C21.5393987,1.24721196 20.454869,2.33529706 20.454869,2.33529706 C20.454869,2.33529706 15.0374394,7.78201813 13.9549973,8.87010323 C12.8704675,9.96133612 11.5583849,13 11.5583849,13",
    "data-id": "icons_Brush_path"
  }), Brush_jsx("path", {
    d: "M0,19.6984307 C2.59440423,18.9903499 2.34200743,16.6589963 3.8828018,12.5731637 C4.63999217,10.5649466 6.66405791,10 6.66405791,10 L10,13.6965508 C10,13.6965508 10,21.6242372 0,19.6984307",
    "data-id": "icons_Brush_path_6"
  })))));
};

Brush.defaultProps = Brush_defaultProps;
/* harmony default export */ var icons_Brush = (Brush);
;// CONCATENATED MODULE: ./src/components/shared/icons/Community.js
var Community_jsx = react.createElement;


var Community_defaultProps = {
  color: styleGuide/* colorPalette.white */.K5.white
};

var Community = function Community(_ref) {
  var color = _ref.color;
  return Community_jsx("svg", {
    width: "27px",
    height: "20px",
    viewBox: "0 0 27 20",
    version: "1.1",
    "data-id": "icons_Community_svg"
  }, Community_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_Community_g"
  }, Community_jsx("g", {
    transform: "translate(-140.000000, -60.000000)",
    fill: color,
    "data-id": "icons_Community_g_2"
  }, Community_jsx("g", {
    transform: "translate(130.000000, 50.000000)",
    "data-id": "icons_Community_g_3"
  }, Community_jsx("g", {
    "data-id": "icons_Community_g_4"
  }, Community_jsx("path", {
    d: "M31.668682,24.1664727 C31.668682,23.7708353 31.6478808,24.1824192 31.668682,24.1664727 M36.6676237,25.8332945 C36.6676237,24.9180557 36.3225031,23.5103362 34.7716138,22.6278052 C34.1259532,22.2604526 33.382518,22.5559875 32.5009183,23.3335273 L31.6675073,24.1669383 L31.6675073,29.1670547 L35.0008019,29.1670547 C36.2611613,29.1670547 36.6676237,28.7096098 36.6676237,27.5001164 C36.6690205,27.4869634 36.6676237,25.8478443 36.6676237,25.8332945 M15.0008019,24.1664727 C15.0216031,24.1824192 15.0008019,23.7708353 15.0008019,24.1664727 M11.8966953,22.6278052 C10.3456896,23.5103362 10.0005691,24.9180557 10.0005691,25.8332945 C10.0005691,25.8478443 9.99928868,27.4869634 10.0005691,27.5001164 C10.0005691,28.7096098 10.4071479,29.1665891 11.6675073,29.1665891 L15.0008019,29.1665891 L15.0008019,24.1664727 L14.1672745,23.3335273 C13.2857911,22.5559875 12.5422396,22.2604526 11.8966953,22.6278052 M31.674724,20.8227023 C32.3431987,20.8227023 34.172396,19.9556523 34.172396,18.1560201 L34.172396,16.8229118 C34.172396,15.0232796 32.8529063,14.1562296 31.674724,14.1562296 C30.5357679,14.1562296 29.1771684,15.0232796 29.1771684,16.8229118 L29.1771684,18.1560201 C29.1771684,19.9556523 31.0418671,20.8227023 31.674724,20.8227023 M29.9720515,24.156928 C29.9706547,24.143775 29.9670464,24.1314368 29.9656496,24.1187494 C29.9460947,23.9613791 29.916064,23.8081991 29.8747426,23.6576962 C29.8747426,23.6562995 29.8747426,23.6547863 29.8733459,23.6536223 C29.7860472,23.3338765 29.6386871,23.0261198 29.4186946,22.7227861 L29.4186946,22.7215057 C29.058093,22.222274 28.5138152,21.7130319 27.6295382,21.2160117 C27.1620832,20.9536502 26.956524,20.8331781 26.6673909,20.8331781 C26.2077345,20.8331781 25.8066264,21.1905205 25.1310514,21.8111556 L25.1296546,21.8111556 L24.5149559,22.3763851 C24.493073,22.3973368 23.8301854,23.3335273 23.3342128,23.3335273 C22.8381238,23.3335273 22.1752362,22.3973368 22.1533533,22.3763851 L21.5385381,21.8111556 L21.5372578,21.8111556 C20.8615664,21.1905205 20.4605746,20.8331781 20.0009183,20.8331781 C19.7117852,20.8331781 19.4538468,20.9536502 19.0386545,21.2160117 C18.1817312,21.7571468 17.6100997,22.2213428 17.2510114,22.7201089 L17.2494982,22.7205745 C17.2483342,22.7219713 17.2483342,22.7236009 17.246821,22.7251141 C17.029622,23.0261198 16.8836587,23.3321306 16.7968257,23.649432 C16.7953125,23.6522255 16.7940321,23.6553683 16.7926354,23.6586274 C16.7521288,23.8081991 16.7222145,23.9595167 16.7031252,24.1150247 C16.7017284,24.1295744 16.6976544,24.1433094 16.6961413,24.1573936 C16.6780996,24.3229118 16.6675073,24.4915728 16.6675073,24.6666356 C16.6675073,24.6861905 16.6670417,28.3163004 16.6675073,28.3331781 C16.6675073,29.5179952 17.1141271,30 18.334562,30 L28.3342128,30 C29.5651235,30 30.001151,29.543952 30.001151,28.3331781 C30.001151,28.3163004 30.0006855,24.6861905 30.0006855,24.6666356 C30.0006855,24.4915728 29.9902096,24.3229118 29.9720515,24.156928 M15.0080185,20.8227023 C15.6764933,20.8227023 17.5055742,19.9556523 17.5055742,18.1560201 L17.5055742,16.8229118 C17.5055742,15.0232796 16.1862009,14.1562296 15.0080185,14.1562296 C13.868946,14.1562296 12.5103465,15.0232796 12.5103465,16.8229118 L12.5103465,18.1560201 C12.5103465,19.9556523 14.3751617,20.8227023 15.0080185,20.8227023 M23.3342128,20.0111742 C25.6716045,20.0111742 27.4898604,17.5867166 27.4898604,15.0769392 L27.4898604,14.2903203 C27.4898604,11.7810085 25.6716045,10 23.3342128,10 C20.9961226,10 19.1784487,11.7805429 19.1784487,14.2903203 L19.1784487,15.0769392 C19.1784487,17.5867166 20.9961226,20.0111742 23.3342128,20.0111742",
    "data-id": "icons_Community_path"
  }))))));
};

Community.defaultProps = Community_defaultProps;
/* harmony default export */ var icons_Community = (Community);
;// CONCATENATED MODULE: ./src/components/shared/icons/House.js
var House_jsx = react.createElement;


var House_defaultProps = {
  color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
  width: 64,
  height: 64
};

var House = function House(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return House_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 64 64",
    "data-id": "icons_House_svg"
  }, House_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_House_g"
  }, House_jsx("g", {
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_House_g_2"
  }, House_jsx("path", {
    d: "M41,64 L41,38 L23,38 L23,64 L0,64 L0,19.1298905 L32,0 L64,19.2300469 L63.9,57.9906103 C63.9,61.2957746 61.2,64 57.9,64 L41,64 Z",
    "data-id": "icons_House_path"
  }))));
};

House.defaultProps = House_defaultProps;
/* harmony default export */ var icons_House = (House);
;// CONCATENATED MODULE: ./src/components/shared/designElements/WidgetContainer.js


var WidgetContainer_templateObject, WidgetContainer_templateObject2, WidgetContainer_templateObject3, WidgetContainer_templateObject4, WidgetContainer_templateObject5;

var WidgetContainer_jsx = react.createElement;











var WidgetContainer_defaultProps = {
  color: styleGuide/* colorPalette.blue */.K5.blue,
  caretColor: '#ffffff',
  size: 'normal'
};
var WidgetContainer_ICONMAPPING = {
  mail: icons_Message,
  action: icons_Actions,
  brush: icons_Brush,
  community: icons_Community,
  house: icons_House
};

var WidgetContainer = function WidgetContainer(_ref) {
  var icon = _ref.icon,
      size = _ref.size,
      label = _ref.label,
      children = _ref.children;
  var Icon = WidgetContainer_ICONMAPPING[icon] || WidgetContainer_ICONMAPPING['action'];
  return WidgetContainer_jsx(WidgetContainer_Container, {
    size: size,
    "data-id": "designElements_WidgetContainer_Container"
  }, WidgetContainer_jsx(WidgetContainer_Label, {
    icon: icon,
    "data-id": "designElements_WidgetContainer_Label"
  }, WidgetContainer_jsx(designElements_ThemeLabel, {
    label: label,
    theme: "projectUpdate",
    "data-id": "designElements_WidgetContainer_ThemeLabel"
  }), WidgetContainer_jsx(Icon, {
    color: styleGuide/* colorPalette.white */.K5.white,
    width: 18,
    height: 18,
    "data-id": "designElements_WidgetContainer_Icon"
  })), WidgetContainer_jsx(WidgetContainer_InnerContent, {
    "data-id": "designElements_WidgetContainer_InnerContent"
  }, children));
};

WidgetContainer.defaultProps = WidgetContainer_defaultProps;
/* harmony default export */ var designElements_WidgetContainer = (WidgetContainer);
var WidgetContainer_Container = styled_components_browser_esm["default"].div(WidgetContainer_templateObject || (WidgetContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(WidgetContainer_templateObject2 || (WidgetContainer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n  "])), function (props) {
  return props.size === 'normal' ? "\n      &:after {\n        content: '';\n        display: block;\n        width: 0;\n        height: 0;\n        position: absolute;\n        z-index: -1;\n        bottom: -20rem;\n        right: -20rem;\n        border-bottom: 310rem solid ".concat((0,utils/* hex2rgb */.wK)(styleGuide/* colorPalette.lightGrey */.K5.lightGrey, 0.65), ";\n        border-left: 310rem solid transparent};\n      }\n    ") : "";
}));
var WidgetContainer_InnerContent = styled_components_browser_esm["default"].div(WidgetContainer_templateObject3 || (WidgetContainer_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  padding: 20rem;\n  min-height: 300rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(WidgetContainer_templateObject4 || (WidgetContainer_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 20rem 30rem;\n  "]))));
var WidgetContainer_Label = styled_components_browser_esm["default"].div(WidgetContainer_templateObject5 || (WidgetContainer_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n\n  > div {\n    > span {\n      width: 240rem;\n      padding-left: 50rem;\n      padding-right: 41rem;\n    }\n  }\n\n  > svg {\n    position: absolute;\n    margin-top: 14rem;\n    margin-left: 20rem;\n\n    ", ";\n  }\n"])), function (props) {
  switch (props.icon) {
    case 'mail':
      return 'top: -1rem;';

    case 'community':
      return 'top: -4rem; left: -5rem;';

    case 'action':
    case 'brush':
    default:
      return 'top: -4rem;';
  }
});
;// CONCATENATED MODULE: ./src/components/dashboard/CommunityBlock.js


var CommunityBlock_templateObject, CommunityBlock_templateObject2, CommunityBlock_templateObject3, CommunityBlock_templateObject4;

var CommunityBlock_jsx = react.createElement;







var CommunityBlock = function CommunityBlock(_ref) {
  var neighbours = _ref.neighbours,
      topics = _ref.topics,
      renderWidth = _ref.renderWidth;
  return CommunityBlock_jsx(CommunityBlock_Container, {
    "data-e2e-block-community": true,
    "data-id": "dashboard_CommunityBlock_Container"
  }, CommunityBlock_jsx(designElements_WidgetContainer, {
    label: "Community",
    size: "normal",
    icon: "community",
    "data-id": "dashboard_CommunityBlock_WidgetContainer"
  }, CommunityBlock_jsx(Blocks, {
    "data-id": "dashboard_CommunityBlock_Blocks"
  }, CommunityBlock_jsx(dashboard_NeighbourWidget, {
    link: neighbours.link,
    neighbours: neighbours.neighbours,
    dummyContent: neighbours.dummyContent,
    "data-id": "dashboard_CommunityBlock_NeighbourWidget"
  }), CommunityBlock_jsx(dashboard_ForumWidget, {
    link: topics.link,
    topics: topics.topics,
    dummyContent: topics.dummyContent,
    renderWidth: renderWidth,
    "data-id": "dashboard_CommunityBlock_ForumWidget"
  }))));
};

/* harmony default export */ var dashboard_CommunityBlock = (CommunityBlock);
var CommunityBlock_Container = styled_components_browser_esm["default"].div(CommunityBlock_templateObject || (CommunityBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 40rem;\n"])));
var Blocks = styled_components_browser_esm["default"].div(CommunityBlock_templateObject2 || (CommunityBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: flex-start;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* toBreakpoint.md */.Hx.md(CommunityBlock_templateObject3 || (CommunityBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: column;\n    align-items: center;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(CommunityBlock_templateObject4 || (CommunityBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    > *:nth-child(1) {\n      width: 32%;\n    }\n    > *:nth-child(2) {\n      width: 68%;\n    }\n  "]))));
;// CONCATENATED MODULE: ./src/components/dashboard/ECWInterestsWidget.js


var ECWInterestsWidget_templateObject, ECWInterestsWidget_templateObject2, ECWInterestsWidget_templateObject3, ECWInterestsWidget_templateObject4, ECWInterestsWidget_templateObject5, ECWInterestsWidget_templateObject6;

var ECWInterestsWidget_jsx = react.createElement;













var ECWInterestsWidget_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openModal: function openModal() {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
        type: 'profile',
        componentProps: {
          type: 'interests',
          content: ownProps.experienceRating.modal
        }
      }));
    }
  };
};

var ECWInterestsWidget = function ECWInterestsWidget(_ref) {
  var experienceRating = _ref.experienceRating,
      openModal = _ref.openModal;
  var router = (0,next_router.useRouter)();
  var link = experienceRating && experienceRating.link ? (0,getLinkFromPageObject/* default */.Z)(experienceRating.link) : undefined;
  var buttonType = experienceRating.modal ? 'button' : 'internalLink';
  var buttonRoute = experienceRating.modal ? undefined : "/".concat(String(link));
  var buttonClickHandler = experienceRating.modal ? openModal : undefined;
  return ECWInterestsWidget_jsx(ECWInterestsWidget_Container, {
    "data-id": "dashboard_ECWInterestsWidget_Container"
  }, ECWInterestsWidget_jsx(designElements_WidgetHeader, {
    title: "Jouw interesses",
    subtitle: "Bekijk hier wat je interessant vond tijdens je bezoek(en) aan het Homestudios experience center.",
    "data-id": "dashboard_ECWInterestsWidget_WidgetHeader"
  }), ECWInterestsWidget_jsx(Image, {
    onClick: experienceRating.modal ? openModal : function () {
      return router === null || router === void 0 ? void 0 : router.push('/' + String(link));
    },
    "data-id": "dashboard_ECWInterestsWidget_Image"
  }, ECWInterestsWidget_jsx(ImageLoader/* default */.Z, {
    src: "/images/interestscollage.jpg",
    mode: "img",
    alt: "BAM Experience Center",
    "data-id": "dashboard_ECWInterestsWidget_ImageLoader"
  })), ECWInterestsWidget_jsx(WidgetFooter, {
    "data-id": "dashboard_ECWInterestsWidget_WidgetFooter"
  }, ECWInterestsWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Mijn interesses bekijken",
    type: buttonType,
    route: buttonRoute,
    clickHandler: buttonClickHandler,
    "data-id": "dashboard_ECWInterestsWidget_ButtonSecondary"
  })));
};

/* harmony default export */ var dashboard_ECWInterestsWidget = ((0,es/* connect */.$j)(null, ECWInterestsWidget_mapDispatchToProps)(ECWInterestsWidget));
var ECWInterestsWidget_Container = styled_components_browser_esm["default"].div(ECWInterestsWidget_templateObject || (ECWInterestsWidget_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-sizing: border-box;\n  margin-top: 30rem;\n  padding-top: 30rem;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), breakpoints/* toBreakpoint.lg */.Hx.lg(ECWInterestsWidget_templateObject2 || (ECWInterestsWidget_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    &:after {\n      content: '';\n      width: calc(100% + 40rem);\n      position: absolute;\n      height: 2rem;\n      top: 0;\n      left: -20rem;\n      background-color: ", "\n    }\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey), breakpoints/* fromBreakpoint.lg */.ks.lg(ECWInterestsWidget_templateObject3 || (ECWInterestsWidget_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(1/3 * 100%);\n    padding-left: 30rem;\n    margin-top: 0;\n    padding-top: 0;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(ECWInterestsWidget_templateObject4 || (ECWInterestsWidget_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(1/3 * 100%);\n    padding-left: 30rem;\n  "]))));
var Image = styled_components_browser_esm["default"].div(ECWInterestsWidget_templateObject5 || (ECWInterestsWidget_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-self: center;\n  width: 260rem;\n  height: auto;\n  margin-bottom: 60rem;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ECWInterestsWidget_templateObject6 || (ECWInterestsWidget_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 338rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/shared/icons/MakeWishList.js
var MakeWishList_jsx = react.createElement;


var MakeWishList_defaultProps = {
  color: styleGuide/* colorPalette.lightBlue */.K5.lightBlue,
  colorBrush: styleGuide/* colorPalette.blue */.K5.blue
};

var MakeWishList_Actions = function Actions(_ref) {
  var color = _ref.color,
      colorBrush = _ref.colorBrush;
  return MakeWishList_jsx("svg", {
    width: "133px",
    height: "133px",
    viewBox: "0 0 133 133",
    version: "1.1",
    "data-id": "icons_MakeWishList_svg"
  }, MakeWishList_jsx("title", {
    "data-id": "icons_MakeWishList_title"
  }, "Make Wishlist"), MakeWishList_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-511.000000, -290.000000)",
    "data-id": "icons_MakeWishList_g"
  }, MakeWishList_jsx("g", {
    transform: "translate(168.000000, 111.000000)",
    "data-id": "icons_MakeWishList_g_3"
  }, MakeWishList_jsx("g", {
    transform: "translate(277.000000, 179.000000)",
    "data-id": "icons_MakeWishList_g_4"
  }, MakeWishList_jsx("g", {
    transform: "translate(66.000000, 0.000000)",
    "data-id": "icons_MakeWishList_g_5"
  }, MakeWishList_jsx("path", {
    d: "M66.5,0 L133,39.9624413 L132.792188,120.511737 C132.792188,127.380282 127.18125,133 120.323438,133 L0,133 L0,39.7543036 L66.5,0 Z M66.5,12.0719875 L10.390625,45.5821596 L10.5984375,122.384977 L116.167188,122.593114 C119.7,122.593114 122.401563,119.887324 122.401563,116.348983 L122.401563,45.7902973 L66.5,12.0719875 Z",
    fill: color,
    "data-id": "icons_MakeWishList_path"
  }), MakeWishList_jsx("g", {
    transform: "translate(38.000000, 53.000000)",
    fill: colorBrush,
    "data-id": "icons_MakeWishList_g"
  }, MakeWishList_jsx("path", {
    d: "M27.2116574,31 L19,22.4703846 C19,22.4703846 26.1325073,19.4878966 28.6352683,16.8907301 C31.1356204,14.2935635 43.6397898,1.30272655 43.6397898,1.30272655 C43.6397898,1.30272655 46.1377331,-1.29193792 48.1900453,0.842342496 C50.2447662,2.97412082 47.7420053,5.56878529 47.7420053,5.56878529 C47.7420053,5.56878529 35.2402447,18.5571202 32.7423014,21.1517846 C30.2395405,23.7539554 27.2116574,31 27.2116574,31",
    "data-id": "icons_MakeWishList_path"
  }), MakeWishList_jsx("path", {
    d: "M0,47.3063907 C6.48601057,45.6778047 5.85501859,40.3156916 9.7070045,30.9182765 C11.5999804,26.2993772 16.6601448,25 16.6601448,25 L25,33.5020668 C25,33.5020668 25,51.7357456 0,47.3063907",
    "data-id": "icons_MakeWishList_path_9"
  })))))));
};

MakeWishList_Actions.defaultProps = MakeWishList_defaultProps;
/* harmony default export */ var MakeWishList = (MakeWishList_Actions);
;// CONCATENATED MODULE: ./src/components/dashboard/DesignsWidget.js








var DesignsWidget_templateObject, DesignsWidget_templateObject2, DesignsWidget_templateObject3, DesignsWidget_templateObject4, DesignsWidget_templateObject5, DesignsWidget_templateObject6, DesignsWidget_templateObject7, DesignsWidget_templateObject8, DesignsWidget_templateObject9, DesignsWidget_templateObject0, DesignsWidget_templateObject1, DesignsWidget_templateObject10, DesignsWidget_templateObject11, DesignsWidget_templateObject12, DesignsWidget_templateObject13, DesignsWidget_templateObject14, DesignsWidget_templateObject15, DesignsWidget_templateObject16, DesignsWidget_templateObject17, DesignsWidget_templateObject18, DesignsWidget_templateObject19, DesignsWidget_templateObject20;

var DesignsWidget_jsx = react.createElement;

function DesignsWidget_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, DesignsWidget_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function DesignsWidget_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (DesignsWidget_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
























var DesignsWidget_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'user', {}),
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase'),
    postWishListRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'postWishList', {
      projectSlug: String(ownProps.match.params.projectSlug)
    })
  };
};

var DesignsWidget_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    handleClick: function handleClick(evt, priceListBlockId, phase, user) {
      evt.preventDefault();

      if (phase === 'cj1') {
        dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.beige */.K5.beige, {
          type: 'pricelist',
          componentProps: {
            projectSlug: String(projectSlug),
            priceListBlockId: priceListBlockId
          }
        }));
      } else {
        // immediately start a new design for house that customer is bound to
        dispatch((0,apiData/* performApiRequest */.T4)('postWishList', {
          projectSlug: String(projectSlug)
        }, {
          house: user.customer && user.customer.houseId
        }));
      }
    },
    invalidateData: function invalidateData() {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getWishLists', {
        projectSlug: String(projectSlug)
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postWishList', {
        projectSlug: String(projectSlug)
      }));
    },
    openExplanationModal: function openExplanationModal(evt) {
      evt.preventDefault();
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
        type: 'deleteWishList',
        componentProps: {
          type: 'confirmation'
        }
      }));
    }
  };
};

var DesignsWidget = /*#__PURE__*/function (_Component) {
  function DesignsWidget() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, DesignsWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = DesignsWidget_callSuper(this, DesignsWidget, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      onHover: false
    });

    return _this;
  }

  (0,inherits/* default */.Z)(DesignsWidget, _Component);

  return (0,createClass/* default */.Z)(DesignsWidget, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          match = _this$props.match,
          router = _this$props.router,
          postWishListRequest = _this$props.postWishListRequest,
          invalidateData = _this$props.invalidateData;
      var projectSlug = match.params.projectSlug;

      if (postWishListRequest && postWishListRequest.networkStatus === 'success') {
        router === null || router === void 0 || router.push("/".concat(String(projectSlug), "/closed/homestudio/").concat(String(postWishListRequest.result)));
      }

      (0,onNetworkStatusChange/* default */.Z)({
        onSucces: invalidateData
      }, prevProps.postWishListRequest, postWishListRequest);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          match = _this$props2.match,
          wishlist = _this$props2.wishlist,
          phase = _this$props2.phase,
          user = _this$props2.user,
          openExplanationModal = _this$props2.openExplanationModal,
          handleClick = _this$props2.handleClick;
      var projectSlug = match.params.projectSlug;
      var whislistCount = wishlist.wishlists.length;
      var ownBNR = lodash_get_default()(user, 'customer.bnr', undefined);
      return DesignsWidget_jsx(react.Fragment, null, DesignsWidget_jsx(designElements_WidgetHeader, {
        title: "Woonontwerpen ".concat(whislistCount > 0 ? "(".concat(whislistCount, ")") : ''),
        "data-id": "dashboard_DesignsWidget_WidgetHeader"
      }), DesignsWidget_jsx(WidgetScroller, {
        "data-id": "dashboard_DesignsWidget_WidgetScroller"
      }, whislistCount > 0 ? DesignsWidget_jsx(Collection, {
        "data-id": "dashboard_DesignsWidget_Collection"
      }, wishlist.wishlists.slice(0, 3).map(function (wishlist, index) {
        return DesignsWidget_jsx(WishList, {
          key: index,
          notAvailable: ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer,
          "data-id": "dashboard_DesignsWidget_WishList"
        }, DesignsWidget_jsx(DesignsWidget_LinkElement, {
          "data-e2e-dashboard-designs-widget": true,
          href: "/".concat(String(projectSlug), "/closed/homestudio/").concat(wishlist.id),
          onClick: (ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer) ? openExplanationModal : undefined,
          "data-id": "dashboard_DesignsWidget_LinkElement"
        }, DesignsWidget_jsx(DesignsWidget_ImageContainer, {
          notAvailable: ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer,
          "data-id": "dashboard_DesignsWidget_ImageContainer"
        }, DesignsWidget_jsx(ImageLoader/* default */.Z, {
          src: lodash_get_default()(wishlist, 'image.image.src'),
          mode: "bg",
          alt: wishlist.house.variantCode,
          "data-id": "dashboard_DesignsWidget_ImageLoader"
        }), !(ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer) && DesignsWidget_jsx(icons_Favorite, {
          filled: wishlist.isFavorite,
          "data-id": "dashboard_DesignsWidget_FavoriteIcon"
        }), wishlist.house.status === 'sold' && DesignsWidget_jsx(DesignsWidget_PriceTagContainer, {
          "data-id": "dashboard_DesignsWidget_PriceTagContainer"
        }, !wishlist.house.hasCustomer && DesignsWidget_jsx(designElements_PriceTag, {
          isSold: true,
          mini: true,
          "data-id": "dashboard_DesignsWidget_PriceTag"
        }), (ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer) && DesignsWidget_jsx("div", {
          "data-id": "dashboard_DesignsWidget_div"
        }, DesignsWidget_jsx("p", {
          "data-id": "dashboard_DesignsWidget_p"
        }, "NIET MEER BESCHIKBAAR")))), DesignsWidget_jsx(InfoContainer, {
          "data-id": "dashboard_DesignsWidget_InfoContainer"
        }, DesignsWidget_jsx(TitleSmall, {
          "data-id": "dashboard_DesignsWidget_TitleSmall"
        }, wishlist.title), DesignsWidget_jsx(DesignsWidget_Description, {
          "data-id": "dashboard_DesignsWidget_Description"
        }, "Ontwerp voor bouwnummer ", wishlist.house.bnr), DesignsWidget_jsx(DesignsWidget_Price, {
          "data-id": "dashboard_DesignsWidget_Price"
        }, DesignsWidget_jsx(designElements_PriceTag, {
          price: wishlist.price,
          isSold: wishlist.house.status === 'sold',
          "data-id": "dashboard_DesignsWidget_PriceTag"
        })), DesignsWidget_jsx(Caption, {
          "data-id": "dashboard_DesignsWidget_Caption"
        }, "Dit bedrag is inclusief", ' ', formatPrice(Number(wishlist.totals.userWishTotal), {
          showDecimal: true
        }), ' ', "aan eigen woonwensen"))));
      })) : DesignsWidget_jsx(MakeWishlist, {
        onClick: function onClick(evt) {
          return handleClick(evt, wishlist.priceListBlockId, phase, user);
        },
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            onHover: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            onHover: false
          });
        },
        "data-id": "dashboard_DesignsWidget_MakeWishlist"
      }, DesignsWidget_jsx(CTAContainer, {
        "data-id": "dashboard_DesignsWidget_CTAContainer"
      }, DesignsWidget_jsx(MakeWishList, {
        color: this.state.onHover ? styleGuide/* colorPalette.darkBlue */.K5.darkBlue : styleGuide/* colorPalette.lightBlue */.K5.lightBlue,
        colorBrush: this.state.onHover ? styleGuide/* colorPalette.darkBlue */.K5.darkBlue : styleGuide/* colorPalette.blue */.K5.blue,
        "data-id": "dashboard_DesignsWidget_MakeWishListIcon"
      }), DesignsWidget_jsx(DesignsWidget_CreateCTA, {
        onHover: this.state.onHover,
        "data-id": "dashboard_DesignsWidget_CreateCTA"
      }, DesignsWidget_jsx(DesignsWidget_Icon, {
        onHover: this.state.onHover,
        "data-id": "dashboard_DesignsWidget_Icon"
      }, DesignsWidget_jsx(icons_Plus, {
        "data-id": "dashboard_DesignsWidget_PlusIcon"
      })), "Maak een nieuw woonontwerp")))), wishlist.link && whislistCount > 0 && DesignsWidget_jsx(WidgetFooter, {
        "data-id": "dashboard_DesignsWidget_WidgetFooter"
      }, DesignsWidget_jsx(ButtonSecondary/* default */.Z, {
        label: "Woonontwerpen beheren",
        type: "internalLink",
        route: '/' + (0,getLinkFromPageObject/* default */.Z)(wishlist.link),
        "data-id": "dashboard_DesignsWidget_ButtonSecondary"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var dashboard_DesignsWidget = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(DesignsWidget_mapStateToProps, DesignsWidget_mapDispatchToProps)(DesignsWidget)));
var CTAContainer = styled_components_browser_esm["default"].div(DesignsWidget_templateObject || (DesignsWidget_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n\n  #makeWishListOutline,\n  #makeWishListBrush {\n    transition: all 0.2s ease-in-out;\n  }\n"])));
var DesignsWidget_CreateCTA = styled_components_browser_esm["default"].div(DesignsWidget_templateObject2 || (DesignsWidget_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-flex;\n  width: 100%;\n  text-align: center;\n  ", ";\n  font-weight: bold;\n  text-decoration: none;\n  color: ", ";\n  transition: color 0.2s ease-in-out;\n  align-items: center;\n  justify-content: center;\n  margin-top: 45rem;\n\n  ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, function (props) {
  return props.onHover ? styleGuide/* colorPalette.darkBlue */.K5.darkBlue : styleGuide/* colorPalette.blue */.K5.blue;
}, breakpoints/* fromBreakpoint.md */.ks.md(DesignsWidget_templateObject3 || (DesignsWidget_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 70rem;\n  "]))));
var DesignsWidget_Icon = styled_components_browser_esm["default"].span(DesignsWidget_templateObject4 || (DesignsWidget_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 26rem;\n  height: 26rem;\n  background-color: ", ";\n  transition: background-color 0.2s ease-in-out;\n  box-sizing: border-box;\n  padding: 7rem;\n  margin-right: 12rem;\n  border-radius: 50%;\n"])), function (props) {
  return props.onHover ? styleGuide/* colorPalette.darkBlue */.K5.darkBlue : styleGuide/* colorPalette.lightBlue */.K5.lightBlue;
});
var MakeWishlist = styled_components_browser_esm["default"].div(DesignsWidget_templateObject5 || (DesignsWidget_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border: 1rem dashed ", ";\n  box-sizing: border-box;\n  background-color: #ffffff;\n  width: 100%;\n  min-height: 260rem;\n  margin-bottom: 20rem;\n  cursor: pointer;\n  display: flex;\n  align-item: center;\n  justify-content: center;\n\n  ", ";\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, breakpoints/* fromBreakpoint.md */.ks.md(DesignsWidget_templateObject6 || (DesignsWidget_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 392rem;\n  "]))));
var DesignsWidget_ImageContainer = styled_components_browser_esm["default"].div(DesignsWidget_templateObject7 || (DesignsWidget_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-shrink: 0;\n  width: 150rem;\n  height: 85rem;\n  margin-bottom: 15rem;\n  margin-right: 20rem;\n  position: relative;\n  overflow: hidden;\n\n  &:after {\n    content: '';\n    opacity: 0.1;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);\n  }\n\n  > svg {\n    position: absolute;\n    z-index: 1;\n    top: 10rem;\n    right: 10rem;\n  }\n\n  > div {\n    transition: transform 0.45s ease-in-out;\n    transform: scale(1);\n    &:nth-of-type(1) {\n      filter: ", ";\n    }\n  }\n\n  ", ";\n"])), function (props) {
  return props.notAvailable ? 'contrast(40%)' : 'contrast(100%)';
}, breakpoints/* fromBreakpoint.md */.ks.md(DesignsWidget_templateObject8 || (DesignsWidget_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 0;\n  "]))));
var DesignsWidget_PriceTagContainer = styled_components_browser_esm["default"].div(DesignsWidget_templateObject9 || (DesignsWidget_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  ", ";\n  font-weight: bold;\n  color: white;\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    > p {\n      margin-top: 0;\n      text-align: center;\n      margin-bottom: 0;\n      font-size: 12rem;\n      max-width: 100rem;\n    }\n  }\n"])), styleGuide/* textStyles.caption */.sq.caption);
var DesignsWidget_LinkElement = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(DesignsWidget_templateObject0 || (DesignsWidget_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  position: relative;\n  text-decoration: none;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", ";\n\n  ", ";\n\n  &:hover {\n    ", " > div {\n      transform: scale(1.1);\n    }\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(DesignsWidget_templateObject1 || (DesignsWidget_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: flex;\n    justify-content: flex-start;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(DesignsWidget_templateObject10 || (DesignsWidget_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-right: 130rem;\n  "]))), DesignsWidget_ImageContainer);
var InfoContainer = styled_components_browser_esm["default"].div(DesignsWidget_templateObject11 || (DesignsWidget_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(DesignsWidget_templateObject12 || (DesignsWidget_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-right: 120rem;\n  "]))));
var TitleSmall = styled_components_browser_esm["default"].h4(DesignsWidget_templateObject13 || (DesignsWidget_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  margin-top: 0;\n  margin-bottom: 10rem;\n  color: ", ";\n  font-weight: bold;\n  font-size: 18rem;\n  line-height: 26rem;\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.orange */.K5.orange);
var DesignsWidget_Description = styled_components_browser_esm["default"].p(DesignsWidget_templateObject14 || (DesignsWidget_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 14rem;\n  line-height: 20rem;\n  color: ", ";\n  font-family: ", ";\n  margin-top: 0;\n  margin-bottom: 10rem;\n"])), styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* fonts.primary */.Rq.primary);
var DesignsWidget_Price = styled_components_browser_esm["default"].div(DesignsWidget_templateObject15 || (DesignsWidget_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 8rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(DesignsWidget_templateObject16 || (DesignsWidget_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: absolute;\n    bottom: 10rem;\n    right: 0;\n  "]))));
var Caption = styled_components_browser_esm["default"].span(DesignsWidget_templateObject17 || (DesignsWidget_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-style: italic;\n  font-size: 12rem;\n  line-height: 16rem;\n  color: ", ";\n  display: block;\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.beige */.K5.beige);
var Collection = styled_components_browser_esm["default"].div(DesignsWidget_templateObject18 || (DesignsWidget_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-height: 210rem;\n  overflow: hidden;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(DesignsWidget_templateObject19 || (DesignsWidget_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 190rem;\n  "]))));
var WishList = styled_components_browser_esm["default"].div(DesignsWidget_templateObject20 || (DesignsWidget_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top: 1rem dashed ", ";\n  padding: 15rem 0;\n  filter: ", ";\n\n  &:last-of-type {\n    border-bottom: 1rem dashed ", ";\n    margin-bottom: 60rem;\n  }\n"])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige, function (props) {
  return props.notAvailable ? 'grayscale(100%)' : 'grayscale(0%)';
}, styleGuide/* colorPalette.lightBeige */.K5.lightBeige);
;// CONCATENATED MODULE: ./src/components/dashboard/DesignsBlock.js


var DesignsBlock_templateObject, DesignsBlock_templateObject2, DesignsBlock_templateObject3, DesignsBlock_templateObject4, DesignsBlock_templateObject5, DesignsBlock_templateObject6;

var DesignsBlock_jsx = react.createElement;









var WishlistBlock = function WishlistBlock(_ref) {
  var wishlist = _ref.wishlist,
      experienceRating = _ref.experienceRating;
  return DesignsBlock_jsx(DesignsBlock_Container, {
    "data-e2e-block-wishlist": true,
    "data-id": "dashboard_DesignsBlock_Container"
  }, DesignsBlock_jsx(designElements_WidgetContainer, {
    label: "Ontwerpen",
    size: "normal",
    icon: "brush",
    "data-id": "dashboard_DesignsBlock_WidgetContainer"
  }, DesignsBlock_jsx(BlocksContainer, {
    "data-id": "dashboard_DesignsBlock_BlocksContainer"
  }, DesignsBlock_jsx(DesignsBlock_Block, {
    "data-id": "dashboard_DesignsBlock_Block"
  }, DesignsBlock_jsx(dashboard_DesignsWidget, {
    wishlist: wishlist,
    "data-id": "dashboard_DesignsBlock_DesignsWidget"
  })), DesignsBlock_jsx(dashboard_ECWInterestsWidget, {
    experienceRating: experienceRating,
    "data-id": "dashboard_DesignsBlock_ECWInterestsWidget"
  }))));
};

/* harmony default export */ var DesignsBlock = ((0,withMatch/* default */.Z)(WishlistBlock));
var DesignsBlock_Container = styled_components_browser_esm["default"].div(DesignsBlock_templateObject || (DesignsBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var BlocksContainer = styled_components_browser_esm["default"].div(DesignsBlock_templateObject2 || (DesignsBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  ", ";\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(DesignsBlock_templateObject3 || (DesignsBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: row;\n  "]))));
var DesignsBlock_Block = styled_components_browser_esm["default"].div(DesignsBlock_templateObject4 || (DesignsBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  position: relative;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(DesignsBlock_templateObject5 || (DesignsBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(2/3 * 100%);\n    border-right: 1rem dashed ", ";\n    padding-right: 30rem;\n  "])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige), breakpoints/* fromBreakpoint.xl */.ks.xl(DesignsBlock_templateObject6 || (DesignsBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    border-right: 1rem dashed ", ";\n    padding-right: 30rem;\n  "])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige));
;// CONCATENATED MODULE: ./src/components/dashboard/NeighboursBlock.js


var NeighboursBlock_templateObject, NeighboursBlock_templateObject2, NeighboursBlock_templateObject3, NeighboursBlock_templateObject4, NeighboursBlock_templateObject5, NeighboursBlock_templateObject6, NeighboursBlock_templateObject7, NeighboursBlock_templateObject8, NeighboursBlock_templateObject9, NeighboursBlock_templateObject0, NeighboursBlock_templateObject1, NeighboursBlock_templateObject10, NeighboursBlock_templateObject11, NeighboursBlock_templateObject12, NeighboursBlock_templateObject13, NeighboursBlock_templateObject14, NeighboursBlock_templateObject15, NeighboursBlock_templateObject16, NeighboursBlock_templateObject17, NeighboursBlock_templateObject18, NeighboursBlock_templateObject19, NeighboursBlock_templateObject20, NeighboursBlock_templateObject21, NeighboursBlock_templateObject22, NeighboursBlock_templateObject23, NeighboursBlock_templateObject24, NeighboursBlock_templateObject25, NeighboursBlock_templateObject26;

var NeighboursBlock_jsx = react.createElement;










var NeighboursBlock = function NeighboursBlock(_ref) {
  var selfPerson = _ref.self,
      match = _ref.match,
      _ref$neighbours = _ref.neighbours,
      neighbours = _ref$neighbours === void 0 ? [] : _ref$neighbours;
  return NeighboursBlock_jsx(NeighboursBlock_Container, {
    "data-e2e-block-neighbours": true,
    "data-id": "dashboard_NeighboursBlock_Container"
  }, selfPerson && NeighboursBlock_jsx(Self, {
    "data-id": "dashboard_NeighboursBlock_Self"
  }, NeighboursBlock_jsx(NeighboursBlock_UserImage, {
    "data-id": "dashboard_NeighboursBlock_UserImage"
  }, selfPerson.customerImage && NeighboursBlock_jsx(ImageLoader/* default */.Z, {
    src: selfPerson.customerImage,
    position: "relative",
    mode: "bg",
    width: 200,
    height: 200,
    alt: selfPerson.customerName,
    "data-id": "dashboard_NeighboursBlock_ImageLoader"
  }), (!selfPerson.publicProfile || !selfPerson.customerImage) && NeighboursBlock_jsx(PlaceholderUserCJ/* default */.Z, {
    width: 80,
    height: 80,
    color: styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
    "data-id": "dashboard_NeighboursBlock_PlaceholderUserCJ"
  })), !selfPerson.publicProfile && NeighboursBlock_jsx(Hide, {
    "data-id": "dashboard_NeighboursBlock_Hide"
  }, NeighboursBlock_jsx(Check/* default */.Z, {
    color: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
    "data-id": "dashboard_NeighboursBlock_Check"
  }), "Huishouden anoniem voor buren"), NeighboursBlock_jsx(UserName, {
    "data-id": "dashboard_NeighboursBlock_UserName"
  }, selfPerson.customerName || 'Toekomstige bewoner(s)'), NeighboursBlock_jsx(NeighboursBlock_BNR, {
    "data-id": "dashboard_NeighboursBlock_BNR"
  }, "Bouwnummer ", selfPerson.bnr), NeighboursBlock_jsx(NeighboursBlock_Intro, {
    "data-id": "dashboard_NeighboursBlock_Intro"
  }, selfPerson.publicProfile ? selfPerson.bio : ''), NeighboursBlock_jsx(ButtonSecondary/* default */.Z, {
    label: "Profielinformatie aanpassen",
    type: "externalLink",
    link: "/".concat(String(match.params.projectSlug), "/closed/profiel/"),
    "data-id": "dashboard_NeighboursBlock_ButtonSecondary"
  })), neighbours && NeighboursBlock_jsx(NeighboursContainer, {
    "data-id": "dashboard_NeighboursBlock_NeighboursContainer"
  }, neighbours.map(function (neighbour, index) {
    return NeighboursBlock_jsx(NeighboursBlock_Block, {
      key: index,
      oneBeforeLast: neighbours.length % 2 === 0 && index === neighbours.length - 2,
      last: neighbours.length % 2 === 1 ? index === neighbours.length - 1 : index === neighbours.length - 1 || index === neighbours.length - 2,
      "data-id": "dashboard_NeighboursBlock_Block"
    }, NeighboursBlock_jsx(NeighbourImage, {
      "data-id": "dashboard_NeighboursBlock_NeighbourImage"
    }, neighbour.customerImage && NeighboursBlock_jsx(ImageLoader/* default */.Z, {
      src: neighbour.customerImage,
      position: "relative",
      mode: "bg",
      width: 200,
      height: 200,
      alt: neighbour.customerName,
      "data-id": "dashboard_NeighboursBlock_ImageLoader"
    }), (!neighbour.publicProfile || !neighbour.customerImage) && NeighboursBlock_jsx(PlaceholderUserCJ/* default */.Z, {
      width: 64,
      height: 64,
      color: styleGuide/* colorPalette.lightOrange */.K5.lightOrange,
      "data-id": "dashboard_NeighboursBlock_PlaceholderUserCJ"
    })), NeighboursBlock_jsx("div", {
      "data-id": "dashboard_NeighboursBlock_div"
    }, NeighboursBlock_jsx(UserName, {
      "data-id": "dashboard_NeighboursBlock_UserName"
    }, neighbour.customerName || 'Toekomstige bewoner(s)'), NeighboursBlock_jsx(NeighboursBlock_BNR, {
      "data-id": "dashboard_NeighboursBlock_BNR"
    }, "Bouwnummer ", neighbour.bnr), NeighboursBlock_jsx(Bio, {
      "data-id": "dashboard_NeighboursBlock_Bio"
    }, !neighbour.publicProfile ? '' : neighbour.bio === 'Stel jezelf of jouw gezin hier voor aan je toekomstige buren.' ? '' : neighbour.bio)));
  })));
};

/* harmony default export */ var dashboard_NeighboursBlock = ((0,withMatch/* default */.Z)(NeighboursBlock));
var NeighboursBlock_Container = styled_components_browser_esm["default"].div(NeighboursBlock_templateObject || (NeighboursBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  background-color: white;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 60rem;\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary);
var NeighboursContainer = styled_components_browser_esm["default"].div(NeighboursBlock_templateObject2 || (NeighboursBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-flow: wrap;\n  position: relative;\n\n  :before {\n    content: '';\n    height: 100%;\n    border: dashed 0.5rem #979797;\n    position: absolute;\n    top: 0;\n    right: 50%;\n    display: block;\n\n    ", ";\n  }\n\n  ", ";\n"])), breakpoints/* toBreakpoint.md */.Hx.md(NeighboursBlock_templateObject3 || (NeighboursBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: none;\n    "]))), breakpoints/* toBreakpoint.md */.Hx.md(NeighboursBlock_templateObject4 || (NeighboursBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: column;\n  "]))));
var NeighboursBlock_Block = styled_components_browser_esm["default"].div(NeighboursBlock_templateObject5 || (NeighboursBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  border-bottom: ", ";\n  width: calc(50% - 40rem);\n  padding-right: 40rem;\n  padding-top: 40rem;\n  padding-bottom: 60rem;\n  ", " ", ";\n"])), function (props) {
  return props.last ? 'none' : 'dashed 1px #979797';
}, breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject6 || (NeighboursBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-right: 10rem;\n    padding-bottom: 30rem;\n    padding-top: 24rem;\n    width: calc(50% - 10rem);\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(NeighboursBlock_templateObject7 || (NeighboursBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-right: 20rem;\n    width: calc(100% - 20rem);\n    border-bottom: ", ";\n  "])), function (props) {
  return !props.last ? 'dashed 1px #979797' : props.oneBeforeLast ? 'dashed 1px #979797' : 'none';
}));
var Bio = styled_components_browser_esm["default"].p(NeighboursBlock_templateObject8 || (NeighboursBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: normal;\n  margin-top: 20rem;\n  ", ";\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject9 || (NeighboursBlock_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-left: -60rem;\n  "]))));
var Hide = styled_components_browser_esm["default"].div(NeighboursBlock_templateObject0 || (NeighboursBlock_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  margin-top: 20rem;\n  > svg {\n    margin-right: 5rem;\n  }\n\n  ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.beige */.K5.beige, breakpoints/* fromBreakpoint.md */.ks.md(NeighboursBlock_templateObject1 || (NeighboursBlock_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: absolute;\n    top: 4rem;\n    right: 32rem;\n  "]))));
var NeighboursBlock_Intro = styled_components_browser_esm["default"].p(NeighboursBlock_templateObject10 || (NeighboursBlock_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  ", ";\n  color: ", ";\n  font-style: italic;\n  font-weight: normal;\n  text-align: center;\n  margin-top: 20rem;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var NeighboursBlock_BNR = styled_components_browser_esm["default"].h3(NeighboursBlock_templateObject11 || (NeighboursBlock_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  font-weight: normal;\n  margin-top: 0;\n  margin-bottom: 0;\n"])), styleGuide/* textStyles.subTitle */.sq.subTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var UserName = styled_components_browser_esm["default"].h2(NeighboursBlock_templateObject12 || (NeighboursBlock_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-bottom: 5rem;\n  word-break: break-word;\n  ", ";\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject13 || (NeighboursBlock_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 2rem;\n  "]))));
var Self = styled_components_browser_esm["default"].div(NeighboursBlock_templateObject14 || (NeighboursBlock_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 60rem;\n  padding-right: 32rem;\n  padding-left: 32rem;\n  position: relative;\n  border-bottom: dashed 1px #979797;\n  ", ";\n\n  > a {\n    align-self: center;\n  }\n"])), breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject15 || (NeighboursBlock_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-bottom: 40rem;\n  "]))));
var NeighboursBlock_UserImage = styled_components_browser_esm["default"].div(NeighboursBlock_templateObject16 || (NeighboursBlock_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 180rem;\n  width: 180rem;\n  overflow: hidden;\n  border-radius: 50%;\n  border: 4px solid white;\n  background-color: ", ";\n  margin-top: -60rem;\n\n  ", " ", "\n\n  > div > div {\n    border-radius: 50%;\n    width: 180rem;\n    height: 180rem;\n    ", " ", ";\n  }\n\n  > svg {\n    margin-top: -12rem;\n    ", " ", ";\n  }\n"])), styleGuide/* colorPalette.loadingOrange */.K5.loadingOrange, breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject17 || (NeighboursBlock_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 120rem;\n    height: 120rem;\n    margin-top: -40rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(NeighboursBlock_templateObject18 || (NeighboursBlock_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 80rem;\n    height: 80rem;\n    margin-top: -20rem;\n  "]))), breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject19 || (NeighboursBlock_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: 120rem;\n      height: 120rem;\n    "]))), breakpoints/* toBreakpoint.md */.Hx.md(NeighboursBlock_templateObject20 || (NeighboursBlock_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: 80rem;\n      height: 80rem;\n    "]))), breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject21 || (NeighboursBlock_templateObject21 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-top: -8rem;\n      width: 53px !important;\n      height: 53px !important;\n    "]))), breakpoints/* toBreakpoint.md */.Hx.md(NeighboursBlock_templateObject22 || (NeighboursBlock_templateObject22 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-top: -4rem;\n      width: 35px !important;\n      height: 35px !important;\n    "]))));
var NeighbourImage = styled_components_browser_esm["default"].div(NeighboursBlock_templateObject23 || (NeighboursBlock_templateObject23 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 140rem;\n  width: 140rem;\n  min-width: 140rem;\n  overflow: hidden;\n  margin-right: 20rem;\n  margin-left: 40rem;\n  border-radius: 50%;\n  border: 4px solid white;\n  background-color: ", ";\n\n  ", ";\n\n  > div > div {\n    border-radius: 50%;\n    width: 140rem;\n    height: 140rem;\n    ", ";\n  }\n\n  > svg {\n    margin-top: -8rem;\n    ", ";\n  }\n"])), styleGuide/* colorPalette.loadingOrange */.K5.loadingOrange, breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject24 || (NeighboursBlock_templateObject24 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 60rem;\n    height: 60rem;\n    min-width: 60rem;\n    margin-right: 10rem;\n    margin-left: 10rem;\n  "]))), breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject25 || (NeighboursBlock_templateObject25 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: 60rem;\n      height: 60rem;\n    "]))), breakpoints/* toBreakpoint.lg */.Hx.lg(NeighboursBlock_templateObject26 || (NeighboursBlock_templateObject26 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-top: -4rem;\n      width: 30px !important;\n      height: 30px !important;\n    "]))));
// EXTERNAL MODULE: ./src/components/dashboard/utils/getProfileFormDefinitionCJ1.js
var getProfileFormDefinitionCJ1 = __webpack_require__(68719);
;// CONCATENATED MODULE: ./src/services/formatPhoneNumbersToBBCodeString.js
/* harmony default export */ var formatPhoneNumbersToBBCodeString = (function (phone, mobile) {
  var phoneString = phone ? "Tel. ".concat(phone) : undefined;
  var mobileString = mobile ? "Mob. ".concat(mobile) : undefined;

  if (phoneString && mobileString) {
    return "".concat(phoneString, "[br][/br]").concat(mobileString);
  }

  if (phoneString) {
    return phoneString;
  }

  if (mobileString) {
    return mobileString;
  }

  return '[i]Geen telefoongegevens bekend[/i]';
});
;// CONCATENATED MODULE: ./src/services/formatAddressElementsToBBCodeString.js
/* harmony default export */ var formatAddressElementsToBBCodeString = (function (address, addressHousenumber, addressHousenumberAddition, postalCode, city) {
  var contactString = 'Neem contact op met je woonadviseur om je adresgegevens compleet te maken.';

  if (address && addressHousenumber && postalCode && city) {
    return "\n      ".concat(address, " ").concat(addressHousenumber, " ").concat(addressHousenumberAddition || '', "[br][/br]\n      ").concat(postalCode, " ").concat(city, "\n    ");
  }

  if (address || addressHousenumber || postalCode || addressHousenumberAddition || city) {
    return "[i]Jouw adresgegevens zijn niet volledig. ".concat(contactString, "[/i]");
  }

  return "[i]Geen adresgegevens bekend. ".concat(contactString, "[/i]");
});
;// CONCATENATED MODULE: ./src/components/dashboard/utils/getProfileFormDefinitionCJ2.js

/* eslint-disable no-useless-computed-key */

/*
  PLEASE NOTE:
  The ProfileForm.js component styles certain form elements in this definition based on their class name.
  So if you decide to make changes to this form definition file, please check the ProfileForm component,
  and the styling of the profile form in the frontend to make sure everything still looks okay.

*/



/* harmony default export */ var getProfileFormDefinitionCJ2 = (function (link, _ref) {
  var address = _ref.address,
      addressHousenumber = _ref.addressHousenumber,
      addressHousenumberAddition = _ref.addressHousenumberAddition,
      postalCode = _ref.postalCode,
      city = _ref.city,
      phone = _ref.phone,
      mobile = _ref.mobile,
      users = _ref.users;
  var phoneString = formatPhoneNumbersToBBCodeString(phone, mobile);
  var addressString = formatAddressElementsToBBCodeString(address, addressHousenumber, addressHousenumberAddition, postalCode, city);
  return [{
    categoryTitle: 'Huishouden',
    categoryDescription: "Met je huishouden communiceer je direct met de homestudios Woonadviseur, kun je jezelf alvast voorstellen aan je toekomstige buren en kun je meepraten op het forum. Blijf je liever nog even anoniem? Vink dan de optie 'Houd mijn huishouden anoniem' aan. Je bouwnummer is dan het enige dat zichtbaar is voor anderen.",
    options: [{
      id: 'customerName',
      name: 'customerName',
      label: 'Naam van het huishouden',
      required: true,
      maxLength: 60,
      title: 'Naam van het huishouden',
      type: 'text'
    }, {
      id: 'customerImage',
      name: 'customerImage',
      label: 'Foto van het huishouden',
      title: 'Foto van het huishouden',
      type: 'imageUpload',
      required: false,
      excludeFromSubmit: true,
      uploadType: 'customer'
    }, {
      id: 'bio',
      name: 'bio',
      label: 'Introductie van het huishouden',
      required: false,
      title: 'Introductie van het huishouden',
      type: 'textarea'
    }, {
      id: 'anonymous',
      name: 'anonymous',
      label: 'Houd mijn huishouden anoniem',
      required: false,
      title: '',
      type: 'checkbox',
      choices: [{
        key: 'anonymous',
        value: 'Houd mijn huishouden anoniem'
      }]
    }, {
      id: 'familyMakeup',
      type: 'readOnly',
      name: 'familyMakeup',
      title: '',
      label: "[h4]Het huishouden van...[/h4][p]Hieronder tonen we alle homestudios accounts die toegang hebben tot het dashboard. Zie je iets dat niet klopt? Neem dan contact op met je woonadviseur.[/p]",
      excludeFromSubmit: true
    }, {
      id: 'users',
      type: 'users',
      name: 'users',
      title: '',
      excludeFromSubmit: true,
      link: {
        link: link,
        label: 'Huishouden wijzigen'
      }
    }]
  }, {
    categoryTitle: 'Communicatie met Homestudios',
    categoryDescription: "",
    options: [{
      id: 'contactInformation',
      name: 'contactInformation',
      type: 'readOnly',
      title: '',
      label: "\n            [p]Je woonadviseur van Homestudios neemt op verschillende momenten tijdens het proces contact met je op. Hiervoor gebruiken ze onderstaande gegevens. Zijn je contactgegevens gewijzigd of wil je ze graag aanpassen? [pagenode=\"0\" type=\"link\"]Stuur dan een bericht[/pagenode] of neem contact op met je woonadviseur.[/p]\n            [p][strong]Adresgegevens[/strong][br][/br]".concat(addressString, "[/p]\n            [p][strong]E-mailadressen[/strong][br][/br]").concat((users || []).map(function (user) {
        return "".concat(user.email);
      }).join('[br][/br]'), "[/p]\n            [p][strong]Telefoongegevens[/strong][br][/br]").concat(phoneString, "[/p]\n            [p][strong][pagenode=\"0\" type=\"link\"]Contactgegevens wijzigen[/pagenode][/strong][/p]\n            "),
      pages: (0,defineProperty/* default */.Z)({}, 0, link || {}),
      excludeFromSubmit: true
    }]
  }];
});
;// CONCATENATED MODULE: ./src/services/isObjectEmpty.js
/* harmony default export */ var isObjectEmpty = (function (obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
});
// EXTERNAL MODULE: ./node_modules/lodash.flatmap/index.js
var lodash_flatmap = __webpack_require__(78661);
var lodash_flatmap_default = /*#__PURE__*/__webpack_require__.n(lodash_flatmap);
// EXTERNAL MODULE: ./src/types/pageType.ts
var types_pageType = __webpack_require__(18011);
;// CONCATENATED MODULE: ./src/components/dashboard/ProfileForm.js








var ProfileForm_templateObject, ProfileForm_templateObject2, ProfileForm_templateObject3, ProfileForm_templateObject4, ProfileForm_templateObject5, ProfileForm_templateObject6;

var ProfileForm_jsx = react.createElement;

function ProfileForm_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function ProfileForm_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ProfileForm_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ProfileForm_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function ProfileForm_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ProfileForm_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ProfileForm_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ProfileForm_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}





















var ProfileForm_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env;
  projectSlug = String(projectSlug);
  env = String(env);
  return {
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: projectSlug,
      env: env
    }), 'phase', undefined),
    profile: (0,apiData/* getResultData */.yh)(state.apiData, 'getProfile', {
      projectSlug: projectSlug
    }),
    getRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'getProfile', {
      projectSlug: projectSlug
    }),
    patchRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'patchProfile', {
      projectSlug: projectSlug
    }),
    resultProfile: (0,apiData/* getResultData */.yh)(state.apiData, 'patchProfile', {
      projectSlug: projectSlug
    })
  };
};

var ProfileForm_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getProfile: function getProfile() {
      var projectSlug = ownProps.match.params.projectSlug;
      dispatch((0,apiData/* performApiRequest */.T4)('getProfile', {
        projectSlug: String(projectSlug)
      }));
    },
    invalidateProfile: function invalidateProfile() {
      var projectSlug = ownProps.match.params.projectSlug;
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getProfile', {
        projectSlug: String(projectSlug)
      }));
    },
    displaySuccessModal: function displaySuccessModal(changedValues) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, changedValues));
    },
    updateProfile: function updateProfile(values) {
      var projectSlug = ownProps.match.params.projectSlug;
      dispatch((0,apiData/* performApiRequest */.T4)('patchProfile', {
        projectSlug: String(projectSlug)
      }, values));
    }
  };
};

var ProfileForm = /*#__PURE__*/function (_Component) {
  function ProfileForm() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ProfileForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ProfileForm_callSuper(this, ProfileForm, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      loading: false,
      error: ''
    });
    /**
     * This method is used to return a numeric value when a boolean value is passed
     * The backend only accepts numeric values as a result for the input of
     * articleNotifications or projectUpdateNotifications
     *
     * @param value
     * @returns Numeric boolean value
     */


    (0,defineProperty/* default */.Z)(_this, "getNumericBooleanValue", function (value) {
      if (typeof value !== 'boolean') {
        return value;
      }

      if (value === true) {
        return 1;
      } else {
        return 0;
      }
    });

    (0,defineProperty/* default */.Z)(_this, "getFormValues", function (_ref) {
      var profile = _ref.profile,
          phase = _ref.phase,
          contactUrl = _ref.contactUrl; // We only get the values for the fields in props
      // that we defined in our formDefinitions.
      // That way we make sure we only fill the defaultValues
      // object with the fields we want.

      if (!profile) return {};
      var profileData = phase === 'cj1' ? profile : Object.assign({}, profile, profile.customer);
      var formCJ1WithValues = (0,getProfileFormDefinitionCJ1/* default */.ZP)(contactUrl, profile.email);
      return profileData ? lodash_flatmap_default()(phase === 'cj1' ? formCJ1WithValues : profile.customer ? getProfileFormDefinitionCJ2(contactUrl, profile.customer).concat(formCJ1WithValues) : null, function (formCat) {
        return formCat.options;
      }).reduce(function (acc, curr) {
        acc[curr.name] = profileData[curr.name];
        return acc;
      }, {}) : {};
    });

    (0,defineProperty/* default */.Z)(_this, "handleSubmit", function (values) {
      _this.setState({
        loading: true
      }, function () {
        // Adjust boolean values if projectUpdateNotifications or articleNotifications is available
        if (values.hasOwnProperty(getProfileFormDefinitionCJ1/* PROJECT_UPDATE_NOTIFICATIONS */.FR) || values.hasOwnProperty(getProfileFormDefinitionCJ1/* ARTICLE_NOTIFICATIONS */.xJ)) {
          values = ProfileForm_objectSpread(ProfileForm_objectSpread({}, values), {}, {
            articleNotifications: _this.getNumericBooleanValue(values.articleNotifications),
            projectUpdateNotifications: _this.getNumericBooleanValue(values.projectUpdateNotifications)
          });
        }

        _this.props.updateProfile(values);
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ProfileForm, _Component);

  return (0,createClass/* default */.Z)(ProfileForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          profile = _this$props.profile,
          getRequest = _this$props.getRequest,
          getProfile = _this$props.getProfile,
          phase = _this$props.phase,
          invalidateProfile = _this$props.invalidateProfile;

      if (profile === undefined && getRequest && getRequest.networkStatus !== 'loading') {
        getProfile();
      }

      if (phase === 'cj2' && profile && profile.customer === null) {
        invalidateProfile();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          newPatchRequest = _this$props2.patchRequest,
          contactUrl = _this$props2.contactUrl,
          profile = _this$props2.profile,
          phase = _this$props2.phase,
          displaySuccessModal = _this$props2.displaySuccessModal;
      var loading = this.state.loading;
      var oldPatchRequest = prevProps.patchRequest;
      var oldNetworkStatus = oldPatchRequest && oldPatchRequest.networkStatus;
      var newNetworkStatus = newPatchRequest && newPatchRequest.networkStatus;

      if (oldNetworkStatus === 'loading' && loading) {
        if (newNetworkStatus === 'success') {
          this.setState({
            loading: false
          });
          var oldValues = this.getFormValues(prevProps);
          var newValues = this.getFormValues(this.props);
          var newValueArray = Object.keys(newValues).map(function (key) {
            return {
              key: key,
              value: newValues[key]
            };
          });
          var diffValues = newValueArray.filter(function (option) {
            return option.value !== oldValues[option.key];
          }).reduce(function (acc, curr) {
            acc[curr.key] = curr.value;
            return acc;
          }, {});
          var formCJ1WithValues = (0,getProfileFormDefinitionCJ1/* default */.ZP)(contactUrl, profile.email);
          var form = phase === 'cj1' ? formCJ1WithValues : profile.customer ? getProfileFormDefinitionCJ2(contactUrl, profile.customer).concat(formCJ1WithValues) : null; // When the user uploads an image, we dont show the modal that summarizes changes

          var diffKeys = Object.keys(diffValues).filter(function (key) {
            return key !== 'users' && key !== 'image' && key !== 'customerImage';
          });

          if (form && form.length > 0 && diffKeys.length > 0) {
            displaySuccessModal({
              type: 'editProfile',
              componentProps: {
                form: form,
                values: diffValues
              }
            });
          }
        }

        if (newNetworkStatus === 'failed') {
          var error;

          switch (lodash_get_default()(newPatchRequest, 'errorBody.message')) {
            case 'Email-address already exists':
              error = 'Er bestaat al een account met dit emailadres.';
              break;

            default:
              error = 'Er is iets mis gegaan.';
              break;
          }

          this.setState({
            error: error,
            loading: false
          });
        }
      }
    }
  }, {
    key: "getProfileFormFields",
    value: function getProfileFormFields() {
      var _this$props3 = this.props,
          contactUrl = _this$props3.contactUrl,
          profile = _this$props3.profile,
          phase = _this$props3.phase;
      var formCJ1WithValues = (0,getProfileFormDefinitionCJ1/* default */.ZP)(contactUrl, profile.email);
      return phase === 'cj1' ? formCJ1WithValues : getProfileFormDefinitionCJ2(contactUrl, profile.customer).concat(formCJ1WithValues);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          match = _this$props4.match,
          profile = _this$props4.profile,
          phase = _this$props4.phase,
          contactUrl = _this$props4.contactUrl;
      var _this$state = this.state,
          error = _this$state.error,
          loading = _this$state.loading;
      return !isObjectEmpty(this.getFormValues({
        profile: profile,
        phase: phase,
        contactUrl: contactUrl
      })) ? ProfileForm_jsx(ProfileForm_Container, {
        "data-e2e-profile-form": true,
        "data-id": "dashboard_ProfileForm_Container"
      }, ProfileForm_jsx(ProfileForm_FormTitle, {
        "data-id": "dashboard_ProfileForm_FormTitle"
      }, "Profiel"), error && ProfileForm_jsx(ProfileForm_FormError, {
        "data-id": "dashboard_ProfileForm_FormError"
      }, error), ProfileForm_jsx(FormGenerator/* default */.Z, {
        fields: this.getProfileFormFields(),
        defaultValues: this.getFormValues({
          profile: profile,
          phase: phase,
          contactUrl: contactUrl
        }),
        submitLabel: "Profielinformatie updaten",
        loadingLabel: "aanpassingen worden verwerkt",
        submitFn: this.handleSubmit,
        loading: loading,
        "data-id": "dashboard_ProfileForm_FormGenerator"
      }), ProfileForm_jsx(ProfileForm_FormFooter, {
        "data-id": "dashboard_ProfileForm_FormFooter"
      }, "We gebruiken de gegevens die je achterlaat om onze producten en diensten steeds beter te maken en jouw gebruikerservaring zo goed mogelijk af te stemmen op jouw profiel. In ons", ' ', ProfileForm_jsx(Link/* default */.Z, {
        href: "/".concat(String(match.params.projectSlug), "/open/sectionpage/privacy-statement"),
        target: "_blank",
        rel: "noopener noreferrer",
        "data-id": "dashboard_ProfileForm_Link"
      }, "privacybeleid"), ' ', "lees je precies hoe we omgaan met de door jou opgegeven informatie"), profile.isAnonymizable && ProfileForm_jsx(ButtonPrimary/* default */.Z, {
        type: "internalLink",
        label: "Verwijder mijn account",
        link: "".concat(String(match.params.projectSlug), "/closed/").concat(types_pageType/* StaticPageSlugForProject.vergeet-mij */.lA["vergeet-mij"]),
        buttonColor: styleGuide/* colorPalette.red */.K5.red,
        "data-id": "dashboard_ProfileForm_ButtonPrimary"
      })) : null;
    }
  }]);
}(react.Component);

/* harmony default export */ var dashboard_ProfileForm = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(ProfileForm_mapStateToProps, ProfileForm_mapDispatchToProps)(ProfileForm)));
var ProfileForm_Container = styled_components_browser_esm["default"].div(ProfileForm_templateObject || (ProfileForm_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  opacity: 0;\n  animation: ", " 0.25s ease-in;\n  animation-fill-mode: forwards;\n  background-color: white;\n  order: 4;\n  width: calc(100% - 60rem);\n  padding: 40rem 30rem;\n\n  > form {\n    > div {\n      > h3 {\n        margin-top: 0rem;\n      }\n    }\n    .formfield_customerName {\n      padding-top: 5rem;\n    }\n    .formfield_familyMakeup h4 {\n      margin-bottom: 5rem;\n    }\n    .formfield_anonymous,\n    .formfield_contactInformation,\n    .formfield_image {\n      padding-top: 0;\n    }\n    .formfield_emailAddress p {\n      margin-bottom: 0;\n    }\n    .formfield_users {\n      ul {\n        margin-bottom: 15rem;\n      }\n      a {\n        font-weight: bold;\n        font-size: 18rem;\n      }\n    }\n    .formfield_projectupdate_subscribed {\n      padding-top: 0;\n    }\n  }\n\n  @media all and (max-width: 969px) {\n    margin-left: 0rem;\n  }\n\n  ", ";\n"])), styleGuide/* fadeIn */.Ji, breakpoints/* toBreakpoint.md */.Hx.md(ProfileForm_templateObject2 || (ProfileForm_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 32rem 15rem;\n    width: calc(100% - 30rem);\n  "]))));
var ProfileForm_FormTitle = styled_components_browser_esm["default"].h2(ProfileForm_templateObject3 || (ProfileForm_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ProfileForm_FormError = styled_components_browser_esm["default"].div(ProfileForm_templateObject4 || (ProfileForm_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  padding: 20rem;\n  justify-content: center;\n  border: solid 1px #eee;\n  border-radius: 5rem;\n  background: ", ";\n  font-family: ", ";\n  color: red;\n  margin-bottom: 15rem;\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, styleGuide/* fonts.primary */.Rq.primary);
var ProfileForm_FormFooter = styled_components_browser_esm["default"].div(ProfileForm_templateObject5 || (ProfileForm_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-top: 40rem;\n  margin-bottom: 20rem;\n  color: ", ";\n\n  > a {\n    color: ", ";\n    cursor: pointer;\n    text-decoration: none;\n    border-bottom: 1rem solid transparent;\n    transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n    &:hover {\n      color: ", ";\n      border-bottom: 1rem solid ", ";\n    }\n  }\n\n  ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey, styleGuide/* colorPalette.blue */.K5.blue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue, styleGuide/* colorPalette.darkBlue */.K5.darkBlue, breakpoints/* toBreakpoint.md */.Hx.md(ProfileForm_templateObject6 || (ProfileForm_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 12rem;\n    margin-top: 32rem;\n    margin-bottom: 10rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/dashboard/ProfileOverviewBlock.js


var ProfileOverviewBlock_templateObject, ProfileOverviewBlock_templateObject2, ProfileOverviewBlock_templateObject3;

var ProfileOverviewBlock_jsx = react.createElement;






var ProfileOverviewBlock = function ProfileOverviewBlock(_ref) {
  var contactUrl = _ref.contactUrl;
  return ProfileOverviewBlock_jsx(ProfileOverviewBlock_Wrapper, {
    "data-e2e-page-layout": "profile",
    "data-id": "dashboard_ProfileOverviewBlock_Wrapper"
  }, ProfileOverviewBlock_jsx(ProfileOverviewBlock_CopyCell, {
    "data-id": "dashboard_ProfileOverviewBlock_CopyCell"
  }, ProfileOverviewBlock_jsx(ProfileOverviewBlock_Block, {
    "data-id": "dashboard_ProfileOverviewBlock_Block"
  }, ProfileOverviewBlock_jsx(dashboard_ProfileWidget, {
    isSmall: true,
    "data-id": "dashboard_ProfileOverviewBlock_ProfileWidget"
  }), ProfileOverviewBlock_jsx(dashboard_ProfileForm, {
    contactUrl: contactUrl,
    "data-id": "dashboard_ProfileOverviewBlock_ProfileForm"
  }))));
};

/* harmony default export */ var dashboard_ProfileOverviewBlock = (ProfileOverviewBlock);
var ProfileOverviewBlock_Wrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(ProfileOverviewBlock_templateObject || (ProfileOverviewBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 1;\n"])));
var ProfileOverviewBlock_CopyCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(ProfileOverviewBlock_templateObject2 || (ProfileOverviewBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 100rem;\n  padding-bottom: 20rem;\n  margin-right: 10rem;\n  margin-left: 10rem;\n  padding-right: 0rem;\n  padding-left: 0rem;\n"])));
var ProfileOverviewBlock_Block = styled_components_browser_esm["default"].div(ProfileOverviewBlock_templateObject3 || (ProfileOverviewBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-template-columns: calc(33.33% - 10rem) calc(66.66% - 10rem);\n  grid-template-rows: 1fr;\n  grid-gap: 20px;\n\n  @media all and (max-width: 969px) {\n    grid-gap: 24px;\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n  }\n"])));
;// CONCATENATED MODULE: ./src/components/shared/icons/Document.js
var Document_jsx = react.createElement;


var Document_defaultProps = {
  color: styleGuide/* colorPalette.lightGrey */.K5.lightGrey,
  width: 90,
  height: 140
};

var Document = function Document(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return Document_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 90 140",
    "data-id": "icons_Document_svg"
  }, Document_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-115.000000, -622.000000)",
    "data-id": "icons_Document_g"
  }, Document_jsx("g", {
    transform: "translate(10.000000, 470.000000)",
    fill: color,
    "data-id": "icons_Document_g_2"
  }, Document_jsx("g", {
    transform: "translate(105.000000, 152.000000)",
    "data-id": "icons_Document_g_3"
  }, Document_jsx("path", {
    d: "M7.9992,131.31824 L80.6672,131.31824 C80.8552,131.31824 80.9824,131.20944 81.0304,131.08144 L81.0304,8.06304 L7.9992,8.00544 L7.9992,131.31824 Z M80.6672,139.31824 L0,139.31824 L0,-0.00016 L89.0296,0.06864 L89.0088,131.81264 C88.5688,136.09184 84.9824,139.31824 80.6672,139.31824 Z",
    "data-id": "icons_Document_path"
  }), Document_jsx("path", {
    d: "M66.11872,41.4104 L23.54352,41.4104 C21.33472,41.4104 19.54352,39.62 19.54352,37.4104 C19.54352,35.2008 21.33472,33.4104 23.54352,33.4104 L66.11872,33.4104 C68.32832,33.4104 70.11872,35.2008 70.11872,37.4104 C70.11872,39.62 68.32832,41.4104 66.11872,41.4104",
    "data-id": "icons_Document_path_5"
  }), Document_jsx("path", {
    d: "M66.11872,62.83464 L23.54352,62.83464 C21.33472,62.83464 19.54352,61.04424 19.54352,58.83464 C19.54352,56.62504 21.33472,54.83464 23.54352,54.83464 L66.11872,54.83464 C68.32832,54.83464 70.11872,56.62504 70.11872,58.83464 C70.11872,61.04424 68.32832,62.83464 66.11872,62.83464",
    "data-id": "icons_Document_path_6"
  }), Document_jsx("path", {
    d: "M66.11872,84.2596 L23.54352,84.2596 C21.33472,84.2596 19.54352,82.4692 19.54352,80.2596 C19.54352,78.05 21.33472,76.2596 23.54352,76.2596 L66.11872,76.2596 C68.32832,76.2596 70.11872,78.05 70.11872,80.2596 C70.11872,82.4692 68.32832,84.2596 66.11872,84.2596",
    "data-id": "icons_Document_path_7"
  }), Document_jsx("path", {
    d: "M35.6828,105.68384 L23.5436,105.68384 C21.334,105.68384 19.5436,103.89344 19.5436,101.68384 C19.5436,99.47424 21.334,97.68384 23.5436,97.68384 L35.6828,97.68384 C37.8924,97.68384 39.6828,99.47424 39.6828,101.68384 C39.6828,103.89344 37.8924,105.68384 35.6828,105.68384",
    "data-id": "icons_Document_path_8"
  })))));
};

Document.defaultProps = Document_defaultProps;
/* harmony default export */ var icons_Document = (Document);
;// CONCATENATED MODULE: ./src/components/dashboard/DocumentsWidget.js


var DocumentsWidget_templateObject, DocumentsWidget_templateObject2, DocumentsWidget_templateObject3, DocumentsWidget_templateObject4, DocumentsWidget_templateObject5, DocumentsWidget_templateObject6, DocumentsWidget_templateObject7, DocumentsWidget_templateObject8;

var DocumentsWidget_jsx = react.createElement;















var DocumentsWidget_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openModal: function openModal(modal) {
      if (modal) {
        dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
          type: 'profile',
          componentProps: {
            type: 'messages',
            content: modal
          }
        }));
      }
    }
  };
};

var DocumentsWidget = function DocumentsWidget(_ref) {
  var phase = _ref.phase,
      docItem = _ref.document,
      openModal = _ref.openModal;
  return DocumentsWidget_jsx(DocumentsWidget_Container, {
    "data-id": "dashboard_DocumentsWidget_Container"
  }, DocumentsWidget_jsx(designElements_WidgetHeader, {
    title: phase === 'cj1' ? 'Documenten' : "Nieuwe documenten (".concat(docItem.documents && docItem.documents.length, ")"),
    subtitle: phase === 'cj1' ? 'Na aankoop zie je hier je documenten.' : (phase === 'cj2' || phase === 'cj3') && (docItem.documents && docItem.documents.length) === 0 ? 'Er zijn geen nieuwe documenten.' : undefined,
    "data-id": "dashboard_DocumentsWidget_WidgetHeader"
  }), DocumentsWidget_jsx(react.Fragment, null, DocumentsWidget_jsx(WidgetScroller, {
    "data-id": "dashboard_DocumentsWidget_WidgetScroller"
  }, (phase === 'cj1' || docItem.documents && docItem.documents.length === 0) && DocumentsWidget_jsx(DocumentsWidget_IconContainer, {
    onClick: function onClick() {
      return openModal(docItem.modal);
    },
    "data-id": "dashboard_DocumentsWidget_IconContainer"
  }, DocumentsWidget_jsx(icons_Document, {
    width: 200,
    height: 140,
    color: styleGuide/* colorPalette.background */.K5.background,
    "data-id": "dashboard_DocumentsWidget_DocumentIcon"
  })), (docItem.documents || []).map(function (doc, index) {
    return DocumentsWidget_jsx(DocumentsWidget_Document, {
      key: index,
      isLast: index === docItem.documents.length - 1,
      "data-id": "dashboard_DocumentsWidget_Document"
    }, DocumentsWidget_jsx(ButtonDownload/* default */.Z, {
      content: doc.name,
      link: doc.url,
      "data-id": "dashboard_DocumentsWidget_DownloadButton"
    }), DocumentsWidget_jsx(DocumentInfo, {
      "data-id": "dashboard_DocumentsWidget_DocumentInfo"
    }, DocumentsWidget_jsx(Folder, {
      "data-id": "dashboard_DocumentsWidget_Folder"
    }, "in map ", doc.folder), DocumentsWidget_jsx(Added, {
      "data-id": "dashboard_DocumentsWidget_Added"
    }, "Toegevoegd door ", doc.author, " |", ' ', doc.created.substring(0, 10).split('-').reverse().join('-'), ' ', doc.created.substring(11, 16))));
  })), DocumentsWidget_jsx(WidgetFooter, {
    "data-id": "dashboard_DocumentsWidget_WidgetFooter"
  }, phase === 'cj1' && DocumentsWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Lees meer",
    type: "button",
    clickHandler: function clickHandler() {
      return openModal(docItem.modal);
    },
    "data-id": "dashboard_DocumentsWidget_ButtonSecondary"
  }), docItem.link && DocumentsWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Alle documenten",
    type: "internalLink",
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(docItem.link),
    "data-id": "dashboard_DocumentsWidget_ButtonSecondary_12"
  }))));
};

/* harmony default export */ var dashboard_DocumentsWidget = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(null, DocumentsWidget_mapDispatchToProps)(DocumentsWidget)));
var DocumentsWidget_Container = styled_components_browser_esm["default"].div(DocumentsWidget_templateObject || (DocumentsWidget_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n\n  ", ";\n\n  > button {\n    position: absolute;\n    bottom: 0;\n  }\n  > div > a {\n    position: absolute;\n    bottom: 0;\n  }\n"])), breakpoints/* toBreakpoint.md */.Hx.md(DocumentsWidget_templateObject2 || (DocumentsWidget_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 30rem;\n    &:after {\n      content: '';\n      width: calc(100% + 40rem);\n      position: absolute;\n      height: 2rem;\n      top: 0;\n      left: -20rem;\n      background-color: ", "\n    }\n  "])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey));
var DocumentsWidget_IconContainer = styled_components_browser_esm["default"].div(DocumentsWidget_templateObject3 || (DocumentsWidget_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-self: center;\n  display: flex;\n  justify-content: center;\n  margin-top: 30rem;\n  margin-bottom: 50rem;\n  &:hover {\n    cursor: pointer;\n  }\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(DocumentsWidget_templateObject4 || (DocumentsWidget_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 80rem;\n    margin-bottom: 80rem;\n  "]))));
var borderStyle = "1rem dashed ".concat(styleGuide/* colorPalette.lightBeige */.K5.lightBeige, ";");
var DocumentsWidget_Document = styled_components_browser_esm["default"].div(DocumentsWidget_templateObject5 || (DocumentsWidget_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 20rem 0;\n  border-top: ", ";\n  border-bottom: ", ";\n\n  > span {\n    margin-bottom: 6rem;\n  }\n"])), borderStyle, function (props) {
  return props.isLast ? borderStyle : '';
});
var DocumentInfo = styled_components_browser_esm["default"].div(DocumentsWidget_templateObject6 || (DocumentsWidget_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 32rem;\n"])));
var Folder = styled_components_browser_esm["default"].p(DocumentsWidget_templateObject7 || (DocumentsWidget_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin: 0;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var Added = styled_components_browser_esm["default"].p(DocumentsWidget_templateObject8 || (DocumentsWidget_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-size: 12rem;\n  color: ", ";\n  margin: 0;\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.beige */.K5.beige);
;// CONCATENATED MODULE: ./src/components/shared/icons/MyHouse.js
var MyHouse_jsx = react.createElement;


var MyHouse_defaultProps = {
  color: styleGuide/* colorPalette.orange */.K5.orange,
  width: 64,
  height: 64
};

var MyHouse = function MyHouse(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return MyHouse_jsx("svg", {
    style: {
      width: "".concat(String(width), "px"),
      height: "".concat(String(height), "px")
    },
    viewBox: "0 0 64 64",
    "data-id": "icons_MyHouse_svg"
  }, MyHouse_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_MyHouse_g"
  }, MyHouse_jsx("g", {
    transform: "translate(-488.000000, -480.000000)",
    fill: color,
    fillRule: "nonzero",
    "data-id": "icons_MyHouse_g_2"
  }, MyHouse_jsx("g", {
    transform: "translate(488.000000, 480.000000)",
    "data-id": "icons_MyHouse_g_3"
  }, MyHouse_jsx("path", {
    d: "M13.6,58.9 L13.6,19.6 L32,6.4 L50.4,19.5 L50.4,55.7 C50.4,57.5 49.1,58.8 47.3,58.8 L13.6,58.8 L13.6,58.9 Z M62.9,22.2 L33.5,1.2 C33.5,1.2 33.5,1.2 33.5,1.2 L32,0.1 L30.5,1.2 L19.3,9.1 L19.3,0 L14.2,0 L14.2,12.8 L8.4,16.9 L8.4,17 L1.1,22.2 C-0.1,23 -0.3,24.6 0.5,25.8 C1,26.5 1.8,26.9 2.6,26.9 C3.1,26.9 3.6,26.7 4.1,26.4 L8.4,23.3 L8.4,64 L46.7,64 L49.1,64 L49.4,64 C52.2,64 54.6,62.1 55.4,59.5 C55.5,59.1 55.6,58.6 55.7,58.2 L55.7,35.4 L55.7,23.3 L60,26.4 C60.5,26.7 61,26.9 61.5,26.9 C62.3,26.9 63.1,26.5 63.6,25.8 C64.3,24.6 64.1,23 62.9,22.2 Z",
    "data-id": "icons_MyHouse_path"
  })))));
};

MyHouse.defaultProps = MyHouse_defaultProps;
/* harmony default export */ var icons_MyHouse = (MyHouse);
;// CONCATENATED MODULE: ./src/components/dashboard/HouseWidget.js


var HouseWidget_templateObject, HouseWidget_templateObject2, HouseWidget_templateObject3, HouseWidget_templateObject4, HouseWidget_templateObject5, HouseWidget_templateObject6, HouseWidget_templateObject7, HouseWidget_templateObject8;

var HouseWidget_jsx = react.createElement;















var HouseWidget_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openModal: function openModal() {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
        type: 'profile',
        componentProps: {
          type: 'messages',
          content: ownProps.house.modal
        }
      }));
    }
  };
};

var HouseWidget_redirect = function redirect(link, router) {
  if (link === undefined || !link) return;
  router === null || router === void 0 || router.push('/' + (0,getLinkFromPageObject/* default */.Z)(link));
};

var HouseWidget = function HouseWidget(_ref) {
  var phase = _ref.phase,
      openModal = _ref.openModal,
      house = _ref.house,
      router = _ref.router;
  var houseImage = lodash_get_default()(house, 'houseType.media[0].image.src');
  return HouseWidget_jsx(HouseWidget_Container, {
    "data-id": "dashboard_HouseWidget_Container"
  }, HouseWidget_jsx(designElements_WidgetHeader, {
    title: "Jouw woning",
    subtitle: phase === 'cj1' ? 'Als koper heb je vanaf hier straks toegang tot meer informatie over de woning die je hebt gekocht en de keuzes die je hebt gemaakt om van je huis een thuis te maken.' : undefined,
    "data-id": "dashboard_HouseWidget_WidgetHeader"
  }), phase === 'cj1' && HouseWidget_jsx(HouseWidget_IconContainer, {
    onClick: openModal,
    "data-id": "dashboard_HouseWidget_IconContainer"
  }, HouseWidget_jsx(icons_MyHouse, {
    width: 200,
    height: 140,
    color: styleGuide/* colorPalette.background */.K5.background,
    "data-id": "dashboard_HouseWidget_House"
  })), (phase === 'cj2' || phase === 'cj3') && HouseWidget_jsx(react.Fragment, null, houseImage && HouseWidget_jsx(HouseWidget_ImageContainer, {
    onClick: function onClick() {
      return HouseWidget_redirect(house.link, router);
    },
    "data-id": "dashboard_HouseWidget_ImageContainer"
  }, HouseWidget_jsx(ImageLoader/* default */.Z, {
    src: houseImage,
    mode: "bg",
    alt: house.houseType.slug,
    "data-id": "dashboard_HouseWidget_ImageLoader"
  })), HouseWidget_jsx(HouseWidget_HouseInfo, {
    "data-id": "dashboard_HouseWidget_HouseInfo"
  }, house.house && house.house.address ? HouseWidget_jsx(HouseWidget_Address, {
    "data-id": "dashboard_HouseWidget_Address"
  }, HouseWidget_jsx("p", {
    "data-id": "dashboard_HouseWidget_p"
  }, house.house.address.street, " ", house.house.address.houseNumber, ' ', house.house.address.houseNumberAddition), HouseWidget_jsx("p", {
    "data-id": "dashboard_HouseWidget_p_9"
  }, house.house.address.zipcode, " ", house.house.address.city)) : HouseWidget_jsx(HouseWidget_Address, {
    "data-id": "dashboard_HouseWidget_Address"
  }, HouseWidget_jsx("p", {
    "data-id": "dashboard_HouseWidget_p"
  }, "Adres nog onbekend")), house.house && house.house.bnr && HouseWidget_jsx("p", {
    "data-id": "dashboard_HouseWidget_p_12"
  }, "Bouwnummer: ", house.house.bnr), house.houseType && house.house && HouseWidget_jsx("p", {
    "data-id": "dashboard_HouseWidget_p_13"
  }, "Variant: ", house.houseType.typeName, " - ", house.houseType.variantName, ' ', house.house.variantCode), house.house && house.house.surface && HouseWidget_jsx("p", {
    "data-id": "dashboard_HouseWidget_p_14"
  }, "Kaveloppervlak: ", house.house.surface, " m\xB2"))), HouseWidget_jsx(WidgetFooter, {
    "data-id": "dashboard_HouseWidget_WidgetFooter"
  }, phase === 'cj1' && HouseWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Lees meer",
    type: "button",
    clickHandler: openModal,
    "data-id": "dashboard_HouseWidget_ButtonSecondary"
  }), house.link && HouseWidget_jsx(ButtonSecondary/* default */.Z, {
    label: "Woning en gemaakte keuzes bekijken",
    type: "internalLink",
    route: '/' + (0,getLinkFromPageObject/* default */.Z)(house.link),
    "data-id": "dashboard_HouseWidget_ButtonSecondary_17"
  })));
};

/* harmony default export */ var dashboard_HouseWidget = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(null, HouseWidget_mapDispatchToProps)(HouseWidget)));
var HouseWidget_Container = styled_components_browser_esm["default"].div(HouseWidget_templateObject || (HouseWidget_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  margin-bottom: 20rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(HouseWidget_templateObject2 || (HouseWidget_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-right: 30rem;\n    border-right: 1rem dashed ", ";\n    margin-bottom: 0;\n    min-height: 480rem;\n  "])), styleGuide/* colorPalette.lightBeige */.K5.lightBeige));
var HouseWidget_IconContainer = styled_components_browser_esm["default"].div(HouseWidget_templateObject3 || (HouseWidget_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-self: center;\n  display: flex;\n  justify-content: center;\n  margin-top: 30rem;\n  margin-bottom: 50rem;\n  &:hover {\n    cursor: pointer;\n  }\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(HouseWidget_templateObject4 || (HouseWidget_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 20rem;\n    margin-bottom: 80rem;\n  "]))));
var HouseWidget_ImageContainer = styled_components_browser_esm["default"].div(HouseWidget_templateObject5 || (HouseWidget_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 218rem;\n  overflow: hidden;\n  cursor: pointer;\n\n  > div {\n    transition: transform 0.45s ease-in-out;\n    transform: scale(1);\n    &:hover {\n      transform: scale(1.04);\n    }\n  }\n"])));
var HouseWidget_HouseInfo = styled_components_browser_esm["default"].div(HouseWidget_templateObject6 || (HouseWidget_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n\n  > p {\n    margin-bottom: 0;\n    margin-top: 8rem;\n  }\n\n  + div {\n    ", ";\n  }\n"])), styleGuide/* textStyles.caption */.sq.caption, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* toBreakpoint.lg */.Hx.lg(HouseWidget_templateObject7 || (HouseWidget_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 10rem;\n    "]))));
var HouseWidget_Address = styled_components_browser_esm["default"].div(HouseWidget_templateObject8 || (HouseWidget_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 12rem;\n  margin-top: 10rem;\n  > p {\n    margin-bottom: 8rem;\n    margin-top: 0;\n  }\n"])));
;// CONCATENATED MODULE: ./src/components/dashboard/MyHouseAndDocsBlock.js


var MyHouseAndDocsBlock_templateObject, MyHouseAndDocsBlock_templateObject2, MyHouseAndDocsBlock_templateObject3, MyHouseAndDocsBlock_templateObject4, MyHouseAndDocsBlock_templateObject5, MyHouseAndDocsBlock_templateObject6, MyHouseAndDocsBlock_templateObject7, MyHouseAndDocsBlock_templateObject8;

var MyHouseAndDocsBlock_jsx = react.createElement;











var MyHouseAndDocsBlock_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    phase: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase', undefined)
  };
};

var MyHouseAndDocsBlock = function MyHouseAndDocsBlock(_ref) {
  var phase = _ref.phase,
      house = _ref.house,
      document = _ref.document;
  return MyHouseAndDocsBlock_jsx(designElements_WidgetContainer, {
    label: "De Woning",
    size: "normal",
    icon: "house",
    "data-e2e-block-pricelistblock": true,
    "data-id": "dashboard_MyHouseAndDocsBlock_WidgetContainer"
  }, MyHouseAndDocsBlock_jsx(MyHouseAndDocsBlock_BlocksContainer, {
    "data-id": "dashboard_MyHouseAndDocsBlock_BlocksContainer"
  }, MyHouseAndDocsBlock_jsx(MyHouseAndDocsBlock_House, {
    "data-id": "dashboard_MyHouseAndDocsBlock_House"
  }, phase && MyHouseAndDocsBlock_jsx(dashboard_HouseWidget, {
    phase: phase,
    house: house,
    "data-id": "dashboard_MyHouseAndDocsBlock_HouseWidget"
  })), MyHouseAndDocsBlock_jsx(MyHouseAndDocsBlock_Documents, {
    "data-id": "dashboard_MyHouseAndDocsBlock_Documents"
  }, phase && MyHouseAndDocsBlock_jsx(dashboard_DocumentsWidget, {
    phase: phase,
    document: document,
    "data-id": "dashboard_MyHouseAndDocsBlock_DocumentsWidget"
  }))));
};

/* harmony default export */ var dashboard_MyHouseAndDocsBlock = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(MyHouseAndDocsBlock_mapStateToProps)(MyHouseAndDocsBlock)));
var MyHouseAndDocsBlock_BlocksContainer = styled_components_browser_esm["default"].div(MyHouseAndDocsBlock_templateObject || (MyHouseAndDocsBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(MyHouseAndDocsBlock_templateObject2 || (MyHouseAndDocsBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: row;\n    max-height: 520rem;\n  "]))));
var MyHouseAndDocsBlock_House = styled_components_browser_esm["default"].div(MyHouseAndDocsBlock_templateObject3 || (MyHouseAndDocsBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: auto;\n  position: relative;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(MyHouseAndDocsBlock_templateObject4 || (MyHouseAndDocsBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 50%;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseAndDocsBlock_templateObject5 || (MyHouseAndDocsBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(1/3 * 100%);\n  "]))));
var MyHouseAndDocsBlock_Documents = styled_components_browser_esm["default"].div(MyHouseAndDocsBlock_templateObject6 || (MyHouseAndDocsBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: auto;\n  position: relative;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(MyHouseAndDocsBlock_templateObject7 || (MyHouseAndDocsBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 50%;\n    margin-left: 60rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(MyHouseAndDocsBlock_templateObject8 || (MyHouseAndDocsBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: calc(2/3 * 100%);\n  "]))));
// EXTERNAL MODULE: ./node_modules/react-map-gl/dist/esm/index.js + 21 modules
var esm = __webpack_require__(61108);
// EXTERNAL MODULE: ./node_modules/mapbox-gl/dist/mapbox-gl.css
var mapbox_gl = __webpack_require__(81634);
;// CONCATENATED MODULE: ./src/components/shared/ui/Map.js








var Map_templateObject, Map_templateObject2, Map_templateObject3, Map_templateObject4, Map_templateObject5, Map_templateObject6, Map_templateObject7, Map_templateObject8;

var Map_jsx = react.createElement;

function Map_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, Map_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function Map_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (Map_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}











var Map_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openModal: function openModal(projectSlug) {
      dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.lightOrange */.K5.lightOrange, {
        type: 'project',
        componentProps: {
          projectSlug: projectSlug
        }
      }));
    }
  };
};

var Map_Map = /*#__PURE__*/function (_Component) {
  function Map() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Map);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Map_callSuper(this, Map, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      selectedMarker: null
    });

    (0,defineProperty/* default */.Z)(_this, "setMarker", function (e, marker) {
      _this.setState({
        selectedMarker: marker
      });
    });

    (0,defineProperty/* default */.Z)(_this, "openProjectModal", function () {
      _this.props.openModal(_this.state.selectedMarker.slug);
    });

    return _this;
  }

  (0,inherits/* default */.Z)(Map, _Component);

  return (0,createClass/* default */.Z)(Map, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$markers = this.props.markers,
          markers = _this$props$markers === void 0 ? [] : _this$props$markers;
      var selectedMarker = this.state.selectedMarker;
      return Map_jsx(Map_Container, {
        "data-id": "ui_Map_Container"
      }, Map_jsx(StyledMapboxMap, {
        mapboxAccessToken: "pk.eyJ1IjoiYW1idiIsImEiOiJjbGRjNTFpNjQwNzhrM3FtaWJjaDB1YThrIn0.fafBzgcYb89ZH_2GyKTDhw",
        initialViewState: {
          longitude: 5.073558,
          latitude: 52.102666,
          zoom: 7.4
        },
        mapStyle: "mapbox://styles/ambv/cldc5k8l2007001ocmtjpoxyr",
        "data-id": "ui_Map_StyledMapboxMap"
      }, markers.map(function (marker) {
        return Map_jsx(StyledMarker, {
          key: marker.slug,
          anchor: "bottom",
          onClick: function onClick(e) {
            e.originalEvent.stopPropagation();

            _this2.setMarker(e, marker);
          },
          latitude: marker.latitude,
          longitude: marker.longitude,
          "data-id": "ui_Map_StyledMarker"
        }, Map_jsx("img", {
          src: "/images/marker.png",
          alt: "Marker voor een project",
          "data-id": "ui_Map_img"
        }));
      }), selectedMarker && Map_jsx(StyledPopup, {
        anchor: "top",
        longitude: selectedMarker.longitude,
        latitude: selectedMarker.latitude,
        onClose: function onClose(e) {
          return _this2.setMarker(e, null);
        },
        "data-id": "ui_Map_StyledPopup"
      }, Map_jsx(Map_ContentWrapper, {
        "data-id": "ui_Map_ContentWrapper"
      }, Map_jsx(Map_Content, {
        onClick: this.openProjectModal,
        "data-id": "ui_Map_Content"
      }, Map_jsx(ImageLoader/* default */.Z, {
        mode: "img",
        src: selectedMarker.image,
        alt: selectedMarker.title,
        width: 140,
        "data-id": "ui_Map_ImageLoader"
      }), Map_jsx(Map_Title, {
        "data-id": "ui_Map_Title"
      }, selectedMarker.title))))));
    }
  }]);
}(react.Component);

/* harmony default export */ var ui_Map = ((0,es/* connect */.$j)(null, Map_mapDispatchToProps)(Map_Map));
var Map_Container = styled_components_browser_esm["default"].div(Map_templateObject || (Map_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 268rem;\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(Map_templateObject2 || (Map_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n     height: 536rem;\n  "]))));
var StyledMapboxMap = (0,styled_components_browser_esm["default"])(esm/* default */.ZP)(Map_templateObject3 || (Map_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n"])));
var StyledMarker = (0,styled_components_browser_esm["default"])(esm/* Marker */.Jx)(Map_templateObject4 || (Map_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 26rem;\n  height: 26rem;\n  cursor: pointer;\n"])));
var StyledPopup = (0,styled_components_browser_esm["default"])(esm/* Popup */.GI)(Map_templateObject5 || (Map_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 140rem;\n\n  // Reset default styling\n  & > .mapboxgl-popup-content {\n    padding: 0;\n    box-shadow: none;\n  }\n"])));
var Map_ContentWrapper = styled_components_browser_esm["default"].div(Map_templateObject6 || (Map_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: #fff;\n  box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.25);\n  transition: box-shadow 0.15s ease-in-out;\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.5);\n  }\n\n  & svg {\n    position: absolute;\n    bottom: 3rem;\n    left: 50%;\n    margin-left: -10rem;\n  }\n"])));
var Map_Content = styled_components_browser_esm["default"].button(Map_templateObject7 || (Map_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
var Map_Title = styled_components_browser_esm["default"].p(Map_templateObject8 || (Map_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 12rem 0 16rem 0;\n  font-family: ", ";\n  font-size: 14rem;\n  font-weight: bold;\n  line-height: 18rem;\n  color: ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.orange */.K5.orange);
// EXTERNAL MODULE: ./src/components/shared/forms/fieldTypes/Select.js + 46 modules
var Select = __webpack_require__(31605);
;// CONCATENATED MODULE: ./src/components/ProjectMapBlock.js








var ProjectMapBlock_templateObject, ProjectMapBlock_templateObject2, ProjectMapBlock_templateObject3, ProjectMapBlock_templateObject4, ProjectMapBlock_templateObject5, ProjectMapBlock_templateObject6, ProjectMapBlock_templateObject7, ProjectMapBlock_templateObject8, ProjectMapBlock_templateObject9, ProjectMapBlock_templateObject0, ProjectMapBlock_templateObject1;

var ProjectMapBlock_jsx = react.createElement;

function ProjectMapBlock_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, ProjectMapBlock_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function ProjectMapBlock_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (ProjectMapBlock_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}












var FILTER_ENABLED = false; // The design team has asked to hide the filter functionality for now. See https://jungleminds.atlassian.net/browse/BAMECW-1038 for more details

var choices = [{
  key: '',
  value: 'Toon alle'
}, {
  key: 'newBuild',
  value: 'Nieuwbouw'
}, {
  key: 'existingBuild',
  value: 'Bestaande bouw'
}];

var ProjectMapBlock = /*#__PURE__*/function (_Component) {
  function ProjectMapBlock() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ProjectMapBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ProjectMapBlock_callSuper(this, ProjectMapBlock, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      markers: [],
      projects: {},
      filterBy: '',
      page: 0,
      totalPages: 0
    });

    (0,defineProperty/* default */.Z)(_this, "paginateItems", function (map, divisor) {
      return map.reduce(function (acc, curr, index) {
        var objectIndex = Math.floor(index / divisor);

        if (!acc[objectIndex]) {
          acc[objectIndex] = [];
        }

        acc[objectIndex] = acc[objectIndex].concat([curr]);
        return acc;
      }, {});
    });

    (0,defineProperty/* default */.Z)(_this, "handleFilterChange", function (e) {
      var filterBy = e.target.value;

      var filteredItems = _this.props.map.filter(function (project) {
        if (filterBy === '') {
          return project;
        }

        return project.isNewBuild === (filterBy === 'newBuild');
      });

      var projects = _this.paginateItems(filteredItems, 12);

      var totalPages = Number(Object.keys(projects).slice(-1)[0]) + 1;

      _this.setState({
        filterBy: filterBy,
        markers: filteredItems,
        page: 0,
        projects: projects,
        totalPages: totalPages
      });
    });

    (0,defineProperty/* default */.Z)(_this, "handlePageChange", function (page) {
      _this.setState({
        page: page - 1
      });
    });

    return _this;
  }

  (0,inherits/* default */.Z)(ProjectMapBlock, _Component);

  return (0,createClass/* default */.Z)(ProjectMapBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          map = _this$props.map,
          filter = _this$props.filter;
      var divisor = filter && filter.show ? 12 : 3;
      var projects = this.paginateItems(map, divisor);
      var totalPages = Number(Object.keys(projects).slice(-1)[0]) + 1;
      this.setState({
        markers: map,
        projects: projects,
        totalPages: totalPages
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          renderWidth = _this$props2.renderWidth,
          map = _this$props2.map,
          filter = _this$props2.filter,
          link = _this$props2.link;
      var _this$state = this.state,
          markers = _this$state.markers,
          projects = _this$state.projects,
          page = _this$state.page,
          totalPages = _this$state.totalPages;
      var filterEnabled = filter && filter.show;
      return ProjectMapBlock_jsx(react.Fragment, null,  true && ProjectMapBlock_jsx(MapContainer, {
        isSmall: renderWidth < breakpoints/* breakpointSizes.md */.YA.md,
        "data-id": "components_ProjectMapBlock_MapContainer"
      }, FILTER_ENABLED && filterEnabled && ProjectMapBlock_jsx(FilterContainer, {
        "data-id": "components_ProjectMapBlock_FilterContainer"
      }, ProjectMapBlock_jsx(Filter, {
        "data-id": "components_ProjectMapBlock_Filter"
      }, ProjectMapBlock_jsx(FilterTitle, {
        "data-id": "components_ProjectMapBlock_FilterTitle"
      }, "Filter projecten"), ProjectMapBlock_jsx(ProjectMapBlock_FormContainer, {
        "data-id": "components_ProjectMapBlock_FormContainer"
      }, ProjectMapBlock_jsx(Select/* default */.Z, {
        name: "buildSelector",
        choices: choices,
        onChange: this.handleFilterChange,
        defaultValue: choices[0].value,
        required: true,
        "data-id": "components_ProjectMapBlock_Select"
      })))), ProjectMapBlock_jsx(ui_Map, {
        markers: filterEnabled ? markers : map,
        containerElement: ProjectMapBlock_jsx("div", {
          style: {
            height: '536rem'
          },
          "data-id": "components_ProjectMapBlock_div"
        }),
        loadingElement: ProjectMapBlock_jsx("div", {
          style: {
            height: "100%"
          },
          "data-id": "components_ProjectMapBlock_div_8"
        }),
        mapElement: ProjectMapBlock_jsx("div", {
          style: {
            height: "100%"
          },
          "data-id": "components_ProjectMapBlock_div_9"
        }),
        "data-id": "components_ProjectMapBlock_Map"
      })), ProjectMapBlock_jsx(ProjectsContainer, {
        filterEnabled: filterEnabled,
        "data-id": "components_ProjectMapBlock_ProjectsContainer"
      }, (projects[page] || []).map(function (item) {
        return ProjectMapBlock_jsx(components_ProjectCard, {
          key: item.slug,
          image: item.image,
          isNewBuild: item.isNewBuild,
          title: item.title,
          description: item.description,
          slug: item.slug,
          "data-id": "components_ProjectMapBlock_ProjectCard"
        });
      })), filterEnabled && ProjectMapBlock_jsx(ProjectMapBlock_PaginationWrapper, {
        "data-id": "components_ProjectMapBlock_PaginationWrapper"
      }, ProjectMapBlock_jsx(components_Pagination, {
        totalPages: totalPages,
        currentPage: page,
        visiblePages: 2,
        goToPageValue: this.handlePageChange,
        isLoading: false,
        "data-id": "components_ProjectMapBlock_Pagination"
      })), link && !filter && ProjectMapBlock_jsx(ProjectMapBlock_ButtonContainer, {
        "data-id": "components_ProjectMapBlock_ButtonContainer"
      }, ProjectMapBlock_jsx(ButtonPrimary/* default */.Z, {
        type: link.linkType === 'internal' ? 'internalLink' : 'externalLink',
        route: '/' + (0,getLinkFromPageObject/* default */.Z)(link.url),
        label: link.label,
        buttonColor: styleGuide/* colorPalette.blue */.K5.blue,
        "data-id": "components_ProjectMapBlock_ButtonPrimary"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var components_ProjectMapBlock = (ProjectMapBlock);
var MapContainer = styled_components_browser_esm["default"].div(ProjectMapBlock_templateObject || (ProjectMapBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  margin-top: 30rem;\n  margin-bottom: 30rem;\n"])));
var FilterContainer = styled_components_browser_esm["default"].div(ProjectMapBlock_templateObject2 || (ProjectMapBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  padding: 0 30rem;\n  margin-top: -50rem;\n  margin-bottom: 60rem;\n  opacity: 0;\n  animation-delay: 0.9s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ", ";\n  animation-duration: 0.5s;\n  animation-name: ", ";\n\n  ", ";\n"])), styleGuide/* CUBIC_TIMING */.I5, styleGuide/* fadeIn */.Ji, breakpoints/* fromBreakpoint.md */.ks.md(ProjectMapBlock_templateObject3 || (ProjectMapBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: -80rem;\n    margin-bottom: 50rem;\n  "]))));
var Filter = styled_components_browser_esm["default"].div(ProjectMapBlock_templateObject4 || (ProjectMapBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 5;\n  max-width: 980rem;\n  box-sizing: border-box;\n  padding: 20rem;\n  width: 100%;\n  background: #fff;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ProjectMapBlock_templateObject5 || (ProjectMapBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 25rem;\n  "]))));
var FilterTitle = styled_components_browser_esm["default"].p(ProjectMapBlock_templateObject6 || (ProjectMapBlock_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  font-size: 16rem;\n  font-weight: bold;\n  color: ", ";\n  margin: 0 0 10rem 0;\n\n  ", ";\n"])), styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.beige */.K5.beige, breakpoints/* fromBreakpoint.md */.ks.md(ProjectMapBlock_templateObject7 || (ProjectMapBlock_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: 18rem;\n  "]))));
var ProjectMapBlock_FormContainer = styled_components_browser_esm["default"].div(ProjectMapBlock_templateObject8 || (ProjectMapBlock_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n\n  > div {\n    width: 100%;\n    max-width: 300rem;\n  }\n"])));
var ProjectsContainer = (0,styled_components_browser_esm["default"])(CardCollectionContainer)(ProjectMapBlock_templateObject9 || (ProjectMapBlock_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: ", ";\n"])), function (props) {
  return props.filterEnabled ? '10rem' : '-60rem';
});
var ProjectMapBlock_ButtonContainer = styled_components_browser_esm["default"].div(ProjectMapBlock_templateObject0 || (ProjectMapBlock_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  padding-top: 10rem;\n  padding-bottom: 30rem;\n"])));
var ProjectMapBlock_PaginationWrapper = styled_components_browser_esm["default"].div(ProjectMapBlock_templateObject1 || (ProjectMapBlock_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: flex-end;\n  margin: 30rem 0;\n"])));
;// CONCATENATED MODULE: ./src/components/Block.js

var Block_jsx = react.createElement;































var Block_Block = function Block(_ref) {
  var renderWidth = _ref.renderWidth,
      block = _ref.block,
      isLastItem = _ref.isLastItem;
  if (!block.type) return null;

  switch (block.type) {
    case 'richtext':
      return Block_jsx(components_RichTextBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_RichTextBlock"
      }));

    case 'ctaform':
      return Block_jsx(components_CTAPrimary, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_CTAPrimary"
      }));

    case 'ctaformSecond':
      return Block_jsx(components_CTASecondary, (0,esm_extends/* default */.Z)({}, block, {
        renderWidth: renderWidth,
        "data-id": "components_Block_CTASecondary"
      }));

    case 'storyslider':
      return Block_jsx(components_StorySlider, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_StorySlider"
      }));

    case 'recentarticles':
      return Block_jsx(components_ArticleCardCollection, (0,esm_extends/* default */.Z)({}, block, {
        renderWidth: renderWidth || 0,
        "data-id": "components_Block_ArticleCardCollection"
      }));

    case 'pricelist':
      return Block_jsx(components_PricelistBlock, (0,esm_extends/* default */.Z)({}, block, {
        renderWidth: renderWidth,
        "data-id": "components_Block_PricelistBlock"
      }));

    case 'housetypeCollection':
      return Block_jsx(components_HouseTypeCollection, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_HouseTypeCollection"
      }));

    case 'articlecollection':
      return Block_jsx(components_ArticleCollection, (0,esm_extends/* default */.Z)({}, block, {
        renderWidth: renderWidth,
        "data-id": "components_Block_ArticleCollection"
      }));

    case 'housetypeCarousel':
      return Block_jsx(components_HouseTypeCarousel, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_HouseTypeCarousel"
      }));

    case 'combo':
      return Block_jsx(components_ComboBlock, (0,esm_extends/* default */.Z)({}, block, {
        renderWidth: renderWidth,
        "data-id": "components_Block_ComboBlock"
      }));

    case 'bannerCollection':
      return Block_jsx(components_BannerBlock, (0,esm_extends/* default */.Z)({
        renderWidth: renderWidth
      }, block, {
        "data-id": "components_Block_BannerBlock"
      }));

    case 'login':
      return Block_jsx(components_LoginBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_LoginBlock"
      }));

    case 'contact':
      return Block_jsx(components_ContactBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_ContactBlock"
      }));

    case 'contactExpert':
      return Block_jsx(components_ContactExpert, (0,esm_extends/* default */.Z)({}, block, {
        isLastItem: isLastItem,
        "data-id": "components_Block_ContactExpert"
      }));

    case 'wishlistOverview':
      return Block_jsx(components_WishListCollection, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_WishListCollection"
      }));

    case 'profile':
      return Block_jsx(dashboard_ProfileBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_ProfileBlock"
      }));

    case 'widgetFeedback':
      return Block_jsx(components_FeedbackBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_FeedbackBlock"
      }));

    case 'widgetPlanning':
      return Block_jsx(dashboard_PlanningSummaryBlock, (0,esm_extends/* default */.Z)({
        renderWidth: renderWidth
      }, block, {
        "data-id": "components_Block_PlanningSummaryBlock"
      }));

    case 'planning':
      return Block_jsx(dashboard_PlanningBlock, (0,esm_extends/* default */.Z)({
        renderWidth: renderWidth
      }, block, {
        "data-id": "components_Block_PlanningBlock"
      }));

    case 'widgetCommunity':
      return Block_jsx(dashboard_CommunityBlock, (0,esm_extends/* default */.Z)({
        renderWidth: renderWidth
      }, block, {
        "data-id": "components_Block_CommunityBlock"
      }));

    case 'wishlistMoodboard':
      return Block_jsx(DesignsBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_DesignsBlock"
      }));

    case 'houseOverview':
      return Block_jsx(components_MyHouseBlock, (0,esm_extends/* default */.Z)({}, block, {
        renderWidth: renderWidth,
        "data-id": "components_Block_MyHouseBlock"
      }));

    case 'neighbour':
      return Block_jsx(dashboard_NeighboursBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_NeighboursBlock"
      }));

    case 'experienceRatingOverview':
      return Block_jsx(ECWInterestsBlock, (0,esm_extends/* default */.Z)({}, block, {
        renderWidth: renderWidth,
        "data-id": "components_Block_ECWInterestsBlock"
      }));

    case 'widgetMyhouseDocument':
      return Block_jsx(dashboard_MyHouseAndDocsBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_MyHouseAndDocsBlock"
      }));

    case 'widgetProjectMap':
      return Block_jsx(components_ProjectMapBlock, (0,esm_extends/* default */.Z)({}, block, {
        renderWidth: renderWidth,
        "data-id": "components_Block_ProjectMapBlock"
      }));

    case 'profileOverview':
      return Block_jsx(dashboard_ProfileOverviewBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_ProfileOverviewBlock"
      }));

    case 'lijst':
      return Block_jsx(components_ExpandableListBlock, (0,esm_extends/* default */.Z)({}, block, {
        "data-id": "components_Block_ExpandableListBlock"
      }));

    case 'forum':
    case 'messageCenter':
    case 'documentCenter':
      return Block_jsx(components_IFrameBlock, (0,esm_extends/* default */.Z)({}, block, {
        renderWidth: renderWidth,
        "data-id": "components_Block_IFrameBlock"
      }));

    default:
      return null;
  }
};

/* harmony default export */ var components_Block = (Block_Block);
;// CONCATENATED MODULE: ./src/services/isLastItem.js
/* harmony default export */ var isLastItem = (function (itemsArray, index) {
  return itemsArray.length - 1 === index;
});
;// CONCATENATED MODULE: ./src/components/shared/layout/LayoutHouseType.js



var LayoutHouseType_templateObject, LayoutHouseType_templateObject2, LayoutHouseType_templateObject3, LayoutHouseType_templateObject4, LayoutHouseType_templateObject5, LayoutHouseType_templateObject6, LayoutHouseType_templateObject7, LayoutHouseType_templateObject8, LayoutHouseType_templateObject9, LayoutHouseType_templateObject0, LayoutHouseType_templateObject1, LayoutHouseType_templateObject10, LayoutHouseType_templateObject11, LayoutHouseType_templateObject12, LayoutHouseType_templateObject13, LayoutHouseType_templateObject14, LayoutHouseType_templateObject15, LayoutHouseType_templateObject16, LayoutHouseType_templateObject17, LayoutHouseType_templateObject18;

var LayoutHouseType_jsx = react.createElement;












var LayoutHouseType = function LayoutHouseType(_ref) {
  var data = _ref.data,
      renderWidth = _ref.renderWidth;
  var variantName = data.variantName,
      variantCodes = data.variantCodes,
      totalCount = data.totalCount,
      isSold = data.isSold,
      availableCount = data.availableCount,
      optionCount = data.optionCount,
      energyLabel = data.energyLabel,
      price = data.price,
      media = data.media,
      description = data.description,
      blocks = data.blocks,
      livingSpace = data.livingSpace,
      bedrooms = data.bedrooms;
  return LayoutHouseType_jsx(HouseTypeGridWrapper, {
    "data-id": "layout_LayoutHouseType_HouseTypeGridWrapper"
  }, LayoutHouseType_jsx(PageTitle, {
    "data-id": "layout_LayoutHouseType_PageTitle"
  }, "".concat(variantName, " ").concat(variantCodes && variantCodes.length > 0 ? "- ".concat(variantCodes.join(', ')) : "")), LayoutHouseType_jsx(AvailabilityList, {
    "data-id": "layout_LayoutHouseType_AvailabilityList"
  }, LayoutHouseType_jsx(AvailabilityItem, {
    "data-id": "layout_LayoutHouseType_AvailabilityItem"
  }, totalCount, " ", totalCount === 1 ? 'woning' : 'woningen', !isSold && LayoutHouseType_jsx(AvailabilityDivider, {
    "data-id": "layout_LayoutHouseType_AvailabilityDivider"
  })), availableCount !== 0 && LayoutHouseType_jsx(AvailabilityItem, {
    color: styleGuide/* colorPalette.green */.K5.green,
    "data-id": "layout_LayoutHouseType_AvailabilityItem"
  }, availableCount, " te koop", optionCount !== 0 && LayoutHouseType_jsx(AvailabilityDivider, {
    "data-id": "layout_LayoutHouseType_AvailabilityDivider"
  })), optionCount !== 0 && LayoutHouseType_jsx(AvailabilityItem, {
    color: styleGuide/* colorPalette.signalOrange */.K5.signalOrange,
    "data-id": "layout_LayoutHouseType_AvailabilityItem"
  }, optionCount, " onder optie")), LayoutHouseType_jsx(PropertyInfoList, {
    "data-id": "layout_LayoutHouseType_PropertyInfoList"
  }, LayoutHouseType_jsx(PropertyInfoItem, {
    line: energyLabel,
    "data-id": "layout_LayoutHouseType_PropertyInfoItem"
  }, LayoutHouseType_jsx(PropertyInfoLabel, {
    "data-id": "layout_LayoutHouseType_PropertyInfoLabel"
  }, "Woonoppervlak: "), LayoutHouseType_jsx(PropertyInfoValue, {
    "data-id": "layout_LayoutHouseType_PropertyInfoValue"
  }, LayoutHouseType_jsx("span", {
    "data-id": "layout_LayoutHouseType_span"
  }, livingSpace, "m\xB2"))), LayoutHouseType_jsx(PropertyInfoItem, {
    line: energyLabel,
    "data-id": "layout_LayoutHouseType_PropertyInfoItem"
  }, LayoutHouseType_jsx(PropertyInfoLabel, {
    "data-id": "layout_LayoutHouseType_PropertyInfoLabel"
  }, "Slaapkamers: "), LayoutHouseType_jsx(PropertyInfoValue, {
    "data-id": "layout_LayoutHouseType_PropertyInfoValue"
  }, LayoutHouseType_jsx("span", {
    "data-id": "layout_LayoutHouseType_span"
  }, bedrooms))), LayoutHouseType_jsx(PropertyInfoItem, {
    line: energyLabel,
    "data-id": "layout_LayoutHouseType_PropertyInfoItem"
  }, LayoutHouseType_jsx(PropertyInfoLabel, {
    "data-id": "layout_LayoutHouseType_PropertyInfoLabel"
  }, "Prijs: "), isSold ? LayoutHouseType_jsx(PropertyInfoValue, {
    "data-id": "layout_LayoutHouseType_PropertyInfoValue"
  }, LayoutHouseType_jsx("span", {
    "data-id": "layout_LayoutHouseType_span"
  }, "Verkocht")) : LayoutHouseType_jsx(PropertyInfoValue, {
    "data-id": "layout_LayoutHouseType_PropertyInfoValue"
  }, "vanaf ", LayoutHouseType_jsx("span", {
    "data-id": "layout_LayoutHouseType_span"
  }, formatPrice(price, {
    showDecimal: true
  })), " v.o.n."))), LayoutHouseType_jsx(components_PictureCollage, {
    media: media,
    renderWidth: renderWidth,
    "data-id": "layout_LayoutHouseType_PictureCollage"
  }), LayoutHouseType_jsx(LayoutHouseType_ContentWrapper, {
    "data-id": "layout_LayoutHouseType_ContentWrapper"
  }, LayoutHouseType_jsx(components_RichTextBlockExpand, {
    richtext: description,
    "data-id": "layout_LayoutHouseType_RichTextBlockExpand"
  })), blocks.map(function (block, index) {
    switch (block.type) {
      case 'richtext':
        return LayoutHouseType_jsx(LayoutHouseType_ContentWrapper, {
          "data-id": "layout_LayoutHouseType_ContentWrapper"
        }, LayoutHouseType_jsx(RichTextCell, {
          key: index,
          "data-id": "layout_LayoutHouseType_RichTextCell"
        }, LayoutHouseType_jsx(components_Block, {
          block: block,
          isLastItem: isLastItem(blocks, index),
          "data-id": "layout_LayoutHouseType_Block"
        })));

      case 'pricelist':
        return LayoutHouseType_jsx(PriceListCell, {
          key: index,
          "data-id": "layout_LayoutHouseType_PriceListCell"
        }, LayoutHouseType_jsx(components_PricelistBlock, (0,esm_extends/* default */.Z)({
          layoutHouseType: true,
          renderWidth: renderWidth
        }, block, {
          isLastItem: isLastItem(blocks, index),
          "data-id": "layout_LayoutHouseType_PricelistBlock"
        })));

      case 'housetypeCarousel':
      default:
        return LayoutHouseType_jsx(CarouselCell, {
          key: index,
          "data-id": "layout_LayoutHouseType_CarouselCell"
        }, LayoutHouseType_jsx(LayoutHouseType_TypeTitle, {
          "data-id": "layout_LayoutHouseType_TypeTitle"
        }, "Andere woningen bekijken"), LayoutHouseType_jsx(components_Block, {
          block: block,
          isLastItem: isLastItem(blocks, index),
          "data-id": "layout_LayoutHouseType_Block"
        }));
    }
  }));
};

/* harmony default export */ var layout_LayoutHouseType = (LayoutHouseType);
var RichTextCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LayoutHouseType_templateObject || (LayoutHouseType_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 20rem;\n  padding-bottom: 20rem;\n  margin-bottom: 10rem;\n"])));
var PriceListCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LayoutHouseType_templateObject2 || (LayoutHouseType_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  margin-bottom: 50rem;\n"])));
var CarouselCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LayoutHouseType_templateObject3 || (LayoutHouseType_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n"])));
var LayoutHouseType_ContentWrapper = styled_components_browser_esm["default"].div(LayoutHouseType_templateObject4 || (LayoutHouseType_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 780rem;\n  margin: 50rem auto 10rem auto;\n  position: relative;\n  max-height: ", "rem;\n  overflow: hidden;\n  transition: max-height 0.4s ease-in-out;\n  z-index: 1;\n"])), function (props) {
  return !props.showMore ? props.maxHeight : '300';
});
var HouseTypeGridWrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(LayoutHouseType_templateObject5 || (LayoutHouseType_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-sizing: border-box;\n  padding: 40rem 20rem 0 20rem;\n"])));
var PageTitle = styled_components_browser_esm["default"].h1(LayoutHouseType_templateObject6 || (LayoutHouseType_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  width: 100%;\n  margin-top: 0rem;\n  margin-bottom: 5rem;\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey, breakpoints/* fromBreakpoint.md */.ks.md(LayoutHouseType_templateObject7 || (LayoutHouseType_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 20rem;\n  "]))));
var LayoutHouseType_TypeTitle = styled_components_browser_esm["default"].div(LayoutHouseType_templateObject8 || (LayoutHouseType_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-top: 40rem;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.textGrey */.K5.textGrey);
var AvailabilityList = styled_components_browser_esm["default"].ul(LayoutHouseType_templateObject9 || (LayoutHouseType_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  list-style: none;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 20rem;\n\n  ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, breakpoints/* fromBreakpoint.md */.ks.md(LayoutHouseType_templateObject0 || (LayoutHouseType_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 40rem;\n  "]))));
var AvailabilityItem = styled_components_browser_esm["default"].li(LayoutHouseType_templateObject1 || (LayoutHouseType_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  position: relative;\n  margin-bottom: 5rem;\n  color: ", ";\n"])), function (props) {
  return props.color ? props.color : styleGuide/* colorPalette.textGrey */.K5.textGrey;
});
var AvailabilityDivider = styled_components_browser_esm["default"].span(LayoutHouseType_templateObject10 || (LayoutHouseType_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  width: 1rem;\n  height: 20rem;\n  background-color: ", ";\n  margin: 0 10rem;\n  position: relative;\n  top: 4rem;\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey);
var PropertyInfoList = styled_components_browser_esm["default"].ul(LayoutHouseType_templateObject11 || (LayoutHouseType_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  list-style: none;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 20rem;\n\n  ", ";\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText, breakpoints/* fromBreakpoint.md */.ks.md(LayoutHouseType_templateObject12 || (LayoutHouseType_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 20rem;\n    display: flex;\n    justify-content: space-around;\n  "]))));
var PropertyInfoItem = styled_components_browser_esm["default"].li(LayoutHouseType_templateObject13 || (LayoutHouseType_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  width: 100%;\n  position: relative;\n  margin-bottom: 5rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(LayoutHouseType_templateObject14 || (LayoutHouseType_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 0 10rem;\n\n    ", "\n  "])), function (props) {
  return props.line ? "&:nth-of-type(1), &:nth-of-type(2), &:nth-of-type(3) {\n        &:after {\n          position: absolute;\n          content: '';\n          width: 2rem;\n          height: 45rem;\n          background-color: ".concat(styleGuide/* colorPalette.lightGrey */.K5.lightGrey, ";\n          right: 0;\n          top: 4rem;\n        }") : "&:nth-of-type(1), &:nth-of-type(2) {\n        &:after {\n          position: absolute;\n          content: '';\n          width: 2rem;\n          height: 45rem;\n          background-color: ".concat(styleGuide/* colorPalette.lightGrey */.K5.lightGrey, ";\n          right: 0;\n          top: 4rem;\n        }");
}));
var PropertyInfoLabel = styled_components_browser_esm["default"].span(LayoutHouseType_templateObject15 || (LayoutHouseType_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(LayoutHouseType_templateObject16 || (LayoutHouseType_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: block;\n      text-align: center;\n  "]))));
var PropertyInfoValue = styled_components_browser_esm["default"].span(LayoutHouseType_templateObject17 || (LayoutHouseType_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  > span {\n    font-weight: bold;\n  }\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(LayoutHouseType_templateObject18 || (LayoutHouseType_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: block;\n      text-align: center;\n  "]))));
;// CONCATENATED MODULE: ./src/components/contentTypes/HouseType.js






var HouseType_jsx = react.createElement;

function HouseType_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, HouseType_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function HouseType_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (HouseType_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}












var HouseType_connectApiData = (0,withApiData/* default */.Z)({
  houseType: 'getHouseType'
}, function (ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env,
      houseTypeSlug = _ownProps$match$param.houseTypeSlug;
  return {
    houseType: {
      projectSlug: projectSlug,
      env: env,
      houseTypeSlug: houseTypeSlug
    }
  };
});

var HouseType_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getNewHouseType: function getNewHouseType(projectSlug, env, houseTypeSlug) {
      dispatch((0,apiData/* performApiRequest */.T4)('getHouseType', {
        projectSlug: projectSlug,
        env: env,
        houseTypeSlug: houseTypeSlug
      }));
    }
  };
};

var HouseTypeContainer = /*#__PURE__*/function (_Component) {
  function HouseTypeContainer() {
    (0,classCallCheck/* default */.Z)(this, HouseTypeContainer);

    return HouseType_callSuper(this, HouseTypeContainer, arguments);
  }

  (0,inherits/* default */.Z)(HouseTypeContainer, _Component);

  return (0,createClass/* default */.Z)(HouseTypeContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          match = _this$props.match,
          getNewHouseType = _this$props.getNewHouseType;
      var _match$params = match.params,
          projectSlug = _match$params.projectSlug,
          env = _match$params.env,
          houseTypeSlug = _match$params.houseTypeSlug;
      var _prevProps$match$para = prevProps.match.params,
          oldProjectSlug = _prevProps$match$para.projectSlug,
          oldEnv = _prevProps$match$para.env,
          oldHouseTypeSlug = _prevProps$match$para.houseTypeSlug;

      if (oldProjectSlug !== projectSlug || oldEnv !== env || oldHouseTypeSlug !== houseTypeSlug) {
        getNewHouseType(String(projectSlug), String(env), String(houseTypeSlug));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          houseType = _this$props2.houseType,
          match = _this$props2.match,
          settings = _this$props2.settings,
          renderWidth = _this$props2.renderWidth;
      var pageNotFound = lodash_get_default()(houseType, 'request.response.status') === 404;
      var title = houseType.data && settings ? "".concat(houseType.data.variantName, " - ").concat(houseType.data.variantCodes && houseType.data.variantCodes.length ? houseType.data.variantCodes.join(', ') : '', " - ").concat(settings.siteName) : undefined;
      var meta = houseType.data ? {
        metaTitle: title
      } : {};
      var layoutSettings = {
        hasHeader: true,
        hasFooter: true,
        hasMenu: true
      };
      return HouseType_jsx(layout_LayoutBase, {
        settings: settings,
        layoutSettings: layoutSettings,
        renderWidth: renderWidth,
        title: title,
        meta: meta,
        "data-id": "contentTypes_HouseType_LayoutBase"
      }, houseType.data && !pageNotFound && HouseType_jsx(layout_LayoutHouseType, {
        renderWidth: renderWidth,
        data: houseType.data,
        "data-id": "contentTypes_HouseType_LayoutHouseType"
      }), houseType.request.networkStatus === 'loading' && HouseType_jsx(ContentLoader/* default */.Z, {
        "data-id": "contentTypes_HouseType_ContentLoader"
      }), pageNotFound && HouseType_jsx(ErrorBlock/* default */.Z, (0,esm_extends/* default */.Z)({}, (0,errorMessages/* getErrorBlockProps */.k)(match, 'houseType', 404), {
        "data-id": "contentTypes_HouseType_ErrorBlock"
      })));
    }
  }]);
}(react.Component);

/* harmony default export */ var HouseType = (WithSettings(HouseType_connectApiData((0,es/* connect */.$j)(null, HouseType_mapDispatchToProps)(HouseTypeContainer))));
;// CONCATENATED MODULE: ./src/components/HeroFlex.js








var HeroFlex_templateObject, HeroFlex_templateObject2;

var HeroFlex_jsx = react.createElement;

function HeroFlex_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, HeroFlex_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function HeroFlex_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (HeroFlex_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}





var BREAKPOINT = 380;

var HeroFlex = /*#__PURE__*/function (_Component) {
  function HeroFlex() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, HeroFlex);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = HeroFlex_callSuper(this, HeroFlex, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      renderWidth: 0
    });

    return _this;
  }

  (0,inherits/* default */.Z)(HeroFlex, _Component);

  return (0,createClass/* default */.Z)(HeroFlex, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          renderWidth = _this$props.renderWidth,
          heroTriangleSmallColor = _this$props.heroTriangleSmallColor,
          heroTriangleLargeColor = _this$props.heroTriangleLargeColor,
          desktopImage = _this$props.desktopImage,
          mobileImage = _this$props.mobileImage;
      return HeroFlex_jsx(HeroFlex_View, {
        size: renderWidth > BREAKPOINT ? 'large' : 'small',
        "data-id": "components_HeroFlex_View"
      }, HeroFlex_jsx(ImageLoader/* default */.Z, {
        src: renderWidth > BREAKPOINT ? desktopImage || '' : mobileImage || '',
        mode: "bg",
        width: renderWidth,
        "data-id": "components_HeroFlex_ImageLoader"
      }), HeroFlex_jsx(HeroFlex_Triangle, {
        height: "58%",
        width: "100%",
        viewBox: "0 0 203 203",
        preserveAspectRatio: "xMaxYMin",
        "data-id": "components_HeroFlex_Triangle"
      }, HeroFlex_jsx("polygon", {
        opacity: "0.5",
        fill: heroTriangleSmallColor || styleGuide/* colorPalette.lightGreen */.K5.lightGreen,
        transform: "translate(101.500000, 101.500000) scale(1, -1) translate(-101.500000, -101.500000)",
        points: "203 0 203 203 0 203",
        "data-id": "components_HeroFlex_polygon"
      })), HeroFlex_jsx(HeroFlex_Triangle, {
        height: "100%",
        width: "100%",
        viewBox: "0 0 349 349",
        preserveAspectRatio: "xMaxYMax",
        "data-id": "components_HeroFlex_Triangle"
      }, HeroFlex_jsx("polygon", {
        opacity: "0.75",
        fill: heroTriangleLargeColor || styleGuide/* colorPalette.lightGreen */.K5.lightGreen,
        points: "349 0 349 349 0 349",
        "data-id": "components_HeroFlex_polygon"
      })));
    }
  }]);
}(react.Component);

var HeroFlex_View = styled_components_browser_esm["default"].div(HeroFlex_templateObject || (HeroFlex_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  box-sizing: border-box;\n  padding-top: ", ";\n  width: 100%;\n  position: relative;\n\n  > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, function (props) {
  return props.size === 'large' ? '24.3%' : '78%';
});
var HeroFlex_Triangle = styled_components_browser_esm["default"].svg(HeroFlex_templateObject2 || (HeroFlex_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 2;\n"])));
/* harmony default export */ var components_HeroFlex = (HeroFlex);
;// CONCATENATED MODULE: ./src/components/PageTextHero.js


var PageTextHero_templateObject, PageTextHero_templateObject2, PageTextHero_templateObject3, PageTextHero_templateObject4, PageTextHero_templateObject5, PageTextHero_templateObject6, PageTextHero_templateObject7, PageTextHero_templateObject8, PageTextHero_templateObject9, PageTextHero_templateObject0, PageTextHero_templateObject1, PageTextHero_templateObject10, PageTextHero_templateObject11;

var PageTextHero_jsx = react.createElement;








var PageTextHero = function PageTextHero(_ref) {
  var heroText = _ref.heroText,
      env = _ref.env,
      renderWidth = _ref.renderWidth;
  var title = heroText.title,
      subtitle = heroText.subtitle,
      introText = heroText.introText;
  return env === 'open' ? PageTextHero_jsx(PageTextHero_Container, {
    "data-id": "components_PageTextHero_Container"
  }, PageTextHero_jsx(PageTextHero_Title, {
    "data-id": "components_PageTextHero_Title"
  }, title), subtitle && PageTextHero_jsx(Subtitle, {
    "data-id": "components_PageTextHero_Subtitle"
  }, subtitle), introText && PageTextHero_jsx(PageTextHero_IntroText, {
    "data-id": "components_PageTextHero_IntroText"
  }, introText)) : PageTextHero_jsx(ContainerFlex, {
    "data-id": "components_PageTextHero_ContainerFlex"
  }, renderWidth && PageTextHero_jsx(TriangleContainer, {
    "data-id": "components_PageTextHero_TriangleContainer"
  }, PageTextHero_jsx(designElements_Triangle, {
    direction: "topleft",
    color: (0,utils/* hex2rgb */.wK)(styleGuide/* colorPalette.orange */.K5.orange, 0.25),
    width: renderWidth > breakpoints/* breakpointSizes.lg */.YA.lg ? 350 : 300,
    height: renderWidth > breakpoints/* breakpointSizes.lg */.YA.lg ? 350 : 300,
    "data-id": "components_PageTextHero_Triangle"
  })), PageTextHero_jsx(TextFlex, {
    "data-id": "components_PageTextHero_TextFlex"
  }, PageTextHero_jsx(PageTextHero_Title, {
    "data-id": "components_PageTextHero_Title"
  }, title), subtitle && PageTextHero_jsx(Subtitle, {
    "data-id": "components_PageTextHero_Subtitle"
  }, subtitle), introText && PageTextHero_jsx(PageTextHero_IntroText, {
    "data-id": "components_PageTextHero_IntroText"
  }, introText)));
};

/* harmony default export */ var components_PageTextHero = (PageTextHero);
var PageTextHero_Container = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(PageTextHero_templateObject || (PageTextHero_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 40rem;\n  max-width: 760rem;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(PageTextHero_templateObject2 || (PageTextHero_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(PageTextHero_templateObject3 || (PageTextHero_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 80rem;\n    margin-bottom: 10rem;\n  "]))));
var PageTextHero_Title = styled_components_browser_esm["default"].h1(PageTextHero_templateObject4 || (PageTextHero_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 8rem;\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var Subtitle = styled_components_browser_esm["default"].h2(PageTextHero_templateObject5 || (PageTextHero_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 10rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var PageTextHero_IntroText = styled_components_browser_esm["default"].p(PageTextHero_templateObject6 || (PageTextHero_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  margin-top: 20rem;\n  margin-bottom: 0;\n\n  ", ";\n"])), styleGuide/* textStyles.introText */.sq.introText, styleGuide/* colorPalette.textGrey */.K5.textGrey, breakpoints/* fromBreakpoint.md */.ks.md(PageTextHero_templateObject7 || (PageTextHero_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 30rem;\n    margin-bottom: 0;\n  "]))));
var TextFlex = styled_components_browser_esm["default"].div(PageTextHero_templateObject8 || (PageTextHero_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 2;\n  margin-top: 0;\n  padding-bottom: 10rem;\n  color: #fff;\n  max-width: 760rem;\n  opacity: 0;\n  animation: ", " 0.75s ", ";\n  animation-fill-mode: forwards;\n  animation-delay: 0.7s;\n\n  > h1 {\n    color: #fff;\n    z-index: 2;\n  }\n\n  > h2 {\n    color: #fff;\n    z-index: 2;\n    margin-top: 0;\n  }\n\n  > p {\n    color: #fff;\n    z-index: 2;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0;\n  }\n"])), styleGuide/* fadeIn */.Ji, styleGuide/* CUBIC_TIMING */.I5);
var ContainerFlex = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(PageTextHero_templateObject9 || (PageTextHero_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  padding: 39rem 30rem 30rem;\n  margin: 30rem 10rem;\n  background-color: ", ";\n  opacity: 0;\n  min-height: 270rem;\n  transform-origin: 0 0;\n  animation: ", " 0.4s ", ";\n  animation-fill-mode: forwards;\n\n  ", ";\n\n  @media screen and (min-width: 1001px) {\n    margin: 100rem 20rem 40rem 20rem;\n  }\n"])), styleGuide/* colorPalette.lightOrange */.K5.lightOrange, styleGuide/* rollOutTop */.GP, styleGuide/* CUBIC_TIMING */.I5, breakpoints/* fromBreakpoint.md */.ks.md(PageTextHero_templateObject0 || (PageTextHero_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 30rem 20rem;\n    padding: 70rem 100rem;\n  "]))));
var TriangleContainer = styled_components_browser_esm["default"].div(PageTextHero_templateObject1 || (PageTextHero_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  z-index: 0;\n  top: -10rem;\n  left: -10rem;\n  height: 100%;\n  opacity: 0;\n  animation: ", " 0.5s ", ";\n  animation-delay: 0.4s;\n  animation-fill-mode: forwards;\n\n  > svg {\n    height: 100%;\n  }\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* moveUpLeft */.om, styleGuide/* CUBIC_TIMING */.I5, breakpoints/* toBreakpoint.md */.Hx.md(PageTextHero_templateObject10 || (PageTextHero_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 60%;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(PageTextHero_templateObject11 || (PageTextHero_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n    top: -20rem;\n    left: -20rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/shared/layout/LayoutFlex.js



var LayoutFlex_templateObject, LayoutFlex_templateObject2, LayoutFlex_templateObject3, LayoutFlex_templateObject4;

var LayoutFlex_jsx = react.createElement;












 // These blocks should have a white background on the flex template closed env

var WHITE_BACKGROUND_BLOCKS = {
  storyslider: true,
  richtext: true,
  forum: true,
  lijst: true,
  messageCenter: true,
  documentCenter: true
};

var LayoutFlex_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};

var getEnv = function getEnv(params) {
  if (params.projectSlug === 'portal') {
    return 'closed';
  }

  return String(params.env);
};

var LayoutFlex = function LayoutFlex(_ref) {
  var styling = _ref.styling,
      renderWidth = _ref.renderWidth,
      page = _ref.page,
      match = _ref.match;
  var templateProps = page.templateProps;
  return LayoutFlex_jsx("div", {
    "data-id": "layout_LayoutFlex_div"
  }, templateProps && templateProps.hero && styling && LayoutFlex_jsx(components_HeroFlex, (0,esm_extends/* default */.Z)({}, templateProps.hero, {
    heroTriangleSmallColor: getEnv(match.params) ? styling.heroTriangleSmall : styleGuide/* colorPalette.beige */.K5.beige,
    heroTriangleLargeColor: getEnv(match.params) ? styling.heroTriangleLarge : styleGuide/* colorPalette.beige */.K5.beige,
    renderWidth: renderWidth,
    "data-id": "layout_LayoutFlex_HeroFlex"
  })), LayoutFlex_jsx(gridElements/* GridWrapper */.zc, {
    "data-id": "layout_LayoutFlex_GridWrapper"
  }, templateProps && LayoutFlex_jsx(components_PageTextHero, {
    env: getEnv(match.params),
    heroText: templateProps,
    renderWidth: renderWidth,
    "data-id": "layout_LayoutFlex_PageTextHero"
  }), (page.blocks || []).map(function (block, index) {
    return LayoutFlex_jsx(LayoutFlex_BlockCell, {
      key: index,
      whiteBackground: lodash_get_default()(WHITE_BACKGROUND_BLOCKS, block.type),
      noGutterUntilBreakpoint: block.type === 'storyslider' ? breakpoints/* breakpointSizes.md */.YA.md : 0,
      "data-id": "layout_LayoutFlex_BlockCell"
    }, LayoutFlex_jsx(components_Block, {
      block: block,
      renderWidth: renderWidth,
      isLastItem: isLastItem(page.blocks, index),
      "data-id": "layout_LayoutFlex_Block"
    }));
  })));
};

/* harmony default export */ var layout_LayoutFlex = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(LayoutFlex_mapStateToProps)(LayoutFlex)));
var LayoutFlex_BlockCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LayoutFlex_templateObject || (LayoutFlex_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 0rem;\n  padding-bottom: 40rem;\n\n  ", " &:last-child {\n    ", ";\n\n    ", ";\n  }\n"])), breakpoints/* toBreakpoint.md */.Hx.md(LayoutFlex_templateObject2 || (LayoutFlex_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-right: 10rem;\n    padding-left: 10rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(LayoutFlex_templateObject3 || (LayoutFlex_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 0;\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(LayoutFlex_templateObject4 || (LayoutFlex_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 30rem;\n    "]))));
;// CONCATENATED MODULE: ./src/components/dashboard/HeroDashboard.js


var HeroDashboard_templateObject, HeroDashboard_templateObject2, HeroDashboard_templateObject3, HeroDashboard_templateObject4, HeroDashboard_templateObject5, HeroDashboard_templateObject6, HeroDashboard_templateObject7, HeroDashboard_templateObject8, HeroDashboard_templateObject9, HeroDashboard_templateObject0, HeroDashboard_templateObject1, HeroDashboard_templateObject10, HeroDashboard_templateObject11, HeroDashboard_templateObject12, HeroDashboard_templateObject13;

var HeroDashboard_jsx = react.createElement;







var HeroDashboard = function HeroDashboard(_ref) {
  var renderWidth = _ref.renderWidth,
      title = _ref.title,
      subtitle = _ref.subtitle,
      hero = _ref.hero;
  return HeroDashboard_jsx(HeroDashboard_Container, {
    "data-id": "dashboard_HeroDashboard_Container"
  }, HeroDashboard_jsx(ImageLoader/* default */.Z, {
    src: renderWidth > 380 ? lodash_get_default()(hero, 'desktopImage') : lodash_get_default()(hero, 'mobileImage'),
    mode: "bg",
    position: "absolute",
    width: renderWidth,
    "data-id": "dashboard_HeroDashboard_ImageLoader"
  }), HeroDashboard_jsx(HeroDashboard_TextContainer, {
    "data-id": "dashboard_HeroDashboard_TextContainer"
  }, title && HeroDashboard_jsx(HeroDashboard_Title, {
    "data-id": "dashboard_HeroDashboard_Title"
  }, title), subtitle && HeroDashboard_jsx(HeroDashboard_SubTitle, {
    "data-id": "dashboard_HeroDashboard_SubTitle"
  }, subtitle), hero && hero.buttonLabel && HeroDashboard_jsx(HeroDashboard_Caption, {
    "data-id": "dashboard_HeroDashboard_Caption"
  }, hero.buttonLabel)));
};

var HeroDashboard_Container = styled_components_browser_esm["default"].div(HeroDashboard_templateObject || (HeroDashboard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  min-height: 300rem;\n  box-sizing: border-box;\n\n  &:after {\n    position: absolute;\n    content: ' ';\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 2;\n    background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2));\n    pointer-events: none;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, breakpoints/* fromBreakpoint.md */.ks.md(HeroDashboard_templateObject2 || (HeroDashboard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 440rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(HeroDashboard_templateObject3 || (HeroDashboard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 552rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(HeroDashboard_templateObject4 || (HeroDashboard_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 621rem;\n  "]))), breakpoints/* fromBreakpoint.xxl */.ks.xxl(HeroDashboard_templateObject5 || (HeroDashboard_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 831rem;\n  "]))));
var HeroDashboard_TextContainer = styled_components_browser_esm["default"].div(HeroDashboard_templateObject6 || (HeroDashboard_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  color: white;\n  z-index: 2;\n  padding: 35rem 15rem 30rem 15rem;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), breakpoints/* fromBreakpoint.md */.ks.md(HeroDashboard_templateObject7 || (HeroDashboard_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 75rem;\n    max-width: calc( (7/8) * 100%);\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(HeroDashboard_templateObject8 || (HeroDashboard_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 50rem;\n    max-width: calc( (7/12) * 100%);\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(HeroDashboard_templateObject9 || (HeroDashboard_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 100rem 130rem;\n    max-width: calc( (6/12) * 100%);\n  "]))), breakpoints/* fromBreakpoint.xxl */.ks.xxl(HeroDashboard_templateObject0 || (HeroDashboard_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: absolute;\n    top: 50%;\n    left: 10%;\n    transform: translateY(-50%);\n    max-width: 50%;\n  "]))));
var HeroDashboard_Title = styled_components_browser_esm["default"].h1(HeroDashboard_templateObject1 || (HeroDashboard_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 15rem;\n  max-width: 780rem;\n  font-family: 'Foco';\n  font-weight: bold;\n  ", ";\n  ", ";\n"])), styleGuide/* shadows.textPrimary */.q.textPrimary, styleGuide/* textStyles.pageTitle */.sq.pageTitle);
var HeroDashboard_SubTitle = styled_components_browser_esm["default"].p(HeroDashboard_templateObject10 || (HeroDashboard_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 40rem;\n  font-family: 'Foco';\n  font-weight: bold;\n  ", ";\n  ", ";\n"])), styleGuide/* shadows.textPrimary */.q.textPrimary, styleGuide/* textStyles.title */.sq.title);
var HeroDashboard_Caption = styled_components_browser_esm["default"].div(HeroDashboard_templateObject11 || (HeroDashboard_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  max-width: 200rem;\n  bottom: 80px;\n  position: absolute;\n\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.caption */.sq.caption, breakpoints/* fromBreakpoint.lg */.ks.lg(HeroDashboard_templateObject12 || (HeroDashboard_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 436rem;\n    bottom: 60px;\n    max-width: 320rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(HeroDashboard_templateObject13 || (HeroDashboard_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 500rem;\n  "]))));
/* harmony default export */ var dashboard_HeroDashboard = (HeroDashboard);
;// CONCATENATED MODULE: ./src/components/shared/layout/LayoutDashboard.js








var LayoutDashboard_templateObject, LayoutDashboard_templateObject2, LayoutDashboard_templateObject3;

var LayoutDashboard_jsx = react.createElement;

function LayoutDashboard_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, LayoutDashboard_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function LayoutDashboard_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (LayoutDashboard_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}













var LayoutDashboard_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    redirect: lodash_get_default()(state, 'redirect'),
    resultWishList: (0,apiData/* getResultData */.yh)(state.apiData, 'postWishList', {
      projectSlug: String(ownProps.match.params.projectSlug)
    }),
    notificationsRequest: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'getNotifications', {
      projectSlug: String(ownProps.match.params.projectSlug)
    }),
    settings: (0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    })
  };
};

var LayoutDashboard_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    invalidateNotifications: function invalidateNotifications(projectSlug) {
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('getNotifications', {
        projectSlug: String(projectSlug)
      }));
    }
  };
};

var LayoutDashboard = /*#__PURE__*/function (_Component) {
  function LayoutDashboard() {
    (0,classCallCheck/* default */.Z)(this, LayoutDashboard);

    return LayoutDashboard_callSuper(this, LayoutDashboard, arguments);
  }

  (0,inherits/* default */.Z)(LayoutDashboard, _Component);

  return (0,createClass/* default */.Z)(LayoutDashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          match = _this$props.match,
          notificationsRequest = _this$props.notificationsRequest,
          invalidateNotifications = _this$props.invalidateNotifications;
      var projectSlug = match.params.projectSlug; // If more than 30 seconds have passed since the last time we retrieved notifications, get them again

      if (notificationsRequest && projectSlug && Date.now() - notificationsRequest.lastCall > 30000) {
        invalidateNotifications(projectSlug);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          page = _this$props2.page,
          renderWidth = _this$props2.renderWidth;
      return LayoutDashboard_jsx("div", {
        "data-e2e-page-layout": "dashboard",
        "data-id": "layout_LayoutDashboard_div"
      }, page.templateProps && LayoutDashboard_jsx(dashboard_HeroDashboard, (0,esm_extends/* default */.Z)({}, page.templateProps, {
        renderWidth: renderWidth,
        "data-id": "layout_LayoutDashboard_HeroDashboard"
      })), LayoutDashboard_jsx(DashboardGridWrapper, {
        "data-id": "layout_LayoutDashboard_DashboardGridWrapper"
      }, (page.blocks || []).map(function (block, index) {
        return LayoutDashboard_jsx(LayoutDashboard_BlockCell, {
          key: index,
          "data-id": "layout_LayoutDashboard_BlockCell"
        }, LayoutDashboard_jsx(components_Block, {
          block: block,
          renderWidth: renderWidth,
          isLastItem: isLastItem(page.blocks, index),
          "data-id": "layout_LayoutDashboard_Block"
        }));
      })));
    }
  }]);
}(react.Component);

var DashboardGridWrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(LayoutDashboard_templateObject || (LayoutDashboard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 3;\n"])));
var LayoutDashboard_BlockCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LayoutDashboard_templateObject2 || (LayoutDashboard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 30rem;\n  padding-bottom: 30rem;\n\n  ", ";\n"])), breakpoints/* toBreakpoint.md */.Hx.md(LayoutDashboard_templateObject3 || (LayoutDashboard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-right: 10rem;\n    padding-left: 10rem;\n  "]))));
/* harmony default export */ var layout_LayoutDashboard = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(LayoutDashboard_mapStateToProps, LayoutDashboard_mapDispatchToProps)(LayoutDashboard)));
;// CONCATENATED MODULE: ./src/components/HeroHome.js








var HeroHome_templateObject, HeroHome_templateObject2, HeroHome_templateObject3, HeroHome_templateObject4, HeroHome_templateObject5, HeroHome_templateObject6, HeroHome_templateObject7, HeroHome_templateObject8, HeroHome_templateObject9, HeroHome_templateObject0, HeroHome_templateObject1, HeroHome_templateObject10, HeroHome_templateObject11, HeroHome_templateObject12, HeroHome_templateObject13, HeroHome_templateObject14, HeroHome_templateObject15, HeroHome_templateObject16, HeroHome_templateObject17, HeroHome_templateObject18;

var HeroHome_jsx = react.createElement;

function HeroHome_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, HeroHome_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function HeroHome_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (HeroHome_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}











var HeroHome = /*#__PURE__*/function (_PureComponent) {
  function HeroHome() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, HeroHome);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = HeroHome_callSuper(this, HeroHome, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "state", {
      renderWidth: 0,
      renderHeight: 0
    });

    return _this;
  }

  (0,inherits/* default */.Z)(HeroHome, _PureComponent);

  return (0,createClass/* default */.Z)(HeroHome, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          hero = _this$props.hero,
          heroTriangleLargeColor = _this$props.heroTriangleLargeColor,
          heroTriangleSmallColor = _this$props.heroTriangleSmallColor,
          buttonColor = _this$props.buttonColor;
      var _this$state = this.state,
          renderWidth = _this$state.renderWidth,
          renderHeight = _this$state.renderHeight;
      return HeroHome_jsx(ObserveSize/* default */.Z, {
        observerFn: function observerFn(contentRect) {
          return _this2.setState({
            renderWidth: contentRect.width,
            renderHeight: Math.round(contentRect.height)
          });
        },
        "data-id": "components_HeroHome_ObserveSize"
      }, HeroHome_jsx(HeroHome_Container, {
        "data-id": "components_HeroHome_Container"
      }, HeroHome_jsx(ImageLoader/* default */.Z, {
        src: renderWidth > 380 ? hero.desktopImage || '' : hero.mobileImage || '',
        mode: "bg",
        position: "absolute",
        width: renderWidth,
        height: renderHeight,
        "data-id": "components_HeroHome_ImageLoader"
      }), HeroHome_jsx(TopTriangle, {
        borderTopColor: heroTriangleSmallColor || styleGuide/* colorPalette.lightGreen */.K5.lightGreen,
        "data-id": "components_HeroHome_TopTriangle"
      }), HeroHome_jsx(BottomTriangle, {
        borderLeftColor: heroTriangleLargeColor || styleGuide/* colorPalette.green */.K5.green,
        "data-id": "components_HeroHome_BottomTriangle"
      }), HeroHome_jsx(HeroHome_TextContainer, {
        "data-id": "components_HeroHome_TextContainer"
      }, HeroHome_jsx(HeroHome_Title, {
        "data-id": "components_HeroHome_Title"
      }, hero.title), HeroHome_jsx(HeroHome_SubTitle, {
        "data-id": "components_HeroHome_SubTitle"
      }, hero.subtitle), hero.internalLink ? HeroHome_jsx(ButtonPrimary/* default */.Z, {
        color: buttonColor,
        type: "internalLink",
        link: '/' + (0,getLinkFromPageObject/* default */.Z)(hero.internalLink),
        label: hero.buttonLabel || '',
        "data-id": "components_HeroHome_ButtonPrimary"
      }) : hero.externalLink ? HeroHome_jsx(ButtonPrimary/* default */.Z, {
        color: buttonColor,
        type: "externalLink",
        link: hero.externalLink,
        label: hero.buttonLabel || '',
        "data-id": "components_HeroHome_ButtonPrimary_9"
      }) : null)));
    }
  }]);
}(react.PureComponent); // $FlowFixMe


/* harmony default export */ var components_HeroHome = ((0,withMatch/* default */.Z)(HeroHome));
var HeroHome_Container = styled_components_browser_esm["default"].div(HeroHome_templateObject || (HeroHome_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  min-height: 444rem;\n  box-sizing: border-box;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, breakpoints/* fromBreakpoint.lg */.ks.lg(HeroHome_templateObject2 || (HeroHome_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 552rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(HeroHome_templateObject3 || (HeroHome_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 621rem;\n  "]))), breakpoints/* fromBreakpoint.xxl */.ks.xxl(HeroHome_templateObject4 || (HeroHome_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: 831rem;\n  "]))));
var HeroHome_TextContainer = styled_components_browser_esm["default"].div(HeroHome_templateObject5 || (HeroHome_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  color: white;\n  z-index: 3;\n  padding: 35rem 15rem 30rem 15rem;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), breakpoints/* fromBreakpoint.md */.ks.md(HeroHome_templateObject6 || (HeroHome_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 75rem;\n    max-width: calc( (7/8) * 100%);\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(HeroHome_templateObject7 || (HeroHome_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 80rem 50rem;\n    max-width: calc( (7/12) * 100%);\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(HeroHome_templateObject8 || (HeroHome_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 100rem 130rem;\n    max-width: calc( (6/12) * 100%);\n  "]))), breakpoints/* fromBreakpoint.xxl */.ks.xxl(HeroHome_templateObject9 || (HeroHome_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%)\n  "]))));
var HeroHome_Title = styled_components_browser_esm["default"].h1(HeroHome_templateObject0 || (HeroHome_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 15rem;\n  max-width: 780rem;\n  font-family: 'Foco';\n  font-weight: bold;\n  ", ";\n  ", ";\n"])), styleGuide/* shadows.textPrimary */.q.textPrimary, styleGuide/* textStyles.pageTitle */.sq.pageTitle);
var HeroHome_SubTitle = styled_components_browser_esm["default"].p(HeroHome_templateObject1 || (HeroHome_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 40rem;\n  font-family: 'Foco';\n  font-weight: bold;\n  ", ";\n  ", ";\n"])), styleGuide/* shadows.textPrimary */.q.textPrimary, styleGuide/* textStyles.title */.sq.title);
var TopTriangle = styled_components_browser_esm["default"].div(HeroHome_templateObject10 || (HeroHome_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 0;\n  padding-left: 100%;\n  padding-top: 100%;\n  overflow: hidden;\n  z-index: 3;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  @media screen and (min-width: 1920rem) {\n    padding-left: 482rem;\n    padding-top: 482rem;\n  }\n\n  &:after {\n    content: '';\n    display: block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0.5;\n    border-right: 185rem solid transparent;\n    border-top-width: 185rem;\n    border-top-style: solid;\n    border-top-color: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n    @media screen and (min-width: 1920rem) {\n      border-right: 482rem solid transparent;\n      border-top-width: 482rem;\n    }\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(HeroHome_templateObject11 || (HeroHome_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 256rem;\n    padding-top: 256rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(HeroHome_templateObject12 || (HeroHome_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 320rem;\n    padding-top: 320rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(HeroHome_templateObject13 || (HeroHome_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 360rem;\n    padding-top: 360rem;\n  "]))), function (props) {
  return props.borderTopColor;
}, breakpoints/* fromBreakpoint.md */.ks.md(HeroHome_templateObject14 || (HeroHome_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n      border-right: 256rem solid transparent;\n      border-top-width: 256rem;\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(HeroHome_templateObject15 || (HeroHome_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n      border-right: 320rem solid transparent;\n      border-top-width: 320rem;\n    "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(HeroHome_templateObject16 || (HeroHome_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n      border-right: 360rem solid transparent;\n      border-top-width: 360 rem;\n    "]))));
var BottomTriangle = styled_components_browser_esm["default"].div(HeroHome_templateObject17 || (HeroHome_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 0;\n  padding-top: 320rem;\n  overflow: hidden;\n  z-index: 2;\n\n  ", ";\n\n  &:after {\n    content: '';\n    display: block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    opacity: 0.75;\n    top: 0;\n    border-top: 8000rem solid transparent;\n    border-left-width: 8000rem;\n    border-left-style: solid;\n    border-left-color: ", ";\n  }\n"])), breakpoints/* fromBreakpoint.md */.ks.md(HeroHome_templateObject18 || (HeroHome_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n    bottom: auto;\n    top: 0;\n    width: 8000rem;\n    padding-top: 8000rem;\n  "]))), function (props) {
  return props.borderLeftColor;
});
;// CONCATENATED MODULE: ./src/components/shared/layout/LayoutHome.js


var LayoutHome_templateObject, LayoutHome_templateObject2, LayoutHome_templateObject3, LayoutHome_templateObject4;

var LayoutHome_jsx = react.createElement;












var LayoutHome_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: lodash_get_default()((0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', undefined)
  };
};

var LayoutHome = function LayoutHome(_ref) {
  var page = _ref.page,
      styling = _ref.styling,
      renderWidth = _ref.renderWidth;
  return LayoutHome_jsx("div", {
    "data-id": "layout_LayoutHome_div"
  }, page.templateProps && page.templateProps.hero && styling && styling.button && LayoutHome_jsx(components_HeroHome, {
    hero: page.templateProps.hero,
    heroTriangleSmallColor: styling.heroTriangleSmall,
    heroTriangleLargeColor: styling.heroTriangleLarge,
    buttonColor: styling.button,
    "data-id": "layout_LayoutHome_HeroHome"
  }), LayoutHome_jsx(LayoutHome_ContentWrapper, {
    "data-e2e-page-layout": "home",
    "data-id": "layout_LayoutHome_ContentWrapper"
  }, (page.blocks || []).map(function (block, index) {
    return LayoutHome_jsx(LayoutHome_BlockCell, {
      key: index,
      noGutterUntilBreakpoint: block.type === 'storyslider' ? breakpoints/* breakpointSizes.md */.YA.md : 0,
      "data-id": "layout_LayoutHome_BlockCell"
    }, LayoutHome_jsx(components_Block, {
      block: block,
      isLastItem: isLastItem(page.blocks, index),
      renderWidth: renderWidth,
      "data-id": "layout_LayoutHome_Block"
    }));
  })));
};

LayoutHome.defaultProperties = {
  hasHeader: true,
  hasFooter: true,
  hasMenu: true
};
/* harmony default export */ var layout_LayoutHome = ((0,withMatch/* default */.Z)((0,es/* connect */.$j)(LayoutHome_mapStateToProps)(LayoutHome)));
var LayoutHome_BlockCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LayoutHome_templateObject || (LayoutHome_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-bottom: 20rem;\n\n  &:last-child {\n    ", ";\n\n    ", ";\n  }\n"])), breakpoints/* toBreakpoint.md */.Hx.md(LayoutHome_templateObject2 || (LayoutHome_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 0;\n    "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(LayoutHome_templateObject3 || (LayoutHome_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 30rem;\n    "]))));
var LayoutHome_ContentWrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(LayoutHome_templateObject4 || (LayoutHome_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 60rem;\n"])));
;// CONCATENATED MODULE: ./src/components/shared/layout/LayoutLogin.js


var LayoutLogin_templateObject, LayoutLogin_templateObject2, LayoutLogin_templateObject3, LayoutLogin_templateObject4, LayoutLogin_templateObject5, LayoutLogin_templateObject6, LayoutLogin_templateObject7, LayoutLogin_templateObject8, LayoutLogin_templateObject9, LayoutLogin_templateObject0, LayoutLogin_templateObject1, LayoutLogin_templateObject10, LayoutLogin_templateObject11, LayoutLogin_templateObject12;

var LayoutLogin_jsx = react.createElement;









var LayoutLogin = function LayoutLogin(_ref) {
  var page = _ref.page,
      renderWidth = _ref.renderWidth;
  var templateProps = page.templateProps;
  return LayoutLogin_jsx("div", {
    "data-e2e-page-layout": "login",
    "data-id": "layout_LayoutLogin_div"
  }, LayoutLogin_jsx(HeroContainer, {
    "data-id": "layout_LayoutLogin_HeroContainer"
  }, templateProps && LayoutLogin_jsx(components_HeroHome, {
    hero: templateProps.hero,
    heroTriangleSmallColor: styleGuide/* colorPalette.lightBeige */.K5.lightBeige,
    heroTriangleLargeColor: styleGuide/* colorPalette.beige */.K5.beige,
    renderWidth: renderWidth,
    "data-id": "layout_LayoutLogin_Hero"
  }), LayoutLogin_jsx(LayoutLogin_TextContainer, {
    "data-id": "layout_LayoutLogin_TextContainer"
  }, templateProps && templateProps.title && LayoutLogin_jsx(LayoutLogin_Title, {
    "data-id": "layout_LayoutLogin_Title"
  }, templateProps.title), templateProps && templateProps.subtitle && LayoutLogin_jsx(LayoutLogin_SubTitle, {
    "data-id": "layout_LayoutLogin_SubTitle"
  }, templateProps.subtitle))), LayoutLogin_jsx(LoginGridWrapper, {
    "data-id": "layout_LayoutLogin_LoginGridWrapper"
  }, (page.blocks || []).map(function (block, index) {
    return LayoutLogin_jsx(LayoutLogin_CopyCell, {
      key: index,
      "data-id": "layout_LayoutLogin_CopyCell"
    }, LayoutLogin_jsx(components_Block, {
      block: block,
      renderWidth: renderWidth,
      isLastItem: isLastItem(page.blocks, index),
      "data-id": "layout_LayoutLogin_Block"
    }));
  })));
};

var HeroContainer = styled_components_browser_esm["default"].div(LayoutLogin_templateObject || (LayoutLogin_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n"])));
var LoginGridWrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(LayoutLogin_templateObject2 || (LayoutLogin_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 2;\n  margin-top: -60rem;\n  margin-bottom: 20rem;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), breakpoints/* fromBreakpoint.md */.ks.md(LayoutLogin_templateObject3 || (LayoutLogin_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 80rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(LayoutLogin_templateObject4 || (LayoutLogin_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 50rem;\n  "]))), breakpoints/* fromBreakpoint.xl */.ks.xl(LayoutLogin_templateObject5 || (LayoutLogin_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 0;\n  "]))));
var LayoutLogin_TextContainer = styled_components_browser_esm["default"].div(LayoutLogin_templateObject6 || (LayoutLogin_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 10%;\n  left: 8%;\n  z-index: 5;\n  margin-right: 20rem;\n  max-width: 780rem;\n  margin-top: 60rem;\n\n  ", " ", ";\n"])), breakpoints/* toBreakpoint.lg */.Hx.lg(LayoutLogin_templateObject7 || (LayoutLogin_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 20rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(LayoutLogin_templateObject8 || (LayoutLogin_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    left: 5%;\n  "]))));
var LayoutLogin_Title = styled_components_browser_esm["default"].h1(LayoutLogin_templateObject9 || (LayoutLogin_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  ", ";\n  color: #fff;\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* shadows.textPrimary */.q.textPrimary);
var LayoutLogin_SubTitle = styled_components_browser_esm["default"].p(LayoutLogin_templateObject0 || (LayoutLogin_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " ", ";\n  color: #fff;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* shadows.textPrimary */.q.textPrimary);
var LayoutLogin_CopyCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(LayoutLogin_templateObject1 || (LayoutLogin_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 20rem;\n\n  ", "\n\n  ", "\n\n  ", "\n\n\n"])), breakpoints/* toBreakpoint.md */.Hx.md(LayoutLogin_templateObject10 || (LayoutLogin_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(LayoutLogin_templateObject11 || (LayoutLogin_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 100rem;\n    padding-right: 100rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(LayoutLogin_templateObject12 || (LayoutLogin_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: -190rem;\n    margin-left: 20rem;\n    margin-right: 20rem;\n  "]))));
/* harmony default export */ var layout_LayoutLogin = (LayoutLogin);
;// CONCATENATED MODULE: ./src/components/shared/layout/LayoutMap.js






var TEMPLATE_LAYOUT_MAP = {
  home: layout_LayoutHome,
  flex: layout_LayoutFlex,
  flex_closed: layout_LayoutFlex,
  dashboard: layout_LayoutDashboard,
  houseType: layout_LayoutHouseType,
  footerPage: layout_LayoutFooterPage,
  notLoggedIn: layout_LayoutLogin
};
;// CONCATENATED MODULE: ./src/components/PageModalHandler.js






var PageModalHandler_jsx = react.createElement;

function PageModalHandler_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, PageModalHandler_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function PageModalHandler_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (PageModalHandler_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}











var PageModalHandler_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var match = ownProps.match;
  var _match$params = match.params,
      projectSlug = _match$params.projectSlug,
      env = _match$params.env;

  var postModalDismiss = function postModalDismiss(modalId) {
    return function () {
      if (modalId !== undefined && !!projectSlug && !!env) {
        dispatch((0,apiData/* performApiRequest */.T4)('postModalDismiss', {
          projectSlug: projectSlug,
          env: env,
          modalId: modalId
        }));
      }
    };
  };

  var closeModal = function closeModal() {
    dispatch((0,redux_modal/* updateModalOpenState */.WU)(false));
    dispatch((0,redux_modal/* clearModalState */.TR)());
  };

  return {
    openModal: function openModal(id, type, content) {
      dispatch((0,redux_modal/* openModal */.h7)(type === 'general' ? styleGuide/* colorPalette.orange */.K5.orange : styleGuide/* colorPalette.beige */.K5.beige, {
        type: 'genericModal',
        onClose: postModalDismiss(id),
        componentProps: {
          id: id,
          content: content,
          onDismiss: function onDismiss() {
            postModalDismiss(id)();
            closeModal();
          }
        }
      }));
    }
  };
};
/**
 * This component is responsible for opening a modal if the page endpoint response has a item in the modals array. If the modal is closed, the dismiss endpoint is called, so the back end can track whether the user has seen the modal.
 */


var PageModalHandler = /*#__PURE__*/function (_Component) {
  function PageModalHandler() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, PageModalHandler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = PageModalHandler_callSuper(this, PageModalHandler, [].concat(args));

    (0,defineProperty/* default */.Z)(_this, "openModal", function () {
      var _getPage$data;

      var _this$props = _this.props,
          getPage = _this$props.getPage,
          openModal = _this$props.openModal;

      if (!((_getPage$data = getPage.data) !== null && _getPage$data !== void 0 && (_getPage$data = _getPage$data.modals) !== null && _getPage$data !== void 0 && _getPage$data[0])) {
        return;
      }

      var _getPage$data$modals$ = getPage.data.modals[0],
          id = _getPage$data$modals$.id,
          type = _getPage$data$modals$.type,
          body = _getPage$data$modals$.body;

      if (id !== undefined && !!body && type !== '') {
        openModal(id, type, PageModalHandler_jsx(BBCode/* default */.Z, {
          content: body,
          "data-id": "components_PageModalHandler_BBCode"
        }));
      }
    });

    return _this;
  }

  (0,inherits/* default */.Z)(PageModalHandler, _Component);

  return (0,createClass/* default */.Z)(PageModalHandler, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var getPage = this.props.getPage;
      var previousGetPage = prevProps.getPage;

      if (getPage.request.networkStatus === 'success' && previousGetPage.request.networkStatus !== 'success') {
        this.openModal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(react.Component);

var PageModalHandler_connectApiData = (0,withApiData/* default */.Z)({
  getPage: 'getPage'
}, function (_ref) {
  var match = _ref.match;
  return {
    getPage: {
      pagePath: (0,getLinkFromPageObject/* default */.Z)(match.params)
    }
  };
});
/* harmony default export */ var components_PageModalHandler = ((0,withMatch/* default */.Z)(PageModalHandler_connectApiData((0,es/* connect */.$j)(null, PageModalHandler_mapDispatchToProps)(PageModalHandler))));
;// CONCATENATED MODULE: ./src/components/contentTypes/Page.js






var Page_jsx = react.createElement;

function Page_callSuper(t, o, e) {
  return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, Page_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e));
}

function Page_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (Page_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}















var Page_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      projectSlug = _ownProps$match$param.projectSlug,
      env = _ownProps$match$param.env;
  var pagePath = (0,getLinkFromPageObject/* default */.Z)(ownProps.match.params);
  return {
    redirect: lodash_get_default()(state, 'redirect'),
    page: (0,apiData/* getResultData */.yh)(state.apiData, 'getPage', {
      pagePath: pagePath
    }),
    settings: (0,apiData/* getResultData */.yh)(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }),
    request: (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'getPage', {
      pagePath: pagePath
    }),
    resultWishList: (0,apiData/* getResultData */.yh)(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    })
  };
};

var Page_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getNewPage: function getNewPage(env, pagePath) {
      dispatch((0,apiData/* performApiRequest */.T4)('getPage', {
        pagePath: pagePath
      }, undefined, {
        cache: env === 'closed' ? 'disabled' : 'enabled'
      }));
    },
    createWishList: function createWishList(projectSlug, wishListId) {
      dispatch((0,apiData/* performApiRequest */.T4)('postWishList', {
        projectSlug: projectSlug
      }, {
        house: wishListId
      }));
      dispatch((0,apiData/* invalidateApiDataRequest */.zk)('postWishList', {
        projectSlug: projectSlug
      }));
    }
  };
};

var Page = /*#__PURE__*/function (_PureComponent) {
  function Page() {
    (0,classCallCheck/* default */.Z)(this, Page);

    return Page_callSuper(this, Page, arguments);
  }

  (0,inherits/* default */.Z)(Page, _PureComponent);

  return (0,createClass/* default */.Z)(Page, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          match = _this$props.match,
          getNewPage = _this$props.getNewPage;
      var env = match.params.env;
      var pagePath = (0,getLinkFromPageObject/* default */.Z)(match.params);
      getNewPage(String(env), pagePath);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          match = _this$props2.match,
          router = _this$props2.router,
          settings = _this$props2.settings,
          page = _this$props2.page,
          request = _this$props2.request,
          redirect = _this$props2.redirect,
          getNewPage = _this$props2.getNewPage,
          resultWishList = _this$props2.resultWishList,
          createWishList = _this$props2.createWishList;
      var oldMatch = prevProps.match,
          oldSettings = prevProps.settings;
      var _match$params = match.params,
          newProjectSlug = _match$params.projectSlug,
          newEnv = _match$params.env,
          newMenuSlug = _match$params.menuSlug,
          newPageSlug = _match$params.pageSlug;
      var oldPagePath = (0,getLinkFromPageObject/* default */.Z)(oldMatch.params);
      var newPagePath = (0,getLinkFromPageObject/* default */.Z)(match.params);
      var newPhase = settings && settings.phase;
      var oldPhase = oldSettings && oldSettings.phase; // When cache is cleared:

      if ((settings === undefined || page === undefined) && request && request.networkStatus !== 'loading' && request.networkStatus !== 'failed') {
        getNewPage(String(newEnv), newPagePath);
        return;
      } // If an extra page is set under home, we must redirect to the first page under that header


      if (settings && settings.menu && settings.menu.length > 0 && (0,menu/* hasSubmenu */.Df)(settings.menu[0]) && Array.isArray(settings.menu[0].pages) && !newMenuSlug && !newPageSlug) {
        var _settings$menu$0$page = settings.menu[0].pages[0],
            _projectSlug = _settings$menu$0$page.projectSlug,
            _env = _settings$menu$0$page.env;
        router === null || router === void 0 || router.push("/".concat((0,getLinkFromPageObject/* default */.Z)({
          projectSlug: _projectSlug,
          env: _env,
          menuSlug: 'home'
        })));
      } // When navigating from one page to another:


      if (oldPagePath !== newPagePath || oldPhase !== undefined && oldPhase !== newPhase) {
        if (redirect.params && settings && settings.user && !resultWishList) {
          createWishList(String(newProjectSlug), redirect.params.wishListId);
        } else {
          if (!settings) {
            // When there are no settings, it means you cant navigate to anything other than /env
            getNewPage(String(newEnv), (0,getLinkFromPageObject/* default */.Z)({
              projectSlug: newProjectSlug,
              env: newEnv
            }));
          } else {
            getNewPage(String(newEnv), newPagePath);
          }
        }
      } // When a wishlist is created, the user will be navigated to the wishlist page


      if (resultWishList && resultWishList.id && redirect.params && settings && settings.user) {
        router === null || router === void 0 || router.push("/".concat(String(newProjectSlug), "/closed/homestudio/").concat(resultWishList.id));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          settings = _this$props3.settings,
          settingsRequest = _this$props3.settingsRequest,
          page = _this$props3.page,
          request = _this$props3.request,
          match = _this$props3.match,
          renderWidth = _this$props3.renderWidth;
      var pageTemplate = lodash_get_default()(page, 'template');
      var pageNotFound = lodash_get_default()(request, 'response.status') === 404;
      var title = page && settings ? "".concat(page.name, " - ").concat(settings.siteName) : '';
      var meta = page ? {
        metaTitle: page.metaTitle,
        metaKeywords: page.metaKeywords,
        metaDescription: page.metaDescription
      } : {};
      var Layout = settings && pageTemplate && TEMPLATE_LAYOUT_MAP[pageTemplate] || TEMPLATE_LAYOUT_MAP.flex;
      var layoutSettings = {
        hasHeader: true,
        hasFooter: true,
        hasMenu: !(page && page.template === 'notLoggedIn')
      };
      return Page_jsx(layout_LayoutBase, {
        settings: settings,
        layoutSettings: layoutSettings,
        renderWidth: renderWidth,
        title: title,
        meta: meta,
        "data-id": "contentTypes_Page_LayoutBase"
      }, Page_jsx(components_PageModalHandler, {
        "data-id": "contentTypes_Page_PageModalHandler"
      }), Layout && page && request.networkStatus !== 'loading' && settingsRequest.networkStatus !== 'loading' && !pageNotFound && Page_jsx(Layout, {
        page: page,
        request: request,
        renderWidth: renderWidth,
        "data-id": "contentTypes_Page_Layout"
      }), (request && request.networkStatus === 'loading' || !settingsRequest || settingsRequest && settingsRequest.networkStatus === 'loading') && Page_jsx(ContentLoader/* default */.Z, {
        big: true,
        "data-id": "contentTypes_Page_ContentLoader"
      }), pageNotFound && request && request.networkStatus !== 'loading' && Page_jsx(ErrorBlock/* default */.Z, (0,esm_extends/* default */.Z)({}, (0,errorMessages/* getErrorBlockProps */.k)(match, 'page', 404), {
        "data-id": "contentTypes_Page_ErrorBlock"
      })));
    }
  }]);
}(react.PureComponent);

/* harmony default export */ var contentTypes_Page = (WithSettings((0,es/* connect */.$j)(Page_mapStateToProps, Page_mapDispatchToProps)(Page)));
// EXTERNAL MODULE: ./src/hooks/useMatch.ts
var useMatch = __webpack_require__(74150);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(5463);
;// CONCATENATED MODULE: ./src/components/ForgotPasswordBlock.tsx


var ForgotPasswordBlock_templateObject, ForgotPasswordBlock_templateObject2, ForgotPasswordBlock_templateObject3, ForgotPasswordBlock_templateObject4, ForgotPasswordBlock_templateObject5;
















var ForgotPasswordBlock_FormContainer = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(ForgotPasswordBlock_templateObject || (ForgotPasswordBlock_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 1;\n  max-width: 1180rem;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  background-color: #ffffff;\n  ", ";\n\n  ", ";\n\n  > div {\n    position: relative;\n    min-width: 250rem;\n    width: 100%;\n    padding: 60rem 0 100rem;\n\n    ", ";\n  }\n"])), styleGuide/* shadows.boxPrimary */.q.boxPrimary, breakpoints/* fromBreakpoint.md */.ks.md(ForgotPasswordBlock_templateObject2 || (ForgotPasswordBlock_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: -210rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(ForgotPasswordBlock_templateObject3 || (ForgotPasswordBlock_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: 80%;\n      padding: 60rem 80rem 100rem 80rem;\n    "]))));
var ForgotPasswordBlock_Title = styled_components_browser_esm["default"].h2(ForgotPasswordBlock_templateObject4 || (ForgotPasswordBlock_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  margin-bottom: 10rem;\n"])), styleGuide/* textStyles.sectionTitle */.sq.sectionTitle, styleGuide/* colorPalette.headerGrey */.K5.headerGrey);
var ForgotPasswordBlock_FormError = styled_components_browser_esm["default"].div(ForgotPasswordBlock_templateObject5 || (ForgotPasswordBlock_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  padding: 20rem;\n  justify-content: center;\n  border: solid 1rem #eeeeee;\n  border-radius: 5rem;\n  background: ", ";\n  font-family: ", ";\n  color: ", ";\n"])), styleGuide/* colorPalette.lightGrey */.K5.lightGrey, styleGuide/* fonts.primary */.Rq.primary, styleGuide/* colorPalette.red */.K5.red);

var ForgotPasswordBlock = function ForgotPasswordBlock() {
  var router = (0,next_router.useRouter)();

  var _useMatch = (0,useMatch/* default */.Z)(),
      _useMatch$match$param = _useMatch.match.params,
      projectSlug = _useMatch$match$param.projectSlug,
      token = _useMatch$match$param.token;

  var dispatch = (0,es/* useDispatch */.I0)();
  var request = (0,redux/* useSelector */.v)(function (state) {
    return (0,apiData/* getApiDataRequest */.LG)(state.apiData, 'resetPassword', {
      projectSlug: String(projectSlug)
    });
  });

  var _useState = (0,react.useState)(false),
      passwordIsVisible = _useState[0],
      setPasswordIsVisible = _useState[1];

  var _useState2 = (0,react.useState)(false),
      success = _useState2[0],
      setSuccess = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var _useState4 = (0,react.useState)(),
      error = _useState4[0],
      setError = _useState4[1];

  (0,react.useEffect)(function () {
    if (!request) return;

    if (request.networkStatus === 'success') {
      setSuccess(true);
      return;
    }

    if (loading && lodash_get_default()(request, 'errorBody.message')) {
      setError(lodash_get_default()(request, 'errorBody.message'));
      setLoading(false);
    }
  }, [loading, request]);
  var formConfig = (0,react.useMemo)(function () {
    return [{
      options: [{
        id: 'password',
        name: 'password',
        label: 'Vul hier je nieuwe wachtwoord in',
        required: true,
        title: 'Vul hier je nieuwe wachtwoord in',
        type: passwordIsVisible ? 'text' : 'password',
        toggle: true,
        help: 'Gebruik acht of meer tekens met een combinatie van letters, cijfers en symbolen'
      }]
    }];
  }, [passwordIsVisible]);
  var onPressSuccesButton = (0,react.useCallback)(function () {
    router === null || router === void 0 || router.push("/".concat(String(projectSlug), "/closed"));
  }, [projectSlug, router]);

  if (success) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPasswordBlock_FormContainer, {
      "data-id": "components_ForgotPasswordBlock_FormContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        "data-id": "components_ForgotPasswordBlock_div",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPasswordBlock_Title, {
          "data-id": "components_ForgotPasswordBlock_Title",
          children: "Gelukt!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          "data-id": "components_ForgotPasswordBlock_p",
          children: "Je wachtwoord is aangepast."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonPrimary/* default */.Z // @ts-ignore
        , {
          id: "form_submit" // @ts-ignore
          ,
          type: "button" // @ts-ignore
          ,
          label: "Naar startpagina" // @ts-ignore
          ,
          clickHandler: onPressSuccesButton,
          "data-id": "components_ForgotPasswordBlock_ButtonPrimary"
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPasswordBlock_FormContainer, {
    "data-id": "components_ForgotPasswordBlock_FormContainer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      "data-id": "components_ForgotPasswordBlock_div",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPasswordBlock_Title, {
        "data-id": "components_ForgotPasswordBlock_Title",
        children: "Wachtwoord opnieuw instellen"
      }), error && /*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPasswordBlock_FormError, {
        "data-id": "components_ForgotPasswordBlock_FormError",
        children: error
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormGenerator/* default */.Z, {
        fields: formConfig,
        submitLabel: "Nieuw wachtwoord instellen",
        loadingLabel: "wachtwoord wordt ingesteld",
        submitFn: function submitFn(_ref) {
          var password = _ref.password;
          setLoading(true);

          if (typeof password === 'string') {
            dispatch( // @ts-ignore
            (0,apiData/* performApiRequest */.T4)('resetPassword', {
              projectSlug: String(projectSlug)
            }, {
              password: password,
              token: String(token)
            }));
          }
        },
        togglePassword: function togglePassword() {
          return setPasswordIsVisible(function (v) {
            return !v;
          });
        },
        "data-id": "components_ForgotPasswordBlock_FormGenerator"
      })]
    })
  });
};

/* harmony default export */ var components_ForgotPasswordBlock = (ForgotPasswordBlock);
;// CONCATENATED MODULE: ./src/components/contentTypes/Password.js


var Password_templateObject, Password_templateObject2, Password_templateObject3, Password_templateObject4, Password_templateObject5, Password_templateObject6, Password_templateObject7, Password_templateObject8, Password_templateObject9, Password_templateObject0, Password_templateObject1;

var Password_jsx = react.createElement;









var meta = {
  metaTitle: 'Wachtwoord vergeten'
};

var Password = function Password(_ref) {
  var settings = _ref.settings,
      renderWidth = _ref.renderWidth;
  return Password_jsx(layout_LayoutBase, {
    settings: settings,
    layoutSettings: {
      hasMenu: false,
      hasHeader: true,
      hasFooter: true
    },
    renderWidth: renderWidth,
    title: "Password",
    meta: meta,
    "data-id": "contentTypes_Password_LayoutBase"
  }, Password_jsx(Password_HeroContainer, {
    "data-id": "contentTypes_Password_HeroContainer"
  }, Password_jsx(components_HeroHome, {
    hero: {
      desktopImage: '/images/defaultHero.jpg'
    },
    heroTriangleSmallColor: styleGuide/* colorPalette.beige */.K5.beige,
    heroTriangleLargeColor: styleGuide/* colorPalette.beige */.K5.beige,
    renderWidth: renderWidth,
    "data-id": "contentTypes_Password_Hero"
  }), Password_jsx(Password_TextContainer, {
    "data-id": "contentTypes_Password_TextContainer"
  }, Password_jsx(Password_Title, {
    "data-id": "contentTypes_Password_Title"
  }, "Wachtwoord opnieuw instellen"), Password_jsx(Password_SubTitle, {
    "data-id": "contentTypes_Password_SubTitle"
  }, "Kies hieronder een nieuw wachtwoord voor toegang tot Mijn Homestudios"))), Password_jsx(Password_Wrapper, {
    "data-id": "contentTypes_Password_Wrapper"
  }, Password_jsx(Password_CopyCell, {
    "data-id": "contentTypes_Password_CopyCell"
  }, Password_jsx(components_ForgotPasswordBlock, {
    "data-id": "contentTypes_Password_ForgotPasswordBlock"
  }))));
};

/* harmony default export */ var contentTypes_Password = (WithSettings(Password));
var Password_HeroContainer = styled_components_browser_esm["default"].div(Password_templateObject || (Password_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n"])));
var Password_TextContainer = styled_components_browser_esm["default"].div(Password_templateObject2 || (Password_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 10%;\n  left: 8%;\n  z-index: 5;\n  margin-right: 20rem;\n  margin-top: 60rem;\n  ", " ", ";\n"])), breakpoints/* toBreakpoint.lg */.Hx.lg(Password_templateObject3 || (Password_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 20rem;\n  "]))), breakpoints/* toBreakpoint.md */.Hx.md(Password_templateObject4 || (Password_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    left: 5%;\n  "]))));
var Password_Title = styled_components_browser_esm["default"].h1(Password_templateObject5 || (Password_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  ", ";\n  color: #fff;\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* shadows.textPrimary */.q.textPrimary);
var Password_SubTitle = styled_components_browser_esm["default"].p(Password_templateObject6 || (Password_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " ", ";\n  color: #fff;\n"])), styleGuide/* textStyles.title */.sq.title, styleGuide/* shadows.textPrimary */.q.textPrimary);
var Password_Wrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(Password_templateObject7 || (Password_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 2;\n  margin-top: -100rem;\n  margin-bottom: 20rem;\n\n  ", ";\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.md */.ks.md(Password_templateObject8 || (Password_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 50rem;\n    margin-bottom: 40rem;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(Password_templateObject9 || (Password_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 0rem;\n  "]))));
var Password_CopyCell = (0,styled_components_browser_esm["default"])(gridElements/* GridItem */.P4)(Password_templateObject0 || (Password_templateObject0 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 20rem;\n  padding-bottom: 20rem;\n  margin-right: 10rem;\n  margin-left: 5rem;\n  padding-right: 10rem;\n  padding-left: 10rem;\n  max-width: 1180rem;\n\n  ", ";\n"])), breakpoints/* fromBreakpoint.lg */.ks.lg(Password_templateObject1 || (Password_templateObject1 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 100rem;\n    padding-right: 100rem;\n  "]))));
;// CONCATENATED MODULE: ./src/components/atoms/FadeAnimationWrapper.tsx



var FadeAnimationWrapper = function FadeAnimationWrapper(_ref) {
  var children = _ref.children,
      animationKey = _ref.animationKey,
      style = _ref.style;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
    initial: "initial",
    animate: "animate",
    transition: {
      duration: 1,
      ease: 'easeInOut'
    },
    variants: {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      }
    },
    style: style,
    children: children
  }, animationKey);
};

/* harmony default export */ var atoms_FadeAnimationWrapper = (FadeAnimationWrapper);
;// CONCATENATED MODULE: ./src/components/organisms/RequestHandler.tsx


function RequestHandler_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RequestHandler_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RequestHandler_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RequestHandler_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var RequestHandler = function RequestHandler(_ref) {
  var children = _ref.children,
      error = _ref.error,
      isError = _ref.isError,
      _ref$fullScreen = _ref.fullScreen,
      fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      statusCode = _ref.statusCode;

  var _useMatch = (0,useMatch/* default */.Z)(),
      match = _useMatch.match;

  if (isError) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBlock/* default */.Z, RequestHandler_objectSpread(RequestHandler_objectSpread({}, (0,errorMessages/* getErrorBlockProps */.k)(match, error, statusCode)), {}, {
      fullscreen: fullScreen,
      "data-id": "organisms_RequestHandler_ErrorBlock"
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_FadeAnimationWrapper, {
    animationKey: isLoading ? 1 : 0,
    "data-id": "organisms_RequestHandler_FadeAnimationWrapper",
    children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(ContentLoader/* default */.Z, {
      big: fullScreen,
      "data-id": "organisms_RequestHandler_ContentLoader"
    }) : children
  });
};

/* harmony default export */ var organisms_RequestHandler = (RequestHandler);
// EXTERNAL MODULE: ./src/styles/shadows.ts
var shadows = __webpack_require__(44563);
;// CONCATENATED MODULE: ./src/styles/zIndexes.ts
var z = {
  categoryIntro: 1,
  sidebarContent: 10,
  slider: 10,
  sliderContent: 11,
  sliderNav: 12,
  stickyButton: 20,
  mobileHeader: 20,
  menu: 30,
  sideBar: 30,
  mobileNav: 40,
  modal: 50,
  modalContent: 51,
  modalButton: 52
};
;// CONCATENATED MODULE: ./src/hooks/useLayoutDimensions.ts


var MAX_SITE_WIDTH_IN_PX = 2800;
var MAX_SIDEBAR_WIDTH = 500;
var MIN_SIDEBAR_WIDTH = 350;
var MIN_SIDEBAR_WIDTH_FOR_MD = 350;

var getSidebarWidth = function getSidebarWidth(currentContentWidthInPx, breakpointInfo) {
  var _breakpointInfo$isLar = breakpointInfo.isLargerThan,
      md = _breakpointInfo$isLar.md,
      slg = _breakpointInfo$isLar.slg;

  if (!md) {
    return 0;
  }

  if (md && !slg) {
    return Math.min(currentContentWidthInPx / 2, MIN_SIDEBAR_WIDTH_FOR_MD);
  }

  var sideBarWidth = Math.round(currentContentWidthInPx / 4);

  if (sideBarWidth > MAX_SIDEBAR_WIDTH) {
    return MAX_SIDEBAR_WIDTH;
  }

  if (sideBarWidth < MIN_SIDEBAR_WIDTH) {
    return MIN_SIDEBAR_WIDTH;
  }

  return sideBarWidth;
};

var useLayoutDimensions = function useLayoutDimensions() {
  var breakpointInfo = hooks_useBreakpointInfo();

  var _useState = (0,react.useState)(0),
      spacing = _useState[0],
      setSpacing = _useState[1];

  var _useState2 = (0,react.useState)(0),
      width = _useState2[0],
      setWidth = _useState2[1];

  var updateSpacing = (0,react.useCallback)(function () {
    var html = document.getElementsByTagName('html')[0];
    var htmlComputedStyle = getComputedStyle(html);
    var htmlWidth = html.clientWidth - (parseFloat(htmlComputedStyle.paddingLeft) + parseFloat(htmlComputedStyle.paddingRight));
    setWidth(htmlWidth);
    var remainingSpace = htmlWidth - MAX_SITE_WIDTH_IN_PX;

    if (remainingSpace < 0) {
      setSpacing(0);
      return;
    }

    setSpacing(Math.round(remainingSpace / 2));
  }, []);
  (0,react.useEffect)(function () {
    updateSpacing();
    window.addEventListener('resize', updateSpacing);
    return function () {
      return window.removeEventListener('resize', updateSpacing);
    };
  }, [updateSpacing]);
  var currentContentWidthInPx = Math.min(MAX_SITE_WIDTH_IN_PX, width);
  return {
    currentContentWidthInPx: currentContentWidthInPx,
    maxContentWidthInPx: MAX_SITE_WIDTH_IN_PX,
    sideBarWidth: getSidebarWidth(currentContentWidthInPx, breakpointInfo),
    spacingInPx: spacing
  };
};

/* harmony default export */ var hooks_useLayoutDimensions = (useLayoutDimensions);
;// CONCATENATED MODULE: ./src/components/atoms/svg/LeftArrowIcon.tsx






var LeftArrowIcon = function LeftArrowIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 10 16",
    "data-id": "svg_LeftArrowIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M8.84385 1.52234L8.8391 1.52735C9.60765 2.34347 9.60265 3.61873 8.79403 4.42734L5.21787 8.0035L8.79428 11.5799C9.61842 12.4043 9.6079 13.7129 8.79428 14.5265C8.78352 14.5372 8.77275 14.5478 8.76174 14.5583L8.76249 14.559L7.32151 16L0.86413 9.54187C0.436292 9.11403 0.233012 8.55576 0.251037 8.0035C0.233763 7.4515 0.436292 6.89298 0.86413 6.46514L7.32176 0L8.84385 1.52234Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_LeftArrowIcon_path"
    })
  });
};

/* harmony default export */ var svg_LeftArrowIcon = (LeftArrowIcon);
;// CONCATENATED MODULE: ./src/components/molecules/Header.tsx


var molecules_Header_templateObject;









var molecules_Header_Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(molecules_Header_templateObject || (molecules_Header_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: ", ";\n  z-index: ", ";\n  ", "\n"])), colors/* colors.white */.O.white, z.mobileHeader, shadows/* default.default */.Z["default"]);

var Header_Header = function Header(_ref) {
  var backButtonText = _ref.backButtonText,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Header_Container, {
    padding: "md",
    "data-id": "molecules_Header_Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* default */.Z, {
      iconBefore: svg_LeftArrowIcon,
      text: backButtonText,
      onClick: onClick,
      variant: "brand",
      "data-id": "molecules_Header_TextButton"
    })
  });
};

/* harmony default export */ var molecules_Header = (Header_Header);
// EXTERNAL MODULE: ./src/redux/houseDesign.ts
var houseDesign = __webpack_require__(86946);
;// CONCATENATED MODULE: ./src/components/houseDesign/Chrome.tsx



var Chrome_templateObject, Chrome_templateObject2, Chrome_templateObject3, Chrome_templateObject4, Chrome_templateObject5, Chrome_templateObject6, Chrome_templateObject7;

function Chrome_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Chrome_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Chrome_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Chrome_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var Chrome_Container = styled_components_browser_esm["default"].div(Chrome_templateObject || (Chrome_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-height: 100vh;\n  background: ", ";\n"])), colors/* colors.gray10 */.O.gray10);
var MobileNav = styled_components_browser_esm["default"].div(Chrome_templateObject2 || (Chrome_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 56rem;\n  background: ", ";\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  z-index: ", ";\n  transform: translateX(-110%);\n  transition: transform 400ms ease-in-out;\n  ", "\n\n  ", "\n"])), colors/* colors.white */.O.white, z.mobileNav, shadows/* default.lg */.Z.lg, function (_ref) {
  var open = _ref.open;
  return open && (0,styled_components_browser_esm.css)(Chrome_templateObject3 || (Chrome_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      transform: translateX(0);\n    "])));
});
var Chrome_Menu = styled_components_browser_esm["default"].div(Chrome_templateObject4 || (Chrome_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  ", "\n  z-index: ", ";\n  ", "\n"])), colors/* colors.white */.O.white, shadows/* default.default */.Z["default"], z.menu, function (_ref2) {
  var sideBarWidth = _ref2.sideBarWidth,
      spacingInPx = _ref2.spacingInPx;
  return (0,styled_components_browser_esm.css)(Chrome_templateObject5 || (Chrome_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-left: ", "px;\n      width: ", "px;\n    "])), spacingInPx, spacingInPx + sideBarWidth);
});
var Chrome_Content = styled_components_browser_esm["default"].div(Chrome_templateObject6 || (Chrome_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0 auto;\n  ", "\n"])), function (_ref3) {
  var maxContentWidthInPx = _ref3.maxContentWidthInPx,
      sideBarWidth = _ref3.sideBarWidth;
  return (0,styled_components_browser_esm.css)(Chrome_templateObject7 || (Chrome_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-left: ", "px;\n      max-width: ", "px;\n    "])), sideBarWidth, maxContentWidthInPx);
});

var Chrome = function Chrome(_ref4) {
  var menu = _ref4.menu,
      backLink = _ref4.backLink,
      children = _ref4.children;
  var layoutDimensions = hooks_useLayoutDimensions();

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      md = _useBreakpointInfo.isLargerThan.md;

  var menuOpen = (0,redux/* useSelector */.v)(function (state) {
    return state.houseDesign.menuOpen;
  });
  var dispatch = (0,es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    if (!md) {
      dispatch((0,houseDesign/* toggleMenu */.js)(true));
    }
  }, [md, dispatch]);

  if (!md) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Chrome_Container, {
      "data-id": "houseDesign_Chrome_Container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Header, {
        backButtonText: "Overzicht",
        onClick: function onClick() {
          return dispatch((0,houseDesign/* toggleMenu */.js)(true));
        },
        "data-id": "houseDesign_Chrome_Header"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundaryWithSentry/* default */.Z, {
        "data-id": "houseDesign_Chrome_ErrorBoundary",
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileNav, {
        open: menuOpen,
        "data-id": "houseDesign_Chrome_MobileNav",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Header, {
          backButtonText: "Mijn woonontwerpen",
          onClick: function onClick() {
            if (backLink) {
              router === null || router === void 0 || router.push(backLink);
            }
          },
          "data-id": "houseDesign_Chrome_Header"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundaryWithSentry/* default */.Z, {
          "data-id": "houseDesign_Chrome_ErrorBoundary",
          children: menu
        })]
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Chrome_Container, {
    "data-id": "houseDesign_Chrome_Container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Chrome_Menu, Chrome_objectSpread(Chrome_objectSpread({}, layoutDimensions), {}, {
      "data-id": "houseDesign_Chrome_Menu",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundaryWithSentry/* default */.Z, {
        "data-id": "houseDesign_Chrome_ErrorBoundary",
        children: menu
      })
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(Chrome_Content, Chrome_objectSpread(Chrome_objectSpread({}, layoutDimensions), {}, {
      "data-id": "houseDesign_Chrome_Content",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundaryWithSentry/* default */.Z, {
        "data-id": "houseDesign_Chrome_ErrorBoundary",
        children: children
      })
    }))]
  });
};

/* harmony default export */ var houseDesign_Chrome = (Chrome);
;// CONCATENATED MODULE: ./src/components/atoms/Dot.tsx


var Dot_templateObject, Dot_templateObject2;




var COLOR_MAP = {
  brand: colors/* colors.brand */.O.brand,
  disabled: colors/* colors.gray20 */.O.gray20,
  inverted: colors/* colors.white */.O.white
};
var DotContainer = styled_components_browser_esm["default"].div(Dot_templateObject || (Dot_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  height: 24rem;\n"])));
var CustomDot = styled_components_browser_esm["default"].div(Dot_templateObject2 || (Dot_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 0 0 ", "rem;\n  height: ", "rem;\n  width: ", "rem;\n  border-radius: 50%;\n  background-color: ", ";\n"])), function (_ref) {
  var size = _ref.size;
  return size === 'lg' ? '6' : '4';
}, function (_ref2) {
  var size = _ref2.size;
  return size === 'lg' ? '6' : '4';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'lg' ? '6' : '4';
}, function (_ref4) {
  var variant = _ref4.variant;
  return COLOR_MAP[variant];
});

var Dot = function Dot(_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 'lg' : _ref5$size,
      _ref5$variant = _ref5.variant,
      variant = _ref5$variant === void 0 ? 'brand' : _ref5$variant;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DotContainer, {
    "data-id": "atoms_Dot_DotContainer",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomDot, {
      variant: variant,
      size: size,
      "data-id": "atoms_Dot_CustomDot"
    })
  });
};

/* harmony default export */ var atoms_Dot = (Dot);
;// CONCATENATED MODULE: ./src/components/atoms/LayerName.tsx


var LayerName_templateObject;





var TextWrapper = styled_components_browser_esm["default"].div(LayerName_templateObject || (LayerName_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 8rem;\n  align-items: center;\n"])));

var LayerName = function LayerName(_ref) {
  var title = _ref.title,
      _ref$hasNew = _ref.hasNew,
      hasNew = _ref$hasNew === void 0 ? false : _ref$hasNew;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TextWrapper, {
    "data-id": "atoms_LayerName_TextWrapper",
    children: [hasNew && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Dot, {
      "data-id": "atoms_LayerName_Dot"
    }), title]
  });
};

/* harmony default export */ var atoms_LayerName = (LayerName);
;// CONCATENATED MODULE: ./src/components/atoms/svg/FloorIcon.tsx






var FloorIcon = function FloorIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 21",
    "data-id": "svg_FloorIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.5 1.9061L1.64062 7.19718L1.67344 19.3239L18.3422 19.3568C18.9 19.3568 19.3266 18.9296 19.3266 18.3709V7.23005L10.5 1.9061ZM10.5 0L21 6.30986L20.9672 19.0282C20.9672 20.1127 20.0813 21 18.9984 21H0V6.277L10.5 0Z",
      fill: fillColor,
      "data-id": "svg_FloorIcon_path"
    })
  });
};

/* harmony default export */ var svg_FloorIcon = (FloorIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/ComfortIcon.tsx







var ComfortIcon = function ComfortIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 21",
    "data-id": "svg_ComfortIcon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_820_50712)",
      "data-id": "svg_ComfortIcon_g",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.5 1.9061L1.64062 7.19718L1.67344 19.3239L18.3422 19.3568C18.9 19.3568 19.3266 18.9296 19.3266 18.3709V7.23005L10.5 1.9061ZM10.5 0L21 6.30986L20.9672 19.0282C20.9672 20.1127 20.0812 21 18.9984 21H0V6.27699L10.5 0Z",
        fill: fillColor,
        "data-id": "svg_ComfortIcon_path"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M8.49841 14.9528C8.36716 15.0843 8.13748 15.0843 8.00623 14.9528C7.9406 14.8871 7.90779 14.7885 7.90779 14.6899C7.90779 14.5913 7.97341 14.4927 8.03904 14.427L13.3875 10.0561L8.49841 14.9528ZM7.1531 15.3472L6.20154 16.366L6.56248 16.7275L7.54685 15.8073C12.9281 17.5819 14.4047 13.0467 14.4047 8.51151C11.3859 11.042 5.90623 9.59601 7.1531 15.3472Z",
        fill: fillColor,
        "data-id": "svg_ComfortIcon_path_3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      "data-id": "svg_ComfortIcon_defs",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_820_50712",
        "data-id": "svg_ComfortIcon_clipPath",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "21",
          height: "21",
          fill: fillColor,
          "data-id": "svg_ComfortIcon_rect"
        })
      })
    })]
  });
};

/* harmony default export */ var svg_ComfortIcon = (ComfortIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/ElectronicsIcon.tsx







var ElectronicsIcon = function ElectronicsIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 21",
    "data-id": "svg_ElectronicsIcon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_820_50722)",
      "data-id": "svg_ElectronicsIcon_g",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.5 1.9061L1.64062 7.19718L1.67344 19.3239L18.3422 19.3568C18.9 19.3568 19.3266 18.9296 19.3266 18.3709V7.23005L10.5 1.9061ZM10.5 0L21 6.30986L20.9672 19.0282C20.9672 20.1127 20.0812 21 18.9984 21H0V6.277L10.5 0Z",
        fill: fillColor,
        "data-id": "svg_ElectronicsIcon_path"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M9.02347 10.2205C9.25316 10.0891 9.51566 9.99049 9.77816 9.92476V8.51161H10.7297C11.0907 8.51161 11.386 8.80739 11.386 9.16889V9.99049C11.5828 10.0562 11.7797 10.1548 11.9766 10.2534L13.0594 9.16889L13.7157 9.82617C13.9782 10.0891 13.9782 10.4834 13.7157 10.7464L13.0594 11.4036C13.1578 11.568 13.2235 11.7651 13.2891 11.9623H14.8641V12.9154C14.8641 13.2769 14.5688 13.5726 14.2078 13.5726H13.2891C13.2235 13.7698 13.1578 13.9341 13.0594 14.1313L14.0438 15.1172L13.3875 15.7745C13.125 16.0374 12.7313 16.0374 12.4688 15.7745L11.9766 15.2816C11.7797 15.3802 11.6157 15.4787 11.386 15.5445V17.0562H10.4672C10.1063 17.0562 9.81097 16.7604 9.81097 16.3989V15.6431C9.58129 15.5773 9.3516 15.5116 9.12191 15.3802L8.07191 16.4318L7.41566 15.7745C7.15316 15.5116 7.15316 15.1172 7.41566 14.8543L7.97347 14.2957C7.84222 14.0656 7.74379 13.8356 7.67816 13.5726H6.2016V12.6196C6.2016 12.2581 6.49691 11.9623 6.85785 11.9623H7.64535C7.71097 11.7323 7.80941 11.5351 7.90785 11.3379L6.9891 10.4177L7.64535 9.76044C7.90785 9.49753 8.3016 9.49753 8.5641 9.76044L9.02347 10.2205ZM10.4672 14.1313C11.1891 14.1313 11.8125 13.5398 11.8125 12.7839C11.8125 12.028 11.2219 11.4365 10.4672 11.4365C9.71254 11.4365 9.12191 12.028 9.12191 12.7839C9.12191 13.5398 9.74535 14.1313 10.4672 14.1313Z",
        fill: fillColor,
        "data-id": "svg_ElectronicsIcon_path_3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      "data-id": "svg_ElectronicsIcon_defs",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_820_50722",
        "data-id": "svg_ElectronicsIcon_clipPath",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "21",
          height: "21",
          fill: fillColor,
          "data-id": "svg_ElectronicsIcon_rect"
        })
      })
    })]
  });
};

/* harmony default export */ var svg_ElectronicsIcon = (ElectronicsIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/Floor0Icon.tsx







var Floor0Icon = function Floor0Icon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 21",
    "data-id": "svg_Floor0Icon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_820_50661)",
      "data-id": "svg_Floor0Icon_g",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M9.94216 14.6244C9.94216 15.3803 9.71248 15.9718 9.18748 16.3005C8.69529 16.662 7.90779 16.7934 6.79216 16.7934H4.56091V9.36619C5.34841 9.30047 6.03748 9.23474 6.6281 9.23474C7.64529 9.23474 8.39998 9.39906 8.85935 9.69483C9.31873 9.99061 9.54841 10.4836 9.54841 11.1408C9.54841 11.4038 9.5156 11.6338 9.38435 11.8967C9.31873 12.1268 9.15466 12.3239 8.9906 12.4883C8.82654 12.6526 8.62966 12.7512 8.39998 12.8498C9.41716 13.1455 9.94216 13.7371 9.94216 14.6244ZM6.72654 15.7089C7.31716 15.7089 7.74373 15.6432 7.97341 15.446C8.2031 15.2488 8.33435 14.9859 8.33435 14.5915C8.33435 13.8357 7.87498 13.507 6.8906 13.507H6.07029V15.7418H6.72654V15.7089ZM8.00623 11.2394C8.00623 10.9108 7.87498 10.6807 7.6781 10.5493C7.48123 10.385 7.1531 10.3192 6.69373 10.3192C6.52966 10.3192 6.43123 10.3192 6.33279 10.3192C6.26716 10.3192 6.16873 10.3192 6.1031 10.3521V12.4225H6.85779C7.21873 12.4225 7.48123 12.2911 7.71091 12.0939C7.9406 11.9296 8.00623 11.6009 8.00623 11.2394ZM14.0437 13.8685V12.7183H16.7672V16.0704C16.6031 16.2347 16.4062 16.3991 16.1437 16.5305C15.8812 16.6948 15.5531 16.7606 15.1922 16.8592C14.7984 16.9249 14.4375 16.9906 14.0437 16.9906C13.289 16.9906 12.6328 16.8263 12.1406 16.5305C11.6484 16.2019 11.2547 15.7418 10.9594 15.1502C10.6968 14.5587 10.5656 13.8685 10.5656 13.0469C10.5656 12.2253 10.7297 11.5352 10.9922 10.9437C11.2547 10.3521 11.6812 9.92488 12.239 9.59624C12.7969 9.2676 13.4203 9.13615 14.2078 9.13615C14.6015 9.13615 14.9953 9.20187 15.389 9.33333C15.75 9.46479 16.0453 9.59624 16.2422 9.79342C16.4718 9.99061 16.5703 10.1549 16.5703 10.3521C16.5703 10.4836 16.5375 10.615 16.4062 10.7465C16.275 10.9108 16.1765 11.0751 16.0125 11.1737C15.6844 10.9108 15.4218 10.7136 15.1593 10.5822C14.8968 10.4507 14.5687 10.4178 14.2078 10.4178C13.5515 10.4178 12.9937 10.6479 12.6328 11.0751C12.2719 11.5352 12.075 12.1596 12.075 13.0469C12.075 13.9343 12.2719 14.6244 12.6328 15.0845C12.9937 15.5446 13.5187 15.7746 14.2078 15.7746C14.5359 15.7746 14.7984 15.7418 15.0281 15.6103C15.0937 15.5775 15.225 15.5446 15.2906 15.446V13.8357H14.0437V13.8685Z",
        fill: fillColor,
        "data-id": "svg_Floor0Icon_path"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.5 1.9061L1.64062 7.19718L1.67344 19.3239L18.3422 19.3568C18.9 19.3568 19.3266 18.9296 19.3266 18.3709V7.23005L10.5 1.9061ZM10.5 0L21 6.30986L20.9672 19.0282C20.9672 20.1127 20.0813 21 18.9984 21H0V6.277L10.5 0Z",
        fill: fillColor,
        "data-id": "svg_Floor0Icon_path_3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      "data-id": "svg_Floor0Icon_defs",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_820_50661",
        "data-id": "svg_Floor0Icon_clipPath",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "21",
          height: "21",
          fill: fillColor,
          "data-id": "svg_Floor0Icon_rect"
        })
      })
    })]
  });
};

/* harmony default export */ var svg_Floor0Icon = (Floor0Icon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/Floor1Icon.tsx







var SecondFloorIcon = function SecondFloorIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 21",
    "data-id": "svg_Floor1Icon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_820_50673)",
      "data-id": "svg_Floor1Icon_g",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.0406 17.0563V10.5493L8.4 11.4038C8.07188 10.9437 7.875 10.5822 7.875 10.3521C7.875 10.1221 8.00625 9.92488 8.30156 9.76056L10.1391 8.80751C10.3031 8.70892 10.4672 8.64319 10.6641 8.61033C10.8281 8.5446 10.9922 8.51174 11.1563 8.51174C11.4188 8.51174 11.6813 8.61033 11.8781 8.70892V17.0563H10.0406Z",
        fill: fillColor,
        "data-id": "svg_Floor1Icon_path"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.5 1.9061L1.64062 7.19718L1.67344 19.3239L18.3422 19.3568C18.9 19.3568 19.3266 18.9296 19.3266 18.3709V7.23005L10.5 1.9061ZM10.5 0L21 6.30986L20.9672 19.0282C20.9672 20.1127 20.0813 21 18.9984 21H0V6.277L10.5 0Z",
        fill: fillColor,
        "data-id": "svg_Floor1Icon_path_3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      "data-id": "svg_Floor1Icon_defs",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_820_50673",
        "data-id": "svg_Floor1Icon_clipPath",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "21",
          height: "21",
          fill: fillColor,
          "data-id": "svg_Floor1Icon_rect"
        })
      })
    })]
  });
};

/* harmony default export */ var Floor1Icon = (SecondFloorIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/Floor2Icon.tsx







var Floor2Icon = function Floor2Icon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 20",
    "data-id": "svg_Floor2Icon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      "data-id": "svg_Floor2Icon_g",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "translate(-142.000000, -767.000000)",
        fill: fillColor,
        "data-id": "svg_Floor2Icon_g_2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          transform: "translate(40.000000, 761.000000)",
          "data-id": "svg_Floor2Icon_g_3",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
            transform: "translate(102.000000, 6.000000)",
            "data-id": "svg_Floor2Icon_g_4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
              transform: "translate(7.187500, 8.125000)",
              fillRule: "nonzero",
              "data-id": "svg_Floor2Icon_g_5",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                d: "M0.125,8.125 L0.125,6.96875 C0.5,6.6875 0.875,6.3125 1.34375,5.875 C1.8125,5.4375 2.21875,5 2.59375,4.59375 C3.28125,3.84375 3.625,3.15625 3.625,2.53125 C3.625,2.15625 3.53125,1.875 3.34375,1.6875 C3.125,1.5 2.84375,1.40625 2.5,1.40625 C2.1875,1.40625 1.84375,1.5 1.53125,1.59375 C1.21875,1.75 0.875,1.96875 0.5625,2.28125 C0.21875,1.84375 0,1.53125 0,1.34375 C0,1.1875 0.09375,1.03125 0.28125,0.875 C0.96875,0.28125 1.78125,0 2.65625,0 C3.46875,0 4.09375,0.1875 4.59375,0.59375 C5.03125,1 5.28125,1.5625 5.28125,2.3125 C5.28125,3.28125 4.71875,4.3125 3.59375,5.46875 C3.125,5.9375 2.71875,6.34375 2.34375,6.6875 L4.625,6.6875 C4.9375,6.6875 5.1875,6.78125 5.34375,6.9375 C5.5,7.09375 5.59375,7.3125 5.59375,7.59375 C5.59375,7.6875 5.59375,7.75 5.59375,7.84375 C5.59375,7.9375 5.59375,7.96875 5.59375,8.03125 L0.125,8.03125 L0.125,8.125 Z",
                "data-id": "svg_Floor2Icon_path"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
              fillRule: "nonzero",
              "data-id": "svg_Floor2Icon_path_7"
            })]
          })
        })
      })
    })
  });
};

/* harmony default export */ var svg_Floor2Icon = (Floor2Icon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/Floor3Icon.tsx







var Floor3Icon = function Floor3Icon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 20",
    "data-id": "svg_Floor3Icon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      "data-id": "svg_Floor3Icon_g",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "translate(-173.000000, -767.000000)",
        fill: fillColor,
        fillRule: "nonzero",
        "data-id": "svg_Floor3Icon_g_2",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          transform: "translate(173.000000, 767.000000)",
          "data-id": "svg_Floor3Icon_g_3",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            "data-id": "svg_Floor3Icon_g_4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
              "data-id": "svg_Floor3Icon_path"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M12.5625,13.78125 C12.5625,14.5625 12.3125,15.15625 11.8125,15.59375 C11.34375,16.03125 10.625,16.25 9.71875,16.25 C8.875,16.25 8.125,16.0625 7.53125,15.71875 C7.40625,15.65625 7.34375,15.5625 7.28125,15.46875 C7.21875,15.375 7.1875,15.28125 7.1875,15.1875 C7.1875,14.96875 7.34375,14.625 7.65625,14.125 C7.9375,14.40625 8.21875,14.59375 8.5625,14.75 C8.90625,14.90625 9.25,14.96875 9.59375,14.96875 C10,14.96875 10.3125,14.84375 10.5625,14.625 C10.8125,14.40625 10.90625,14.09375 10.90625,13.71875 C10.90625,13.34375 10.78125,13.0625 10.53125,12.84375 C10.28125,12.625 9.96875,12.53125 9.53125,12.53125 L8.9375,12.53125 L8.9375,11.34375 L9.53125,11.34375 C9.75,11.34375 9.9375,11.3125 10.125,11.21875 C10.3125,11.125 10.4375,11 10.53125,10.84375 C10.625,10.6875 10.6875,10.5 10.6875,10.28125 C10.6875,9.6875 10.3125,9.375 9.5625,9.375 C9.28125,9.375 9,9.4375 8.71875,9.53125 C8.4375,9.625 8.125,9.84375 7.75,10.15625 C7.59375,10.03125 7.46875,9.875 7.375,9.6875 C7.28125,9.5 7.21875,9.375 7.21875,9.25 C7.21875,9.125 7.25,9.0625 7.3125,8.96875 C7.375,8.90625 7.4375,8.8125 7.5,8.75 C7.75,8.53125 8.09375,8.375 8.5,8.25 C8.90625,8.125 9.34375,8.0625 9.8125,8.0625 C10.625,8.0625 11.25,8.25 11.6875,8.59375 C12.125,8.9375 12.34375,9.4375 12.34375,10.0625 C12.34375,10.46875 12.25,10.84375 12.03125,11.15625 C11.8125,11.46875 11.53125,11.71875 11.15625,11.875 C11.625,12.0625 11.96875,12.28125 12.1875,12.59375 C12.46875,12.9375 12.5625,13.3125 12.5625,13.78125 Z",
            "data-id": "svg_Floor3Icon_path_6"
          })]
        })
      })
    })
  });
};

/* harmony default export */ var svg_Floor3Icon = (Floor3Icon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/Floor4Icon.tsx







var Floor4Icon = function Floor4Icon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 20",
    "data-id": "svg_Floor4Icon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      "data-id": "svg_Floor4Icon_title",
      children: "Derde Verdieping"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      "data-id": "svg_Floor4Icon_g",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "translate(-185.000000, -130.000000)",
        fill: fillColor,
        "data-id": "svg_Floor4Icon_g_3",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          transform: "translate(185.000000, 130.000000)",
          "data-id": "svg_Floor4Icon_g_4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            strokeWidth: "1",
            "data-id": "svg_Floor4Icon_g_5",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
              fillRule: "nonzero",
              "data-id": "svg_Floor4Icon_path"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M6.875,14.3001527 L6.875,13.1851946 L9.98708094,8.87238952 C10.1831185,8.60283785 10.3791531,8.41088727 10.5751907,8.29653202 C10.7712283,8.18217677 10.9835992,8.125 11.2123097,8.125 C11.3184967,8.125 11.4410183,8.14337825 11.5798783,8.18013529 C11.7187382,8.21689234 11.8208396,8.25977491 11.8861855,8.30878431 L11.8861855,13.0871763 L12.2660064,13.0871763 C12.6907544,13.0871763 12.9031253,13.2832109 12.9031253,13.6752861 C12.9031253,13.7488002 12.8990412,13.8202711 12.890873,13.8897011 C12.8827048,13.9591311 12.8745367,14.026518 12.8663684,14.0918639 L12.8418639,14.3001527 L11.8861855,14.3001527 L11.8861855,16.2482664 L10.2198744,16.2482664 L10.2198744,14.3001527 L6.875,14.3001527 Z M10.2198744,13.0504194 L10.2198744,10.3304117 L8.19824701,13.0504194 L10.2198744,13.0504194 Z",
            "data-id": "svg_Floor4Icon_path_7"
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var svg_Floor4Icon = (Floor4Icon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/HomeReadyIcon.tsx







var HomeReadyIcon = function HomeReadyIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 21",
    "data-id": "svg_HomeReadyIcon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_820_50693)",
      "data-id": "svg_HomeReadyIcon_g",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M9.31873 13.3427L7.80935 11.831C7.51404 11.5023 7.02185 11.5023 6.72654 11.831L5.54529 12.9812L9.28591 16.7277L15.6844 10.2535L14.5359 9.10329C14.2078 8.77465 13.7484 8.77465 13.4203 9.10329L9.31873 13.3427Z",
        fill: fillColor,
        "data-id": "svg_HomeReadyIcon_path"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.5 1.9061L1.64062 7.19718L1.67344 19.3239L18.3422 19.3568C18.9 19.3568 19.3266 18.9296 19.3266 18.3709V7.23005L10.5 1.9061ZM10.5 0L21 6.30986L20.9672 19.0282C20.9672 20.1127 20.0813 21 18.9984 21H0V6.277L10.5 0Z",
        fill: fillColor,
        "data-id": "svg_HomeReadyIcon_path_3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      "data-id": "svg_HomeReadyIcon_defs",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_820_50693",
        "data-id": "svg_HomeReadyIcon_clipPath",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "21",
          height: "21",
          fill: fillColor,
          "data-id": "svg_HomeReadyIcon_rect"
        })
      })
    })]
  });
};

/* harmony default export */ var svg_HomeReadyIcon = (HomeReadyIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/HomeReadyPlusIcon.tsx







var HomeReadyPlusIcon = function HomeReadyPlusIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 21",
    "data-id": "svg_HomeReadyPlusIcon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_820_50703)",
      "data-id": "svg_HomeReadyPlusIcon_g",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.71091 12.9155L6.46404 11.6667C6.20154 11.4038 5.80779 11.4038 5.54529 11.6667L4.56091 12.6197L7.6781 15.7418L13.0265 10.3521L12.075 9.39906C11.8125 9.13615 11.4187 9.13615 11.1562 9.39906L7.71091 12.9155Z",
        fill: fillColor,
        "data-id": "svg_HomeReadyPlusIcon_path"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M16.7015 14.8216V14.6573C16.6687 14.4272 16.5047 14.2629 16.275 14.2629H15.0609V12.4554H14.5031H14.3062C14.0765 12.4883 13.9125 12.6526 13.9125 12.8826V14.2629H12.1078V14.8216V15.0188C12.1406 15.2488 12.3047 15.4131 12.5344 15.4131H13.9125V17.0563H14.5031H14.6672C14.8969 17.0235 15.0609 16.8592 15.0609 16.6291V15.4131H16.7015V14.8216Z",
        fill: fillColor,
        "data-id": "svg_HomeReadyPlusIcon_path_3"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.5 1.9061L1.64062 7.19718L1.67344 19.3239L18.3422 19.3568C18.9 19.3568 19.3266 18.9296 19.3266 18.3709V7.23005L10.5 1.9061ZM10.5 0L21 6.30986L20.9672 19.0282C20.9672 20.1127 20.0812 21 18.9984 21H0V6.277L10.5 0Z",
        fill: fillColor,
        "data-id": "svg_HomeReadyPlusIcon_path_4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      "data-id": "svg_HomeReadyPlusIcon_defs",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_820_50703",
        "data-id": "svg_HomeReadyPlusIcon_clipPath",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "21",
          height: "21",
          fill: fillColor,
          "data-id": "svg_HomeReadyPlusIcon_rect"
        })
      })
    })]
  });
};

/* harmony default export */ var svg_HomeReadyPlusIcon = (HomeReadyPlusIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/SummaryIcon.tsx







var SummaryIcon = function SummaryIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 21",
    "data-id": "svg_SummaryIcon_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_820_50742)",
      "data-id": "svg_SummaryIcon_g",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M18.375 21H0V7.31719L10.4672 0L21 7.84219V18.375C21 19.8188 19.8188 21 18.375 21ZM1.64062 19.3594H18.375C18.9328 19.3594 19.3594 18.9328 19.3594 18.375V8.6625L10.4344 2.03437L1.64062 8.17031V19.3594Z",
        fill: fillColor,
        "data-id": "svg_SummaryIcon_path"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4128 17.0058C10.796 17.0058 10.2595 16.8865 9.80304 16.648C9.34663 16.4095 8.97656 16.0683 8.69285 15.6242C8.40913 15.1801 8.22204 14.6538 8.13158 14.0452H7.21875V13.2681H8.05757C8.04934 13.1776 8.04523 13.0419 8.04523 12.861C8.04523 12.6883 8.04934 12.5362 8.05757 12.4046H7.21875V11.6398H8.13158C8.28783 10.6776 8.662 9.919 9.25411 9.3639C9.84622 8.8088 10.5905 8.53125 11.4868 8.53125C12.2188 8.53125 12.8314 8.69983 13.3248 9.03701C13.6291 9.2426 13.7812 9.46464 13.7812 9.70312C13.7812 9.82648 13.7257 9.97451 13.6147 10.1472C13.5037 10.3199 13.366 10.4844 13.2015 10.6406C12.9794 10.4186 12.7924 10.2603 12.6402 10.1657C12.4881 10.0711 12.3236 9.99918 12.1468 9.94984C11.97 9.90049 11.7788 9.87582 11.5732 9.87582C11.0798 9.87582 10.685 10.0197 10.389 10.3076C10.0929 10.5954 9.88734 11.0395 9.7722 11.6398H12.3133V12.4046H9.68586C9.67763 12.4951 9.67352 12.6184 9.67352 12.7747V13.0029C9.67352 13.0892 9.68174 13.1776 9.69819 13.2681H12.3133V14.0452H9.79688C9.90378 14.5962 10.1011 15.0074 10.389 15.2788C10.6768 15.5502 11.0633 15.6859 11.5485 15.6859C11.7459 15.6859 11.935 15.6612 12.116 15.6118C12.2969 15.5625 12.4675 15.4885 12.6279 15.3898C12.7882 15.2911 12.9589 15.139 13.1398 14.9334C13.1974 15.0074 13.2714 15.0958 13.3618 15.1986C13.4523 15.3014 13.5325 15.4145 13.6024 15.5378C13.6723 15.6612 13.7072 15.7804 13.7072 15.8956C13.7072 16.0929 13.588 16.2862 13.3495 16.4753C13.111 16.6562 12.8355 16.7899 12.523 16.8762C12.2105 16.9626 11.8405 17.0058 11.4128 17.0058Z",
        fill: fillColor,
        "data-id": "svg_SummaryIcon_path_3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      "data-id": "svg_SummaryIcon_defs",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_820_50742",
        "data-id": "svg_SummaryIcon_clipPath",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "21",
          height: "21",
          fill: fillColor,
          "data-id": "svg_SummaryIcon_rect"
        })
      })
    })]
  });
};

/* harmony default export */ var svg_SummaryIcon = (SummaryIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/FloorOptionsIcon.tsx







var FloorOptionsIcon = function FloorOptionsIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 20",
    "data-id": "svg_FloorOptionsIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      "data-id": "svg_FloorOptionsIcon_g",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "translate(-242.000000, -130.000000)",
        fill: fillColor,
        "data-id": "svg_FloorOptionsIcon_g_2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          transform: "translate(0.000000, 124.000000)",
          "data-id": "svg_FloorOptionsIcon_g_3",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            transform: "translate(242.000000, 6.000000)",
            "data-id": "svg_FloorOptionsIcon_g_4",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
              "data-id": "svg_FloorOptionsIcon_g_5",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
                transform: "translate(4.062500, 13.125000)",
                fillRule: "nonzero",
                "data-id": "svg_FloorOptionsIcon_g_6",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
                  "data-id": "svg_FloorOptionsIcon_g_7",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                    cx: "1.40625",
                    cy: "1.40625",
                    r: "1.40625",
                    "data-id": "svg_FloorOptionsIcon_circle"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                    cx: "5.90625",
                    cy: "1.40625",
                    r: "1.40625",
                    "data-id": "svg_FloorOptionsIcon_circle_9"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                    cx: "10.375",
                    cy: "1.40625",
                    r: "1.40625",
                    "data-id": "svg_FloorOptionsIcon_circle_10"
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
                fillRule: "nonzero",
                "data-id": "svg_FloorOptionsIcon_path"
              })]
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var svg_FloorOptionsIcon = (FloorOptionsIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/OneLayerIcon.tsx






var OneLayerIcon = function OneLayerIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray30' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  var fillColor = colors/* colors */.O[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 21 21",
    "data-id": "svg_OneLayerIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      "data-id": "svg_OneLayerIcon_g",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "translate(-40.000000, -212.000000)",
        fill: fillColor,
        fillRule: "nonzero",
        "data-id": "svg_OneLayerIcon_g_2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          transform: "translate(40.000000, 212.000000)",
          "data-id": "svg_OneLayerIcon_g_3",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            "data-id": "svg_OneLayerIcon_g_4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M10,0 L0,6 L0,20 L8.40625,20 L8.40625,13.125 L11.53125,13.125 L11.53125,20 L18.09375,20 C19.125,20 19.96875,19.15625 19.96875,18.125 L20,6 L10,0 Z M18.40625,17.5 C18.40625,18.03125 18,18.4375 17.46875,18.4375 L12.78125,18.4375 L12.78125,11.875 L7.15625,11.875 L7.15625,18.375 L7.15625,18.4375 L1.59375,18.4375 L1.5625,6.875 L10,1.84375 L18.40625,6.875 L18.40625,17.5 Z",
              "data-id": "svg_OneLayerIcon_path"
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var svg_OneLayerIcon = (OneLayerIcon);
;// CONCATENATED MODULE: ./src/constants/icons.ts













var ICON_MAP = {
  houseEmpty: svg_FloorIcon,
  houseGroundFloor: svg_Floor0Icon,
  houseFirstFloor: Floor1Icon,
  houseSecondFloor: svg_Floor2Icon,
  houseThirdFloor: svg_Floor3Icon,
  houseFourthFloor: svg_Floor4Icon,
  houseEllipsis: svg_FloorOptionsIcon,
  houseCheck: svg_HomeReadyIcon,
  houseEuro: svg_SummaryIcon,
  houseLeaf: svg_ComfortIcon,
  houseGear: svg_ElectronicsIcon,
  houseCheckPlus: svg_HomeReadyPlusIcon,
  houseOneLayer: svg_OneLayerIcon
};
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
;// CONCATENATED MODULE: ./src/components/atoms/UpdateAnimator.tsx


var UpdateAnimator_templateObject, UpdateAnimator_templateObject2, UpdateAnimator_templateObject3;







var UpdateAnimator_Container = styled_components_browser_esm["default"].div(UpdateAnimator_templateObject || (UpdateAnimator_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  min-height: 22rem;\n  min-width: 22rem;\n"])));
var UpdateAnimator_Loading = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div)(UpdateAnimator_templateObject2 || (UpdateAnimator_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])));
var LoadingInner = styled_components_browser_esm["default"].div(UpdateAnimator_templateObject3 || (UpdateAnimator_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"])), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
});

var UpdateAnimator = function UpdateAnimator(_ref2) {
  var children = _ref2.children,
      loading = _ref2.loading,
      _ref2$backgroundColor = _ref2.backgroundColor,
      backgroundColor = _ref2$backgroundColor === void 0 ? colors/* colors.white */.O.white : _ref2$backgroundColor;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(UpdateAnimator_Container, {
    "data-id": "atoms_UpdateAnimator_Container",
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      "data-id": "atoms_UpdateAnimator_AnimatePresence",
      children: loading && /*#__PURE__*/(0,jsx_runtime.jsx)(UpdateAnimator_Loading, {
        animate: {
          opacity: 1
        },
        initial: {
          opacity: 0
        },
        exit: {
          opacity: 0
        },
        transition: {
          duration: 0.5
        },
        "data-id": "atoms_UpdateAnimator_Loading",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingInner, {
          backgroundColor: backgroundColor,
          "data-id": "atoms_UpdateAnimator_LoadingInner",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
            monochrome: true,
            size: "small",
            color: colors/* colors.brand */.O.brand,
            "data-id": "atoms_UpdateAnimator_Spinner"
          })
        })
      })
    })]
  });
};

/* harmony default export */ var atoms_UpdateAnimator = (UpdateAnimator);
;// CONCATENATED MODULE: ./src/components/molecules/Layer.tsx


var Layer_templateObject, Layer_templateObject2, Layer_templateObject3, Layer_templateObject4, Layer_templateObject5, Layer_templateObject6, Layer_templateObject7, Layer_templateObject8, Layer_templateObject9, Layer_templateObject10, Layer_templateObject11, Layer_templateObject12, Layer_templateObject13, Layer_templateObject14;















var Layer_ContentWrapper = styled_components_browser_esm["default"].div(Layer_templateObject || (Layer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 8rem;\n  font-weight: ", ";\n  color: ", ";\n  transition: color 200ms ease-in-out;\n  ", "\n\n  ", "\n"])), fonts/* fontWeight.bold */.Ue.bold, colors/* colors.gray40 */.O.gray40, function (_ref) {
  var isLast = _ref.isLast;
  return isLast && fonts/* fontStyles.body.lg */.g6.body.lg;
}, breakpoints/* fromBreakpoint.slg */.ks.slg(Layer_templateObject2 || (Layer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    gap: 12rem;\n  "]))));
var Outer = styled_components_browser_esm["default"].div(Layer_templateObject3 || (Layer_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  ", "\n  padding-top: 0;\n  padding-bottom: 0;\n  transition: padding-top 300ms ease-in-out, padding-bottom 300ms ease-in-out;\n  ", "\n  ", "\n"])), function (_ref2) {
  var isFirst = _ref2.isFirst,
      isMd = _ref2.isMd,
      interactive = _ref2.interactive;
  return isFirst && isMd && interactive && (0,styled_components_browser_esm.css)(Layer_templateObject4 || (Layer_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      border-top: 1rem dashed ", ";\n    "])), colors/* colors.gray20 */.O.gray20);
}, function (_ref3) {
  var isMd = _ref3.isMd,
      interactive = _ref3.interactive;
  return isMd && interactive && (0,styled_components_browser_esm.css)(Layer_templateObject5 || (Layer_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      border-bottom: 1rem dashed ", ";\n    "])), colors/* colors.gray20 */.O.gray20);
}, function (_ref4) {
  var active = _ref4.active;
  return active && (0,styled_components_browser_esm.css)(Layer_templateObject6 || (Layer_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-top: 12rem;\n      padding-bottom: 12rem;\n    "])));
}, function (_ref5) {
  var isMd = _ref5.isMd;
  return !isMd && (0,styled_components_browser_esm.css)(Layer_templateObject7 || (Layer_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-top: 4rem;\n      padding-bottom: 4rem;\n    "])));
});
var Inner = styled_components_browser_esm["default"].div(Layer_templateObject8 || (Layer_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ", "\n  gap: 8rem;\n  border-radius: 8rem 0;\n  font-size: 16rem;\n  line-height: 20rem;\n\n  ", "\n\n  ", "\n\n  &:hover,\n  &:focus,\n  &:active {\n    ", " {\n      ", "\n    }\n  }\n"])), shared/* transitions.hover */.p.hover, function (_ref6) {
  var interactive = _ref6.interactive;
  return interactive && (0,styled_components_browser_esm.css)(Layer_templateObject9 || (Layer_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding: 16rem;\n      margin: 0 -16rem;\n    "])));
}, function (_ref7) {
  var interactive = _ref7.interactive;
  return interactive && "cursor: pointer;";
}, function (_ref8) {
  var active = _ref8.active,
      isMd = _ref8.isMd,
      interactive = _ref8.interactive;
  return (active || !isMd) && interactive && (0,styled_components_browser_esm.css)(Layer_templateObject10 || (Layer_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n      background-color: ", ";\n    "])), colors/* colors.gray10 */.O.gray10);
}, Layer_ContentWrapper, function (_ref9) {
  var interactive = _ref9.interactive;
  return interactive && "color: ".concat(colors/* colors.brand */.O.brand, ";");
});
var Layer_IconWrapper = styled_components_browser_esm["default"].div(Layer_templateObject11 || (Layer_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 16rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  padding-bottom: 1rem;\n\n  svg {\n    width: 100%;\n  }\n\n  ", "\n"])), breakpoints/* fromBreakpoint.slg */.ks.slg(Layer_templateObject12 || (Layer_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 24rem;\n  "]))));
var InfoWrapper = styled_components_browser_esm["default"].div(Layer_templateObject13 || (Layer_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8rem;\n\n  ", "\n"])), breakpoints/* fromBreakpoint.slg */.ks.slg(Layer_templateObject14 || (Layer_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n    gap: 16rem;\n  "]))));

var Layer = function Layer(_ref10) {
  var _ref10$active = _ref10.active,
      active = _ref10$active === void 0 ? false : _ref10$active,
      _ref10$hasNew = _ref10.hasNew,
      hasNew = _ref10$hasNew === void 0 ? false : _ref10$hasNew,
      title = _ref10.title,
      squareMeters = _ref10.squareMeters,
      _ref10$extraSquareMet = _ref10.extraSquareMeters,
      extraSquareMeters = _ref10$extraSquareMet === void 0 ? false : _ref10$extraSquareMet,
      price = _ref10.price,
      _ref10$sign = _ref10.sign,
      sign = _ref10$sign === void 0 ? 'none' : _ref10$sign,
      _ref10$isFirst = _ref10.isFirst,
      isFirst = _ref10$isFirst === void 0 ? false : _ref10$isFirst,
      _ref10$isSummary = _ref10.isSummary,
      isSummary = _ref10$isSummary === void 0 ? false : _ref10$isSummary,
      onClick = _ref10.onClick,
      _ref10$iconSlug = _ref10.iconSlug,
      iconSlug = _ref10$iconSlug === void 0 ? 'houseEmpty' : _ref10$iconSlug,
      _ref10$loading = _ref10.loading,
      loading = _ref10$loading === void 0 ? false : _ref10$loading;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      md = _useBreakpointInfo.isLargerThan.md;

  var _useState = (0,react.useState)(false),
      hovered = _useState[0],
      setHovered = _useState[1];

  var Icon = ICON_MAP[iconSlug];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Outer, {
    isFirst: isFirst,
    active: active,
    isMd: md,
    interactive: !!onClick,
    "data-id": "molecules_Layer_Outer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
      active: active,
      interactive: !!onClick,
      onMouseEnter: function onMouseEnter() {
        return setHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHovered(false);
      },
      onClick: onClick,
      isMd: md,
      "data-id": "molecules_Layer_Inner",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Layer_ContentWrapper, {
        isLast: isSummary,
        "data-id": "molecules_Layer_ContentWrapper",
        children: [!!Icon && /*#__PURE__*/(0,jsx_runtime.jsx)(Layer_IconWrapper, {
          "data-id": "molecules_Layer_IconWrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
            variant: active || hovered || !onClick || !md ? 'brand' : undefined,
            width: 22,
            "data-id": "molecules_Layer_Icon"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_LayerName, {
          title: title,
          hasNew: hasNew,
          "data-id": "molecules_Layer_LayerName"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_UpdateAnimator, {
        loading: loading,
        backgroundColor: active ? colors/* colors.gray10 */.O.gray10 : undefined,
        "data-id": "molecules_Layer_UpdateAnimator",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(InfoWrapper, {
          "data-id": "molecules_Layer_InfoWrapper",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_SquareMeters, {
            squareMeters: squareMeters,
            withPlus: extraSquareMeters,
            animation: true,
            "data-id": "molecules_Layer_SquareMeters"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Price, {
            price: price,
            sign: sign,
            variant: isSummary ? 'brand' : 'transparent',
            displayZero: true,
            animation: true,
            "data-id": "molecules_Layer_Price"
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var molecules_Layer = (Layer);
;// CONCATENATED MODULE: ./src/processes/houseDesignSlugs.ts
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var slugify = function slugify(s) {
  return s.toLowerCase().trim().replace(/[^\-a-zA-Z\d\s]/g, '').replace(/[\s_-]+/g, '-');
};
var getCategoryBySlug = function getCategoryBySlug(wishList, slug) {
  if (!(wishList !== null && wishList !== void 0 && wishList.categories)) {
    return undefined;
  } // eslint-disable-next-line no-restricted-syntax


  var _iterator = _createForOfIteratorHelper(wishList.categories),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var category = _step.value;

      if (slugify(category.title) === slug) {
        return category;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return undefined;
};
;// CONCATENATED MODULE: ./src/processes/wishListPostProcess.ts


function wishListPostProcess_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function wishListPostProcess_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? wishListPostProcess_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : wishListPostProcess_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var PLACE_TO_STATUS_MAP = {
  blocked: 'blocked',
  requested: 'requested',
  process: 'processing',
  pending_bim_submit: 'processing',
  bim_submitted: 'processing',
  controle: 'processing',
  processed: 'processed',
  confirmed: 'confirmed',
  presale: 'processing',
  pending_presale_bim_submit: 'processing',
  presale_bim_submitted: 'processing',
  include: 'processing',
  pending_include_bim_submit: 'processing',
  include_bim_submitted: 'processing',
  signed: 'signed',
  presold: 'presold',
  included: 'included',
  irrevocable: 'signed'
};
var PLACE_IGNORE_LIST = ['blank', 'prognosis', 'cancelled', 'cancelled-postsale'];
/**
 * After fetching a wish list, wo do some post processing to:
 * 1. filter out the "places" that we don't handle in the front end and
 * 2. map the "places" to "statuses" that we will actually use to implement front end logic
 */

var wishListPostProcess = function wishListPostProcess(wishList) {
  return wishListPostProcess_objectSpread(wishListPostProcess_objectSpread({}, wishList), {}, {
    categories: wishList.categories.map(function (category) {
      return wishListPostProcess_objectSpread(wishListPostProcess_objectSpread({}, category), {}, {
        subcategories: category.subcategories.map(function (subcategory) {
          return wishListPostProcess_objectSpread(wishListPostProcess_objectSpread({}, subcategory), {}, {
            options: subcategory.options.map(function (option) {
              var orders = [];
              option.orders.forEach(function (order) {
                var place = order.place;

                if (PLACE_IGNORE_LIST.includes(place)) {
                  return;
                }

                orders.push(wishListPostProcess_objectSpread(wishListPostProcess_objectSpread({}, order), {}, {
                  status: PLACE_TO_STATUS_MAP[place]
                }));
              });
              return wishListPostProcess_objectSpread(wishListPostProcess_objectSpread({}, option), {}, {
                orders: orders
              });
            })
          });
        })
      });
    })
  });
};
var getLayoutImages = function getLayoutImages(_ref) {
  var categories = _ref.categories;
  var result = {};
  categories.forEach(function (_ref2) {
    var title = _ref2.title,
        subcategories = _ref2.subcategories;
    subcategories.forEach(function (_ref3) {
      var _options$find;

      var options = _ref3.options;
      var imageSrc = (_options$find = options.find(function (option) {
        return !!option.layoutImage && isOptionSelected(option);
      })) === null || _options$find === void 0 || (_options$find = _options$find.layoutImage) === null || _options$find === void 0 ? void 0 : _options$find.src;

      if (imageSrc) {
        result[slugify(title)] = imageSrc;
      }
    });
  });
  return result;
};
;// CONCATENATED MODULE: ./src/hooks/useWishList.ts



var useWishList = function useWishList() {
  var _useParams = (0,useParams/* default */.Z)(),
      wishListId = _useParams.wishListId;

  return (0,redux/* useSelector */.v)(function (state) {
    var _state$houseDesign$wi;

    if (!wishListId) {
      return undefined;
    }

    return (_state$houseDesign$wi = state.houseDesign.wishLists[wishListId]) === null || _state$houseDesign$wi === void 0 ? void 0 : _state$houseDesign$wi.data;
  });
};

/* harmony default export */ var hooks_useWishList = (useWishList);
;// CONCATENATED MODULE: ./src/hooks/wishListRequestHooks.ts


function wishListRequestHooks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function wishListRequestHooks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? wishListRequestHooks_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : wishListRequestHooks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






/*
 * We use these hooks to consolidate a number of requests that all return the Wish List data: getWishList,
 * postUserWish and patchWishList. We take the last response that we receive from any of these endpoints
 * and store it in the redux state, so the redux state becomes the single source of truth for the Wish
 * List data.
 */

/**
 * Determine whether the new WishList data is more recent than the current WishList data, by comparing the updatedAt timestamps.
 */

var isOutdated = function isOutdated(newWishListData, currentWishlistData) {
  if (!currentWishlistData) {
    return false;
  }

  return newWishListData.updatedAt < currentWishlistData.updatedAt;
};
/**
 * Hook for GET requests that return an WishList response.
 */


var useWishListQuery = function useWishListQuery(endpoint, queryKey) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var dispatch = (0,es/* useDispatch */.I0)();
  var currentWishlistData = hooks_useWishList();
  var result = (0,requestHooks/* useQueryRequest */.c)(endpoint, queryKey, params, wishListRequestHooks_objectSpread(wishListRequestHooks_objectSpread({}, options), {}, {
    onSuccess: function onSuccess(newWishListData) {
      var _options$onSuccess;

      var wishListId = params === null || params === void 0 ? void 0 : params.wishListId;

      if (wishListId && !isOutdated(newWishListData, currentWishlistData)) {
        var data = wishListPostProcess(newWishListData);
        dispatch((0,houseDesign/* addWishListData */.rC)(wishListId, data, getLayoutImages(data)));
      }

      options === null || options === void 0 || (_options$onSuccess = options.onSuccess) === null || _options$onSuccess === void 0 || _options$onSuccess.call(options, newWishListData);
    }
  }));
  return wishListRequestHooks_objectSpread(wishListRequestHooks_objectSpread({}, result), {}, {
    data: currentWishlistData
  });
};
/**
 * Hook for mutation requests that return an WishList response.
 */

var useWishListMutation = function useWishListMutation(endpoint, mutationKey, params, options) {
  var dispatch = (0,es/* useDispatch */.I0)();
  var currentWishlistData = hooks_useWishList();
  var result = (0,requestHooks/* useMutationRequest */.iO)(endpoint, mutationKey, wishListRequestHooks_objectSpread(wishListRequestHooks_objectSpread({}, options), {}, {
    onSuccess: function onSuccess(newWishListData) {
      var _options$onSuccess2;

      var wishListId = params === null || params === void 0 ? void 0 : params.wishListId;

      if (wishListId && !isOutdated(newWishListData, currentWishlistData)) {
        dispatch((0,houseDesign/* addWishListData */.rC)(wishListId, wishListPostProcess(newWishListData)));
      }

      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      options === null || options === void 0 || (_options$onSuccess2 = options.onSuccess) === null || _options$onSuccess2 === void 0 || _options$onSuccess2.call.apply(_options$onSuccess2, [options, newWishListData].concat(rest));
    }
  }));
  return wishListRequestHooks_objectSpread(wishListRequestHooks_objectSpread({}, result), {}, {
    data: currentWishlistData
  });
};
;// CONCATENATED MODULE: ./src/components/atoms/svg/SaveIcon.tsx






var SaveIcon_SaveIcon = function SaveIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 460.002 460.002",
    "data-id": "svg_SaveIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M427.137,0H32.865C14.743,0,0,14.743,0,32.865v394.272c0,18.122,14.743,32.865,32.865,32.865c3.087,0,390.415,0,394.272,0 c18.122,0,32.865-14.743,32.865-32.865V32.865C460.001,14.743,445.258,0,427.137,0z M382.993,430.001h-29.999V309.673H107.007 v120.328h-30V294.673c0-8.284,6.716-15,15-15h275.986c8.284,0,15,6.716,15,15V430.001z M383.185,165.328c0,8.284-6.716,15-15,15 H92.198c-8.284,0-15-6.716-15-15V30h138.615v0.691v75.435c0,8.284,6.716,15,15,15h80.995c8.284,0,15-6.716,15-15V30.691V30h56.377 V165.328z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_SaveIcon_path"
    })
  });
};

/* harmony default export */ var svg_SaveIcon = (SaveIcon_SaveIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/CloseCircleIcon.tsx






var CloseCircleIcon = function CloseCircleIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 330 330",
    "data-id": "svg_CloseCircleIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      id: "XMLID_29_",
      d: "M165,0C120.926,0,79.492,17.163,48.328,48.327c-64.334,64.333-64.334,169.011-0.002,233.345 C79.49,312.837,120.926,330,165,330c44.072,0,85.508-17.163,116.672-48.328c64.334-64.334,64.334-169.012,0-233.345 C250.508,17.163,209.072,0,165,0z M239.246,239.245c-2.93,2.929-6.768,4.394-10.607,4.394c-3.838,0-7.678-1.465-10.605-4.394 L165,186.213l-53.033,53.033c-2.93,2.929-6.768,4.394-10.607,4.394c-3.838,0-7.678-1.465-10.605-4.394 c-5.859-5.857-5.859-15.355,0-21.213L143.787,165l-53.033-53.033c-5.859-5.857-5.859-15.355,0-21.213 c5.857-5.857,15.355-5.857,21.213,0L165,143.787l53.031-53.033c5.857-5.857,15.355-5.857,21.213,0 c5.859,5.857,5.859,15.355,0,21.213L186.213,165l53.033,53.032C245.104,223.89,245.104,233.388,239.246,239.245z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_CloseCircleIcon_path"
    })
  });
};

/* harmony default export */ var svg_CloseCircleIcon = (CloseCircleIcon);
;// CONCATENATED MODULE: ./src/components/molecules/EditableTitle.tsx


var EditableTitle_excluded = ["wishListItem"];

var EditableTitle_templateObject, EditableTitle_templateObject2, EditableTitle_templateObject3, EditableTitle_templateObject4, EditableTitle_templateObject5;

















var EditableTitle_Container = styled_components_browser_esm["default"].div(EditableTitle_templateObject || (EditableTitle_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-right: 32rem;\n  position: relative;\n  transition: padding-right 300ms ease-in-out, border-color 300ms ease-in-out;\n  border-bottom: 1rem solid transparent;\n\n  ", "\n"])), function (_ref) {
  var editing = _ref.editing;
  return editing && (0,styled_components_browser_esm.css)(EditableTitle_templateObject2 || (EditableTitle_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-right: 64rem;\n      border-bottom: 1rem solid ", ";\n    "])), colors/* colors.gray30 */.O.gray30);
});
var EditableTitle_Input = styled_components_browser_esm["default"].input(EditableTitle_templateObject3 || (EditableTitle_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  width: 100%;\n  border: none;\n  color: ", ";\n  background-color: inherit;\n  padding: 0;\n\n  &:focus-visible {\n    outline: none;\n  }\n"])), fonts/* fontStyles.title.lg */.g6.title.lg, colors/* colors.brand */.O.brand);
var IconButtons = styled_components_browser_esm["default"].div(EditableTitle_templateObject4 || (EditableTitle_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 8rem;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 56rem;\n  justify-content: flex-end;\n  align-items: center;\n  opacity: 1;\n  transition: opacity 300ms ease-in-out;\n\n  ", "\n"])), function (_ref2) {
  var isLoading = _ref2.isLoading;
  return isLoading && (0,styled_components_browser_esm.css)(EditableTitle_templateObject5 || (EditableTitle_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      opacity: 0;\n    "])));
});

var EditableTitle = function EditableTitle(_ref3) {
  var _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? '' : _ref3$title;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useParams = (0,useParams/* default */.Z)(),
      wishListItem = _useParams.wishListItem,
      params = (0,objectWithoutProperties/* default */.Z)(_useParams, EditableTitle_excluded);

  var _useState = (0,react.useState)(false),
      editing = _useState[0],
      setEditing = _useState[1];

  var _useState2 = (0,react.useState)(title),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0,react.useState)(title),
      initialValue = _useState3[0],
      setInitalValue = _useState3[1];

  (0,react.useEffect)(function () {
    setValue(title);
    setInitalValue(title);
  }, [title]);

  var _useWishListMutation = useWishListMutation('patchWishList', [endpoints/* WishListRequestKey.wishListTitle */.P.wishListTitle], params),
      mutate = _useWishListMutation.mutate,
      isLoading = _useWishListMutation.isLoading;

  var submit = function submit() {
    setEditing(false);

    if (value === initialValue) {
      return;
    }

    mutate({
      params: params,
      body: {
        title: value
      }
    });
    setInitalValue(value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_InlineRequestHandler, {
    isLoading: isLoading,
    transparent: true,
    alignRight: true,
    "data-id": "molecules_EditableTitle_InlineRequestHandler",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(EditableTitle_Container, {
      editing: editing,
      "data-id": "molecules_EditableTitle_Container",
      children: [editing || isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(EditableTitle_Input, {
        value: value,
        onChange: function onChange(e) {
          return setValue(e.target.value);
        },
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Escape') {
            setEditing(false);
            return;
          }

          if (e.key === 'Enter') {
            submit();
          }
        },
        maxLength: 50,
        type: "text",
        autoFocus: !isLoading,
        "data-id": "molecules_EditableTitle_Input"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
        text: value,
        variant: "brand",
        hideOverflow: true,
        onClick: function onClick() {
          setEditing(true);
        },
        "data-id": "molecules_EditableTitle_Title"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconButtons, {
        isLoading: isLoading,
        "data-id": "molecules_EditableTitle_IconButtons",
        children: editing ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_IconButton, {
            icon: svg_SaveIcon,
            onClick: submit,
            "data-id": "molecules_EditableTitle_IconButton"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_IconButton, {
            icon: svg_CloseCircleIcon,
            onClick: function onClick() {
              setValue(initialValue);
              setEditing(false);
            },
            "data-id": "molecules_EditableTitle_IconButton_6"
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_IconButton, {
          icon: svg_EditIcon,
          onClick: function onClick() {
            return setEditing(true);
          },
          "data-id": "molecules_EditableTitle_IconButton_7"
        })
      })]
    })
  });
};

/* harmony default export */ var molecules_EditableTitle = (EditableTitle);
// EXTERNAL MODULE: ./src/components/atoms/BoxIcon.tsx
var BoxIcon = __webpack_require__(73566);
;// CONCATENATED MODULE: ./src/components/atoms/svg/FavoriteIcon.tsx






var FavoriteIcon = function FavoriteIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 14 14",
    "data-id": "svg_FavoriteIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.4683 4.78996C12.2831 6.90296 10.4434 9.32983 6.99958 12.0176C3.55478 9.33087 1.71801 6.90296 1.52988 4.78996V4.08737C1.68039 2.4057 2.66561 1.69791 3.29931 1.63347C3.4716 1.61476 3.63399 1.60645 3.7845 1.60645C4.69347 1.60645 5.07469 1.89954 5.82722 2.84015L6.99958 4.30667L8.17293 2.84015C8.92546 1.89954 9.30469 1.60645 10.2156 1.60645C10.3642 1.60645 10.5266 1.61476 10.7008 1.63347C11.3335 1.69791 12.3198 2.4057 12.4683 4.08737V4.78996ZM10.8493 0.0342984C10.6235 0.0114328 10.4126 0 10.2156 0C8.62932 0 7.86887 0.718188 6.9995 1.80742C6.12915 0.718188 5.3687 0 3.78443 0C3.5854 0 3.3745 0.0114328 3.15072 0.0342984C1.77735 0.17461 0.192093 1.4925 0 4.01915V4.85895C0.180211 7.27751 1.91895 10.2594 6.9995 14C12.0811 10.2594 13.8198 7.27751 14 4.85895V4.01915C13.8069 1.4925 12.2207 0.17461 10.8493 0.0342984Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_FavoriteIcon_path"
    })
  });
};

/* harmony default export */ var svg_FavoriteIcon = (FavoriteIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/FavoriteFilledIcon.tsx






var FavoriteFilledIcon_FavoriteIcon = function FavoriteIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 14 14",
    "data-id": "svg_FavoriteFilledIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8493 0.0342984C10.6235 0.0114328 10.4126 0 10.2156 0C8.62932 0 7.86887 0.718188 6.9995 1.80742C6.12915 0.718188 5.3687 0 3.78443 0C3.5854 0 3.3745 0.0114328 3.15072 0.0342984C1.77735 0.17461 0.192093 1.4925 0 4.01915V4.85895C0.180211 7.27751 1.91895 10.2594 6.9995 14C12.0811 10.2594 13.8198 7.27751 14 4.85895V4.01915C13.8069 1.4925 12.2207 0.17461 10.8493 0.0342984Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_FavoriteFilledIcon_path"
    })
  });
};

/* harmony default export */ var FavoriteFilledIcon = (FavoriteFilledIcon_FavoriteIcon);
;// CONCATENATED MODULE: ./src/components/molecules/FavoriteButton.tsx

var FavoriteButton_excluded = ["wishListItem"];










var FavoriteButton = function FavoriteButton(_ref) {
  var _ref$isFavorite = _ref.isFavorite,
      isFavorite = _ref$isFavorite === void 0 ? false : _ref$isFavorite;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useParams = (0,useParams/* default */.Z)(),
      wishListItem = _useParams.wishListItem,
      params = (0,objectWithoutProperties/* default */.Z)(_useParams, FavoriteButton_excluded);

  var _useWishListMutation = useWishListMutation('patchWishList', [endpoints/* WishListRequestKey.wishListFavorite */.P.wishListFavorite], params),
      mutate = _useWishListMutation.mutate,
      isLoading = _useWishListMutation.isLoading;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_InlineRequestHandler, {
    isLoading: isLoading,
    "data-id": "molecules_FavoriteButton_InlineRequestHandler",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BoxIcon/* default */.Z, {
      variant: "transparent",
      size: "lg",
      icon: isFavorite ? FavoriteFilledIcon : svg_FavoriteIcon,
      onClick: function onClick() {
        mutate({
          params: params,
          body: {
            isFavorite: !isFavorite
          }
        });
      },
      "data-id": "molecules_FavoriteButton_BoxIcon"
    })
  });
};

/* harmony default export */ var molecules_FavoriteButton = (FavoriteButton);
// EXTERNAL MODULE: ./node_modules/react-custom-scrollbars/lib/index.js
var react_custom_scrollbars_lib = __webpack_require__(31298);
;// CONCATENATED MODULE: ./src/components/atoms/CustomScrollbars.tsx


var CustomScrollbars_excluded = ["children"];

function CustomScrollbars_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CustomScrollbars_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CustomScrollbars_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CustomScrollbars_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CustomScrollbars = function CustomScrollbars(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, CustomScrollbars_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_custom_scrollbars_lib/* default */.ZP, CustomScrollbars_objectSpread(CustomScrollbars_objectSpread({
    autoHide: true,
    autoHideTimeout: 1000,
    autoHideDuration: 200
  }, props), {}, {
    "data-id": "atoms_CustomScrollbars_Scrollbars",
    children: children
  }));
};

/* harmony default export */ var atoms_CustomScrollbars = (CustomScrollbars);
;// CONCATENATED MODULE: ./src/components/atoms/svg/HomestudiosLogo.tsx







var HomestudiosLogo = function HomestudiosLogo(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 430 248",
    "data-id": "svg_HomestudiosLogo_Svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      "data-id": "svg_HomestudiosLogo_g",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        "data-id": "svg_HomestudiosLogo_g_2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          "data-id": "svg_HomestudiosLogo_g_3",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M24.52,90.19h38.39V48.9c3.05-0.51,5.58-0.76,7.62-0.76c4.16,0,7.41,0.99,9.75,2.97 c2.34,1.98,3.5,4.95,3.5,8.91v90.8H62.91v-44.18H24.52v44.18H3.65V48.9c3.25-0.51,5.69-0.76,7.31-0.76 c9.04,0,13.56,3.96,13.56,11.88V90.19z",
            "data-id": "svg_HomestudiosLogo_path"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M189.28,99.48c0,16.86-4.04,30.06-12.11,39.61c-8.07,9.55-19.58,14.32-34.51,14.32 c-9.85,0-18.18-2.19-24.98-6.55c-6.81-4.37-11.96-10.61-15.46-18.74c-3.5-8.12-5.26-17.62-5.26-28.49 c0-10.76,1.93-20.19,5.79-28.26c3.86-8.07,9.29-14.19,16.3-18.36c7.01-4.16,15.29-6.25,24.83-6.25 c14.52,0,25.72,4.62,33.59,13.86C185.34,69.87,189.28,82.82,189.28,99.48z M167.8,99.63c0-11.58-2.06-20.49-6.17-26.74 c-4.11-6.25-10.08-9.37-17.9-9.37c-8.23,0-14.47,3.12-18.74,9.37c-4.27,6.25-6.4,15.16-6.4,26.74c0,11.68,2.13,20.79,6.4,27.35 c4.26,6.55,10.36,9.83,18.28,9.83c7.92,0,13.99-3.25,18.21-9.75C165.69,120.56,167.8,111.42,167.8,99.63z",
            "data-id": "svg_HomestudiosLogo_path_5"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M217.36,48.14c2.84,0,5.26,0.66,7.24,1.98c1.98,1.32,3.63,3.51,4.95,6.55l23.16,54.54l23.31-53.93 c2.74-6.09,6.96-9.14,12.64-9.14c4.67,0,8.18,0.46,10.51,1.37l7.31,101.31h-19.81l-4.72-67.64l-20.72,46.31h-17.52l-20.11-44.33 l-4.42,65.66h-19.96l7.47-101.31C209.64,48.6,213.19,48.14,217.36,48.14z",
            "data-id": "svg_HomestudiosLogo_path_6"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M374.55,134.67c4.06,0,7.18,0.94,9.37,2.82c2.18,1.88,3.28,4.55,3.28,8c0,1.12-0.03,2.06-0.07,2.82 c-0.05,0.76-0.13,1.6-0.23,2.51h-65.97V48.75h63.53c0.3,1.52,0.46,3.4,0.46,5.64c0,3.86-0.99,6.6-2.97,8.23 c-1.98,1.63-5.31,2.44-9.98,2.44h-30.01v25.14h32.3v16.3h-32.3v28.18H374.55z",
            "data-id": "svg_HomestudiosLogo_path_7"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          "data-id": "svg_HomestudiosLogo_g",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M8.11,228.22c3.11,2.42,6.02,4.15,8.72,5.19c2.7,1.04,5.5,1.56,8.4,1.56c3.53,0,6.35-0.81,8.46-2.44 c2.11-1.63,3.16-3.93,3.16-6.9c-0.07-2.42-0.73-4.34-1.97-5.76c-1.25-1.42-2.89-2.59-4.93-3.53c-2.04-0.93-4.27-1.78-6.69-2.54 c-2.22-0.69-4.43-1.5-6.64-2.44c-2.22-0.93-4.24-2.13-6.07-3.58c-1.83-1.45-3.32-3.32-4.46-5.6c-1.14-2.28-1.71-5.12-1.71-8.51 c0-4.22,1.07-7.85,3.22-10.89c2.14-3.04,5.1-5.38,8.87-7c3.77-1.62,7.97-2.44,12.61-2.44c3.6,0,7.09,0.47,10.48,1.4 c3.39,0.93,5.91,2.02,7.57,3.27c1.94,1.11,2.91,2.66,2.91,4.67c0,0.9-0.38,2.06-1.14,3.48c-0.76,1.42-1.76,2.79-3.01,4.1 c-2.14-1.73-4.6-3.13-7.37-4.2c-2.77-1.07-5.47-1.61-8.09-1.61c-3.39,0-6.09,0.67-8.09,2.02c-2.01,1.35-3.01,3.3-3.01,5.86 c0,1.39,0.33,2.63,0.99,3.74c0.66,1.11,1.75,2.14,3.27,3.11c1.52,0.97,4.36,2.22,8.51,3.74c2.21,0.83,4.46,1.73,6.74,2.7 c2.28,0.97,4.36,2.2,6.23,3.68c1.87,1.49,3.39,3.36,4.57,5.6c1.18,2.25,1.76,5.07,1.76,8.46c0,7.06-2.33,12.59-7,16.6 c-4.67,4.01-11.02,6.02-19.04,6.02c-3.73,0-7.23-0.38-10.48-1.14c-3.25-0.76-6.02-1.8-8.3-3.11c-1.94-1.31-2.91-2.84-2.91-4.57 C3.65,235.14,5.14,232.16,8.11,228.22z",
            "data-id": "svg_HomestudiosLogo_path"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M76.64,186.3H54.96c-0.21-1.25-0.31-2.63-0.31-4.15c0-2.28,0.79-4.1,2.39-5.45 c1.59-1.35,3.73-2.02,6.43-2.02h48.77c0.21,1.45,0.31,2.94,0.31,4.46c0,2.21-0.74,3.96-2.23,5.24c-1.49,1.28-3.58,1.92-6.28,1.92 H90.96v57.9H76.64V186.3z",
            "data-id": "svg_HomestudiosLogo_path_10"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M171.81,216.19c0,3.05-0.14,5.85-0.42,8.4c-0.41,4.5-1.75,8.34-3.99,11.52c-2.25,3.18-5.29,5.59-9.13,7.21 c-3.84,1.63-8.39,2.44-13.64,2.44c-8.16,0-14.35-1.71-18.57-5.14c-4.22-3.42-6.78-8.91-7.68-16.45 c-0.28-2.21-0.41-4.88-0.41-7.99v-41.4c2.21-0.34,3.87-0.52,4.98-0.52c6.16,0,9.23,2.7,9.23,8.09v34.76 c0,4.15,0.42,7.37,1.25,9.65c0.83,2.28,2.18,3.98,4.05,5.08c1.87,1.11,4.36,1.66,7.47,1.66c4.36,0,7.56-1.25,9.6-3.74 c2.04-2.49,3.06-6.43,3.06-11.83v-43.16c2.21-0.34,3.87-0.52,4.98-0.52c6.16,0,9.24,2.7,9.24,8.09V216.19z",
            "data-id": "svg_HomestudiosLogo_path_11"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M237.79,208.3c0,7.33-1.35,13.73-4.05,19.19c-2.7,5.47-6.52,9.61-11.46,12.45 c-4.95,2.84-10.81,4.25-17.59,4.25h-22.1v-68.9c6.43-0.83,12.94-1.24,19.51-1.24c11.83,0,20.73,2.87,26.72,8.61 C234.8,188.41,237.79,196.96,237.79,208.3z M223.27,208.51c0-7.89-1.66-13.75-4.98-17.59c-3.32-3.84-8.37-5.76-15.15-5.76 c-1.94,0-4.01,0.1-6.22,0.31v47.83h5.71c7.12,0,12.35-1.97,15.67-5.92C221.61,223.45,223.27,217.15,223.27,208.51z",
            "data-id": "svg_HomestudiosLogo_path_12"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M247.93,174.79c2.21-0.34,3.87-0.52,4.98-0.52c6.16,0,9.23,2.7,9.23,8.09v61.84h-14.21V174.79z",
            "data-id": "svg_HomestudiosLogo_path_13"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M334.4,209.23c0,11.48-2.75,20.48-8.25,26.98c-5.5,6.5-13.33,9.75-23.5,9.75c-6.71,0-12.38-1.49-17.02-4.46 c-4.63-2.97-8.14-7.23-10.53-12.76c-2.39-5.53-3.58-12-3.58-19.4c0-7.33,1.31-13.75,3.94-19.25c2.63-5.5,6.33-9.67,11.1-12.5 c4.77-2.84,10.41-4.25,16.91-4.25c9.89,0,17.52,3.15,22.88,9.44C331.72,189.07,334.4,197.89,334.4,209.23z M319.77,209.34 c0-7.88-1.4-13.95-4.2-18.21c-2.8-4.25-6.87-6.38-12.19-6.38c-5.6,0-9.86,2.13-12.76,6.38c-2.9,4.25-4.36,10.32-4.36,18.21 c0,7.96,1.45,14.16,4.36,18.63c2.91,4.46,7.06,6.69,12.45,6.69c5.4,0,9.53-2.21,12.4-6.64 C318.33,223.59,319.77,217.36,319.77,209.34z",
            "data-id": "svg_HomestudiosLogo_path_14"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: colors/* colors.gray30 */.O.gray30,
            d: "M343.62,228.22c3.11,2.42,6.02,4.15,8.72,5.19c2.7,1.04,5.5,1.56,8.4,1.56c3.53,0,6.35-0.81,8.46-2.44 c2.11-1.63,3.16-3.93,3.16-6.9c-0.07-2.42-0.73-4.34-1.97-5.76c-1.25-1.42-2.89-2.59-4.93-3.53c-2.04-0.93-4.27-1.78-6.69-2.54 c-2.22-0.69-4.43-1.5-6.64-2.44c-2.22-0.93-4.24-2.13-6.07-3.58c-1.83-1.45-3.32-3.32-4.46-5.6c-1.14-2.28-1.71-5.12-1.71-8.51 c0-4.22,1.07-7.85,3.22-10.89c2.14-3.04,5.1-5.38,8.87-7c3.77-1.62,7.97-2.44,12.61-2.44c3.6,0,7.09,0.47,10.48,1.4 c3.39,0.93,5.91,2.02,7.57,3.27c1.94,1.11,2.91,2.66,2.91,4.67c0,0.9-0.38,2.06-1.14,3.48c-0.76,1.42-1.76,2.79-3.01,4.1 c-2.14-1.73-4.6-3.13-7.37-4.2c-2.77-1.07-5.47-1.61-8.09-1.61c-3.39,0-6.09,0.67-8.09,2.02c-2.01,1.35-3.01,3.3-3.01,5.86 c0,1.39,0.33,2.63,0.99,3.74c0.66,1.11,1.75,2.14,3.27,3.11c1.52,0.97,4.36,2.22,8.51,3.74c2.21,0.83,4.46,1.73,6.74,2.7 c2.28,0.97,4.36,2.2,6.23,3.68c1.87,1.49,3.39,3.36,4.57,5.6c1.18,2.25,1.76,5.07,1.76,8.46c0,7.06-2.33,12.59-7,16.6 c-4.67,4.01-11.02,6.02-19.04,6.02c-3.73,0-7.23-0.38-10.48-1.14c-3.25-0.76-6.02-1.8-8.3-3.11c-1.94-1.31-2.91-2.84-2.91-4.57 C339.16,235.14,340.65,232.16,343.62,228.22z",
            "data-id": "svg_HomestudiosLogo_path_15"
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      "data-id": "svg_HomestudiosLogo_g",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "none",
        d: "M431.86,35.18V10.52c0-0.41-0.22-0.78-0.57-0.98L409.94-2.79c-0.35-0.2-0.78-0.2-1.13,0L387.46,9.54 c-0.35,0.2-0.57,0.58-0.57,0.98v24.66c0,0.41,0.22,0.78,0.57,0.98l21.35,12.33c0.35,0.2,0.78,0.2,1.13,0l21.35-12.33 C431.65,35.96,431.86,35.58,431.86,35.18z",
        "data-id": "svg_HomestudiosLogo_path"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        "data-id": "svg_HomestudiosLogo_g",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: colors/* colors.brand */.O.brand,
          d: "M427.78,32.89c0-0.37-0.2-0.7-0.5-0.87l0,0l-16.89-9.75v-2.69l14.98,8.65c0.23,0.13,0.5,0.21,0.76,0.21 c0.54,0,1.05-0.29,1.33-0.76l0.25-0.42l-17.32-10v-2.69l14.98,8.65c0.23,0.13,0.5,0.21,0.76,0.21c0.54,0,1.05-0.29,1.33-0.77 l0.25-0.42l-17.32-10V9.53l14.98,8.65c0.23,0.13,0.5,0.21,0.76,0.21c0.55,0,1.05-0.29,1.33-0.77l0.25-0.42l-17.32-10V4.51 l14.98,8.65c0.23,0.13,0.5,0.21,0.76,0.21c0.54,0,1.05-0.29,1.33-0.76l0.25-0.42L409.88,1.89l0,0c-0.15-0.09-0.32-0.14-0.5-0.14 c-0.56,0-1.01,0.45-1.01,1.01v40.17l0,0c0,0.56,0.45,1.01,1.01,1.01c0.18,0,0.35-0.05,0.49-0.13l0,0c0,0,0.01,0,0.01-0.01 l17.4-10.04c0,0,0,0,0,0C427.58,33.59,427.78,33.27,427.78,32.89z M410.39,24.6l2.13,1.23l-2.13,1.23V24.6z M410.39,29.39 l4.15-2.4l2.06,1.19l-6.22,3.58V29.39z M410.39,34.1l8.24-4.75l2.07,1.2l-10.31,5.96V34.1z M410.39,41.19v-2.35l12.33-7.12 l2.04,1.18L410.39,41.19z",
          "data-id": "svg_HomestudiosLogo_path"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: colors/* colors.brand */.O.brand,
          d: "M390.97,13.85v19.53h2.02V12.32h-0.49C391.66,12.32,390.97,13.01,390.97,13.85z",
          "data-id": "svg_HomestudiosLogo_path_20"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: colors/* colors.brand */.O.brand,
          d: "M404.02,5.85v35.11h2.02V4.32h-0.49C404.7,4.32,404.02,5.01,404.02,5.85z",
          "data-id": "svg_HomestudiosLogo_path_21"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: colors/* colors.brand */.O.brand,
          d: "M399.67,8.49v29.92h2.02V6.96h-0.49C400.36,6.96,399.67,7.65,399.67,8.49z",
          "data-id": "svg_HomestudiosLogo_path_22"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: colors/* colors.brand */.O.brand,
          d: "M395.32,11.18v24.66h2.02V9.65h-0.49C396.01,9.65,395.32,10.34,395.32,11.18z",
          "data-id": "svg_HomestudiosLogo_path_23"
        })]
      })]
    })]
  });
};

/* harmony default export */ var svg_HomestudiosLogo = (HomestudiosLogo);
;// CONCATENATED MODULE: ./src/hooks/useHomestudiosPath.ts


var useHomestudiosPath = function useHomestudiosPath(slug) {
  var _useParams = (0,useParams/* default */.Z)(),
      projectSlug = _useParams.projectSlug,
      wishListId = _useParams.wishListId;

  if (!wishListId) {
    return "/".concat(projectSlug, "/closed/");
  }

  var baseUrl = "/".concat(projectSlug, "/closed/homestudio/").concat(wishListId);

  if (!slug) {
    return baseUrl;
  }

  return "".concat(baseUrl, "/").concat(slug);
};

/* harmony default export */ var hooks_useHomestudiosPath = (useHomestudiosPath);
;// CONCATENATED MODULE: ./src/processes/houseDesignLivingSpace.ts

/**
 * Get the living surface in square meters for an option and it's orders
 */

var getLivingSurfaceForOption = function getLivingSurfaceForOption(option, wishList) {
  return houseDesignStatuses_getTotalAmountForOption(option, wishList) * option.livingSurface;
};
/**
 * Get the cumulative living surface in square meters for the selected and/or ordered options of a subcategory
 */

var getTotalLivingSurfaceForSubcategory = function getTotalLivingSurfaceForSubcategory(_ref, wishList) {
  var options = _ref.options;
  return options.reduce(function (optionsCumulative, option) {
    return optionsCumulative + getLivingSurfaceForOption(option, wishList);
  }, 0);
};
/**
 * Get the cumulative living surface in square meters for the selected and/or ordered options of a category
 */

var getTotalLivingSurfaceForCategory = function getTotalLivingSurfaceForCategory(subCategories, wishList) {
  return subCategories.reduce(function (subcategoryCumulative, subcategory) {
    return subcategoryCumulative + getTotalLivingSurfaceForSubcategory(subcategory, wishList);
  }, 0);
};
/**
 * Get the cumulative living surface in square meters for all categories, plus the house living space
 */

var getTotalLivingSurface = function getTotalLivingSurface(wishList) {
  var _houseType$livingSpac;

  var houseType = wishList.houseType,
      categories = wishList.categories;
  var houseLivingSpace = (_houseType$livingSpac = houseType === null || houseType === void 0 ? void 0 : houseType.livingSpace) !== null && _houseType$livingSpac !== void 0 ? _houseType$livingSpac : 0;
  return houseLivingSpace + categories.reduce(function (categoryTotal, _ref2) {
    var subcategories = _ref2.subcategories;
    return categoryTotal + subcategories.reduce(function (subCategoryTotal, subcategory) {
      return subCategoryTotal + getTotalLivingSurfaceForSubcategory(subcategory, wishList);
    }, 0);
  }, 0);
};
;// CONCATENATED MODULE: ./src/processes/houseDesignPrices.ts

/**
 * The total price for a WishList subcategory
 */

var getTotalPriceForSubcategory = function getTotalPriceForSubcategory(_ref, wishList) {
  var options = _ref.options;
  return options.reduce(function (totalPrice, option) {
    var price = option.price;
    return totalPrice + getTotalAmountForOption(option, wishList) * price;
  }, 0);
};
/**
 * The total price for a WishList category
 */

var getTotalPriceForCategory = function getTotalPriceForCategory(title, totals) {
  var _totals$categories$fi, _totals$categories$fi2;

  return (_totals$categories$fi = (_totals$categories$fi2 = totals.categories.find(function (item) {
    return item.title === title;
  })) === null || _totals$categories$fi2 === void 0 ? void 0 : _totals$categories$fi2.total) !== null && _totals$categories$fi !== void 0 ? _totals$categories$fi : 0;
};
/**
 * The total price for the reference options in a WishList category
 */

var getTotalReferencePriceForCategory = function getTotalReferencePriceForCategory(subcategories, wishList) {
  return subcategories.reduce(function (totalSubcategoryPrice, _ref2) {
    var options = _ref2.options;
    return totalSubcategoryPrice + options.reduce(function (totalOptionsPrice, option) {
      var price = option.price,
          optionType = option.optionType;

      if (optionType !== 'reference') {
        return totalOptionsPrice;
      }

      return totalOptionsPrice + houseDesignStatuses_getTotalAmountForOption(option, wishList) * price;
    }, 0);
  }, 0);
};
/**
 * The total price for the full WishList
 */

var getTotalPrice = function getTotalPrice(_ref3) {
  var _ref3$categories = _ref3.categories,
      categories = _ref3$categories === void 0 ? [] : _ref3$categories,
      _ref3$userWishTotal = _ref3.userWishTotal,
      userWishTotal = _ref3$userWishTotal === void 0 ? 0 : _ref3$userWishTotal;
  var basePrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return userWishTotal + categories.reduce(function (cumulativeTotal, _ref4) {
    var _ref4$total = _ref4.total,
        total = _ref4$total === void 0 ? 0 : _ref4$total;
    return cumulativeTotal + total;
  }, basePrice);
};
;// CONCATENATED MODULE: ./src/constants/slugs.ts
var Slug;

(function (Slug) {
  Slug["base"] = "de-basis";
  Slug["summary"] = "samenvatting";
  Slug["userWishes"] = "eigen-woonwensen";
})(Slug || (Slug = {}));
;// CONCATENATED MODULE: ./src/processes/houseDesignSections.ts







/**
 * Get the config for the sections/pages of a wish list, to build navigation etc.
 */
var getWishListSections = function getWishListSections(baseUrl, wishList) {
  if (!wishList) {
    return [];
  }

  var categories = wishList.categories,
      house = wishList.house,
      houseType = wishList.houseType,
      totals = wishList.totals;
  return [{
    slug: Slug.base,
    title: 'De basis',
    price: house.price,
    squareMeters: houseType === null || houseType === void 0 ? void 0 : houseType.livingSpace,
    url: baseUrl
  }].concat((0,toConsumableArray/* default */.Z)(categories.map(function (_ref) {
    var title = _ref.title,
        icon = _ref.icon,
        subcategories = _ref.subcategories,
        id = _ref.id;
    var slug = slugify(title);
    return {
      id: id,
      slug: slug,
      title: title,
      price: getTotalPriceForCategory(title, totals),
      url: "".concat(baseUrl, "/").concat(slug),
      squareMeters: getTotalLivingSurfaceForCategory(subcategories, wishList),
      iconSlug: icon,
      extraSquareMeters: true,
      hasNew: hasNewOptions(subcategories),
      referencePrice: getTotalReferencePriceForCategory(subcategories, wishList)
    };
  })), [{
    slug: Slug.userWishes,
    title: 'Eigen woonwensen',
    price: totals.userWishTotal,
    url: "".concat(baseUrl, "/eigen-woonwensen"),
    iconSlug: 'houseEllipsis'
  }, {
    slug: Slug.summary,
    title: 'Samenvatting',
    price: getTotalPrice(totals, house.price),
    url: "".concat(baseUrl, "/samenvatting"),
    squareMeters: getTotalLivingSurface(wishList),
    iconSlug: 'houseEuro',
    isSummary: true
  }]);
};
/**
 * Get the index of the current section in the list of all sections
 */

var getCurrentSectionIndex = function getCurrentSectionIndex(sections, currentSectionSlug) {
  if (!currentSectionSlug) {
    return 0;
  }

  return sections.findIndex(function (_ref2) {
    var slug = _ref2.slug;
    return slug === currentSectionSlug;
  });
};
/**
 * Get the next section of the wish list, based on the current slug.
 */

var getNextSection = function getNextSection(sections, currentSectionSlug) {
  var currentSectionIndex = getCurrentSectionIndex(sections, currentSectionSlug);

  if (currentSectionIndex === -1) {
    return undefined;
  }

  return sections[currentSectionIndex + 1];
};
/**
 * Get the previous section of the wish list, based on the current slug.
 */

var getPreviousSection = function getPreviousSection(sections, currentSectionSlug) {
  var currentSectionIndex = getCurrentSectionIndex(sections, currentSectionSlug);

  if (currentSectionIndex === -1) {
    return undefined;
  }

  return sections[currentSectionIndex - 1];
};
var getSelectedOptions = function getSelectedOptions(wishList, categoryId) {
  if (!categoryId) {
    return [];
  }

  var category = wishList.categories.find(function (_ref3) {
    var id = _ref3.id;
    return id === categoryId;
  });

  if (!category) {
    return [];
  }

  var optionSummaries = [];
  category.subcategories.forEach(function (_ref4) {
    var options = _ref4.options;
    options.forEach(function (option) {
      var optionAmount = houseDesignStatuses_getTotalAmountForOption(option);

      if (optionAmount === 0 || isOptionExcluded(option, wishList) || isOptionDisabled(option)) {
        return;
      }

      optionSummaries.push({
        id: option.id,
        title: option.title,
        price: optionAmount * option.price,
        squareMeters: getLivingSurfaceForOption(option),
        iconSlug: undefined,
        isSummary: false,
        isReference: option.optionType === 'reference'
      });
    });
  });
  return optionSummaries;
};
;// CONCATENATED MODULE: ./src/hooks/useSections.ts





/**
 * Get the config for the sections/pages of a wish list, to build and handle navigation etc.
 */

var useSections = function useSections() {
  var _useParams = (0,useParams/* default */.Z)(),
      wishListItem = _useParams.wishListItem;

  var wishList = hooks_useWishList();
  var baseUrl = hooks_useHomestudiosPath();
  var sections = (0,react.useMemo)(function () {
    return getWishListSections(baseUrl, wishList);
  }, [wishList, baseUrl]);
  return {
    sections: sections,
    currentSectionSlug: wishListItem,
    nextSection: getNextSection(sections, wishListItem),
    previousSection: getPreviousSection(sections, wishListItem)
  };
};

/* harmony default export */ var hooks_useSections = (useSections);
;// CONCATENATED MODULE: ./src/components/atoms/MaxWidth.tsx


var MaxWidth_templateObject, MaxWidth_templateObject2, MaxWidth_templateObject3;






var MaxWidthOuter = styled_components_browser_esm["default"].div(MaxWidth_templateObject || (MaxWidth_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n"])));
var MaxWidthInner = styled_components_browser_esm["default"].div(MaxWidth_templateObject2 || (MaxWidth_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 520rem;\n  width: 100%;\n  margin: 0 auto;\n\n  ", "\n"])), breakpoints/* fromBreakpoint.slg */.ks.slg(MaxWidth_templateObject3 || (MaxWidth_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    max-width: 680rem;\n  "]))));

var MaxWidth_MaxWidth = function MaxWidth(_ref) {
  var children = _ref.children,
      applyUpToBreakpoint = _ref.applyUpToBreakpoint;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      isLargerThan = _useBreakpointInfo.isLargerThan;

  if (!!applyUpToBreakpoint && isLargerThan[applyUpToBreakpoint]) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(MaxWidthOuter, {
    "data-id": "atoms_MaxWidth_MaxWidthOuter",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MaxWidthInner, {
      "data-id": "atoms_MaxWidth_MaxWidthInner",
      children: children
    })
  });
};

/* harmony default export */ var atoms_MaxWidth = (MaxWidth_MaxWidth);
;// CONCATENATED MODULE: ./src/hooks/useSectionLoading.ts






var useSectionLoading = function useSectionLoading() {
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useParams = (0,useParams/* default */.Z)(),
      wishListId = _useParams.wishListId;

  var sectionLoadingStates = (0,redux/* useSelector */.v)(function (state) {
    if (!wishListId) {
      return {};
    }

    return state.houseDesign.wishLists[wishListId].sectionLoadingStates;
  });
  return (0,react.useMemo)(function () {
    return {
      isSectionLoading: function isSectionLoading(slug) {
        if (!slug) {
          return false;
        }

        return sectionLoadingStates[slug] === true;
      },
      toggleSectionLoading: function toggleSectionLoading(loading, slug) {
        if (!wishListId || !slug) {
          return;
        }

        dispatch((0,houseDesign/* toggleSectionLoading */.D2)(wishListId, slug, loading));
      },
      isAnySectionLoading: Object.values(sectionLoadingStates).some(function (isLoading) {
        return isLoading;
      })
    };
  }, [dispatch, sectionLoadingStates, wishListId]);
};

/* harmony default export */ var hooks_useSectionLoading = (useSectionLoading);
;// CONCATENATED MODULE: ./src/components/houseDesign/Menu.tsx


var houseDesign_Menu_templateObject, houseDesign_Menu_templateObject2, houseDesign_Menu_templateObject3, houseDesign_Menu_templateObject4, houseDesign_Menu_templateObject5;



























var houseDesign_Menu_Container = styled_components_browser_esm["default"].nav(houseDesign_Menu_templateObject || (houseDesign_Menu_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  height: 100%;\n\n  ", "\n"])), colors/* colors.white */.O.white, breakpoints/* fromBreakpoint.md */.ks.md(houseDesign_Menu_templateObject2 || (houseDesign_Menu_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 100vh;\n  "]))));
var Menu_TitleContainer = styled_components_browser_esm["default"].div(houseDesign_Menu_templateObject3 || (houseDesign_Menu_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-right: 40rem;\n  position: relative;\n  min-height: 24rem;\n"])));
var EditableTitleWrapper = styled_components_browser_esm["default"].div(houseDesign_Menu_templateObject4 || (houseDesign_Menu_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 8rem;\n"])));
var FavoriteButtonWrapper = styled_components_browser_esm["default"].div(houseDesign_Menu_templateObject5 || (houseDesign_Menu_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  width: 24rem;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));

var houseDesign_Menu_Menu = function Menu(_ref) {
  var wishList = _ref.wishList,
      backLink = _ref.backLink;
  var router = (0,next_router.useRouter)();

  var _useParams = (0,useParams/* default */.Z)(),
      projectSlug = _useParams.projectSlug,
      wishListId = _useParams.wishListId;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      md = _useBreakpointInfo.isLargerThan.md;

  var _useSections = hooks_useSections(),
      sections = _useSections.sections,
      currentSectionSlug = _useSections.currentSectionSlug;

  var _useSectionLoading = hooks_useSectionLoading(),
      isSectionLoading = _useSectionLoading.isSectionLoading,
      isAnySectionLoading = _useSectionLoading.isAnySectionLoading;

  if (!wishList || !projectSlug || !wishListId) {
    return null;
  }

  var _onClick = function onClick(path) {
    dispatch((0,houseDesign/* toggleMenu */.js)(false));
    router === null || router === void 0 || router.push(path);
  };

  var createdAt = wishList.createdAt,
      house = wishList.house,
      isFavorite = wishList.isFavorite,
      title = wishList.title;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_Menu_Container, {
    "data-id": "houseDesign_Menu_Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_CustomScrollbars, {
      autoHeight: true,
      autoHeightMax: md ? '100vh' : '100%',
      "data-id": "houseDesign_Menu_CustomScrollbars",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        padding: "xl",
        paddingTop: "lg",
        "data-id": "houseDesign_Menu_Box",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_MaxWidth, {
          applyUpToBreakpoint: breakpoints/* BreakpointSize.md */.EC.md,
          "data-id": "houseDesign_Menu_MaxWidth",
          children: [md && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
              marginBottom: "md",
              "data-id": "houseDesign_Menu_Box",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* default */.Z, {
                variant: "brand",
                iconBefore: svg_LeftArrowIcon,
                text: "Mijn woonontwerpen",
                onClick: function onClick() {
                  router === null || router === void 0 || router.push(backLink);
                },
                "data-id": "houseDesign_Menu_TextButton"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
              marginBottom: "md",
              "data-id": "houseDesign_Menu_Box",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(svg_HomestudiosLogo, {
                width: 100,
                "data-id": "houseDesign_Menu_HomestudiosLogo"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            marginBottom: "lg",
            "data-id": "houseDesign_Menu_Box",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Menu_TitleContainer, {
              "data-id": "houseDesign_Menu_TitleContainer",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EditableTitleWrapper, {
                "data-id": "houseDesign_Menu_EditableTitleWrapper",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_EditableTitle, {
                  title: title,
                  "data-id": "houseDesign_Menu_EditableTitle"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(FavoriteButtonWrapper, {
                "data-id": "houseDesign_Menu_FavoriteButtonWrapper",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_FavoriteButton, {
                  isFavorite: isFavorite,
                  "data-id": "houseDesign_Menu_FavoriteButton"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
              text: "Ontwerp voor bouwnummer ".concat(house.bnr),
              "data-id": "houseDesign_Menu_Text"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
              text: "Aangemaakt op ".concat(formatDateWithFullMonth(createdAt)),
              variant: "gray30",
              "data-id": "houseDesign_Menu_Text_15"
            })]
          }), sections.map(function (_ref2, i) {
            var slug = _ref2.slug,
                title = _ref2.title,
                price = _ref2.price,
                squareMeters = _ref2.squareMeters,
                url = _ref2.url,
                iconSlug = _ref2.iconSlug,
                extraSquareMeters = _ref2.extraSquareMeters,
                hasNew = _ref2.hasNew,
                isSummary = _ref2.isSummary;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Layer, {
              active: currentSectionSlug === slug || slug === Slug.base && !currentSectionSlug,
              title: title,
              price: price,
              onClick: function onClick() {
                return _onClick(url);
              },
              squareMeters: squareMeters,
              iconSlug: iconSlug,
              extraSquareMeters: extraSquareMeters,
              hasNew: hasNew,
              isSummary: isSummary,
              isFirst: i === 0,
              loading: slug === Slug.summary ? isAnySectionLoading : isSectionLoading(slug),
              "data-id": "houseDesign_Menu_Layer"
            }, slug);
          })]
        })
      })
    })
  });
};

/* harmony default export */ var houseDesign_Menu = (houseDesign_Menu_Menu);
// EXTERNAL MODULE: ./src/styles/globalStyles.ts
var globalStyles = __webpack_require__(88999);
;// CONCATENATED MODULE: ./src/components/atoms/UtilityButton.tsx


var UtilityButton_templateObject;




var VARIANT_ICON_VARIANT_MAP = {
  brand: 'white',
  gray40: 'white',
  white: 'brand'
};
var VARIANT_HOVER_COLOR_MAP = {
  brand: colors/* colors.gray10 */.O.gray10,
  gray40: colors/* colors.white */.O.white,
  white: colors/* colors.white */.O.white
};
var UtilityButton_Wrapper = styled_components_browser_esm["default"].div(UtilityButton_templateObject || (UtilityButton_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48rem;\n  height: 48rem;\n  border-radius: 8rem 0;\n  background-color: ", ";\n  transition: background-color 200ms ease-in-out;\n  cursor: pointer;\n\n  path {\n    transition: fill 200ms ease-in-out;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: ", ";\n\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref) {
  var variant = _ref.variant;
  return colors/* colors */.O[variant];
}, function (_ref2) {
  var variant = _ref2.variant;
  return VARIANT_HOVER_COLOR_MAP[variant];
}, colors/* colors.brand */.O.brand);

var UtilityButton = function UtilityButton(_ref3) {
  var Icon = _ref3.icon,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'brand' : _ref3$variant,
      _ref3$iconSize = _ref3.iconSize,
      iconSize = _ref3$iconSize === void 0 ? 16 : _ref3$iconSize,
      onClick = _ref3.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(UtilityButton_Wrapper, {
    onClick: onClick,
    variant: variant,
    "data-id": "atoms_UtilityButton_Wrapper",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
      height: iconSize,
      variant: VARIANT_ICON_VARIANT_MAP[variant],
      "data-id": "atoms_UtilityButton_Icon"
    })
  });
};

/* harmony default export */ var atoms_UtilityButton = (UtilityButton);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/molecules/ImageWithFullscreen.tsx


var ImageWithFullscreen_templateObject, ImageWithFullscreen_templateObject2, ImageWithFullscreen_templateObject3;












var ImageWithFullscreen_Container = styled_components_browser_esm["default"].figure(ImageWithFullscreen_templateObject || (ImageWithFullscreen_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  margin: 0;\n  min-height: 200rem;\n  height: 40vh;\n  max-height: 344rem;\n  position: relative;\n"])));
var StyledImage = (0,styled_components_browser_esm["default"])((image_default()))(ImageWithFullscreen_templateObject2 || (ImageWithFullscreen_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  object-fit: cover;\n"])));
var ImageWithFullscreen_ButtonContainer = styled_components_browser_esm["default"].div(ImageWithFullscreen_templateObject3 || (ImageWithFullscreen_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  z-index: 11;\n  top: 32rem;\n  right: 32rem;\n"])));

var ImageWithFullscreen = function ImageWithFullscreen(_ref) {
  var image = _ref.image;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      isHighResolution = _useBreakpointInfo.isHighResolution;

  var src = (0,formatCmsImageUrl/* default */.Z)(isHighResolution ? 1600 : 800, isHighResolution ? 900 : 450, image === null || image === void 0 ? void 0 : image.src);

  if (!image || !src) {
    return null;
  }

  var width = image.width,
      height = image.height;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundaryWithSentry/* default */.Z, {
    silent: true,
    "data-id": "molecules_ImageWithFullscreen_ErrorBoundary",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ImageWithFullscreen_Container, {
      "data-id": "molecules_ImageWithFullscreen_Container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledImage, {
        priority: true,
        src: src,
        layout: "fill",
        "data-id": "molecules_ImageWithFullscreen_StyledImage"
      }), width !== undefined && height !== undefined && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageWithFullscreen_ButtonContainer, {
        "data-id": "molecules_ImageWithFullscreen_ButtonContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_UtilityButton, {
          icon: svg_UnionIcon,
          onClick: function onClick() {
            dispatch((0,houseDesign/* openModal */.h7)({
              type: 'Image',
              props: {
                src: image.src,
                width: width,
                height: height,
                withPadding: true
              }
            }));
          },
          "data-id": "molecules_ImageWithFullscreen_UtilityButton"
        })
      })]
    })
  });
};

/* harmony default export */ var molecules_ImageWithFullscreen = (ImageWithFullscreen);
// EXTERNAL MODULE: ./src/components/atoms/Container.tsx
var atoms_Container = __webpack_require__(661);
;// CONCATENATED MODULE: ./src/components/atoms/CircularImage.tsx


var CircularImage_templateObject;




var CircleWithImage = styled_components_browser_esm["default"].div(CircularImage_templateObject || (CircularImage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  border: 2rem solid ", ";\n  border-radius: 50%;\n  width: 60rem;\n  height: 60rem;\n"])), function (_ref) {
  var url = _ref.url;
  return "url(".concat(url, ") center center/cover no-repeat;");
}, colors/* colors.white */.O.white);

var CircularImage = function CircularImage(_ref2) {
  var url = _ref2.url;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleWithImage, {
    url: url,
    "data-id": "atoms_CircularImage_CircleWithImage"
  });
};

/* harmony default export */ var atoms_CircularImage = (CircularImage);
;// CONCATENATED MODULE: ./src/components/molecules/CTA.tsx


var CTA_templateObject, CTA_templateObject2, CTA_templateObject3;










var CTA_Content = styled_components_browser_esm["default"].div(CTA_templateObject || (CTA_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 16rem;\n  width: 100%;\n"])));
var CTA_Wrapper = styled_components_browser_esm["default"].div(CTA_templateObject2 || (CTA_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 40rem;\n"])));
var CircularImageBox = styled_components_browser_esm["default"].div(CTA_templateObject3 || (CTA_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: -56rem;\n  flex: 0 0 64rem;\n"])));

var CTA = function CTA(_ref) {
  var imageUrl = _ref.imageUrl,
      text = _ref.text,
      modalId = _ref.modalId;

  var _useOpenLegacyModal = hooks_useOpenLegacyModal(),
      openSubcategoryDescriptionModal = _useOpenLegacyModal.openSubcategoryDescriptionModal;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(CTA_Wrapper, {
    "data-id": "molecules_CTA_Wrapper",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Container/* default */.Z, {
      variant: "gray10",
      padding: "md",
      "data-id": "molecules_CTA_Container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CTA_Content, {
        "data-id": "molecules_CTA_Content",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CircularImageBox, {
          "data-id": "molecules_CTA_CircularImageBox",
          children: !!imageUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_CircularImage, {
            url: imageUrl,
            "data-id": "molecules_CTA_CircularImage"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
          text: text,
          "data-id": "molecules_CTA_Text",
          children: !!modalId && /*#__PURE__*/(0,jsx_runtime.jsx)(BoxIcon/* default */.Z, {
            variant: "white",
            icon: svg_UnionIcon,
            onClick: function onClick() {
              openSubcategoryDescriptionModal(modalId);
            },
            "data-id": "molecules_CTA_BoxIcon"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var molecules_CTA = (CTA);
;// CONCATENATED MODULE: ./src/components/atoms/inputs/InputControl.tsx



var InputControl_excluded = ["onClick"];

var InputControl_templateObject, InputControl_templateObject2;

function InputControl_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InputControl_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InputControl_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InputControl_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var OuterCheckbox = styled_components_browser_esm["default"].div(InputControl_templateObject || (InputControl_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  width: 24rem;\n  height: 24rem;\n  border-radius: ", ";\n  box-sizing: border-box;\n  border: 1rem solid ", ";\n  padding: 1rem;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), colors/* colors.white */.O.white, function (_ref) {
  var isRadio = _ref.isRadio;
  return isRadio ? '100%' : '4rem';
}, colors/* colors.gray40 */.O.gray40, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && "opacity: .5;";
}, function (_ref3) {
  var disabled = _ref3.disabled,
      _final = _ref3["final"],
      pending = _ref3.pending,
      actionRequired = _ref3.actionRequired;
  return !disabled && !_final && !pending && !actionRequired && "cursor: pointer;";
}, function (_ref4) {
  var checked = _ref4.checked,
      _final2 = _ref4["final"],
      pending = _ref4.pending;

  if (_final2) {
    return "\n        border-color: ".concat(colors/* colors.green */.O.green, ";\n      ");
  }

  if (pending) {
    return "\n        border-color: ".concat(colors/* colors.blue */.O.blue, ";\n      ");
  }

  if (checked) {
    return "\n        border-color: ".concat(colors/* colors.brand */.O.brand, ";\n      ");
  }

  return "";
});
var InnerCheckbox = styled_components_browser_esm["default"].div(InputControl_templateObject2 || (InputControl_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 3rem 2rem 1rem;\n  border-radius: ", ";\n  box-sizing: border-box;\n\n  ", "\n"])), function (_ref5) {
  var isRadio = _ref5.isRadio;
  return isRadio ? '100%' : '2rem';
}, function (_ref6) {
  var checked = _ref6.checked,
      _final3 = _ref6["final"],
      excluded = _ref6.excluded,
      pending = _ref6.pending;

  if (_final3) {
    return "\n        background-color: ".concat(colors/* colors.green */.O.green, ";\n      ");
  }

  if (pending) {
    return "\n        background-color: ".concat(colors/* colors.blue */.O.blue, ";\n      ");
  }

  if (checked) {
    if (excluded) {
      return "\n          background-color: ".concat(colors/* colors.brand */.O.brand, ";\n          width: 12rem;\n          height: 12rem;\n        ");
    }

    return "\n        background-color: ".concat(colors/* colors.brand */.O.brand, ";\n      ");
  }

  return "";
});

var InputControl = function InputControl(_ref7) {
  var _onClick = _ref7.onClick,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref7, InputControl_excluded);

  var checked = rest.checked,
      disabled = rest.disabled,
      _rest$final = rest["final"],
      _final4 = _rest$final === void 0 ? false : _rest$final,
      _rest$pending = rest.pending,
      pending = _rest$pending === void 0 ? false : _rest$pending,
      _rest$actionRequired = rest.actionRequired,
      actionRequired = _rest$actionRequired === void 0 ? false : _rest$actionRequired,
      _rest$excluded = rest.excluded,
      excluded = _rest$excluded === void 0 ? false : _rest$excluded;

  var showAsChecked = checked || _final4 || pending || actionRequired;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OuterCheckbox, InputControl_objectSpread(InputControl_objectSpread({
    onClick: function onClick() {
      if (!disabled && !_final4 && !pending && !actionRequired) {
        _onClick(!checked);
      }
    }
  }, rest), {}, {
    checked: showAsChecked,
    "data-id": "inputs_InputControl_OuterCheckbox",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InnerCheckbox, InputControl_objectSpread(InputControl_objectSpread({}, rest), {}, {
      checked: showAsChecked,
      "data-id": "inputs_InputControl_InnerCheckbox",
      children: showAsChecked && !excluded && /*#__PURE__*/(0,jsx_runtime.jsx)(svg_CheckmarkIcon, {
        variant: "white",
        "data-id": "inputs_InputControl_CheckmarkIcon"
      })
    }))
  }));
};

/* harmony default export */ var inputs_InputControl = (InputControl);
;// CONCATENATED MODULE: ./src/components/atoms/inputs/InputCheckbox.tsx


function InputCheckbox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InputCheckbox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InputCheckbox_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InputCheckbox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var InputCheckbox = function InputCheckbox(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(inputs_InputControl, InputCheckbox_objectSpread(InputCheckbox_objectSpread({}, props), {}, {
    "data-id": "inputs_InputCheckbox_InputControl"
  }));
};

/* harmony default export */ var inputs_InputCheckbox = (InputCheckbox);
;// CONCATENATED MODULE: ./src/processes/houseDesignDeadline.ts


var CJ1_DEFAULT_INFO = {
  content: "Na activatie account tonen we hier de beslisperiode voor de meerwerkopties in deze subcategorie",
  variant: 'brand2'
};
var CJ2_DEFAULT_INFO = {
  content: "Beslisperiode nog onbekend\u2014informeer bij woonadviseur",
  variant: 'brand2'
};
var getDeadlineState = function getDeadlineState(date) {
  var passed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!date) {
    return 'unknown';
  }

  try {
    var deadline = moment_default()(date);
    var now = moment_default()();
    var daysUntilDeadline = deadline.diff(now, 'days');

    if (passed || daysUntilDeadline < 0) {
      return 'expired';
    }

    if (daysUntilDeadline <= 5) {
      return 'expiring';
    }

    return 'valid';
  } catch (e) {
    return 'unknown';
  }
};
var isExpired = function isExpired(_ref) {
  var deadline = _ref.deadline,
      deadlinePassed = _ref.deadlinePassed;

  if (deadlinePassed) {
    return true;
  }

  return getDeadlineState(deadline) === 'expired';
};
var getDeadlineInfo = function getDeadlineInfo(userInCj1, date, passed) {
  // if user is in CJ1, we ignore deadlines always
  if (userInCj1) {
    return CJ1_DEFAULT_INFO;
  }

  if (!date) {
    return CJ2_DEFAULT_INFO;
  }

  var state = getDeadlineState(date, passed);
  var formattedDate = formatDateWithFullMonth(date);

  switch (state) {
    case 'unknown':
      return CJ2_DEFAULT_INFO;

    case 'expired':
      return {
        content: "Beslisperiode verlopen op ".concat(formattedDate),
        variant: 'gray25'
      };

    case 'expiring':
      return {
        content: "Beslisperiode verloopt op ".concat(formattedDate),
        variant: 'red'
      };

    case 'valid':
    default:
      return {
        content: "Beslisperiode tot ".concat(formattedDate),
        variant: 'brand2'
      };
  }
};
;// CONCATENATED MODULE: ./src/hooks/useOptionStatus.ts


function useOptionStatus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useOptionStatus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useOptionStatus_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useOptionStatus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var useOptionStatus = function useOptionStatus(option, subcategory) {
  var wishList = hooks_useWishList();
  return (0,react.useMemo)(function () {
    var deadlineExpired = subcategory ? isExpired(subcategory) : false;
    var statuses = {
      isExcluded: wishList ? isOptionExcluded(option, wishList) : false,
      isFinal: isOptionFinal(option),
      isDisabled: isOptionDisabled(option),
      isNew: isOptionNew(option),
      isPending: isOptionPending(option),
      isActionRequired: isOptionActionRequired(option),
      isPostDeadlineSelected: deadlineExpired && isOptionFinalPostDeadline(option),
      isPostDeadlineNotSelected: deadlineExpired && !isOptionFinalPostDeadline(option)
    };
    return useOptionStatus_objectSpread(useOptionStatus_objectSpread({}, statuses), {}, {
      optionStatus: getOptionStatus(statuses)
    });
  }, [option, subcategory, wishList]);
};

/* harmony default export */ var hooks_useOptionStatus = (useOptionStatus);
;// CONCATENATED MODULE: ./src/components/atoms/inputs/InputNumber.tsx



var InputNumber_excluded = ["onBlur", "value"];

var InputNumber_templateObject;

function InputNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InputNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InputNumber_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InputNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var InputNumber_Input = styled_components_browser_esm["default"].input.attrs(function (_ref) {
  var min = _ref.min,
      max = _ref.max,
      value = _ref.value,
      disabled = _ref.disabled;
  return {
    type: 'number',
    max: max,
    min: min,
    value: value,
    disabled: disabled
  };
})(InputNumber_templateObject || (InputNumber_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  ", ";\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  border: 1rem solid ", ";\n  border-radius: 2rem;\n  color: ", ";\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n"])), fonts/* fontStyles.body.md */.g6.body.md, function (_ref2) {
  var centered = _ref2.centered;
  return centered && 'text-align: center';
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? colors/* colors.gray20 */.O.gray20 : colors/* colors.gray30 */.O.gray30;
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? colors/* colors.gray20 */.O.gray20 : colors/* colors.gray40 */.O.gray40;
});

var InputNumber = function InputNumber(_ref5) {
  var _onBlur = _ref5.onBlur,
      value = _ref5.value,
      props = (0,objectWithoutProperties/* default */.Z)(_ref5, InputNumber_excluded);

  var _useState = (0,react.useState)(value),
      newValue = _useState[0],
      setNewValue = _useState[1];

  (0,react.useEffect)(function () {
    setNewValue(value);
  }, [value]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InputNumber_Input, InputNumber_objectSpread(InputNumber_objectSpread({}, props), {}, {
    value: newValue,
    onChange: function onChange(e) {
      return setNewValue(Number(e.target.value));
    },
    onBlur: function onBlur() {
      if (newValue !== value) {
        _onBlur(newValue);
      }
    },
    "data-id": "inputs_InputNumber_Input"
  }));
};

/* harmony default export */ var inputs_InputNumber = (InputNumber);
// EXTERNAL MODULE: ./src/styles/radii.ts
var radii = __webpack_require__(22232);
;// CONCATENATED MODULE: ./src/components/atoms/CounterButton.tsx



var CounterButton_excluded = ["icon"];

var CounterButton_templateObject;

function CounterButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CounterButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CounterButton_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CounterButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CounterBtn = styled_components_browser_esm["default"].button.attrs(function (_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick;
  return {
    disabled: disabled,
    onClick: onClick
  };
})(CounterButton_templateObject || (CounterButton_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  width: 20rem;\n  height: 20rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  ", ";\n"])), radii/* default.circle */.Z.circle, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? colors/* colors.gray20 */.O.gray20 : colors/* colors.brand */.O.brand;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? "cursor: default" : "cursor: pointer";
});

var CounterButton = function CounterButton(_ref4) {
  var icon = _ref4.icon,
      props = (0,objectWithoutProperties/* default */.Z)(_ref4, CounterButton_excluded);

  var Icon = icon;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CounterBtn, CounterButton_objectSpread(CounterButton_objectSpread({}, props), {}, {
    "data-id": "atoms_CounterButton_CounterBtn",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
      width: 8,
      "data-id": "atoms_CounterButton_Icon"
    })
  }));
};

/* harmony default export */ var atoms_CounterButton = (CounterButton);
;// CONCATENATED MODULE: ./src/components/atoms/svg/MinusIcon.tsx






var MinusIcon = function MinusIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'white' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 8 2",
    "data-id": "svg_MinusIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.9965 0.679625C7.961 0.2975 7.641 0 7.251 0H0V0.99875L0.004125 1.32838C0.04325 1.70688 0.36175 2 0.749 2H8V0.96475L7.9965 0.679625Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_MinusIcon_path"
    })
  });
};

/* harmony default export */ var svg_MinusIcon = (MinusIcon);
;// CONCATENATED MODULE: ./src/components/atoms/svg/PlusIcon.tsx






var PlusIcon = function PlusIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'white' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 8 9",
    "data-id": "svg_PlusIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M8 4.92211L7.9965 4.63698C7.961 4.25486 7.641 3.95736 7.251 3.95736H5.14587V0.818359H4.14712L3.8175 0.822484C3.439 0.861609 3.14587 1.18011 3.14587 1.56736V3.95748H0V4.95623L0.004125 5.28586C0.04325 5.66436 0.36175 5.95748 0.749 5.95748H3.14587V8.81836H4.18113L4.46613 8.81486C4.84837 8.77936 5.14587 8.45936 5.14587 8.06936V5.95736H8V4.92211Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_PlusIcon_path"
    })
  });
};

/* harmony default export */ var svg_PlusIcon = (PlusIcon);
;// CONCATENATED MODULE: ./src/components/atoms/inputs/InputCounter.tsx


var InputCounter_templateObject, InputCounter_templateObject2;








var InputCounter_Wrapper = styled_components_browser_esm["default"].div(InputCounter_templateObject || (InputCounter_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 8rem;\n"])));
var InputContainer = styled_components_browser_esm["default"].div(InputCounter_templateObject2 || (InputCounter_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 40rem;\n"])));

var InputCounter = function InputCounter(_ref) {
  var value = _ref.value,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      max = _ref.max,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InputCounter_Wrapper, {
    "data-id": "inputs_InputCounter_Wrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_CounterButton, {
      disabled: value <= min || disabled,
      onClick: function onClick() {
        return onChange(value - 1);
      },
      icon: svg_MinusIcon,
      "data-id": "inputs_InputCounter_CounterButton"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputContainer, {
      "data-id": "inputs_InputCounter_InputContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(inputs_InputNumber, {
        value: value,
        min: min,
        onBlur: onChange,
        disabled: disabled,
        centered: true,
        "data-id": "inputs_InputCounter_InputNumber"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_CounterButton, {
      disabled: !!max && value >= max || disabled,
      onClick: function onClick() {
        return onChange(value + 1);
      },
      icon: svg_PlusIcon,
      "data-id": "inputs_InputCounter_CounterButton"
    })]
  });
};

/* harmony default export */ var inputs_InputCounter = (InputCounter);
;// CONCATENATED MODULE: ./src/components/atoms/inputs/InputRadio.tsx


function InputRadio_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InputRadio_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InputRadio_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InputRadio_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var InputRadio_InputCheckbox = function InputCheckbox(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(inputs_InputControl, InputRadio_objectSpread(InputRadio_objectSpread({
    isRadio: true
  }, props), {}, {
    "data-id": "inputs_InputRadio_InputControl"
  }));
};

/* harmony default export */ var InputRadio = (InputRadio_InputCheckbox);
;// CONCATENATED MODULE: ./src/hooks/useLayoutImages.ts





/**
 * If a Wish List category has options with a layout image (as in: floorplan), this hook will return the current layout image for the category
 * plus a function to update the layout image for the current category.
 */

var useLayoutImages = function useLayoutImages() {
  var _useParams = (0,useParams/* default */.Z)(),
      wishListId = _useParams.wishListId,
      wishListItem = _useParams.wishListItem;

  var dispatch = (0,es/* useDispatch */.I0)();
  var layoutImages = (0,redux/* useSelector */.v)(function (state) {
    var _state$houseDesign$wi, _state$houseDesign$wi2;

    if (!wishListId) {
      return undefined;
    }

    return (_state$houseDesign$wi = (_state$houseDesign$wi2 = state.houseDesign.wishLists[wishListId]) === null || _state$houseDesign$wi2 === void 0 ? void 0 : _state$houseDesign$wi2.layoutImages) !== null && _state$houseDesign$wi !== void 0 ? _state$houseDesign$wi : {};
  });
  return (0,react.useMemo)(function () {
    return {
      setLayoutImage: function setLayoutImage(url) {
        if (!wishListId || !wishListItem) {
          return;
        }

        dispatch((0,houseDesign/* setLayoutImage */.o9)(wishListId, wishListItem, url));
      },
      currentLayoutImage: wishListItem ? layoutImages === null || layoutImages === void 0 ? void 0 : layoutImages[wishListItem] : undefined
    };
  }, [dispatch, layoutImages, wishListId, wishListItem]);
};

/* harmony default export */ var hooks_useLayoutImages = (useLayoutImages);
;// CONCATENATED MODULE: ./src/components/houseDesign/OptionDefault.tsx


var OptionDefault_excluded = ["wishListItem"];

function OptionDefault_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OptionDefault_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OptionDefault_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OptionDefault_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var isOtherSingleChoiceOptionSelected = function isOtherSingleChoiceOptionSelected(currentOptionId, allOptionsInSubcategory) {
  return allOptionsInSubcategory.some(function (option) {
    return option.id !== currentOptionId && (isOptionFinal(option) || isOptionPending(option));
  });
};

var OptionDefault = function OptionDefault(_ref) {
  var _option$layoutImage;

  var option = _ref.option,
      subcategory = _ref.subcategory;
  var optionStatus = hooks_useOptionStatus(option, subcategory);
  var isDisabled = optionStatus.isDisabled,
      isExcluded = optionStatus.isExcluded,
      isFinal = optionStatus.isFinal,
      isPending = optionStatus.isPending,
      isActionRequired = optionStatus.isActionRequired,
      isPostDeadlineSelected = optionStatus.isPostDeadlineSelected,
      isPostDeadlineNotSelected = optionStatus.isPostDeadlineNotSelected; // eslint-disable-next-line @typescript-eslint/no-unused-vars

  var _useParams = (0,useParams/* default */.Z)(),
      wishListItem = _useParams.wishListItem,
      params = (0,objectWithoutProperties/* default */.Z)(_useParams, OptionDefault_excluded);

  var _useSectionLoading = hooks_useSectionLoading(),
      toggleSectionLoading = _useSectionLoading.toggleSectionLoading;

  var _useLayoutImages = hooks_useLayoutImages(),
      setLayoutImage = _useLayoutImages.setLayoutImage;

  var id = option.id,
      amount = option.amount,
      multiple = option.multiple;
  var isSingleChoice = subcategory.isSingleChoice,
      allOptionsInSubcategory = subcategory.options;

  var _useWishListMutation = useWishListMutation('patchWishList', [endpoints/* WishListRequestKey.wishListLoading */.P.wishListLoading], params, {
    onSettled: function onSettled() {
      return toggleSectionLoading(false, wishListItem);
    }
  }),
      mutate = _useWishListMutation.mutate,
      isLoading = _useWishListMutation.isLoading;

  var layoutImageSrc = (_option$layoutImage = option.layoutImage) === null || _option$layoutImage === void 0 ? void 0 : _option$layoutImage.src;
  var onChange = (0,react.useCallback)(function (n) {
    toggleSectionLoading(true, wishListItem);

    var options = (0,defineProperty/* default */.Z)({}, id, {
      amount: n,
      productOption: id
    });

    if (isSingleChoice) {
      allOptionsInSubcategory.forEach(function (_ref2) {
        var optionId = _ref2.id;

        if (optionId !== id) {
          options[optionId] = {
            amount: 0,
            productOption: optionId
          };
        }
      });
    }

    if (layoutImageSrc) {
      setLayoutImage(n > 0 ? layoutImageSrc : undefined);
    }

    mutate({
      params: params,
      body: {
        options: options
      }
    });
  }, [allOptionsInSubcategory, id, isSingleChoice, layoutImageSrc, mutate, params, setLayoutImage, toggleSectionLoading, wishListItem]);
  var selected = amount > 0 || isPostDeadlineSelected;
  var isDisabledBecauseOfSingleChoice = isSingleChoice && isOtherSingleChoiceOptionSelected(id, allOptionsInSubcategory);
  var disabled = isDisabled || isDisabledBecauseOfSingleChoice;
  var Input = isSingleChoice ? InputRadio : inputs_InputCheckbox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_Option, OptionDefault_objectSpread(OptionDefault_objectSpread({}, optionStatus), {}, {
    isDisabled: disabled,
    option: option,
    selected: selected,
    input: isPostDeadlineNotSelected ? undefined : /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
      checked: selected,
      onClick: function onClick(checked) {
        return onChange(checked ? 1 : 0);
      },
      disabled: (disabled || isExcluded) && !isFinal,
      "final": isFinal || isPostDeadlineSelected && !isPending,
      pending: isPending,
      actionRequired: isActionRequired,
      excluded: isExcluded,
      "data-id": "houseDesign_OptionDefault_Input"
    }),
    isLoading: isLoading,
    subcategory: subcategory,
    "data-id": "houseDesign_OptionDefault_Option",
    children: !isFinal && !isPostDeadlineSelected && !isPostDeadlineNotSelected && multiple && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      "data-id": "houseDesign_OptionDefault_Box",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(inputs_InputCounter, {
        value: amount,
        onChange: onChange,
        disabled: disabled || isExcluded,
        "data-id": "houseDesign_OptionDefault_InputCounter"
      })
    })
  }));
};

/* harmony default export */ var houseDesign_OptionDefault = (OptionDefault);
;// CONCATENATED MODULE: ./src/components/atoms/svg/InformationIcon.tsx






var InformationIcon_InformationIcon = function InformationIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 2 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 2 9",
    "data-id": "svg_InformationIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1.80011 8.42601C1.74797 8.45581 1.5692 8.4707 1.2638 8.4707C0.913706 8.4707 0.660447 8.39621 0.504023 8.24724C0.355047 8.09826 0.280559 7.86363 0.280559 7.54333V3.07406C0.302905 3.06661 0.369944 3.05916 0.481676 3.05171C0.593408 3.03681 0.697691 3.02936 0.794525 3.02936C1.46492 3.02936 1.80011 3.32359 1.80011 3.91204V8.42601ZM1.81128 1.28635C1.81128 1.51726 1.73307 1.71093 1.57665 1.86735C1.42022 2.01633 1.22656 2.09081 0.995643 2.09081C0.757281 2.09081 0.559888 2.01633 0.403464 1.86735C0.254488 1.71093 0.18 1.51726 0.18 1.28635C0.18 1.05543 0.254488 0.861764 0.403464 0.70534C0.559888 0.548915 0.757281 0.470703 0.995643 0.470703C1.22656 0.470703 1.42022 0.548915 1.57665 0.70534C1.73307 0.861764 1.81128 1.05543 1.81128 1.28635Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_InformationIcon_path"
    })
  });
};

/* harmony default export */ var svg_InformationIcon = (InformationIcon_InformationIcon);
;// CONCATENATED MODULE: ./src/components/molecules/Deadline.tsx






var Deadline_Deadline = function Deadline(_ref) {
  var deadline = _ref.deadline,
      passed = _ref.passed,
      onClick = _ref.onClick;
  var userIsInCj1 = (0,redux/* useSelector */.v)(function (state) {
    return state.houseDesign.phase;
  }) === 'cj1';

  var _getDeadlineInfo = getDeadlineInfo(userIsInCj1, deadline, passed),
      content = _getDeadlineInfo.content,
      variant = _getDeadlineInfo.variant;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* default */.Z, {
    size: "sm",
    onClick: onClick,
    text: content,
    iconAfter: svg_InformationIcon,
    variant: variant,
    "data-id": "molecules_Deadline_TextButton"
  });
};

/* harmony default export */ var molecules_Deadline = (Deadline_Deadline);
;// CONCATENATED MODULE: ./src/hooks/useResponsiveSpacing.ts

/**
 * Get the spacing size to use for the current breakpoint: spacing xl if larger than breakpoint md, otherwise spacing lg
 */

var useResponsiveSpacing = function useResponsiveSpacing() {
  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      md = _useBreakpointInfo.isLargerThan.md;

  return md ? 'xl' : 'lg';
};

/* harmony default export */ var hooks_useResponsiveSpacing = (useResponsiveSpacing);
// EXTERNAL MODULE: ./src/components/atoms/ToggleButton.tsx + 1 modules
var atoms_ToggleButton = __webpack_require__(44197);
;// CONCATENATED MODULE: ./src/components/molecules/FlyoutContainer.tsx


var FlyoutContainer_templateObject, FlyoutContainer_templateObject2, FlyoutContainer_templateObject3, FlyoutContainer_templateObject4;












var FlyoutContainer_Wrapper = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(FlyoutContainer_templateObject || (FlyoutContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  border-radius: 8rem 0;\n"])), shadows/* default.default */.Z["default"]);
var FlyoutContainer_TopContainer = (0,styled_components_browser_esm["default"])(atoms_Container/* default */.Z)(FlyoutContainer_templateObject2 || (FlyoutContainer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 8rem 0 0;\n"])));
var BottomContainer = (0,styled_components_browser_esm["default"])(atoms_Container/* default */.Z)(FlyoutContainer_templateObject3 || (FlyoutContainer_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 0 0 8rem;\n  background-color: ", ";\n  border-top: 1rem solid ", ";\n"])), colors/* colors.gray05 */.O.gray05, colors/* colors.gray15 */.O.gray15);
var SlideInOut = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div)(FlyoutContainer_templateObject4 || (FlyoutContainer_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n"])));

var FlyoutContainer = function FlyoutContainer(_ref) {
  var children = _ref.children,
      flyoutContent = _ref.flyoutContent,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? 'Weergeven' : _ref$buttonText;
  var horizontalSpacing = hooks_useResponsiveSpacing();

  var _useState = (0,react.useState)(false),
      flyoutOpen = _useState[0],
      setFlyoutOpen = _useState[1];

  if (!flyoutContent || Array.isArray(flyoutContent) && flyoutContent.length === 0) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Container/* default */.Z, {
      paddingTop: "xl",
      paddingHorizontal: horizontalSpacing,
      paddingBottom: "xs",
      marginBottom: "xl",
      shadow: true,
      "data-id": "molecules_FlyoutContainer_Container",
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FlyoutContainer_Wrapper, {
    marginBottom: "xl",
    "data-id": "molecules_FlyoutContainer_Wrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FlyoutContainer_TopContainer, {
      paddingTop: "xl",
      paddingHorizontal: horizontalSpacing,
      paddingBottom: "xs",
      "data-id": "molecules_FlyoutContainer_TopContainer",
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BottomContainer, {
      "data-id": "molecules_FlyoutContainer_BottomContainer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        paddingHorizontal: horizontalSpacing,
        paddingTop: "xl",
        paddingBottom: "xl",
        "data-id": "molecules_FlyoutContainer_Box",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_ToggleButton/* default */.Z, {
          text: buttonText,
          onClick: function onClick() {
            return setFlyoutOpen(function (v) {
              return !v;
            });
          },
          open: flyoutOpen,
          "data-id": "molecules_FlyoutContainer_ToggleButton"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        "data-id": "molecules_FlyoutContainer_AnimatePresence",
        children: flyoutOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(SlideInOut, {
          animate: {
            height: 'auto',
            opacity: 1
          },
          initial: {
            height: 0,
            opacity: 0.2
          },
          exit: {
            height: 0,
            opacity: 0.2
          },
          transition: {
            duration: 0.8
          },
          "data-id": "molecules_FlyoutContainer_SlideInOut",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            paddingHorizontal: horizontalSpacing,
            paddingBottom: "sm",
            "data-id": "molecules_FlyoutContainer_Box",
            children: flyoutContent
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var molecules_FlyoutContainer = (FlyoutContainer);
;// CONCATENATED MODULE: ./src/components/houseDesign/Subcategory.tsx


















var Subcategory = function Subcategory(_ref) {
  var subcategory = _ref.subcategory;
  var userIsInCj1 = (0,redux/* useSelector */.v)(function (state) {
    return state.houseDesign.phase;
  }) === 'cj1';

  var _useOpenLegacyModal = hooks_useOpenLegacyModal(),
      openDeadlinesDescriptionModal = _useOpenLegacyModal.openDeadlinesDescriptionModal;

  var horizontalSpacing = hooks_useResponsiveSpacing();
  var title = subcategory.title,
      description = subcategory.description,
      hasModal = subcategory.hasModal,
      teaserText = subcategory.teaserText,
      author = subcategory.author,
      id = subcategory.id,
      options = subcategory.options,
      deadline = subcategory.deadline,
      deadlinePassed = subcategory.deadlinePassed;
  var deadlineHasPassed = deadlinePassed || getDeadlineState(deadline) === 'expired';

  var subcategoryInfo = /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_TextBox, {
    marginBottom: "xl",
    spacing: "md",
    "data-id": "houseDesign_Subcategory_TextBox",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      marginBottom: "sm",
      "data-id": "houseDesign_Subcategory_Box",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Deadline, {
        deadline: deadline,
        passed: deadlinePassed,
        onClick: function onClick() {
          openDeadlinesDescriptionModal();
        },
        "data-id": "houseDesign_Subcategory_Deadline"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
      text: title,
      level: 2,
      size: "md",
      "data-id": "houseDesign_Subcategory_Title"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
      text: description,
      "data-id": "houseDesign_Subcategory_Text"
    }), !!teaserText && !!(author !== null && author !== void 0 && author.image) && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_CTA, {
      text: teaserText,
      imageUrl: (0,formatCmsImageUrl/* default */.Z)(300, 300, author.image),
      modalId: hasModal ? id : undefined,
      "data-id": "houseDesign_Subcategory_CTA"
    })]
  });

  if (deadlineHasPassed) {
    var _getPostDeadlineOptio = getPostDeadlineOptions(subcategory),
        selected = _getPostDeadlineOptio.selected,
        notSelected = _getPostDeadlineOptio.notSelected;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(molecules_FlyoutContainer, {
      buttonText: userIsInCj1 ? 'Niet meer beschikbaar' : 'Niet gekozen',
      flyoutContent: notSelected.map(function (option) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_OptionDefault, {
          option: option,
          subcategory: subcategory,
          "data-id": "houseDesign_Subcategory_OptionDefault"
        }, option.id);
      }),
      "data-id": "houseDesign_Subcategory_FlyoutContainer",
      children: [subcategoryInfo, /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        marginBottom: "xl",
        "data-id": "houseDesign_Subcategory_Box",
        children: selected.map(function (option) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_OptionDefault, {
            option: option,
            subcategory: subcategory,
            "data-id": "houseDesign_Subcategory_OptionDefault"
          }, option.id);
        })
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_Container/* default */.Z, {
    paddingTop: "xl",
    paddingHorizontal: horizontalSpacing,
    paddingBottom: "xs",
    marginBottom: "xl",
    shadow: true,
    "data-id": "houseDesign_Subcategory_Container",
    children: [subcategoryInfo, /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      marginBottom: "xl",
      "data-id": "houseDesign_Subcategory_Box",
      children: options.map(function (option) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_OptionDefault, {
          option: option,
          subcategory: subcategory,
          "data-id": "houseDesign_Subcategory_OptionDefault"
        }, option.id);
      })
    })]
  });
};

/* harmony default export */ var houseDesign_Subcategory = (Subcategory);
;// CONCATENATED MODULE: ./src/components/houseDesign/CategoryIntro.tsx


var CategoryIntro_templateObject, CategoryIntro_templateObject2, CategoryIntro_templateObject3;

















var IntroContainer = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(CategoryIntro_templateObject || (CategoryIntro_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", " url('/images/homestudios.svg') no-repeat 24rem 24rem;\n  background-size: min(80%, 300rem);\n  padding-bottom: 104rem;\n"])), colors/* colors.gray40 */.O.gray40);
var CategoryIntro_ContentContainer = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(CategoryIntro_templateObject2 || (CategoryIntro_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: -104rem;\n"])));
var NewOptionLink = styled_components_browser_esm["default"].a(CategoryIntro_templateObject3 || (CategoryIntro_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-style: italic;\n  text-decoration: underline;\n\n  &:hover,\n  &:focus,\n  &:active {\n    text-decoration: none;\n  }\n"])), colors/* colors.white */.O.white);

var getNewOptionsText = function getNewOptionsText(newOptions) {
  if (!newOptions || newOptions.length === 0) {
    return undefined;
  }

  if (newOptions.length === 1) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["Er is een nieuwe optie toegevoegd:", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(NewOptionLink, {
        href: "#optie-".concat(newOptions[0].id),
        "data-id": "houseDesign_CategoryIntro_NewOptionLink",
        children: newOptions[0].title
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: ["Er zijn nieuwe opties toegevoegd:", ' ', newOptions.map(function (option, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [i !== 0 ? ', ' : '', /*#__PURE__*/(0,jsx_runtime.jsx)(NewOptionLink, {
          href: "#optie-".concat(option.id),
          "data-id": "houseDesign_CategoryIntro_NewOptionLink_1",
          children: option.title
        }, option.id)]
      });
    })]
  });
};

var CategoryIntro = function CategoryIntro(_ref) {
  var children = _ref.children,
      title = _ref.title,
      description = _ref.description,
      additionalContent = _ref.additionalContent,
      iconSlug = _ref.iconSlug,
      _ref$categoryHasImage = _ref.categoryHasImage,
      categoryHasImage = _ref$categoryHasImage === void 0 ? false : _ref$categoryHasImage,
      newOptions = _ref.newOptions,
      modalId = _ref.modalId;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      md = _useBreakpointInfo.isLargerThan.md;

  var _useOpenLegacyModal = hooks_useOpenLegacyModal(),
      openCategoryDescriptionModal = _useOpenLegacyModal.openCategoryDescriptionModal;

  var newOptionsText = getNewOptionsText(newOptions);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    "data-id": "houseDesign_CategoryIntro_Box",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IntroContainer, {
      paddingHorizontal: md ? 'xl' : 'none',
      paddingTop: !categoryHasImage ? 'md' : undefined,
      "data-id": "houseDesign_CategoryIntro_IntroContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_MaxWidth, {
        "data-id": "houseDesign_CategoryIntro_MaxWidth",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_TextBox, {
          paddingHorizontal: md ? 'none' : 'xl',
          paddingBottom: "xl",
          paddingTop: "xl",
          "data-id": "houseDesign_CategoryIntro_TextBox",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
            text: title,
            size: "lg",
            variant: "white",
            icon: iconSlug ? ICON_MAP[iconSlug] : undefined,
            "data-id": "houseDesign_CategoryIntro_Title"
          }), !!description && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
            text: description,
            variant: "white",
            "data-id": "houseDesign_CategoryIntro_Text"
          }), !!modalId && /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* default */.Z, {
            variant: "white",
            text: "Lees meer",
            iconAfter: svg_UnionIcon,
            onClick: function onClick() {
              openCategoryDescriptionModal(modalId);
            },
            "data-id": "houseDesign_CategoryIntro_TextButton"
          }), !!newOptionsText && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Banner/* default */.Z, {
            "data-id": "houseDesign_CategoryIntro_Banner",
            children: newOptionsText
          }), additionalContent]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryIntro_ContentContainer, {
      paddingHorizontal: md ? 'xl' : 'sm',
      "data-id": "houseDesign_CategoryIntro_ContentContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_MaxWidth, {
        "data-id": "houseDesign_CategoryIntro_MaxWidth",
        children: children
      })
    })]
  });
};

/* harmony default export */ var houseDesign_CategoryIntro = (CategoryIntro);
;// CONCATENATED MODULE: ./src/components/atoms/svg/RightArrowIcon.tsx






var RightArrowIcon = function RightArrowIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 10 16",
    "data-id": "svg_RightArrowIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1.0646 1.52234L1.06935 1.52735C0.300795 2.34347 0.305802 3.61873 1.11441 4.42734L4.69058 8.0035L1.11416 11.5799C0.29003 12.4043 0.300545 13.7129 1.11416 14.5265C1.12493 14.5372 1.13569 14.5478 1.14671 14.5583L1.14596 14.559L2.58694 16L9.04432 9.54187C9.47216 9.11403 9.67544 8.55576 9.65741 8.0035C9.67468 7.4515 9.47216 6.89298 9.04432 6.46514L2.58669 0L1.0646 1.52234Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_RightArrowIcon_path"
    })
  });
};

/* harmony default export */ var svg_RightArrowIcon = (RightArrowIcon);
;// CONCATENATED MODULE: ./src/components/houseDesign/NavButtons.tsx


var NavButtons_templateObject, NavButtons_templateObject2;










var NavigationButtons = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(NavButtons_templateObject || (NavButtons_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: space-between;\n  gap: 16rem;\n  flex-wrap: wrap;\n"])));
var NavigationButton = styled_components_browser_esm["default"].div(NavButtons_templateObject2 || (NavButtons_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 240rem;\n\n  ", "\n"])), function (_ref) {
  var _ref$alignRight = _ref.alignRight,
      alignRight = _ref$alignRight === void 0 ? false : _ref$alignRight;
  return alignRight && "\n    margin-left: auto\n  ";
});

var NavButtons = function NavButtons(_ref2) {
  var _ref2$isInitial = _ref2.isInitial,
      isInitial = _ref2$isInitial === void 0 ? false : _ref2$isInitial;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      sm = _useBreakpointInfo.isLargerThan.sm;

  var _useSections = hooks_useSections(),
      nextSection = _useSections.nextSection,
      previousSection = _useSections.previousSection;

  if (!sm || !nextSection && !previousSection) {
    return null;
  }

  if (isInitial) {
    return nextSection ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
      href: nextSection.url,
      text: nextSection.title,
      icon: svg_RightArrowIcon,
      "data-id": "houseDesign_NavButtons_Button"
    }) : null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationButtons, {
    marginTop: "xxl",
    "data-id": "houseDesign_NavButtons_NavigationButtons",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationButton, {
      "data-id": "houseDesign_NavButtons_NavigationButton",
      children: !!previousSection && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
        variant: "outlined",
        href: previousSection.url,
        text: previousSection.title,
        iconBefore: svg_LeftArrowIcon,
        "data-id": "houseDesign_NavButtons_Button"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationButton, {
      alignRight: true,
      "data-id": "houseDesign_NavButtons_NavigationButton",
      children: !!nextSection && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
        variant: "outlined",
        href: nextSection.url,
        text: nextSection.title,
        icon: svg_RightArrowIcon,
        "data-id": "houseDesign_NavButtons_Button"
      })
    })]
  });
};

/* harmony default export */ var houseDesign_NavButtons = (NavButtons);
;// CONCATENATED MODULE: ./src/components/houseDesign/Category.tsx















var Category_Category = function Category(_ref) {
  var _ref$category = _ref.category,
      id = _ref$category.id,
      hasModal = _ref$category.hasModal,
      image = _ref$category.image,
      title = _ref$category.title,
      icon = _ref$category.icon,
      description = _ref$category.description,
      subcategories = _ref$category.subcategories,
      wishList = _ref.wishList;

  var _useSectionLoading = hooks_useSectionLoading(),
      isSectionLoading = _useSectionLoading.isSectionLoading;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ErrorBoundaryWithSentry/* default */.Z, {
    "data-id": "houseDesign_Category_ErrorBoundary",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(molecules_ImageWithFullscreen, {
      image: image,
      "data-id": "houseDesign_Category_ImageWithFullscreen"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(houseDesign_CategoryIntro, {
      title: title,
      iconSlug: icon,
      description: description,
      categoryHasImage: !!image,
      newOptions: getAllNewOptions(subcategories),
      modalId: hasModal ? id : undefined,
      "data-id": "houseDesign_Category_CategoryIntro",
      children: [subcategories.map(function (subcategory) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_Subcategory, {
          subcategory: subcategory,
          "data-id": "houseDesign_Category_Subcategory"
        }, subcategory.id);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Container/* default */.Z, {
        paddingHorizontal: "xl",
        paddingVertical: "lg",
        marginBottom: "xl",
        shadow: true,
        "data-id": "houseDesign_Category_Container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Layer, {
          title: title,
          squareMeters: getTotalLivingSurfaceForCategory(subcategories, wishList),
          price: getTotalPriceForCategory(title, wishList.totals),
          extraSquareMeters: true,
          iconSlug: icon,
          isSummary: true,
          loading: isSectionLoading(slugify(title)),
          "data-id": "houseDesign_Category_Layer"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_NavButtons, {
        "data-id": "houseDesign_Category_NavButtons"
      })]
    })]
  });
};

/* harmony default export */ var houseDesign_Category = (Category_Category);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 5 modules
var swiper_react = __webpack_require__(57973);
;// CONCATENATED MODULE: ./src/components/atoms/CoveredImage.tsx



var CoveredImage_excluded = ["src", "width", "height", "withPadding"];

var CoveredImage_templateObject, CoveredImage_templateObject2, CoveredImage_templateObject3, CoveredImage_templateObject4, CoveredImage_templateObject5;

function CoveredImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CoveredImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CoveredImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CoveredImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ContainerOuter = styled_components_browser_esm["default"].figure(CoveredImage_templateObject || (CoveredImage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  background-color: ", ";\n  position: relative;\n"])), colors/* colors.white */.O.white);

var getOffsets = function getOffsets(_ref) {
  var withPadding = _ref.withPadding;
  var offset = withPadding ? 32 : 0;
  return (0,styled_components_browser_esm.css)(CoveredImage_templateObject2 || (CoveredImage_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    top: ", "rem;\n    right: ", "rem;\n    bottom: ", "rem;\n    left: ", "rem;\n  "])), offset, offset, offset, offset);
};

var ContainerInner = styled_components_browser_esm["default"].div(CoveredImage_templateObject3 || (CoveredImage_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  span {\n    max-height: 100%;\n  }\n"])), getOffsets);
var Blur = styled_components_browser_esm["default"].div(CoveredImage_templateObject4 || (CoveredImage_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0.5;\n  ", "\n  background-size: cover;\n  filter: blur(8rem);\n"])), function (_ref2) {
  var src = _ref2.src;
  return "background: url(".concat(src, ") center center no-repeat;");
});
var CoveredImage_StyledImage = (0,styled_components_browser_esm["default"])((image_default()))(CoveredImage_templateObject5 || (CoveredImage_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  object-fit: contain;\n"])));

var CoveredImage = function CoveredImage(_ref3) {
  var src = _ref3.src,
      width = _ref3.width,
      height = _ref3.height,
      _ref3$withPadding = _ref3.withPadding,
      withPadding = _ref3$withPadding === void 0 ? false : _ref3$withPadding,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, CoveredImage_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerOuter, {
    "data-id": "atoms_CoveredImage_ContainerOuter",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Blur, {
      src: src,
      "data-id": "atoms_CoveredImage_Blur"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContainerInner, {
      withPadding: withPadding,
      "data-id": "atoms_CoveredImage_ContainerInner",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CoveredImage_StyledImage, CoveredImage_objectSpread(CoveredImage_objectSpread({
        alt: "",
        src: src,
        layout: !width || !height ? 'fill' : undefined,
        width: width,
        height: height
      }, rest), {}, {
        "data-id": "atoms_CoveredImage_StyledImage"
      }))
    })]
  });
};

/* harmony default export */ var atoms_CoveredImage = (CoveredImage);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(25194);
;// CONCATENATED MODULE: ./src/components/atoms/ImageSlider.tsx


var ImageSlider_templateObject, ImageSlider_templateObject2, ImageSlider_templateObject3, ImageSlider_templateObject4, ImageSlider_templateObject5, ImageSlider_templateObject6;

 // eslint-disable-next-line import/no-unresolved















// eslint-disable-next-line import/no-unresolved



var ImageSlider_Slider = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.tq)(ImageSlider_templateObject || (ImageSlider_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  background: ", ";\n  z-index: ", ";\n\n  .swiper-wrapper {\n    z-index: ", ";\n  }\n"])), colors/* colors.gray20 */.O.gray20, z.slider, z.slider);
var ImageSlider_Slide = (0,styled_components_browser_esm["default"])(swiper_react/* SwiperSlide */.o5)(ImageSlider_templateObject2 || (ImageSlider_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n"])));
var SlideImage = styled_components_browser_esm["default"].img.attrs(function (_ref) {
  var src = _ref.src;
  return {
    src: src
  };
})(ImageSlider_templateObject3 || (ImageSlider_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  object-fit: cover;\n  display: block;\n  height: 100%;\n  width: 100%;\n"])));
var Nav = styled_components_browser_esm["default"].div(ImageSlider_templateObject4 || (ImageSlider_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-sizing: border-box;\n  position: absolute;\n  bottom: 0;\n  display: flex;\n  gap: 8rem;\n  justify-content: flex-end;\n  width: 100%;\n  flex-wrap: wrap;\n  padding: 32rem;\n  z-index: ", ";\n"])), z.sliderNav);
var ImageSlider_NavButtons = styled_components_browser_esm["default"].div(ImageSlider_templateObject5 || (ImageSlider_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 8rem;\n"])));
var SliderTitle = styled_components_browser_esm["default"].span(ImageSlider_templateObject6 || (ImageSlider_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  color: ", ";\n  border-radius: 8rem 0;\n  background-color: ", ";\n  padding: 8rem 16rem;\n  display: flex;\n  align-items: center;\n"])), fonts/* fontStyles.title.xs */.g6.title.xs, colors/* colors.white */.O.white, colors/* RGBAColors.black70 */.$.black70);

var SwiperButtonPrev = function SwiperButtonPrev() {
  var swiper = (0,swiper_react/* useSwiper */.oc)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_UtilityButton, {
    onClick: function onClick() {
      return swiper.slidePrev();
    },
    icon: svg_LeftArrowIcon,
    "data-id": "atoms_ImageSlider_UtilityButton"
  });
};

var SwiperButtonNext = function SwiperButtonNext() {
  var swiper = (0,swiper_react/* useSwiper */.oc)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_UtilityButton, {
    onClick: function onClick() {
      return swiper.slideNext();
    },
    icon: svg_RightArrowIcon,
    "data-id": "atoms_ImageSlider_UtilityButton_1"
  });
};

var ImageSlider = function ImageSlider(_ref2) {
  var title = _ref2.title,
      images = _ref2.images,
      _ref2$withFullscreenB = _ref2.withFullscreenButton,
      withFullscreenButton = _ref2$withFullscreenB === void 0 ? false : _ref2$withFullscreenB,
      _ref2$initialSlideInd = _ref2.initialSlideIndex,
      initialSlideIndex = _ref2$initialSlideInd === void 0 ? 0 : _ref2$initialSlideInd,
      _ref2$fill = _ref2.fill,
      fill = _ref2$fill === void 0 ? true : _ref2$fill,
      _ref2$squareAspect = _ref2.squareAspect,
      squareAspect = _ref2$squareAspect === void 0 ? false : _ref2$squareAspect;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      md = _useBreakpointInfo.isLargerThan.md,
      isHighResolution = _useBreakpointInfo.isHighResolution;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  if (!images || images.length === 0) {
    return null;
  }

  var squareAspectSize = isHighResolution ? 2000 : 1000;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ImageSlider_Slider, {
    initialSlide: initialSlideIndex,
    loop: true,
    allowTouchMove: false,
    spaceBetween: 0,
    onSlideChange: function onSlideChange(_ref3) {
      var activeIndex = _ref3.activeIndex;
      // Note that we subtract 1, because the activeIndex from the slider 1-based while other properties, like initialSlide, are 0-based
      setActiveIndex(activeIndex - 1);
    },
    "data-id": "atoms_ImageSlider_Slider",
    children: [images.map(function (_ref4) {
      var _ref4$image = _ref4.image,
          name = _ref4$image.name,
          unformattedSrc = _ref4$image.src;
      var src = squareAspect ? (0,formatCmsImageUrl/* default */.Z)(squareAspectSize, squareAspectSize, unformattedSrc) : unformattedSrc;

      if (!src) {
        return null;
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageSlider_Slide, {
        "data-id": "atoms_ImageSlider_Slide",
        children: fill ? /*#__PURE__*/(0,jsx_runtime.jsx)(SlideImage, {
          src: src,
          "data-id": "atoms_ImageSlider_SlideImage"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_CoveredImage, {
          src: src,
          withPadding: true,
          "data-id": "atoms_ImageSlider_CoveredImage"
        })
      }, name);
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Nav, {
      "data-id": "atoms_ImageSlider_Nav",
      children: [title && md && /*#__PURE__*/(0,jsx_runtime.jsx)(SliderTitle, {
        "data-id": "atoms_ImageSlider_SliderTitle",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ImageSlider_NavButtons, {
        "data-id": "atoms_ImageSlider_NavButtons",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SwiperButtonPrev, {
          "data-id": "atoms_ImageSlider_SwiperButtonPrev"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SwiperButtonNext, {
          "data-id": "atoms_ImageSlider_SwiperButtonNext"
        }), withFullscreenButton && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_UtilityButton, {
          onClick: function onClick() {
            return dispatch((0,houseDesign/* openModal */.h7)({
              type: 'ImageSlider',
              props: {
                images: images,
                title: title,
                initialSlideIndex: activeIndex,
                fill: false
              }
            }));
          },
          icon: svg_UnionIcon,
          "data-id": "atoms_ImageSlider_UtilityButton"
        })]
      })]
    })]
  });
};

/* harmony default export */ var atoms_ImageSlider = (ImageSlider);
;// CONCATENATED MODULE: ./src/components/atoms/List.tsx


var List_templateObject, List_templateObject2;






var DOT_VARIANT_MAP = {
  primary: 'brand',
  disabled: 'disabled',
  inverted: 'inverted'
};
var TEXT_VARIANT_MAP = {
  primary: 'gray40',
  disabled: 'gray25',
  inverted: 'white'
};
var List_ListContainer = styled_components_browser_esm["default"].ul(List_templateObject || (List_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  margin: 0;\n"])));
var List_ListItem = styled_components_browser_esm["default"].li(List_templateObject2 || (List_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  display: flex;\n  align-items: start;\n  gap: 12rem;\n  list-style: none;\n  margin-bottom: 4rem;\n"])));

var atoms_List_List = function List(_ref) {
  var values = _ref.values,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(List_ListContainer, {
    "data-id": "atoms_List_ListContainer",
    children: values.map(function (value) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(List_ListItem, {
        "data-id": "atoms_List_ListItem",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Dot, {
          variant: DOT_VARIANT_MAP[variant],
          "data-id": "atoms_List_Dot"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
          text: value,
          variant: TEXT_VARIANT_MAP[variant],
          "data-id": "atoms_List_Text"
        })]
      }, value);
    })
  });
};

/* harmony default export */ var atoms_List = (atoms_List_List);
// EXTERNAL MODULE: ./src/components/organisms/BBCodeHandler.tsx + 1 modules
var BBCodeHandler = __webpack_require__(72871);
;// CONCATENATED MODULE: ./src/components/atoms/Divider.tsx


var Divider_templateObject;






var Line = styled_components_browser_esm["default"].div(Divider_templateObject || (Divider_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top: 1rem dashed ", ";\n  margin-top: ", "rem;\n  margin-bottom: ", "rem;\n"])), function (_ref) {
  var variant = _ref.variant;
  return colors/* colors */.O[variant];
}, function (_ref2) {
  var spacing = _ref2.spacing;
  return styles_spacing/* SIZE_MAP */.H[spacing !== null && spacing !== void 0 ? spacing : 'none'];
}, function (_ref3) {
  var spacing = _ref3.spacing;
  return styles_spacing/* SIZE_MAP */.H[spacing !== null && spacing !== void 0 ? spacing : 'none'];
});

var Divider_Divider = function Divider(_ref4) {
  var _ref4$spacing = _ref4.spacing,
      spacing = _ref4$spacing === void 0 ? 'sm' : _ref4$spacing,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'gray30' : _ref4$variant;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Line, {
    spacing: spacing,
    variant: variant,
    "data-id": "atoms_Divider_Line"
  });
};

/* harmony default export */ var atoms_Divider = (Divider_Divider);
;// CONCATENATED MODULE: ./src/processes/stringFormatters.ts

var listFormat = function listFormat(strings) {
  if (!strings || strings.length === 0) {
    return '';
  }

  if (strings.length <= 2) {
    return strings.join(' en ');
  }

  var stringsCopy = (0,toConsumableArray/* default */.Z)(strings);

  var last = stringsCopy.pop();
  return "".concat(stringsCopy.join(', '), " en ").concat(last);
};
;// CONCATENATED MODULE: ./src/components/houseDesign/HouseDescription.tsx



var HouseDescription_templateObject, HouseDescription_templateObject2, HouseDescription_templateObject3;
















var Main = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(HouseDescription_templateObject || (HouseDescription_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", " url('/images/homestudios.svg') no-repeat 24rem 24rem;\n  background-size: min(80%, 320rem);\n  padding-bottom: 112rem;\n  position: relative;\n  color: ", ";\n  min-height: 100%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  flex-grow: 2;\n"])), colors/* colors.gray40 */.O.gray40, colors/* colors.white */.O.white);
var HouseDescription_TextContainer = styled_components_browser_esm["default"].div(HouseDescription_templateObject2 || (HouseDescription_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  & * {\n    color: ", ";\n  }\n"])), colors/* colors.white */.O.white);
var HouseDescription_ButtonContainer = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(HouseDescription_templateObject3 || (HouseDescription_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  right: 0;\n"])));

var getList = function getList(wishList) {
  var _wishList$houseType, _wishList$houseType3, _wishList$houseType4;

  var houseType;

  if ((_wishList$houseType = wishList.houseType) !== null && _wishList$houseType !== void 0 && _wishList$houseType.typeName) {
    houseType = "Type: ".concat(wishList.houseType.typeName, ", ").concat(wishList.houseType.variantName);

    if (wishList.houseType.variantCodes) {
      var _wishList$houseType2;

      houseType = "".concat(houseType, " (").concat(listFormat((_wishList$houseType2 = wishList.houseType) === null || _wishList$houseType2 === void 0 ? void 0 : _wishList$houseType2.variantCodes), ")");
    }
  }

  var livingSpace = (_wishList$houseType3 = wishList.houseType) !== null && _wishList$houseType3 !== void 0 && _wishList$houseType3.livingSpace ? "Woonoppervlak: ".concat((_wishList$houseType4 = wishList.houseType) === null || _wishList$houseType4 === void 0 ? void 0 : _wishList$houseType4.livingSpace) : undefined;
  return [].concat((0,toConsumableArray/* default */.Z)(houseType ? [houseType] : []), ["Bouwnummer: ".concat(wishList.house.bnr)], (0,toConsumableArray/* default */.Z)(livingSpace ? [livingSpace] : []), ["Slaapkamers: ".concat(wishList.bedrooms)]);
};

var HouseDescription = function HouseDescription(_ref) {
  var wishList = _ref.wishList;
  var list = (0,react.useMemo)(function () {
    return getList(wishList);
  }, [wishList]);
  var houseType = wishList.houseType;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Main, {
    padding: "xl",
    "data-id": "houseDesign_HouseDescription_Main",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_MaxWidth, {
      "data-id": "houseDesign_HouseDescription_MaxWidth",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HouseDescription_TextContainer, {
        "data-id": "houseDesign_HouseDescription_TextContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_TextBox, {
          "data-id": "houseDesign_HouseDescription_TextBox",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
            icon: svg_FloorIcon,
            text: "De basis",
            variant: "white",
            "data-id": "houseDesign_HouseDescription_Title"
          }), !!(houseType !== null && houseType !== void 0 && houseType.typeUsp) && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
            text: houseType.typeUsp,
            level: 2,
            size: "md",
            variant: "white",
            "data-id": "houseDesign_HouseDescription_Title_5"
          }), !!(houseType !== null && houseType !== void 0 && houseType.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(BBCodeHandler/* default */.Z, {
            content: houseType.description,
            "data-id": "houseDesign_HouseDescription_BBCodeHandler"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Divider, {
          spacing: "xl",
          "data-id": "houseDesign_HouseDescription_Divider"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_TextBox, {
          marginBottom: "sm",
          "data-id": "houseDesign_HouseDescription_TextBox",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
            text: "De basis",
            variant: "white",
            size: "md",
            level: 2,
            "data-id": "houseDesign_HouseDescription_Title"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_List, {
            values: list,
            variant: "inverted",
            "data-id": "houseDesign_HouseDescription_List"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HouseDescription_ButtonContainer, {
        padding: "xl",
        "data-id": "houseDesign_HouseDescription_ButtonContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_MaxWidth, {
          "data-id": "houseDesign_HouseDescription_MaxWidth",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_NavButtons, {
            isInitial: true,
            "data-id": "houseDesign_HouseDescription_NavButtons"
          })
        })
      })]
    })
  });
};

/* harmony default export */ var houseDesign_HouseDescription = (HouseDescription);
;// CONCATENATED MODULE: ./src/components/houseDesign/HouseLayout.tsx


var HouseLayout_templateObject, HouseLayout_templateObject2, HouseLayout_templateObject3, HouseLayout_templateObject4, HouseLayout_templateObject5, HouseLayout_templateObject6, HouseLayout_templateObject7, HouseLayout_templateObject8, HouseLayout_templateObject9;











var HouseLayout_Container = styled_components_browser_esm["default"].div(HouseLayout_templateObject || (HouseLayout_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  background-color: ", ";\n  min-height: 100vh;\n  padding-top: 56rem;\n\n  ", "\n  ", "\n"])), colors/* colors.gray40 */.O.gray40, breakpoints/* fromBreakpoint.md */.ks.md(HouseLayout_templateObject2 || (HouseLayout_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 0;\n  "]))), breakpoints/* fromBreakpoint.slg */.ks.slg(HouseLayout_templateObject3 || (HouseLayout_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    align-items: stretch;\n    height: 100vh;\n    flex-direction: row-reverse;\n  "]))));
var HouseDescriptionWrapper = styled_components_browser_esm["default"].div(HouseLayout_templateObject4 || (HouseLayout_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-grow: 10;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"])), breakpoints/* fromBreakpoint.slg */.ks.slg(HouseLayout_templateObject5 || (HouseLayout_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    min-height: unset;\n  "]))));
var ImageSliderWrapper = styled_components_browser_esm["default"].div(HouseLayout_templateObject6 || (HouseLayout_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 40vh;\n\n  ", "\n  ", "\n  ", "\n"])), breakpoints/* fromBreakpoint.md */.ks.md(HouseLayout_templateObject7 || (HouseLayout_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 50vh;\n  "]))), breakpoints/* fromBreakpoint.lg */.ks.lg(HouseLayout_templateObject8 || (HouseLayout_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 60vh;\n  "]))), breakpoints/* fromBreakpoint.slg */.ks.slg(HouseLayout_templateObject9 || (HouseLayout_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 66.66667%;\n    height: 100vh;\n  "]))));

var HouseLayout = function HouseLayout(_ref) {
  var wishList = _ref.wishList;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      slg = _useBreakpointInfo.isLargerThan.slg;

  var houseType = wishList.houseType;

  var houseDescription = /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_HouseDescription, {
    wishList: wishList,
    "data-id": "houseDesign_HouseLayout_HouseDescription"
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HouseLayout_Container, {
    "data-id": "houseDesign_HouseLayout_Container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageSliderWrapper, {
      "data-id": "houseDesign_HouseLayout_ImageSliderWrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_ImageSlider, {
        images: houseType === null || houseType === void 0 ? void 0 : houseType.media,
        title: houseType === null || houseType === void 0 ? void 0 : houseType.variantName,
        withFullscreenButton: true,
        squareAspect: true,
        "data-id": "houseDesign_HouseLayout_ImageSlider"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HouseDescriptionWrapper, {
      "data-id": "houseDesign_HouseLayout_HouseDescriptionWrapper",
      children: slg ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_CustomScrollbars, {
        height: "100vh",
        "data-id": "houseDesign_HouseLayout_CustomScrollbars",
        children: houseDescription
      }) : houseDescription
    })]
  });
};

/* harmony default export */ var houseDesign_HouseLayout = (HouseLayout);
;// CONCATENATED MODULE: ./src/components/atoms/svg/DownloadIcon.tsx





var DownloadIcon = function DownloadIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 22 19",
    "data-id": "svg_DownloadIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fillRule: "evenodd",
      "data-id": "svg_DownloadIcon_g",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "translate(-330.000000, -1524.000000)",
        fill: constants_colors/* ICON_COLORS */.M[variant],
        "data-id": "svg_DownloadIcon_g_2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          transform: "translate(230.000000, 100.000000)",
          "data-id": "svg_DownloadIcon_g_3",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            transform: "translate(100.000000, 1421.000000)",
            "data-id": "svg_DownloadIcon_g_4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
              transform: "translate(11.000000, 12.500000) rotate(90.000000) translate(-11.000000, -12.500000) translate(1.500000, 1.500000)",
              "data-id": "svg_DownloadIcon_g_5",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                d: "M7.76109881,9.051119 L7.76109881,2.23142104 L10.7610988,2.23142104 L10.7610988,8.81727181 L11.8775853,7.70078531 C12.4956146,7.08275603 13.4701232,7.07892207 14.0939389,7.66645496 L14.0975444,7.66284944 L15.2610988,8.82640387 L13.346646,10.7408567 L13.3438609,10.7380715 L10.3198756,13.7620568 C9.99286,14.0890723 9.56603925,14.2441288 9.14417521,14.2306079 L9.14417521,14.2306079 C8.72231117,14.2441288 8.29549043,14.0890723 7.96847486,13.7620568 L4.92687869,10.7204606 L3.0326296,8.82639314 L4.13394739,7.72507534 L4.13460889,7.72573684 C4.14263371,7.71736432 4.15076778,7.70905552 4.15901112,7.70081218 C4.78082324,7.07900006 5.78091644,7.07093663 6.41076512,7.70078531 L7.76109881,9.051119 Z M1.26264058,17.2626406 L16.768579,17.2626406 L16.768579,10.231421 L19.768579,10.231421 L19.768579,17.7626406 C19.768579,19.1433525 18.6492908,20.2626406 17.268579,20.2626406 L0.762640584,20.2626406 C-0.618071291,20.2626406 -1.73735942,19.1433525 -1.73735942,17.7626406 L-1.73735942,10.231421 L1.26264058,10.231421 L1.26264058,17.2626406 Z",
                transform: "translate(9.015610, 11.247031) rotate(-90.000000) translate(-9.015610, -11.247031) ",
                "data-id": "svg_DownloadIcon_path"
              })
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var svg_DownloadIcon = (DownloadIcon);
;// CONCATENATED MODULE: ./src/components/atoms/SimpleBanner.tsx



var SimpleBanner_excluded = ["children", "icon"];

var SimpleBanner_templateObject, SimpleBanner_templateObject2, SimpleBanner_templateObject3;

function SimpleBanner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SimpleBanner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SimpleBanner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SimpleBanner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SimpleBanner_Banner = (0,styled_components_browser_esm["default"])(atoms_Container/* default */.Z)(SimpleBanner_templateObject || (SimpleBanner_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 8rem;\n  align-items: flex-start;\n"])));
var SimpleBanner_IconWrapper = styled_components_browser_esm["default"].div(SimpleBanner_templateObject2 || (SimpleBanner_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 3rem;\n  height: 22rem;\n"])));
var SimpleBanner_ContentWrapper = styled_components_browser_esm["default"].div(SimpleBanner_templateObject3 || (SimpleBanner_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));

var SimpleBanner = function SimpleBanner(_ref) {
  var children = _ref.children,
      Icon = _ref.icon,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, SimpleBanner_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SimpleBanner_Banner, SimpleBanner_objectSpread(SimpleBanner_objectSpread({
    variant: "gray10",
    paddingVertical: "sm",
    paddingHorizontal: "md"
  }, props), {}, {
    "data-id": "atoms_SimpleBanner_Banner",
    children: [!!Icon && /*#__PURE__*/(0,jsx_runtime.jsx)(SimpleBanner_IconWrapper, {
      "data-id": "atoms_SimpleBanner_IconWrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
        variant: "gray30",
        height: 16,
        "data-id": "atoms_SimpleBanner_Icon"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SimpleBanner_ContentWrapper, {
      "data-id": "atoms_SimpleBanner_ContentWrapper",
      children: children
    })]
  }));
};

/* harmony default export */ var atoms_SimpleBanner = (SimpleBanner);
;// CONCATENATED MODULE: ./src/components/houseDesign/Summary.tsx




var Summary_templateObject, Summary_templateObject2, Summary_templateObject3, Summary_templateObject4, Summary_templateObject5, Summary_templateObject6;

function Summary_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Summary_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Summary_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Summary_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


























var Summary_StyledTable = styled_components_browser_esm["default"].table(Summary_templateObject || (Summary_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  text-align: left;\n  border-collapse: collapse;\n"])));

var sharedThTdStyles = function sharedThTdStyles(_ref) {
  var _ref$isCategory = _ref.isCategory,
      isCategory = _ref$isCategory === void 0 ? false : _ref$isCategory,
      _ref$alignRight = _ref.alignRight,
      alignRight = _ref$alignRight === void 0 ? false : _ref$alignRight,
      _ref$isLastOfCategory = _ref.isLastOfCategory,
      isLastOfCategory = _ref$isLastOfCategory === void 0 ? false : _ref$isLastOfCategory,
      _ref$isSummary = _ref.isSummary,
      isSummary = _ref$isSummary === void 0 ? false : _ref$isSummary;
  return (0,styled_components_browser_esm.css)(Summary_templateObject2 || (Summary_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 4rem;\n  ", "\n  ", "\n  ", "\n  ", "\n"])), alignRight ? "text-align: right;" : "", isCategory ? "padding-top: 16rem;" : "", isLastOfCategory ? "padding-bottom: 16rem;" : "", isSummary ? "border-top: 1rem solid ".concat(colors/* colors.gray20 */.O.gray20, ";") : "");
};

var Summary_StyledTh = styled_components_browser_esm["default"].th(Summary_templateObject3 || (Summary_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: ", ";\n  ", "\n\n  ", "\n"])), fonts/* fontWeight.medium */.Ue.medium, function (_ref2) {
  var _ref2$isCategory = _ref2.isCategory,
      isCategory = _ref2$isCategory === void 0 ? false : _ref2$isCategory;
  return isCategory && "font-weight: ".concat(fonts/* fontWeight.bold */.Ue.bold, ";");
}, sharedThTdStyles);
var Summary_StyledTd = styled_components_browser_esm["default"].td(Summary_templateObject4 || (Summary_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), sharedThTdStyles);
var Summary_StyledTr = styled_components_browser_esm["default"].tr(Summary_templateObject5 || (Summary_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ", ", " {\n    ", "\n  }\n"])), Summary_StyledTd, Summary_StyledTh, function (_ref3) {
  var _ref3$isCategory = _ref3.isCategory,
      isCategory = _ref3$isCategory === void 0 ? false : _ref3$isCategory;
  return isCategory && "border-top: 1rem solid ".concat(colors/* colors.gray10 */.O.gray10, ";");
});
var Summary_IconContainer = styled_components_browser_esm["default"].div(Summary_templateObject6 || (Summary_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 4rem;\n"])));

var getPriceVariant = function getPriceVariant(isSummary, isCategory) {
  if (isSummary) {
    return 'brand';
  }

  if (isCategory) {
    return 'transparent';
  }

  return 'gray30';
};

var Row = function Row(_ref4) {
  var iconSlug = _ref4.iconSlug,
      price = _ref4.price,
      squareMeters = _ref4.squareMeters,
      title = _ref4.title,
      _ref4$isBase = _ref4.isBase,
      isBase = _ref4$isBase === void 0 ? false : _ref4$isBase,
      _ref4$isCategory = _ref4.isCategory,
      isCategory = _ref4$isCategory === void 0 ? false : _ref4$isCategory,
      _ref4$isSummary = _ref4.isSummary,
      isSummary = _ref4$isSummary === void 0 ? false : _ref4$isSummary,
      _ref4$isLastOfCategor = _ref4.isLastOfCategory,
      isLastOfCategory = _ref4$isLastOfCategor === void 0 ? false : _ref4$isLastOfCategor,
      _ref4$isReference = _ref4.isReference,
      isReference = _ref4$isReference === void 0 ? false : _ref4$isReference;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      _useBreakpointInfo$is = _useBreakpointInfo.isLargerThan,
      lg = _useBreakpointInfo$is.lg,
      md = _useBreakpointInfo$is.md;

  var Icon = ICON_MAP[iconSlug !== null && iconSlug !== void 0 ? iconSlug : 'houseEmpty'];
  var showIconCell = !md || lg;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Summary_StyledTr, {
    isCategory: isCategory,
    "data-id": "houseDesign_Summary_StyledTr",
    children: [showIconCell && /*#__PURE__*/(0,jsx_runtime.jsx)(Summary_StyledTd, {
      isCategory: isCategory,
      isLastOfCategory: isLastOfCategory,
      "data-id": "houseDesign_Summary_StyledTd",
      children: isCategory && /*#__PURE__*/(0,jsx_runtime.jsx)(Summary_IconContainer, {
        "data-id": "houseDesign_Summary_IconContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
          width: 22,
          variant: "brand",
          "data-id": "houseDesign_Summary_Icon"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Summary_StyledTh, {
      isCategory: isCategory,
      isLastOfCategory: isLastOfCategory,
      "data-id": "houseDesign_Summary_StyledTh",
      children: [isReference && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(svg_ApproximateIcon, {
          height: 12,
          variant: "gray30",
          "data-id": "houseDesign_Summary_ApproximateIcon"
        }), ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
        inline: true,
        text: title,
        variant: isCategory ? 'gray40' : 'gray30',
        "data-id": "houseDesign_Summary_Text"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Summary_StyledTd, {
      isCategory: isCategory,
      isLastOfCategory: isLastOfCategory,
      alignRight: true,
      "data-id": "houseDesign_Summary_StyledTd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_SquareMeters, {
        squareMeters: squareMeters,
        withPlus: !isBase && !isSummary,
        variant: isCategory ? 'gray40' : 'gray30',
        "data-id": "houseDesign_Summary_SquareMeters"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Summary_StyledTd, {
      isCategory: isCategory,
      isLastOfCategory: isLastOfCategory,
      alignRight: true,
      "data-id": "houseDesign_Summary_StyledTd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Price, {
        price: price,
        displayZero: true,
        variant: getPriceVariant(isSummary, isCategory),
        "data-id": "houseDesign_Summary_Price"
      })
    })]
  });
};

var CategoryRow = function CategoryRow(_ref5) {
  var wishList = _ref5.wishList,
      section = _ref5.section;
  var id = section.id,
      slug = section.slug;
  var options = (0,react.useMemo)(function () {
    return getSelectedOptions(wishList, id);
  }, [id, wishList]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Row, Summary_objectSpread(Summary_objectSpread({}, section), {}, {
      isBase: slug === Slug.base,
      isCategory: true,
      isLastOfCategory: options.length === 0,
      "data-id": "houseDesign_Summary_Row"
    })), options.map(function (option, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Row, Summary_objectSpread(Summary_objectSpread({}, option), {}, {
        isLastOfCategory: i === options.length - 1,
        "data-id": "houseDesign_Summary_Row_12"
      }), option.id);
    })]
  });
};

var Summary = function Summary(_ref6) {
  var wishList = _ref6.wishList;

  var _useSections = hooks_useSections(),
      sections = _useSections.sections;

  var exportUrl = wishList.exportUrl;
  var downloadButton = exportUrl ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
    href: exportUrl,
    text: "Download samenvatting",
    icon: svg_DownloadIcon,
    "data-id": "houseDesign_Summary_Button"
  }) : null;

  var sectionsWithoutSummary = (0,toConsumableArray/* default */.Z)(sections);

  var summarySection = sectionsWithoutSummary.pop();
  var referenceOptionsTotalPrice = (0,react.useMemo)(function () {
    return Math.round(sections.reduce(function (total, _ref7) {
      var _ref7$referencePrice = _ref7.referencePrice,
          referencePrice = _ref7$referencePrice === void 0 ? 0 : _ref7$referencePrice;
      return total + referencePrice;
    }, 0));
  }, [sections]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(houseDesign_CategoryIntro, {
    title: "Samenvatting",
    iconSlug: "houseEuro",
    "data-id": "houseDesign_Summary_CategoryIntro",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_Container/* default */.Z, {
      padding: "xl",
      marginBottom: "xl",
      shadow: true,
      "data-id": "houseDesign_Summary_Container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_TextBox, {
        marginBottom: "xl",
        "data-id": "houseDesign_Summary_TextBox",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
          text: "Download een samenvatting van dit woonontwerp en deel deze met vrienden of familie. Of neem 'm mee naar de makelaar of hypotheekadviseur. Zo kom je goed beslagen ten ijs.",
          "data-id": "houseDesign_Summary_Text"
        }), downloadButton]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Summary_StyledTable, {
        "data-id": "houseDesign_Summary_StyledTable",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
          "data-id": "houseDesign_Summary_tbody",
          children: sectionsWithoutSummary.map(function (section) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryRow, {
              section: section,
              wishList: wishList,
              "data-id": "houseDesign_Summary_CategoryRow"
            }, section.slug);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("tfoot", {
          "data-id": "houseDesign_Summary_tfoot",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row, Summary_objectSpread(Summary_objectSpread({}, summarySection), {}, {
            title: "Totaal",
            isCategory: true,
            isLastOfCategory: true,
            "data-id": "houseDesign_Summary_Row"
          }))
        })]
      }), referenceOptionsTotalPrice > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_SimpleBanner, {
        icon: svg_ApproximateIcon,
        "data-id": "houseDesign_Summary_SimpleBanner",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
          variant: "gray30",
          text: "In dit totaalbedrag zijn voorbeeldopties meegerekend ter waarde van ".concat(formatPrice(referenceOptionsTotalPrice, {
            showDecimal: false,
            showEuroSign: true
          }), ". Deze kosten zijn een schatting."),
          "data-id": "houseDesign_Summary_Text"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        marginTop: "lg",
        "data-id": "houseDesign_Summary_Box",
        children: downloadButton
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_NavButtons, {
      "data-id": "houseDesign_Summary_NavButtons"
    })]
  });
};

/* harmony default export */ var houseDesign_Summary = (Summary);
;// CONCATENATED MODULE: ./src/constants/inputs.ts


var INPUT_SIZE_MAP = {
  sm: fonts/* fontStyles.body.sm */.g6.body.sm,
  md: fonts/* fontStyles.body.md */.g6.body.md,
  lg: fonts/* fontStyles.title.lg */.g6.title.lg
};
var INPUT_UNDERLINE_MAP = {
  brand: colors/* colors.gray30 */.O.gray30,
  gray30: colors/* colors.gray30 */.O.gray30,
  white: colors/* colors.white */.O.white
};
;// CONCATENATED MODULE: ./src/components/atoms/inputs/InputText.tsx



var InputText_excluded = ["onChange", "value", "inputSize", "variant", "maxLength", "placeholder"];

var InputText_templateObject;

function InputText_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InputText_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InputText_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InputText_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var InputText_Input = styled_components_browser_esm["default"].input(InputText_templateObject || (InputText_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  width: 100%;\n  border: none;\n  color: ", ";\n  background-color: inherit;\n  padding: 7rem 0 8rem;\n  border-bottom: 1rem solid ", ";\n  resize: none;\n  &:focus-visible {\n    outline: none;\n  }\n  &::placeholder {\n    color: ", ";\n    font-style: italic;\n  }\n"])), function (_ref) {
  var inputSize = _ref.inputSize;
  return INPUT_SIZE_MAP[inputSize];
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant && colors/* colors */.O[variant];
}, function (_ref3) {
  var variant = _ref3.variant;
  return variant && INPUT_UNDERLINE_MAP[variant];
}, function (_ref4) {
  var variant = _ref4.variant;
  return variant && colors/* colors */.O[variant];
});

var InputText = function InputText(_ref5) {
  var _onChange = _ref5.onChange,
      value = _ref5.value,
      _ref5$inputSize = _ref5.inputSize,
      inputSize = _ref5$inputSize === void 0 ? 'md' : _ref5$inputSize,
      _ref5$variant = _ref5.variant,
      variant = _ref5$variant === void 0 ? 'gray30' : _ref5$variant,
      _ref5$maxLength = _ref5.maxLength,
      maxLength = _ref5$maxLength === void 0 ? 150 : _ref5$maxLength,
      _ref5$placeholder = _ref5.placeholder,
      placeholder = _ref5$placeholder === void 0 ? '' : _ref5$placeholder,
      props = (0,objectWithoutProperties/* default */.Z)(_ref5, InputText_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(InputText_Input, InputText_objectSpread(InputText_objectSpread({}, props), {}, {
    maxLength: maxLength,
    variant: variant,
    value: value,
    inputSize: inputSize,
    placeholder: placeholder,
    onChange: function onChange(e) {
      _onChange(e.target.value);
    },
    type: "text",
    "data-id": "inputs_InputText_Input"
  }));
};

/* harmony default export */ var inputs_InputText = (InputText);
;// CONCATENATED MODULE: ./src/components/atoms/inputs/InputPrice.tsx


var InputPrice_templateObject, InputPrice_templateObject2;







var InputPrice_Wrapper = styled_components_browser_esm["default"].div(InputPrice_templateObject || (InputPrice_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 8rem;\n"])));
var InputPrice_Input = styled_components_browser_esm["default"].input(InputPrice_templateObject2 || (InputPrice_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  width: 100%;\n  border: none;\n  color: ", ";\n  background-color: inherit;\n  padding: 7rem 0 8rem;\n  border-bottom: 1rem solid ", ";\n  &:focus-visible {\n    outline: none;\n  }\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n  &::placeholder {\n    color: ", ";\n    font-style: italic;\n  }\n  &::before {\n    content: '\u20AC ';\n  }\n"])), function (_ref) {
  var inputSize = _ref.inputSize;
  return inputSize && INPUT_SIZE_MAP[inputSize];
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant && colors/* colors */.O[variant];
}, function (_ref3) {
  var variant = _ref3.variant;
  return variant && INPUT_UNDERLINE_MAP[variant];
}, function (_ref4) {
  var variant = _ref4.variant;
  return variant && colors/* colors */.O[variant];
});

var InputPrice = function InputPrice(_ref5) {
  var _onChange = _ref5.onChange,
      value = _ref5.value,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 'md' : _ref5$size,
      _ref5$placeholder = _ref5.placeholder,
      placeholder = _ref5$placeholder === void 0 ? '' : _ref5$placeholder,
      _ref5$variant = _ref5.variant,
      variant = _ref5$variant === void 0 ? 'gray30' : _ref5$variant;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InputPrice_Wrapper, {
    "data-id": "inputs_InputPrice_Wrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
      text: "\u20AC",
      variant: "white",
      size: size,
      italic: true,
      "data-id": "inputs_InputPrice_Text"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputPrice_Input, {
      value: value,
      variant: variant,
      placeholder: placeholder,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      },
      inputSize: size,
      type: "number",
      step: 0.01,
      min: 0,
      "data-id": "inputs_InputPrice_Input"
    })]
  });
};

/* harmony default export */ var inputs_InputPrice = (InputPrice);
;// CONCATENATED MODULE: ./src/components/houseDesign/userWish/UserWishForm.tsx



var UserWishForm_templateObject, UserWishForm_templateObject2, UserWishForm_templateObject3, UserWishForm_templateObject4, UserWishForm_templateObject5;

function UserWishForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UserWishForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UserWishForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UserWishForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var UserWishForm_Wrapper = (0,styled_components_browser_esm["default"])(atoms_Container/* default */.Z)(UserWishForm_templateObject || (UserWishForm_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n\n  ", "\n"])), colors/* colors.gray40 */.O.gray40, function (_ref) {
  var isEditing = _ref.isEditing;
  return !isEditing && "border-top-left-radius: 0;";
});
var UserWishForm_Form = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(UserWishForm_templateObject2 || (UserWishForm_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24rem;\n"])));
var UserWishForm_ButtonContainer = styled_components_browser_esm["default"].div(UserWishForm_templateObject3 || (UserWishForm_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: end;\n  gap: 20rem;\n"])));
var ButtonWidth = styled_components_browser_esm["default"].div(UserWishForm_templateObject4 || (UserWishForm_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-width: 96rem;\n"])));
var InputTextField = (0,styled_components_browser_esm["default"])(inputs_InputText)(UserWishForm_templateObject5 || (UserWishForm_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1 0 75%;\n"])));

var UserWishForm = function UserWishForm(_ref2) {
  var _userWish$id$toString;

  var callback = _ref2.callback,
      userWish = _ref2.userWish;
  var params = (0,useParams/* default */.Z)();

  var _useSectionLoading = hooks_useSectionLoading(),
      toggleSectionLoading = _useSectionLoading.toggleSectionLoading;

  var originalTitle = userWish === null || userWish === void 0 ? void 0 : userWish.title;
  var originalPrice = userWish === null || userWish === void 0 ? void 0 : userWish.price.toString();

  var _useState = (0,react.useState)(originalTitle !== null && originalTitle !== void 0 ? originalTitle : ''),
      userWishDescription = _useState[0],
      setUserWishDescription = _useState[1];

  var _useState2 = (0,react.useState)(originalPrice !== null && originalPrice !== void 0 ? originalPrice : ''),
      userWishPrice = _useState2[0],
      setUserWishPrice = _useState2[1];

  var onSuccess = function onSuccess() {
    setUserWishDescription('');
    setUserWishPrice('');
  };

  var onSettled = function onSettled() {
    callback === null || callback === void 0 || callback();
    toggleSectionLoading(false, Slug.userWishes);
  };

  var _useWishListMutation = useWishListMutation('postUserWish', [endpoints/* WishListRequestKey.wishListUserWish */.P.wishListUserWish], params, {
    onSuccess: onSuccess,
    onSettled: onSettled
  }),
      postUserWish = _useWishListMutation.mutate,
      postUserWishIsLoading = _useWishListMutation.isLoading,
      postUserWishIsError = _useWishListMutation.isError,
      postUserWishError = _useWishListMutation.error;

  var _useWishListMutation2 = useWishListMutation('patchUserWish', [endpoints/* WishListRequestKey.wishListUserWish */.P.wishListUserWish, userWish === null || userWish === void 0 ? void 0 : userWish.id], UserWishForm_objectSpread(UserWishForm_objectSpread({}, params), {}, {
    userWishId: (_userWish$id$toString = userWish === null || userWish === void 0 ? void 0 : userWish.id.toString()) !== null && _userWish$id$toString !== void 0 ? _userWish$id$toString : ''
  }), {
    onSuccess: onSuccess,
    onSettled: onSettled
  }),
      patchUserWish = _useWishListMutation2.mutate,
      patchUserWishIsLoading = _useWishListMutation2.isLoading,
      patchUserWishIsError = _useWishListMutation2.isError,
      patchUserWishError = _useWishListMutation2.error;

  var isLoading = postUserWishIsLoading || patchUserWishIsLoading;
  var isError = postUserWishIsError || patchUserWishIsError;
  var error = postUserWishError !== null && postUserWishError !== void 0 ? postUserWishError : patchUserWishError;
  var isEditing = !!userWish;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_InlineRequestHandler, {
    isError: isError,
    error: error === null || error === void 0 ? void 0 : error.humanReadableMessage,
    isLoading: isLoading,
    statusCode: error === null || error === void 0 ? void 0 : error.statusCode,
    transparent: true,
    "data-id": "userWish_UserWishForm_InlineRequestHandler",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(UserWishForm_Wrapper, {
      padding: "xl",
      isEditing: isEditing,
      "data-id": "userWish_UserWishForm_Wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Title/* default */.Z, {
        variant: "white",
        level: 3,
        size: "md",
        text: isEditing ? 'Woonwens aanpassen' : 'Voeg een woonwens toe',
        "data-id": "userWish_UserWishForm_Title"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(UserWishForm_Form, {
        paddingTop: "md",
        paddingBottom: "lg",
        "data-id": "userWish_UserWishForm_Form",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputTextField, {
          variant: "white",
          placeholder: "Beschrijving woonwens",
          onChange: setUserWishDescription,
          value: userWishDescription,
          "data-id": "userWish_UserWishForm_InputTextField"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(inputs_InputPrice, {
          variant: "white",
          placeholder: "Prijs",
          onChange: setUserWishPrice,
          value: userWishPrice,
          "data-id": "userWish_UserWishForm_InputPrice"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(UserWishForm_ButtonContainer, {
        "data-id": "userWish_UserWishForm_ButtonContainer",
        children: [isEditing && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWidth, {
          "data-id": "userWish_UserWishForm_ButtonWidth",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
            text: "Annuleren",
            size: "sm",
            centerText: true,
            variant: "outlined-inverted",
            onClick: function onClick() {
              callback === null || callback === void 0 || callback();
            },
            "data-id": "userWish_UserWishForm_Button"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWidth, {
          "data-id": "userWish_UserWishForm_ButtonWidth",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
            text: isEditing ? 'Wijziging opslaan' : 'Opslaan',
            size: "sm",
            centerText: true,
            disabled: userWishDescription.length === 0 || userWishPrice.length === 0,
            onClick: function onClick() {
              if (userWishDescription === originalTitle && userWishPrice === originalPrice) {
                callback === null || callback === void 0 || callback();
                return;
              }

              toggleSectionLoading(true, Slug.userWishes);
              var body = {
                price: userWishPrice,
                selected: true,
                title: userWishDescription,
                wishList: params.wishListId
              };

              if (isEditing) {
                var _userWish$id$toString2;

                patchUserWish({
                  params: UserWishForm_objectSpread(UserWishForm_objectSpread({}, params), {}, {
                    userWishId: (_userWish$id$toString2 = userWish === null || userWish === void 0 ? void 0 : userWish.id.toString()) !== null && _userWish$id$toString2 !== void 0 ? _userWish$id$toString2 : ''
                  }),
                  body: body
                });
                return;
              }

              postUserWish({
                params: params,
                body: body
              });
            },
            "data-id": "userWish_UserWishForm_Button"
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var userWish_UserWishForm = (UserWishForm);
;// CONCATENATED MODULE: ./src/components/houseDesign/userWish/UserWishItem.tsx



var UserWishItem_excluded = ["wishListItem"];

var UserWishItem_templateObject;

function UserWishItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UserWishItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UserWishItem_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UserWishItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var UserWishItem_SlideInOut = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div)(UserWishItem_templateObject || (UserWishItem_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n"])));

var UserWishItem = function UserWishItem(_ref) {
  var userWish = _ref.userWish,
      editing = _ref.editing,
      _onEdit = _ref.onEdit;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useParams = (0,useParams/* default */.Z)(),
      wishListItem = _useParams.wishListItem,
      params = (0,objectWithoutProperties/* default */.Z)(_useParams, UserWishItem_excluded);

  var _useState = (0,react.useState)(false),
      refetchWishListIsLoading = _useState[0],
      setRefetchWishListIsLoading = _useState[1];

  var _useSectionLoading = hooks_useSectionLoading(),
      toggleSectionLoading = _useSectionLoading.toggleSectionLoading;

  var id = userWish.id,
      amount = userWish.amount,
      title = userWish.title,
      price = userWish.price;

  var paramsWithUserWishId = UserWishItem_objectSpread(UserWishItem_objectSpread({}, params), {}, {
    userWishId: id.toString()
  });

  var toggleUserWishSectionLoadingOff = function toggleUserWishSectionLoadingOff() {
    return toggleSectionLoading(false, Slug.userWishes);
  };

  var _useWishListMutation = useWishListMutation('patchUserWish', [id], paramsWithUserWishId, {
    onSettled: toggleUserWishSectionLoadingOff
  }),
      mutate = _useWishListMutation.mutate,
      mutateUserWishIsLoading = _useWishListMutation.isLoading;

  var _useMutationRequest = (0,requestHooks/* useMutationRequest */.iO)('deleteUserWish'),
      deleteUserWish = _useMutationRequest.mutate,
      deleteUserWishIsLoading = _useMutationRequest.isLoading,
      deleteUserWishIsSuccess = _useMutationRequest.isSuccess; // the key (wishListUpdating) is intentionally different from the initial request key, so the UI does not go into the initial (blocking) loading state


  var _useWishListQuery = useWishListQuery('getWishList', [endpoints/* WishListRequestKey.wishListUpdating */.P.wishListUpdating], params, {
    enabled: false,
    onSettled: function onSettled() {
      toggleUserWishSectionLoadingOff();
    },
    onError: function onError() {
      setRefetchWishListIsLoading(false);
    }
  }),
      refetch = _useWishListQuery.refetch;

  (0,react.useEffect)(function () {
    if (deleteUserWishIsSuccess) {
      refetch();
    }
  }, [deleteUserWishIsSuccess, refetch]);
  var selected = amount > 0;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-id": "userWish_UserWishItem_div",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      "data-id": "userWish_UserWishItem_AnimatePresence",
      children: !editing && /*#__PURE__*/(0,jsx_runtime.jsx)(UserWishItem_SlideInOut, {
        animate: {
          height: 'auto'
        },
        initial: {
          height: 0
        },
        exit: {
          height: 0
        },
        transition: {
          duration: 0.8
        },
        "data-id": "userWish_UserWishItem_SlideInOut",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_InlineRequestHandler, {
          isLoading: refetchWishListIsLoading || mutateUserWishIsLoading || deleteUserWishIsLoading,
          transparent: true,
          "data-id": "userWish_UserWishItem_InlineRequestHandler",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Container/* default */.Z, {
            variant: "gray10",
            padding: "md",
            "data-id": "userWish_UserWishItem_Container",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_OptionTitleLine, {
              title: title,
              price: price,
              small: true,
              onEdit: function onEdit() {
                _onEdit(id);
              },
              onDelete: function onDelete() {
                setRefetchWishListIsLoading(true); // only go into loading state if the user wish is selected, otherwise it does not affect the totals anyway

                if (amount > 0) {
                  toggleSectionLoading(true, Slug.userWishes);
                }

                deleteUserWish({
                  params: paramsWithUserWishId
                });
              },
              "data-id": "userWish_UserWishItem_OptionTitleLine",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(inputs_InputCheckbox, {
                onClick: function onClick() {
                  toggleSectionLoading(true, Slug.userWishes);
                  mutate({
                    params: paramsWithUserWishId,
                    body: {
                      selected: !(amount > 0),
                      wishList: params.wishListId
                    }
                  });
                },
                checked: selected,
                disabled: refetchWishListIsLoading,
                "data-id": "userWish_UserWishItem_InputCheckbox"
              })
            })
          })
        })
      }, id)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      "data-id": "userWish_UserWishItem_AnimatePresence",
      children: editing && /*#__PURE__*/(0,jsx_runtime.jsx)(UserWishItem_SlideInOut, {
        animate: {
          height: 'auto'
        },
        initial: {
          height: 0
        },
        exit: {
          height: 0
        },
        transition: {
          duration: 0.8
        },
        "data-id": "userWish_UserWishItem_SlideInOut",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(userWish_UserWishForm, {
          userWish: userWish,
          callback: function callback() {
            _onEdit();
          },
          "data-id": "userWish_UserWishItem_UserWishForm"
        })
      }, id)
    })]
  });
};

/* harmony default export */ var userWish_UserWishItem = (UserWishItem);
;// CONCATENATED MODULE: ./src/components/houseDesign/userWish/UserWishList.tsx


var UserWishList_excluded = ["wishListItem"];

var UserWishList_templateObject;






var UserWishList_WishList = styled_components_browser_esm["default"].ul(UserWishList_templateObject || (UserWishList_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16rem;\n"])));

var UserWishList = function UserWishList(_ref) {
  var userWishes = _ref.userWishes;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useParams = (0,useParams/* default */.Z)(),
      wishListItem = _useParams.wishListItem,
      params = (0,objectWithoutProperties/* default */.Z)(_useParams, UserWishList_excluded);

  var _useState = (0,react.useState)(),
      currentlyEditing = _useState[0],
      setCurrentlyEditing = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(UserWishList_WishList, {
    "data-id": "userWish_UserWishList_WishList",
    children: userWishes === null || userWishes === void 0 ? void 0 : userWishes.map(function (userWish) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(userWish_UserWishItem, {
        userWish: userWish,
        editing: currentlyEditing === userWish.id,
        onEdit: function onEdit(id) {
          return setCurrentlyEditing(id);
        },
        "data-id": "userWish_UserWishList_UserWishItem"
      }, userWish.id);
    })
  });
};

/* harmony default export */ var userWish_UserWishList = (UserWishList);
;// CONCATENATED MODULE: ./src/components/houseDesign/userWish/UserWishes.tsx
















var UserWishes = function UserWishes(_ref) {
  var wishList = _ref.wishList;
  var userWishes = wishList.userWishes;

  var _useSections = hooks_useSections(),
      sections = _useSections.sections;

  var _useSectionLoading = hooks_useSectionLoading(),
      isSectionLoading = _useSectionLoading.isSectionLoading;

  var config = sections === null || sections === void 0 ? void 0 : sections.find(function (section) {
    return section.slug === Slug.userWishes;
  });

  if (!config) {
    return null;
  }

  var title = config.title,
      price = config.price,
      iconSlug = config.iconSlug;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundaryWithSentry/* default */.Z, {
    "data-id": "userWish_UserWishes_ErrorBoundary",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(houseDesign_CategoryIntro, {
      title: title,
      iconSlug: iconSlug,
      "data-id": "userWish_UserWishes_CategoryIntro",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_Container/* default */.Z, {
        shadow: true,
        marginBottom: "xl",
        "data-id": "userWish_UserWishes_Container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_TextBox, {
          padding: "xl",
          "data-id": "userWish_UserWishes_TextBox",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Text/* default */.Z, {
            text: "Heb je woonwensen die je niet kon terugvinden? Voeg ze hier toe, inclusief een omschrijving en de benodigde investering. Zo houd je jouw verlangontwerp compleet en heb je alle kosten en mogelijkheden overzichtelijk bij elkaar.",
            "data-id": "userWish_UserWishes_Text"
          }), !!userWishes && userWishes.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(userWish_UserWishList, {
            userWishes: userWishes,
            "data-id": "userWish_UserWishes_UserWishList"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Banner/* default */.Z, {
            content: "Voeg hieronder je eerste eigen woonwens toe!",
            "data-id": "userWish_UserWishes_Banner"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(userWish_UserWishForm, {
          "data-id": "userWish_UserWishes_UserWishForm"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Container/* default */.Z, {
        paddingHorizontal: "xl",
        paddingVertical: "lg",
        marginBottom: "xl",
        shadow: true,
        "data-id": "userWish_UserWishes_Container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Layer, {
          title: title,
          price: price,
          iconSlug: iconSlug,
          isSummary: true,
          loading: isSectionLoading(Slug.userWishes),
          "data-id": "userWish_UserWishes_Layer"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_NavButtons, {
        "data-id": "userWish_UserWishes_NavButtons"
      })]
    })
  });
};

/* harmony default export */ var userWish_UserWishes = (UserWishes);
// EXTERNAL MODULE: ./node_modules/react-svgmt/index.js
var react_svgmt = __webpack_require__(52890);
;// CONCATENATED MODULE: ./src/processes/optionByUuid.ts
function optionByUuid_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = optionByUuid_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function optionByUuid_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return optionByUuid_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return optionByUuid_arrayLikeToArray(o, minLen); }

function optionByUuid_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getOptionByUuid = function getOptionByUuid(uuid, _ref) {
  var categories = _ref.categories;

  // eslint-disable-next-line no-restricted-syntax
  var _iterator = optionByUuid_createForOfIteratorHelper(categories),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var category = _step.value;

      // eslint-disable-next-line no-restricted-syntax
      var _iterator2 = optionByUuid_createForOfIteratorHelper(category.subcategories),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var subcategory = _step2.value;

          // eslint-disable-next-line no-restricted-syntax
          var _iterator3 = optionByUuid_createForOfIteratorHelper(subcategory.options),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var option = _step3.value;

              if (option.uuid === uuid) {
                return option;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return undefined;
};
var getAllOptionUuids = function getAllOptionUuids(_ref2) {
  var categories = _ref2.categories;
  var uuids = [];
  categories.forEach(function (_ref3) {
    var subcategories = _ref3.subcategories;
    subcategories.forEach(function (_ref4) {
      var options = _ref4.options;
      options.forEach(function (_ref5) {
        var uuid = _ref5.uuid;
        uuids.push(uuid);
      });
    });
  });
  return uuids;
};
;// CONCATENATED MODULE: ./src/components/houseDesign/FloorPlan.tsx


var FloorPlan_templateObject, FloorPlan_templateObject2, FloorPlan_templateObject3, FloorPlan_templateObject4;

/* eslint-disable react/style-prop-object */


 // there is no typing for react-svgmt, but since the code is simple, we can ignore it
// @ts-ignore














var FloorPlan_Container = styled_components_browser_esm["default"].div(FloorPlan_templateObject || (FloorPlan_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: hidden;\n  gap: 16rem;\n"])));
var FloorPlanContainer = (0,styled_components_browser_esm["default"])(atoms_FadeAnimationWrapper)(FloorPlan_templateObject2 || (FloorPlan_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-grow: 10;\n  overflow: hidden;\n"])));
var FloorPlan_Buttons = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(FloorPlan_templateObject3 || (FloorPlan_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12rem;\n"])));
var StyledSvgLoader = (0,styled_components_browser_esm["default"])(react_svgmt.SvgLoader)(FloorPlan_templateObject4 || (FloorPlan_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  width: 100%;\n  height: 100%;\n"])));
var animationStyle = 'transition:opacity 700ms;';

var getGetStyle = function getGetStyle(wishList) {
  return function (uuid) {
    var option = getOptionByUuid(uuid, wishList);

    if (!option) {
      return 'opacity:0';
    }

    return houseDesignStatuses_getTotalAmountForOption(option, wishList) > 0 ? "opacity:1;".concat(animationStyle) : "opacity:0;".concat(animationStyle);
  };
};

var FloorPlan_ICON_MAP = [svg_Floor0Icon, Floor1Icon, svg_Floor2Icon, svg_Floor3Icon, svg_Floor4Icon];

var FloorPlan = function FloorPlan(_ref) {
  var storeys = _ref.storeys,
      wishList = _ref.wishList;

  var _useState = (0,react.useState)(0),
      currentStoreyIndex = _useState[0],
      setCurrentStoreyIndex = _useState[1];

  var getStyle = getGetStyle(wishList);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FloorPlan_Container, {
    "data-id": "houseDesign_FloorPlan_Container",
    children: [storeys.length > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(FloorPlan_Buttons, {
      "data-id": "houseDesign_FloorPlan_Buttons",
      children: storeys.map(function (_ref2, i) {
        var _ICON_MAP$i;

        var name = _ref2.name;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_UtilityButton, {
          onClick: function onClick() {
            setCurrentStoreyIndex(i);
          },
          icon: (_ICON_MAP$i = FloorPlan_ICON_MAP[i]) !== null && _ICON_MAP$i !== void 0 ? _ICON_MAP$i : svg_FloorIcon,
          iconSize: 22,
          variant: i === currentStoreyIndex ? 'white' : 'gray40',
          "data-id": "houseDesign_FloorPlan_UtilityButton"
        }, name);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FloorPlanContainer, {
      animationKey: currentStoreyIndex,
      style: {
        flexGrow: 10,
        overflow: 'hidden'
      },
      "data-id": "houseDesign_FloorPlan_FloorPlanContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSvgLoader, {
        path: storeys[currentStoreyIndex].floorPlan,
        "data-id": "houseDesign_FloorPlan_StyledSvgLoader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svgmt.SvgProxy, {
          selector: "[data-is-option=\"true\"]",
          style: "opacity:0",
          "data-id": "houseDesign_FloorPlan_SvgProxy"
        }), getAllOptionUuids(wishList).map(function (uuid) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react_svgmt.SvgProxy, {
            selector: "#uuid-".concat(uuid),
            style: getStyle(uuid),
            "data-id": "houseDesign_FloorPlan_SvgProxy_6"
          }, uuid);
        })]
      })
    })]
  });
};

/* harmony default export */ var houseDesign_FloorPlan = (FloorPlan);
;// CONCATENATED MODULE: ./src/components/houseDesign/SidebarImage.tsx


var SidebarImage_templateObject, SidebarImage_templateObject2, SidebarImage_templateObject3, SidebarImage_templateObject4, SidebarImage_templateObject5;


















var SidebarImage_Container = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div)(SidebarImage_templateObject || (SidebarImage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  height: 100%;\n  position: relative;\n"])), colors/* colors.gray20 */.O.gray20);
var SidebarImage_StyledImage = (0,styled_components_browser_esm["default"])((image_default()))(SidebarImage_templateObject2 || (SidebarImage_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  object-fit: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 1;\n"])), function (_ref) {
  var covered = _ref.covered;
  return covered ? 'cover' : 'contain';
});
var Shadow = styled_components_browser_esm["default"].div(SidebarImage_templateObject3 || (SidebarImage_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 2;\n"])), shadows/* default.insetDarker */.Z.insetDarker);
var SidebarImage_ImageContainer = styled_components_browser_esm["default"].div(SidebarImage_templateObject4 || (SidebarImage_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  position: relative;\n"])));
var SidebarImage_ButtonContainer = styled_components_browser_esm["default"].div(SidebarImage_templateObject5 || (SidebarImage_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  z-index: ", ";\n  ", "\n"])), z.sidebarContent, function (_ref2) {
  var spacing = _ref2.spacing;
  return "bottom: ".concat(styles_spacing/* SIZE_MAP */.H[spacing], "rem; right: ").concat(styles_spacing/* SIZE_MAP */.H[spacing], "rem");
});

var SidebarImage = function SidebarImage(_ref3) {
  var src = _ref3.src,
      withFullscreen = _ref3.withFullscreen,
      _ref3$withPadding = _ref3.withPadding,
      withPadding = _ref3$withPadding === void 0 ? false : _ref3$withPadding;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      isHighResolution = _useBreakpointInfo.isHighResolution;

  var spacing = hooks_useResponsiveSpacing();
  var dispatch = (0,es/* useDispatch */.I0)();

  if (!src) {
    return null;
  }

  var width = isHighResolution ? 800 : 400;

  if (withPadding) {
    // in this case, we show the full image, so set the width to 0 to keep the original aspect ratio while resizing
    width = 0;
  }

  var processedSrc = (0,formatCmsImageUrl/* default */.Z)(width, isHighResolution ? 1600 : 800, src);
  var processedSrcFull = (0,formatCmsImageUrl/* default */.Z)(0, 0, src);

  if (!processedSrc) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SidebarImage_Container, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    "data-id": "houseDesign_SidebarImage_Container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SidebarImage_ImageContainer, {
      "data-id": "houseDesign_SidebarImage_ImageContainer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SidebarImage_StyledImage, {
        priority: true,
        src: processedSrc,
        layout: "fill",
        covered: !withPadding,
        "data-id": "houseDesign_SidebarImage_StyledImage"
      }), withFullscreen && !!processedSrcFull && /*#__PURE__*/(0,jsx_runtime.jsx)(SidebarImage_ButtonContainer, {
        spacing: spacing,
        "data-id": "houseDesign_SidebarImage_ButtonContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_UtilityButton, {
          icon: svg_UnionIcon,
          onClick: function onClick() {
            dispatch((0,houseDesign/* openModal */.h7)({
              type: 'Image',
              props: {
                src: processedSrcFull,
                layout: 'fill',
                withPadding: true
              }
            }));
          },
          "data-id": "houseDesign_SidebarImage_UtilityButton"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Shadow, {
      "data-id": "houseDesign_SidebarImage_Shadow"
    })]
  }, processedSrc);
};

/* harmony default export */ var houseDesign_SidebarImage = (SidebarImage);
;// CONCATENATED MODULE: ./src/components/houseDesign/LayoutSidebar.tsx



var LayoutSidebar_templateObject, LayoutSidebar_templateObject2, LayoutSidebar_templateObject3, LayoutSidebar_templateObject4, LayoutSidebar_templateObject5;

function LayoutSidebar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LayoutSidebar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LayoutSidebar_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LayoutSidebar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var SideBar = styled_components_browser_esm["default"].div(LayoutSidebar_templateObject || (LayoutSidebar_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  z-index: ", ";\n  background: ", ";\n\n  ", "\n\n  ", ";\n"])), z.sideBar, colors/* colors.gray20 */.O.gray20, function (_ref) {
  var currentContentWidthInPx = _ref.currentContentWidthInPx,
      sideBarWidth = _ref.sideBarWidth,
      spacingInPx = _ref.spacingInPx;
  return (0,styled_components_browser_esm.css)(LayoutSidebar_templateObject2 || (LayoutSidebar_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-right: ", "px;\n      width: ", "px;\n      left: ", "px;\n    "])), spacingInPx, spacingInPx + sideBarWidth, Math.round(spacingInPx + currentContentWidthInPx - sideBarWidth));
}, breakpoints/* fromBreakpoint.slg */.ks.slg(LayoutSidebar_templateObject3 || (LayoutSidebar_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n  "])), shadows/* default.defaultInset */.Z.defaultInset));
var LayoutSidebar_Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(LayoutSidebar_templateObject4 || (LayoutSidebar_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  gap: 16rem;\n"])));
var LayoutSidebar_Buttons = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(LayoutSidebar_templateObject5 || (LayoutSidebar_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12rem;\n"])));
/**
 * Get an image from houseType based on the index of the current category
 */

var getImageSrc = function getImageSrc(_ref2, wishListItem) {
  var _houseType$media$inde;

  var houseType = _ref2.houseType,
      categories = _ref2.categories;

  if (!(houseType !== null && houseType !== void 0 && houseType.media) || houseType.media.length === 0 || !wishListItem) {
    return undefined;
  }

  var index = 0;
  categories.forEach(function (_ref3, i) {
    var title = _ref3.title;

    if (wishListItem === slugify(title)) {
      index = i;
    }
  });

  while (index >= houseType.media.length) {
    index -= houseType.media.length;
  }

  return (_houseType$media$inde = houseType.media[index]) === null || _houseType$media$inde === void 0 ? void 0 : _houseType$media$inde.image.src;
};

var LayoutSidebar = function LayoutSidebar(_ref4) {
  var _storeys$;

  var wishList = _ref4.wishList,
      wishListItem = _ref4.wishListItem,
      _ref4$disableFloorPla = _ref4.disableFloorPlan,
      disableFloorPlan = _ref4$disableFloorPla === void 0 ? false : _ref4$disableFloorPla,
      storeys = _ref4.storeys,
      openModal = _ref4.openModal;
  var layoutDimensions = hooks_useLayoutDimensions();

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      slg = _useBreakpointInfo.isLargerThan.slg;

  var spacing = hooks_useResponsiveSpacing();

  var _useLayoutImages = hooks_useLayoutImages(),
      currentLayoutImage = _useLayoutImages.currentLayoutImage; // has a storeys array of which the first item has a floorPlan svg


  var hasStoreys = !!(storeys !== null && storeys !== void 0 && (_storeys$ = storeys[0]) !== null && _storeys$ !== void 0 && _storeys$.floorPlan);
  var content = (0,react.useMemo)(function () {
    if (!slg) {
      return null;
    }

    if (!disableFloorPlan && hasStoreys) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(LayoutSidebar_Container, {
        padding: spacing,
        "data-id": "houseDesign_LayoutSidebar_Container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_FloorPlan // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        , {
          storeys: storeys,
          wishList: wishList,
          "data-id": "houseDesign_LayoutSidebar_FloorPlan"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LayoutSidebar_Buttons, {
          "data-id": "houseDesign_LayoutSidebar_Buttons",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_UtilityButton, {
            onClick: openModal,
            icon: svg_UnionIcon,
            "data-id": "houseDesign_LayoutSidebar_UtilityButton"
          })
        })]
      });
    }

    if (currentLayoutImage) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_SidebarImage, {
        src: currentLayoutImage,
        withFullscreen: true,
        withPadding: true,
        "data-id": "houseDesign_LayoutSidebar_SidebarImage"
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_SidebarImage, {
      src: getImageSrc(wishList, wishListItem),
      "data-id": "houseDesign_LayoutSidebar_SidebarImage_5"
    });
  }, [currentLayoutImage, disableFloorPlan, hasStoreys, openModal, slg, spacing, storeys, wishList, wishListItem]);

  if (!slg) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SideBar, LayoutSidebar_objectSpread(LayoutSidebar_objectSpread({}, layoutDimensions), {}, {
    "data-id": "houseDesign_LayoutSidebar_SideBar",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundaryWithSentry/* default */.Z, {
      "data-id": "houseDesign_LayoutSidebar_ErrorBoundary",
      children: content
    })
  }));
};

/* harmony default export */ var houseDesign_LayoutSidebar = (LayoutSidebar);
;// CONCATENATED MODULE: ./src/components/atoms/Sticky.tsx



var Sticky_templateObject, Sticky_templateObject2;

function Sticky_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Sticky_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Sticky_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Sticky_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var StyledSticky = styled_components_browser_esm["default"].div(Sticky_templateObject || (Sticky_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: ", ";\n  ", "\n"])), z.stickyButton, function (_ref) {
  var sideBarWidth = _ref.sideBarWidth,
      currentContentWidthInPx = _ref.currentContentWidthInPx,
      withOffset = _ref.withOffset;
  return withOffset && (0,styled_components_browser_esm.css)(Sticky_templateObject2 || (Sticky_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-left: ", "px;\n      width: ", "px;\n    "])), sideBarWidth, currentContentWidthInPx);
});

var Sticky = function Sticky(_ref2) {
  var children = _ref2.children,
      _ref2$withPadding = _ref2.withPadding,
      withPadding = _ref2$withPadding === void 0 ? false : _ref2$withPadding,
      _ref2$withOffset = _ref2.withOffset,
      withOffset = _ref2$withOffset === void 0 ? true : _ref2$withOffset;
  var layoutDimensions = hooks_useLayoutDimensions();
  var spacing = hooks_useResponsiveSpacing();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSticky, Sticky_objectSpread(Sticky_objectSpread({
    withOffset: withOffset
  }, layoutDimensions), {}, {
    "data-id": "atoms_Sticky_StyledSticky",
    children: withPadding ? /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      padding: spacing,
      paddingTop: "none",
      "data-id": "atoms_Sticky_Box",
      children: children
    }) : children
  }));
};

/* harmony default export */ var atoms_Sticky = (Sticky);
;// CONCATENATED MODULE: ./src/components/atoms/svg/MapIcon.tsx






var MapIcon = function MapIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 22 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'gray40' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 14 14",
    "data-id": "svg_MapIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.33333 14L4.66667 12.3667L1.05 13.7667C0.790741 13.8704 0.550926 13.8411 0.330556 13.6788C0.110185 13.517 0 13.3 0 13.0278V2.13889C0 1.97037 0.0487407 1.8213 0.146222 1.69167C0.243185 1.56204 0.375926 1.46482 0.544445 1.4L4.66667 0L9.33333 1.63333L12.95 0.233333C13.2093 0.12963 13.4491 0.158667 13.6694 0.320444C13.8898 0.482741 14 0.7 14 0.972222V11.8611C14 12.0296 13.9513 12.1787 13.8538 12.3083C13.7568 12.438 13.6241 12.5352 13.4556 12.6L9.33333 14ZM8.55556 12.0944V2.99444L5.44444 1.90556V11.0056L8.55556 12.0944ZM10.1111 12.0944L12.4444 11.3167V2.1L10.1111 2.99444V12.0944ZM1.55556 11.9L3.88889 11.0056V1.90556L1.55556 2.68333V11.9Z",
      fill: constants_colors/* ICON_COLORS */.M[variant],
      "data-id": "svg_MapIcon_path"
    })
  });
};

/* harmony default export */ var svg_MapIcon = (MapIcon);
;// CONCATENATED MODULE: ./src/components/houseDesign/LayoutStickyButton.tsx








var LayoutStickyButton = function LayoutStickyButton(_ref) {
  var _storeys$;

  var storeys = _ref.storeys,
      openModal = _ref.openModal,
      _ref$disableFloorPlan = _ref.disableFloorPlan,
      disableFloorPlan = _ref$disableFloorPlan === void 0 ? false : _ref$disableFloorPlan;

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      slg = _useBreakpointInfo.isLargerThan.slg; // has a storeys array of which the first item has a floorPlan svg


  var hasStoreys = !!(storeys !== null && storeys !== void 0 && (_storeys$ = storeys[0]) !== null && _storeys$ !== void 0 && _storeys$.floorPlan);

  if (!hasStoreys || slg || disableFloorPlan) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Sticky, {
    withPadding: true,
    "data-id": "houseDesign_LayoutStickyButton_Sticky",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_MaxWidth, {
      "data-id": "houseDesign_LayoutStickyButton_MaxWidth",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
        shadow: true,
        text: "Bekijk plattegrond",
        variant: "secondary",
        onClick: openModal,
        icon: svg_MapIcon,
        "data-id": "houseDesign_LayoutStickyButton_Button"
      })
    })
  });
};

/* harmony default export */ var houseDesign_LayoutStickyButton = (LayoutStickyButton);
;// CONCATENATED MODULE: ./src/components/houseDesign/Layout.tsx



var Layout_templateObject, Layout_templateObject2, Layout_templateObject3, Layout_templateObject4, Layout_templateObject5;

function Layout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Layout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Layout_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Layout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var Layout_Container = styled_components_browser_esm["default"].div(Layout_templateObject || (Layout_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  min-height: 100vh;\n  padding-top: 56rem;\n  padding-bottom: ", "rem;\n\n  ", "\n  ", "\n"])), function (_ref) {
  var disableFloorPlan = _ref.disableFloorPlan;
  return disableFloorPlan ? 0 : 80;
}, breakpoints/* fromBreakpoint.md */.ks.md(Layout_templateObject2 || (Layout_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 0;\n  "]))), breakpoints/* fromBreakpoint.slg */.ks.slg(Layout_templateObject3 || (Layout_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: block;\n    padding-bottom: 0;\n  "]))));
var Layout_Main = styled_components_browser_esm["default"].div(Layout_templateObject4 || (Layout_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  padding-bottom: 32rem;\n"])), function (_ref2) {
  var sideBarWidth = _ref2.sideBarWidth;
  return breakpoints/* fromBreakpoint.slg */.ks.slg(Layout_templateObject5 || (Layout_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-right: ", "px;\n    "])), sideBarWidth);
});

var LayoutContent = function LayoutContent(_ref3) {
  var wishList = _ref3.wishList,
      wishListItem = _ref3.wishListItem;

  if (wishListItem === 'samenvatting') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_Summary, {
      wishList: wishList,
      "data-id": "houseDesign_Layout_Summary"
    });
  }

  if (wishListItem === 'eigen-woonwensen') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(userWish_UserWishes, {
      wishList: wishList,
      "data-id": "houseDesign_Layout_UserWishes"
    });
  }

  var category = getCategoryBySlug(wishList, wishListItem);

  if (!category) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(InlineError/* default */.Z, {
      text: "Excuses, we hebben deze pagina niet kunnen vinden.",
      "data-id": "houseDesign_Layout_InlineError"
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_Category, {
    category: category,
    wishList: wishList,
    "data-id": "houseDesign_Layout_Category"
  });
};

var Layout = function Layout(_ref4) {
  var _wishList$houseType;

  var wishListItem = _ref4.wishListItem,
      wishList = _ref4.wishList,
      _ref4$disableFloorPla = _ref4.disableFloorPlan,
      disableFloorPlan = _ref4$disableFloorPla === void 0 ? false : _ref4$disableFloorPla;
  var layoutDimensions = hooks_useLayoutDimensions();
  var storeys = (_wishList$houseType = wishList.houseType) === null || _wishList$houseType === void 0 ? void 0 : _wishList$houseType.storeys;
  var dispatch = (0,es/* useDispatch */.I0)();
  var openFloorplanModal = (0,react.useCallback)(function () {
    if (storeys) {
      dispatch((0,houseDesign/* openModal */.h7)({
        type: 'FloorPlan',
        props: {
          storeys: storeys,
          wishList: wishList
        }
      }));
    }
  }, [dispatch, storeys, wishList]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_FadeAnimationWrapper, {
    animationKey: wishListItem ? 1 : 0,
    "data-id": "houseDesign_Layout_FadeAnimationWrapper",
    children: wishListItem ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout_Container, {
      disableFloorPlan: disableFloorPlan,
      "data-id": "houseDesign_Layout_Container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Layout_Main, Layout_objectSpread(Layout_objectSpread({}, layoutDimensions), {}, {
        "data-id": "houseDesign_Layout_Main",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_FadeAnimationWrapper, {
          animationKey: wishListItem,
          "data-id": "houseDesign_Layout_FadeAnimationWrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LayoutContent, {
            wishListItem: wishListItem,
            wishList: wishList,
            "data-id": "houseDesign_Layout_LayoutContent"
          })
        })
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_LayoutSidebar, {
        disableFloorPlan: disableFloorPlan,
        wishList: wishList,
        wishListItem: wishListItem,
        storeys: storeys,
        openModal: openFloorplanModal,
        "data-id": "houseDesign_Layout_LayoutSidebar"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_LayoutStickyButton, {
        disableFloorPlan: disableFloorPlan,
        storeys: storeys,
        openModal: openFloorplanModal,
        "data-id": "houseDesign_Layout_LayoutStickyButton"
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_HouseLayout, {
      wishList: wishList,
      "data-id": "houseDesign_Layout_House"
    })
  });
};

/* harmony default export */ var houseDesign_Layout = (Layout);
;// CONCATENATED MODULE: ./src/components/atoms/svg/CloseIcon.tsx






var CloseIcon = function CloseIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'brand' : _ref$variant;

  var _getWidthOrHeight = (0,getWidthOrHeight/* default */.Z)(width, height),
      h = _getWidthOrHeight.h,
      w = _getWidthOrHeight.w;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Svg/* default */.Z, {
    style: {
      width: w,
      height: h
    },
    viewBox: "0 0 16 16",
    "data-id": "svg_CloseIcon_Svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: constants_colors/* ICON_COLORS */.M[variant],
      fillRule: "evenodd",
      d: "M11.2,8l3.669,3.669a1.6,1.6,0,0,1,0,2.263L12.8,16,8,11.2,4.331,14.869a1.6,1.6,0,0,1-2.263,0L0,12.8,4.8,8,1.13,4.331a1.6,1.6,0,0,1,0-2.263L3.2,0,8,4.8,11.669,1.13a1.6,1.6,0,0,1,2.263,0L16,3.2Z",
      "data-id": "svg_CloseIcon_path"
    })
  });
};

/* harmony default export */ var svg_CloseIcon = (CloseIcon);
;// CONCATENATED MODULE: ./src/hooks/useScrollbarWidth.ts


var useScrollbarWidth = function useScrollbarWidth() {
  var didCompute = (0,react.useRef)(false);
  var widthRef = (0,react.useRef)(0);
  if (didCompute.current) return widthRef.current;
  var scrollbarWidth = getScrollbarWidth();
  widthRef.current = scrollbarWidth;
  didCompute.current = true;
  return scrollbarWidth;
};
;// CONCATENATED MODULE: ./src/components/houseDesign/FloorPlanModal.tsx



var FloorPlanModal_templateObject, FloorPlanModal_templateObject2;

function FloorPlanModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FloorPlanModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FloorPlanModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FloorPlanModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // there is no typing for react-svgmt, but since the code is simple, we can ignore it
// @ts-ignore






var FloorPlanModal_Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(FloorPlanModal_templateObject || (FloorPlanModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n\n  ", "\n"])), function (_ref) {
  var spacing = _ref.spacing;
  return breakpoints/* fromBreakpoint.md */.ks.md(FloorPlanModal_templateObject2 || (FloorPlanModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: ", "rem;\n    padding-right: ", "rem;\n  "])), styles_spacing/* SIZE_MAP */.H[spacing] + 60, styles_spacing/* SIZE_MAP */.H[spacing] + 60);
});

var FloorPlanModal = function FloorPlanModal(props) {
  var spacing = hooks_useResponsiveSpacing();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FloorPlanModal_Container, {
    paddingVertical: spacing,
    paddingHorizontal: spacing,
    spacing: spacing,
    "data-id": "houseDesign_FloorPlanModal_Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_FloorPlan, FloorPlanModal_objectSpread(FloorPlanModal_objectSpread({}, props), {}, {
      "data-id": "houseDesign_FloorPlanModal_FloorPlan"
    }))
  });
};

/* harmony default export */ var houseDesign_FloorPlanModal = (FloorPlanModal);
;// CONCATENATED MODULE: ./src/components/molecules/Modal.tsx



var molecules_Modal_templateObject, molecules_Modal_templateObject2, molecules_Modal_templateObject3, molecules_Modal_templateObject4, molecules_Modal_templateObject5, molecules_Modal_templateObject6, molecules_Modal_templateObject7, molecules_Modal_templateObject8;

function Modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Modal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























var FadeInOut = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div)(molecules_Modal_templateObject || (molecules_Modal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: ", ";\n"])), z.modal);
var Modal_Overlay = styled_components_browser_esm["default"].div(molecules_Modal_templateObject2 || (molecules_Modal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  height: 100%;\n  overflow-y: auto;\n\n  ", "\n"])), function (_ref) {
  var transparent = _ref.transparent;
  return transparent ? colors/* RGBAColors.black70 */.$.black70 : colors/* colors.gray20 */.O.gray20;
}, function (_ref2) {
  var noScroll = _ref2.noScroll;
  return noScroll && (0,styled_components_browser_esm.css)(molecules_Modal_templateObject3 || (molecules_Modal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      overflow-y: hidden;\n    "])));
});
var TopButtonWrapper = styled_components_browser_esm["default"].div(molecules_Modal_templateObject4 || (molecules_Modal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: ", ";\n  display: flex;\n  justify-content: flex-end;\n  ", "\n  z-index: ", ";\n"])), function (_ref3) {
  var spacing = _ref3.spacing;
  return "".concat(styles_spacing/* SIZE_MAP */.H[spacing], "rem ").concat(styles_spacing/* SIZE_MAP */.H[spacing], "rem 0 0");
}, function (_ref4) {
  var overlayed = _ref4.overlayed;
  return overlayed && (0,styled_components_browser_esm.css)(molecules_Modal_templateObject5 || (molecules_Modal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      position: fixed;\n      top: 0;\n      right: 0;\n    "])));
}, z.modalButton);
var Modal_ContentWrapper = styled_components_browser_esm["default"].div(molecules_Modal_templateObject6 || (molecules_Modal_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n\n  ", "\n"])), function (_ref5) {
  var bottomButton = _ref5.bottomButton;
  return bottomButton && (0,styled_components_browser_esm.css)(molecules_Modal_templateObject7 || (molecules_Modal_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 80rem;\n    "])));
});
var BottomButtonWrapper = (0,styled_components_browser_esm["default"])(atoms_Sticky)(molecules_Modal_templateObject8 || (molecules_Modal_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  z-index: ", ";\n"])), z.modalButton);

var getModalConfig = function getModalConfig(modalState) {
  if (!modalState) {
    return undefined;
  }

  var type = modalState.type,
      props = modalState.props;

  switch (type) {
    case 'FloorPlan':
      return {
        Component: houseDesign_FloorPlanModal,
        props: props,
        topButtonOverlayed: true,
        transparent: false,
        buttonOnBottom: true,
        noScroll: true
      };

    case 'Image':
      return {
        Component: function Component(props) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_CoveredImage, Modal_objectSpread(Modal_objectSpread({
            alt: ""
          }, props), {}, {
            "data-id": "molecules_Modal_CoveredImage"
          }));
        },
        props: props,
        topButtonOverlayed: true,
        noScroll: true
      };

    case 'ImageSlider':
      return {
        Component: atoms_ImageSlider,
        props: props,
        topButtonOverlayed: true,
        noScroll: true
      };

    default:
      return undefined;
  }
};

var Modal_Modal = function Modal() {
  var _modalConfig$noScroll;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var scrollbarWidth = useScrollbarWidth();
  var modalState = (0,redux/* useSelector */.v)(function (state) {
    return state.houseDesign.modal;
  });

  var _useBreakpointInfo = hooks_useBreakpointInfo(),
      md = _useBreakpointInfo.isLargerThan.md;

  var spacing = hooks_useResponsiveSpacing();
  (0,react.useEffect)(function () {
    if (modalState) {
      setOpen(true);
    }
  }, [modalState]);
  var modalConfig = getModalConfig(modalState);
  var validAndOpen = !!modalConfig;
  var noScroll = (_modalConfig$noScroll = modalConfig === null || modalConfig === void 0 ? void 0 : modalConfig.noScroll) !== null && _modalConfig$noScroll !== void 0 ? _modalConfig$noScroll : false;
  (0,react.useEffect)(function () {
    return function () {
      dispatch((0,houseDesign/* closeModal */.Mr)());
    };
  }, [dispatch]);
  (0,react.useEffect)(function () {
    setHtmlStyleForModal(validAndOpen, scrollbarWidth);
    return resetHtmlStyleForModal;
  }, [dispatch, noScroll, scrollbarWidth, validAndOpen]);

  if (!modalConfig) {
    return null;
  }

  var _modalConfig$topButto = modalConfig.topButtonOverlayed,
      topButtonOverlayed = _modalConfig$topButto === void 0 ? false : _modalConfig$topButto,
      _modalConfig$buttonOn = modalConfig.buttonOnBottom,
      buttonOnBottom = _modalConfig$buttonOn === void 0 ? false : _modalConfig$buttonOn,
      Component = modalConfig.Component,
      props = modalConfig.props,
      _modalConfig$transpar = modalConfig.transparent,
      transparent = _modalConfig$transpar === void 0 ? true : _modalConfig$transpar;
  var bottomButton = buttonOnBottom && !md;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
    onExitComplete: function onExitComplete() {
      dispatch((0,houseDesign/* closeModal */.Mr)());
    },
    "data-id": "molecules_Modal_AnimatePresence",
    children: open && /*#__PURE__*/(0,jsx_runtime.jsx)(FadeInOut, {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      "data-id": "molecules_Modal_FadeInOut",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal_Overlay, {
        transparent: transparent,
        noScroll: noScroll,
        "data-id": "molecules_Modal_Overlay",
        children: [!bottomButton && /*#__PURE__*/(0,jsx_runtime.jsx)(TopButtonWrapper, {
          overlayed: topButtonOverlayed,
          spacing: spacing,
          "data-id": "molecules_Modal_TopButtonWrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_UtilityButton, {
            onClick: function onClick() {
              return setOpen(false);
            },
            icon: svg_CloseIcon,
            "data-id": "molecules_Modal_UtilityButton"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal_ContentWrapper, {
          bottomButton: bottomButton,
          "data-id": "molecules_Modal_ContentWrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Modal_objectSpread(Modal_objectSpread({}, props), {}, {
            style: {
              zIndex: z.modalContent
            },
            "data-id": "molecules_Modal_Component"
          }))
        }), bottomButton && /*#__PURE__*/(0,jsx_runtime.jsx)(BottomButtonWrapper, {
          withPadding: true,
          withOffset: false,
          "data-id": "molecules_Modal_BottomButtonWrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_MaxWidth, {
            "data-id": "molecules_Modal_MaxWidth",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
              shadow: true,
              text: "Sluiten",
              onClick: function onClick() {
                return setOpen(false);
              },
              icon: svg_CloseIcon,
              variant: "secondary",
              "data-id": "molecules_Modal_Button"
            })
          })
        })]
      })
    })
  });
};

/* harmony default export */ var molecules_Modal = (Modal_Modal);
;// CONCATENATED MODULE: ./src/components/LegacyModal.tsx






var LegacyModal = function LegacyModal() {
  var _useMatch = (0,useMatch/* default */.Z)(),
      match = _useMatch.match;

  var router = (0,next_router.useRouter)();
  var renderWidth = hooks_useRenderWidth();

  if (!match || !router) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_Modal, {
    match: match,
    renderWidth: renderWidth,
    router: router,
    "data-id": "components_LegacyModal_Modal"
  });
};

/* harmony default export */ var components_LegacyModal = (LegacyModal);
;// CONCATENATED MODULE: ./src/hooks/useSetPhase.ts





/**
 * Request the settings endpoint, then set the user's phase (e.g. customer journey 1) in the redux state
 */

var useSetPhase = function useSetPhase() {
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useMatch = (0,useMatch/* default */.Z)(),
      projectSlug = _useMatch.match.params.projectSlug;

  var _useQueryRequest = (0,requestHooks/* useQueryRequest */.c)('getSettings', undefined, {
    projectSlug: projectSlug,
    env: 'closed'
  }),
      data = _useQueryRequest.data,
      error = _useQueryRequest.error,
      isError = _useQueryRequest.isError,
      isLoading = _useQueryRequest.isLoading,
      isRefetching = _useQueryRequest.isRefetching;

  (0,react.useEffect)(function () {
    if (!data) {
      return;
    }

    dispatch((0,houseDesign/* setPhase */.$Y)(data.phase));
  }, [data, dispatch]);
  return {
    error: error,
    isError: isError,
    isLoading: isLoading,
    isRefetching: isRefetching
  };
};
;// CONCATENATED MODULE: ./src/components/contentTypes/HouseDesign.tsx

var HouseDesign_excluded = ["wishListItem"];

















var HouseDesign = function HouseDesign() {
  var _data$link;

  var _useParams = (0,useParams/* default */.Z)(),
      wishListItem = _useParams.wishListItem,
      params = (0,objectWithoutProperties/* default */.Z)(_useParams, HouseDesign_excluded);

  var _useWishListQuery = useWishListQuery('getWishList', [endpoints/* WishListRequestKey.wishListLoading */.P.wishListLoading], params),
      errorWishlist = _useWishListQuery.error,
      data = _useWishListQuery.data,
      isLoadingWishlist = _useWishListQuery.isLoading,
      isErrorWishlist = _useWishListQuery.isError,
      isRefetchingWishlist = _useWishListQuery.isRefetching;

  var _useSetPhase = useSetPhase(),
      errorSettings = _useSetPhase.error,
      isLoadingSettings = _useSetPhase.isLoading,
      isErrorSettings = _useSetPhase.isError,
      isRefetchingSettings = _useSetPhase.isRefetching;

  var backLink = (0,getLinkFromPageObject/* default */.Z)((_data$link = data === null || data === void 0 ? void 0 : data.link) !== null && _data$link !== void 0 ? _data$link : params);
  var isLoading = isLoadingWishlist || isLoadingSettings || isRefetchingWishlist || isRefetchingSettings;
  var isError = isErrorWishlist || isErrorSettings;
  var error = errorWishlist !== null && errorWishlist !== void 0 ? errorWishlist : errorSettings;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(globalStyles/* GlobalStyleHouseDesign */.E, {
      "data-id": "contentTypes_HouseDesign_GlobalStyleHouseDesign"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_RequestHandler, {
      fullScreen: true,
      error: error === null || error === void 0 ? void 0 : error.humanReadableMessage,
      isError: isError || !isLoading && !data,
      isLoading: isLoading,
      statusCode: error === null || error === void 0 ? void 0 : error.statusCode,
      "data-id": "contentTypes_HouseDesign_RequestHandler",
      children: !!data && /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_Chrome, {
        menu: /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_Menu, {
          wishList: data,
          backLink: backLink,
          "data-id": "contentTypes_HouseDesign_Menu"
        }),
        backLink: backLink,
        "data-id": "contentTypes_HouseDesign_Chrome",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(houseDesign_Layout, {
          wishList: data,
          wishListItem: wishListItem,
          "data-id": "contentTypes_HouseDesign_Layout"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_Modal, {
      "data-id": "contentTypes_HouseDesign_Modal"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_LegacyModal, {
      "data-id": "contentTypes_HouseDesign_LegacyModal"
    })]
  });
};

/* harmony default export */ var contentTypes_HouseDesign = (HouseDesign);
// EXTERNAL MODULE: ./node_modules/process/browser.js
var browser = __webpack_require__(34155);
;// CONCATENATED MODULE: ./src/components/organisms/AppPage.tsx


var AppPage_templateObject, AppPage_templateObject2, AppPage_templateObject3, AppPage_templateObject4, AppPage_templateObject5, AppPage_templateObject6, AppPage_templateObject7, AppPage_templateObject8, AppPage_templateObject9, AppPage_templateObject10;












var AppPage_ArticleGridWrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(AppPage_templateObject || (AppPage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-sizing: border-box;\n  padding: 40rem 20rem 100rem;\n"])));
var AppPage_Article = styled_components_browser_esm["default"].div(AppPage_templateObject2 || (AppPage_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 40rem;\n  padding-left: 0;\n  padding-right: 0;\n"])));
var AppPage_Title = styled_components_browser_esm["default"].h1(AppPage_templateObject3 || (AppPage_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.orange */.K5.orange, breakpoints/* toBreakpoint.md */.Hx.md(AppPage_templateObject4 || (AppPage_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(AppPage_templateObject5 || (AppPage_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))));
var IntroParagraph = styled_components_browser_esm["default"].p(AppPage_templateObject6 || (AppPage_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.introText */.sq.introText);
var AppPage_Paragraph = styled_components_browser_esm["default"].p(AppPage_templateObject7 || (AppPage_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.bodyText */.sq.bodyText);
var ButtonsWrapper = styled_components_browser_esm["default"].div(AppPage_templateObject8 || (AppPage_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), breakpoints/* fromBreakpoint.md */.ks.md(AppPage_templateObject9 || (AppPage_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20rem;"]))));
var AppPage_ButtonWrapper = styled_components_browser_esm["default"].p(AppPage_templateObject10 || (AppPage_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 20rem;\n"])));
var TITLE = 'De Homestudios app';
var INTRO = "Met de Homestudios app kun je gebruikmaken van verschillende functionaliteiten in het Homestudios experience center om je bezoek optimaal te benutten en te personaliseren. Daarnaast biedt de app toegang tot je persoonlijke Homestudios account; zo heb je alle informatie over je nieuwe woning altijd binnen handbereik.";
var APPLE_TEXT = "Download de app voor je iPhone of iPad:";
var ANDROID_TEXT = "Download de app voor je Android device:";
var APP_STORE_LINK = 'https://apps.apple.com/nl/app/homestudios/id6504245890';
var PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=nl.homestudios.customers&utm_source=download_page';
var LAYOUT_SETTINGS = {
  hasHeader: true,
  hasFooter: true,
  hasMenu: true
};
var META = {
  metaTitle: TITLE,
  metaKeywords: 'app',
  metaDescription: ''
};

var getPlatform = function getPlatform() {
  if (navigator) {
    // @ts-ignore
    var userAgentData = navigator.userAgentData;

    if (userAgentData !== null && userAgentData !== void 0 && userAgentData.platform) {
      return userAgentData.platform.toUpperCase();
    }

    if (navigator.platform) {
      return navigator.platform.toUpperCase();
    }
  }

  return undefined;
};

var isDebug = function isDebug() {
  var params = new URLSearchParams(document.location.search);
  return params.get('debug');
};

var navigateToStore = function navigateToStore() {
  var currentPlatform = getPlatform();

  if (isDebug() || !currentPlatform) {
    return;
  }

  if (currentPlatform.includes('MAC') || currentPlatform.includes('IPHONE') || currentPlatform.includes('IPAD')) {
    window.location.replace(APP_STORE_LINK);
    return;
  }

  if (currentPlatform.includes('ANDROID')) {
    window.location.replace(PLAY_STORE_LINK);
  }
};

var AppPage = function AppPage(_ref) {
  var settings = _ref.settings;
  var renderWidth = hooks_useRenderWidth();
  (0,react.useEffect)(function () {
    navigateToStore();
  }, []);
  return (
    /*#__PURE__*/
    // @ts-ignore
    (0,jsx_runtime.jsx)(layout_LayoutBase, {
      settings: settings,
      layoutSettings: LAYOUT_SETTINGS,
      renderWidth: renderWidth,
      title: browser.title,
      pageTitle: TITLE,
      meta: META,
      "data-id": "organisms_AppPage_LayoutBase",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AppPage_ArticleGridWrapper, {
        "data-id": "organisms_AppPage_ArticleGridWrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(AppPage_Article, {
          "data-id": "organisms_AppPage_Article",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AppPage_Title, {
            "data-id": "organisms_AppPage_Title",
            children: TITLE
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(IntroParagraph, {
            "data-id": "organisms_AppPage_IntroParagraph",
            children: INTRO
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonsWrapper, {
            "data-id": "organisms_AppPage_ButtonsWrapper",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AppPage_ButtonWrapper, {
              "data-id": "organisms_AppPage_ButtonWrapper",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AppPage_Paragraph, {
                "data-id": "organisms_AppPage_Paragraph",
                children: APPLE_TEXT
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
                href: APP_STORE_LINK,
                text: "App Store",
                centerText: true,
                "data-id": "organisms_AppPage_Button"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AppPage_ButtonWrapper, {
              "data-id": "organisms_AppPage_ButtonWrapper",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AppPage_Paragraph, {
                "data-id": "organisms_AppPage_Paragraph",
                children: ANDROID_TEXT
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
                href: PLAY_STORE_LINK,
                text: "Google Play",
                centerText: true,
                "data-id": "organisms_AppPage_Button"
              })]
            })]
          })]
        })
      })
    })
  );
};

/* harmony default export */ var organisms_AppPage = (AppPage);
;// CONCATENATED MODULE: ./src/components/organisms/ForgetAccountPage.tsx


var ForgetAccountPage_templateObject, ForgetAccountPage_templateObject2, ForgetAccountPage_templateObject3, ForgetAccountPage_templateObject4, ForgetAccountPage_templateObject5, ForgetAccountPage_templateObject6, ForgetAccountPage_templateObject7, ForgetAccountPage_templateObject8, ForgetAccountPage_templateObject9;



















var ForgetAccountPage_ArticleGridWrapper = (0,styled_components_browser_esm["default"])(gridElements/* GridWrapper */.zc)(ForgetAccountPage_templateObject || (ForgetAccountPage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-sizing: border-box;\n  padding: 40rem 20rem 100rem;\n"])));
var ForgetAccountPage_Article = styled_components_browser_esm["default"].div(ForgetAccountPage_templateObject2 || (ForgetAccountPage_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 40rem;\n  padding-left: 0;\n  padding-right: 0;\n"])));
var ForgetAccountPage_Title = styled_components_browser_esm["default"].h1(ForgetAccountPage_templateObject3 || (ForgetAccountPage_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  color: ", ";\n  ", ";\n\n  ", ";\n"])), styleGuide/* textStyles.pageTitle */.sq.pageTitle, styleGuide/* colorPalette.orange */.K5.orange, breakpoints/* toBreakpoint.md */.Hx.md(ForgetAccountPage_templateObject4 || (ForgetAccountPage_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 40rem;\n  "]))), breakpoints/* fromBreakpoint.md */.ks.md(ForgetAccountPage_templateObject5 || (ForgetAccountPage_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: 60rem;\n  "]))));
var ForgetAccountPage_IntroParagraph = styled_components_browser_esm["default"].p(ForgetAccountPage_templateObject6 || (ForgetAccountPage_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), styleGuide/* textStyles.introText */.sq.introText);
var EmailText = styled_components_browser_esm["default"].span(ForgetAccountPage_templateObject7 || (ForgetAccountPage_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n  font-weight: ", ";\n  display: inline-block;\n"])), styleGuide/* textStyles.introText */.sq.introText, fonts/* fontWeight.bold */.Ue.bold);
var ForgetAccountPage_ButtonsWrapper = styled_components_browser_esm["default"].div(ForgetAccountPage_templateObject8 || (ForgetAccountPage_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), breakpoints/* fromBreakpoint.md */.ks.md(ForgetAccountPage_templateObject9 || (ForgetAccountPage_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20rem;"]))));
var ForgetAccountPage_TITLE = 'Account verwijderen';
var ForgetAccountPage_LAYOUT_SETTINGS = {
  hasHeader: true,
  hasFooter: true,
  hasMenu: true
};
var ForgetAccountPage_META = {
  metaTitle: ForgetAccountPage_TITLE,
  metaKeywords: 'app',
  metaDescription: ''
};

var ForgetAccountPage = function ForgetAccountPage(_ref) {
  var settings = _ref.settings;
  var renderWidth = hooks_useRenderWidth();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useMatch = (0,useMatch/* default */.Z)(),
      params = _useMatch.match.params;

  var _useQueryRequest = (0,requestHooks/* useQueryRequest */.c)('getProfile', undefined, {
    projectSlug: params.projectSlug
  }),
      data = _useQueryRequest.data,
      isLoading = _useQueryRequest.isLoading; // Temporary Solution: Without this useEffect is it not possible to open the modal at the first click of the button.


  (0,react.useEffect)(function () {
    dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.orange */.K5.orange, {
      type: 'anonymizeUser'
    }));
  }, [dispatch]);
  var handleOnClick = (0,react.useCallback)(function () {
    dispatch((0,redux_modal/* openModal */.h7)(styleGuide/* colorPalette.orange */.K5.orange, {
      type: 'anonymizeUser'
    }));
  }, [dispatch]);

  if (isLoading) {
    return (
      /*#__PURE__*/
      // @ts-ignore
      (0,jsx_runtime.jsx)(layout_LayoutBase, {
        settings: settings,
        layoutSettings: ForgetAccountPage_LAYOUT_SETTINGS,
        renderWidth: renderWidth,
        title: browser.title,
        pageTitle: ForgetAccountPage_TITLE,
        meta: ForgetAccountPage_META,
        "data-id": "organisms_ForgetAccountPage_LayoutBase",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ForgetAccountPage_ArticleGridWrapper, {
          "data-id": "organisms_ForgetAccountPage_ArticleGridWrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ForgetAccountPage_Article, {
            "data-id": "organisms_ForgetAccountPage_Article",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
              "data-id": "organisms_ForgetAccountPage_Spinner"
            })
          })
        })
      })
    );
  }

  return (
    /*#__PURE__*/
    // @ts-ignore
    (0,jsx_runtime.jsx)(layout_LayoutBase, {
      settings: settings,
      layoutSettings: ForgetAccountPage_LAYOUT_SETTINGS,
      renderWidth: renderWidth,
      title: browser.title,
      pageTitle: ForgetAccountPage_TITLE,
      meta: ForgetAccountPage_META,
      loggedIn: true,
      "data-id": "organisms_ForgetAccountPage_LayoutBase",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ForgetAccountPage_ArticleGridWrapper, {
        "data-id": "organisms_ForgetAccountPage_ArticleGridWrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ForgetAccountPage_Article, {
          "data-id": "organisms_ForgetAccountPage_Article",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ForgetAccountPage_Title, {
            "data-id": "organisms_ForgetAccountPage_Title",
            children: "Account verwijderen"
          }), data !== null && data !== void 0 && data.isAnonymizable ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ForgetAccountPage_IntroParagraph, {
            "data-id": "organisms_ForgetAccountPage_IntroParagraph",
            children: ["Je staat op het punt om jouw account te verwijderen. Dit houdt in dat je persoonlijke gegevens, zoals naam en emailadres, worden verwijderd uit ons systeem en je geen toegang meer hebt tot Mijn Homestudios. Wil je jouw account verwijderen, klik dan op onderstaande knop om ", /*#__PURE__*/(0,jsx_runtime.jsx)(EmailText, {
              "data-id": "organisms_ForgetAccountPage_EmailText",
              children: data === null || data === void 0 ? void 0 : data.email
            }), " te verwijderen. Let op: na het verwijderen van je gegevens is het niet meer mogelijk om je account te herstellen."]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(ForgetAccountPage_IntroParagraph, {
            "data-id": "organisms_ForgetAccountPage_IntroParagraph",
            children: ["We kunnen jouw account op dit moment niet verwijderen. Dit account is namelijk het enige of laatste account dat aan je gebruikersprofiel is gekoppeld. Zonder gekoppeld account heb je geen toegang meer tot Mijn Homestudios voor jouw project. Mocht je hierover vragen hebben, mail dan naar:", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
              href: "mailto:info@homestudios.nl",
              "data-id": "organisms_ForgetAccountPage_Link",
              children: "info@homestudios.nl"
            }), "."]
          }), (data === null || data === void 0 ? void 0 : data.isAnonymizable) && /*#__PURE__*/(0,jsx_runtime.jsx)(ForgetAccountPage_ButtonsWrapper, {
            "data-id": "organisms_ForgetAccountPage_ButtonsWrapper",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Button/* default */.Z, {
              centerText: true,
              onClick: handleOnClick,
              text: "Verwijder account",
              "data-id": "organisms_ForgetAccountPage_Button"
            })
          })]
        })
      })
    })
  );
};

/* harmony default export */ var organisms_ForgetAccountPage = (ForgetAccountPage);
;// CONCATENATED MODULE: ./src/components/contentTypes/StaticPage.tsx








var SLUG_COMPONENT_MAP = (0,defineProperty/* default */.Z)({}, types_pageType/* StaticPageSlug.app */.OF.app, organisms_AppPage);

var SLUG_COMPONENT_MAP_FOR_PROJECT = (0,defineProperty/* default */.Z)({}, types_pageType/* StaticPageSlugForProject.vergeet-mij */.lA["vergeet-mij"], organisms_ForgetAccountPage);
/**
 * We can use this component to render pages that do not serve content from the back end.
 */


var StaticPage = function StaticPage() {
  var _params$env;

  var _useMatch = (0,useMatch/* default */.Z)(),
      slugs = _useMatch.slugs,
      params = _useMatch.match.params;

  var _useQueryRequest = (0,requestHooks/* useQueryRequest */.c)('getSettings', undefined, {
    projectSlug: params.projectSlug,
    env: (_params$env = params.env) !== null && _params$env !== void 0 ? _params$env : 'open'
  }),
      data = _useQueryRequest.data,
      isError = _useQueryRequest.isError,
      isLoading = _useQueryRequest.isLoading;

  if (isLoading || isError) {
    return null;
  }

  var StaticComponent;

  if (params.projectSlug === 'portal') {
    StaticComponent = slugs ? SLUG_COMPONENT_MAP[slugs[0]] : function () {
      return null;
    };
  } else {
    StaticComponent = slugs ? SLUG_COMPONENT_MAP_FOR_PROJECT[slugs[2]] : function () {
      return null;
    };
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StaticComponent, {
    settings: data,
    "data-id": "contentTypes_StaticPage_StaticComponent"
  });
};

/* harmony default export */ var contentTypes_StaticPage = (StaticPage);
;// CONCATENATED MODULE: ./pages/[...slugs].tsx











var ProjectPage = function ProjectPage() {
  var _useMatch = (0,useMatch/* default */.Z)(),
      pageType = _useMatch.pageType;

  switch (pageType) {
    case types_pageType/* PageType.article */.GV.article:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(contentTypes_ArticlePage, {
        "data-id": "pages_[_ArticlePage"
      });

    case types_pageType/* PageType.footer */.GV.footer:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FooterPage, {
        "data-id": "pages_[_FooterPage"
      });

    case types_pageType/* PageType.houseType */.GV.houseType:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(HouseType, {
        "data-id": "pages_[_HouseType"
      });

    case types_pageType/* PageType.password */.GV.password:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(contentTypes_Password, {
        "data-id": "pages_[_Password"
      });

    case types_pageType/* PageType.wishList */.GV.wishList:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(contentTypes_HouseDesign, {
        "data-id": "pages_[_HouseDesign"
      });

    case types_pageType/* PageType.static */.GV["static"]:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(contentTypes_StaticPage, {
        "data-id": "pages_[_StaticPage"
      });

    case types_pageType/* PageType.page */.GV.page:
    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(contentTypes_Page, {
        "data-id": "pages_[_Page"
      });
  }
};

/* harmony default export */ var _slugs_ = (ProjectPage);

/***/ }),

/***/ 70833:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slugs]",
      function () {
        return __webpack_require__(4754);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [885,462,774,888,179], function() { return __webpack_exec__(70833); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);